
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fjcgS", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $b36dd57b0aab58a0$export$799525ac94ca811d);
$parcel$export(module.exports, "resolveAnalyticsWebClientPromise", () => $b36dd57b0aab58a0$export$2b194038750b3976);
let $b36dd57b0aab58a0$var$markAnalyticsClientAsReady;
const $b36dd57b0aab58a0$var$analyticsClientPromise = new Promise((resolve)=>{
    $b36dd57b0aab58a0$var$markAnalyticsClientAsReady = resolve;
});
const $b36dd57b0aab58a0$export$799525ac94ca811d = ()=>$b36dd57b0aab58a0$var$analyticsClientPromise;
const $b36dd57b0aab58a0$export$2b194038750b3976 = (client)=>$b36dd57b0aab58a0$var$markAnalyticsClientAsReady(client);

});

parcelRegister("4R6GH", function(module, exports) {

$parcel$export(module.exports, "withoutFeatureExistenceCheck", () => $a00a9760f835bf20$export$ede4c4e7e9dad3f2);
$parcel$export(module.exports, "fg", () => $a00a9760f835bf20$export$b40ec24ac8275656);

var $iEN9D = parcelRequire("iEN9D");

var $gSA3s = parcelRequire("gSA3s");

var $40Gox = parcelRequire("40Gox");

var $aMh57 = parcelRequire("aMh57");
class $a00a9760f835bf20$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        // Capture the stack without the error construction
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // Remove the error creation line and preserve caller stack
            // 1 - checkIfGateExists
            // 2 - featureGate
            // 3 - fg
            this.stack = [
                ...stackLines.slice(3)
            ].join('\n');
        }
    }
}
const $a00a9760f835bf20$var$checkedGates = new Set();
const $a00a9760f835bf20$var$checkIfGateExists = (gateName)=>{
    // perform early exist to minimize performance impact
    if ($a00a9760f835bf20$var$checkedGates.has(gateName)) return;
    $a00a9760f835bf20$var$checkedGates.add(gateName);
    if ((0, $iEN9D.default).checkGate('jfp_magma_jira-report-incorrect-gates', {
        fireGateExposure: false
    })) {
        if (!(0, $iEN9D.default).isGateExists(gateName)) {
            const error = new $a00a9760f835bf20$var$ErrorPointingUp(`Feature gate ${gateName} does not exist`);
            (0, $aMh57.captureException)('FeatureGates.isGateExists', error);
            // eslint-disable-next-line no-console
            console.error(`Feature gate ${gateName} does not exist in StatSig. It was archived or hasn't been created yet`);
        }
    }
};
let $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = true;
const $a00a9760f835bf20$export$ede4c4e7e9dad3f2 = (fn)=>{
    $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = false;
    const result = fn();
    $a00a9760f835bf20$var$shouldPerformGateExistenceCheck = true;
    return result;
};
const $a00a9760f835bf20$var$featureGate = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).checkGate(gateName);
    (0, $gSA3s.addFeatureFlagAccessed)(gateName, value);
    if ($a00a9760f835bf20$var$shouldPerformGateExistenceCheck) $a00a9760f835bf20$var$checkIfGateExists(gateName);
    return value;
};
const $a00a9760f835bf20$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) return $a00a9760f835bf20$var$featureGate(gateName);
        // StatSig is not allowed to initialise yet, returning false
        return false;
    }
    return $a00a9760f835bf20$var$featureGate(gateName);
};
const $a00a9760f835bf20$var$featureGateNoExposure = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $40Gox.UNSAFE_initIfNeeded)();
    const value = (0, $iEN9D.default).checkGate(gateName, {
        fireGateExposure: false
    });
    return value;
};
const $a00a9760f835bf20$export$c7fa95c00de0c062 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) return $a00a9760f835bf20$var$featureGateNoExposure(gateName);
        // StatSig is not allowed to initialise yet, returning false
        return false;
    }
    return $a00a9760f835bf20$var$featureGateNoExposure(gateName);
};

});
parcelRegister("40Gox", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_initIfNeeded", () => $b7a4e79bf226085d$export$c9517ca8c289160f);

var $iEN9D = parcelRequire("iEN9D");
var $8ruqY = parcelRequire("8ruqY");

var $j8DrX = parcelRequire("j8DrX");

var $1zAKS = parcelRequire("1zAKS");

var $ouJAE = parcelRequire("ouJAE");
// This script is part of early scripts, where analytics clients are too heavy to be included.
// Therefore, we just record the error in a global variable. Downstream code will report this.
const $b7a4e79bf226085d$var$captureStatsigInitError = (error)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    if (globalThis.statsigInitialisationFixesPir24496Enabled === true) (0, $ouJAE.setUnreportedStatsigInitialisationError)(new Error('Statsig initialisation failed', {
        cause: error
    }));
};
const $b7a4e79bf226085d$var$initIfNeeded = ()=>{
    if (!(0, $iEN9D.default).initializeCalled()) try {
        const gateValues = (0, $1zAKS.getGateValues)();
        const initPromise = (0, $iEN9D.default).initializeFromValues({
            sdkKey: 'client-7hFqlBhHaY5b2zA7LaaHDy1QKH7yZigbikmrwNpCuRy',
            // this environment variable is defined in webpack.config.js
            environment: (0, $j8DrX.default)('ajs-environment') === 'prod' ? (0, $8ruqY.FeatureGateEnvironment).Production : (0, $8ruqY.FeatureGateEnvironment).Staging,
            targetApp: 'jira_web',
            // Enable exposure firing from server side
            ...false && true ? {
                ignoreWindowUndefined: true
            } : null
        }, {
            // These getMeta functions should only be called once due to performance implications
            // Ideally we should get these passed through from react which memoizes this call already
            atlassianAccountId: (0, $j8DrX.default)('ajs-atlassian-account-id') || undefined,
            tenantId: (0, $j8DrX.default)('ajs-cloud-id') ?? undefined
        }, (0, $1zAKS.getCustomAttributes)(), gateValues);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        if (globalThis.statsigInitialisationFixesPir24496Enabled === true) initPromise.catch($b7a4e79bf226085d$var$captureStatsigInitError);
    } catch (error) {
        $b7a4e79bf226085d$var$captureStatsigInitError(error);
        if (error instanceof Error) // eslint-disable-next-line no-console
        console.error('statsig.client.initialization', error.message);
    }
};
const $b7a4e79bf226085d$export$c9517ca8c289160f = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    // If fast meta is enabled, we need to check if the statsig values are ready
    // Mainly avoid the statsig initialisation is trying to use a default value
    // which is an empty object.
    if (globalVar.__SSR_IS_FAST_META_ENABLED__ === true && globalVar._statsigValuesReady !== true) return;
    if (globalVar.isReorderEarlyScriptsEnabled) {
        if (globalVar.allowStatsigInitialisation_DO_NOT_USE) $b7a4e79bf226085d$var$initIfNeeded();
    } else $b7a4e79bf226085d$var$initIfNeeded();
};

});
parcelRegister("j8DrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $05371d41eb9586d7$export$2e2bcd8739ae039);

var $e7Ou5 = parcelRequire("e7Ou5");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$05371d41eb9586d7$export$2e2bcd8739ae039 = (0, $e7Ou5.default);

});
parcelRegister("e7Ou5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c123e7f489961af$export$2e2bcd8739ae039);
const $1c123e7f489961af$export$c47913ca32a5c6f7 = (name)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};
var $1c123e7f489961af$export$2e2bcd8739ae039 = $1c123e7f489961af$export$c47913ca32a5c6f7;

});


parcelRegister("1zAKS", function(module, exports) {

$parcel$export(module.exports, "getCustomAttributes", () => $12e62e66c508782c$export$1ef2b1f78c9e40d9);
$parcel$export(module.exports, "_haveValuesArrived", () => $12e62e66c508782c$export$8ece9c90e8293278);
$parcel$export(module.exports, "getGateValues", () => $12e62e66c508782c$export$fc7c61934a5b05);

var $j8DrX = parcelRequire("j8DrX");

var $5aM2o = parcelRequire("5aM2o");
const $12e62e66c508782c$export$1ef2b1f78c9e40d9 = ()=>({
        ...(0, $5aM2o.getProductEditions)(),
        exposureSource: false ? 'server' : 'client'
    });
const $12e62e66c508782c$var$valuesFromGlobal = (()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>'_statsigValues' in globalVar,
        processor: ()=>globalVar._statsigValues
    };
})();
const $12e62e66c508782c$var$valuesFromMeta = (()=>{
    // FeatureGate value written into globalThis via SSR. Because statsig is not yet initialised on the client.
    const statsigInitialisationFixesPir24496Enabled = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    globalThis.statsigInitialisationFixesPir24496Enabled === true;
    // If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
    let parsingFailed = false;
    const locator = ()=>{
        if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) return null;
        return (0, $j8DrX.default)('ajs-fe-statsig-values');
    };
    return {
        locator: locator,
        processor: ()=>{
            if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) throw new Error("Can't parse 'ajs-fe-statsig-values' value");
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') {
                globalThis.performance?.mark?.('statsig-parse:start');
                try {
                    const result = JSON.parse(featureFlags);
                    globalThis.performance?.mark?.('statsig-parse:end');
                    return result;
                } catch  {
                    if (statsigInitialisationFixesPir24496Enabled === true) parsingFailed = true;
                    throw new Error("Can't parse 'ajs-fe-statsig-values' value");
                }
            }
        }
    };
})();
const $12e62e66c508782c$export$8ece9c90e8293278 = ()=>{
    return Boolean($12e62e66c508782c$var$valuesFromGlobal.locator() || $12e62e66c508782c$var$valuesFromMeta.locator());
};
const $12e62e66c508782c$export$fc7c61934a5b05 = ()=>{
    if ($12e62e66c508782c$var$valuesFromGlobal.locator()) return $12e62e66c508782c$var$valuesFromGlobal.processor();
    if ($12e62e66c508782c$var$valuesFromMeta.locator()) return $12e62e66c508782c$var$valuesFromMeta.processor();
    return undefined;
};

});
parcelRegister("5aM2o", function(module, exports) {

$parcel$export(module.exports, "getProductEditions", () => $f9ec11628237a2b2$export$61e1423c6d76fbe3);

var $j8DrX = parcelRequire("j8DrX");
const $f9ec11628237a2b2$var$TAP_VALUES = {
    f: 'free',
    s: 'standard',
    p: 'premium'
};
const $f9ec11628237a2b2$var$getTapValue = (editionShorthand)=>$f9ec11628237a2b2$var$TAP_VALUES[editionShorthand] ?? 'UNLICENSED';
const $f9ec11628237a2b2$export$61e1423c6d76fbe3 = ()=>{
    try {
        const tenantContextEditions = JSON.parse((0, $j8DrX.default)('ajs-product-editions') || '{}');
        return {
            'jira-software_edition': $f9ec11628237a2b2$var$getTapValue(tenantContextEditions['jira-software']),
            'jira-servicedesk_edition': $f9ec11628237a2b2$var$getTapValue(tenantContextEditions['jira-servicedesk']),
            'jira-workmanagement_edition': $f9ec11628237a2b2$var$getTapValue(tenantContextEditions['jira-core'])
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return {
            'jira-software_edition': 'UNLICENSED',
            'jira-servicedesk_edition': 'UNLICENSED',
            'jira-workmanagement_edition': 'UNLICENSED'
        };
    }
};

});


parcelRegister("ouJAE", function(module, exports) {

$parcel$export(module.exports, "unreportedStatsigInitialisationError", () => $d85468caf6eb5df9$export$2f1d868dc4cd45f5);
$parcel$export(module.exports, "setUnreportedStatsigInitialisationError", () => $d85468caf6eb5df9$export$f0253a32470c87a6);
// eslint-disable-next-line import/no-mutable-exports
let $d85468caf6eb5df9$export$2f1d868dc4cd45f5;
const $d85468caf6eb5df9$export$f0253a32470c87a6 = (error)=>{
    $d85468caf6eb5df9$export$2f1d868dc4cd45f5 = error;
};

});


parcelRegister("aMh57", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $7a2e988876e668fc$export$f5282963edea4a68);

var $gES3x = parcelRequire("gES3x");
const $7a2e988876e668fc$export$f5282963edea4a68 = (location, error, details = {})=>false ? undefined : (0, $gES3x.captureException)(location, error, details);

});
parcelRegister("gES3x", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $265ac1cd167664c8$export$f5282963edea4a68);

var $fq71H = parcelRequire("fq71H");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $265ac1cd167664c8$var$tags = [
    'packageName',
    'teamName',
    'hash',
    'userLocation'
];
const $265ac1cd167664c8$export$f5282963edea4a68 = (location, error, details)=>{
    if (!error) return;
    (0, $fq71H.withScope)((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($265ac1cd167664c8$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
        (0, $fq71H.captureException)(error);
    });
};

});
parcelRegister("fq71H", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $b39ebc005c5eaf89$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $b39ebc005c5eaf89$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $b39ebc005c5eaf89$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $b39ebc005c5eaf89$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $b39ebc005c5eaf89$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $b39ebc005c5eaf89$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $b39ebc005c5eaf89$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setExtra", () => $b39ebc005c5eaf89$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTags", () => $b39ebc005c5eaf89$export$74a8fb34822092e6);
$parcel$export(module.exports, "setTag", () => $b39ebc005c5eaf89$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $b39ebc005c5eaf89$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $b39ebc005c5eaf89$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $b39ebc005c5eaf89$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "withActiveSpan", () => $b39ebc005c5eaf89$export$e57ac09b143d92a2);
$parcel$export(module.exports, "startTransaction", () => $b39ebc005c5eaf89$export$e262da7ae6480481);
$parcel$export(module.exports, "getCurrentScope", () => $b39ebc005c5eaf89$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $b39ebc005c5eaf89$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "flush", () => $b39ebc005c5eaf89$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $b39ebc005c5eaf89$export$8360e631d277ea4d);
$parcel$export(module.exports, "lastEventId", () => $b39ebc005c5eaf89$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "isInitialized", () => $b39ebc005c5eaf89$export$3f95c6f800b78024);
$parcel$export(module.exports, "startSession", () => $b39ebc005c5eaf89$export$c0d84948cecf78d8);
$parcel$export(module.exports, "endSession", () => $b39ebc005c5eaf89$export$17a5be43989a0bc1);
$parcel$export(module.exports, "captureSession", () => $b39ebc005c5eaf89$export$667e7b4d445d566b);

var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");

var $b5y9n = parcelRequire("b5y9n");

var $cQ4mt = parcelRequire("cQ4mt");

var $egVmm = parcelRequire("egVmm");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $1WSQk = parcelRequire("1WSQk");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $b39ebc005c5eaf89$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureException(exception, (0, $1WSQk.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $b39ebc005c5eaf89$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $b39ebc005c5eaf89$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $b39ebc005c5eaf89$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $b39ebc005c5eaf89$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $egVmm.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b39ebc005c5eaf89$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $egVmm.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $b39ebc005c5eaf89$export$9a4fed82c350c2bd(callback) {
    return (0, $egVmm.runWithAsyncContext)(()=>{
        return callback((0, $egVmm.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $b39ebc005c5eaf89$export$e57ac09b143d92a2(span, callback) {
    return $b39ebc005c5eaf89$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $b39ebc005c5eaf89$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b39ebc005c5eaf89$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (!client) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $1y8R2.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $b39ebc005c5eaf89$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $b39ebc005c5eaf89$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $leMLP.timestampInSeconds)();
    function finishCheckIn(status) {
        $b39ebc005c5eaf89$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $leMLP.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $dlAFs.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b39ebc005c5eaf89$export$4909b86c8034bf73(timeout) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $b39ebc005c5eaf89$export$8360e631d277ea4d(timeout) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $b39ebc005c5eaf89$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $b39ebc005c5eaf89$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $b39ebc005c5eaf89$export$3f95c6f800b78024() {
    return !!$b39ebc005c5eaf89$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $b39ebc005c5eaf89$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $egVmm.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $b39ebc005c5eaf89$export$c0d84948cecf78d8(context) {
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $b5y9n.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $4mb67.GLOBAL_OBJ).navigator || {};
    const session = (0, $AQ9Bo.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $AQ9Bo.updateSession)(currentSession, {
        status: 'exited'
    });
    $b39ebc005c5eaf89$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $b39ebc005c5eaf89$export$17a5be43989a0bc1() {
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $AQ9Bo.closeSession)(session);
    $b39ebc005c5eaf89$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $b39ebc005c5eaf89$var$_sendSessionUpdate() {
    const isolationScope = (0, $egVmm.getIsolationScope)();
    const currentScope = $b39ebc005c5eaf89$export$c7be4b0125a10cba();
    const client = $b39ebc005c5eaf89$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $b39ebc005c5eaf89$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $b39ebc005c5eaf89$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $b39ebc005c5eaf89$var$_sendSessionUpdate();
}

});
parcelRegister("4mb67", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $32c1d343120fd67b$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $32c1d343120fd67b$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $32c1d343120fd67b$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $32c1d343120fd67b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $32c1d343120fd67b$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $32c1d343120fd67b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $32c1d343120fd67b$var$isGlobalObj(window) || typeof self == 'object' && $32c1d343120fd67b$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $32c1d343120fd67b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $32c1d343120fd67b$export$256479dc0cea61c4() {
    return $32c1d343120fd67b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $32c1d343120fd67b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $32c1d343120fd67b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("dlAFs", function(module, exports) {

$parcel$export(module.exports, "isError", () => $9b79adf0c2239458$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9b79adf0c2239458$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9b79adf0c2239458$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9b79adf0c2239458$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9b79adf0c2239458$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9b79adf0c2239458$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9b79adf0c2239458$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9b79adf0c2239458$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9b79adf0c2239458$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9b79adf0c2239458$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9b79adf0c2239458$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9b79adf0c2239458$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9b79adf0c2239458$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9b79adf0c2239458$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $9b79adf0c2239458$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $9b79adf0c2239458$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9b79adf0c2239458$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$e6127cc7fe7395c3(wat) {
    switch($9b79adf0c2239458$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $9b79adf0c2239458$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$var$isBuiltin(wat, className) {
    return $9b79adf0c2239458$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$9f9636d330b71954(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$ef9e2056653f0c8e(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$12e869b2a583f783(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$844ec244b1367d54(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$c3825b437cbdea5c(wat) {
    return wat === null || $9b79adf0c2239458$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$53b83ca8eaab0383(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9b79adf0c2239458$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9b79adf0c2239458$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$49841c62b9eff15(wat) {
    return $9b79adf0c2239458$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9b79adf0c2239458$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$bc2894c7158efbac(wat) {
    return $9b79adf0c2239458$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9b79adf0c2239458$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("lN8pX", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $fdd4b42aa0c3fc99$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $fdd4b42aa0c3fc99$export$af88d00dbe7f521);

var $jK6Z8 = parcelRequire("jK6Z8");

var $4mb67 = parcelRequire("4mb67");
/** Prefix for logging strings */ const $fdd4b42aa0c3fc99$var$PREFIX = 'Sentry Logger ';
const $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $fdd4b42aa0c3fc99$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $4mb67.GLOBAL_OBJ))) return callback();
    const console = (0, $4mb67.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fdd4b42aa0c3fc99$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fdd4b42aa0c3fc99$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fdd4b42aa0c3fc99$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $jK6Z8.DEBUG_BUILD) $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $fdd4b42aa0c3fc99$export$cda52e2a8927a2ca(()=>{
                (0, $4mb67.GLOBAL_OBJ).console[name](`${$fdd4b42aa0c3fc99$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $fdd4b42aa0c3fc99$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $fdd4b42aa0c3fc99$export$af88d00dbe7f521 = $fdd4b42aa0c3fc99$var$makeLogger();

});
parcelRegister("jK6Z8", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $e5f7bb4dc7625723$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e5f7bb4dc7625723$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("leMLP", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $f760bc959839c129$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $f760bc959839c129$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $f760bc959839c129$export$baf075a948ffc0bf);

var $4mb67 = parcelRequire("4mb67");
const $f760bc959839c129$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $f760bc959839c129$export$7740643b9eeaf0c4() {
    return Date.now() / $f760bc959839c129$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $f760bc959839c129$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $4mb67.GLOBAL_OBJ);
    if (!performance || !performance.now) return $f760bc959839c129$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $f760bc959839c129$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $f760bc959839c129$export$ee52dced521e3e18 = $f760bc959839c129$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $f760bc959839c129$export$c5907b5a8838db13 = $f760bc959839c129$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $f760bc959839c129$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $f760bc959839c129$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $4mb67.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $f760bc959839c129$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $f760bc959839c129$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $f760bc959839c129$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $f760bc959839c129$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("1y8R2", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $120fd5c154f81fc1$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $120fd5c154f81fc1$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $120fd5c154f81fc1$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $120fd5c154f81fc1$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "addContextToFrame", () => $120fd5c154f81fc1$export$ec2291bfc64632f0);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $120fd5c154f81fc1$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $120fd5c154f81fc1$export$3131421a7d01b4fb);

var $aLrZa = parcelRequire("aLrZa");

var $jmfnM = parcelRequire("jmfnM");

var $4mb67 = parcelRequire("4mb67");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $120fd5c154f81fc1$export$19f53698e68b2496() {
    const gbl = (0, $4mb67.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $120fd5c154f81fc1$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $120fd5c154f81fc1$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $120fd5c154f81fc1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $120fd5c154f81fc1$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $120fd5c154f81fc1$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $120fd5c154f81fc1$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $120fd5c154f81fc1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $120fd5c154f81fc1$export$d364f2020ab30578(input) {
    const match = input.match($120fd5c154f81fc1$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $120fd5c154f81fc1$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $jmfnM.snipLine)(line, 0));
    frame.context_line = (0, $jmfnM.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $jmfnM.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $120fd5c154f81fc1$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $aLrZa.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $120fd5c154f81fc1$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("aLrZa", function(module, exports) {

$parcel$export(module.exports, "fill", () => $7d640080e6eb3f0b$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $7d640080e6eb3f0b$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $7d640080e6eb3f0b$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $7d640080e6eb3f0b$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $7d640080e6eb3f0b$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $7d640080e6eb3f0b$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $7d640080e6eb3f0b$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $7d640080e6eb3f0b$export$d25f2688db1bb433);

var $3oSFd = parcelRequire("3oSFd");

var $jK6Z8 = parcelRequire("jK6Z8");

var $dlAFs = parcelRequire("dlAFs");

var $lN8pX = parcelRequire("lN8pX");

var $jmfnM = parcelRequire("jmfnM");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $7d640080e6eb3f0b$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $7d640080e6eb3f0b$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $7d640080e6eb3f0b$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $7d640080e6eb3f0b$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $7d640080e6eb3f0b$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $7d640080e6eb3f0b$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $7d640080e6eb3f0b$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $7d640080e6eb3f0b$export$62ff257738bf57f5(value) {
    if ((0, $dlAFs.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$7d640080e6eb3f0b$var$getOwnProperties(value)
    };
    else if ((0, $dlAFs.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $7d640080e6eb3f0b$var$serializeEventTarget(value.target),
            currentTarget: $7d640080e6eb3f0b$var$serializeEventTarget(value.currentTarget),
            ...$7d640080e6eb3f0b$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $dlAFs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $7d640080e6eb3f0b$var$serializeEventTarget(target) {
    try {
        return (0, $dlAFs.isElement)(target) ? (0, $3oSFd.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $7d640080e6eb3f0b$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $7d640080e6eb3f0b$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($7d640080e6eb3f0b$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $jmfnM.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $jmfnM.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $7d640080e6eb3f0b$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($7d640080e6eb3f0b$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $7d640080e6eb3f0b$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($7d640080e6eb3f0b$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $7d640080e6eb3f0b$var$isPojo(input) {
    if (!(0, $dlAFs.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $7d640080e6eb3f0b$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dlAFs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("3oSFd", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $279e040ce8072513$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $279e040ce8072513$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $279e040ce8072513$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $279e040ce8072513$export$26727cfcc4d7e0fc);

var $dlAFs = parcelRequire("dlAFs");

var $4mb67 = parcelRequire("4mb67");
// eslint-disable-next-line deprecation/deprecation
const $279e040ce8072513$var$WINDOW = (0, $4mb67.getGlobalObject)();
const $279e040ce8072513$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $279e040ce8072513$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $279e040ce8072513$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $279e040ce8072513$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $279e040ce8072513$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($279e040ce8072513$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $dlAFs.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $279e040ce8072513$export$1cfafeee2987818b() {
    try {
        return $279e040ce8072513$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $279e040ce8072513$export$c660c1f3ab49225c(selector) {
    if ($279e040ce8072513$var$WINDOW.document && $279e040ce8072513$var$WINDOW.document.querySelector) return $279e040ce8072513$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $279e040ce8072513$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$279e040ce8072513$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("jmfnM", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $e17c0107279bbd2f$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $e17c0107279bbd2f$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $e17c0107279bbd2f$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $e17c0107279bbd2f$export$a7a5ec66062ea5d);

var $dlAFs = parcelRequire("dlAFs");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e17c0107279bbd2f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e17c0107279bbd2f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e17c0107279bbd2f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dlAFs.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e17c0107279bbd2f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dlAFs.isString)(value)) return false;
    if ((0, $dlAFs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dlAFs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e17c0107279bbd2f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e17c0107279bbd2f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("b5y9n", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $812aa6e213d9b78e$export$849dbeeeda01ae98);
const $812aa6e213d9b78e$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("cQ4mt", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $958db979092b43dc$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $958db979092b43dc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("egVmm", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $a63f0dc2ef4b012c$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $a63f0dc2ef4b012c$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getMainCarrier", () => $a63f0dc2ef4b012c$export$19eade501500c6c1);
$parcel$export(module.exports, "getHubFromCarrier", () => $a63f0dc2ef4b012c$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $a63f0dc2ef4b012c$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $a63f0dc2ef4b012c$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $a63f0dc2ef4b012c$export$70d775fb1f267027);

var $lN8pX = parcelRequire("lN8pX");
var $leMLP = parcelRequire("leMLP");
var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $1y8R2 = parcelRequire("1y8R2");

var $b5y9n = parcelRequire("b5y9n");

var $cQ4mt = parcelRequire("cQ4mt");

var $XZfNs = parcelRequire("XZfNs");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $itB3p = parcelRequire("itB3p");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $a63f0dc2ef4b012c$export$24a86ef7798177e4 = parseFloat((0, $itB3p.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $a63f0dc2ef4b012c$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $a63f0dc2ef4b012c$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $a63f0dc2ef4b012c$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $XZfNs.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $XZfNs.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $dlAFs.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $a63f0dc2ef4b012c$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $leMLP.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $lN8pX.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $a63f0dc2ef4b012c$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $a63f0dc2ef4b012c$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $cQ4mt.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $lN8pX.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $lN8pX.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $AQ9Bo.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $b5y9n.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $4mb67.GLOBAL_OBJ).navigator || {};
        const session = (0, $AQ9Bo.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $AQ9Bo.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $a63f0dc2ef4b012c$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $cQ4mt.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $a63f0dc2ef4b012c$export$19eade501500c6c1() {
    (0, $4mb67.GLOBAL_OBJ).__SENTRY__ = (0, $4mb67.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $4mb67.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$4188a14ad302d1bc(hub) {
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    const oldHub = $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry);
    $a63f0dc2ef4b012c$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $a63f0dc2ef4b012c$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $a63f0dc2ef4b012c$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $a63f0dc2ef4b012c$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$var$getGlobalHub(registry = $a63f0dc2ef4b012c$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$a63f0dc2ef4b012c$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry).isOlderThan($a63f0dc2ef4b012c$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$849f05434e95d2f2(registry, new $a63f0dc2ef4b012c$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$236689a79f5aa020(carrier, parent = $a63f0dc2ef4b012c$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$a63f0dc2ef4b012c$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(carrier).isOlderThan($a63f0dc2ef4b012c$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $a63f0dc2ef4b012c$export$849f05434e95d2f2(carrier, new $a63f0dc2ef4b012c$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a63f0dc2ef4b012c$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $a63f0dc2ef4b012c$export$70d775fb1f267027(callback, options = {}) {
    const registry = $a63f0dc2ef4b012c$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $a63f0dc2ef4b012c$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4mb67.getGlobalSingleton)('hub', ()=>new $a63f0dc2ef4b012c$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $a63f0dc2ef4b012c$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("XZfNs", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $0b4506875d60d857$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $0b4506875d60d857$export$aa55d5ab8e05984f);

var $leMLP = parcelRequire("leMLP");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $1y8R2 = parcelRequire("1y8R2");

var $bu7hL = parcelRequire("bu7hL");

var $AQ9Bo = parcelRequire("AQ9Bo");

var $cICvr = parcelRequire("cICvr");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $0b4506875d60d857$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $0b4506875d60d857$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $0b4506875d60d857$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $0b4506875d60d857$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $0b4506875d60d857$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $0b4506875d60d857$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $AQ9Bo.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $0b4506875d60d857$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $dlAFs.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $0b4506875d60d857$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $0b4506875d60d857$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $leMLP.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $cICvr.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $bu7hL.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $bu7hL.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $1y8R2.uuid4)();
        if (!this._client) {
            (0, $lN8pX.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $0b4506875d60d857$export$aa55d5ab8e05984f() {
    if (!$0b4506875d60d857$var$globalScope) $0b4506875d60d857$var$globalScope = new $0b4506875d60d857$export$775b6bb06e53a214();
    return $0b4506875d60d857$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $0b4506875d60d857$export$c83048efd17527d6(scope) {
    $0b4506875d60d857$var$globalScope = scope;
}
function $0b4506875d60d857$var$generatePropagationContext() {
    return {
        traceId: (0, $1y8R2.uuid4)(),
        spanId: (0, $1y8R2.uuid4)().substring(16)
    };
}

});
parcelRegister("bu7hL", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", () => $85c825cf5a735bc0$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $85c825cf5a735bc0$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $85c825cf5a735bc0$export$bf2a096c3e883e79);

var $4mb67 = parcelRequire("4mb67");
var $dlAFs = parcelRequire("dlAFs");
var $lN8pX = parcelRequire("lN8pX");
var $57iGk = parcelRequire("57iGk");

var $cQ4mt = parcelRequire("cQ4mt");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $85c825cf5a735bc0$export$3c4238858b85e8ac() {
    return (0, $4mb67.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $85c825cf5a735bc0$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $85c825cf5a735bc0$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $85c825cf5a735bc0$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $57iGk.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $cQ4mt.DEBUG_BUILD) && processor.id && result === null && (0, $lN8pX.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dlAFs.isThenable)(result)) result.then((final)=>$85c825cf5a735bc0$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $85c825cf5a735bc0$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("57iGk", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $3b9c18ffdaba0874$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $3b9c18ffdaba0874$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $3b9c18ffdaba0874$export$78e43115b553f358);

var $dlAFs = parcelRequire("dlAFs");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $3b9c18ffdaba0874$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($3b9c18ffdaba0874$var$States || ($3b9c18ffdaba0874$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3b9c18ffdaba0874$export$1fda8aa4d135f8aa(value) {
    return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3b9c18ffdaba0874$export$78e43115b553f358(reason) {
    return new $3b9c18ffdaba0874$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3b9c18ffdaba0874$export$6f292d4960313241 {
    constructor(executor){
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init2.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init3.call(this);
        $3b9c18ffdaba0874$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $3b9c18ffdaba0874$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $3b9c18ffdaba0874$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($3b9c18ffdaba0874$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($3b9c18ffdaba0874$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $3b9c18ffdaba0874$var$States.PENDING) return;
            if ((0, $dlAFs.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $3b9c18ffdaba0874$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $3b9c18ffdaba0874$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $3b9c18ffdaba0874$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("AQ9Bo", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $06ebd19476826491$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $06ebd19476826491$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $06ebd19476826491$export$56521d9ba90f62ee);

var $aLrZa = parcelRequire("aLrZa");
var $leMLP = parcelRequire("leMLP");
var $1y8R2 = parcelRequire("1y8R2");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $06ebd19476826491$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $leMLP.timestampInSeconds)();
    const session = {
        sid: (0, $1y8R2.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$06ebd19476826491$var$sessionToJSON(session)
    };
    if (context) $06ebd19476826491$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $06ebd19476826491$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $leMLP.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $1y8R2.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $06ebd19476826491$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $06ebd19476826491$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $06ebd19476826491$var$sessionToJSON(session) {
    return (0, $aLrZa.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("cICvr", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $94277699c2a807a7$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $94277699c2a807a7$export$25ac7e259a513db4);

var $1y8R2 = parcelRequire("1y8R2");
var $aLrZa = parcelRequire("aLrZa");

var $7AtVc = parcelRequire("7AtVc");

var $iB4pU = parcelRequire("iB4pU");

var $aYVgD = parcelRequire("aYVgD");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $94277699c2a807a7$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $94277699c2a807a7$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $94277699c2a807a7$var$applySpanToEvent(event, span);
    $94277699c2a807a7$var$applyFingerprintToEvent(event, fingerprint);
    $94277699c2a807a7$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $94277699c2a807a7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $94277699c2a807a7$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'extra', extra);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'tags', tags);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'user', user);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'contexts', contexts);
    $94277699c2a807a7$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $94277699c2a807a7$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $94277699c2a807a7$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $aLrZa.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $aLrZa.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $aLrZa.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $aLrZa.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $94277699c2a807a7$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $94277699c2a807a7$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $94277699c2a807a7$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $aYVgD.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $iB4pU.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $7AtVc.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $aYVgD.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $94277699c2a807a7$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $1y8R2.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("7AtVc", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $58631b0599d820c1$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $58631b0599d820c1$export$a117f995597e25df);

var $aLrZa = parcelRequire("aLrZa");

var $b5y9n = parcelRequire("b5y9n");

var $fq71H = parcelRequire("fq71H");

var $iB4pU = parcelRequire("iB4pU");

var $aYVgD = parcelRequire("aYVgD");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $58631b0599d820c1$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $aLrZa.dropUndefinedKeys)({
        environment: options.environment || (0, $b5y9n.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $58631b0599d820c1$export$a117f995597e25df(span) {
    const client = (0, $fq71H.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $58631b0599d820c1$export$366bad00d6815eed((0, $aYVgD.spanToJSON)(span).trace_id || '', client, (0, $fq71H.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $iB4pU.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $aYVgD.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $aYVgD.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("iB4pU", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", () => $d89f1bcbc7bf781a$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $d89f1bcbc7bf781a$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("aYVgD", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $7febee0d424b9dbc$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $7febee0d424b9dbc$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $7febee0d424b9dbc$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $7febee0d424b9dbc$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $7febee0d424b9dbc$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $7febee0d424b9dbc$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $7febee0d424b9dbc$export$3f7581298f56c6d7);

var $aLrZa = parcelRequire("aLrZa");
var $27K1p = parcelRequire("27K1p");
var $leMLP = parcelRequire("leMLP");
// These are aligned with OpenTelemetry trace flags
const $7febee0d424b9dbc$export$208d5b368507fb8b = 0x0;
const $7febee0d424b9dbc$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $7febee0d424b9dbc$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $7febee0d424b9dbc$export$92d8c23565496537(span);
    return (0, $aLrZa.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $7febee0d424b9dbc$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7febee0d424b9dbc$export$5caecac1caaf3a71(span);
    return (0, $27K1p.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $7febee0d424b9dbc$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $7febee0d424b9dbc$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $7febee0d424b9dbc$var$ensureTimestampInSeconds(input.getTime());
    return (0, $leMLP.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $7febee0d424b9dbc$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $7febee0d424b9dbc$export$92d8c23565496537(span) {
    if ($7febee0d424b9dbc$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $7febee0d424b9dbc$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $7febee0d424b9dbc$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $7febee0d424b9dbc$export$eb571cd9b5d98de8);
}

});
parcelRegister("27K1p", function(module, exports) {

$parcel$export(module.exports, "extractTraceparentData", () => $18bfef263e152628$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $18bfef263e152628$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $18bfef263e152628$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $18bfef263e152628$export$f35d907436da45cf);

var $1QelU = parcelRequire("1QelU");

var $1y8R2 = parcelRequire("1y8R2");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $18bfef263e152628$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $18bfef263e152628$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($18bfef263e152628$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $18bfef263e152628$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $18bfef263e152628$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $1QelU.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $1y8R2.uuid4)(),
            spanId: (0, $1y8R2.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $1y8R2.uuid4)(),
            parentSpanId: parentSpanId || (0, $1y8R2.uuid4)().substring(16),
            spanId: (0, $1y8R2.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $18bfef263e152628$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $18bfef263e152628$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $1QelU.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $1y8R2.uuid4)(),
        spanId: (0, $1y8R2.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $1y8R2.uuid4)(),
        parentSpanId: parentSpanId || (0, $1y8R2.uuid4)().substring(16),
        spanId: (0, $1y8R2.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $18bfef263e152628$export$f35d907436da45cf(traceId = (0, $1y8R2.uuid4)(), spanId = (0, $1y8R2.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("1QelU", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $1575c7dcc60fd6f1$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $1575c7dcc60fd6f1$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $1575c7dcc60fd6f1$export$56766feef403f365);

var $jK6Z8 = parcelRequire("jK6Z8");

var $dlAFs = parcelRequire("dlAFs");

var $lN8pX = parcelRequire("lN8pX");
const $1575c7dcc60fd6f1$export$9ca9946bd449ac06 = 'baggage';
const $1575c7dcc60fd6f1$export$6e69537d67fa20f = 'sentry-';
const $1575c7dcc60fd6f1$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $1575c7dcc60fd6f1$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $1575c7dcc60fd6f1$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $dlAFs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $1575c7dcc60fd6f1$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $1575c7dcc60fd6f1$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($1575c7dcc60fd6f1$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($1575c7dcc60fd6f1$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $1575c7dcc60fd6f1$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$1575c7dcc60fd6f1$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $1575c7dcc60fd6f1$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $1575c7dcc60fd6f1$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $1575c7dcc60fd6f1$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $1575c7dcc60fd6f1$export$bdd844ddb2def819) {
            (0, $jK6Z8.DEBUG_BUILD) && (0, $lN8pX.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("itB3p", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $d737ad8d6bf38903$export$31499a9cd224b78c);
const $d737ad8d6bf38903$export$31499a9cd224b78c = '7.119.0';

});


parcelRegister("1WSQk", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $16b5bfea67ef6af7$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $16b5bfea67ef6af7$export$76b5f966996d1653);

var $1y8R2 = parcelRequire("1y8R2");
var $leMLP = parcelRequire("leMLP");
var $4mb67 = parcelRequire("4mb67");
var $j15Q6 = parcelRequire("j15Q6");
var $jmfnM = parcelRequire("jmfnM");

var $b5y9n = parcelRequire("b5y9n");

var $bu7hL = parcelRequire("bu7hL");

var $XZfNs = parcelRequire("XZfNs");

var $cICvr = parcelRequire("cICvr");

var $aYVgD = parcelRequire("aYVgD");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $16b5bfea67ef6af7$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $1y8R2.uuid4)(),
        timestamp: event.timestamp || (0, $leMLP.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $16b5bfea67ef6af7$var$applyClientOptions(prepared, options);
    $16b5bfea67ef6af7$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $16b5bfea67ef6af7$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $16b5bfea67ef6af7$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $1y8R2.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $XZfNs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $cICvr.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $cICvr.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $cICvr.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $bu7hL.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $bu7hL.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $16b5bfea67ef6af7$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $16b5bfea67ef6af7$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $16b5bfea67ef6af7$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $b5y9n.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $jmfnM.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $jmfnM.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $jmfnM.truncate)(request.url, maxValueLength);
}
const $16b5bfea67ef6af7$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $16b5bfea67ef6af7$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $4mb67.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $16b5bfea67ef6af7$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $16b5bfea67ef6af7$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $16b5bfea67ef6af7$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $16b5bfea67ef6af7$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $16b5bfea67ef6af7$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $j15Q6.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $j15Q6.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $j15Q6.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $j15Q6.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $j15Q6.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $aYVgD.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $j15Q6.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $16b5bfea67ef6af7$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $XZfNs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $16b5bfea67ef6af7$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($16b5bfea67ef6af7$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($16b5bfea67ef6af7$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $16b5bfea67ef6af7$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $XZfNs.Scope) || typeof hint === 'function';
}
const $16b5bfea67ef6af7$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $16b5bfea67ef6af7$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$16b5bfea67ef6af7$var$captureContextKeys.includes(key));
}

});
parcelRegister("j15Q6", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $dd82a3e2defd66c3$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $dd82a3e2defd66c3$export$23fbbb20bed71033);

var $dlAFs = parcelRequire("dlAFs");

var $bH6rI = parcelRequire("bH6rI");

var $aLrZa = parcelRequire("aLrZa");

var $jVtDJ = parcelRequire("jVtDJ");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dd82a3e2defd66c3$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $dd82a3e2defd66c3$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $dd82a3e2defd66c3$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $dd82a3e2defd66c3$export$a3295358bff77e(object, depth);
    if ($dd82a3e2defd66c3$var$jsonSize(normalized) > maxSize) return $dd82a3e2defd66c3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $dd82a3e2defd66c3$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $bH6rI.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $dlAFs.isNaN)(value)) return value;
    const stringified = $dd82a3e2defd66c3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $dd82a3e2defd66c3$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $aLrZa.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $dd82a3e2defd66c3$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $dd82a3e2defd66c3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $dlAFs.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $dlAFs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $jVtDJ.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $dd82a3e2defd66c3$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $dd82a3e2defd66c3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $dd82a3e2defd66c3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dd82a3e2defd66c3$var$jsonSize(value) {
    return $dd82a3e2defd66c3$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $dd82a3e2defd66c3$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("bH6rI", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $8838b5eb2ad6927f$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $8838b5eb2ad6927f$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("jVtDJ", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $e81a55111f017fb6$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $e81a55111f017fb6$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $e81a55111f017fb6$export$aad197c7121a6651);

var $g1pU3 = parcelRequire("g1pU3");
const $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $e81a55111f017fb6$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $e81a55111f017fb6$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($e81a55111f017fb6$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $e81a55111f017fb6$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $e81a55111f017fb6$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $e81a55111f017fb6$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $e81a55111f017fb6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($e81a55111f017fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($e81a55111f017fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $e81a55111f017fb6$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $e81a55111f017fb6$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $e81a55111f017fb6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $e81a55111f017fb6$var$defaultFunctionName;
        return fn.name || $e81a55111f017fb6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $e81a55111f017fb6$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $e81a55111f017fb6$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $g1pU3.node)(getModule)
    ];
}

});
parcelRegister("g1pU3", function(module, exports) {

$parcel$export(module.exports, "node", () => $baa0d5261c6742c8$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $baa0d5261c6742c8$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $baa0d5261c6742c8$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $baa0d5261c6742c8$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});








parcelRegister("1Nxtn", function(module, exports) {
"use strict";
var $14f4550c94fd1c44$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14f4550c94fd1c44$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $14f4550c94fd1c44$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $b9ZdZ = parcelRequire("b9ZdZ");
module.exports.StatsigClient = $b9ZdZ.default;

$14f4550c94fd1c44$var$__exportStar((parcelRequire("10Gqk")), module.exports);
const $14f4550c94fd1c44$var$__STATSIG__ = Object.assign((0, (parcelRequire("10Gqk"))._getStatsigGlobal)(), {
    StatsigClient: $b9ZdZ.default
});
module.exports.default = $14f4550c94fd1c44$var$__STATSIG__;

});
parcelRegister("10Gqk", function(module, exports) {
"use strict";
var $0bc6b2fd8e2f8939$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0bc6b2fd8e2f8939$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0bc6b2fd8e2f8939$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cLdPq")).Diagnostics;
    }
});

var $jPmF4 = parcelRequire("jPmF4");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $jPmF4.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("bWQcA")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6abDe")).Storage;
    }
});

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("dWN0S")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cKhdt")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("kvuMv")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("lTh7N")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cLdPq")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("3Ldy5")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("chIEM")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("jQTNP")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("4r2xR")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("iFJ4e")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("6gUK9")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("bWQcA")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9ewyA")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("fcTTc")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("5oGx8")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("j5rLe")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("lHEph")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("41u1G")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("aufpK")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("i7IAl")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("kISM6")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2EFwj")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2hLV8")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("egTIF")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("c0FvX")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cOFsX")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("2av9q")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("ejscn")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("cJCL7")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("jKP2H")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("dHfQC")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("6abDe")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("fAGEY")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9nGbQ")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("9cY7K")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("4Pas4")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("LDu8c")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("b7bEu")), module.exports);

$0bc6b2fd8e2f8939$var$__exportStar((parcelRequire("CFdSR")), module.exports);
Object.assign((0, (parcelRequire("dWN0S"))._getStatsigGlobal)(), {
    Log: (parcelRequire("bWQcA")).Log,
    SDK_VERSION: (parcelRequire("cOFsX")).SDK_VERSION
});

});
parcelRegister("dWN0S", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $a276b61d30e1e400$var$_a, $a276b61d30e1e400$var$_b, $a276b61d30e1e400$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $bWQcA = parcelRequire("bWQcA");
const $a276b61d30e1e400$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $a276b61d30e1e400$var$statsigGlobal;
    } catch (e) {
        return $a276b61d30e1e400$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $a276b61d30e1e400$var$_getStatsigGlobal;
const $a276b61d30e1e400$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $a276b61d30e1e400$var$_getStatsigGlobalFlag;
const $a276b61d30e1e400$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $bWQcA.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $a276b61d30e1e400$var$_getInstance;
const $a276b61d30e1e400$var$GLOBAL_KEY = '__STATSIG__';
const $a276b61d30e1e400$var$_window = typeof window !== 'undefined' ? window : {};
const $a276b61d30e1e400$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $a276b61d30e1e400$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $a276b61d30e1e400$var$statsigGlobal = ($a276b61d30e1e400$var$_c = ($a276b61d30e1e400$var$_b = ($a276b61d30e1e400$var$_a = $a276b61d30e1e400$var$_window[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_a !== void 0 ? $a276b61d30e1e400$var$_a : $a276b61d30e1e400$var$_global[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_b !== void 0 ? $a276b61d30e1e400$var$_b : $a276b61d30e1e400$var$_globalThis[$a276b61d30e1e400$var$GLOBAL_KEY]) !== null && $a276b61d30e1e400$var$_c !== void 0 ? $a276b61d30e1e400$var$_c : {
    instance: module.exports._getInstance
};
$a276b61d30e1e400$var$_window[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;
$a276b61d30e1e400$var$_global[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;
$a276b61d30e1e400$var$_globalThis[$a276b61d30e1e400$var$GLOBAL_KEY] = $a276b61d30e1e400$var$statsigGlobal;

});
parcelRegister("bWQcA", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $8b2d9ab9bfd5eaf2$var$DEBUG = ' DEBUG ';
const $8b2d9ab9bfd5eaf2$var$_INFO = '  INFO ';
const $8b2d9ab9bfd5eaf2$var$_WARN = '  WARN ';
const $8b2d9ab9bfd5eaf2$var$ERROR = ' ERROR ';
function $8b2d9ab9bfd5eaf2$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $8b2d9ab9bfd5eaf2$var$Log {
    static info(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Info) console.info($8b2d9ab9bfd5eaf2$var$_INFO, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static debug(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Debug) console.debug($8b2d9ab9bfd5eaf2$var$DEBUG, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static warn(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Warn) console.warn($8b2d9ab9bfd5eaf2$var$_WARN, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
    static error(...args) {
        if ($8b2d9ab9bfd5eaf2$var$Log.level >= module.exports.LogLevel.Error) console.error($8b2d9ab9bfd5eaf2$var$ERROR, ...$8b2d9ab9bfd5eaf2$var$addTag(args));
    }
}
module.exports.Log = $8b2d9ab9bfd5eaf2$var$Log;
$8b2d9ab9bfd5eaf2$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("cLdPq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $94a499d7a6ebffae$var$MARKER_MAP = new Map();
const $94a499d7a6ebffae$var$ACT_START = 'start';
const $94a499d7a6ebffae$var$ACT_END = 'end';
const $94a499d7a6ebffae$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $94a499d7a6ebffae$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({}, $94a499d7a6ebffae$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $94a499d7a6ebffae$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker({}, $94a499d7a6ebffae$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $94a499d7a6ebffae$var$_addMarker(sdkKey, $94a499d7a6ebffae$var$_createMarker(data, $94a499d7a6ebffae$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $94a499d7a6ebffae$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $94a499d7a6ebffae$var$_safeGetField(e, 'code'),
            name: $94a499d7a6ebffae$var$_safeGetField(e, 'name'),
            message: $94a499d7a6ebffae$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $94a499d7a6ebffae$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $94a499d7a6ebffae$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $94a499d7a6ebffae$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $94a499d7a6ebffae$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $94a499d7a6ebffae$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $94a499d7a6ebffae$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $94a499d7a6ebffae$var$MARKER_MAP.set(sdkKey, markers);
}
function $94a499d7a6ebffae$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("jPmF4", function(module, exports) {
"use strict";
var $e6f45bd75fd22a5d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $cKhdt = parcelRequire("cKhdt");

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");

var $fcTTc = parcelRequire("fcTTc");

var $41u1G = parcelRequire("41u1G");

var $c0FvX = parcelRequire("c0FvX");

var $2av9q = parcelRequire("2av9q");

var $6abDe = parcelRequire("6abDe");

var $9cY7K = parcelRequire("9cY7K");

var $LDu8c = parcelRequire("LDu8c");
const $e6f45bd75fd22a5d$var$DEFAULT_QUEUE_SIZE = 100;
const $e6f45bd75fd22a5d$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $e6f45bd75fd22a5d$var$MAX_DEDUPER_KEYS = 1000;
const $e6f45bd75fd22a5d$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $e6f45bd75fd22a5d$var$MAX_FAILED_LOGS = 500;
const $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS = 200;
const $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP = {};
const $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $e6f45bd75fd22a5d$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $2av9q.LoggingEnabledOption.disabled : $2av9q.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $bWQcA.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $e6f45bd75fd22a5d$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $9cY7K.UrlConfiguration($fcTTc.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $41u1G._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $LDu8c._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $e6f45bd75fd22a5d$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey), $e6f45bd75fd22a5d$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $41u1G._isServerEnv)()) return false;
        if (!(0, $c0FvX._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $cKhdt._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $e6f45bd75fd22a5d$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $e6f45bd75fd22a5d$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $LDu8c._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $bWQcA.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $bWQcA.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$fcTTc.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $e6f45bd75fd22a5d$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $6abDe._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $bWQcA.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$e6f45bd75fd22a5d$var$__awaiter(this, void 0, void 0, function*() {
                if (!$6abDe.Storage.isReady()) yield $6abDe.Storage.isReadyResolver();
                const events = (0, $6abDe._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.Startup) $6abDe.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $e6f45bd75fd22a5d$var$RetryFailedLogsTrigger.GainedFocus) $6abDe.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $bWQcA.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $iFJ4e._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $bWQcA.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $41u1G._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $e6f45bd75fd22a5d$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $e6f45bd75fd22a5d$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $e6f45bd75fd22a5d$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $e6f45bd75fd22a5d$var$EventLogger;

});
parcelRegister("cKhdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $iFJ4e = parcelRequire("iFJ4e");
function $947722b3fa4f6609$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $iFJ4e._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $947722b3fa4f6609$var$_getUserStorageKey;
function $947722b3fa4f6609$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $947722b3fa4f6609$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $iFJ4e._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $947722b3fa4f6609$var$_getStorageKey;

});
parcelRegister("iFJ4e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9nGbQ = parcelRequire("9nGbQ");
const $d97f03c19f6b4be6$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $d97f03c19f6b4be6$var$_DJB2;
const $d97f03c19f6b4be6$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $d97f03c19f6b4be6$var$_DJB2Object;
const $d97f03c19f6b4be6$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9nGbQ._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $d97f03c19f6b4be6$var$_getSortedObject;

});
parcelRegister("9nGbQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6d46fd1d22276144$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6d46fd1d22276144$var$_typeOf;
function $6d46fd1d22276144$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6d46fd1d22276144$var$_isTypeMatch;

});



parcelRegister("fcTTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("41u1G", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $2ede8bff48d17c3f$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $2ede8bff48d17c3f$var$_getWindowSafe;
const $2ede8bff48d17c3f$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $2ede8bff48d17c3f$var$_getDocumentSafe;
const $2ede8bff48d17c3f$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $6cAn5 !== 'undefined' && $6cAn5.versions != null && $6cAn5.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $2ede8bff48d17c3f$var$_isServerEnv;
const $2ede8bff48d17c3f$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $2ede8bff48d17c3f$var$_addWindowEventListenerSafe;
const $2ede8bff48d17c3f$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $2ede8bff48d17c3f$var$_addDocumentEventListenerSafe;
const $2ede8bff48d17c3f$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $2ede8bff48d17c3f$var$_getCurrentPageUrlSafe;
const $2ede8bff48d17c3f$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $2ede8bff48d17c3f$var$_getUnloadEvent;

});
parcelRegister("6cAn5", function(module, exports) {
// shim for using process in browser
var $484013ac3f8916ed$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $484013ac3f8916ed$var$cachedSetTimeout;
var $484013ac3f8916ed$var$cachedClearTimeout;
function $484013ac3f8916ed$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $484013ac3f8916ed$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $484013ac3f8916ed$var$cachedSetTimeout = setTimeout;
        else $484013ac3f8916ed$var$cachedSetTimeout = $484013ac3f8916ed$var$defaultSetTimout;
    } catch (e) {
        $484013ac3f8916ed$var$cachedSetTimeout = $484013ac3f8916ed$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $484013ac3f8916ed$var$cachedClearTimeout = clearTimeout;
        else $484013ac3f8916ed$var$cachedClearTimeout = $484013ac3f8916ed$var$defaultClearTimeout;
    } catch (e) {
        $484013ac3f8916ed$var$cachedClearTimeout = $484013ac3f8916ed$var$defaultClearTimeout;
    }
})();
function $484013ac3f8916ed$var$runTimeout(fun) {
    if ($484013ac3f8916ed$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($484013ac3f8916ed$var$cachedSetTimeout === $484013ac3f8916ed$var$defaultSetTimout || !$484013ac3f8916ed$var$cachedSetTimeout) && setTimeout) {
        $484013ac3f8916ed$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $484013ac3f8916ed$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $484013ac3f8916ed$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $484013ac3f8916ed$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $484013ac3f8916ed$var$runClearTimeout(marker) {
    if ($484013ac3f8916ed$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($484013ac3f8916ed$var$cachedClearTimeout === $484013ac3f8916ed$var$defaultClearTimeout || !$484013ac3f8916ed$var$cachedClearTimeout) && clearTimeout) {
        $484013ac3f8916ed$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $484013ac3f8916ed$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $484013ac3f8916ed$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $484013ac3f8916ed$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $484013ac3f8916ed$var$queue = [];
var $484013ac3f8916ed$var$draining = false;
var $484013ac3f8916ed$var$currentQueue;
var $484013ac3f8916ed$var$queueIndex = -1;
function $484013ac3f8916ed$var$cleanUpNextTick() {
    if (!$484013ac3f8916ed$var$draining || !$484013ac3f8916ed$var$currentQueue) return;
    $484013ac3f8916ed$var$draining = false;
    if ($484013ac3f8916ed$var$currentQueue.length) $484013ac3f8916ed$var$queue = $484013ac3f8916ed$var$currentQueue.concat($484013ac3f8916ed$var$queue);
    else $484013ac3f8916ed$var$queueIndex = -1;
    if ($484013ac3f8916ed$var$queue.length) $484013ac3f8916ed$var$drainQueue();
}
function $484013ac3f8916ed$var$drainQueue() {
    if ($484013ac3f8916ed$var$draining) return;
    var timeout = $484013ac3f8916ed$var$runTimeout($484013ac3f8916ed$var$cleanUpNextTick);
    $484013ac3f8916ed$var$draining = true;
    var len = $484013ac3f8916ed$var$queue.length;
    while(len){
        $484013ac3f8916ed$var$currentQueue = $484013ac3f8916ed$var$queue;
        $484013ac3f8916ed$var$queue = [];
        while(++$484013ac3f8916ed$var$queueIndex < len)if ($484013ac3f8916ed$var$currentQueue) $484013ac3f8916ed$var$currentQueue[$484013ac3f8916ed$var$queueIndex].run();
        $484013ac3f8916ed$var$queueIndex = -1;
        len = $484013ac3f8916ed$var$queue.length;
    }
    $484013ac3f8916ed$var$currentQueue = null;
    $484013ac3f8916ed$var$draining = false;
    $484013ac3f8916ed$var$runClearTimeout(timeout);
}
$484013ac3f8916ed$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $484013ac3f8916ed$var$queue.push(new $484013ac3f8916ed$var$Item(fun, args));
    if ($484013ac3f8916ed$var$queue.length === 1 && !$484013ac3f8916ed$var$draining) $484013ac3f8916ed$var$runTimeout($484013ac3f8916ed$var$drainQueue);
};
// v8 likes predictible objects
function $484013ac3f8916ed$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$484013ac3f8916ed$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$484013ac3f8916ed$var$process.title = 'browser';
$484013ac3f8916ed$var$process.browser = true;
$484013ac3f8916ed$var$process.env = {};
$484013ac3f8916ed$var$process.argv = [];
$484013ac3f8916ed$var$process.version = ''; // empty string to avoid regexp issues
$484013ac3f8916ed$var$process.versions = {};
function $484013ac3f8916ed$var$noop() {}
$484013ac3f8916ed$var$process.on = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.addListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.once = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.off = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.removeListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.removeAllListeners = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.emit = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.prependListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.prependOnceListener = $484013ac3f8916ed$var$noop;
$484013ac3f8916ed$var$process.listeners = function(name) {
    return [];
};
$484013ac3f8916ed$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$484013ac3f8916ed$var$process.cwd = function() {
    return '/';
};
$484013ac3f8916ed$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$484013ac3f8916ed$var$process.umask = function() {
    return 0;
};

});


parcelRegister("c0FvX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $8be5b000a996ae67$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $8be5b000a996ae67$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $8be5b000a996ae67$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $8be5b000a996ae67$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $8be5b000a996ae67$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $8be5b000a996ae67$var$GATE_EXPOSURE_NAME || eventName === $8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME || eventName === $8be5b000a996ae67$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $8be5b000a996ae67$var$_isExposureEvent;
const $8be5b000a996ae67$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $8be5b000a996ae67$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $8be5b000a996ae67$var$_createGateExposure;
function $8be5b000a996ae67$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $8be5b000a996ae67$var$_mapExposures;
const $8be5b000a996ae67$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $8be5b000a996ae67$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $8be5b000a996ae67$var$_createConfigExposure;
const $8be5b000a996ae67$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const parameterRuleIDs = (_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_e = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _e !== void 0 ? _e : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_f = layer.__evaluation) === null || _f === void 0 ? void 0 : _f.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $8be5b000a996ae67$var$_createExposure($8be5b000a996ae67$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $8be5b000a996ae67$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $8be5b000a996ae67$var$_createLayerParameterExposure;
const $8be5b000a996ae67$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("2av9q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("6abDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $41u1G = parcelRequire("41u1G");
const $47ccb314d7420b3b$var$inMemoryStore = {};
const $47ccb314d7420b3b$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$47ccb314d7420b3b$var$inMemoryStore[key] ? $47ccb314d7420b3b$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $47ccb314d7420b3b$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $47ccb314d7420b3b$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($47ccb314d7420b3b$var$inMemoryStore)
};
let $47ccb314d7420b3b$var$_localStorageProvider = null;
try {
    const win = (0, $41u1G._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $47ccb314d7420b3b$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $bWQcA.Log.warn('Failed to setup localStorageProvider.');
}
let $47ccb314d7420b3b$var$_main = $47ccb314d7420b3b$var$_localStorageProvider !== null && $47ccb314d7420b3b$var$_localStorageProvider !== void 0 ? $47ccb314d7420b3b$var$_localStorageProvider : $47ccb314d7420b3b$var$_inMemoryProvider;
let $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_main;
function $47ccb314d7420b3b$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($47ccb314d7420b3b$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$47ccb314d7420b3b$var$_current.isReady(),
    isReadyResolver: ()=>$47ccb314d7420b3b$var$_current.isReadyResolver(),
    getProviderName: ()=>$47ccb314d7420b3b$var$_current.getProviderName(),
    getItem: (key)=>$47ccb314d7420b3b$var$_inMemoryBreaker(()=>$47ccb314d7420b3b$var$_current.getItem(key)),
    setItem: (key, value)=>$47ccb314d7420b3b$var$_inMemoryBreaker(()=>$47ccb314d7420b3b$var$_current.setItem(key, value)),
    removeItem: (key)=>$47ccb314d7420b3b$var$_current.removeItem(key),
    getAllKeys: ()=>$47ccb314d7420b3b$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $47ccb314d7420b3b$var$_main = newProvider;
        $47ccb314d7420b3b$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_inMemoryProvider;
        else $47ccb314d7420b3b$var$_current = $47ccb314d7420b3b$var$_main;
    }
};
function $47ccb314d7420b3b$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $47ccb314d7420b3b$var$_getObjectFromStorage;
function $47ccb314d7420b3b$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $47ccb314d7420b3b$var$_setObjectInStorage;

});

parcelRegister("9cY7K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $iFJ4e = parcelRequire("iFJ4e");

var $fcTTc = parcelRequire("fcTTc");
const $6b43df6ee783ce73$var$ENDPOINT_DNS_KEY_MAP = {
    [$fcTTc.Endpoint._initialize]: 'i',
    [$fcTTc.Endpoint._rgstr]: 'e',
    [$fcTTc.Endpoint._download_config_specs]: 'd'
};
class $6b43df6ee783ce73$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $6b43df6ee783ce73$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $fcTTc.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $iFJ4e._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $6b43df6ee783ce73$var$UrlConfiguration;

});

parcelRegister("LDu8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $41u1G = parcelRequire("41u1G");
const $08f304cbfc59140c$var$FOREGROUND = 'foreground';
const $08f304cbfc59140c$var$BACKGROUND = 'background';
const $08f304cbfc59140c$var$LISTENERS = [];
let $08f304cbfc59140c$var$current = $08f304cbfc59140c$var$FOREGROUND;
let $08f304cbfc59140c$var$isUnloading = false;
const $08f304cbfc59140c$var$_isCurrentlyVisible = ()=>{
    return $08f304cbfc59140c$var$current === $08f304cbfc59140c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $08f304cbfc59140c$var$_isCurrentlyVisible;
const $08f304cbfc59140c$var$_isUnloading = ()=>$08f304cbfc59140c$var$isUnloading;
module.exports._isUnloading = $08f304cbfc59140c$var$_isUnloading;
const $08f304cbfc59140c$var$_subscribeToVisiblityChanged = (listener)=>{
    $08f304cbfc59140c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $08f304cbfc59140c$var$_subscribeToVisiblityChanged;
const $08f304cbfc59140c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $08f304cbfc59140c$var$current) return;
    $08f304cbfc59140c$var$current = visibility;
    $08f304cbfc59140c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $08f304cbfc59140c$var$_notifyVisibilityChanged;
(0, $41u1G._addWindowEventListenerSafe)('focus', ()=>{
    $08f304cbfc59140c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$FOREGROUND);
});
(0, $41u1G._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$BACKGROUND));
(0, $41u1G._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $08f304cbfc59140c$var$FOREGROUND : $08f304cbfc59140c$var$BACKGROUND);
});
(0, $41u1G._addWindowEventListenerSafe)((0, $41u1G._getUnloadEvent)(), ()=>{
    $08f304cbfc59140c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($08f304cbfc59140c$var$BACKGROUND);
});

});


parcelRegister("cOFsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.17.2';
let $954a51ddfc554c85$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$954a51ddfc554c85$var$metadata,
    add: (additions)=>{
        $954a51ddfc554c85$var$metadata = Object.assign(Object.assign({}, $954a51ddfc554c85$var$metadata), additions);
    }
};

});

parcelRegister("kvuMv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lTh7N", function(module, exports) {
"use strict";
var $fefc04a5334f0e35$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $kISM6 = parcelRequire("kISM6");

var $dHfQC = parcelRequire("dHfQC");

var $6abDe = parcelRequire("6abDe");

var $fAGEY = parcelRequire("fAGEY");
const $fefc04a5334f0e35$var$CACHE_LIMIT = 10;
class $fefc04a5334f0e35$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $fefc04a5334f0e35$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $fefc04a5334f0e35$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            if (!$6abDe.Storage.isReady()) yield $6abDe.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $bWQcA.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $dHfQC._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        var _a;
        return $fefc04a5334f0e35$var$__awaiter(this, void 0, void 0, function*() {
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $bWQcA.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $fAGEY._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $kISM6.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $fefc04a5334f0e35$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $fefc04a5334f0e35$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $bWQcA.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $6abDe.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($6abDe.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $fAGEY._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $6abDe.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $6abDe._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $fefc04a5334f0e35$var$_getEvictableKey(lastModifiedTimeMap, $fefc04a5334f0e35$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $6abDe.Storage.removeItem(evictable);
        }
        (0, $6abDe._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $fefc04a5334f0e35$var$DataAdapterCore;
function $fefc04a5334f0e35$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $dHfQC._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $fefc04a5334f0e35$var$_makeDataAdapterResult;
class $fefc04a5334f0e35$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $bWQcA.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $fefc04a5334f0e35$var$_getEvictableKey(this._data, $fefc04a5334f0e35$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $fefc04a5334f0e35$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("kISM6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $cKhdt = parcelRequire("cKhdt");

var $bWQcA = parcelRequire("bWQcA");

var $41u1G = parcelRequire("41u1G");

var $6abDe = parcelRequire("6abDe");

var $4Pas4 = parcelRequire("4Pas4");
const $f16267e08d9b62ab$var$PROMISE_MAP = {};
const $f16267e08d9b62ab$var$COOKIE_ENABLED_MAP = {};
const $f16267e08d9b62ab$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($f16267e08d9b62ab$var$DISABLED_MAP[sdkKey]) return null;
        if ($f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] != null) return $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $f16267e08d9b62ab$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] = stableID;
            $f16267e08d9b62ab$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $f16267e08d9b62ab$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $4Pas4.getUUID)();
        $f16267e08d9b62ab$var$_persistToStorage(stableID, sdkKey);
        $f16267e08d9b62ab$var$_persistToCookie(stableID, sdkKey);
        $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $f16267e08d9b62ab$var$PROMISE_MAP[sdkKey] = override;
        $f16267e08d9b62ab$var$_persistToStorage(override, sdkKey);
        $f16267e08d9b62ab$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $f16267e08d9b62ab$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $f16267e08d9b62ab$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $cKhdt._getStorageKey)(sdkKey)}`;
}
function $f16267e08d9b62ab$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $6abDe._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $bWQcA.Log.warn('Failed to save StableID to storage');
    }
}
function $f16267e08d9b62ab$var$_loadFromStorage(sdkKey) {
    const storageKey = $f16267e08d9b62ab$var$_getStableIDStorageKey(sdkKey);
    return (0, $6abDe._getObjectFromStorage)(storageKey);
}
function $f16267e08d9b62ab$var$_loadFromCookie(sdkKey) {
    if (!$f16267e08d9b62ab$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $41u1G._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $f16267e08d9b62ab$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $f16267e08d9b62ab$var$_persistToCookie(stableID, sdkKey) {
    if (!$f16267e08d9b62ab$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$f16267e08d9b62ab$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $f16267e08d9b62ab$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $cKhdt._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("4Pas4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $3834085e5db4efd7$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $3834085e5db4efd7$var$getUUID;

});


parcelRegister("dHfQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");
function $9f8b9588b140fb9e$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $bWQcA.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $9f8b9588b140fb9e$var$_normalizeUser;
function $9f8b9588b140fb9e$var$_getFullUserHash(user) {
    return user ? (0, $iFJ4e._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $9f8b9588b140fb9e$var$_getFullUserHash;

});

parcelRegister("fAGEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $bWQcA = parcelRequire("bWQcA");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $b59b4f260bbb468d$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $bWQcA.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $b59b4f260bbb468d$var$_typedJsonParse;

});


parcelRegister("3Ldy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("chIEM", function(module, exports) {
"use strict";
var $8f19b676caca501d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $aufpK = parcelRequire("aufpK");

var $cOFsX = parcelRequire("cOFsX");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $8f19b676caca501d$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $8f19b676caca501d$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $8f19b676caca501d$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $8f19b676caca501d$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $bWQcA.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$8f19b676caca501d$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($8f19b676caca501d$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $8f19b676caca501d$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $aufpK.SDKType._get(this._sdkKey);
                    const statsigMetadata = $cOFsX.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $8f19b676caca501d$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $8f19b676caca501d$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $8f19b676caca501d$var$ErrorBoundary;
function $8f19b676caca501d$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $8f19b676caca501d$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $8f19b676caca501d$var$UNKNOWN_ERROR;
    }
}
function $8f19b676caca501d$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $8f19b676caca501d$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("aufpK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $7a28a9aa1041049f$var$SDK_CLIENT = {};
let $7a28a9aa1041049f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $7a28a9aa1041049f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($7a28a9aa1041049f$var$suffix !== null && $7a28a9aa1041049f$var$suffix !== void 0 ? $7a28a9aa1041049f$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $7a28a9aa1041049f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$7a28a9aa1041049f$var$suffix || $7a28a9aa1041049f$var$suffix === '-react') $7a28a9aa1041049f$var$suffix = '-' + binding;
    }
};

});


parcelRegister("jQTNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4r2xR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6gUK9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9ewyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $6b8eacf9f40140b7$var$EXIST_KEYS = new Set([]);
const $6b8eacf9f40140b7$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $6b8eacf9f40140b7$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($6b8eacf9f40140b7$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($6b8eacf9f40140b7$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $6b8eacf9f40140b7$var$createMemoKey;

});

parcelRegister("5oGx8", function(module, exports) {
"use strict";
var $3ee02fe0b5e0b9b6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $dWN0S = parcelRequire("dWN0S");

var $dWN0S = parcelRequire("dWN0S");

var $cLdPq = parcelRequire("cLdPq");

var $bWQcA = parcelRequire("bWQcA");

var $fcTTc = parcelRequire("fcTTc");

var $goBIO = parcelRequire("goBIO");

var $CFdSR = parcelRequire("CFdSR");

var $aufpK = parcelRequire("aufpK");

var $41u1G = parcelRequire("41u1G");

var $i7IAl = parcelRequire("i7IAl");

var $kISM6 = parcelRequire("kISM6");

var $2hLV8 = parcelRequire("2hLV8");

var $cOFsX = parcelRequire("cOFsX");

var $2av9q = parcelRequire("2av9q");

var $LDu8c = parcelRequire("LDu8c");
const $3ee02fe0b5e0b9b6$var$DEFAULT_TIMEOUT_MS = 10000;
const $3ee02fe0b5e0b9b6$var$BACKOFF_BASE_MS = 500;
const $3ee02fe0b5e0b9b6$var$BACKOFF_MAX_MS = 30000;
const $3ee02fe0b5e0b9b6$var$RATE_LIMIT_WINDOW_MS = 1000;
const $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $3ee02fe0b5e0b9b6$var$LEAK_RATE = $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT / $3ee02fe0b5e0b9b6$var$RATE_LIMIT_WINDOW_MS;
const $3ee02fe0b5e0b9b6$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $3ee02fe0b5e0b9b6$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $3ee02fe0b5e0b9b6$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $goBIO.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$3ee02fe0b5e0b9b6$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            if (!$3ee02fe0b5e0b9b6$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $bWQcA.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $LDu8c._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $3ee02fe0b5e0b9b6$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $3ee02fe0b5e0b9b6$var$_getErrorMessage(abortController, error);
                const timedOut = $3ee02fe0b5e0b9b6$var$_didTimeout(abortController);
                $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$3ee02fe0b5e0b9b6$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $2hLV8.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $bWQcA.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $3ee02fe0b5e0b9b6$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $2av9q.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $2av9q.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $3ee02fe0b5e0b9b6$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $3ee02fe0b5e0b9b6$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $fcTTc.Endpoint._initialize || args.urlConfig.endpoint === $fcTTc.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$fcTTc.NetworkParam.SdkKey]: args.sdkKey,
            [$fcTTc.NetworkParam.SdkType]: $aufpK.SDKType._get(args.sdkKey),
            [$fcTTc.NetworkParam.SdkVersion]: $cOFsX.SDK_VERSION,
            [$fcTTc.NetworkParam.Time]: String(Date.now()),
            [$fcTTc.NetworkParam.SessionID]: $i7IAl.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $41u1G._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $dWN0S._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$fcTTc.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $bWQcA.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        var _a;
        return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
            const body = args.body;
            if (typeof body !== 'string' || !$3ee02fe0b5e0b9b6$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($bWQcA.Log.error);
                writer.close().catch($bWQcA.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$fcTTc.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $bWQcA.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $3ee02fe0b5e0b9b6$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $3ee02fe0b5e0b9b6$var$NetworkCore;
const $3ee02fe0b5e0b9b6$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $bWQcA.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $3ee02fe0b5e0b9b6$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $kISM6.StableID.get(sdkKey);
    const sessionID = $i7IAl.SessionID.get(sdkKey);
    const sdkType = $aufpK.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $cOFsX.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $3ee02fe0b5e0b9b6$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $dWN0S._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $CFdSR.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $2av9q.LogEventCompressionMode.Disabled:
            return false;
        case $2av9q.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $2av9q.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $3ee02fe0b5e0b9b6$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $3ee02fe0b5e0b9b6$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $3ee02fe0b5e0b9b6$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $fcTTc.Endpoint._initialize) return;
    $cLdPq.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $3ee02fe0b5e0b9b6$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $fcTTc.Endpoint._initialize) return;
    $cLdPq.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $cLdPq.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $3ee02fe0b5e0b9b6$var$_exponentialBackoff(attempt) {
    return $3ee02fe0b5e0b9b6$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($3ee02fe0b5e0b9b6$var$BACKOFF_BASE_MS * (attempt * attempt), $3ee02fe0b5e0b9b6$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("goBIO", function(module, exports) {
"use strict";
var $befc26043885e3a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $fqq4V = parcelRequire("fqq4V");

var $iFJ4e = parcelRequire("iFJ4e");

var $bWQcA = parcelRequire("bWQcA");

var $6abDe = parcelRequire("6abDe");
const $befc26043885e3a5$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $befc26043885e3a5$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $befc26043885e3a5$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $befc26043885e3a5$var$DEFAULT_TTL_MS;
        $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $befc26043885e3a5$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $befc26043885e3a5$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$befc26043885e3a5$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $befc26043885e3a5$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $befc26043885e3a5$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $befc26043885e3a5$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $fqq4V._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $befc26043885e3a5$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $befc26043885e3a5$var$NetworkFallbackResolver;
function $befc26043885e3a5$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $befc26043885e3a5$var$_isDomainFailure;
function $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $iFJ4e._DJB2)(sdkKey)}`;
}
function $befc26043885e3a5$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $6abDe.Storage.removeItem(hashKey);
        return;
    }
    $6abDe.Storage.setItem(hashKey, JSON.stringify(info));
}
function $befc26043885e3a5$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $befc26043885e3a5$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $6abDe.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $bWQcA.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $befc26043885e3a5$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("fqq4V", function(module, exports) {
"use strict";
var $b3ad8355bad4e62d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $b3ad8355bad4e62d$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $b3ad8355bad4e62d$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $b3ad8355bad4e62d$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $b3ad8355bad4e62d$var$MAX_START_LOOKUP = 200;
function $b3ad8355bad4e62d$var$_fetchTxtRecords(networkFunc) {
    return $b3ad8355bad4e62d$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($b3ad8355bad4e62d$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $b3ad8355bad4e62d$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $b3ad8355bad4e62d$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $b3ad8355bad4e62d$var$_fetchTxtRecords;
function $b3ad8355bad4e62d$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $b3ad8355bad4e62d$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $b3ad8355bad4e62d$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("CFdSR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $074386bd88212bf7$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $074386bd88212bf7$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $074386bd88212bf7$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("i7IAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $dWN0S = parcelRequire("dWN0S");

var $cKhdt = parcelRequire("cKhdt");

var $bWQcA = parcelRequire("bWQcA");

var $6abDe = parcelRequire("6abDe");

var $4Pas4 = parcelRequire("4Pas4");
const $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $d31b7720065816c5$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $d31b7720065816c5$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($d31b7720065816c5$var$PROMISE_MAP[sdkKey] == null) $d31b7720065816c5$var$PROMISE_MAP[sdkKey] = $d31b7720065816c5$var$_loadSession(sdkKey);
        const session = $d31b7720065816c5$var$PROMISE_MAP[sdkKey];
        return $d31b7720065816c5$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $d31b7720065816c5$var$PROMISE_MAP[sdkKey] = $d31b7720065816c5$var$_overrideSessionId(override, sdkKey);
    }
};
function $d31b7720065816c5$var$_loadSession(sdkKey) {
    let data = $d31b7720065816c5$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $4Pas4.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $d31b7720065816c5$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $d31b7720065816c5$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($d31b7720065816c5$var$_isIdle(data) || $d31b7720065816c5$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $4Pas4.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $d31b7720065816c5$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $d31b7720065816c5$var$_createSessionTimeout(sdkKey, $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $d31b7720065816c5$var$_createSessionTimeout(sdkKey, $d31b7720065816c5$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $d31b7720065816c5$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $dWN0S._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $d31b7720065816c5$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $d31b7720065816c5$var$MAX_SESSION_IDLE_TIME;
}
function $d31b7720065816c5$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $d31b7720065816c5$var$MAX_SESSION_AGE;
}
function $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $cKhdt._getStorageKey)(sdkKey)}`;
}
function $d31b7720065816c5$var$_persistToStorage(session, sdkKey) {
    const storageKey = $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $6abDe._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $bWQcA.Log.warn('Failed to save SessionID');
    }
}
function $d31b7720065816c5$var$_loadFromStorage(sdkKey) {
    const storageKey = $d31b7720065816c5$var$_getSessionIDStorageKey(sdkKey);
    return (0, $6abDe._getObjectFromStorage)(storageKey);
}

});

parcelRegister("2hLV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("j5rLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lHEph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2EFwj", function(module, exports) {
"use strict";
var $1eef863bd57456de$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $dWN0S = parcelRequire("dWN0S");

var $dWN0S = parcelRequire("dWN0S");

var $chIEM = parcelRequire("chIEM");

var $jPmF4 = parcelRequire("jPmF4");

var $bWQcA = parcelRequire("bWQcA");

var $9ewyA = parcelRequire("9ewyA");

var $41u1G = parcelRequire("41u1G");

var $i7IAl = parcelRequire("i7IAl");

var $kISM6 = parcelRequire("kISM6");

var $2av9q = parcelRequire("2av9q");

var $6abDe = parcelRequire("6abDe");
const $1eef863bd57456de$var$MAX_MEMO_CACHE_SIZE = 3000;
class $1eef863bd57456de$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($bWQcA.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $6abDe.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $i7IAl.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $6abDe.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $kISM6.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $kISM6.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $jPmF4.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $chIEM.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $6abDe.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $1eef863bd57456de$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $6abDe.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $kISM6.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($2av9q.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $1eef863bd57456de$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $bWQcA.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $9ewyA.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $1eef863bd57456de$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $1eef863bd57456de$var$StatsigClientBase;
function $1eef863bd57456de$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $41u1G._isServerEnv)()) return;
    const statsigGlobal = (0, $dWN0S._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $bWQcA.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("egTIF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("ejscn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cJCL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $bWQcA = parcelRequire("bWQcA");

var $9nGbQ = parcelRequire("9nGbQ");
function $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $9457c0baaccffd65$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $9457c0baaccffd65$var$_makeFeatureGate;
function $9457c0baaccffd65$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $9457c0baaccffd65$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $9457c0baaccffd65$var$_makeDynamicConfig;
function $9457c0baaccffd65$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $9457c0baaccffd65$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $9457c0baaccffd65$var$_makeExperiment;
function $9457c0baaccffd65$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $9457c0baaccffd65$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $9457c0baaccffd65$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $9457c0baaccffd65$var$_makeLayer;
function $9457c0baaccffd65$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $9457c0baaccffd65$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $9457c0baaccffd65$var$_mergeOverride;
function $9457c0baaccffd65$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9nGbQ._isTypeMatch)(found, fallback)) {
            $bWQcA.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $9457c0baaccffd65$var$_makeTypedGet;

});

parcelRegister("jKP2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b7bEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $81796305d4513c6f$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $81796305d4513c6f$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("b9ZdZ", function(module, exports) {
"use strict";
var $820006e6093ad8b3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");

var $kY5TA = parcelRequire("kY5TA");

var $4m0mJ = parcelRequire("4m0mJ");

var $lsG6u = parcelRequire("lsG6u");

var $krRcT = parcelRequire("krRcT");
class $820006e6093ad8b3$var$StatsigClient extends $10Gqk.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $10Gqk._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $820006e6093ad8b3$var$StatsigClient) return instance;
        $10Gqk.Log.warn((0, $10Gqk._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $820006e6093ad8b3$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $10Gqk.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $4m0mJ.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $krRcT.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($10Gqk.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($10Gqk.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($10Gqk.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($10Gqk.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($10Gqk.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $kY5TA.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $10Gqk.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $10Gqk.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $10Gqk.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $10Gqk.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $10Gqk.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($10Gqk.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $10Gqk.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $10Gqk.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $10Gqk.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $10Gqk.StatsigSession.get(this._sdkKey),
            stableID: $10Gqk.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $820006e6093ad8b3$var$__awaiter(this, void 0, void 0, function*() {
            if (!$10Gqk.Storage.isReady()) yield $10Gqk.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $10Gqk.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $10Gqk._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $10Gqk.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $10Gqk._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $10Gqk._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $10Gqk._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $10Gqk._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $10Gqk._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $10Gqk._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $10Gqk._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $10Gqk._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $10Gqk._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $10Gqk._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $lsG6u._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $lsG6u._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $820006e6093ad8b3$var$StatsigClient;

});
parcelRegister("kY5TA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");
class $f43dfc011d243ec2$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $10Gqk._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $10Gqk._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $10Gqk.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $10Gqk._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $10Gqk.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $10Gqk._getFullUserHash)(user) !== (0, $10Gqk._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $f43dfc011d243ec2$var$EvaluationStore;

});

parcelRegister("4m0mJ", function(module, exports) {
"use strict";
var $32b98016f09d5f8a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10Gqk = parcelRequire("10Gqk");

var $aKDb8 = parcelRequire("aKDb8");
class $32b98016f09d5f8a$var$StatsigNetwork extends $10Gqk.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $10Gqk.UrlConfiguration($10Gqk.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        var _a, _b, _c, _d, _e, _f;
        return $32b98016f09d5f8a$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $10Gqk._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $32b98016f09d5f8a$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aKDb8._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $32b98016f09d5f8a$var$StatsigNetwork;

});
parcelRegister("aKDb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $10Gqk = parcelRequire("10Gqk");
const $7d3c97532ff78645$var$MAX_DELTAS_SORT_DEPTH = 2;
function $7d3c97532ff78645$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $10Gqk._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $7d3c97532ff78645$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $7d3c97532ff78645$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $10Gqk._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $7d3c97532ff78645$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $7d3c97532ff78645$var$_resolveDeltasResponse;
function $7d3c97532ff78645$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $7d3c97532ff78645$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $7d3c97532ff78645$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $7d3c97532ff78645$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("lsG6u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $10Gqk = parcelRequire("10Gqk");
const $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $f9fcdf6c868e549f$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $10Gqk._isTypeMatch)(value, fallback);
}
function $f9fcdf6c868e549f$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $f9fcdf6c868e549f$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $f9fcdf6c868e549f$var$_shouldLogExposure(options) ? undefined : $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $f9fcdf6c868e549f$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $f9fcdf6c868e549f$var$_shouldLogExposure(options) ? undefined : $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f9fcdf6c868e549f$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $f9fcdf6c868e549f$var$_shouldLogExposure(options) ? undefined : $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f9fcdf6c868e549f$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $f9fcdf6c868e549f$var$_shouldLogExposure(options) ? undefined : $f9fcdf6c868e549f$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($f9fcdf6c868e549f$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $f9fcdf6c868e549f$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $10Gqk._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $f9fcdf6c868e549f$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $f9fcdf6c868e549f$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $f9fcdf6c868e549f$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $f9fcdf6c868e549f$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $f9fcdf6c868e549f$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $f9fcdf6c868e549f$var$_makeParamStoreGetter;

});

parcelRegister("krRcT", function(module, exports) {
"use strict";
var $ee2f9a0c916ece5f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $10Gqk = parcelRequire("10Gqk");

var $4m0mJ = parcelRequire("4m0mJ");
class $ee2f9a0c916ece5f$var$StatsigEvaluationsDataAdapter extends $10Gqk.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $4m0mJ.default) this._network = network;
        else this._network = new $4m0mJ.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $10Gqk._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $10Gqk._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $10Gqk.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        var _a;
        return $ee2f9a0c916ece5f$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $10Gqk._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$10Gqk.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $10Gqk._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $ee2f9a0c916ece5f$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("7n9mn", function(module, exports) {

var $6cAn5 = parcelRequire("6cAn5");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $6cAn5.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("6BStr", function(module, exports) {

var $fDtbf = parcelRequire("fDtbf");

var $6pIol = parcelRequire("6pIol");
const $e8215c603be2a1e2$var$isDevelopment = false;
const { performance: $e8215c603be2a1e2$var$performance, document: $e8215c603be2a1e2$var$document } = window || {};
const $e8215c603be2a1e2$var$assetToShortName = (0, $6pIol.sanitiseAssetName)($e8215c603be2a1e2$var$isDevelopment);
// defensively check for the necessary APIs, in SSR these would be missing
// OSX El Capitan and earlier: `performance.mark` is not defined [even though `performance` is present]
// https://stackoverflow.com/a/32940166/12146527
if (window && $e8215c603be2a1e2$var$document && $e8215c603be2a1e2$var$performance && $e8215c603be2a1e2$var$performance.mark) /**
	 * We rely on being passed the short basename of the chunk file.
	 * It must not include path or hash but should include ".js" extension.
	 */ // @ts-expect-error - TS2740 - Type '(shortName: string) => void' is missing the following properties from type 'Window': clientInformation, closed, customElements, devicePixelRatio, and 267 more.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window[0, $fDtbf.JS_EVAL_API] = (shortName)=>{
    const prefix = shortName.replace(/\.js$/, '.');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const nodeList = $e8215c603be2a1e2$var$document.querySelectorAll(`script[src*="${prefix}"]`);
    const scripts = Array.from(nodeList).filter((node)=>$e8215c603be2a1e2$var$assetToShortName(node.getAttribute('src') ?? '') === shortName);
    if (scripts.length !== 1) {
        $e8215c603be2a1e2$var$performance.mark(`${shortName}${(0, $fDtbf.JS_EVAL_STOP)}`);
        return;
    }
    const script = scripts[0];
    const onLoaded = ()=>{
        script.removeEventListener('load', onLoaded);
        $e8215c603be2a1e2$var$performance.mark(`${shortName}${(0, $fDtbf.JS_EVAL_STOP)}`);
        if ($e8215c603be2a1e2$var$isDevelopment) try {
            // not all scripts are instrumented with eval mark so measure() may error
            $e8215c603be2a1e2$var$performance.measure(`_${shortName}`, `${shortName}${(0, $fDtbf.JS_EVAL_START)}`, `${shortName}${(0, $fDtbf.JS_EVAL_STOP)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        /* do nothing */ }
    };
    script.addEventListener('load', onLoaded);
};

});
parcelRegister("fDtbf", function(module, exports) {

$parcel$export(module.exports, "SPA_SSR_RENDERED_MARK", () => $b6212225cc553de6$export$db6a769879aea97b, (v) => $b6212225cc553de6$export$db6a769879aea97b = v);
$parcel$export(module.exports, "JS_EVAL_START", () => $b6212225cc553de6$export$4719e2a29dbcb33d, (v) => $b6212225cc553de6$export$4719e2a29dbcb33d = v);
$parcel$export(module.exports, "JS_EVAL_STOP", () => $b6212225cc553de6$export$7ee4e0433d720dea, (v) => $b6212225cc553de6$export$7ee4e0433d720dea = v);
$parcel$export(module.exports, "JS_EVAL_API", () => $b6212225cc553de6$export$d619b0b88beaed3d, (v) => $b6212225cc553de6$export$d619b0b88beaed3d = v);
/**
 *  IMPORTANT
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ var $b6212225cc553de6$export$db6a769879aea97b;
var $b6212225cc553de6$export$4719e2a29dbcb33d;
var $b6212225cc553de6$export$7ee4e0433d720dea;
var $b6212225cc553de6$export$d619b0b88beaed3d;
$b6212225cc553de6$export$db6a769879aea97b = 'ssr.spa.rendered';
/*::
export type JsEvalStart = ':eval-start';
 */ const $b6212225cc553de6$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
$b6212225cc553de6$export$4719e2a29dbcb33d = $b6212225cc553de6$var$JS_EVAL_START;
/*::
export type JsEvalStop = ':eval-stop';
 */ const $b6212225cc553de6$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
$b6212225cc553de6$export$7ee4e0433d720dea = $b6212225cc553de6$var$JS_EVAL_STOP;
/*::
export type JsEvalApi = '__jsEvalStop';
*/ const $b6212225cc553de6$var$JS_EVAL_API /*:: :JsEvalApi */  = '__jsEvalStop';
$b6212225cc553de6$export$d619b0b88beaed3d = $b6212225cc553de6$var$JS_EVAL_API;

});

parcelRegister("6pIol", function(module, exports) {
const $4ab78325b2f5b8b0$var$getBaseName = (assetPathOrURL /*:: :string */ )=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop();
/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ const $4ab78325b2f5b8b0$var$sanitiseAssetName = (isDevelopment /*:: :boolean */ )=>(assetPathOrURL /*:: :string */ )=>{
        const baseName = $4ab78325b2f5b8b0$var$getBaseName(assetPathOrURL);
        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        const split = baseName.split('.');
        if (split.length === 1) // Inline bundles are only an id
        return split[0];
        // Remove the has section from bundles (penultimate section separated by dots)
        // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
        // In the case of runtime bundles (e.g. bundle.runtime.hash.js) this will return 'bundle.runtime.js'.
        // This will cause only the first shared bundle loaded to be tracked.
        // In the short term this is desired to prevent too much noise.
        return [
            ...split.slice(0, -2),
            split[split.length - 1]
        ].join('.');
        return isDevelopment || split.length < 4 ? baseName : [
            ...split.slice(0, -3),
            ...split.slice(-1)
        ].join('.');
    };
module.exports = {
    sanitiseAssetName: $4ab78325b2f5b8b0$var$sanitiseAssetName
};

});


parcelRegister("lRSO6", function(module, exports) {
/* eslint-disable @typescript-eslint/no-require-imports */ // Import polyfills first as a safety-net for the remaining imports

parcelRequire("7nsd3");





parcelRequire("47bDC");
parcelRequire("7bpAK");
parcelRequire("6n3fk");






parcelRequire("1PVpv");


parcelRequire("5CIBP");


parcelRequire("6BStr");





















































































































// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1eb57f3b18060785$var$lazyImports = ()=>{
    (parcelRequire("e8KHW"));
    (parcelRequire("cYqgi"));
    (parcelRequire("lA9Ix"));
    (parcelRequire("1WTBp"));
    (parcelRequire("aCkmM"));
    (parcelRequire("bC2fB"));
    (parcelRequire("8Uumt"));
    (parcelRequire("e1AU2"));
    (parcelRequire("3f2cs"));
    (parcelRequire("eiowN"));
    (parcelRequire("lQipv"));
    // rx-js
    (parcelRequire("dOAU7"));
    (parcelRequire("kVLXA"));
    (parcelRequire("dZ0DN"));
    (parcelRequire("e4FEf"));
    (parcelRequire("cab1K"));
    (parcelRequire("aZdZn"));
    (parcelRequire("jFVZ1"));
    (parcelRequire("inj9P"));
    (parcelRequire("6hSeW"));
    (parcelRequire("9IWoG"));
    (parcelRequire("zjDln"));
    (parcelRequire("jG6Un"));
    (parcelRequire("9o0uh"));
    (parcelRequire("2JdQp"));
    (parcelRequire("93e44"));
    (parcelRequire("huL2s"));
    (parcelRequire("fp4O3"));
    (parcelRequire("3q49N"));
    (parcelRequire("8n054"));
    (parcelRequire("aSIuP"));
    (parcelRequire("d6iim"));
    (parcelRequire("4ma2a"));
    (parcelRequire("9UYXg"));
    (parcelRequire("76ueo"));
    (parcelRequire("c66Ur"));
    (parcelRequire("2HNfr"));
    (parcelRequire("fg0YM"));
    (parcelRequire("2agIZ"));
    (parcelRequire("eSGL3"));
    (parcelRequire("eV0gs"));
    (parcelRequire("kxK5F"));
    (parcelRequire("64ZAE"));
    (parcelRequire("bZiwb"));
    (parcelRequire("1oQta"));
    (parcelRequire("7Ts1V"));
    (parcelRequire("8vsXW"));
    (parcelRequire("4s3Ak"));
    (parcelRequire("hZWgu"));
    (parcelRequire("djxBj"));
    (parcelRequire("d0pqD"));
    (parcelRequire("ihPQR"));
    (parcelRequire("fjPtF"));
    (parcelRequire("3ldUM"));
    (parcelRequire("fPS7b"));
    (parcelRequire("bqQg9"));
    (parcelRequire("6l5HT"));
    (parcelRequire("kzFNe"));
    (parcelRequire("bO7qL"));
    (parcelRequire("d063O"));
    (parcelRequire("bZUGB"));
    (parcelRequire("4kRRr"));
    (parcelRequire("XSP0W"));
    (parcelRequire("iQCJJ"));
    (parcelRequire("6cbqE"));
    (parcelRequire("2R2to"));
    (parcelRequire("7mHDu"));
    (parcelRequire("3FmRD"));
    (parcelRequire("7qVV7"));
    (parcelRequire("djSMA"));
    (parcelRequire("3awJm"));
    (parcelRequire("g6kZl"));
    (parcelRequire("bdJi4"));
    (parcelRequire("aPq29"));
    (parcelRequire("5xp9B"));
    (parcelRequire("lgMzo"));
    (parcelRequire("dY7et"));
    (parcelRequire("7wZPc"));
    (parcelRequire("bK6mC"));
    (parcelRequire("hgDZf"));
    (parcelRequire("1EOTz"));
    (parcelRequire("fZcqr"));
    (parcelRequire("dhq2n"));
    (parcelRequire("7S1yD"));
    (parcelRequire("fmbNd"));
    (parcelRequire("dmXNS"));
    (parcelRequire("dAzMx"));
    (parcelRequire("h94Ey"));
    (parcelRequire("lriaX"));
    (parcelRequire("6R6Qn"));
    (parcelRequire("faGMz"));
    (parcelRequire("bXPjr"));
    (parcelRequire("lG8js"));
    (parcelRequire("llamJ"));
    (parcelRequire("aq199"));
    (parcelRequire("eTa7E"));
    (parcelRequire("icZql"));
    (parcelRequire("9RLLl"));
    (parcelRequire("kkXTB"));
    (parcelRequire("cuNVo"));
    (parcelRequire("ib0Rz"));
    (parcelRequire("4mCND"));
    (parcelRequire("k4nsZ"));
    (parcelRequire("fVAsD"));
    (parcelRequire("kO8p6"));
    (parcelRequire("eGi4b"));
    (parcelRequire("6UJhT"));
    (parcelRequire("cv9dl"));
    (parcelRequire("7UXWF"));
    (parcelRequire("ixMxd"));
    (parcelRequire("dqok3"));
    (parcelRequire("j7Dz8"));
    (parcelRequire("iQUbM"));
    (parcelRequire("g18Ye"));
    (parcelRequire("iTGyE"));
    (parcelRequire("iNqrn"));
    (parcelRequire("15UuB"));
};

});
parcelRegister("7nsd3", function(module, exports) {
'use strict';
function $55f090328863c73d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($55f090328863c73d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$55f090328863c73d$var$checkDCE();

module.exports = (parcelRequire("3Sq1R"));

});
parcelRegister("3Sq1R", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $2d2a9b09a68bd399$export$ae55be85d98224ed, (v) => $2d2a9b09a68bd399$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $2d2a9b09a68bd399$export$d39a5bbd09211389, (v) => $2d2a9b09a68bd399$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $2d2a9b09a68bd399$export$882461b6382ed46c, (v) => $2d2a9b09a68bd399$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $2d2a9b09a68bd399$export$466bfc07425424d5, (v) => $2d2a9b09a68bd399$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $2d2a9b09a68bd399$export$cd75ccfd720a3cd4, (v) => $2d2a9b09a68bd399$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $2d2a9b09a68bd399$export$fa8d919ba61d84db, (v) => $2d2a9b09a68bd399$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $2d2a9b09a68bd399$export$757ceba2d55c277e, (v) => $2d2a9b09a68bd399$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $2d2a9b09a68bd399$export$b3890eb0ae9dca99, (v) => $2d2a9b09a68bd399$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $2d2a9b09a68bd399$export$502457920280e6be, (v) => $2d2a9b09a68bd399$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $2d2a9b09a68bd399$export$c78a37762a8d58e1, (v) => $2d2a9b09a68bd399$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $2d2a9b09a68bd399$export$dc54d992c10e8a18, (v) => $2d2a9b09a68bd399$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $2d2a9b09a68bd399$export$83d89fbfd8236492, (v) => $2d2a9b09a68bd399$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2d2a9b09a68bd399$export$ae55be85d98224ed;
var $2d2a9b09a68bd399$export$d39a5bbd09211389;
var $2d2a9b09a68bd399$export$882461b6382ed46c;
var $2d2a9b09a68bd399$export$466bfc07425424d5;
var $2d2a9b09a68bd399$export$cd75ccfd720a3cd4;
var $2d2a9b09a68bd399$export$fa8d919ba61d84db;
var $2d2a9b09a68bd399$export$757ceba2d55c277e;
var $2d2a9b09a68bd399$export$b3890eb0ae9dca99;
var $2d2a9b09a68bd399$export$502457920280e6be;
var $2d2a9b09a68bd399$export$c78a37762a8d58e1;
var $2d2a9b09a68bd399$export$dc54d992c10e8a18;
var $2d2a9b09a68bd399$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $gg6CF = parcelRequire("gg6CF");
function $2d2a9b09a68bd399$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2d2a9b09a68bd399$var$da = new Set, $2d2a9b09a68bd399$var$ea = {};
function $2d2a9b09a68bd399$var$fa(a, b) {
    $2d2a9b09a68bd399$var$ha(a, b);
    $2d2a9b09a68bd399$var$ha(a + "Capture", b);
}
function $2d2a9b09a68bd399$var$ha(a, b) {
    $2d2a9b09a68bd399$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$2d2a9b09a68bd399$var$da.add(b[a]);
}
var $2d2a9b09a68bd399$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2d2a9b09a68bd399$var$ja = Object.prototype.hasOwnProperty, $2d2a9b09a68bd399$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $2d2a9b09a68bd399$var$la = {}, $2d2a9b09a68bd399$var$ma = {};
function $2d2a9b09a68bd399$var$na(a) {
    if ($2d2a9b09a68bd399$var$ja.call($2d2a9b09a68bd399$var$ma, a)) return !0;
    if ($2d2a9b09a68bd399$var$ja.call($2d2a9b09a68bd399$var$la, a)) return !1;
    if ($2d2a9b09a68bd399$var$ka.test(a)) return $2d2a9b09a68bd399$var$ma[a] = !0;
    $2d2a9b09a68bd399$var$la[a] = !0;
    return !1;
}
function $2d2a9b09a68bd399$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $2d2a9b09a68bd399$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $2d2a9b09a68bd399$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $2d2a9b09a68bd399$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $2d2a9b09a68bd399$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $2d2a9b09a68bd399$var$t[b] = new $2d2a9b09a68bd399$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $2d2a9b09a68bd399$var$ra = /[\-:]([a-z])/g;
function $2d2a9b09a68bd399$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($2d2a9b09a68bd399$var$ra, $2d2a9b09a68bd399$var$ta);
    $2d2a9b09a68bd399$var$t[b] = new $2d2a9b09a68bd399$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($2d2a9b09a68bd399$var$ra, $2d2a9b09a68bd399$var$ta);
    $2d2a9b09a68bd399$var$t[b] = new $2d2a9b09a68bd399$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($2d2a9b09a68bd399$var$ra, $2d2a9b09a68bd399$var$ta);
    $2d2a9b09a68bd399$var$t[b] = new $2d2a9b09a68bd399$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$2d2a9b09a68bd399$var$t.xlinkHref = new $2d2a9b09a68bd399$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $2d2a9b09a68bd399$var$t[a] = new $2d2a9b09a68bd399$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $2d2a9b09a68bd399$var$ua(a, b, c, d) {
    var e = $2d2a9b09a68bd399$var$t.hasOwnProperty(b) ? $2d2a9b09a68bd399$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $2d2a9b09a68bd399$var$pa(b, c, e, d) && (c = null), d || null === e ? $2d2a9b09a68bd399$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $2d2a9b09a68bd399$var$va = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $2d2a9b09a68bd399$var$wa = Symbol.for("react.element"), $2d2a9b09a68bd399$var$xa = Symbol.for("react.portal"), $2d2a9b09a68bd399$var$ya = Symbol.for("react.fragment"), $2d2a9b09a68bd399$var$za = Symbol.for("react.strict_mode"), $2d2a9b09a68bd399$var$Aa = Symbol.for("react.profiler"), $2d2a9b09a68bd399$var$Ba = Symbol.for("react.provider"), $2d2a9b09a68bd399$var$Ca = Symbol.for("react.context"), $2d2a9b09a68bd399$var$Da = Symbol.for("react.forward_ref"), $2d2a9b09a68bd399$var$Ea = Symbol.for("react.suspense"), $2d2a9b09a68bd399$var$Fa = Symbol.for("react.suspense_list"), $2d2a9b09a68bd399$var$Ga = Symbol.for("react.memo"), $2d2a9b09a68bd399$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $2d2a9b09a68bd399$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $2d2a9b09a68bd399$var$Ja = Symbol.iterator;
function $2d2a9b09a68bd399$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $2d2a9b09a68bd399$var$Ja && a[$2d2a9b09a68bd399$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $2d2a9b09a68bd399$var$u = Object.assign, $2d2a9b09a68bd399$var$La;
function $2d2a9b09a68bd399$var$Ma(a) {
    if (void 0 === $2d2a9b09a68bd399$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $2d2a9b09a68bd399$var$La = b && b[1] || "";
    }
    return "\n" + $2d2a9b09a68bd399$var$La + a;
}
var $2d2a9b09a68bd399$var$Na = !1;
function $2d2a9b09a68bd399$var$Oa(a, b) {
    if (!a || $2d2a9b09a68bd399$var$Na) return "";
    $2d2a9b09a68bd399$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $2d2a9b09a68bd399$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $2d2a9b09a68bd399$var$Ma(a) : "";
}
function $2d2a9b09a68bd399$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $2d2a9b09a68bd399$var$Ma(a.type);
        case 16:
            return $2d2a9b09a68bd399$var$Ma("Lazy");
        case 13:
            return $2d2a9b09a68bd399$var$Ma("Suspense");
        case 19:
            return $2d2a9b09a68bd399$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $2d2a9b09a68bd399$var$Oa(a.type, !1), a;
        case 11:
            return a = $2d2a9b09a68bd399$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $2d2a9b09a68bd399$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $2d2a9b09a68bd399$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $2d2a9b09a68bd399$var$ya:
            return "Fragment";
        case $2d2a9b09a68bd399$var$xa:
            return "Portal";
        case $2d2a9b09a68bd399$var$Aa:
            return "Profiler";
        case $2d2a9b09a68bd399$var$za:
            return "StrictMode";
        case $2d2a9b09a68bd399$var$Ea:
            return "Suspense";
        case $2d2a9b09a68bd399$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $2d2a9b09a68bd399$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $2d2a9b09a68bd399$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $2d2a9b09a68bd399$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $2d2a9b09a68bd399$var$Ga:
            return b = a.displayName || null, null !== b ? b : $2d2a9b09a68bd399$var$Qa(a.type) || "Memo";
        case $2d2a9b09a68bd399$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $2d2a9b09a68bd399$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $2d2a9b09a68bd399$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $2d2a9b09a68bd399$var$Qa(b);
        case 8:
            return b === $2d2a9b09a68bd399$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $2d2a9b09a68bd399$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $2d2a9b09a68bd399$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $2d2a9b09a68bd399$var$Ua(a) {
    var b = $2d2a9b09a68bd399$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $2d2a9b09a68bd399$var$Va(a) {
    a._valueTracker || (a._valueTracker = $2d2a9b09a68bd399$var$Ua(a));
}
function $2d2a9b09a68bd399$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $2d2a9b09a68bd399$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $2d2a9b09a68bd399$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $2d2a9b09a68bd399$var$Ya(a, b) {
    var c = b.checked;
    return $2d2a9b09a68bd399$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $2d2a9b09a68bd399$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $2d2a9b09a68bd399$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $2d2a9b09a68bd399$var$$a(a, b) {
    b = b.checked;
    null != b && $2d2a9b09a68bd399$var$ua(a, "checked", b, !1);
}
function $2d2a9b09a68bd399$var$ab(a, b) {
    $2d2a9b09a68bd399$var$$a(a, b);
    var c = $2d2a9b09a68bd399$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $2d2a9b09a68bd399$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $2d2a9b09a68bd399$var$bb(a, b.type, $2d2a9b09a68bd399$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $2d2a9b09a68bd399$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $2d2a9b09a68bd399$var$bb(a, b, c) {
    if ("number" !== b || $2d2a9b09a68bd399$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $2d2a9b09a68bd399$var$db = Array.isArray;
function $2d2a9b09a68bd399$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $2d2a9b09a68bd399$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $2d2a9b09a68bd399$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($2d2a9b09a68bd399$var$p(91));
    return $2d2a9b09a68bd399$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $2d2a9b09a68bd399$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($2d2a9b09a68bd399$var$p(92));
            if ($2d2a9b09a68bd399$var$db(c)) {
                if (1 < c.length) throw Error($2d2a9b09a68bd399$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $2d2a9b09a68bd399$var$Sa(c)
    };
}
function $2d2a9b09a68bd399$var$hb(a, b) {
    var c = $2d2a9b09a68bd399$var$Sa(b.value), d = $2d2a9b09a68bd399$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $2d2a9b09a68bd399$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $2d2a9b09a68bd399$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $2d2a9b09a68bd399$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $2d2a9b09a68bd399$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $2d2a9b09a68bd399$var$lb, $2d2a9b09a68bd399$var$mb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $2d2a9b09a68bd399$var$lb = $2d2a9b09a68bd399$var$lb || document.createElement("div");
        $2d2a9b09a68bd399$var$lb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $2d2a9b09a68bd399$var$lb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $2d2a9b09a68bd399$var$nb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $2d2a9b09a68bd399$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $2d2a9b09a68bd399$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($2d2a9b09a68bd399$var$pb).forEach(function(a) {
    $2d2a9b09a68bd399$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $2d2a9b09a68bd399$var$pb[b] = $2d2a9b09a68bd399$var$pb[a];
    });
});
function $2d2a9b09a68bd399$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $2d2a9b09a68bd399$var$pb.hasOwnProperty(a) && $2d2a9b09a68bd399$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $2d2a9b09a68bd399$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $2d2a9b09a68bd399$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $2d2a9b09a68bd399$var$tb = $2d2a9b09a68bd399$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $2d2a9b09a68bd399$var$ub(a, b) {
    if (b) {
        if ($2d2a9b09a68bd399$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($2d2a9b09a68bd399$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($2d2a9b09a68bd399$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($2d2a9b09a68bd399$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($2d2a9b09a68bd399$var$p(62));
    }
}
function $2d2a9b09a68bd399$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2d2a9b09a68bd399$var$wb = null;
function $2d2a9b09a68bd399$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $2d2a9b09a68bd399$var$yb = null, $2d2a9b09a68bd399$var$zb = null, $2d2a9b09a68bd399$var$Ab = null;
function $2d2a9b09a68bd399$var$Bb(a) {
    if (a = $2d2a9b09a68bd399$var$Cb(a)) {
        if ("function" !== typeof $2d2a9b09a68bd399$var$yb) throw Error($2d2a9b09a68bd399$var$p(280));
        var b = a.stateNode;
        b && (b = $2d2a9b09a68bd399$var$Db(b), $2d2a9b09a68bd399$var$yb(a.stateNode, a.type, b));
    }
}
function $2d2a9b09a68bd399$var$Eb(a) {
    $2d2a9b09a68bd399$var$zb ? $2d2a9b09a68bd399$var$Ab ? $2d2a9b09a68bd399$var$Ab.push(a) : $2d2a9b09a68bd399$var$Ab = [
        a
    ] : $2d2a9b09a68bd399$var$zb = a;
}
function $2d2a9b09a68bd399$var$Fb() {
    if ($2d2a9b09a68bd399$var$zb) {
        var a = $2d2a9b09a68bd399$var$zb, b = $2d2a9b09a68bd399$var$Ab;
        $2d2a9b09a68bd399$var$Ab = $2d2a9b09a68bd399$var$zb = null;
        $2d2a9b09a68bd399$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$2d2a9b09a68bd399$var$Bb(b[a]);
    }
}
function $2d2a9b09a68bd399$var$Gb(a, b) {
    return a(b);
}
function $2d2a9b09a68bd399$var$Hb() {}
var $2d2a9b09a68bd399$var$Ib = !1;
function $2d2a9b09a68bd399$var$Jb(a, b, c) {
    if ($2d2a9b09a68bd399$var$Ib) return a(b, c);
    $2d2a9b09a68bd399$var$Ib = !0;
    try {
        return $2d2a9b09a68bd399$var$Gb(a, b, c);
    } finally{
        if ($2d2a9b09a68bd399$var$Ib = !1, null !== $2d2a9b09a68bd399$var$zb || null !== $2d2a9b09a68bd399$var$Ab) $2d2a9b09a68bd399$var$Hb(), $2d2a9b09a68bd399$var$Fb();
    }
}
function $2d2a9b09a68bd399$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $2d2a9b09a68bd399$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($2d2a9b09a68bd399$var$p(231, b, typeof c));
    return c;
}
var $2d2a9b09a68bd399$var$Lb = !1;
if ($2d2a9b09a68bd399$var$ia) try {
    var $2d2a9b09a68bd399$var$Mb = {};
    Object.defineProperty($2d2a9b09a68bd399$var$Mb, "passive", {
        get: function() {
            $2d2a9b09a68bd399$var$Lb = !0;
        }
    });
    window.addEventListener("test", $2d2a9b09a68bd399$var$Mb, $2d2a9b09a68bd399$var$Mb);
    window.removeEventListener("test", $2d2a9b09a68bd399$var$Mb, $2d2a9b09a68bd399$var$Mb);
} catch (a) {
    $2d2a9b09a68bd399$var$Lb = !1;
}
function $2d2a9b09a68bd399$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $2d2a9b09a68bd399$var$Ob = !1, $2d2a9b09a68bd399$var$Pb = null, $2d2a9b09a68bd399$var$Qb = !1, $2d2a9b09a68bd399$var$Rb = null, $2d2a9b09a68bd399$var$Sb = {
    onError: function(a) {
        $2d2a9b09a68bd399$var$Ob = !0;
        $2d2a9b09a68bd399$var$Pb = a;
    }
};
function $2d2a9b09a68bd399$var$Tb(a, b, c, d, e, f, g, h, k) {
    $2d2a9b09a68bd399$var$Ob = !1;
    $2d2a9b09a68bd399$var$Pb = null;
    $2d2a9b09a68bd399$var$Nb.apply($2d2a9b09a68bd399$var$Sb, arguments);
}
function $2d2a9b09a68bd399$var$Ub(a, b, c, d, e, f, g, h, k) {
    $2d2a9b09a68bd399$var$Tb.apply(this, arguments);
    if ($2d2a9b09a68bd399$var$Ob) {
        if ($2d2a9b09a68bd399$var$Ob) {
            var l = $2d2a9b09a68bd399$var$Pb;
            $2d2a9b09a68bd399$var$Ob = !1;
            $2d2a9b09a68bd399$var$Pb = null;
        } else throw Error($2d2a9b09a68bd399$var$p(198));
        $2d2a9b09a68bd399$var$Qb || ($2d2a9b09a68bd399$var$Qb = !0, $2d2a9b09a68bd399$var$Rb = l);
    }
}
function $2d2a9b09a68bd399$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $2d2a9b09a68bd399$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $2d2a9b09a68bd399$var$Xb(a) {
    if ($2d2a9b09a68bd399$var$Vb(a) !== a) throw Error($2d2a9b09a68bd399$var$p(188));
}
function $2d2a9b09a68bd399$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $2d2a9b09a68bd399$var$Vb(a);
        if (null === b) throw Error($2d2a9b09a68bd399$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $2d2a9b09a68bd399$var$Xb(e), a;
                if (f === d) return $2d2a9b09a68bd399$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($2d2a9b09a68bd399$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($2d2a9b09a68bd399$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($2d2a9b09a68bd399$var$p(190));
    }
    if (3 !== c.tag) throw Error($2d2a9b09a68bd399$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $2d2a9b09a68bd399$var$Zb(a) {
    a = $2d2a9b09a68bd399$var$Yb(a);
    return null !== a ? $2d2a9b09a68bd399$var$$b(a) : null;
}
function $2d2a9b09a68bd399$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $2d2a9b09a68bd399$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $2d2a9b09a68bd399$var$ac = $gg6CF.unstable_scheduleCallback, $2d2a9b09a68bd399$var$bc = $gg6CF.unstable_cancelCallback, $2d2a9b09a68bd399$var$cc = $gg6CF.unstable_shouldYield, $2d2a9b09a68bd399$var$dc = $gg6CF.unstable_requestPaint, $2d2a9b09a68bd399$var$A = $gg6CF.unstable_now, $2d2a9b09a68bd399$var$ec = $gg6CF.unstable_getCurrentPriorityLevel, $2d2a9b09a68bd399$var$fc = $gg6CF.unstable_ImmediatePriority, $2d2a9b09a68bd399$var$gc = $gg6CF.unstable_UserBlockingPriority, $2d2a9b09a68bd399$var$hc = $gg6CF.unstable_NormalPriority, $2d2a9b09a68bd399$var$ic = $gg6CF.unstable_LowPriority, $2d2a9b09a68bd399$var$jc = $gg6CF.unstable_IdlePriority, $2d2a9b09a68bd399$var$kc = null, $2d2a9b09a68bd399$var$lc = null, $2d2a9b09a68bd399$var$B = null, $2d2a9b09a68bd399$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $2d2a9b09a68bd399$var$nc(a, b) {
    if ($2d2a9b09a68bd399$var$lc && "function" === typeof $2d2a9b09a68bd399$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $2d2a9b09a68bd399$var$fc;
                break;
            case 4:
                d = $2d2a9b09a68bd399$var$gc;
                break;
            case 16:
                d = $2d2a9b09a68bd399$var$hc;
                break;
            case 536870912:
                d = $2d2a9b09a68bd399$var$jc;
                break;
            default:
                d = $2d2a9b09a68bd399$var$hc;
        }
        $2d2a9b09a68bd399$var$lc.onCommitFiberRoot($2d2a9b09a68bd399$var$kc, a, d, c);
    } catch (e) {}
}
function $2d2a9b09a68bd399$var$oc(a) {
    $2d2a9b09a68bd399$var$B = a;
}
function $2d2a9b09a68bd399$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $2d2a9b09a68bd399$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $2d2a9b09a68bd399$var$rc() {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markCommitStopped && $2d2a9b09a68bd399$var$B.markCommitStopped();
}
function $2d2a9b09a68bd399$var$sc(a) {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentRenderStarted && $2d2a9b09a68bd399$var$B.markComponentRenderStarted(a);
}
function $2d2a9b09a68bd399$var$tc() {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentRenderStopped && $2d2a9b09a68bd399$var$B.markComponentRenderStopped();
}
function $2d2a9b09a68bd399$var$uc(a) {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentLayoutEffectUnmountStarted && $2d2a9b09a68bd399$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $2d2a9b09a68bd399$var$vc() {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentLayoutEffectUnmountStopped && $2d2a9b09a68bd399$var$B.markComponentLayoutEffectUnmountStopped();
}
function $2d2a9b09a68bd399$var$wc(a) {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markRenderStarted && $2d2a9b09a68bd399$var$B.markRenderStarted(a);
}
function $2d2a9b09a68bd399$var$xc() {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markRenderStopped && $2d2a9b09a68bd399$var$B.markRenderStopped();
}
function $2d2a9b09a68bd399$var$yc(a, b) {
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markStateUpdateScheduled && $2d2a9b09a68bd399$var$B.markStateUpdateScheduled(a, b);
}
var $2d2a9b09a68bd399$var$Ac = Math.clz32 ? Math.clz32 : $2d2a9b09a68bd399$var$zc, $2d2a9b09a68bd399$var$Bc = Math.log, $2d2a9b09a68bd399$var$Cc = Math.LN2;
function $2d2a9b09a68bd399$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($2d2a9b09a68bd399$var$Bc(a) / $2d2a9b09a68bd399$var$Cc | 0) | 0;
}
function $2d2a9b09a68bd399$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $2d2a9b09a68bd399$var$Dc = 64, $2d2a9b09a68bd399$var$Ec = 4194304;
function $2d2a9b09a68bd399$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $2d2a9b09a68bd399$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $2d2a9b09a68bd399$var$Fc(h) : (f &= g, 0 !== f && (d = $2d2a9b09a68bd399$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $2d2a9b09a68bd399$var$Fc(g) : 0 !== f && (d = $2d2a9b09a68bd399$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $2d2a9b09a68bd399$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $2d2a9b09a68bd399$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2d2a9b09a68bd399$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $2d2a9b09a68bd399$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $2d2a9b09a68bd399$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $2d2a9b09a68bd399$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $2d2a9b09a68bd399$var$Kc() {
    var a = $2d2a9b09a68bd399$var$Dc;
    $2d2a9b09a68bd399$var$Dc <<= 1;
    0 === ($2d2a9b09a68bd399$var$Dc & 4194240) && ($2d2a9b09a68bd399$var$Dc = 64);
    return a;
}
function $2d2a9b09a68bd399$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $2d2a9b09a68bd399$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $2d2a9b09a68bd399$var$Ac(b);
    a[b] = c;
}
function $2d2a9b09a68bd399$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $2d2a9b09a68bd399$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $2d2a9b09a68bd399$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $2d2a9b09a68bd399$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $2d2a9b09a68bd399$var$Pc(a, b, c) {
    if ($2d2a9b09a68bd399$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $2d2a9b09a68bd399$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $2d2a9b09a68bd399$var$Qc(a, b) {
    if ($2d2a9b09a68bd399$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $2d2a9b09a68bd399$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $2d2a9b09a68bd399$var$E = 0;
function $2d2a9b09a68bd399$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $2d2a9b09a68bd399$var$Sc, $2d2a9b09a68bd399$var$Tc, $2d2a9b09a68bd399$var$Uc, $2d2a9b09a68bd399$var$Vc, $2d2a9b09a68bd399$var$Wc, $2d2a9b09a68bd399$var$Xc = !1, $2d2a9b09a68bd399$var$Yc = [], $2d2a9b09a68bd399$var$Zc = null, $2d2a9b09a68bd399$var$$c = null, $2d2a9b09a68bd399$var$ad = null, $2d2a9b09a68bd399$var$bd = new Map, $2d2a9b09a68bd399$var$cd = new Map, $2d2a9b09a68bd399$var$dd = [], $2d2a9b09a68bd399$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $2d2a9b09a68bd399$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $2d2a9b09a68bd399$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $2d2a9b09a68bd399$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $2d2a9b09a68bd399$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $2d2a9b09a68bd399$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2d2a9b09a68bd399$var$cd.delete(b.pointerId);
    }
}
function $2d2a9b09a68bd399$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $2d2a9b09a68bd399$var$Cb(b), null !== b && $2d2a9b09a68bd399$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $2d2a9b09a68bd399$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $2d2a9b09a68bd399$var$Zc = $2d2a9b09a68bd399$var$gd($2d2a9b09a68bd399$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $2d2a9b09a68bd399$var$$c = $2d2a9b09a68bd399$var$gd($2d2a9b09a68bd399$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $2d2a9b09a68bd399$var$ad = $2d2a9b09a68bd399$var$gd($2d2a9b09a68bd399$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $2d2a9b09a68bd399$var$bd.set(f, $2d2a9b09a68bd399$var$gd($2d2a9b09a68bd399$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $2d2a9b09a68bd399$var$cd.set(f, $2d2a9b09a68bd399$var$gd($2d2a9b09a68bd399$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $2d2a9b09a68bd399$var$id(a) {
    var b = $2d2a9b09a68bd399$var$jd(a.target);
    if (null !== b) {
        var c = $2d2a9b09a68bd399$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $2d2a9b09a68bd399$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $2d2a9b09a68bd399$var$Wc(a.priority, function() {
                        $2d2a9b09a68bd399$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $2d2a9b09a68bd399$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $2d2a9b09a68bd399$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $2d2a9b09a68bd399$var$wb = d;
            c.target.dispatchEvent(d);
            $2d2a9b09a68bd399$var$wb = null;
        } else return b = $2d2a9b09a68bd399$var$Cb(c), null !== b && $2d2a9b09a68bd399$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $2d2a9b09a68bd399$var$md(a, b, c) {
    $2d2a9b09a68bd399$var$kd(a) && c.delete(b);
}
function $2d2a9b09a68bd399$var$nd() {
    $2d2a9b09a68bd399$var$Xc = !1;
    null !== $2d2a9b09a68bd399$var$Zc && $2d2a9b09a68bd399$var$kd($2d2a9b09a68bd399$var$Zc) && ($2d2a9b09a68bd399$var$Zc = null);
    null !== $2d2a9b09a68bd399$var$$c && $2d2a9b09a68bd399$var$kd($2d2a9b09a68bd399$var$$c) && ($2d2a9b09a68bd399$var$$c = null);
    null !== $2d2a9b09a68bd399$var$ad && $2d2a9b09a68bd399$var$kd($2d2a9b09a68bd399$var$ad) && ($2d2a9b09a68bd399$var$ad = null);
    $2d2a9b09a68bd399$var$bd.forEach($2d2a9b09a68bd399$var$md);
    $2d2a9b09a68bd399$var$cd.forEach($2d2a9b09a68bd399$var$md);
}
function $2d2a9b09a68bd399$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $2d2a9b09a68bd399$var$Xc || ($2d2a9b09a68bd399$var$Xc = !0, $gg6CF.unstable_scheduleCallback($gg6CF.unstable_NormalPriority, $2d2a9b09a68bd399$var$nd)));
}
function $2d2a9b09a68bd399$var$pd(a) {
    function b(b) {
        return $2d2a9b09a68bd399$var$od(b, a);
    }
    if (0 < $2d2a9b09a68bd399$var$Yc.length) {
        $2d2a9b09a68bd399$var$od($2d2a9b09a68bd399$var$Yc[0], a);
        for(var c = 1; c < $2d2a9b09a68bd399$var$Yc.length; c++){
            var d = $2d2a9b09a68bd399$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $2d2a9b09a68bd399$var$Zc && $2d2a9b09a68bd399$var$od($2d2a9b09a68bd399$var$Zc, a);
    null !== $2d2a9b09a68bd399$var$$c && $2d2a9b09a68bd399$var$od($2d2a9b09a68bd399$var$$c, a);
    null !== $2d2a9b09a68bd399$var$ad && $2d2a9b09a68bd399$var$od($2d2a9b09a68bd399$var$ad, a);
    $2d2a9b09a68bd399$var$bd.forEach(b);
    $2d2a9b09a68bd399$var$cd.forEach(b);
    for(c = 0; c < $2d2a9b09a68bd399$var$dd.length; c++)d = $2d2a9b09a68bd399$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $2d2a9b09a68bd399$var$dd.length && (c = $2d2a9b09a68bd399$var$dd[0], null === c.blockedOn);)$2d2a9b09a68bd399$var$id(c), null === c.blockedOn && $2d2a9b09a68bd399$var$dd.shift();
}
var $2d2a9b09a68bd399$var$qd = $2d2a9b09a68bd399$var$va.ReactCurrentBatchConfig, $2d2a9b09a68bd399$var$rd = !0;
function $2d2a9b09a68bd399$var$sd(a, b, c, d) {
    var e = $2d2a9b09a68bd399$var$E, f = $2d2a9b09a68bd399$var$qd.transition;
    $2d2a9b09a68bd399$var$qd.transition = null;
    try {
        $2d2a9b09a68bd399$var$E = 1, $2d2a9b09a68bd399$var$td(a, b, c, d);
    } finally{
        $2d2a9b09a68bd399$var$E = e, $2d2a9b09a68bd399$var$qd.transition = f;
    }
}
function $2d2a9b09a68bd399$var$ud(a, b, c, d) {
    var e = $2d2a9b09a68bd399$var$E, f = $2d2a9b09a68bd399$var$qd.transition;
    $2d2a9b09a68bd399$var$qd.transition = null;
    try {
        $2d2a9b09a68bd399$var$E = 4, $2d2a9b09a68bd399$var$td(a, b, c, d);
    } finally{
        $2d2a9b09a68bd399$var$E = e, $2d2a9b09a68bd399$var$qd.transition = f;
    }
}
function $2d2a9b09a68bd399$var$td(a, b, c, d) {
    if ($2d2a9b09a68bd399$var$rd) {
        var e = $2d2a9b09a68bd399$var$ld(a, b, c, d);
        if (null === e) $2d2a9b09a68bd399$var$vd(a, b, d, $2d2a9b09a68bd399$var$wd, c), $2d2a9b09a68bd399$var$fd(a, d);
        else if ($2d2a9b09a68bd399$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($2d2a9b09a68bd399$var$fd(a, d), b & 4 && -1 < $2d2a9b09a68bd399$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $2d2a9b09a68bd399$var$Cb(e);
                null !== f && $2d2a9b09a68bd399$var$Sc(f);
                f = $2d2a9b09a68bd399$var$ld(a, b, c, d);
                null === f && $2d2a9b09a68bd399$var$vd(a, b, d, $2d2a9b09a68bd399$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $2d2a9b09a68bd399$var$vd(a, b, d, null, c);
    }
}
var $2d2a9b09a68bd399$var$wd = null;
function $2d2a9b09a68bd399$var$ld(a, b, c, d) {
    $2d2a9b09a68bd399$var$wd = null;
    a = $2d2a9b09a68bd399$var$xb(d);
    a = $2d2a9b09a68bd399$var$jd(a);
    if (null !== a) {
        if (b = $2d2a9b09a68bd399$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $2d2a9b09a68bd399$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $2d2a9b09a68bd399$var$wd = a;
    return null;
}
function $2d2a9b09a68bd399$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($2d2a9b09a68bd399$var$ec()){
                case $2d2a9b09a68bd399$var$fc:
                    return 1;
                case $2d2a9b09a68bd399$var$gc:
                    return 4;
                case $2d2a9b09a68bd399$var$hc:
                case $2d2a9b09a68bd399$var$ic:
                    return 16;
                case $2d2a9b09a68bd399$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $2d2a9b09a68bd399$var$yd = null, $2d2a9b09a68bd399$var$zd = null, $2d2a9b09a68bd399$var$Ad = null;
function $2d2a9b09a68bd399$var$Bd() {
    if ($2d2a9b09a68bd399$var$Ad) return $2d2a9b09a68bd399$var$Ad;
    var a, b = $2d2a9b09a68bd399$var$zd, c = b.length, d, e = "value" in $2d2a9b09a68bd399$var$yd ? $2d2a9b09a68bd399$var$yd.value : $2d2a9b09a68bd399$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $2d2a9b09a68bd399$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $2d2a9b09a68bd399$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $2d2a9b09a68bd399$var$Dd() {
    return !0;
}
function $2d2a9b09a68bd399$var$Ed() {
    return !1;
}
function $2d2a9b09a68bd399$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $2d2a9b09a68bd399$var$Dd : $2d2a9b09a68bd399$var$Ed;
        this.isPropagationStopped = $2d2a9b09a68bd399$var$Ed;
        return this;
    }
    $2d2a9b09a68bd399$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $2d2a9b09a68bd399$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $2d2a9b09a68bd399$var$Dd);
        },
        persist: function() {},
        isPersistent: $2d2a9b09a68bd399$var$Dd
    });
    return b;
}
var $2d2a9b09a68bd399$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2d2a9b09a68bd399$var$Hd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Gd), $2d2a9b09a68bd399$var$Id = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Gd, {
    view: 0,
    detail: 0
}), $2d2a9b09a68bd399$var$Jd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Id), $2d2a9b09a68bd399$var$Kd, $2d2a9b09a68bd399$var$Ld, $2d2a9b09a68bd399$var$Md, $2d2a9b09a68bd399$var$Od = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2d2a9b09a68bd399$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $2d2a9b09a68bd399$var$Md && ($2d2a9b09a68bd399$var$Md && "mousemove" === a.type ? ($2d2a9b09a68bd399$var$Kd = a.screenX - $2d2a9b09a68bd399$var$Md.screenX, $2d2a9b09a68bd399$var$Ld = a.screenY - $2d2a9b09a68bd399$var$Md.screenY) : $2d2a9b09a68bd399$var$Ld = $2d2a9b09a68bd399$var$Kd = 0, $2d2a9b09a68bd399$var$Md = a);
        return $2d2a9b09a68bd399$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $2d2a9b09a68bd399$var$Ld;
    }
}), $2d2a9b09a68bd399$var$Pd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Od), $2d2a9b09a68bd399$var$Qd = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Od, {
    dataTransfer: 0
}), $2d2a9b09a68bd399$var$Rd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Qd), $2d2a9b09a68bd399$var$Sd = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Id, {
    relatedTarget: 0
}), $2d2a9b09a68bd399$var$Td = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Sd), $2d2a9b09a68bd399$var$Ud = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2d2a9b09a68bd399$var$Vd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Ud), $2d2a9b09a68bd399$var$Wd = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $2d2a9b09a68bd399$var$Xd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Wd), $2d2a9b09a68bd399$var$Yd = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Gd, {
    data: 0
}), $2d2a9b09a68bd399$var$Zd = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$Yd), $2d2a9b09a68bd399$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2d2a9b09a68bd399$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2d2a9b09a68bd399$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2d2a9b09a68bd399$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $2d2a9b09a68bd399$var$be[a]) ? !!b[a] : !1;
}
function $2d2a9b09a68bd399$var$Nd() {
    return $2d2a9b09a68bd399$var$ce;
}
var $2d2a9b09a68bd399$var$de = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $2d2a9b09a68bd399$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $2d2a9b09a68bd399$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $2d2a9b09a68bd399$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2d2a9b09a68bd399$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $2d2a9b09a68bd399$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $2d2a9b09a68bd399$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $2d2a9b09a68bd399$var$ee = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$de), $2d2a9b09a68bd399$var$fe = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2d2a9b09a68bd399$var$ge = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$fe), $2d2a9b09a68bd399$var$he = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2d2a9b09a68bd399$var$Nd
}), $2d2a9b09a68bd399$var$ie = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$he), $2d2a9b09a68bd399$var$je = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2d2a9b09a68bd399$var$ke = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$je), $2d2a9b09a68bd399$var$le = $2d2a9b09a68bd399$var$u({}, $2d2a9b09a68bd399$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2d2a9b09a68bd399$var$me = $2d2a9b09a68bd399$var$Fd($2d2a9b09a68bd399$var$le), $2d2a9b09a68bd399$var$ne = [
    9,
    13,
    27,
    32
], $2d2a9b09a68bd399$var$oe = $2d2a9b09a68bd399$var$ia && "CompositionEvent" in window, $2d2a9b09a68bd399$var$pe = null;
$2d2a9b09a68bd399$var$ia && "documentMode" in document && ($2d2a9b09a68bd399$var$pe = document.documentMode);
var $2d2a9b09a68bd399$var$qe = $2d2a9b09a68bd399$var$ia && "TextEvent" in window && !$2d2a9b09a68bd399$var$pe, $2d2a9b09a68bd399$var$re = $2d2a9b09a68bd399$var$ia && (!$2d2a9b09a68bd399$var$oe || $2d2a9b09a68bd399$var$pe && 8 < $2d2a9b09a68bd399$var$pe && 11 >= $2d2a9b09a68bd399$var$pe), $2d2a9b09a68bd399$var$se = String.fromCharCode(32), $2d2a9b09a68bd399$var$te = !1;
function $2d2a9b09a68bd399$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $2d2a9b09a68bd399$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2d2a9b09a68bd399$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $2d2a9b09a68bd399$var$we = !1;
function $2d2a9b09a68bd399$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $2d2a9b09a68bd399$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $2d2a9b09a68bd399$var$te = !0;
            return $2d2a9b09a68bd399$var$se;
        case "textInput":
            return a = b.data, a === $2d2a9b09a68bd399$var$se && $2d2a9b09a68bd399$var$te ? null : a;
        default:
            return null;
    }
}
function $2d2a9b09a68bd399$var$ye(a, b) {
    if ($2d2a9b09a68bd399$var$we) return "compositionend" === a || !$2d2a9b09a68bd399$var$oe && $2d2a9b09a68bd399$var$ue(a, b) ? (a = $2d2a9b09a68bd399$var$Bd(), $2d2a9b09a68bd399$var$Ad = $2d2a9b09a68bd399$var$zd = $2d2a9b09a68bd399$var$yd = null, $2d2a9b09a68bd399$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $2d2a9b09a68bd399$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $2d2a9b09a68bd399$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2d2a9b09a68bd399$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$2d2a9b09a68bd399$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $2d2a9b09a68bd399$var$Be(a, b, c, d) {
    $2d2a9b09a68bd399$var$Eb(d);
    b = $2d2a9b09a68bd399$var$Ce(b, "onChange");
    0 < b.length && (c = new $2d2a9b09a68bd399$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $2d2a9b09a68bd399$var$De = null, $2d2a9b09a68bd399$var$Ee = null;
function $2d2a9b09a68bd399$var$Fe(a) {
    $2d2a9b09a68bd399$var$Ge(a, 0);
}
function $2d2a9b09a68bd399$var$He(a) {
    var b = $2d2a9b09a68bd399$var$Ie(a);
    if ($2d2a9b09a68bd399$var$Wa(b)) return a;
}
function $2d2a9b09a68bd399$var$Je(a, b) {
    if ("change" === a) return b;
}
var $2d2a9b09a68bd399$var$Ke = !1;
if ($2d2a9b09a68bd399$var$ia) {
    var $2d2a9b09a68bd399$var$Le;
    if ($2d2a9b09a68bd399$var$ia) {
        var $2d2a9b09a68bd399$var$Me = "oninput" in document;
        if (!$2d2a9b09a68bd399$var$Me) {
            var $2d2a9b09a68bd399$var$Ne = document.createElement("div");
            $2d2a9b09a68bd399$var$Ne.setAttribute("oninput", "return;");
            $2d2a9b09a68bd399$var$Me = "function" === typeof $2d2a9b09a68bd399$var$Ne.oninput;
        }
        $2d2a9b09a68bd399$var$Le = $2d2a9b09a68bd399$var$Me;
    } else $2d2a9b09a68bd399$var$Le = !1;
    $2d2a9b09a68bd399$var$Ke = $2d2a9b09a68bd399$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $2d2a9b09a68bd399$var$Oe() {
    $2d2a9b09a68bd399$var$De && ($2d2a9b09a68bd399$var$De.detachEvent("onpropertychange", $2d2a9b09a68bd399$var$Pe), $2d2a9b09a68bd399$var$Ee = $2d2a9b09a68bd399$var$De = null);
}
function $2d2a9b09a68bd399$var$Pe(a) {
    if ("value" === a.propertyName && $2d2a9b09a68bd399$var$He($2d2a9b09a68bd399$var$Ee)) {
        var b = [];
        $2d2a9b09a68bd399$var$Be(b, $2d2a9b09a68bd399$var$Ee, a, $2d2a9b09a68bd399$var$xb(a));
        $2d2a9b09a68bd399$var$Jb($2d2a9b09a68bd399$var$Fe, b);
    }
}
function $2d2a9b09a68bd399$var$Qe(a, b, c) {
    "focusin" === a ? ($2d2a9b09a68bd399$var$Oe(), $2d2a9b09a68bd399$var$De = b, $2d2a9b09a68bd399$var$Ee = c, $2d2a9b09a68bd399$var$De.attachEvent("onpropertychange", $2d2a9b09a68bd399$var$Pe)) : "focusout" === a && $2d2a9b09a68bd399$var$Oe();
}
function $2d2a9b09a68bd399$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $2d2a9b09a68bd399$var$He($2d2a9b09a68bd399$var$Ee);
}
function $2d2a9b09a68bd399$var$Se(a, b) {
    if ("click" === a) return $2d2a9b09a68bd399$var$He(b);
}
function $2d2a9b09a68bd399$var$Te(a, b) {
    if ("input" === a || "change" === a) return $2d2a9b09a68bd399$var$He(b);
}
function $2d2a9b09a68bd399$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2d2a9b09a68bd399$var$Ve = "function" === typeof Object.is ? Object.is : $2d2a9b09a68bd399$var$Ue;
function $2d2a9b09a68bd399$var$We(a, b) {
    if ($2d2a9b09a68bd399$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$2d2a9b09a68bd399$var$ja.call(b, e) || !$2d2a9b09a68bd399$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $2d2a9b09a68bd399$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $2d2a9b09a68bd399$var$Ye(a, b) {
    var c = $2d2a9b09a68bd399$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $2d2a9b09a68bd399$var$Xe(c);
    }
}
function $2d2a9b09a68bd399$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $2d2a9b09a68bd399$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $2d2a9b09a68bd399$var$$e() {
    for(var a = window, b = $2d2a9b09a68bd399$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $2d2a9b09a68bd399$var$Xa(a.document);
    }
    return b;
}
function $2d2a9b09a68bd399$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $2d2a9b09a68bd399$var$bf(a) {
    var b = $2d2a9b09a68bd399$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $2d2a9b09a68bd399$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $2d2a9b09a68bd399$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $2d2a9b09a68bd399$var$Ye(c, f);
                var g = $2d2a9b09a68bd399$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $2d2a9b09a68bd399$var$cf = $2d2a9b09a68bd399$var$ia && "documentMode" in document && 11 >= document.documentMode, $2d2a9b09a68bd399$var$df = null, $2d2a9b09a68bd399$var$ef = null, $2d2a9b09a68bd399$var$ff = null, $2d2a9b09a68bd399$var$gf = !1;
function $2d2a9b09a68bd399$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $2d2a9b09a68bd399$var$gf || null == $2d2a9b09a68bd399$var$df || $2d2a9b09a68bd399$var$df !== $2d2a9b09a68bd399$var$Xa(d) || (d = $2d2a9b09a68bd399$var$df, "selectionStart" in d && $2d2a9b09a68bd399$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $2d2a9b09a68bd399$var$ff && $2d2a9b09a68bd399$var$We($2d2a9b09a68bd399$var$ff, d) || ($2d2a9b09a68bd399$var$ff = d, d = $2d2a9b09a68bd399$var$Ce($2d2a9b09a68bd399$var$ef, "onSelect"), 0 < d.length && (b = new $2d2a9b09a68bd399$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $2d2a9b09a68bd399$var$df)));
}
function $2d2a9b09a68bd399$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $2d2a9b09a68bd399$var$kf = {
    animationend: $2d2a9b09a68bd399$var$jf("Animation", "AnimationEnd"),
    animationiteration: $2d2a9b09a68bd399$var$jf("Animation", "AnimationIteration"),
    animationstart: $2d2a9b09a68bd399$var$jf("Animation", "AnimationStart"),
    transitionend: $2d2a9b09a68bd399$var$jf("Transition", "TransitionEnd")
}, $2d2a9b09a68bd399$var$lf = {}, $2d2a9b09a68bd399$var$mf = {};
$2d2a9b09a68bd399$var$ia && ($2d2a9b09a68bd399$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $2d2a9b09a68bd399$var$kf.animationend.animation, delete $2d2a9b09a68bd399$var$kf.animationiteration.animation, delete $2d2a9b09a68bd399$var$kf.animationstart.animation), "TransitionEvent" in window || delete $2d2a9b09a68bd399$var$kf.transitionend.transition);
function $2d2a9b09a68bd399$var$nf(a) {
    if ($2d2a9b09a68bd399$var$lf[a]) return $2d2a9b09a68bd399$var$lf[a];
    if (!$2d2a9b09a68bd399$var$kf[a]) return a;
    var b = $2d2a9b09a68bd399$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $2d2a9b09a68bd399$var$mf) return $2d2a9b09a68bd399$var$lf[a] = b[c];
    return a;
}
var $2d2a9b09a68bd399$var$of = $2d2a9b09a68bd399$var$nf("animationend"), $2d2a9b09a68bd399$var$pf = $2d2a9b09a68bd399$var$nf("animationiteration"), $2d2a9b09a68bd399$var$qf = $2d2a9b09a68bd399$var$nf("animationstart"), $2d2a9b09a68bd399$var$rf = $2d2a9b09a68bd399$var$nf("transitionend"), $2d2a9b09a68bd399$var$sf = new Map, $2d2a9b09a68bd399$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $2d2a9b09a68bd399$var$uf(a, b) {
    $2d2a9b09a68bd399$var$sf.set(a, b);
    $2d2a9b09a68bd399$var$fa(b, [
        a
    ]);
}
for(var $2d2a9b09a68bd399$var$vf = 0; $2d2a9b09a68bd399$var$vf < $2d2a9b09a68bd399$var$tf.length; $2d2a9b09a68bd399$var$vf++){
    var $2d2a9b09a68bd399$var$wf = $2d2a9b09a68bd399$var$tf[$2d2a9b09a68bd399$var$vf], $2d2a9b09a68bd399$var$xf = $2d2a9b09a68bd399$var$wf.toLowerCase(), $2d2a9b09a68bd399$var$yf = $2d2a9b09a68bd399$var$wf[0].toUpperCase() + $2d2a9b09a68bd399$var$wf.slice(1);
    $2d2a9b09a68bd399$var$uf($2d2a9b09a68bd399$var$xf, "on" + $2d2a9b09a68bd399$var$yf);
}
$2d2a9b09a68bd399$var$uf($2d2a9b09a68bd399$var$of, "onAnimationEnd");
$2d2a9b09a68bd399$var$uf($2d2a9b09a68bd399$var$pf, "onAnimationIteration");
$2d2a9b09a68bd399$var$uf($2d2a9b09a68bd399$var$qf, "onAnimationStart");
$2d2a9b09a68bd399$var$uf("dblclick", "onDoubleClick");
$2d2a9b09a68bd399$var$uf("focusin", "onFocus");
$2d2a9b09a68bd399$var$uf("focusout", "onBlur");
$2d2a9b09a68bd399$var$uf($2d2a9b09a68bd399$var$rf, "onTransitionEnd");
$2d2a9b09a68bd399$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2d2a9b09a68bd399$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2d2a9b09a68bd399$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2d2a9b09a68bd399$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2d2a9b09a68bd399$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2d2a9b09a68bd399$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2d2a9b09a68bd399$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2d2a9b09a68bd399$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2d2a9b09a68bd399$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2d2a9b09a68bd399$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2d2a9b09a68bd399$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2d2a9b09a68bd399$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($2d2a9b09a68bd399$var$zf));
function $2d2a9b09a68bd399$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $2d2a9b09a68bd399$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $2d2a9b09a68bd399$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2d2a9b09a68bd399$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $2d2a9b09a68bd399$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($2d2a9b09a68bd399$var$Qb) throw a = $2d2a9b09a68bd399$var$Rb, $2d2a9b09a68bd399$var$Qb = !1, $2d2a9b09a68bd399$var$Rb = null, a;
}
function $2d2a9b09a68bd399$var$F(a, b) {
    var c = b[$2d2a9b09a68bd399$var$Cf];
    void 0 === c && (c = b[$2d2a9b09a68bd399$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($2d2a9b09a68bd399$var$Df(b, a, 2, !1), c.add(d));
}
function $2d2a9b09a68bd399$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $2d2a9b09a68bd399$var$Df(c, a, d, b);
}
var $2d2a9b09a68bd399$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $2d2a9b09a68bd399$var$Gf(a) {
    if (!a[$2d2a9b09a68bd399$var$Ff]) {
        a[$2d2a9b09a68bd399$var$Ff] = !0;
        $2d2a9b09a68bd399$var$da.forEach(function(b) {
            "selectionchange" !== b && ($2d2a9b09a68bd399$var$Af.has(b) || $2d2a9b09a68bd399$var$Ef(b, !1, a), $2d2a9b09a68bd399$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$2d2a9b09a68bd399$var$Ff] || (b[$2d2a9b09a68bd399$var$Ff] = !0, $2d2a9b09a68bd399$var$Ef("selectionchange", !1, b));
    }
}
function $2d2a9b09a68bd399$var$Df(a, b, c, d) {
    switch($2d2a9b09a68bd399$var$xd(b)){
        case 1:
            var e = $2d2a9b09a68bd399$var$sd;
            break;
        case 4:
            e = $2d2a9b09a68bd399$var$ud;
            break;
        default:
            e = $2d2a9b09a68bd399$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$2d2a9b09a68bd399$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $2d2a9b09a68bd399$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $2d2a9b09a68bd399$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $2d2a9b09a68bd399$var$Jb(function() {
        var d = f, e = $2d2a9b09a68bd399$var$xb(c), g = [];
        a: {
            var h = $2d2a9b09a68bd399$var$sf.get(a);
            if (void 0 !== h) {
                var k = $2d2a9b09a68bd399$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $2d2a9b09a68bd399$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $2d2a9b09a68bd399$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $2d2a9b09a68bd399$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $2d2a9b09a68bd399$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $2d2a9b09a68bd399$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $2d2a9b09a68bd399$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $2d2a9b09a68bd399$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $2d2a9b09a68bd399$var$ie;
                        break;
                    case $2d2a9b09a68bd399$var$of:
                    case $2d2a9b09a68bd399$var$pf:
                    case $2d2a9b09a68bd399$var$qf:
                        k = $2d2a9b09a68bd399$var$Vd;
                        break;
                    case $2d2a9b09a68bd399$var$rf:
                        k = $2d2a9b09a68bd399$var$ke;
                        break;
                    case "scroll":
                        k = $2d2a9b09a68bd399$var$Jd;
                        break;
                    case "wheel":
                        k = $2d2a9b09a68bd399$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $2d2a9b09a68bd399$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $2d2a9b09a68bd399$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $2d2a9b09a68bd399$var$Kb(y, x), null != D && w.push($2d2a9b09a68bd399$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $2d2a9b09a68bd399$var$wb && (m = c.relatedTarget || c.fromElement) && ($2d2a9b09a68bd399$var$jd(m) || m[$2d2a9b09a68bd399$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $2d2a9b09a68bd399$var$jd(m) : null, null !== m && (C = $2d2a9b09a68bd399$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $2d2a9b09a68bd399$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $2d2a9b09a68bd399$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $2d2a9b09a68bd399$var$Ie(k);
                        v = null == m ? h : $2d2a9b09a68bd399$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $2d2a9b09a68bd399$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $2d2a9b09a68bd399$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $2d2a9b09a68bd399$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $2d2a9b09a68bd399$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $2d2a9b09a68bd399$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $2d2a9b09a68bd399$var$Jf(w);
                                x = $2d2a9b09a68bd399$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $2d2a9b09a68bd399$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $2d2a9b09a68bd399$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $2d2a9b09a68bd399$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $2d2a9b09a68bd399$var$Je;
                else if ($2d2a9b09a68bd399$var$Ae(h)) {
                    if ($2d2a9b09a68bd399$var$Ke) ca = $2d2a9b09a68bd399$var$Te;
                    else {
                        ca = $2d2a9b09a68bd399$var$Re;
                        var R = $2d2a9b09a68bd399$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $2d2a9b09a68bd399$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $2d2a9b09a68bd399$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $2d2a9b09a68bd399$var$bb(h, "number", h.value);
            }
            R = d ? $2d2a9b09a68bd399$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($2d2a9b09a68bd399$var$Ae(R) || "true" === R.contentEditable) $2d2a9b09a68bd399$var$df = R, $2d2a9b09a68bd399$var$ef = d, $2d2a9b09a68bd399$var$ff = null;
                    break;
                case "focusout":
                    $2d2a9b09a68bd399$var$ff = $2d2a9b09a68bd399$var$ef = $2d2a9b09a68bd399$var$df = null;
                    break;
                case "mousedown":
                    $2d2a9b09a68bd399$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2d2a9b09a68bd399$var$gf = !1;
                    $2d2a9b09a68bd399$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($2d2a9b09a68bd399$var$cf) break;
                case "keydown":
                case "keyup":
                    $2d2a9b09a68bd399$var$hf(g, c, e);
            }
            var sa;
            if ($2d2a9b09a68bd399$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $2d2a9b09a68bd399$var$we ? $2d2a9b09a68bd399$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($2d2a9b09a68bd399$var$re && "ko" !== c.locale && ($2d2a9b09a68bd399$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $2d2a9b09a68bd399$var$we && (sa = $2d2a9b09a68bd399$var$Bd()) : ($2d2a9b09a68bd399$var$yd = e, $2d2a9b09a68bd399$var$zd = "value" in $2d2a9b09a68bd399$var$yd ? $2d2a9b09a68bd399$var$yd.value : $2d2a9b09a68bd399$var$yd.textContent, $2d2a9b09a68bd399$var$we = !0)), R = $2d2a9b09a68bd399$var$Ce(d, V), 0 < R.length && (V = new $2d2a9b09a68bd399$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $2d2a9b09a68bd399$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $2d2a9b09a68bd399$var$qe ? $2d2a9b09a68bd399$var$xe(a, c) : $2d2a9b09a68bd399$var$ye(a, c)) d = $2d2a9b09a68bd399$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $2d2a9b09a68bd399$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $2d2a9b09a68bd399$var$Ge(g, b);
    });
}
function $2d2a9b09a68bd399$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $2d2a9b09a68bd399$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $2d2a9b09a68bd399$var$Kb(a, c), null != f && d.unshift($2d2a9b09a68bd399$var$Hf(a, f, e)), f = $2d2a9b09a68bd399$var$Kb(a, b), null != f && d.push($2d2a9b09a68bd399$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $2d2a9b09a68bd399$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $2d2a9b09a68bd399$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $2d2a9b09a68bd399$var$Kb(c, f), null != k && g.unshift($2d2a9b09a68bd399$var$Hf(c, k, h))) : e || (k = $2d2a9b09a68bd399$var$Kb(c, f), null != k && g.push($2d2a9b09a68bd399$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $2d2a9b09a68bd399$var$Lf = /\r\n?/g, $2d2a9b09a68bd399$var$Mf = /\u0000|\uFFFD/g;
function $2d2a9b09a68bd399$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($2d2a9b09a68bd399$var$Lf, "\n").replace($2d2a9b09a68bd399$var$Mf, "");
}
function $2d2a9b09a68bd399$var$Of(a, b, c) {
    b = $2d2a9b09a68bd399$var$Nf(b);
    if ($2d2a9b09a68bd399$var$Nf(a) !== b && c) throw Error($2d2a9b09a68bd399$var$p(425));
}
function $2d2a9b09a68bd399$var$Pf() {}
var $2d2a9b09a68bd399$var$Qf = null, $2d2a9b09a68bd399$var$Rf = null;
function $2d2a9b09a68bd399$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $2d2a9b09a68bd399$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $2d2a9b09a68bd399$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $2d2a9b09a68bd399$var$Vf = "function" === typeof Promise ? Promise : void 0, $2d2a9b09a68bd399$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2d2a9b09a68bd399$var$Vf ? function(a) {
    return $2d2a9b09a68bd399$var$Vf.resolve(null).then(a).catch($2d2a9b09a68bd399$var$Wf);
} : $2d2a9b09a68bd399$var$Tf;
function $2d2a9b09a68bd399$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $2d2a9b09a68bd399$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $2d2a9b09a68bd399$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $2d2a9b09a68bd399$var$pd(b);
}
function $2d2a9b09a68bd399$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $2d2a9b09a68bd399$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $2d2a9b09a68bd399$var$ag = Math.random().toString(36).slice(2), $2d2a9b09a68bd399$var$bg = "__reactFiber$" + $2d2a9b09a68bd399$var$ag, $2d2a9b09a68bd399$var$cg = "__reactProps$" + $2d2a9b09a68bd399$var$ag, $2d2a9b09a68bd399$var$If = "__reactContainer$" + $2d2a9b09a68bd399$var$ag, $2d2a9b09a68bd399$var$Cf = "__reactEvents$" + $2d2a9b09a68bd399$var$ag, $2d2a9b09a68bd399$var$dg = "__reactListeners$" + $2d2a9b09a68bd399$var$ag, $2d2a9b09a68bd399$var$eg = "__reactHandles$" + $2d2a9b09a68bd399$var$ag;
function $2d2a9b09a68bd399$var$jd(a) {
    var b = a[$2d2a9b09a68bd399$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$2d2a9b09a68bd399$var$If] || c[$2d2a9b09a68bd399$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $2d2a9b09a68bd399$var$$f(a); null !== a;){
                if (c = a[$2d2a9b09a68bd399$var$bg]) return c;
                a = $2d2a9b09a68bd399$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $2d2a9b09a68bd399$var$Cb(a) {
    a = a[$2d2a9b09a68bd399$var$bg] || a[$2d2a9b09a68bd399$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $2d2a9b09a68bd399$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($2d2a9b09a68bd399$var$p(33));
}
function $2d2a9b09a68bd399$var$Db(a) {
    return a[$2d2a9b09a68bd399$var$cg] || null;
}
var $2d2a9b09a68bd399$var$fg = [], $2d2a9b09a68bd399$var$gg = -1;
function $2d2a9b09a68bd399$var$hg(a) {
    return {
        current: a
    };
}
function $2d2a9b09a68bd399$var$G(a) {
    0 > $2d2a9b09a68bd399$var$gg || (a.current = $2d2a9b09a68bd399$var$fg[$2d2a9b09a68bd399$var$gg], $2d2a9b09a68bd399$var$fg[$2d2a9b09a68bd399$var$gg] = null, $2d2a9b09a68bd399$var$gg--);
}
function $2d2a9b09a68bd399$var$H(a, b) {
    $2d2a9b09a68bd399$var$gg++;
    $2d2a9b09a68bd399$var$fg[$2d2a9b09a68bd399$var$gg] = a.current;
    a.current = b;
}
var $2d2a9b09a68bd399$var$ig = {}, $2d2a9b09a68bd399$var$I = $2d2a9b09a68bd399$var$hg($2d2a9b09a68bd399$var$ig), $2d2a9b09a68bd399$var$jg = $2d2a9b09a68bd399$var$hg(!1), $2d2a9b09a68bd399$var$kg = $2d2a9b09a68bd399$var$ig;
function $2d2a9b09a68bd399$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $2d2a9b09a68bd399$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $2d2a9b09a68bd399$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $2d2a9b09a68bd399$var$ng() {
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg);
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$I);
}
function $2d2a9b09a68bd399$var$og(a, b, c) {
    if ($2d2a9b09a68bd399$var$I.current !== $2d2a9b09a68bd399$var$ig) throw Error($2d2a9b09a68bd399$var$p(168));
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$I, b);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$jg, c);
}
function $2d2a9b09a68bd399$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($2d2a9b09a68bd399$var$p(108, $2d2a9b09a68bd399$var$Ra(a) || "Unknown", e));
    return $2d2a9b09a68bd399$var$u({}, c, d);
}
function $2d2a9b09a68bd399$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $2d2a9b09a68bd399$var$ig;
    $2d2a9b09a68bd399$var$kg = $2d2a9b09a68bd399$var$I.current;
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$I, a);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$jg, $2d2a9b09a68bd399$var$jg.current);
    return !0;
}
function $2d2a9b09a68bd399$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($2d2a9b09a68bd399$var$p(169));
    c ? (a = $2d2a9b09a68bd399$var$pg(a, b, $2d2a9b09a68bd399$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg), $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$I), $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$I, a)) : $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$jg, c);
}
var $2d2a9b09a68bd399$var$sg = null, $2d2a9b09a68bd399$var$tg = !1, $2d2a9b09a68bd399$var$ug = !1;
function $2d2a9b09a68bd399$var$vg(a) {
    null === $2d2a9b09a68bd399$var$sg ? $2d2a9b09a68bd399$var$sg = [
        a
    ] : $2d2a9b09a68bd399$var$sg.push(a);
}
function $2d2a9b09a68bd399$var$wg(a) {
    $2d2a9b09a68bd399$var$tg = !0;
    $2d2a9b09a68bd399$var$vg(a);
}
function $2d2a9b09a68bd399$var$xg() {
    if (!$2d2a9b09a68bd399$var$ug && null !== $2d2a9b09a68bd399$var$sg) {
        $2d2a9b09a68bd399$var$ug = !0;
        var a = 0, b = $2d2a9b09a68bd399$var$E;
        try {
            var c = $2d2a9b09a68bd399$var$sg;
            for($2d2a9b09a68bd399$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $2d2a9b09a68bd399$var$sg = null;
            $2d2a9b09a68bd399$var$tg = !1;
        } catch (e) {
            throw null !== $2d2a9b09a68bd399$var$sg && ($2d2a9b09a68bd399$var$sg = $2d2a9b09a68bd399$var$sg.slice(a + 1)), $2d2a9b09a68bd399$var$ac($2d2a9b09a68bd399$var$fc, $2d2a9b09a68bd399$var$xg), e;
        } finally{
            $2d2a9b09a68bd399$var$E = b, $2d2a9b09a68bd399$var$ug = !1;
        }
    }
    return null;
}
var $2d2a9b09a68bd399$var$yg = [], $2d2a9b09a68bd399$var$zg = 0, $2d2a9b09a68bd399$var$Ag = null, $2d2a9b09a68bd399$var$Bg = 0, $2d2a9b09a68bd399$var$Cg = [], $2d2a9b09a68bd399$var$Dg = 0, $2d2a9b09a68bd399$var$Eg = null, $2d2a9b09a68bd399$var$Fg = 1, $2d2a9b09a68bd399$var$Gg = "";
function $2d2a9b09a68bd399$var$Hg(a, b) {
    $2d2a9b09a68bd399$var$yg[$2d2a9b09a68bd399$var$zg++] = $2d2a9b09a68bd399$var$Bg;
    $2d2a9b09a68bd399$var$yg[$2d2a9b09a68bd399$var$zg++] = $2d2a9b09a68bd399$var$Ag;
    $2d2a9b09a68bd399$var$Ag = a;
    $2d2a9b09a68bd399$var$Bg = b;
}
function $2d2a9b09a68bd399$var$Ig(a, b, c) {
    $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Fg;
    $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Gg;
    $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Eg;
    $2d2a9b09a68bd399$var$Eg = a;
    var d = $2d2a9b09a68bd399$var$Fg;
    a = $2d2a9b09a68bd399$var$Gg;
    var e = 32 - $2d2a9b09a68bd399$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $2d2a9b09a68bd399$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $2d2a9b09a68bd399$var$Fg = 1 << 32 - $2d2a9b09a68bd399$var$Ac(b) + e | c << e | d;
        $2d2a9b09a68bd399$var$Gg = f + a;
    } else $2d2a9b09a68bd399$var$Fg = 1 << f | c << e | d, $2d2a9b09a68bd399$var$Gg = a;
}
function $2d2a9b09a68bd399$var$Jg(a) {
    null !== a.return && ($2d2a9b09a68bd399$var$Hg(a, 1), $2d2a9b09a68bd399$var$Ig(a, 1, 0));
}
function $2d2a9b09a68bd399$var$Kg(a) {
    for(; a === $2d2a9b09a68bd399$var$Ag;)$2d2a9b09a68bd399$var$Ag = $2d2a9b09a68bd399$var$yg[--$2d2a9b09a68bd399$var$zg], $2d2a9b09a68bd399$var$yg[$2d2a9b09a68bd399$var$zg] = null, $2d2a9b09a68bd399$var$Bg = $2d2a9b09a68bd399$var$yg[--$2d2a9b09a68bd399$var$zg], $2d2a9b09a68bd399$var$yg[$2d2a9b09a68bd399$var$zg] = null;
    for(; a === $2d2a9b09a68bd399$var$Eg;)$2d2a9b09a68bd399$var$Eg = $2d2a9b09a68bd399$var$Cg[--$2d2a9b09a68bd399$var$Dg], $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg] = null, $2d2a9b09a68bd399$var$Gg = $2d2a9b09a68bd399$var$Cg[--$2d2a9b09a68bd399$var$Dg], $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg] = null, $2d2a9b09a68bd399$var$Fg = $2d2a9b09a68bd399$var$Cg[--$2d2a9b09a68bd399$var$Dg], $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg] = null;
}
var $2d2a9b09a68bd399$var$Lg = null, $2d2a9b09a68bd399$var$Mg = null, $2d2a9b09a68bd399$var$J = !1, $2d2a9b09a68bd399$var$Ng = null;
function $2d2a9b09a68bd399$var$Og(a, b) {
    var c = $2d2a9b09a68bd399$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $2d2a9b09a68bd399$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $2d2a9b09a68bd399$var$Lg = a, $2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $2d2a9b09a68bd399$var$Lg = a, $2d2a9b09a68bd399$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $2d2a9b09a68bd399$var$Eg ? {
                id: $2d2a9b09a68bd399$var$Fg,
                overflow: $2d2a9b09a68bd399$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $2d2a9b09a68bd399$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $2d2a9b09a68bd399$var$Lg = a, $2d2a9b09a68bd399$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $2d2a9b09a68bd399$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $2d2a9b09a68bd399$var$Sg(a) {
    if ($2d2a9b09a68bd399$var$J) {
        var b = $2d2a9b09a68bd399$var$Mg;
        if (b) {
            var c = b;
            if (!$2d2a9b09a68bd399$var$Qg(a, b)) {
                if ($2d2a9b09a68bd399$var$Rg(a)) throw Error($2d2a9b09a68bd399$var$p(418));
                b = $2d2a9b09a68bd399$var$Zf(c.nextSibling);
                var d = $2d2a9b09a68bd399$var$Lg;
                b && $2d2a9b09a68bd399$var$Qg(a, b) ? $2d2a9b09a68bd399$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $2d2a9b09a68bd399$var$J = !1, $2d2a9b09a68bd399$var$Lg = a);
            }
        } else {
            if ($2d2a9b09a68bd399$var$Rg(a)) throw Error($2d2a9b09a68bd399$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $2d2a9b09a68bd399$var$J = !1;
            $2d2a9b09a68bd399$var$Lg = a;
        }
    }
}
function $2d2a9b09a68bd399$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $2d2a9b09a68bd399$var$Lg = a;
}
function $2d2a9b09a68bd399$var$Ug(a) {
    if (a !== $2d2a9b09a68bd399$var$Lg) return !1;
    if (!$2d2a9b09a68bd399$var$J) return $2d2a9b09a68bd399$var$Tg(a), $2d2a9b09a68bd399$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$2d2a9b09a68bd399$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $2d2a9b09a68bd399$var$Mg)) {
        if ($2d2a9b09a68bd399$var$Rg(a)) throw $2d2a9b09a68bd399$var$Vg(), Error($2d2a9b09a68bd399$var$p(418));
        for(; b;)$2d2a9b09a68bd399$var$Og(a, b), b = $2d2a9b09a68bd399$var$Zf(b.nextSibling);
    }
    $2d2a9b09a68bd399$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($2d2a9b09a68bd399$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $2d2a9b09a68bd399$var$Mg = null;
        }
    } else $2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Lg ? $2d2a9b09a68bd399$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $2d2a9b09a68bd399$var$Vg() {
    for(var a = $2d2a9b09a68bd399$var$Mg; a;)a = $2d2a9b09a68bd399$var$Zf(a.nextSibling);
}
function $2d2a9b09a68bd399$var$Wg() {
    $2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Lg = null;
    $2d2a9b09a68bd399$var$J = !1;
}
function $2d2a9b09a68bd399$var$Xg(a) {
    null === $2d2a9b09a68bd399$var$Ng ? $2d2a9b09a68bd399$var$Ng = [
        a
    ] : $2d2a9b09a68bd399$var$Ng.push(a);
}
var $2d2a9b09a68bd399$var$Yg = $2d2a9b09a68bd399$var$va.ReactCurrentBatchConfig;
function $2d2a9b09a68bd399$var$Zg(a, b) {
    if (a && a.defaultProps) {
        b = $2d2a9b09a68bd399$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $2d2a9b09a68bd399$var$$g = $2d2a9b09a68bd399$var$hg(null), $2d2a9b09a68bd399$var$ah = null, $2d2a9b09a68bd399$var$bh = null, $2d2a9b09a68bd399$var$ch = null;
function $2d2a9b09a68bd399$var$dh() {
    $2d2a9b09a68bd399$var$ch = $2d2a9b09a68bd399$var$bh = $2d2a9b09a68bd399$var$ah = null;
}
function $2d2a9b09a68bd399$var$eh(a) {
    var b = $2d2a9b09a68bd399$var$$g.current;
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$$g);
    a._currentValue = b;
}
function $2d2a9b09a68bd399$var$fh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $2d2a9b09a68bd399$var$gh(a, b) {
    $2d2a9b09a68bd399$var$ah = a;
    $2d2a9b09a68bd399$var$ch = $2d2a9b09a68bd399$var$bh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($2d2a9b09a68bd399$var$hh = !0), a.firstContext = null);
}
function $2d2a9b09a68bd399$var$ih(a) {
    var b = a._currentValue;
    if ($2d2a9b09a68bd399$var$ch !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $2d2a9b09a68bd399$var$bh) {
            if (null === $2d2a9b09a68bd399$var$ah) throw Error($2d2a9b09a68bd399$var$p(308));
            $2d2a9b09a68bd399$var$bh = a;
            $2d2a9b09a68bd399$var$ah.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $2d2a9b09a68bd399$var$bh = $2d2a9b09a68bd399$var$bh.next = a;
    }
    return b;
}
var $2d2a9b09a68bd399$var$jh = null;
function $2d2a9b09a68bd399$var$kh(a) {
    null === $2d2a9b09a68bd399$var$jh ? $2d2a9b09a68bd399$var$jh = [
        a
    ] : $2d2a9b09a68bd399$var$jh.push(a);
}
function $2d2a9b09a68bd399$var$lh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $2d2a9b09a68bd399$var$kh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $2d2a9b09a68bd399$var$mh(a, d);
}
function $2d2a9b09a68bd399$var$mh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $2d2a9b09a68bd399$var$nh = !1;
function $2d2a9b09a68bd399$var$oh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $2d2a9b09a68bd399$var$ph(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $2d2a9b09a68bd399$var$qh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2d2a9b09a68bd399$var$rh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($2d2a9b09a68bd399$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $2d2a9b09a68bd399$var$mh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $2d2a9b09a68bd399$var$kh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $2d2a9b09a68bd399$var$mh(a, c);
}
function $2d2a9b09a68bd399$var$sh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2d2a9b09a68bd399$var$Oc(a, c);
    }
}
function $2d2a9b09a68bd399$var$th(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $2d2a9b09a68bd399$var$uh(a, b, c, d) {
    var e = a.updateQueue;
    $2d2a9b09a68bd399$var$nh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $2d2a9b09a68bd399$var$u({}, q, r);
                            break a;
                        case 2:
                            $2d2a9b09a68bd399$var$nh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $2d2a9b09a68bd399$var$vh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $2d2a9b09a68bd399$var$wh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($2d2a9b09a68bd399$var$p(191, e));
            e.call(d);
        }
    }
}
var $2d2a9b09a68bd399$var$xh = (new $5uXOq.Component).refs;
function $2d2a9b09a68bd399$var$yh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2d2a9b09a68bd399$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $2d2a9b09a68bd399$var$Ch = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $2d2a9b09a68bd399$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2d2a9b09a68bd399$var$zh(), e = $2d2a9b09a68bd399$var$Ah(a), f = $2d2a9b09a68bd399$var$qh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2d2a9b09a68bd399$var$rh(a, f, e);
        null !== b && ($2d2a9b09a68bd399$var$Bh(b, a, e, d), $2d2a9b09a68bd399$var$sh(b, a, e));
        $2d2a9b09a68bd399$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $2d2a9b09a68bd399$var$zh(), e = $2d2a9b09a68bd399$var$Ah(a), f = $2d2a9b09a68bd399$var$qh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $2d2a9b09a68bd399$var$rh(a, f, e);
        null !== b && ($2d2a9b09a68bd399$var$Bh(b, a, e, d), $2d2a9b09a68bd399$var$sh(b, a, e));
        $2d2a9b09a68bd399$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $2d2a9b09a68bd399$var$zh(), d = $2d2a9b09a68bd399$var$Ah(a), e = $2d2a9b09a68bd399$var$qh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $2d2a9b09a68bd399$var$rh(a, e, d);
        null !== b && ($2d2a9b09a68bd399$var$Bh(b, a, d, c), $2d2a9b09a68bd399$var$sh(b, a, d));
        null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markForceUpdateScheduled && $2d2a9b09a68bd399$var$B.markForceUpdateScheduled(a, d);
    }
};
function $2d2a9b09a68bd399$var$Dh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$2d2a9b09a68bd399$var$We(c, d) || !$2d2a9b09a68bd399$var$We(e, f) : !0;
}
function $2d2a9b09a68bd399$var$Eh(a, b, c) {
    var d = !1, e = $2d2a9b09a68bd399$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $2d2a9b09a68bd399$var$ih(f) : (e = $2d2a9b09a68bd399$var$mg(b) ? $2d2a9b09a68bd399$var$kg : $2d2a9b09a68bd399$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $2d2a9b09a68bd399$var$lg(a, e) : $2d2a9b09a68bd399$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $2d2a9b09a68bd399$var$Ch;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $2d2a9b09a68bd399$var$Fh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $2d2a9b09a68bd399$var$Ch.enqueueReplaceState(b, b.state, null);
}
function $2d2a9b09a68bd399$var$Gh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $2d2a9b09a68bd399$var$xh;
    $2d2a9b09a68bd399$var$oh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $2d2a9b09a68bd399$var$ih(f) : (f = $2d2a9b09a68bd399$var$mg(b) ? $2d2a9b09a68bd399$var$kg : $2d2a9b09a68bd399$var$I.current, e.context = $2d2a9b09a68bd399$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($2d2a9b09a68bd399$var$yh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $2d2a9b09a68bd399$var$Ch.enqueueReplaceState(e, e.state, null), $2d2a9b09a68bd399$var$uh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $2d2a9b09a68bd399$var$Hh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($2d2a9b09a68bd399$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($2d2a9b09a68bd399$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $2d2a9b09a68bd399$var$xh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($2d2a9b09a68bd399$var$p(284));
        if (!c._owner) throw Error($2d2a9b09a68bd399$var$p(290, a));
    }
    return a;
}
function $2d2a9b09a68bd399$var$Ih(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($2d2a9b09a68bd399$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $2d2a9b09a68bd399$var$Jh(a) {
    var b = a._init;
    return b(a._payload);
}
function $2d2a9b09a68bd399$var$Kh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $2d2a9b09a68bd399$var$Lh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $2d2a9b09a68bd399$var$Mh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $2d2a9b09a68bd399$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $2d2a9b09a68bd399$var$Ha && $2d2a9b09a68bd399$var$Jh(f) === b.type)) return d = e(b, c.props), d.ref = $2d2a9b09a68bd399$var$Hh(a, b, c), d.return = a, d;
        d = $2d2a9b09a68bd399$var$Nh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $2d2a9b09a68bd399$var$Hh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $2d2a9b09a68bd399$var$Oh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $2d2a9b09a68bd399$var$Ph(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $2d2a9b09a68bd399$var$Mh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $2d2a9b09a68bd399$var$wa:
                    return c = $2d2a9b09a68bd399$var$Nh(b.type, b.key, b.props, null, a.mode, c), c.ref = $2d2a9b09a68bd399$var$Hh(a, null, b), c.return = a, c;
                case $2d2a9b09a68bd399$var$xa:
                    return b = $2d2a9b09a68bd399$var$Oh(b, a.mode, c), b.return = a, b;
                case $2d2a9b09a68bd399$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($2d2a9b09a68bd399$var$db(b) || $2d2a9b09a68bd399$var$Ka(b)) return b = $2d2a9b09a68bd399$var$Ph(b, a.mode, c, null), b.return = a, b;
            $2d2a9b09a68bd399$var$Ih(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $2d2a9b09a68bd399$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $2d2a9b09a68bd399$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $2d2a9b09a68bd399$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($2d2a9b09a68bd399$var$db(c) || $2d2a9b09a68bd399$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $2d2a9b09a68bd399$var$Ih(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $2d2a9b09a68bd399$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $2d2a9b09a68bd399$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $2d2a9b09a68bd399$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($2d2a9b09a68bd399$var$db(d) || $2d2a9b09a68bd399$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $2d2a9b09a68bd399$var$Ih(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $2d2a9b09a68bd399$var$Ka(h);
        if ("function" !== typeof l) throw Error($2d2a9b09a68bd399$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($2d2a9b09a68bd399$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $2d2a9b09a68bd399$var$J && $2d2a9b09a68bd399$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $2d2a9b09a68bd399$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $2d2a9b09a68bd399$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $2d2a9b09a68bd399$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $2d2a9b09a68bd399$var$Ha && $2d2a9b09a68bd399$var$Jh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $2d2a9b09a68bd399$var$Hh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $2d2a9b09a68bd399$var$ya ? (d = $2d2a9b09a68bd399$var$Ph(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $2d2a9b09a68bd399$var$Nh(f.type, f.key, f.props, null, a.mode, h), h.ref = $2d2a9b09a68bd399$var$Hh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $2d2a9b09a68bd399$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $2d2a9b09a68bd399$var$Oh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $2d2a9b09a68bd399$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($2d2a9b09a68bd399$var$db(f)) return m(a, d, f, h);
            if ($2d2a9b09a68bd399$var$Ka(f)) return w(a, d, f, h);
            $2d2a9b09a68bd399$var$Ih(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $2d2a9b09a68bd399$var$Mh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $2d2a9b09a68bd399$var$Qh = $2d2a9b09a68bd399$var$Kh(!0), $2d2a9b09a68bd399$var$Rh = $2d2a9b09a68bd399$var$Kh(!1), $2d2a9b09a68bd399$var$Sh = {}, $2d2a9b09a68bd399$var$Th = $2d2a9b09a68bd399$var$hg($2d2a9b09a68bd399$var$Sh), $2d2a9b09a68bd399$var$Uh = $2d2a9b09a68bd399$var$hg($2d2a9b09a68bd399$var$Sh), $2d2a9b09a68bd399$var$Vh = $2d2a9b09a68bd399$var$hg($2d2a9b09a68bd399$var$Sh);
function $2d2a9b09a68bd399$var$Wh(a) {
    if (a === $2d2a9b09a68bd399$var$Sh) throw Error($2d2a9b09a68bd399$var$p(174));
    return a;
}
function $2d2a9b09a68bd399$var$Xh(a, b) {
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Vh, b);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Uh, a);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Th, $2d2a9b09a68bd399$var$Sh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $2d2a9b09a68bd399$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $2d2a9b09a68bd399$var$kb(b, a);
    }
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Th);
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Th, b);
}
function $2d2a9b09a68bd399$var$Yh() {
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Th);
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Uh);
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Vh);
}
function $2d2a9b09a68bd399$var$Zh(a) {
    $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Vh.current);
    var b = $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Th.current);
    var c = $2d2a9b09a68bd399$var$kb(b, a.type);
    b !== c && ($2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Uh, a), $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Th, c));
}
function $2d2a9b09a68bd399$var$$h(a) {
    $2d2a9b09a68bd399$var$Uh.current === a && ($2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Th), $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Uh));
}
var $2d2a9b09a68bd399$var$L = $2d2a9b09a68bd399$var$hg(0);
function $2d2a9b09a68bd399$var$ai(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $2d2a9b09a68bd399$var$bi = [];
function $2d2a9b09a68bd399$var$ci() {
    for(var a = 0; a < $2d2a9b09a68bd399$var$bi.length; a++)$2d2a9b09a68bd399$var$bi[a]._workInProgressVersionPrimary = null;
    $2d2a9b09a68bd399$var$bi.length = 0;
}
var $2d2a9b09a68bd399$var$di = $2d2a9b09a68bd399$var$va.ReactCurrentDispatcher, $2d2a9b09a68bd399$var$ei = $2d2a9b09a68bd399$var$va.ReactCurrentBatchConfig, $2d2a9b09a68bd399$var$fi = 0, $2d2a9b09a68bd399$var$M = null, $2d2a9b09a68bd399$var$N = null, $2d2a9b09a68bd399$var$O = null, $2d2a9b09a68bd399$var$gi = !1, $2d2a9b09a68bd399$var$hi = !1, $2d2a9b09a68bd399$var$ii = 0, $2d2a9b09a68bd399$var$ji = 0;
function $2d2a9b09a68bd399$var$P() {
    throw Error($2d2a9b09a68bd399$var$p(321));
}
function $2d2a9b09a68bd399$var$ki(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$2d2a9b09a68bd399$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $2d2a9b09a68bd399$var$li(a, b, c, d, e, f) {
    $2d2a9b09a68bd399$var$fi = f;
    $2d2a9b09a68bd399$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $2d2a9b09a68bd399$var$di.current = null === a || null === a.memoizedState ? $2d2a9b09a68bd399$var$mi : $2d2a9b09a68bd399$var$ni;
    a = c(d, e);
    if ($2d2a9b09a68bd399$var$hi) {
        f = 0;
        do {
            $2d2a9b09a68bd399$var$hi = !1;
            $2d2a9b09a68bd399$var$ii = 0;
            if (25 <= f) throw Error($2d2a9b09a68bd399$var$p(301));
            f += 1;
            $2d2a9b09a68bd399$var$O = $2d2a9b09a68bd399$var$N = null;
            b.updateQueue = null;
            $2d2a9b09a68bd399$var$di.current = $2d2a9b09a68bd399$var$oi;
            a = c(d, e);
        }while ($2d2a9b09a68bd399$var$hi);
    }
    $2d2a9b09a68bd399$var$di.current = $2d2a9b09a68bd399$var$pi;
    b = null !== $2d2a9b09a68bd399$var$N && null !== $2d2a9b09a68bd399$var$N.next;
    $2d2a9b09a68bd399$var$fi = 0;
    $2d2a9b09a68bd399$var$O = $2d2a9b09a68bd399$var$N = $2d2a9b09a68bd399$var$M = null;
    $2d2a9b09a68bd399$var$gi = !1;
    if (b) throw Error($2d2a9b09a68bd399$var$p(300));
    return a;
}
function $2d2a9b09a68bd399$var$qi() {
    var a = 0 !== $2d2a9b09a68bd399$var$ii;
    $2d2a9b09a68bd399$var$ii = 0;
    return a;
}
function $2d2a9b09a68bd399$var$ri() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2d2a9b09a68bd399$var$O ? $2d2a9b09a68bd399$var$M.memoizedState = $2d2a9b09a68bd399$var$O = a : $2d2a9b09a68bd399$var$O = $2d2a9b09a68bd399$var$O.next = a;
    return $2d2a9b09a68bd399$var$O;
}
function $2d2a9b09a68bd399$var$si() {
    if (null === $2d2a9b09a68bd399$var$N) {
        var a = $2d2a9b09a68bd399$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $2d2a9b09a68bd399$var$N.next;
    var b = null === $2d2a9b09a68bd399$var$O ? $2d2a9b09a68bd399$var$M.memoizedState : $2d2a9b09a68bd399$var$O.next;
    if (null !== b) $2d2a9b09a68bd399$var$O = b, $2d2a9b09a68bd399$var$N = a;
    else {
        if (null === a) throw Error($2d2a9b09a68bd399$var$p(310));
        $2d2a9b09a68bd399$var$N = a;
        a = {
            memoizedState: $2d2a9b09a68bd399$var$N.memoizedState,
            baseState: $2d2a9b09a68bd399$var$N.baseState,
            baseQueue: $2d2a9b09a68bd399$var$N.baseQueue,
            queue: $2d2a9b09a68bd399$var$N.queue,
            next: null
        };
        null === $2d2a9b09a68bd399$var$O ? $2d2a9b09a68bd399$var$M.memoizedState = $2d2a9b09a68bd399$var$O = a : $2d2a9b09a68bd399$var$O = $2d2a9b09a68bd399$var$O.next = a;
    }
    return $2d2a9b09a68bd399$var$O;
}
function $2d2a9b09a68bd399$var$ti(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $2d2a9b09a68bd399$var$ui(a) {
    var b = $2d2a9b09a68bd399$var$si(), c = b.queue;
    if (null === c) throw Error($2d2a9b09a68bd399$var$p(311));
    c.lastRenderedReducer = a;
    var d = $2d2a9b09a68bd399$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($2d2a9b09a68bd399$var$fi & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $2d2a9b09a68bd399$var$M.lanes |= n;
                $2d2a9b09a68bd399$var$vh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $2d2a9b09a68bd399$var$Ve(d, b.memoizedState) || ($2d2a9b09a68bd399$var$hh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $2d2a9b09a68bd399$var$M.lanes |= f, $2d2a9b09a68bd399$var$vh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $2d2a9b09a68bd399$var$vi(a) {
    var b = $2d2a9b09a68bd399$var$si(), c = b.queue;
    if (null === c) throw Error($2d2a9b09a68bd399$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $2d2a9b09a68bd399$var$Ve(f, b.memoizedState) || ($2d2a9b09a68bd399$var$hh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $2d2a9b09a68bd399$var$wi() {}
function $2d2a9b09a68bd399$var$xi(a, b) {
    var c = $2d2a9b09a68bd399$var$M, d = $2d2a9b09a68bd399$var$si(), e = b(), f = !$2d2a9b09a68bd399$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $2d2a9b09a68bd399$var$hh = !0);
    d = d.queue;
    $2d2a9b09a68bd399$var$yi($2d2a9b09a68bd399$var$zi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $2d2a9b09a68bd399$var$O && $2d2a9b09a68bd399$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $2d2a9b09a68bd399$var$Ai(9, $2d2a9b09a68bd399$var$Bi.bind(null, c, d, e, b), void 0, null);
        if (null === $2d2a9b09a68bd399$var$Q) throw Error($2d2a9b09a68bd399$var$p(349));
        0 !== ($2d2a9b09a68bd399$var$fi & 30) || $2d2a9b09a68bd399$var$Ci(c, b, e);
    }
    return e;
}
function $2d2a9b09a68bd399$var$Ci(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $2d2a9b09a68bd399$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2d2a9b09a68bd399$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $2d2a9b09a68bd399$var$Bi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $2d2a9b09a68bd399$var$Di(b) && $2d2a9b09a68bd399$var$Ei(a);
}
function $2d2a9b09a68bd399$var$zi(a, b, c) {
    return c(function() {
        $2d2a9b09a68bd399$var$Di(b) && $2d2a9b09a68bd399$var$Ei(a);
    });
}
function $2d2a9b09a68bd399$var$Di(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$2d2a9b09a68bd399$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $2d2a9b09a68bd399$var$Ei(a) {
    var b = $2d2a9b09a68bd399$var$mh(a, 1);
    null !== b && $2d2a9b09a68bd399$var$Bh(b, a, 1, -1);
}
function $2d2a9b09a68bd399$var$Fi(a) {
    var b = $2d2a9b09a68bd399$var$ri();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2d2a9b09a68bd399$var$ti,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $2d2a9b09a68bd399$var$Gi.bind(null, $2d2a9b09a68bd399$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $2d2a9b09a68bd399$var$Ai(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $2d2a9b09a68bd399$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $2d2a9b09a68bd399$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $2d2a9b09a68bd399$var$Ji() {
    return $2d2a9b09a68bd399$var$si().memoizedState;
}
function $2d2a9b09a68bd399$var$Ki(a, b, c, d) {
    var e = $2d2a9b09a68bd399$var$ri();
    $2d2a9b09a68bd399$var$M.flags |= a;
    e.memoizedState = $2d2a9b09a68bd399$var$Ai(1 | b, c, void 0, void 0 === d ? null : d);
}
function $2d2a9b09a68bd399$var$Li(a, b, c, d) {
    var e = $2d2a9b09a68bd399$var$si();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $2d2a9b09a68bd399$var$N) {
        var g = $2d2a9b09a68bd399$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $2d2a9b09a68bd399$var$ki(d, g.deps)) {
            e.memoizedState = $2d2a9b09a68bd399$var$Ai(b, c, f, d);
            return;
        }
    }
    $2d2a9b09a68bd399$var$M.flags |= a;
    e.memoizedState = $2d2a9b09a68bd399$var$Ai(1 | b, c, f, d);
}
function $2d2a9b09a68bd399$var$Mi(a, b) {
    return $2d2a9b09a68bd399$var$Ki(8390656, 8, a, b);
}
function $2d2a9b09a68bd399$var$yi(a, b) {
    return $2d2a9b09a68bd399$var$Li(2048, 8, a, b);
}
function $2d2a9b09a68bd399$var$Ni(a, b) {
    return $2d2a9b09a68bd399$var$Li(4, 2, a, b);
}
function $2d2a9b09a68bd399$var$Oi(a, b) {
    return $2d2a9b09a68bd399$var$Li(4, 4, a, b);
}
function $2d2a9b09a68bd399$var$Pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $2d2a9b09a68bd399$var$Qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $2d2a9b09a68bd399$var$Li(4, 4, $2d2a9b09a68bd399$var$Pi.bind(null, b, a), c);
}
function $2d2a9b09a68bd399$var$Ri() {}
function $2d2a9b09a68bd399$var$Si(a, b) {
    var c = $2d2a9b09a68bd399$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2d2a9b09a68bd399$var$ki(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2d2a9b09a68bd399$var$Ti(a, b) {
    var c = $2d2a9b09a68bd399$var$si();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $2d2a9b09a68bd399$var$ki(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $2d2a9b09a68bd399$var$Ui(a, b, c) {
    if (0 === ($2d2a9b09a68bd399$var$fi & 21)) return a.baseState && (a.baseState = !1, $2d2a9b09a68bd399$var$hh = !0), a.memoizedState = c;
    $2d2a9b09a68bd399$var$Ve(c, b) || (c = $2d2a9b09a68bd399$var$Kc(), $2d2a9b09a68bd399$var$M.lanes |= c, $2d2a9b09a68bd399$var$vh |= c, a.baseState = !0);
    return b;
}
function $2d2a9b09a68bd399$var$Vi(a, b) {
    var c = $2d2a9b09a68bd399$var$E;
    $2d2a9b09a68bd399$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $2d2a9b09a68bd399$var$ei.transition;
    $2d2a9b09a68bd399$var$ei.transition = {};
    try {
        a(!1), b();
    } finally{
        $2d2a9b09a68bd399$var$E = c, $2d2a9b09a68bd399$var$ei.transition = d;
    }
}
function $2d2a9b09a68bd399$var$Wi() {
    return $2d2a9b09a68bd399$var$si().memoizedState;
}
function $2d2a9b09a68bd399$var$Xi(a, b, c) {
    var d = $2d2a9b09a68bd399$var$Ah(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2d2a9b09a68bd399$var$Yi(a)) $2d2a9b09a68bd399$var$Zi(b, c);
    else if (c = $2d2a9b09a68bd399$var$lh(a, b, c, d), null !== c) {
        var e = $2d2a9b09a68bd399$var$zh();
        $2d2a9b09a68bd399$var$Bh(c, a, d, e);
        $2d2a9b09a68bd399$var$$i(c, b, d);
    }
    $2d2a9b09a68bd399$var$yc(a, d);
}
function $2d2a9b09a68bd399$var$Gi(a, b, c) {
    var d = $2d2a9b09a68bd399$var$Ah(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2d2a9b09a68bd399$var$Yi(a)) $2d2a9b09a68bd399$var$Zi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($2d2a9b09a68bd399$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $2d2a9b09a68bd399$var$kh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $2d2a9b09a68bd399$var$lh(a, b, e, d);
        null !== c && (e = $2d2a9b09a68bd399$var$zh(), $2d2a9b09a68bd399$var$Bh(c, a, d, e), $2d2a9b09a68bd399$var$$i(c, b, d));
    }
    $2d2a9b09a68bd399$var$yc(a, d);
}
function $2d2a9b09a68bd399$var$Yi(a) {
    var b = a.alternate;
    return a === $2d2a9b09a68bd399$var$M || null !== b && b === $2d2a9b09a68bd399$var$M;
}
function $2d2a9b09a68bd399$var$Zi(a, b) {
    $2d2a9b09a68bd399$var$hi = $2d2a9b09a68bd399$var$gi = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $2d2a9b09a68bd399$var$$i(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $2d2a9b09a68bd399$var$Oc(a, c);
    }
}
var $2d2a9b09a68bd399$var$pi = {
    readContext: $2d2a9b09a68bd399$var$ih,
    useCallback: $2d2a9b09a68bd399$var$P,
    useContext: $2d2a9b09a68bd399$var$P,
    useEffect: $2d2a9b09a68bd399$var$P,
    useImperativeHandle: $2d2a9b09a68bd399$var$P,
    useInsertionEffect: $2d2a9b09a68bd399$var$P,
    useLayoutEffect: $2d2a9b09a68bd399$var$P,
    useMemo: $2d2a9b09a68bd399$var$P,
    useReducer: $2d2a9b09a68bd399$var$P,
    useRef: $2d2a9b09a68bd399$var$P,
    useState: $2d2a9b09a68bd399$var$P,
    useDebugValue: $2d2a9b09a68bd399$var$P,
    useDeferredValue: $2d2a9b09a68bd399$var$P,
    useTransition: $2d2a9b09a68bd399$var$P,
    useMutableSource: $2d2a9b09a68bd399$var$P,
    useSyncExternalStore: $2d2a9b09a68bd399$var$P,
    useId: $2d2a9b09a68bd399$var$P,
    unstable_isNewReconciler: !1
}, $2d2a9b09a68bd399$var$mi = {
    readContext: $2d2a9b09a68bd399$var$ih,
    useCallback: function(a, b) {
        $2d2a9b09a68bd399$var$ri().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $2d2a9b09a68bd399$var$ih,
    useEffect: $2d2a9b09a68bd399$var$Mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $2d2a9b09a68bd399$var$Ki(4194308, 4, $2d2a9b09a68bd399$var$Pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $2d2a9b09a68bd399$var$Ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $2d2a9b09a68bd399$var$Ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $2d2a9b09a68bd399$var$ri();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $2d2a9b09a68bd399$var$ri();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $2d2a9b09a68bd399$var$Xi.bind(null, $2d2a9b09a68bd399$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $2d2a9b09a68bd399$var$ri();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $2d2a9b09a68bd399$var$Fi,
    useDebugValue: $2d2a9b09a68bd399$var$Ri,
    useDeferredValue: function(a) {
        return $2d2a9b09a68bd399$var$ri().memoizedState = a;
    },
    useTransition: function() {
        var a = $2d2a9b09a68bd399$var$Fi(!1), b = a[0];
        a = $2d2a9b09a68bd399$var$Vi.bind(null, a[1]);
        $2d2a9b09a68bd399$var$ri().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $2d2a9b09a68bd399$var$M, e = $2d2a9b09a68bd399$var$ri();
        if ($2d2a9b09a68bd399$var$J) {
            if (void 0 === c) throw Error($2d2a9b09a68bd399$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $2d2a9b09a68bd399$var$Q) throw Error($2d2a9b09a68bd399$var$p(349));
            0 !== ($2d2a9b09a68bd399$var$fi & 30) || $2d2a9b09a68bd399$var$Ci(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $2d2a9b09a68bd399$var$Mi($2d2a9b09a68bd399$var$zi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $2d2a9b09a68bd399$var$Ai(9, $2d2a9b09a68bd399$var$Bi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $2d2a9b09a68bd399$var$ri(), b = $2d2a9b09a68bd399$var$Q.identifierPrefix;
        if ($2d2a9b09a68bd399$var$J) {
            var c = $2d2a9b09a68bd399$var$Gg;
            var d = $2d2a9b09a68bd399$var$Fg;
            c = (d & ~(1 << 32 - $2d2a9b09a68bd399$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $2d2a9b09a68bd399$var$ii++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $2d2a9b09a68bd399$var$ji++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $2d2a9b09a68bd399$var$ni = {
    readContext: $2d2a9b09a68bd399$var$ih,
    useCallback: $2d2a9b09a68bd399$var$Si,
    useContext: $2d2a9b09a68bd399$var$ih,
    useEffect: $2d2a9b09a68bd399$var$yi,
    useImperativeHandle: $2d2a9b09a68bd399$var$Qi,
    useInsertionEffect: $2d2a9b09a68bd399$var$Ni,
    useLayoutEffect: $2d2a9b09a68bd399$var$Oi,
    useMemo: $2d2a9b09a68bd399$var$Ti,
    useReducer: $2d2a9b09a68bd399$var$ui,
    useRef: $2d2a9b09a68bd399$var$Ji,
    useState: function() {
        return $2d2a9b09a68bd399$var$ui($2d2a9b09a68bd399$var$ti);
    },
    useDebugValue: $2d2a9b09a68bd399$var$Ri,
    useDeferredValue: function(a) {
        var b = $2d2a9b09a68bd399$var$si();
        return $2d2a9b09a68bd399$var$Ui(b, $2d2a9b09a68bd399$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2d2a9b09a68bd399$var$ui($2d2a9b09a68bd399$var$ti)[0], b = $2d2a9b09a68bd399$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2d2a9b09a68bd399$var$wi,
    useSyncExternalStore: $2d2a9b09a68bd399$var$xi,
    useId: $2d2a9b09a68bd399$var$Wi,
    unstable_isNewReconciler: !1
}, $2d2a9b09a68bd399$var$oi = {
    readContext: $2d2a9b09a68bd399$var$ih,
    useCallback: $2d2a9b09a68bd399$var$Si,
    useContext: $2d2a9b09a68bd399$var$ih,
    useEffect: $2d2a9b09a68bd399$var$yi,
    useImperativeHandle: $2d2a9b09a68bd399$var$Qi,
    useInsertionEffect: $2d2a9b09a68bd399$var$Ni,
    useLayoutEffect: $2d2a9b09a68bd399$var$Oi,
    useMemo: $2d2a9b09a68bd399$var$Ti,
    useReducer: $2d2a9b09a68bd399$var$vi,
    useRef: $2d2a9b09a68bd399$var$Ji,
    useState: function() {
        return $2d2a9b09a68bd399$var$vi($2d2a9b09a68bd399$var$ti);
    },
    useDebugValue: $2d2a9b09a68bd399$var$Ri,
    useDeferredValue: function(a) {
        var b = $2d2a9b09a68bd399$var$si();
        return null === $2d2a9b09a68bd399$var$N ? b.memoizedState = a : $2d2a9b09a68bd399$var$Ui(b, $2d2a9b09a68bd399$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $2d2a9b09a68bd399$var$vi($2d2a9b09a68bd399$var$ti)[0], b = $2d2a9b09a68bd399$var$si().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $2d2a9b09a68bd399$var$wi,
    useSyncExternalStore: $2d2a9b09a68bd399$var$xi,
    useId: $2d2a9b09a68bd399$var$Wi,
    unstable_isNewReconciler: !1
}, $2d2a9b09a68bd399$var$aj = $gg6CF.unstable_now, $2d2a9b09a68bd399$var$bj = 0, $2d2a9b09a68bd399$var$cj = -1, $2d2a9b09a68bd399$var$dj = -1, $2d2a9b09a68bd399$var$ej = -1, $2d2a9b09a68bd399$var$fj = !1, $2d2a9b09a68bd399$var$gj = !1;
function $2d2a9b09a68bd399$var$hj(a, b) {
    if (0 <= $2d2a9b09a68bd399$var$dj) {
        var c = $2d2a9b09a68bd399$var$aj() - $2d2a9b09a68bd399$var$dj;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $2d2a9b09a68bd399$var$dj = -1;
    }
}
function $2d2a9b09a68bd399$var$ij(a) {
    if (0 <= $2d2a9b09a68bd399$var$cj) {
        var b = $2d2a9b09a68bd399$var$aj() - $2d2a9b09a68bd399$var$cj;
        $2d2a9b09a68bd399$var$cj = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $2d2a9b09a68bd399$var$jj(a) {
    if (0 <= $2d2a9b09a68bd399$var$ej) {
        var b = $2d2a9b09a68bd399$var$aj() - $2d2a9b09a68bd399$var$ej;
        $2d2a9b09a68bd399$var$ej = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $2d2a9b09a68bd399$var$kj() {
    $2d2a9b09a68bd399$var$cj = $2d2a9b09a68bd399$var$aj();
}
function $2d2a9b09a68bd399$var$lj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $2d2a9b09a68bd399$var$mj(a, b) {
    try {
        var c = "", d = b;
        do c += $2d2a9b09a68bd399$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $2d2a9b09a68bd399$var$nj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $2d2a9b09a68bd399$var$oj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $2d2a9b09a68bd399$var$pj = "function" === typeof WeakMap ? WeakMap : Map;
function $2d2a9b09a68bd399$var$qj(a, b, c) {
    c = $2d2a9b09a68bd399$var$qh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $2d2a9b09a68bd399$var$rj || ($2d2a9b09a68bd399$var$rj = !0, $2d2a9b09a68bd399$var$sj = d);
        $2d2a9b09a68bd399$var$oj(a, b);
    };
    return c;
}
function $2d2a9b09a68bd399$var$tj(a, b, c) {
    c = $2d2a9b09a68bd399$var$qh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $2d2a9b09a68bd399$var$oj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $2d2a9b09a68bd399$var$oj(a, b);
        "function" !== typeof d && (null === $2d2a9b09a68bd399$var$uj ? $2d2a9b09a68bd399$var$uj = new Set([
            this
        ]) : $2d2a9b09a68bd399$var$uj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $2d2a9b09a68bd399$var$vj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $2d2a9b09a68bd399$var$pj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $2d2a9b09a68bd399$var$wj.bind(null, a, b, c), $2d2a9b09a68bd399$var$mc && $2d2a9b09a68bd399$var$xj(a, c), b.then(d, d));
}
function $2d2a9b09a68bd399$var$yj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $2d2a9b09a68bd399$var$zj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $2d2a9b09a68bd399$var$qh(-1, 1), b.tag = 2, $2d2a9b09a68bd399$var$rh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $2d2a9b09a68bd399$var$Aj = $2d2a9b09a68bd399$var$va.ReactCurrentOwner, $2d2a9b09a68bd399$var$hh = !1;
function $2d2a9b09a68bd399$var$Bj(a, b, c, d) {
    b.child = null === a ? $2d2a9b09a68bd399$var$Rh(b, null, c, d) : $2d2a9b09a68bd399$var$Qh(b, a.child, c, d);
}
function $2d2a9b09a68bd399$var$Cj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $2d2a9b09a68bd399$var$gh(b, e);
    $2d2a9b09a68bd399$var$sc(b);
    d = $2d2a9b09a68bd399$var$li(a, b, c, d, f, e);
    c = $2d2a9b09a68bd399$var$qi();
    $2d2a9b09a68bd399$var$tc();
    if (null !== a && !$2d2a9b09a68bd399$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2d2a9b09a68bd399$var$Dj(a, b, e);
    $2d2a9b09a68bd399$var$J && c && $2d2a9b09a68bd399$var$Jg(b);
    b.flags |= 1;
    $2d2a9b09a68bd399$var$Bj(a, b, d, e);
    return b.child;
}
function $2d2a9b09a68bd399$var$Ej(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$2d2a9b09a68bd399$var$Fj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $2d2a9b09a68bd399$var$Gj(a, b, f, d, e);
        a = $2d2a9b09a68bd399$var$Nh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $2d2a9b09a68bd399$var$We;
        if (c(g, d) && a.ref === b.ref) return $2d2a9b09a68bd399$var$Dj(a, b, e);
    }
    b.flags |= 1;
    a = $2d2a9b09a68bd399$var$Lh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $2d2a9b09a68bd399$var$Gj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($2d2a9b09a68bd399$var$We(f, d) && a.ref === b.ref) {
            if ($2d2a9b09a68bd399$var$hh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($2d2a9b09a68bd399$var$hh = !0);
            else return b.lanes = a.lanes, $2d2a9b09a68bd399$var$Dj(a, b, e);
        }
    }
    return $2d2a9b09a68bd399$var$Hj(a, b, c, d, e);
}
function $2d2a9b09a68bd399$var$Ij(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Jj, $2d2a9b09a68bd399$var$Kj), $2d2a9b09a68bd399$var$Kj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Jj, $2d2a9b09a68bd399$var$Kj), $2d2a9b09a68bd399$var$Kj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Jj, $2d2a9b09a68bd399$var$Kj);
            $2d2a9b09a68bd399$var$Kj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$Jj, $2d2a9b09a68bd399$var$Kj), $2d2a9b09a68bd399$var$Kj |= d;
    $2d2a9b09a68bd399$var$Bj(a, b, e, c);
    return b.child;
}
function $2d2a9b09a68bd399$var$Lj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $2d2a9b09a68bd399$var$Hj(a, b, c, d, e) {
    var f = $2d2a9b09a68bd399$var$mg(c) ? $2d2a9b09a68bd399$var$kg : $2d2a9b09a68bd399$var$I.current;
    f = $2d2a9b09a68bd399$var$lg(b, f);
    $2d2a9b09a68bd399$var$gh(b, e);
    $2d2a9b09a68bd399$var$sc(b);
    c = $2d2a9b09a68bd399$var$li(a, b, c, d, f, e);
    d = $2d2a9b09a68bd399$var$qi();
    $2d2a9b09a68bd399$var$tc();
    if (null !== a && !$2d2a9b09a68bd399$var$hh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $2d2a9b09a68bd399$var$Dj(a, b, e);
    $2d2a9b09a68bd399$var$J && d && $2d2a9b09a68bd399$var$Jg(b);
    b.flags |= 1;
    $2d2a9b09a68bd399$var$Bj(a, b, c, e);
    return b.child;
}
function $2d2a9b09a68bd399$var$Mj(a, b, c, d, e) {
    if ($2d2a9b09a68bd399$var$mg(c)) {
        var f = !0;
        $2d2a9b09a68bd399$var$qg(b);
    } else f = !1;
    $2d2a9b09a68bd399$var$gh(b, e);
    if (null === b.stateNode) $2d2a9b09a68bd399$var$Nj(a, b), $2d2a9b09a68bd399$var$Eh(b, c, d), $2d2a9b09a68bd399$var$Gh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $2d2a9b09a68bd399$var$ih(l) : (l = $2d2a9b09a68bd399$var$mg(c) ? $2d2a9b09a68bd399$var$kg : $2d2a9b09a68bd399$var$I.current, l = $2d2a9b09a68bd399$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $2d2a9b09a68bd399$var$Fh(b, g, d, l);
        $2d2a9b09a68bd399$var$nh = !1;
        var r = b.memoizedState;
        g.state = r;
        $2d2a9b09a68bd399$var$uh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $2d2a9b09a68bd399$var$jg.current || $2d2a9b09a68bd399$var$nh ? ("function" === typeof n && ($2d2a9b09a68bd399$var$yh(b, c, n, d), k = b.memoizedState), (h = $2d2a9b09a68bd399$var$nh || $2d2a9b09a68bd399$var$Dh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $2d2a9b09a68bd399$var$ph(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $2d2a9b09a68bd399$var$Zg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $2d2a9b09a68bd399$var$ih(k) : (k = $2d2a9b09a68bd399$var$mg(c) ? $2d2a9b09a68bd399$var$kg : $2d2a9b09a68bd399$var$I.current, k = $2d2a9b09a68bd399$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $2d2a9b09a68bd399$var$Fh(b, g, d, k);
        $2d2a9b09a68bd399$var$nh = !1;
        r = b.memoizedState;
        g.state = r;
        $2d2a9b09a68bd399$var$uh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $2d2a9b09a68bd399$var$jg.current || $2d2a9b09a68bd399$var$nh ? ("function" === typeof z && ($2d2a9b09a68bd399$var$yh(b, c, z, d), m = b.memoizedState), (l = $2d2a9b09a68bd399$var$nh || $2d2a9b09a68bd399$var$Dh(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $2d2a9b09a68bd399$var$Oj(a, b, c, d, f, e);
}
function $2d2a9b09a68bd399$var$Oj(a, b, c, d, e, f) {
    $2d2a9b09a68bd399$var$Lj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $2d2a9b09a68bd399$var$rg(b, c, !1), $2d2a9b09a68bd399$var$Dj(a, b, f);
    d = b.stateNode;
    $2d2a9b09a68bd399$var$Aj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $2d2a9b09a68bd399$var$dj = -1;
    } else $2d2a9b09a68bd399$var$sc(b), h = d.render(), $2d2a9b09a68bd399$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $2d2a9b09a68bd399$var$Qh(b, a.child, null, f), b.child = $2d2a9b09a68bd399$var$Qh(b, null, g, f)) : $2d2a9b09a68bd399$var$Bj(a, b, h, f);
    b.memoizedState = d.state;
    e && $2d2a9b09a68bd399$var$rg(b, c, !0);
    return b.child;
}
function $2d2a9b09a68bd399$var$Pj(a) {
    var b = a.stateNode;
    b.pendingContext ? $2d2a9b09a68bd399$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $2d2a9b09a68bd399$var$og(a, b.context, !1);
    $2d2a9b09a68bd399$var$Xh(a, b.containerInfo);
}
function $2d2a9b09a68bd399$var$Qj(a, b, c, d, e) {
    $2d2a9b09a68bd399$var$Wg();
    $2d2a9b09a68bd399$var$Xg(e);
    b.flags |= 256;
    $2d2a9b09a68bd399$var$Bj(a, b, c, d);
    return b.child;
}
var $2d2a9b09a68bd399$var$Tj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $2d2a9b09a68bd399$var$Uj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $2d2a9b09a68bd399$var$Vj(a, b, c) {
    var d = b.pendingProps, e = $2d2a9b09a68bd399$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, e & 1);
    if (null === a) {
        $2d2a9b09a68bd399$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $2d2a9b09a68bd399$var$Wj(g, d, 0, null), a = $2d2a9b09a68bd399$var$Ph(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $2d2a9b09a68bd399$var$Uj(c), b.memoizedState = $2d2a9b09a68bd399$var$Tj, a) : $2d2a9b09a68bd399$var$Xj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $2d2a9b09a68bd399$var$Yj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $2d2a9b09a68bd399$var$Lh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $2d2a9b09a68bd399$var$Lh(h, f) : (f = $2d2a9b09a68bd399$var$Ph(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $2d2a9b09a68bd399$var$Uj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $2d2a9b09a68bd399$var$Tj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $2d2a9b09a68bd399$var$Lh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $2d2a9b09a68bd399$var$Xj(a, b) {
    b = $2d2a9b09a68bd399$var$Wj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $2d2a9b09a68bd399$var$Zj(a, b, c, d) {
    null !== d && $2d2a9b09a68bd399$var$Xg(d);
    $2d2a9b09a68bd399$var$Qh(b, a.child, null, c);
    a = $2d2a9b09a68bd399$var$Xj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $2d2a9b09a68bd399$var$Yj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $2d2a9b09a68bd399$var$nj(Error($2d2a9b09a68bd399$var$p(422))), $2d2a9b09a68bd399$var$Zj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $2d2a9b09a68bd399$var$Wj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $2d2a9b09a68bd399$var$Ph(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $2d2a9b09a68bd399$var$Qh(b, a.child, null, g);
        b.child.memoizedState = $2d2a9b09a68bd399$var$Uj(g);
        b.memoizedState = $2d2a9b09a68bd399$var$Tj;
        return f;
    }
    if (0 === (b.mode & 1)) return $2d2a9b09a68bd399$var$Zj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($2d2a9b09a68bd399$var$p(419));
        d = $2d2a9b09a68bd399$var$nj(f, d, void 0);
        return $2d2a9b09a68bd399$var$Zj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($2d2a9b09a68bd399$var$hh || h) {
        d = $2d2a9b09a68bd399$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $2d2a9b09a68bd399$var$mh(a, e), $2d2a9b09a68bd399$var$Bh(d, a, e, -1));
        }
        $2d2a9b09a68bd399$var$ak();
        d = $2d2a9b09a68bd399$var$nj(Error($2d2a9b09a68bd399$var$p(421)));
        return $2d2a9b09a68bd399$var$Zj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $2d2a9b09a68bd399$var$bk.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Zf(e.nextSibling);
    $2d2a9b09a68bd399$var$Lg = b;
    $2d2a9b09a68bd399$var$J = !0;
    $2d2a9b09a68bd399$var$Ng = null;
    null !== a && ($2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Fg, $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Gg, $2d2a9b09a68bd399$var$Cg[$2d2a9b09a68bd399$var$Dg++] = $2d2a9b09a68bd399$var$Eg, $2d2a9b09a68bd399$var$Fg = a.id, $2d2a9b09a68bd399$var$Gg = a.overflow, $2d2a9b09a68bd399$var$Eg = b);
    b = $2d2a9b09a68bd399$var$Xj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $2d2a9b09a68bd399$var$ck(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $2d2a9b09a68bd399$var$fh(a.return, b, c);
}
function $2d2a9b09a68bd399$var$dk(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $2d2a9b09a68bd399$var$ek(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $2d2a9b09a68bd399$var$Bj(a, b, d.children, c);
    d = $2d2a9b09a68bd399$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $2d2a9b09a68bd399$var$ck(a, c, b);
            else if (19 === a.tag) $2d2a9b09a68bd399$var$ck(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $2d2a9b09a68bd399$var$ai(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $2d2a9b09a68bd399$var$dk(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $2d2a9b09a68bd399$var$ai(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $2d2a9b09a68bd399$var$dk(b, !0, c, null, f);
            break;
        case "together":
            $2d2a9b09a68bd399$var$dk(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $2d2a9b09a68bd399$var$Nj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $2d2a9b09a68bd399$var$Dj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $2d2a9b09a68bd399$var$dj = -1;
    $2d2a9b09a68bd399$var$vh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($2d2a9b09a68bd399$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $2d2a9b09a68bd399$var$Lh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $2d2a9b09a68bd399$var$Lh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $2d2a9b09a68bd399$var$fk(a, b, c) {
    switch(b.tag){
        case 3:
            $2d2a9b09a68bd399$var$Pj(b);
            $2d2a9b09a68bd399$var$Wg();
            break;
        case 5:
            $2d2a9b09a68bd399$var$Zh(b);
            break;
        case 1:
            $2d2a9b09a68bd399$var$mg(b.type) && $2d2a9b09a68bd399$var$qg(b);
            break;
        case 4:
            $2d2a9b09a68bd399$var$Xh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$$g, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, $2d2a9b09a68bd399$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $2d2a9b09a68bd399$var$Vj(a, b, c);
                $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, $2d2a9b09a68bd399$var$L.current & 1);
                a = $2d2a9b09a68bd399$var$Dj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, $2d2a9b09a68bd399$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $2d2a9b09a68bd399$var$ek(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, $2d2a9b09a68bd399$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $2d2a9b09a68bd399$var$Ij(a, b, c);
    }
    return $2d2a9b09a68bd399$var$Dj(a, b, c);
}
var $2d2a9b09a68bd399$var$gk, $2d2a9b09a68bd399$var$hk, $2d2a9b09a68bd399$var$ik, $2d2a9b09a68bd399$var$jk;
$2d2a9b09a68bd399$var$gk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$2d2a9b09a68bd399$var$hk = function() {};
$2d2a9b09a68bd399$var$ik = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Th.current);
        var f = null;
        switch(c){
            case "input":
                e = $2d2a9b09a68bd399$var$Ya(a, e);
                d = $2d2a9b09a68bd399$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $2d2a9b09a68bd399$var$u({}, e, {
                    value: void 0
                });
                d = $2d2a9b09a68bd399$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $2d2a9b09a68bd399$var$fb(a, e);
                d = $2d2a9b09a68bd399$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $2d2a9b09a68bd399$var$Pf);
        }
        $2d2a9b09a68bd399$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($2d2a9b09a68bd399$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($2d2a9b09a68bd399$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $2d2a9b09a68bd399$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$2d2a9b09a68bd399$var$jk = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $2d2a9b09a68bd399$var$kk(a, b) {
    if (!$2d2a9b09a68bd399$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $2d2a9b09a68bd399$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $2d2a9b09a68bd399$var$lk(a, b, c) {
    var d = b.pendingProps;
    $2d2a9b09a68bd399$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2d2a9b09a68bd399$var$S(b), null;
        case 1:
            return $2d2a9b09a68bd399$var$mg(b.type) && $2d2a9b09a68bd399$var$ng(), $2d2a9b09a68bd399$var$S(b), null;
        case 3:
            d = b.stateNode;
            $2d2a9b09a68bd399$var$Yh();
            $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg);
            $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$I);
            $2d2a9b09a68bd399$var$ci();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $2d2a9b09a68bd399$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $2d2a9b09a68bd399$var$Ng && ($2d2a9b09a68bd399$var$mk($2d2a9b09a68bd399$var$Ng), $2d2a9b09a68bd399$var$Ng = null));
            $2d2a9b09a68bd399$var$hk(a, b);
            $2d2a9b09a68bd399$var$S(b);
            return null;
        case 5:
            $2d2a9b09a68bd399$var$$h(b);
            var e = $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Vh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $2d2a9b09a68bd399$var$ik(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($2d2a9b09a68bd399$var$p(166));
                    $2d2a9b09a68bd399$var$S(b);
                    return null;
                }
                a = $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Th.current);
                if ($2d2a9b09a68bd399$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$2d2a9b09a68bd399$var$bg] = b;
                    d[$2d2a9b09a68bd399$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $2d2a9b09a68bd399$var$F("cancel", d);
                            $2d2a9b09a68bd399$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $2d2a9b09a68bd399$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $2d2a9b09a68bd399$var$zf.length; e++)$2d2a9b09a68bd399$var$F($2d2a9b09a68bd399$var$zf[e], d);
                            break;
                        case "source":
                            $2d2a9b09a68bd399$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $2d2a9b09a68bd399$var$F("error", d);
                            $2d2a9b09a68bd399$var$F("load", d);
                            break;
                        case "details":
                            $2d2a9b09a68bd399$var$F("toggle", d);
                            break;
                        case "input":
                            $2d2a9b09a68bd399$var$Za(d, c);
                            $2d2a9b09a68bd399$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $2d2a9b09a68bd399$var$F("invalid", d);
                            break;
                        case "textarea":
                            $2d2a9b09a68bd399$var$gb(d, c), $2d2a9b09a68bd399$var$F("invalid", d);
                    }
                    $2d2a9b09a68bd399$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $2d2a9b09a68bd399$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $2d2a9b09a68bd399$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $2d2a9b09a68bd399$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $2d2a9b09a68bd399$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $2d2a9b09a68bd399$var$Va(d);
                            $2d2a9b09a68bd399$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $2d2a9b09a68bd399$var$Va(d);
                            $2d2a9b09a68bd399$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $2d2a9b09a68bd399$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $2d2a9b09a68bd399$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$2d2a9b09a68bd399$var$bg] = b;
                    a[$2d2a9b09a68bd399$var$cg] = d;
                    $2d2a9b09a68bd399$var$gk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $2d2a9b09a68bd399$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $2d2a9b09a68bd399$var$F("cancel", a);
                                $2d2a9b09a68bd399$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $2d2a9b09a68bd399$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $2d2a9b09a68bd399$var$zf.length; e++)$2d2a9b09a68bd399$var$F($2d2a9b09a68bd399$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $2d2a9b09a68bd399$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $2d2a9b09a68bd399$var$F("error", a);
                                $2d2a9b09a68bd399$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $2d2a9b09a68bd399$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $2d2a9b09a68bd399$var$Za(a, d);
                                e = $2d2a9b09a68bd399$var$Ya(a, d);
                                $2d2a9b09a68bd399$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $2d2a9b09a68bd399$var$u({}, d, {
                                    value: void 0
                                });
                                $2d2a9b09a68bd399$var$F("invalid", a);
                                break;
                            case "textarea":
                                $2d2a9b09a68bd399$var$gb(a, d);
                                e = $2d2a9b09a68bd399$var$fb(a, d);
                                $2d2a9b09a68bd399$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $2d2a9b09a68bd399$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $2d2a9b09a68bd399$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $2d2a9b09a68bd399$var$mb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $2d2a9b09a68bd399$var$nb(a, k) : "number" === typeof k && $2d2a9b09a68bd399$var$nb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($2d2a9b09a68bd399$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $2d2a9b09a68bd399$var$F("scroll", a) : null != k && $2d2a9b09a68bd399$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $2d2a9b09a68bd399$var$Va(a);
                                $2d2a9b09a68bd399$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $2d2a9b09a68bd399$var$Va(a);
                                $2d2a9b09a68bd399$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $2d2a9b09a68bd399$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $2d2a9b09a68bd399$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $2d2a9b09a68bd399$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $2d2a9b09a68bd399$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $2d2a9b09a68bd399$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $2d2a9b09a68bd399$var$jk(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($2d2a9b09a68bd399$var$p(166));
                a = $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Vh.current);
                $2d2a9b09a68bd399$var$Wh($2d2a9b09a68bd399$var$Th.current);
                if ($2d2a9b09a68bd399$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$2d2a9b09a68bd399$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $2d2a9b09a68bd399$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $2d2a9b09a68bd399$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $2d2a9b09a68bd399$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$2d2a9b09a68bd399$var$bg] = b, b.stateNode = d;
            }
            $2d2a9b09a68bd399$var$S(b);
            return null;
        case 13:
            $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($2d2a9b09a68bd399$var$J && null !== $2d2a9b09a68bd399$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $2d2a9b09a68bd399$var$Vg(), $2d2a9b09a68bd399$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $2d2a9b09a68bd399$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($2d2a9b09a68bd399$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($2d2a9b09a68bd399$var$p(317));
                        f[$2d2a9b09a68bd399$var$bg] = b;
                        $2d2a9b09a68bd399$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $2d2a9b09a68bd399$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $2d2a9b09a68bd399$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $2d2a9b09a68bd399$var$Ng && ($2d2a9b09a68bd399$var$mk($2d2a9b09a68bd399$var$Ng), $2d2a9b09a68bd399$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $2d2a9b09a68bd399$var$lj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($2d2a9b09a68bd399$var$L.current & 1) ? 0 === $2d2a9b09a68bd399$var$T && ($2d2a9b09a68bd399$var$T = 3) : $2d2a9b09a68bd399$var$ak()));
            null !== b.updateQueue && (b.flags |= 4);
            $2d2a9b09a68bd399$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $2d2a9b09a68bd399$var$Yh(), $2d2a9b09a68bd399$var$hk(a, b), null === a && $2d2a9b09a68bd399$var$Gf(b.stateNode.containerInfo), $2d2a9b09a68bd399$var$S(b), null;
        case 10:
            return $2d2a9b09a68bd399$var$eh(b.type._context), $2d2a9b09a68bd399$var$S(b), null;
        case 17:
            return $2d2a9b09a68bd399$var$mg(b.type) && $2d2a9b09a68bd399$var$ng(), $2d2a9b09a68bd399$var$S(b), null;
        case 19:
            $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L);
            f = b.memoizedState;
            if (null === f) return $2d2a9b09a68bd399$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $2d2a9b09a68bd399$var$kk(f, !1);
                else {
                    if (0 !== $2d2a9b09a68bd399$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $2d2a9b09a68bd399$var$ai(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $2d2a9b09a68bd399$var$kk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, $2d2a9b09a68bd399$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $2d2a9b09a68bd399$var$A() > $2d2a9b09a68bd399$var$nk && (b.flags |= 128, d = !0, $2d2a9b09a68bd399$var$kk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $2d2a9b09a68bd399$var$ai(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $2d2a9b09a68bd399$var$kk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$2d2a9b09a68bd399$var$J) return $2d2a9b09a68bd399$var$S(b), null;
                    } else 2 * $2d2a9b09a68bd399$var$A() - f.renderingStartTime > $2d2a9b09a68bd399$var$nk && 1073741824 !== c && (b.flags |= 128, d = !0, $2d2a9b09a68bd399$var$kk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $2d2a9b09a68bd399$var$A(), b.sibling = null, a = $2d2a9b09a68bd399$var$L.current, $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$L, d ? a & 1 | 2 : a & 1), b;
            $2d2a9b09a68bd399$var$S(b);
            return null;
        case 22:
        case 23:
            return $2d2a9b09a68bd399$var$ok(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($2d2a9b09a68bd399$var$Kj & 1073741824) && ($2d2a9b09a68bd399$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $2d2a9b09a68bd399$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($2d2a9b09a68bd399$var$p(156, b.tag));
}
function $2d2a9b09a68bd399$var$pk(a, b) {
    $2d2a9b09a68bd399$var$Kg(b);
    switch(b.tag){
        case 1:
            return $2d2a9b09a68bd399$var$mg(b.type) && $2d2a9b09a68bd399$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $2d2a9b09a68bd399$var$lj(b), b) : null;
        case 3:
            return $2d2a9b09a68bd399$var$Yh(), $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg), $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$I), $2d2a9b09a68bd399$var$ci(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $2d2a9b09a68bd399$var$$h(b), null;
        case 13:
            $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($2d2a9b09a68bd399$var$p(340));
                $2d2a9b09a68bd399$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $2d2a9b09a68bd399$var$lj(b), b) : null;
        case 19:
            return $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L), null;
        case 4:
            return $2d2a9b09a68bd399$var$Yh(), null;
        case 10:
            return $2d2a9b09a68bd399$var$eh(b.type._context), null;
        case 22:
        case 23:
            return $2d2a9b09a68bd399$var$ok(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $2d2a9b09a68bd399$var$qk = !1, $2d2a9b09a68bd399$var$rk = !1, $2d2a9b09a68bd399$var$sk = "function" === typeof WeakSet ? WeakSet : Set, $2d2a9b09a68bd399$var$U = null, $2d2a9b09a68bd399$var$tk = null, $2d2a9b09a68bd399$var$uk = null;
function $2d2a9b09a68bd399$var$vk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $2d2a9b09a68bd399$var$kj(), b.componentWillUnmount();
    } finally{
        $2d2a9b09a68bd399$var$ij(a);
    }
    else b.componentWillUnmount();
}
function $2d2a9b09a68bd399$var$wk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $2d2a9b09a68bd399$var$kj(), c(null);
            } finally{
                $2d2a9b09a68bd399$var$ij(a);
            }
            else c(null);
        } catch (d) {
            $2d2a9b09a68bd399$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $2d2a9b09a68bd399$var$xk(a, b, c) {
    try {
        c();
    } catch (d) {
        $2d2a9b09a68bd399$var$W(a, b, d);
    }
}
var $2d2a9b09a68bd399$var$yk = !1;
function $2d2a9b09a68bd399$var$zk(a, b) {
    $2d2a9b09a68bd399$var$Qf = $2d2a9b09a68bd399$var$rd;
    a = $2d2a9b09a68bd399$var$$e();
    if ($2d2a9b09a68bd399$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $2d2a9b09a68bd399$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $2d2a9b09a68bd399$var$rd = !1;
    for($2d2a9b09a68bd399$var$U = b; null !== $2d2a9b09a68bd399$var$U;)if (b = $2d2a9b09a68bd399$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $2d2a9b09a68bd399$var$U = a;
    else for(; null !== $2d2a9b09a68bd399$var$U;){
        b = $2d2a9b09a68bd399$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $2d2a9b09a68bd399$var$Zg(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($2d2a9b09a68bd399$var$p(163));
            }
        } catch (D) {
            $2d2a9b09a68bd399$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $2d2a9b09a68bd399$var$U = a;
            break;
        }
        $2d2a9b09a68bd399$var$U = b.return;
    }
    m = $2d2a9b09a68bd399$var$yk;
    $2d2a9b09a68bd399$var$yk = !1;
    return m;
}
function $2d2a9b09a68bd399$var$Ak(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentPassiveEffectUnmountStarted && $2d2a9b09a68bd399$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $2d2a9b09a68bd399$var$uc(b), $2d2a9b09a68bd399$var$xk(b, c, f), 0 !== (a & 8) ? null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentPassiveEffectUnmountStopped && $2d2a9b09a68bd399$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $2d2a9b09a68bd399$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $2d2a9b09a68bd399$var$Bk(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentPassiveEffectMountStarted && $2d2a9b09a68bd399$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentLayoutEffectMountStarted && $2d2a9b09a68bd399$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentPassiveEffectMountStopped && $2d2a9b09a68bd399$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentLayoutEffectMountStopped && $2d2a9b09a68bd399$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $2d2a9b09a68bd399$var$Ck(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $2d2a9b09a68bd399$var$kj(), b(c);
            } finally{
                $2d2a9b09a68bd399$var$ij(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $2d2a9b09a68bd399$var$Dk(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $2d2a9b09a68bd399$var$Dk(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$2d2a9b09a68bd399$var$bg], delete b[$2d2a9b09a68bd399$var$cg], delete b[$2d2a9b09a68bd399$var$Cf], delete b[$2d2a9b09a68bd399$var$dg], delete b[$2d2a9b09a68bd399$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $2d2a9b09a68bd399$var$Ek(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $2d2a9b09a68bd399$var$Fk(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $2d2a9b09a68bd399$var$Ek(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $2d2a9b09a68bd399$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $2d2a9b09a68bd399$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($2d2a9b09a68bd399$var$Gk(a, b, c), a = a.sibling; null !== a;)$2d2a9b09a68bd399$var$Gk(a, b, c), a = a.sibling;
}
function $2d2a9b09a68bd399$var$Hk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($2d2a9b09a68bd399$var$Hk(a, b, c), a = a.sibling; null !== a;)$2d2a9b09a68bd399$var$Hk(a, b, c), a = a.sibling;
}
var $2d2a9b09a68bd399$var$X = null, $2d2a9b09a68bd399$var$Ik = !1;
function $2d2a9b09a68bd399$var$Jk(a, b, c) {
    for(c = c.child; null !== c;)$2d2a9b09a68bd399$var$Kk(a, b, c), c = c.sibling;
}
function $2d2a9b09a68bd399$var$Kk(a, b, c) {
    if ($2d2a9b09a68bd399$var$lc && "function" === typeof $2d2a9b09a68bd399$var$lc.onCommitFiberUnmount) try {
        $2d2a9b09a68bd399$var$lc.onCommitFiberUnmount($2d2a9b09a68bd399$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $2d2a9b09a68bd399$var$rk || $2d2a9b09a68bd399$var$wk(c, b);
        case 6:
            var d = $2d2a9b09a68bd399$var$X, e = $2d2a9b09a68bd399$var$Ik;
            $2d2a9b09a68bd399$var$X = null;
            $2d2a9b09a68bd399$var$Jk(a, b, c);
            $2d2a9b09a68bd399$var$X = d;
            $2d2a9b09a68bd399$var$Ik = e;
            null !== $2d2a9b09a68bd399$var$X && ($2d2a9b09a68bd399$var$Ik ? (a = $2d2a9b09a68bd399$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $2d2a9b09a68bd399$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $2d2a9b09a68bd399$var$X && ($2d2a9b09a68bd399$var$Ik ? (a = $2d2a9b09a68bd399$var$X, c = c.stateNode, 8 === a.nodeType ? $2d2a9b09a68bd399$var$Yf(a.parentNode, c) : 1 === a.nodeType && $2d2a9b09a68bd399$var$Yf(a, c), $2d2a9b09a68bd399$var$pd(a)) : $2d2a9b09a68bd399$var$Yf($2d2a9b09a68bd399$var$X, c.stateNode));
            break;
        case 4:
            d = $2d2a9b09a68bd399$var$X;
            e = $2d2a9b09a68bd399$var$Ik;
            $2d2a9b09a68bd399$var$X = c.stateNode.containerInfo;
            $2d2a9b09a68bd399$var$Ik = !0;
            $2d2a9b09a68bd399$var$Jk(a, b, c);
            $2d2a9b09a68bd399$var$X = d;
            $2d2a9b09a68bd399$var$Ik = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$2d2a9b09a68bd399$var$rk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $2d2a9b09a68bd399$var$xk(c, b, g) : 0 !== (f & 4) && ($2d2a9b09a68bd399$var$uc(c), c.mode & 2 ? ($2d2a9b09a68bd399$var$kj(), $2d2a9b09a68bd399$var$xk(c, b, g), $2d2a9b09a68bd399$var$ij(c)) : $2d2a9b09a68bd399$var$xk(c, b, g), $2d2a9b09a68bd399$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $2d2a9b09a68bd399$var$Jk(a, b, c);
            break;
        case 1:
            if (!$2d2a9b09a68bd399$var$rk && ($2d2a9b09a68bd399$var$wk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $2d2a9b09a68bd399$var$vk(c, d);
            } catch (h) {
                $2d2a9b09a68bd399$var$W(c, b, h);
            }
            $2d2a9b09a68bd399$var$Jk(a, b, c);
            break;
        case 21:
            $2d2a9b09a68bd399$var$Jk(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($2d2a9b09a68bd399$var$rk = (d = $2d2a9b09a68bd399$var$rk) || null !== c.memoizedState, $2d2a9b09a68bd399$var$Jk(a, b, c), $2d2a9b09a68bd399$var$rk = d) : $2d2a9b09a68bd399$var$Jk(a, b, c);
            break;
        default:
            $2d2a9b09a68bd399$var$Jk(a, b, c);
    }
}
function $2d2a9b09a68bd399$var$Lk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $2d2a9b09a68bd399$var$sk);
        b.forEach(function(b) {
            var d = $2d2a9b09a68bd399$var$Mk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($2d2a9b09a68bd399$var$mc) {
                    if (null !== $2d2a9b09a68bd399$var$tk && null !== $2d2a9b09a68bd399$var$uk) $2d2a9b09a68bd399$var$xj($2d2a9b09a68bd399$var$uk, $2d2a9b09a68bd399$var$tk);
                    else throw Error($2d2a9b09a68bd399$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $2d2a9b09a68bd399$var$Nk(a, b, c) {
    $2d2a9b09a68bd399$var$tk = c;
    $2d2a9b09a68bd399$var$uk = a;
    $2d2a9b09a68bd399$var$Ok(b, a);
    $2d2a9b09a68bd399$var$uk = $2d2a9b09a68bd399$var$tk = null;
}
function $2d2a9b09a68bd399$var$Pk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $2d2a9b09a68bd399$var$X = h.stateNode;
                        $2d2a9b09a68bd399$var$Ik = !1;
                        break a;
                    case 3:
                        $2d2a9b09a68bd399$var$X = h.stateNode.containerInfo;
                        $2d2a9b09a68bd399$var$Ik = !0;
                        break a;
                    case 4:
                        $2d2a9b09a68bd399$var$X = h.stateNode.containerInfo;
                        $2d2a9b09a68bd399$var$Ik = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $2d2a9b09a68bd399$var$X) throw Error($2d2a9b09a68bd399$var$p(160));
            $2d2a9b09a68bd399$var$Kk(f, g, e);
            $2d2a9b09a68bd399$var$X = null;
            $2d2a9b09a68bd399$var$Ik = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $2d2a9b09a68bd399$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$2d2a9b09a68bd399$var$Ok(b, a), b = b.sibling;
}
function $2d2a9b09a68bd399$var$Ok(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            if (d & 4) {
                try {
                    $2d2a9b09a68bd399$var$Ak(3, a, a.return), $2d2a9b09a68bd399$var$Bk(3, a);
                } catch (m) {
                    $2d2a9b09a68bd399$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $2d2a9b09a68bd399$var$kj(), $2d2a9b09a68bd399$var$Ak(5, a, a.return);
                    } catch (m) {
                        $2d2a9b09a68bd399$var$W(a, a.return, m);
                    }
                    $2d2a9b09a68bd399$var$ij(a);
                } else try {
                    $2d2a9b09a68bd399$var$Ak(5, a, a.return);
                } catch (m) {
                    $2d2a9b09a68bd399$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            d & 512 && null !== c && $2d2a9b09a68bd399$var$wk(c, c.return);
            break;
        case 5:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            d & 512 && null !== c && $2d2a9b09a68bd399$var$wk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $2d2a9b09a68bd399$var$nb(e, "");
                } catch (m) {
                    $2d2a9b09a68bd399$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $2d2a9b09a68bd399$var$$a(e, f);
                    $2d2a9b09a68bd399$var$vb(h, g);
                    var l = $2d2a9b09a68bd399$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $2d2a9b09a68bd399$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $2d2a9b09a68bd399$var$mb(e, q) : "children" === n ? $2d2a9b09a68bd399$var$nb(e, q) : $2d2a9b09a68bd399$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $2d2a9b09a68bd399$var$ab(e, f);
                            break;
                        case "textarea":
                            $2d2a9b09a68bd399$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $2d2a9b09a68bd399$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $2d2a9b09a68bd399$var$eb(e, !!f.multiple, f.defaultValue, !0) : $2d2a9b09a68bd399$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$2d2a9b09a68bd399$var$cg] = f;
                } catch (m) {
                    $2d2a9b09a68bd399$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($2d2a9b09a68bd399$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $2d2a9b09a68bd399$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $2d2a9b09a68bd399$var$pd(b.containerInfo);
            } catch (m) {
                $2d2a9b09a68bd399$var$W(a, a.return, m);
            }
            break;
        case 4:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            break;
        case 13:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($2d2a9b09a68bd399$var$Rk = $2d2a9b09a68bd399$var$A()));
            d & 4 && $2d2a9b09a68bd399$var$Lk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($2d2a9b09a68bd399$var$rk = (l = $2d2a9b09a68bd399$var$rk) || n, $2d2a9b09a68bd399$var$Pk(b, a), $2d2a9b09a68bd399$var$rk = l) : $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($2d2a9b09a68bd399$var$U = a, n = a.child; null !== n;){
                    for(q = $2d2a9b09a68bd399$var$U = n; null !== $2d2a9b09a68bd399$var$U;){
                        r = $2d2a9b09a68bd399$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $2d2a9b09a68bd399$var$kj(), $2d2a9b09a68bd399$var$Ak(4, r, r.return);
                                } finally{
                                    $2d2a9b09a68bd399$var$ij(r);
                                }
                                else $2d2a9b09a68bd399$var$Ak(4, r, r.return);
                                break;
                            case 1:
                                $2d2a9b09a68bd399$var$wk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $2d2a9b09a68bd399$var$vk(c, d);
                                    } catch (m) {
                                        $2d2a9b09a68bd399$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $2d2a9b09a68bd399$var$wk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $2d2a9b09a68bd399$var$Sk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $2d2a9b09a68bd399$var$U = z) : $2d2a9b09a68bd399$var$Sk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $2d2a9b09a68bd399$var$rb("display", g));
                            } catch (m) {
                                $2d2a9b09a68bd399$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $2d2a9b09a68bd399$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $2d2a9b09a68bd399$var$Pk(b, a);
            $2d2a9b09a68bd399$var$Qk(a);
            d & 4 && $2d2a9b09a68bd399$var$Lk(a);
            break;
        case 21:
            break;
        default:
            $2d2a9b09a68bd399$var$Pk(b, a), $2d2a9b09a68bd399$var$Qk(a);
    }
}
function $2d2a9b09a68bd399$var$Qk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($2d2a9b09a68bd399$var$Ek(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($2d2a9b09a68bd399$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($2d2a9b09a68bd399$var$nb(e, ""), d.flags &= -33);
                    var f = $2d2a9b09a68bd399$var$Fk(a);
                    $2d2a9b09a68bd399$var$Hk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $2d2a9b09a68bd399$var$Fk(a);
                    $2d2a9b09a68bd399$var$Gk(a, h, g);
                    break;
                default:
                    throw Error($2d2a9b09a68bd399$var$p(161));
            }
        } catch (k) {
            $2d2a9b09a68bd399$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $2d2a9b09a68bd399$var$Tk(a, b, c) {
    $2d2a9b09a68bd399$var$tk = c;
    $2d2a9b09a68bd399$var$uk = b;
    $2d2a9b09a68bd399$var$U = a;
    $2d2a9b09a68bd399$var$Uk(a, b, c);
    $2d2a9b09a68bd399$var$uk = $2d2a9b09a68bd399$var$tk = null;
}
function $2d2a9b09a68bd399$var$Uk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $2d2a9b09a68bd399$var$U;){
        var e = $2d2a9b09a68bd399$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $2d2a9b09a68bd399$var$qk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $2d2a9b09a68bd399$var$rk;
                h = $2d2a9b09a68bd399$var$qk;
                var l = $2d2a9b09a68bd399$var$rk;
                $2d2a9b09a68bd399$var$qk = g;
                if (($2d2a9b09a68bd399$var$rk = k) && !l) for($2d2a9b09a68bd399$var$U = e; null !== $2d2a9b09a68bd399$var$U;)g = $2d2a9b09a68bd399$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $2d2a9b09a68bd399$var$Vk(e) : null !== k ? (k.return = g, $2d2a9b09a68bd399$var$U = k) : $2d2a9b09a68bd399$var$Vk(e);
                for(; null !== f;)$2d2a9b09a68bd399$var$U = f, $2d2a9b09a68bd399$var$Uk(f, b, c), f = f.sibling;
                $2d2a9b09a68bd399$var$U = e;
                $2d2a9b09a68bd399$var$qk = h;
                $2d2a9b09a68bd399$var$rk = l;
            }
            $2d2a9b09a68bd399$var$Wk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $2d2a9b09a68bd399$var$U = f) : $2d2a9b09a68bd399$var$Wk(a, b, c);
    }
}
function $2d2a9b09a68bd399$var$Wk(a) {
    for(; null !== $2d2a9b09a68bd399$var$U;){
        var b = $2d2a9b09a68bd399$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$2d2a9b09a68bd399$var$rk) {
                            if (b.mode & 2) try {
                                $2d2a9b09a68bd399$var$kj(), $2d2a9b09a68bd399$var$Bk(5, b);
                            } finally{
                                $2d2a9b09a68bd399$var$ij(b);
                            }
                            else $2d2a9b09a68bd399$var$Bk(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$2d2a9b09a68bd399$var$rk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $2d2a9b09a68bd399$var$kj(), d.componentDidMount();
                                } finally{
                                    $2d2a9b09a68bd399$var$ij(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $2d2a9b09a68bd399$var$Zg(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $2d2a9b09a68bd399$var$kj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $2d2a9b09a68bd399$var$ij(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $2d2a9b09a68bd399$var$wh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $2d2a9b09a68bd399$var$wh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $2d2a9b09a68bd399$var$bj;
                        c = null === c ? "mount" : "update";
                        $2d2a9b09a68bd399$var$fj && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $2d2a9b09a68bd399$var$Xk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $2d2a9b09a68bd399$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($2d2a9b09a68bd399$var$p(163));
                }
                $2d2a9b09a68bd399$var$rk || b.flags & 512 && $2d2a9b09a68bd399$var$Ck(b);
            } catch (v) {
                $2d2a9b09a68bd399$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $2d2a9b09a68bd399$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $2d2a9b09a68bd399$var$U = k;
            break;
        }
        $2d2a9b09a68bd399$var$U = b.return;
    }
}
function $2d2a9b09a68bd399$var$Sk(a) {
    for(; null !== $2d2a9b09a68bd399$var$U;){
        var b = $2d2a9b09a68bd399$var$U;
        if (b === a) {
            $2d2a9b09a68bd399$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $2d2a9b09a68bd399$var$U = c;
            break;
        }
        $2d2a9b09a68bd399$var$U = b.return;
    }
}
function $2d2a9b09a68bd399$var$Vk(a) {
    for(; null !== $2d2a9b09a68bd399$var$U;){
        var b = $2d2a9b09a68bd399$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $2d2a9b09a68bd399$var$kj();
                        var c = b.return;
                        try {
                            $2d2a9b09a68bd399$var$Bk(4, b);
                        } catch (l) {
                            $2d2a9b09a68bd399$var$W(b, c, l);
                        }
                    } finally{
                        $2d2a9b09a68bd399$var$ij(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $2d2a9b09a68bd399$var$Bk(4, b);
                        } catch (l) {
                            $2d2a9b09a68bd399$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $2d2a9b09a68bd399$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $2d2a9b09a68bd399$var$Ck(b);
                    } catch (l) {
                        $2d2a9b09a68bd399$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $2d2a9b09a68bd399$var$Ck(b);
                    } catch (l) {
                        $2d2a9b09a68bd399$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $2d2a9b09a68bd399$var$W(b, b.return, l);
        }
        if (b === a) {
            $2d2a9b09a68bd399$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $2d2a9b09a68bd399$var$U = k;
            break;
        }
        $2d2a9b09a68bd399$var$U = b.return;
    }
}
var $2d2a9b09a68bd399$var$Yk = Math.ceil, $2d2a9b09a68bd399$var$Zk = $2d2a9b09a68bd399$var$va.ReactCurrentDispatcher, $2d2a9b09a68bd399$var$$k = $2d2a9b09a68bd399$var$va.ReactCurrentOwner, $2d2a9b09a68bd399$var$al = $2d2a9b09a68bd399$var$va.ReactCurrentBatchConfig, $2d2a9b09a68bd399$var$K = 0, $2d2a9b09a68bd399$var$Q = null, $2d2a9b09a68bd399$var$Y = null, $2d2a9b09a68bd399$var$Z = 0, $2d2a9b09a68bd399$var$Kj = 0, $2d2a9b09a68bd399$var$Jj = $2d2a9b09a68bd399$var$hg(0), $2d2a9b09a68bd399$var$T = 0, $2d2a9b09a68bd399$var$bl = null, $2d2a9b09a68bd399$var$vh = 0, $2d2a9b09a68bd399$var$cl = 0, $2d2a9b09a68bd399$var$dl = 0, $2d2a9b09a68bd399$var$el = null, $2d2a9b09a68bd399$var$fl = null, $2d2a9b09a68bd399$var$Rk = 0, $2d2a9b09a68bd399$var$nk = Infinity, $2d2a9b09a68bd399$var$gl = null, $2d2a9b09a68bd399$var$rj = !1, $2d2a9b09a68bd399$var$sj = null, $2d2a9b09a68bd399$var$uj = null, $2d2a9b09a68bd399$var$hl = !1, $2d2a9b09a68bd399$var$il = null, $2d2a9b09a68bd399$var$jl = 0, $2d2a9b09a68bd399$var$kl = [], $2d2a9b09a68bd399$var$ll = 0, $2d2a9b09a68bd399$var$ml = null, $2d2a9b09a68bd399$var$nl = -1, $2d2a9b09a68bd399$var$ol = 0;
function $2d2a9b09a68bd399$var$zh() {
    return 0 !== ($2d2a9b09a68bd399$var$K & 6) ? $2d2a9b09a68bd399$var$A() : -1 !== $2d2a9b09a68bd399$var$nl ? $2d2a9b09a68bd399$var$nl : $2d2a9b09a68bd399$var$nl = $2d2a9b09a68bd399$var$A();
}
function $2d2a9b09a68bd399$var$Ah(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($2d2a9b09a68bd399$var$K & 2) && 0 !== $2d2a9b09a68bd399$var$Z) return $2d2a9b09a68bd399$var$Z & -$2d2a9b09a68bd399$var$Z;
    if (null !== $2d2a9b09a68bd399$var$Yg.transition) return 0 === $2d2a9b09a68bd399$var$ol && ($2d2a9b09a68bd399$var$ol = $2d2a9b09a68bd399$var$Kc()), $2d2a9b09a68bd399$var$ol;
    a = $2d2a9b09a68bd399$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $2d2a9b09a68bd399$var$xd(a.type);
    return a;
}
function $2d2a9b09a68bd399$var$Bh(a, b, c, d) {
    if (50 < $2d2a9b09a68bd399$var$ll) throw $2d2a9b09a68bd399$var$ll = 0, $2d2a9b09a68bd399$var$ml = null, Error($2d2a9b09a68bd399$var$p(185));
    $2d2a9b09a68bd399$var$Mc(a, c, d);
    if (0 === ($2d2a9b09a68bd399$var$K & 2) || a !== $2d2a9b09a68bd399$var$Q) $2d2a9b09a68bd399$var$mc && $2d2a9b09a68bd399$var$Pc(a, b, c), a === $2d2a9b09a68bd399$var$Q && (0 === ($2d2a9b09a68bd399$var$K & 2) && ($2d2a9b09a68bd399$var$cl |= c), 4 === $2d2a9b09a68bd399$var$T && $2d2a9b09a68bd399$var$pl(a, $2d2a9b09a68bd399$var$Z)), $2d2a9b09a68bd399$var$ql(a, d), 1 === c && 0 === $2d2a9b09a68bd399$var$K && 0 === (b.mode & 1) && ($2d2a9b09a68bd399$var$nk = $2d2a9b09a68bd399$var$A() + 500, $2d2a9b09a68bd399$var$tg && $2d2a9b09a68bd399$var$xg());
}
function $2d2a9b09a68bd399$var$ql(a, b) {
    var c = a.callbackNode;
    $2d2a9b09a68bd399$var$Ic(a, b);
    var d = $2d2a9b09a68bd399$var$Gc(a, a === $2d2a9b09a68bd399$var$Q ? $2d2a9b09a68bd399$var$Z : 0);
    if (0 === d) null !== c && $2d2a9b09a68bd399$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $2d2a9b09a68bd399$var$bc(c);
        if (1 === b) 0 === a.tag ? $2d2a9b09a68bd399$var$wg($2d2a9b09a68bd399$var$rl.bind(null, a)) : $2d2a9b09a68bd399$var$vg($2d2a9b09a68bd399$var$rl.bind(null, a)), $2d2a9b09a68bd399$var$Xf(function() {
            0 === ($2d2a9b09a68bd399$var$K & 6) && $2d2a9b09a68bd399$var$xg();
        }), c = null;
        else {
            switch($2d2a9b09a68bd399$var$Rc(d)){
                case 1:
                    c = $2d2a9b09a68bd399$var$fc;
                    break;
                case 4:
                    c = $2d2a9b09a68bd399$var$gc;
                    break;
                case 16:
                    c = $2d2a9b09a68bd399$var$hc;
                    break;
                case 536870912:
                    c = $2d2a9b09a68bd399$var$jc;
                    break;
                default:
                    c = $2d2a9b09a68bd399$var$hc;
            }
            c = $2d2a9b09a68bd399$var$sl(c, $2d2a9b09a68bd399$var$tl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $2d2a9b09a68bd399$var$tl(a, b) {
    $2d2a9b09a68bd399$var$gj = $2d2a9b09a68bd399$var$fj = !1;
    $2d2a9b09a68bd399$var$nl = -1;
    $2d2a9b09a68bd399$var$ol = 0;
    if (0 !== ($2d2a9b09a68bd399$var$K & 6)) throw Error($2d2a9b09a68bd399$var$p(327));
    var c = a.callbackNode;
    if ($2d2a9b09a68bd399$var$ul() && a.callbackNode !== c) return null;
    var d = $2d2a9b09a68bd399$var$Gc(a, a === $2d2a9b09a68bd399$var$Q ? $2d2a9b09a68bd399$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $2d2a9b09a68bd399$var$vl(a, d);
    else {
        b = d;
        var e = $2d2a9b09a68bd399$var$K;
        $2d2a9b09a68bd399$var$K |= 2;
        var f = $2d2a9b09a68bd399$var$wl();
        if ($2d2a9b09a68bd399$var$Q !== a || $2d2a9b09a68bd399$var$Z !== b) {
            if ($2d2a9b09a68bd399$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($2d2a9b09a68bd399$var$xj(a, $2d2a9b09a68bd399$var$Z), g.clear());
                $2d2a9b09a68bd399$var$Qc(a, b);
            }
            $2d2a9b09a68bd399$var$gl = null;
            $2d2a9b09a68bd399$var$nk = $2d2a9b09a68bd399$var$A() + 500;
            $2d2a9b09a68bd399$var$xl(a, b);
        }
        $2d2a9b09a68bd399$var$wc(b);
        for(;;)try {
            $2d2a9b09a68bd399$var$yl();
            break;
        } catch (h) {
            $2d2a9b09a68bd399$var$zl(a, h);
        }
        $2d2a9b09a68bd399$var$dh();
        $2d2a9b09a68bd399$var$Zk.current = f;
        $2d2a9b09a68bd399$var$K = e;
        null !== $2d2a9b09a68bd399$var$Y ? (null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markRenderYielded && $2d2a9b09a68bd399$var$B.markRenderYielded(), b = 0) : ($2d2a9b09a68bd399$var$xc(), $2d2a9b09a68bd399$var$Q = null, $2d2a9b09a68bd399$var$Z = 0, b = $2d2a9b09a68bd399$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $2d2a9b09a68bd399$var$Jc(a), 0 !== e && (d = e, b = $2d2a9b09a68bd399$var$Al(a, e)));
        if (1 === b) throw c = $2d2a9b09a68bd399$var$bl, $2d2a9b09a68bd399$var$xl(a, 0), $2d2a9b09a68bd399$var$pl(a, d), $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A()), c;
        if (6 === b) $2d2a9b09a68bd399$var$pl(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$2d2a9b09a68bd399$var$Bl(e) && (b = $2d2a9b09a68bd399$var$vl(a, d), 2 === b && (f = $2d2a9b09a68bd399$var$Jc(a), 0 !== f && (d = f, b = $2d2a9b09a68bd399$var$Al(a, f))), 1 === b)) throw c = $2d2a9b09a68bd399$var$bl, $2d2a9b09a68bd399$var$xl(a, 0), $2d2a9b09a68bd399$var$pl(a, d), $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($2d2a9b09a68bd399$var$p(345));
                case 2:
                    $2d2a9b09a68bd399$var$Dl(a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl);
                    break;
                case 3:
                    $2d2a9b09a68bd399$var$pl(a, d);
                    if ((d & 130023424) === d && (b = $2d2a9b09a68bd399$var$Rk + 500 - $2d2a9b09a68bd399$var$A(), 10 < b)) {
                        if (0 !== $2d2a9b09a68bd399$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $2d2a9b09a68bd399$var$zh();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $2d2a9b09a68bd399$var$Tf($2d2a9b09a68bd399$var$Dl.bind(null, a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl), b);
                        break;
                    }
                    $2d2a9b09a68bd399$var$Dl(a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl);
                    break;
                case 4:
                    $2d2a9b09a68bd399$var$pl(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $2d2a9b09a68bd399$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $2d2a9b09a68bd399$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $2d2a9b09a68bd399$var$Yk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $2d2a9b09a68bd399$var$Tf($2d2a9b09a68bd399$var$Dl.bind(null, a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl), d);
                        break;
                    }
                    $2d2a9b09a68bd399$var$Dl(a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl);
                    break;
                case 5:
                    $2d2a9b09a68bd399$var$Dl(a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl);
                    break;
                default:
                    throw Error($2d2a9b09a68bd399$var$p(329));
            }
        }
    }
    $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A());
    return a.callbackNode === c ? $2d2a9b09a68bd399$var$tl.bind(null, a) : null;
}
function $2d2a9b09a68bd399$var$Al(a, b) {
    var c = $2d2a9b09a68bd399$var$el;
    a.current.memoizedState.isDehydrated && ($2d2a9b09a68bd399$var$xl(a, b).flags |= 256);
    a = $2d2a9b09a68bd399$var$vl(a, b);
    2 !== a && (b = $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$fl = c, null !== b && $2d2a9b09a68bd399$var$mk(b));
    return a;
}
function $2d2a9b09a68bd399$var$mk(a) {
    null === $2d2a9b09a68bd399$var$fl ? $2d2a9b09a68bd399$var$fl = a : $2d2a9b09a68bd399$var$fl.push.apply($2d2a9b09a68bd399$var$fl, a);
}
function $2d2a9b09a68bd399$var$Bl(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$2d2a9b09a68bd399$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $2d2a9b09a68bd399$var$pl(a, b) {
    b &= ~$2d2a9b09a68bd399$var$dl;
    b &= ~$2d2a9b09a68bd399$var$cl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $2d2a9b09a68bd399$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $2d2a9b09a68bd399$var$rl(a) {
    $2d2a9b09a68bd399$var$fj = $2d2a9b09a68bd399$var$gj;
    $2d2a9b09a68bd399$var$gj = !1;
    if (0 !== ($2d2a9b09a68bd399$var$K & 6)) throw Error($2d2a9b09a68bd399$var$p(327));
    $2d2a9b09a68bd399$var$ul();
    var b = $2d2a9b09a68bd399$var$Gc(a, 0);
    if (0 === (b & 1)) return $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A()), null;
    var c = $2d2a9b09a68bd399$var$vl(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $2d2a9b09a68bd399$var$Jc(a);
        0 !== d && (b = d, c = $2d2a9b09a68bd399$var$Al(a, d));
    }
    if (1 === c) throw c = $2d2a9b09a68bd399$var$bl, $2d2a9b09a68bd399$var$xl(a, 0), $2d2a9b09a68bd399$var$pl(a, b), $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A()), c;
    if (6 === c) throw Error($2d2a9b09a68bd399$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $2d2a9b09a68bd399$var$Dl(a, $2d2a9b09a68bd399$var$fl, $2d2a9b09a68bd399$var$gl);
    $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A());
    return null;
}
function $2d2a9b09a68bd399$var$El(a, b) {
    var c = $2d2a9b09a68bd399$var$K;
    $2d2a9b09a68bd399$var$K |= 1;
    try {
        return a(b);
    } finally{
        $2d2a9b09a68bd399$var$K = c, 0 === $2d2a9b09a68bd399$var$K && ($2d2a9b09a68bd399$var$nk = $2d2a9b09a68bd399$var$A() + 500, $2d2a9b09a68bd399$var$tg && $2d2a9b09a68bd399$var$xg());
    }
}
function $2d2a9b09a68bd399$var$Fl(a) {
    null !== $2d2a9b09a68bd399$var$il && 0 === $2d2a9b09a68bd399$var$il.tag && 0 === ($2d2a9b09a68bd399$var$K & 6) && $2d2a9b09a68bd399$var$ul();
    var b = $2d2a9b09a68bd399$var$K;
    $2d2a9b09a68bd399$var$K |= 1;
    var c = $2d2a9b09a68bd399$var$al.transition, d = $2d2a9b09a68bd399$var$E;
    try {
        if ($2d2a9b09a68bd399$var$al.transition = null, $2d2a9b09a68bd399$var$E = 1, a) return a();
    } finally{
        $2d2a9b09a68bd399$var$E = d, $2d2a9b09a68bd399$var$al.transition = c, $2d2a9b09a68bd399$var$K = b, 0 === ($2d2a9b09a68bd399$var$K & 6) && $2d2a9b09a68bd399$var$xg();
    }
}
function $2d2a9b09a68bd399$var$ok() {
    $2d2a9b09a68bd399$var$Kj = $2d2a9b09a68bd399$var$Jj.current;
    $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$Jj);
}
function $2d2a9b09a68bd399$var$xl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $2d2a9b09a68bd399$var$Uf(c));
    if (null !== $2d2a9b09a68bd399$var$Y) for(c = $2d2a9b09a68bd399$var$Y.return; null !== c;){
        var d = c;
        $2d2a9b09a68bd399$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $2d2a9b09a68bd399$var$ng();
                break;
            case 3:
                $2d2a9b09a68bd399$var$Yh();
                $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$jg);
                $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$I);
                $2d2a9b09a68bd399$var$ci();
                break;
            case 5:
                $2d2a9b09a68bd399$var$$h(d);
                break;
            case 4:
                $2d2a9b09a68bd399$var$Yh();
                break;
            case 13:
                $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L);
                break;
            case 19:
                $2d2a9b09a68bd399$var$G($2d2a9b09a68bd399$var$L);
                break;
            case 10:
                $2d2a9b09a68bd399$var$eh(d.type._context);
                break;
            case 22:
            case 23:
                $2d2a9b09a68bd399$var$ok();
        }
        c = c.return;
    }
    $2d2a9b09a68bd399$var$Q = a;
    $2d2a9b09a68bd399$var$Y = a = $2d2a9b09a68bd399$var$Lh(a.current, null);
    $2d2a9b09a68bd399$var$Z = $2d2a9b09a68bd399$var$Kj = b;
    $2d2a9b09a68bd399$var$T = 0;
    $2d2a9b09a68bd399$var$bl = null;
    $2d2a9b09a68bd399$var$dl = $2d2a9b09a68bd399$var$cl = $2d2a9b09a68bd399$var$vh = 0;
    $2d2a9b09a68bd399$var$fl = $2d2a9b09a68bd399$var$el = null;
    if (null !== $2d2a9b09a68bd399$var$jh) {
        for(b = 0; b < $2d2a9b09a68bd399$var$jh.length; b++)if (c = $2d2a9b09a68bd399$var$jh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $2d2a9b09a68bd399$var$jh = null;
    }
    return a;
}
function $2d2a9b09a68bd399$var$zl(a, b) {
    do {
        var c = $2d2a9b09a68bd399$var$Y;
        try {
            $2d2a9b09a68bd399$var$dh();
            $2d2a9b09a68bd399$var$di.current = $2d2a9b09a68bd399$var$pi;
            if ($2d2a9b09a68bd399$var$gi) {
                for(var d = $2d2a9b09a68bd399$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $2d2a9b09a68bd399$var$gi = !1;
            }
            $2d2a9b09a68bd399$var$fi = 0;
            $2d2a9b09a68bd399$var$O = $2d2a9b09a68bd399$var$N = $2d2a9b09a68bd399$var$M = null;
            $2d2a9b09a68bd399$var$hi = !1;
            $2d2a9b09a68bd399$var$ii = 0;
            $2d2a9b09a68bd399$var$$k.current = null;
            if (null === c || null === c.return) {
                $2d2a9b09a68bd399$var$T = 1;
                $2d2a9b09a68bd399$var$bl = b;
                $2d2a9b09a68bd399$var$Y = null;
                break;
            }
            c.mode & 2 && $2d2a9b09a68bd399$var$hj(c, !0);
            $2d2a9b09a68bd399$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentSuspended && $2d2a9b09a68bd399$var$B.markComponentSuspended(c, f, $2d2a9b09a68bd399$var$Z);
            } else null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markComponentErrored && $2d2a9b09a68bd399$var$B.markComponentErrored(c, b, $2d2a9b09a68bd399$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $2d2a9b09a68bd399$var$Z;
                k.flags |= 32768;
                $2d2a9b09a68bd399$var$mc && $2d2a9b09a68bd399$var$xj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $2d2a9b09a68bd399$var$yj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $2d2a9b09a68bd399$var$zj(z, h, k, g, b);
                        z.mode & 1 && $2d2a9b09a68bd399$var$vj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $2d2a9b09a68bd399$var$vj(g, l, b);
                            $2d2a9b09a68bd399$var$ak();
                            break a;
                        }
                        f = Error($2d2a9b09a68bd399$var$p(426));
                    }
                } else if ($2d2a9b09a68bd399$var$J && k.mode & 1) {
                    var C = $2d2a9b09a68bd399$var$yj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $2d2a9b09a68bd399$var$zj(C, h, k, g, b);
                        $2d2a9b09a68bd399$var$Xg($2d2a9b09a68bd399$var$mj(f, k));
                        break a;
                    }
                }
                g = f = $2d2a9b09a68bd399$var$mj(f, k);
                4 !== $2d2a9b09a68bd399$var$T && ($2d2a9b09a68bd399$var$T = 2);
                null === $2d2a9b09a68bd399$var$el ? $2d2a9b09a68bd399$var$el = [
                    g
                ] : $2d2a9b09a68bd399$var$el.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $2d2a9b09a68bd399$var$qj(g, f, b);
                            $2d2a9b09a68bd399$var$th(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $2d2a9b09a68bd399$var$uj || !$2d2a9b09a68bd399$var$uj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $2d2a9b09a68bd399$var$tj(g, k, b);
                                $2d2a9b09a68bd399$var$th(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $2d2a9b09a68bd399$var$Gl(c);
        } catch (ca) {
            b = ca;
            $2d2a9b09a68bd399$var$Y === c && null !== c && ($2d2a9b09a68bd399$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $2d2a9b09a68bd399$var$wl() {
    var a = $2d2a9b09a68bd399$var$Zk.current;
    $2d2a9b09a68bd399$var$Zk.current = $2d2a9b09a68bd399$var$pi;
    return null === a ? $2d2a9b09a68bd399$var$pi : a;
}
function $2d2a9b09a68bd399$var$ak() {
    if (0 === $2d2a9b09a68bd399$var$T || 3 === $2d2a9b09a68bd399$var$T || 2 === $2d2a9b09a68bd399$var$T) $2d2a9b09a68bd399$var$T = 4;
    null === $2d2a9b09a68bd399$var$Q || 0 === ($2d2a9b09a68bd399$var$vh & 268435455) && 0 === ($2d2a9b09a68bd399$var$cl & 268435455) || $2d2a9b09a68bd399$var$pl($2d2a9b09a68bd399$var$Q, $2d2a9b09a68bd399$var$Z);
}
function $2d2a9b09a68bd399$var$vl(a, b) {
    var c = $2d2a9b09a68bd399$var$K;
    $2d2a9b09a68bd399$var$K |= 2;
    var d = $2d2a9b09a68bd399$var$wl();
    if ($2d2a9b09a68bd399$var$Q !== a || $2d2a9b09a68bd399$var$Z !== b) {
        if ($2d2a9b09a68bd399$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($2d2a9b09a68bd399$var$xj(a, $2d2a9b09a68bd399$var$Z), e.clear());
            $2d2a9b09a68bd399$var$Qc(a, b);
        }
        $2d2a9b09a68bd399$var$gl = null;
        $2d2a9b09a68bd399$var$xl(a, b);
    }
    $2d2a9b09a68bd399$var$wc(b);
    for(;;)try {
        $2d2a9b09a68bd399$var$Hl();
        break;
    } catch (f) {
        $2d2a9b09a68bd399$var$zl(a, f);
    }
    $2d2a9b09a68bd399$var$dh();
    $2d2a9b09a68bd399$var$K = c;
    $2d2a9b09a68bd399$var$Zk.current = d;
    if (null !== $2d2a9b09a68bd399$var$Y) throw Error($2d2a9b09a68bd399$var$p(261));
    $2d2a9b09a68bd399$var$xc();
    $2d2a9b09a68bd399$var$Q = null;
    $2d2a9b09a68bd399$var$Z = 0;
    return $2d2a9b09a68bd399$var$T;
}
function $2d2a9b09a68bd399$var$Hl() {
    for(; null !== $2d2a9b09a68bd399$var$Y;)$2d2a9b09a68bd399$var$Il($2d2a9b09a68bd399$var$Y);
}
function $2d2a9b09a68bd399$var$yl() {
    for(; null !== $2d2a9b09a68bd399$var$Y && !$2d2a9b09a68bd399$var$cc();)$2d2a9b09a68bd399$var$Il($2d2a9b09a68bd399$var$Y);
}
function $2d2a9b09a68bd399$var$Il(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($2d2a9b09a68bd399$var$dj = $2d2a9b09a68bd399$var$aj(), 0 > a.actualStartTime && (a.actualStartTime = $2d2a9b09a68bd399$var$aj()), b = $2d2a9b09a68bd399$var$Jl(b, a, $2d2a9b09a68bd399$var$Kj), $2d2a9b09a68bd399$var$hj(a, !0)) : b = $2d2a9b09a68bd399$var$Jl(b, a, $2d2a9b09a68bd399$var$Kj);
    a.memoizedProps = a.pendingProps;
    null === b ? $2d2a9b09a68bd399$var$Gl(a) : $2d2a9b09a68bd399$var$Y = b;
    $2d2a9b09a68bd399$var$$k.current = null;
}
function $2d2a9b09a68bd399$var$Gl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $2d2a9b09a68bd399$var$lk(c, b, $2d2a9b09a68bd399$var$Kj);
            else {
                var d = b;
                $2d2a9b09a68bd399$var$dj = $2d2a9b09a68bd399$var$aj();
                0 > d.actualStartTime && (d.actualStartTime = $2d2a9b09a68bd399$var$aj());
                c = $2d2a9b09a68bd399$var$lk(c, b, $2d2a9b09a68bd399$var$Kj);
                $2d2a9b09a68bd399$var$hj(b, !1);
            }
            if (null !== c) {
                $2d2a9b09a68bd399$var$Y = c;
                return;
            }
        } else {
            c = $2d2a9b09a68bd399$var$pk(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $2d2a9b09a68bd399$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $2d2a9b09a68bd399$var$hj(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $2d2a9b09a68bd399$var$T = 6;
                $2d2a9b09a68bd399$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $2d2a9b09a68bd399$var$Y = b;
            return;
        }
        $2d2a9b09a68bd399$var$Y = b = a;
    }while (null !== b);
    0 === $2d2a9b09a68bd399$var$T && ($2d2a9b09a68bd399$var$T = 5);
}
function $2d2a9b09a68bd399$var$Dl(a, b, c) {
    var d = $2d2a9b09a68bd399$var$E, e = $2d2a9b09a68bd399$var$al.transition;
    try {
        $2d2a9b09a68bd399$var$al.transition = null, $2d2a9b09a68bd399$var$E = 1, $2d2a9b09a68bd399$var$Kl(a, b, c, d);
    } finally{
        $2d2a9b09a68bd399$var$al.transition = e, $2d2a9b09a68bd399$var$E = d;
    }
    return null;
}
function $2d2a9b09a68bd399$var$Kl(a, b, c, d) {
    do $2d2a9b09a68bd399$var$ul();
    while (null !== $2d2a9b09a68bd399$var$il);
    if (0 !== ($2d2a9b09a68bd399$var$K & 6)) throw Error($2d2a9b09a68bd399$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markCommitStarted && $2d2a9b09a68bd399$var$B.markCommitStarted(e);
    if (null === c) return $2d2a9b09a68bd399$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($2d2a9b09a68bd399$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $2d2a9b09a68bd399$var$Nc(a, f);
    a === $2d2a9b09a68bd399$var$Q && ($2d2a9b09a68bd399$var$Y = $2d2a9b09a68bd399$var$Q = null, $2d2a9b09a68bd399$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $2d2a9b09a68bd399$var$hl || ($2d2a9b09a68bd399$var$hl = !0, $2d2a9b09a68bd399$var$sl($2d2a9b09a68bd399$var$hc, function() {
        $2d2a9b09a68bd399$var$ul();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $2d2a9b09a68bd399$var$al.transition;
        $2d2a9b09a68bd399$var$al.transition = null;
        var g = $2d2a9b09a68bd399$var$E;
        $2d2a9b09a68bd399$var$E = 1;
        var h = $2d2a9b09a68bd399$var$K;
        $2d2a9b09a68bd399$var$K |= 4;
        $2d2a9b09a68bd399$var$$k.current = null;
        $2d2a9b09a68bd399$var$zk(a, c);
        $2d2a9b09a68bd399$var$bj = $2d2a9b09a68bd399$var$aj();
        $2d2a9b09a68bd399$var$Nk(a, c, e);
        $2d2a9b09a68bd399$var$bf($2d2a9b09a68bd399$var$Rf);
        $2d2a9b09a68bd399$var$rd = !!$2d2a9b09a68bd399$var$Qf;
        $2d2a9b09a68bd399$var$Rf = $2d2a9b09a68bd399$var$Qf = null;
        a.current = c;
        null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markLayoutEffectsStarted && $2d2a9b09a68bd399$var$B.markLayoutEffectsStarted(e);
        $2d2a9b09a68bd399$var$Tk(c, a, e);
        null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markLayoutEffectsStopped && $2d2a9b09a68bd399$var$B.markLayoutEffectsStopped();
        $2d2a9b09a68bd399$var$dc();
        $2d2a9b09a68bd399$var$K = h;
        $2d2a9b09a68bd399$var$E = g;
        $2d2a9b09a68bd399$var$al.transition = f;
    } else a.current = c, $2d2a9b09a68bd399$var$bj = $2d2a9b09a68bd399$var$aj();
    $2d2a9b09a68bd399$var$hl && ($2d2a9b09a68bd399$var$hl = !1, $2d2a9b09a68bd399$var$il = a, $2d2a9b09a68bd399$var$jl = e);
    f = a.pendingLanes;
    0 === f && ($2d2a9b09a68bd399$var$uj = null);
    $2d2a9b09a68bd399$var$nc(c.stateNode, d);
    $2d2a9b09a68bd399$var$mc && a.memoizedUpdaters.clear();
    $2d2a9b09a68bd399$var$ql(a, $2d2a9b09a68bd399$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($2d2a9b09a68bd399$var$rj) throw $2d2a9b09a68bd399$var$rj = !1, a = $2d2a9b09a68bd399$var$sj, $2d2a9b09a68bd399$var$sj = null, a;
    0 !== ($2d2a9b09a68bd399$var$jl & 1) && 0 !== a.tag && $2d2a9b09a68bd399$var$ul();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($2d2a9b09a68bd399$var$gj = !0, a === $2d2a9b09a68bd399$var$ml ? $2d2a9b09a68bd399$var$ll++ : ($2d2a9b09a68bd399$var$ll = 0, $2d2a9b09a68bd399$var$ml = a)) : $2d2a9b09a68bd399$var$ll = 0;
    $2d2a9b09a68bd399$var$xg();
    $2d2a9b09a68bd399$var$rc();
    return null;
}
function $2d2a9b09a68bd399$var$ul() {
    if (null !== $2d2a9b09a68bd399$var$il) {
        var a = $2d2a9b09a68bd399$var$Rc($2d2a9b09a68bd399$var$jl), b = $2d2a9b09a68bd399$var$al.transition, c = $2d2a9b09a68bd399$var$E;
        try {
            $2d2a9b09a68bd399$var$al.transition = null;
            $2d2a9b09a68bd399$var$E = 16 > a ? 16 : a;
            if (null === $2d2a9b09a68bd399$var$il) var d = !1;
            else {
                a = $2d2a9b09a68bd399$var$il;
                var e = $2d2a9b09a68bd399$var$jl;
                $2d2a9b09a68bd399$var$il = null;
                $2d2a9b09a68bd399$var$jl = 0;
                if (0 !== ($2d2a9b09a68bd399$var$K & 6)) throw Error($2d2a9b09a68bd399$var$p(331));
                null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markPassiveEffectsStarted && $2d2a9b09a68bd399$var$B.markPassiveEffectsStarted(e);
                e = $2d2a9b09a68bd399$var$K;
                $2d2a9b09a68bd399$var$K |= 4;
                for($2d2a9b09a68bd399$var$U = a.current; null !== $2d2a9b09a68bd399$var$U;){
                    var f = $2d2a9b09a68bd399$var$U, g = f.child;
                    if (0 !== ($2d2a9b09a68bd399$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($2d2a9b09a68bd399$var$U = l; null !== $2d2a9b09a68bd399$var$U;){
                                    var n = $2d2a9b09a68bd399$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($2d2a9b09a68bd399$var$ej = $2d2a9b09a68bd399$var$aj(), $2d2a9b09a68bd399$var$Ak(8, q, f), $2d2a9b09a68bd399$var$jj(q)) : $2d2a9b09a68bd399$var$Ak(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $2d2a9b09a68bd399$var$U = r;
                                    else for(; null !== $2d2a9b09a68bd399$var$U;){
                                        n = $2d2a9b09a68bd399$var$U;
                                        var z = n.sibling, m = n.return;
                                        $2d2a9b09a68bd399$var$Dk(n);
                                        if (n === l) {
                                            $2d2a9b09a68bd399$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $2d2a9b09a68bd399$var$U = z;
                                            break;
                                        }
                                        $2d2a9b09a68bd399$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $2d2a9b09a68bd399$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $2d2a9b09a68bd399$var$U = g;
                    else b: for(; null !== $2d2a9b09a68bd399$var$U;){
                        f = $2d2a9b09a68bd399$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($2d2a9b09a68bd399$var$ej = $2d2a9b09a68bd399$var$aj(), $2d2a9b09a68bd399$var$Ak(9, k, k.return), $2d2a9b09a68bd399$var$jj(k)) : $2d2a9b09a68bd399$var$Ak(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $2d2a9b09a68bd399$var$U = y;
                            break b;
                        }
                        $2d2a9b09a68bd399$var$U = f.return;
                    }
                }
                var v = a.current;
                for($2d2a9b09a68bd399$var$U = v; null !== $2d2a9b09a68bd399$var$U;){
                    g = $2d2a9b09a68bd399$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $2d2a9b09a68bd399$var$U = D;
                    else b: for(g = v; null !== $2d2a9b09a68bd399$var$U;){
                        h = $2d2a9b09a68bd399$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $2d2a9b09a68bd399$var$ej = $2d2a9b09a68bd399$var$aj();
                                        try {
                                            $2d2a9b09a68bd399$var$Bk(9, l);
                                        } finally{
                                            $2d2a9b09a68bd399$var$jj(l);
                                        }
                                    } else $2d2a9b09a68bd399$var$Bk(9, l);
                            }
                        } catch (Rj) {
                            $2d2a9b09a68bd399$var$W(h, h.return, Rj);
                        }
                        if (h === g) {
                            $2d2a9b09a68bd399$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $2d2a9b09a68bd399$var$U = ca;
                            break b;
                        }
                        $2d2a9b09a68bd399$var$U = h.return;
                    }
                }
                v = $2d2a9b09a68bd399$var$kl;
                $2d2a9b09a68bd399$var$kl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Cl = V.id, Hi = V.onPostCommit;
                            ca = $2d2a9b09a68bd399$var$bj;
                            var Ii = null === R.alternate ? "mount" : "update";
                            $2d2a9b09a68bd399$var$fj && (Ii = "nested-update");
                            "function" === typeof Hi && Hi(Cl, Ii, sa, ca);
                            var ob = R.return;
                            b: for(; null !== ob;){
                                switch(ob.tag){
                                    case 3:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        ob.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                ob = ob.return;
                            }
                    }
                }
                null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markPassiveEffectsStopped && $2d2a9b09a68bd399$var$B.markPassiveEffectsStopped();
                $2d2a9b09a68bd399$var$K = e;
                $2d2a9b09a68bd399$var$xg();
                if ($2d2a9b09a68bd399$var$lc && "function" === typeof $2d2a9b09a68bd399$var$lc.onPostCommitFiberRoot) try {
                    $2d2a9b09a68bd399$var$lc.onPostCommitFiberRoot($2d2a9b09a68bd399$var$kc, a);
                } catch (Rj) {}
                var Sj = a.current.stateNode;
                Sj.effectDuration = 0;
                Sj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $2d2a9b09a68bd399$var$E = c, $2d2a9b09a68bd399$var$al.transition = b;
        }
    }
    return !1;
}
function $2d2a9b09a68bd399$var$Xk(a) {
    $2d2a9b09a68bd399$var$kl.push(a);
    $2d2a9b09a68bd399$var$hl || ($2d2a9b09a68bd399$var$hl = !0, $2d2a9b09a68bd399$var$sl($2d2a9b09a68bd399$var$hc, function() {
        $2d2a9b09a68bd399$var$ul();
        return null;
    }));
}
function $2d2a9b09a68bd399$var$Ll(a, b, c) {
    b = $2d2a9b09a68bd399$var$mj(c, b);
    b = $2d2a9b09a68bd399$var$qj(a, b, 1);
    a = $2d2a9b09a68bd399$var$rh(a, b, 1);
    b = $2d2a9b09a68bd399$var$zh();
    null !== a && ($2d2a9b09a68bd399$var$Mc(a, 1, b), $2d2a9b09a68bd399$var$ql(a, b));
}
function $2d2a9b09a68bd399$var$W(a, b, c) {
    if (3 === a.tag) $2d2a9b09a68bd399$var$Ll(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $2d2a9b09a68bd399$var$Ll(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $2d2a9b09a68bd399$var$uj || !$2d2a9b09a68bd399$var$uj.has(d))) {
                a = $2d2a9b09a68bd399$var$mj(c, a);
                a = $2d2a9b09a68bd399$var$tj(b, a, 1);
                b = $2d2a9b09a68bd399$var$rh(b, a, 1);
                a = $2d2a9b09a68bd399$var$zh();
                null !== b && ($2d2a9b09a68bd399$var$Mc(b, 1, a), $2d2a9b09a68bd399$var$ql(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $2d2a9b09a68bd399$var$wj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $2d2a9b09a68bd399$var$zh();
    a.pingedLanes |= a.suspendedLanes & c;
    $2d2a9b09a68bd399$var$Q === a && ($2d2a9b09a68bd399$var$Z & c) === c && (4 === $2d2a9b09a68bd399$var$T || 3 === $2d2a9b09a68bd399$var$T && ($2d2a9b09a68bd399$var$Z & 130023424) === $2d2a9b09a68bd399$var$Z && 500 > $2d2a9b09a68bd399$var$A() - $2d2a9b09a68bd399$var$Rk ? $2d2a9b09a68bd399$var$xl(a, 0) : $2d2a9b09a68bd399$var$dl |= c);
    $2d2a9b09a68bd399$var$ql(a, b);
}
function $2d2a9b09a68bd399$var$Ml(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $2d2a9b09a68bd399$var$Ec, $2d2a9b09a68bd399$var$Ec <<= 1, 0 === ($2d2a9b09a68bd399$var$Ec & 130023424) && ($2d2a9b09a68bd399$var$Ec = 4194304)));
    var c = $2d2a9b09a68bd399$var$zh();
    a = $2d2a9b09a68bd399$var$mh(a, b);
    null !== a && ($2d2a9b09a68bd399$var$Mc(a, b, c), $2d2a9b09a68bd399$var$ql(a, c));
}
function $2d2a9b09a68bd399$var$bk(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $2d2a9b09a68bd399$var$Ml(a, c);
}
function $2d2a9b09a68bd399$var$Mk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($2d2a9b09a68bd399$var$p(314));
    }
    null !== d && d.delete(b);
    $2d2a9b09a68bd399$var$Ml(a, c);
}
var $2d2a9b09a68bd399$var$Jl;
$2d2a9b09a68bd399$var$Jl = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $2d2a9b09a68bd399$var$jg.current) $2d2a9b09a68bd399$var$hh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $2d2a9b09a68bd399$var$hh = !1, $2d2a9b09a68bd399$var$fk(a, b, c);
            $2d2a9b09a68bd399$var$hh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $2d2a9b09a68bd399$var$hh = !1, $2d2a9b09a68bd399$var$J && 0 !== (b.flags & 1048576) && $2d2a9b09a68bd399$var$Ig(b, $2d2a9b09a68bd399$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $2d2a9b09a68bd399$var$Nj(a, b);
            a = b.pendingProps;
            var e = $2d2a9b09a68bd399$var$lg(b, $2d2a9b09a68bd399$var$I.current);
            $2d2a9b09a68bd399$var$gh(b, c);
            $2d2a9b09a68bd399$var$sc(b);
            e = $2d2a9b09a68bd399$var$li(null, b, d, a, e, c);
            var f = $2d2a9b09a68bd399$var$qi();
            $2d2a9b09a68bd399$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $2d2a9b09a68bd399$var$mg(d) ? (f = !0, $2d2a9b09a68bd399$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $2d2a9b09a68bd399$var$oh(b), e.updater = $2d2a9b09a68bd399$var$Ch, b.stateNode = e, e._reactInternals = b, $2d2a9b09a68bd399$var$Gh(b, d, a, c), b = $2d2a9b09a68bd399$var$Oj(null, b, d, !0, f, c)) : (b.tag = 0, $2d2a9b09a68bd399$var$J && f && $2d2a9b09a68bd399$var$Jg(b), $2d2a9b09a68bd399$var$Bj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $2d2a9b09a68bd399$var$Nj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $2d2a9b09a68bd399$var$Nl(d);
                a = $2d2a9b09a68bd399$var$Zg(d, a);
                switch(e){
                    case 0:
                        b = $2d2a9b09a68bd399$var$Hj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $2d2a9b09a68bd399$var$Mj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $2d2a9b09a68bd399$var$Cj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $2d2a9b09a68bd399$var$Ej(null, b, d, $2d2a9b09a68bd399$var$Zg(d.type, a), c);
                        break a;
                }
                throw Error($2d2a9b09a68bd399$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2d2a9b09a68bd399$var$Zg(d, e), $2d2a9b09a68bd399$var$Hj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2d2a9b09a68bd399$var$Zg(d, e), $2d2a9b09a68bd399$var$Mj(a, b, d, e, c);
        case 3:
            a: {
                $2d2a9b09a68bd399$var$Pj(b);
                if (null === a) throw Error($2d2a9b09a68bd399$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $2d2a9b09a68bd399$var$ph(a, b);
                $2d2a9b09a68bd399$var$uh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $2d2a9b09a68bd399$var$mj(Error($2d2a9b09a68bd399$var$p(423)), b);
                        b = $2d2a9b09a68bd399$var$Qj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $2d2a9b09a68bd399$var$mj(Error($2d2a9b09a68bd399$var$p(424)), b);
                        b = $2d2a9b09a68bd399$var$Qj(a, b, d, c, e);
                        break a;
                    } else for($2d2a9b09a68bd399$var$Mg = $2d2a9b09a68bd399$var$Zf(b.stateNode.containerInfo.firstChild), $2d2a9b09a68bd399$var$Lg = b, $2d2a9b09a68bd399$var$J = !0, $2d2a9b09a68bd399$var$Ng = null, c = $2d2a9b09a68bd399$var$Rh(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $2d2a9b09a68bd399$var$Wg();
                    if (d === e) {
                        b = $2d2a9b09a68bd399$var$Dj(a, b, c);
                        break a;
                    }
                    $2d2a9b09a68bd399$var$Bj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $2d2a9b09a68bd399$var$Zh(b), null === a && $2d2a9b09a68bd399$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $2d2a9b09a68bd399$var$Sf(d, e) ? g = null : null !== f && $2d2a9b09a68bd399$var$Sf(d, f) && (b.flags |= 32), $2d2a9b09a68bd399$var$Lj(a, b), $2d2a9b09a68bd399$var$Bj(a, b, g, c), b.child;
        case 6:
            return null === a && $2d2a9b09a68bd399$var$Sg(b), null;
        case 13:
            return $2d2a9b09a68bd399$var$Vj(a, b, c);
        case 4:
            return $2d2a9b09a68bd399$var$Xh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $2d2a9b09a68bd399$var$Qh(b, null, d, c) : $2d2a9b09a68bd399$var$Bj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2d2a9b09a68bd399$var$Zg(d, e), $2d2a9b09a68bd399$var$Cj(a, b, d, e, c);
        case 7:
            return $2d2a9b09a68bd399$var$Bj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $2d2a9b09a68bd399$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $2d2a9b09a68bd399$var$Bj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $2d2a9b09a68bd399$var$H($2d2a9b09a68bd399$var$$g, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($2d2a9b09a68bd399$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$2d2a9b09a68bd399$var$jg.current) {
                            b = $2d2a9b09a68bd399$var$Dj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $2d2a9b09a68bd399$var$qh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $2d2a9b09a68bd399$var$fh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($2d2a9b09a68bd399$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $2d2a9b09a68bd399$var$fh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $2d2a9b09a68bd399$var$Bj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $2d2a9b09a68bd399$var$gh(b, c), e = $2d2a9b09a68bd399$var$ih(e), $2d2a9b09a68bd399$var$sc(b), d = d(e), $2d2a9b09a68bd399$var$tc(), b.flags |= 1, $2d2a9b09a68bd399$var$Bj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $2d2a9b09a68bd399$var$Zg(d, b.pendingProps), e = $2d2a9b09a68bd399$var$Zg(d.type, e), $2d2a9b09a68bd399$var$Ej(a, b, d, e, c);
        case 15:
            return $2d2a9b09a68bd399$var$Gj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $2d2a9b09a68bd399$var$Zg(d, e), $2d2a9b09a68bd399$var$Nj(a, b), b.tag = 1, $2d2a9b09a68bd399$var$mg(d) ? (a = !0, $2d2a9b09a68bd399$var$qg(b)) : a = !1, $2d2a9b09a68bd399$var$gh(b, c), $2d2a9b09a68bd399$var$Eh(b, d, e), $2d2a9b09a68bd399$var$Gh(b, d, e, c), $2d2a9b09a68bd399$var$Oj(null, b, d, !0, a, c);
        case 19:
            return $2d2a9b09a68bd399$var$ek(a, b, c);
        case 22:
            return $2d2a9b09a68bd399$var$Ij(a, b, c);
    }
    throw Error($2d2a9b09a68bd399$var$p(156, b.tag));
};
function $2d2a9b09a68bd399$var$xj(a, b) {
    $2d2a9b09a68bd399$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $2d2a9b09a68bd399$var$Pc(a, c, b);
    });
}
function $2d2a9b09a68bd399$var$sl(a, b) {
    return $2d2a9b09a68bd399$var$ac(a, b);
}
function $2d2a9b09a68bd399$var$Ol(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $2d2a9b09a68bd399$var$Pg(a, b, c, d) {
    return new $2d2a9b09a68bd399$var$Ol(a, b, c, d);
}
function $2d2a9b09a68bd399$var$Fj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $2d2a9b09a68bd399$var$Nl(a) {
    if ("function" === typeof a) return $2d2a9b09a68bd399$var$Fj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $2d2a9b09a68bd399$var$Da) return 11;
        if (a === $2d2a9b09a68bd399$var$Ga) return 14;
    }
    return 2;
}
function $2d2a9b09a68bd399$var$Lh(a, b) {
    var c = a.alternate;
    null === c ? (c = $2d2a9b09a68bd399$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $2d2a9b09a68bd399$var$Nh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $2d2a9b09a68bd399$var$Fj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $2d2a9b09a68bd399$var$ya:
            return $2d2a9b09a68bd399$var$Ph(c.children, e, f, b);
        case $2d2a9b09a68bd399$var$za:
            g = 8;
            e |= 8;
            break;
        case $2d2a9b09a68bd399$var$Aa:
            return a = $2d2a9b09a68bd399$var$Pg(12, c, b, e | 2), a.elementType = $2d2a9b09a68bd399$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $2d2a9b09a68bd399$var$Ea:
            return a = $2d2a9b09a68bd399$var$Pg(13, c, b, e), a.elementType = $2d2a9b09a68bd399$var$Ea, a.lanes = f, a;
        case $2d2a9b09a68bd399$var$Fa:
            return a = $2d2a9b09a68bd399$var$Pg(19, c, b, e), a.elementType = $2d2a9b09a68bd399$var$Fa, a.lanes = f, a;
        case $2d2a9b09a68bd399$var$Ia:
            return $2d2a9b09a68bd399$var$Wj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $2d2a9b09a68bd399$var$Ba:
                    g = 10;
                    break a;
                case $2d2a9b09a68bd399$var$Ca:
                    g = 9;
                    break a;
                case $2d2a9b09a68bd399$var$Da:
                    g = 11;
                    break a;
                case $2d2a9b09a68bd399$var$Ga:
                    g = 14;
                    break a;
                case $2d2a9b09a68bd399$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($2d2a9b09a68bd399$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $2d2a9b09a68bd399$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $2d2a9b09a68bd399$var$Ph(a, b, c, d) {
    a = $2d2a9b09a68bd399$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $2d2a9b09a68bd399$var$Wj(a, b, c, d) {
    a = $2d2a9b09a68bd399$var$Pg(22, a, d, b);
    a.elementType = $2d2a9b09a68bd399$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $2d2a9b09a68bd399$var$Mh(a, b, c) {
    a = $2d2a9b09a68bd399$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $2d2a9b09a68bd399$var$Oh(a, b, c) {
    b = $2d2a9b09a68bd399$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $2d2a9b09a68bd399$var$Pl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $2d2a9b09a68bd399$var$Lc(0);
    this.expirationTimes = $2d2a9b09a68bd399$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2d2a9b09a68bd399$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $2d2a9b09a68bd399$var$Ql(a, b, c, d, e, f, g, h, k) {
    a = new $2d2a9b09a68bd399$var$Pl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $2d2a9b09a68bd399$var$mc && (b |= 2);
    f = $2d2a9b09a68bd399$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $2d2a9b09a68bd399$var$oh(f);
    return a;
}
function $2d2a9b09a68bd399$var$Rl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2d2a9b09a68bd399$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $2d2a9b09a68bd399$var$Sl(a) {
    if (!a) return $2d2a9b09a68bd399$var$ig;
    a = a._reactInternals;
    a: {
        if ($2d2a9b09a68bd399$var$Vb(a) !== a || 1 !== a.tag) throw Error($2d2a9b09a68bd399$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($2d2a9b09a68bd399$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($2d2a9b09a68bd399$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($2d2a9b09a68bd399$var$mg(c)) return $2d2a9b09a68bd399$var$pg(a, c, b);
    }
    return b;
}
function $2d2a9b09a68bd399$var$Tl(a, b, c, d, e, f, g, h, k) {
    a = $2d2a9b09a68bd399$var$Ql(c, d, !0, a, e, f, g, h, k);
    a.context = $2d2a9b09a68bd399$var$Sl(null);
    c = a.current;
    d = $2d2a9b09a68bd399$var$zh();
    e = $2d2a9b09a68bd399$var$Ah(c);
    f = $2d2a9b09a68bd399$var$qh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $2d2a9b09a68bd399$var$rh(c, f, e);
    a.current.lanes = e;
    $2d2a9b09a68bd399$var$Mc(a, e, d);
    $2d2a9b09a68bd399$var$ql(a, d);
    return a;
}
function $2d2a9b09a68bd399$var$Ul(a, b, c, d) {
    var e = b.current, f = $2d2a9b09a68bd399$var$zh(), g = $2d2a9b09a68bd399$var$Ah(e);
    null !== $2d2a9b09a68bd399$var$B && "function" === typeof $2d2a9b09a68bd399$var$B.markRenderScheduled && $2d2a9b09a68bd399$var$B.markRenderScheduled(g);
    c = $2d2a9b09a68bd399$var$Sl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $2d2a9b09a68bd399$var$qh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $2d2a9b09a68bd399$var$rh(e, b, g);
    null !== a && ($2d2a9b09a68bd399$var$Bh(a, e, g, f), $2d2a9b09a68bd399$var$sh(a, e, g));
    return g;
}
function $2d2a9b09a68bd399$var$Vl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $2d2a9b09a68bd399$var$Wl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $2d2a9b09a68bd399$var$Xl(a, b) {
    $2d2a9b09a68bd399$var$Wl(a, b);
    (a = a.alternate) && $2d2a9b09a68bd399$var$Wl(a, b);
}
function $2d2a9b09a68bd399$var$Yl() {
    return null;
}
var $2d2a9b09a68bd399$var$Zl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $2d2a9b09a68bd399$var$$l(a) {
    this._internalRoot = a;
}
$2d2a9b09a68bd399$var$am.prototype.render = $2d2a9b09a68bd399$var$$l.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($2d2a9b09a68bd399$var$p(409));
    $2d2a9b09a68bd399$var$Ul(a, b, null, null);
};
$2d2a9b09a68bd399$var$am.prototype.unmount = $2d2a9b09a68bd399$var$$l.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $2d2a9b09a68bd399$var$Fl(function() {
            $2d2a9b09a68bd399$var$Ul(null, a, null, null);
        });
        b[$2d2a9b09a68bd399$var$If] = null;
    }
};
function $2d2a9b09a68bd399$var$am(a) {
    this._internalRoot = a;
}
$2d2a9b09a68bd399$var$am.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $2d2a9b09a68bd399$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $2d2a9b09a68bd399$var$dd.length && 0 !== b && b < $2d2a9b09a68bd399$var$dd[c].priority; c++);
        $2d2a9b09a68bd399$var$dd.splice(c, 0, a);
        0 === c && $2d2a9b09a68bd399$var$id(a);
    }
};
function $2d2a9b09a68bd399$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $2d2a9b09a68bd399$var$cm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $2d2a9b09a68bd399$var$dm() {}
function $2d2a9b09a68bd399$var$em(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $2d2a9b09a68bd399$var$Vl(g);
                f.call(a);
            };
        }
        var g = $2d2a9b09a68bd399$var$Tl(b, d, a, 0, null, !1, !1, "", $2d2a9b09a68bd399$var$dm);
        a._reactRootContainer = g;
        a[$2d2a9b09a68bd399$var$If] = g.current;
        $2d2a9b09a68bd399$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $2d2a9b09a68bd399$var$Fl();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $2d2a9b09a68bd399$var$Vl(k);
            h.call(a);
        };
    }
    var k = $2d2a9b09a68bd399$var$Ql(a, 0, !1, null, null, !1, !1, "", $2d2a9b09a68bd399$var$dm);
    a._reactRootContainer = k;
    a[$2d2a9b09a68bd399$var$If] = k.current;
    $2d2a9b09a68bd399$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $2d2a9b09a68bd399$var$Fl(function() {
        $2d2a9b09a68bd399$var$Ul(b, k, c, d);
    });
    return k;
}
function $2d2a9b09a68bd399$var$fm(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $2d2a9b09a68bd399$var$Vl(g);
                h.call(a);
            };
        }
        $2d2a9b09a68bd399$var$Ul(b, g, a, e);
    } else g = $2d2a9b09a68bd399$var$em(c, b, a, e, d);
    return $2d2a9b09a68bd399$var$Vl(g);
}
$2d2a9b09a68bd399$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $2d2a9b09a68bd399$var$Fc(b.pendingLanes);
                0 !== c && ($2d2a9b09a68bd399$var$Oc(b, c | 1), $2d2a9b09a68bd399$var$ql(b, $2d2a9b09a68bd399$var$A()), 0 === ($2d2a9b09a68bd399$var$K & 6) && ($2d2a9b09a68bd399$var$nk = $2d2a9b09a68bd399$var$A() + 500, $2d2a9b09a68bd399$var$xg()));
            }
            break;
        case 13:
            $2d2a9b09a68bd399$var$Fl(function() {
                var b = $2d2a9b09a68bd399$var$mh(a, 1);
                if (null !== b) {
                    var c = $2d2a9b09a68bd399$var$zh();
                    $2d2a9b09a68bd399$var$Bh(b, a, 1, c);
                }
            }), $2d2a9b09a68bd399$var$Xl(a, 1);
    }
};
$2d2a9b09a68bd399$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $2d2a9b09a68bd399$var$mh(a, 134217728);
        if (null !== b) {
            var c = $2d2a9b09a68bd399$var$zh();
            $2d2a9b09a68bd399$var$Bh(b, a, 134217728, c);
        }
        $2d2a9b09a68bd399$var$Xl(a, 134217728);
    }
};
$2d2a9b09a68bd399$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $2d2a9b09a68bd399$var$Ah(a), c = $2d2a9b09a68bd399$var$mh(a, b);
        if (null !== c) {
            var d = $2d2a9b09a68bd399$var$zh();
            $2d2a9b09a68bd399$var$Bh(c, a, b, d);
        }
        $2d2a9b09a68bd399$var$Xl(a, b);
    }
};
$2d2a9b09a68bd399$var$Vc = function() {
    return $2d2a9b09a68bd399$var$E;
};
$2d2a9b09a68bd399$var$Wc = function(a, b) {
    var c = $2d2a9b09a68bd399$var$E;
    try {
        return $2d2a9b09a68bd399$var$E = a, b();
    } finally{
        $2d2a9b09a68bd399$var$E = c;
    }
};
$2d2a9b09a68bd399$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $2d2a9b09a68bd399$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $2d2a9b09a68bd399$var$Db(d);
                        if (!e) throw Error($2d2a9b09a68bd399$var$p(90));
                        $2d2a9b09a68bd399$var$Wa(d);
                        $2d2a9b09a68bd399$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $2d2a9b09a68bd399$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $2d2a9b09a68bd399$var$eb(a, !!c.multiple, b, !1);
    }
};
$2d2a9b09a68bd399$var$Gb = $2d2a9b09a68bd399$var$El;
$2d2a9b09a68bd399$var$Hb = $2d2a9b09a68bd399$var$Fl;
var $2d2a9b09a68bd399$var$gm = {
    usingClientEntryPoint: !1,
    Events: [
        $2d2a9b09a68bd399$var$Cb,
        $2d2a9b09a68bd399$var$Ie,
        $2d2a9b09a68bd399$var$Db,
        $2d2a9b09a68bd399$var$Eb,
        $2d2a9b09a68bd399$var$Fb,
        $2d2a9b09a68bd399$var$El
    ]
}, $2d2a9b09a68bd399$var$hm = {
    findFiberByHostInstance: $2d2a9b09a68bd399$var$jd,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $2d2a9b09a68bd399$var$u({}, a, {
            getLaneLabelMap: $2d2a9b09a68bd399$var$pc,
            injectProfilingHooks: $2d2a9b09a68bd399$var$oc
        }), $2d2a9b09a68bd399$var$kc = b.inject(a), $2d2a9b09a68bd399$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $2d2a9b09a68bd399$var$hm.bundleType,
    version: $2d2a9b09a68bd399$var$hm.version,
    rendererPackageName: $2d2a9b09a68bd399$var$hm.rendererPackageName,
    rendererConfig: $2d2a9b09a68bd399$var$hm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $2d2a9b09a68bd399$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $2d2a9b09a68bd399$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $2d2a9b09a68bd399$var$hm.findFiberByHostInstance || $2d2a9b09a68bd399$var$Yl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
});
$2d2a9b09a68bd399$export$ae55be85d98224ed = $2d2a9b09a68bd399$var$gm;
$2d2a9b09a68bd399$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$2d2a9b09a68bd399$var$bm(b)) throw Error($2d2a9b09a68bd399$var$p(200));
    return $2d2a9b09a68bd399$var$Rl(a, b, null, c);
};
$2d2a9b09a68bd399$export$882461b6382ed46c = function(a, b) {
    if (!$2d2a9b09a68bd399$var$bm(a)) throw Error($2d2a9b09a68bd399$var$p(299));
    var c = !1, d = "", e = $2d2a9b09a68bd399$var$Zl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $2d2a9b09a68bd399$var$Ql(a, 1, !1, null, null, c, !1, d, e);
    a[$2d2a9b09a68bd399$var$If] = b.current;
    $2d2a9b09a68bd399$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $2d2a9b09a68bd399$var$$l(b);
};
$2d2a9b09a68bd399$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($2d2a9b09a68bd399$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($2d2a9b09a68bd399$var$p(268, a));
    }
    a = $2d2a9b09a68bd399$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$2d2a9b09a68bd399$export$cd75ccfd720a3cd4 = function(a) {
    return $2d2a9b09a68bd399$var$Fl(a);
};
$2d2a9b09a68bd399$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$2d2a9b09a68bd399$var$cm(b)) throw Error($2d2a9b09a68bd399$var$p(200));
    return $2d2a9b09a68bd399$var$fm(null, a, b, !0, c);
};
$2d2a9b09a68bd399$export$757ceba2d55c277e = function(a, b, c) {
    if (!$2d2a9b09a68bd399$var$bm(a)) throw Error($2d2a9b09a68bd399$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $2d2a9b09a68bd399$var$Zl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $2d2a9b09a68bd399$var$Tl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$2d2a9b09a68bd399$var$If] = b.current;
    $2d2a9b09a68bd399$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $2d2a9b09a68bd399$var$am(b);
};
$2d2a9b09a68bd399$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$2d2a9b09a68bd399$var$cm(b)) throw Error($2d2a9b09a68bd399$var$p(200));
    return $2d2a9b09a68bd399$var$fm(null, a, b, !1, c);
};
$2d2a9b09a68bd399$export$502457920280e6be = function(a) {
    if (!$2d2a9b09a68bd399$var$cm(a)) throw Error($2d2a9b09a68bd399$var$p(40));
    return a._reactRootContainer ? ($2d2a9b09a68bd399$var$Fl(function() {
        $2d2a9b09a68bd399$var$fm(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$2d2a9b09a68bd399$var$If] = null;
        });
    }), !0) : !1;
};
$2d2a9b09a68bd399$export$c78a37762a8d58e1 = $2d2a9b09a68bd399$var$El;
$2d2a9b09a68bd399$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$2d2a9b09a68bd399$var$cm(c)) throw Error($2d2a9b09a68bd399$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($2d2a9b09a68bd399$var$p(38));
    return $2d2a9b09a68bd399$var$fm(a, b, c, !1, d);
};
$2d2a9b09a68bd399$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("5uXOq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("boLIc"));

});
parcelRegister("boLIc", function(module, exports) {

$parcel$export(module.exports, "Children", () => $84c6f22c1328fe7e$export$dca3b0875bd9a954, (v) => $84c6f22c1328fe7e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $84c6f22c1328fe7e$export$16fa2f45be04daa8, (v) => $84c6f22c1328fe7e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $84c6f22c1328fe7e$export$ffb0004e005737fa, (v) => $84c6f22c1328fe7e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $84c6f22c1328fe7e$export$e2c29f18771995cb, (v) => $84c6f22c1328fe7e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $84c6f22c1328fe7e$export$221d75b3f55bb0bd, (v) => $84c6f22c1328fe7e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $84c6f22c1328fe7e$export$5f8d39834fd61797, (v) => $84c6f22c1328fe7e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $84c6f22c1328fe7e$export$74bf444e3cd11ea5, (v) => $84c6f22c1328fe7e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $84c6f22c1328fe7e$export$ae55be85d98224ed, (v) => $84c6f22c1328fe7e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $84c6f22c1328fe7e$export$e530037191fcd5d7, (v) => $84c6f22c1328fe7e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $84c6f22c1328fe7e$export$fd42f52fd3ae1109, (v) => $84c6f22c1328fe7e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $84c6f22c1328fe7e$export$c8a8987d4410bf2d, (v) => $84c6f22c1328fe7e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $84c6f22c1328fe7e$export$d38cd72104c1f0e9, (v) => $84c6f22c1328fe7e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $84c6f22c1328fe7e$export$7d1e3a5e95ceca43, (v) => $84c6f22c1328fe7e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $84c6f22c1328fe7e$export$257a8862b851cb5b, (v) => $84c6f22c1328fe7e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $84c6f22c1328fe7e$export$a8257692ac88316c, (v) => $84c6f22c1328fe7e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $84c6f22c1328fe7e$export$488013bae63b21da, (v) => $84c6f22c1328fe7e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $84c6f22c1328fe7e$export$7c73462e0d25e514, (v) => $84c6f22c1328fe7e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $84c6f22c1328fe7e$export$7568632d0d33d16d, (v) => $84c6f22c1328fe7e$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $84c6f22c1328fe7e$export$88948ce120ea2619, (v) => $84c6f22c1328fe7e$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $84c6f22c1328fe7e$export$35808ee640e87ca7, (v) => $84c6f22c1328fe7e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $84c6f22c1328fe7e$export$fae74005e78b1a27, (v) => $84c6f22c1328fe7e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e, (v) => $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $84c6f22c1328fe7e$export$6a7bc4e911dc01cf, (v) => $84c6f22c1328fe7e$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $84c6f22c1328fe7e$export$6d9c69b0de29b591, (v) => $84c6f22c1328fe7e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $84c6f22c1328fe7e$export$f680877a34711e37, (v) => $84c6f22c1328fe7e$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $84c6f22c1328fe7e$export$d5a552a76deda3c2, (v) => $84c6f22c1328fe7e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $84c6f22c1328fe7e$export$aaabe4eda9ed9969, (v) => $84c6f22c1328fe7e$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $84c6f22c1328fe7e$export$e5c5a5f917a5871c, (v) => $84c6f22c1328fe7e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $84c6f22c1328fe7e$export$1538c33de8887b59, (v) => $84c6f22c1328fe7e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $84c6f22c1328fe7e$export$13e3392192263954, (v) => $84c6f22c1328fe7e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $84c6f22c1328fe7e$export$b8f5890fc79d6aca, (v) => $84c6f22c1328fe7e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $84c6f22c1328fe7e$export$60241385465d0a34, (v) => $84c6f22c1328fe7e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $84c6f22c1328fe7e$export$306c0aa65ff9ec16, (v) => $84c6f22c1328fe7e$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $84c6f22c1328fe7e$export$7b286972b8d8ccbf, (v) => $84c6f22c1328fe7e$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $84c6f22c1328fe7e$export$83d89fbfd8236492, (v) => $84c6f22c1328fe7e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84c6f22c1328fe7e$export$dca3b0875bd9a954;
var $84c6f22c1328fe7e$export$16fa2f45be04daa8;
var $84c6f22c1328fe7e$export$ffb0004e005737fa;
var $84c6f22c1328fe7e$export$e2c29f18771995cb;
var $84c6f22c1328fe7e$export$221d75b3f55bb0bd;
var $84c6f22c1328fe7e$export$5f8d39834fd61797;
var $84c6f22c1328fe7e$export$74bf444e3cd11ea5;
var $84c6f22c1328fe7e$export$ae55be85d98224ed;
var $84c6f22c1328fe7e$export$e530037191fcd5d7;
var $84c6f22c1328fe7e$export$fd42f52fd3ae1109;
var $84c6f22c1328fe7e$export$c8a8987d4410bf2d;
var $84c6f22c1328fe7e$export$d38cd72104c1f0e9;
var $84c6f22c1328fe7e$export$7d1e3a5e95ceca43;
var $84c6f22c1328fe7e$export$257a8862b851cb5b;
var $84c6f22c1328fe7e$export$a8257692ac88316c;
var $84c6f22c1328fe7e$export$488013bae63b21da;
var $84c6f22c1328fe7e$export$7c73462e0d25e514;
var $84c6f22c1328fe7e$export$7568632d0d33d16d;
var $84c6f22c1328fe7e$export$88948ce120ea2619;
var $84c6f22c1328fe7e$export$35808ee640e87ca7;
var $84c6f22c1328fe7e$export$fae74005e78b1a27;
var $84c6f22c1328fe7e$export$dc8fbce3eb94dc1e;
var $84c6f22c1328fe7e$export$6a7bc4e911dc01cf;
var $84c6f22c1328fe7e$export$6d9c69b0de29b591;
var $84c6f22c1328fe7e$export$f680877a34711e37;
var $84c6f22c1328fe7e$export$d5a552a76deda3c2;
var $84c6f22c1328fe7e$export$aaabe4eda9ed9969;
var $84c6f22c1328fe7e$export$e5c5a5f917a5871c;
var $84c6f22c1328fe7e$export$1538c33de8887b59;
var $84c6f22c1328fe7e$export$13e3392192263954;
var $84c6f22c1328fe7e$export$b8f5890fc79d6aca;
var $84c6f22c1328fe7e$export$60241385465d0a34;
var $84c6f22c1328fe7e$export$306c0aa65ff9ec16;
var $84c6f22c1328fe7e$export$7b286972b8d8ccbf;
var $84c6f22c1328fe7e$export$83d89fbfd8236492;
'use strict';
var $84c6f22c1328fe7e$var$l = Symbol.for("react.element"), $84c6f22c1328fe7e$var$n = Symbol.for("react.portal"), $84c6f22c1328fe7e$var$p = Symbol.for("react.fragment"), $84c6f22c1328fe7e$var$q = Symbol.for("react.strict_mode"), $84c6f22c1328fe7e$var$r = Symbol.for("react.profiler"), $84c6f22c1328fe7e$var$t = Symbol.for("react.provider"), $84c6f22c1328fe7e$var$u = Symbol.for("react.context"), $84c6f22c1328fe7e$var$v = Symbol.for("react.forward_ref"), $84c6f22c1328fe7e$var$w = Symbol.for("react.suspense"), $84c6f22c1328fe7e$var$x = Symbol.for("react.memo"), $84c6f22c1328fe7e$var$y = Symbol.for("react.lazy"), $84c6f22c1328fe7e$var$z = Symbol.iterator;
function $84c6f22c1328fe7e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $84c6f22c1328fe7e$var$z && a[$84c6f22c1328fe7e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $84c6f22c1328fe7e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $84c6f22c1328fe7e$var$C = Object.assign, $84c6f22c1328fe7e$var$D = {};
function $84c6f22c1328fe7e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84c6f22c1328fe7e$var$D;
    this.updater = e || $84c6f22c1328fe7e$var$B;
}
$84c6f22c1328fe7e$var$E.prototype.isReactComponent = {};
$84c6f22c1328fe7e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$84c6f22c1328fe7e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $84c6f22c1328fe7e$var$F() {}
$84c6f22c1328fe7e$var$F.prototype = $84c6f22c1328fe7e$var$E.prototype;
function $84c6f22c1328fe7e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $84c6f22c1328fe7e$var$D;
    this.updater = e || $84c6f22c1328fe7e$var$B;
}
var $84c6f22c1328fe7e$var$H = $84c6f22c1328fe7e$var$G.prototype = new $84c6f22c1328fe7e$var$F;
$84c6f22c1328fe7e$var$H.constructor = $84c6f22c1328fe7e$var$G;
$84c6f22c1328fe7e$var$C($84c6f22c1328fe7e$var$H, $84c6f22c1328fe7e$var$E.prototype);
$84c6f22c1328fe7e$var$H.isPureReactComponent = !0;
var $84c6f22c1328fe7e$var$I = Array.isArray, $84c6f22c1328fe7e$var$J = Object.prototype.hasOwnProperty, $84c6f22c1328fe7e$var$K = {
    current: null
}, $84c6f22c1328fe7e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $84c6f22c1328fe7e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$84c6f22c1328fe7e$var$J.call(b, d) && !$84c6f22c1328fe7e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $84c6f22c1328fe7e$var$K.current
    };
}
function $84c6f22c1328fe7e$var$N(a, b) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $84c6f22c1328fe7e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $84c6f22c1328fe7e$var$l;
}
function $84c6f22c1328fe7e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $84c6f22c1328fe7e$var$P = /\/+/g;
function $84c6f22c1328fe7e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $84c6f22c1328fe7e$var$escape("" + a.key) : b.toString(36);
}
function $84c6f22c1328fe7e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $84c6f22c1328fe7e$var$l:
                case $84c6f22c1328fe7e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $84c6f22c1328fe7e$var$Q(h, 0) : d, $84c6f22c1328fe7e$var$I(c) ? (e = "", null != a && (e = a.replace($84c6f22c1328fe7e$var$P, "$&/") + "/"), $84c6f22c1328fe7e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($84c6f22c1328fe7e$var$O(c) && (c = $84c6f22c1328fe7e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($84c6f22c1328fe7e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($84c6f22c1328fe7e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $84c6f22c1328fe7e$var$Q(k, g);
        h += $84c6f22c1328fe7e$var$R(k, b, e, f, c);
    }
    else if (f = $84c6f22c1328fe7e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $84c6f22c1328fe7e$var$Q(k, g++), h += $84c6f22c1328fe7e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $84c6f22c1328fe7e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $84c6f22c1328fe7e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $84c6f22c1328fe7e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $84c6f22c1328fe7e$var$U = {
    current: null
}, $84c6f22c1328fe7e$var$V = {
    transition: null
}, $84c6f22c1328fe7e$var$W = {
    ReactCurrentDispatcher: $84c6f22c1328fe7e$var$U,
    ReactCurrentBatchConfig: $84c6f22c1328fe7e$var$V,
    ReactCurrentOwner: $84c6f22c1328fe7e$var$K
};
$84c6f22c1328fe7e$export$dca3b0875bd9a954 = {
    map: $84c6f22c1328fe7e$var$S,
    forEach: function(a, b, e) {
        $84c6f22c1328fe7e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $84c6f22c1328fe7e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $84c6f22c1328fe7e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$84c6f22c1328fe7e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$84c6f22c1328fe7e$export$16fa2f45be04daa8 = $84c6f22c1328fe7e$var$E;
$84c6f22c1328fe7e$export$ffb0004e005737fa = $84c6f22c1328fe7e$var$p;
$84c6f22c1328fe7e$export$e2c29f18771995cb = $84c6f22c1328fe7e$var$r;
$84c6f22c1328fe7e$export$221d75b3f55bb0bd = $84c6f22c1328fe7e$var$G;
$84c6f22c1328fe7e$export$5f8d39834fd61797 = $84c6f22c1328fe7e$var$q;
$84c6f22c1328fe7e$export$74bf444e3cd11ea5 = $84c6f22c1328fe7e$var$w;
$84c6f22c1328fe7e$export$ae55be85d98224ed = $84c6f22c1328fe7e$var$W;
$84c6f22c1328fe7e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $84c6f22c1328fe7e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $84c6f22c1328fe7e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$84c6f22c1328fe7e$var$J.call(b, f) && !$84c6f22c1328fe7e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $84c6f22c1328fe7e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$84c6f22c1328fe7e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $84c6f22c1328fe7e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $84c6f22c1328fe7e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$84c6f22c1328fe7e$export$c8a8987d4410bf2d = $84c6f22c1328fe7e$var$M;
$84c6f22c1328fe7e$export$d38cd72104c1f0e9 = function(a) {
    var b = $84c6f22c1328fe7e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$84c6f22c1328fe7e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$84c6f22c1328fe7e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$v,
        render: a
    };
};
$84c6f22c1328fe7e$export$a8257692ac88316c = $84c6f22c1328fe7e$var$O;
$84c6f22c1328fe7e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $84c6f22c1328fe7e$var$T
    };
};
$84c6f22c1328fe7e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $84c6f22c1328fe7e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$84c6f22c1328fe7e$export$7568632d0d33d16d = function(a) {
    var b = $84c6f22c1328fe7e$var$V.transition;
    $84c6f22c1328fe7e$var$V.transition = {};
    try {
        a();
    } finally{
        $84c6f22c1328fe7e$var$V.transition = b;
    }
};
$84c6f22c1328fe7e$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$84c6f22c1328fe7e$export$35808ee640e87ca7 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useCallback(a, b);
};
$84c6f22c1328fe7e$export$fae74005e78b1a27 = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useContext(a);
};
$84c6f22c1328fe7e$export$dc8fbce3eb94dc1e = function() {};
$84c6f22c1328fe7e$export$6a7bc4e911dc01cf = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useDeferredValue(a);
};
$84c6f22c1328fe7e$export$6d9c69b0de29b591 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useEffect(a, b);
};
$84c6f22c1328fe7e$export$f680877a34711e37 = function() {
    return $84c6f22c1328fe7e$var$U.current.useId();
};
$84c6f22c1328fe7e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useImperativeHandle(a, b, e);
};
$84c6f22c1328fe7e$export$aaabe4eda9ed9969 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useInsertionEffect(a, b);
};
$84c6f22c1328fe7e$export$e5c5a5f917a5871c = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useLayoutEffect(a, b);
};
$84c6f22c1328fe7e$export$1538c33de8887b59 = function(a, b) {
    return $84c6f22c1328fe7e$var$U.current.useMemo(a, b);
};
$84c6f22c1328fe7e$export$13e3392192263954 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useReducer(a, b, e);
};
$84c6f22c1328fe7e$export$b8f5890fc79d6aca = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useRef(a);
};
$84c6f22c1328fe7e$export$60241385465d0a34 = function(a) {
    return $84c6f22c1328fe7e$var$U.current.useState(a);
};
$84c6f22c1328fe7e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $84c6f22c1328fe7e$var$U.current.useSyncExternalStore(a, b, e);
};
$84c6f22c1328fe7e$export$7b286972b8d8ccbf = function() {
    return $84c6f22c1328fe7e$var$U.current.useTransition();
};
$84c6f22c1328fe7e$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("6n3fk", function(module, exports) {
/**
 * Expose `pathToRegexp`.
 */ module.exports = $4a3768b3382b8eb1$var$pathToRegexp;
module.exports.parse = $4a3768b3382b8eb1$var$parse;
module.exports.compile = $4a3768b3382b8eb1$var$compile;
module.exports.tokensToFunction = $4a3768b3382b8eb1$var$tokensToFunction;
module.exports.tokensToRegExp = $4a3768b3382b8eb1$var$tokensToRegExp;
/**
 * Default configs.
 */ var $4a3768b3382b8eb1$var$DEFAULT_DELIMITER = '/';
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $4a3768b3382b8eb1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $4a3768b3382b8eb1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || $4a3768b3382b8eb1$var$DEFAULT_DELIMITER;
    var whitelist = options && options.whitelist || undefined;
    var pathEscaped = false;
    var res;
    while((res = $4a3768b3382b8eb1$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = '';
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            var c = path[k];
            var matches = whitelist ? whitelist.indexOf(c) > -1 : true;
            if (matches) {
                prev = c;
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var pattern = capture || group;
        var delimiter = prev || defaultDelimiter;
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            pattern: pattern ? $4a3768b3382b8eb1$var$escapeGroup(pattern) : '[^' + $4a3768b3382b8eb1$var$escapeString(delimiter === defaultDelimiter ? delimiter : delimiter + defaultDelimiter) + ']+?'
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $4a3768b3382b8eb1$var$compile(str, options) {
    return $4a3768b3382b8eb1$var$tokensToFunction($4a3768b3382b8eb1$var$parse(str, options));
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $4a3768b3382b8eb1$var$tokensToFunction(tokens) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    return function(data, options) {
        var path = '';
        var encode = options && options.encode || encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) continue;
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $4a3768b3382b8eb1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $4a3768b3382b8eb1$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $4a3768b3382b8eb1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $4a3768b3382b8eb1$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $4a3768b3382b8eb1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($4a3768b3382b8eb1$var$pathToRegexp(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $4a3768b3382b8eb1$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $4a3768b3382b8eb1$var$stringToRegexp(path, keys, options) {
    return $4a3768b3382b8eb1$var$tokensToRegExp($4a3768b3382b8eb1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $4a3768b3382b8eb1$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = options.delimiter || $4a3768b3382b8eb1$var$DEFAULT_DELIMITER;
    var endsWith = [].concat(options.endsWith || []).map($4a3768b3382b8eb1$var$escapeString).concat('$').join('|');
    var route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $4a3768b3382b8eb1$var$escapeString(token);
        else {
            var capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $4a3768b3382b8eb1$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (!token.prefix) route += '(' + capture + ')?';
                else route += '(?:' + $4a3768b3382b8eb1$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $4a3768b3382b8eb1$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + $4a3768b3382b8eb1$var$escapeString(delimiter) + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === 'string' ? endToken[endToken.length - 1] === delimiter : endToken === undefined;
        if (!strict) route += '(?:' + $4a3768b3382b8eb1$var$escapeString(delimiter) + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + $4a3768b3382b8eb1$var$escapeString(delimiter) + '|' + endsWith + ')';
    }
    return new RegExp(route, $4a3768b3382b8eb1$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $4a3768b3382b8eb1$var$pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return $4a3768b3382b8eb1$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $4a3768b3382b8eb1$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $4a3768b3382b8eb1$var$stringToRegexp(/** @type {string} */ path, keys, options);
}

});

parcelRegister("5CIBP", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $41831ac912a8b6c1$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "jsx", () => $41831ac912a8b6c1$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("6krxd")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("6krxd")).w);
$parcel$export(module.exports, "css", () => (parcelRequire("bPYrV")).default);

var $2jS8g = parcelRequire("2jS8g");

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("lzhmV");

var $6krxd = parcelRequire("6krxd");

var $5VNZY = parcelRequire("5VNZY");

var $8ESZd = parcelRequire("8ESZd");

var $2Ebme = parcelRequire("2Ebme");

var $bPYrV = parcelRequire("bPYrV");
var $41831ac912a8b6c1$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $6krxd.h).call(props, 'css')) // $FlowFixMe
    return (0, $5uXOq.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6krxd.E);
    createElementArgArray[1] = (0, $6krxd.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $5uXOq.createElement).apply(null, createElementArgArray);
};
var $41831ac912a8b6c1$var$warnedAboutCssPropForGlobal = false;
var $41831ac912a8b6c1$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6krxd.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $6krxd.T).Consumer, null, function(theme) {
        var serialized = (0, $8ESZd.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $5uXOq.createElement)($41831ac912a8b6c1$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $8ESZd.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $5uXOq.createElement)($41831ac912a8b6c1$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $41831ac912a8b6c1$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $2jS8g.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $2Ebme.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $5VNZY.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $5uXOq.Component));
var $41831ac912a8b6c1$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $bPYrV.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $41831ac912a8b6c1$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $41831ac912a8b6c1$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $5VNZY.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $41831ac912a8b6c1$var$Noop = function Noop() {
    return null;
};
var $41831ac912a8b6c1$export$9b9c0f9d9f3552b8 = (0, $6krxd.w)(function(props, context) {
    return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $6krxd.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $8ESZd.serializeStyles)(args, context.registered);
            (0, $5VNZY.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $41831ac912a8b6c1$var$merge(context.registered, css, $41831ac912a8b6c1$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $5uXOq.createElement)($41831ac912a8b6c1$var$Noop, null);
        return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("lzhmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb3a56e886afc8b1$export$2e2bcd8739ae039);

var $2Ebme = parcelRequire("2Ebme");

var $4J7hP = parcelRequire("4J7hP");
parcelRequire("kh1Ye");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $fb3a56e886afc8b1$var$delimiter = '/*|*/';
var $fb3a56e886afc8b1$var$needle = $fb3a56e886afc8b1$var$delimiter + '}';
function $fb3a56e886afc8b1$var$toSheet(block) {
    if (block) $fb3a56e886afc8b1$var$Sheet.current.insert(block + '}');
}
var $fb3a56e886afc8b1$var$Sheet = {
    current: null
};
var $fb3a56e886afc8b1$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $fb3a56e886afc8b1$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $fb3a56e886afc8b1$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $fb3a56e886afc8b1$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $fb3a56e886afc8b1$var$delimiter : '');
            }
        case -2:
            content.split($fb3a56e886afc8b1$var$needle).forEach($fb3a56e886afc8b1$var$toSheet);
    }
};
var $fb3a56e886afc8b1$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $4J7hP.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($fb3a56e886afc8b1$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $fb3a56e886afc8b1$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $2Ebme.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $fb3a56e886afc8b1$export$2e2bcd8739ae039 = $fb3a56e886afc8b1$var$createCache;

});
parcelRegister("2Ebme", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $1ed8208df2345ee4$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $1ed8208df2345ee4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $1ed8208df2345ee4$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $1ed8208df2345ee4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($1ed8208df2345ee4$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $1ed8208df2345ee4$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("4J7hP", function(module, exports) {

$parcel$export(module.exports, "default", () => $371104590ce99c47$export$2e2bcd8739ae039);
function $371104590ce99c47$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $371104590ce99c47$export$2e2bcd8739ae039 = $371104590ce99c47$var$stylis_min;

});

parcelRegister("kh1Ye", function(module, exports) {
var $ec26ec7fd7cee6e9$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $ec26ec7fd7cee6e9$export$2e2bcd8739ae039 = $ec26ec7fd7cee6e9$var$weakMemoize;

});


parcelRegister("6krxd", function(module, exports) {

$parcel$export(module.exports, "h", () => $49b9f826d9f8f00c$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $49b9f826d9f8f00c$export$971d5caa766a69d7);
$parcel$export(module.exports, "w", () => $49b9f826d9f8f00c$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $49b9f826d9f8f00c$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $49b9f826d9f8f00c$export$a9c23c6ac3fc3eca);
parcelRequire("2jS8g");

var $5uXOq = parcelRequire("5uXOq");

var $lzhmV = parcelRequire("lzhmV");

var $5VNZY = parcelRequire("5VNZY");

var $8ESZd = parcelRequire("8ESZd");
var $49b9f826d9f8f00c$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $49b9f826d9f8f00c$var$EmotionCacheContext = /*#__PURE__*/ (0, $5uXOq.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $lzhmV.default)() : null);
var $49b9f826d9f8f00c$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
var $49b9f826d9f8f00c$export$e7094788287c5e9b = $49b9f826d9f8f00c$var$EmotionCacheContext.Provider;
var $49b9f826d9f8f00c$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $5uXOq.createElement)($49b9f826d9f8f00c$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $49b9f826d9f8f00c$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $49b9f826d9f8f00c$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $49b9f826d9f8f00c$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $49b9f826d9f8f00c$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($49b9f826d9f8f00c$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$49b9f826d9f8f00c$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $49b9f826d9f8f00c$var$Noop = function Noop() {
    return null;
};
var $49b9f826d9f8f00c$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$49b9f826d9f8f00c$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $5VNZY.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8ESZd.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $5VNZY.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($49b9f826d9f8f00c$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $49b9f826d9f8f00c$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $5uXOq.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $5uXOq.createElement)($49b9f826d9f8f00c$var$Noop, null);
    return /*#__PURE__*/ (0, $5uXOq.createElement)((0, $5uXOq.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $49b9f826d9f8f00c$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $49b9f826d9f8f00c$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $5uXOq.createElement)($49b9f826d9f8f00c$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $49b9f826d9f8f00c$var$render(cache, props, theme, ref);
    });
    return $49b9f826d9f8f00c$var$render(cache, props, null, ref);
});

});
parcelRegister("5VNZY", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $45190f46bb00ecff$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $45190f46bb00ecff$export$6f077d94b33a01aa);
var $45190f46bb00ecff$var$isBrowser = true;
function $45190f46bb00ecff$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $45190f46bb00ecff$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $45190f46bb00ecff$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("8ESZd", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $64dcb64a87607e2c$export$6321afa313b251b5);

var $20Q6T = parcelRequire("20Q6T");

var $3VJsK = parcelRequire("3VJsK");

var $icCEG = parcelRequire("icCEG");
var $64dcb64a87607e2c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $64dcb64a87607e2c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $64dcb64a87607e2c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $64dcb64a87607e2c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $64dcb64a87607e2c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $64dcb64a87607e2c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $64dcb64a87607e2c$var$processStyleName = (0, $icCEG.default)(function(styleName) {
    return $64dcb64a87607e2c$var$isCustomProperty(styleName) ? styleName : styleName.replace($64dcb64a87607e2c$var$hyphenateRegex, '-$&').toLowerCase();
});
var $64dcb64a87607e2c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($64dcb64a87607e2c$var$animationRegex, function(match, p1, p2) {
                $64dcb64a87607e2c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $64dcb64a87607e2c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3VJsK.default)[key] !== 1 && !$64dcb64a87607e2c$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $64dcb64a87607e2c$var$contentValuePattern, $64dcb64a87607e2c$var$contentValues, $64dcb64a87607e2c$var$oldProcessStyleValue, $64dcb64a87607e2c$var$msPattern, $64dcb64a87607e2c$var$hyphenPattern, $64dcb64a87607e2c$var$hyphenatedCache;
var $64dcb64a87607e2c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $64dcb64a87607e2c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $64dcb64a87607e2c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $64dcb64a87607e2c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $64dcb64a87607e2c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $64dcb64a87607e2c$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $64dcb64a87607e2c$var$cursor;
                var result = interpolation(mergedProps);
                $64dcb64a87607e2c$var$cursor = previousCursor;
                return $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $64dcb64a87607e2c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($64dcb64a87607e2c$var$isProcessableValue(value)) string += $64dcb64a87607e2c$var$processStyleName(_key) + ":" + $64dcb64a87607e2c$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($64dcb64a87607e2c$var$isProcessableValue(value[_i])) string += $64dcb64a87607e2c$var$processStyleName(_key) + ":" + $64dcb64a87607e2c$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $64dcb64a87607e2c$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $64dcb64a87607e2c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $64dcb64a87607e2c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $64dcb64a87607e2c$var$cursor;
var $64dcb64a87607e2c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $64dcb64a87607e2c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $64dcb64a87607e2c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $64dcb64a87607e2c$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $64dcb64a87607e2c$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $20Q6T.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $64dcb64a87607e2c$var$cursor
    };
};

});
parcelRegister("20Q6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $177400d426a5fbd0$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $177400d426a5fbd0$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $177400d426a5fbd0$export$2e2bcd8739ae039 = $177400d426a5fbd0$var$murmur2;

});

parcelRegister("3VJsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc9f5e78ef3305c$export$2e2bcd8739ae039);
var $2dc9f5e78ef3305c$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2dc9f5e78ef3305c$export$2e2bcd8739ae039 = $2dc9f5e78ef3305c$var$unitlessKeys;

});

parcelRegister("icCEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d407551e3231066b$export$2e2bcd8739ae039);
function $d407551e3231066b$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $d407551e3231066b$export$2e2bcd8739ae039 = $d407551e3231066b$var$memoize;

});



parcelRegister("bPYrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $89e3591b7d95e04b$export$2e2bcd8739ae039);

var $8ESZd = parcelRequire("8ESZd");
function $89e3591b7d95e04b$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8ESZd.serializeStyles)(args);
}
var $89e3591b7d95e04b$export$2e2bcd8739ae039 = $89e3591b7d95e04b$var$css;

});


parcelRegister("bC2fB", function(module, exports) {

$parcel$export(module.exports, "connect", () => $ac0b161905bf5bbf$export$64605811ab45167f);
$parcel$export(module.exports, "Provider8Wrapped", () => $ac0b161905bf5bbf$export$a55ac1850eecafb9);
$parcel$export(module.exports, "Provider", () => $ac0b161905bf5bbf$export$2881499e37b75b9a);
$parcel$export(module.exports, "createProvider", () => $ac0b161905bf5bbf$export$500fbc0cd14cdbaa);
$parcel$export(module.exports, "useStore", () => (parcelRequire("gJKSD")).useStore);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("d0Ii5")).useSelector);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("02M5b")).useDispatch);
$parcel$export(module.exports, "extractFactoryFunction", () => (parcelRequire("cAUzv")).extractFactoryFunction);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => (parcelRequire("cAUzv")).mapStateToPropsWithErrorHandling);

var $5uXOq = parcelRequire("5uXOq");

var $7Z8iG = parcelRequire("7Z8iG");
parcelRequire("kVVL1");
var $9GYMs = parcelRequire("9GYMs");
var $9UgEX = parcelRequire("9UgEX");
var $02M5b = parcelRequire("02M5b");
var $d0Ii5 = parcelRequire("d0Ii5");
var $gJKSD = parcelRequire("gJKSD");

var $9Hjn4 = parcelRequire("9Hjn4");

var $cAUzv = parcelRequire("cAUzv");

var $cAUzv = parcelRequire("cAUzv");
const $ac0b161905bf5bbf$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>{
        const { context: context, storeKey: storeKey, forceV8: forceV8, skipStability: skipStability, ...restOptions } = options;
        const stabilizedMapping = skipStability ? mapStateToProps : (0, $9Hjn4.withStability)(component, 'mapStateToProps', mapStateToProps);
        const stabilizedMergeProps = skipStability ? mergeProps : (0, $9Hjn4.withStability)(component, 'mergeProps', mergeProps);
        const safeMapStateToProps = (0, $cAUzv.mapStateToPropsWithErrorHandling)(stabilizedMapping);
        const ResultComponent = (0, $9GYMs.default)(safeMapStateToProps, mapDispatchToProps, stabilizedMergeProps, {
            context: context,
            ...restOptions
        })(component);
        ResultComponent.displayName = `Connect(${component.displayName || component.name || typeof component})`;
        return ResultComponent;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
const $ac0b161905bf5bbf$export$a55ac1850eecafb9 = ({ store: store, children: children, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Z8iG.Provider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UgEX.default), {
        store: store,
        context: context
    }, children));
const $ac0b161905bf5bbf$export$2881499e37b75b9a = (0, $9UgEX.default);
const $ac0b161905bf5bbf$var$makeWrappedProvider8 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(context)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ac0b161905bf5bbf$export$2881499e37b75b9a, {
            context: context,
            ...props
        });
const $ac0b161905bf5bbf$export$500fbc0cd14cdbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
context)=>$ac0b161905bf5bbf$var$makeWrappedProvider8(context);

});
parcelRegister("kVVL1", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("9GYMs")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("02M5b")).createDispatchHook);
$parcel$export(module.exports, "Provider", () => (parcelRequire("9UgEX")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("02M5b")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("d0Ii5")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("gJKSD")).useStore);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $8tyNL = parcelRequire("8tyNL");

var $bDWQ3 = parcelRequire("bDWQ3");
parcelRequire("jBwY2");
var $7nsd3 = parcelRequire("7nsd3");

var $dDtRT = parcelRequire("dDtRT");

var $d0Ii5 = parcelRequire("d0Ii5");

var $9GYMs = parcelRequire("9GYMs");
parcelRequire("lsmC4");
(0, $d0Ii5.initializeUseSelector)((0, $bDWQ3.useSyncExternalStoreWithSelector));
(0, $9GYMs.initializeConnect)((0, $8tyNL.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $dDtRT.setBatch)((0, $7nsd3.unstable_batchedUpdates));

});
parcelRegister("jBwY2", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("7nsd3")).unstable_batchedUpdates);

var $7nsd3 = parcelRequire("7nsd3");

});

parcelRegister("dDtRT", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $9ed6161b8e8656d0$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $9ed6161b8e8656d0$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $9ed6161b8e8656d0$var$defaultNoopBatch(callback) {
    callback();
}
let $9ed6161b8e8656d0$var$batch = $9ed6161b8e8656d0$var$defaultNoopBatch; // Allow injecting another batching function later
const $9ed6161b8e8656d0$export$4b9874722d0da7bc = (newBatch)=>$9ed6161b8e8656d0$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $9ed6161b8e8656d0$export$fc47d4c0ba3bd2c6 = ()=>$9ed6161b8e8656d0$var$batch;

});

parcelRegister("d0Ii5", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $978da1a65f5b18aa$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $978da1a65f5b18aa$export$2105062e25df4afe);

var $5uXOq = parcelRequire("5uXOq");

var $8zGGo = parcelRequire("8zGGo");

var $3aaq3 = parcelRequire("3aaq3");

var $2HZB2 = parcelRequire("2HZB2");
let $978da1a65f5b18aa$var$useSyncExternalStoreWithSelector = (0, $2HZB2.notInitialized);
const $978da1a65f5b18aa$export$e2e6e3f3f3b782e3 = (fn)=>{
    $978da1a65f5b18aa$var$useSyncExternalStoreWithSelector = fn;
};
const $978da1a65f5b18aa$var$refEquality = (a, b)=>a === b;
function $978da1a65f5b18aa$export$2b53f90d2bd1cbfb(context = (0, $3aaq3.ReactReduxContext)) {
    const useReduxContext = context === (0, $3aaq3.ReactReduxContext) ? (0, $8zGGo.useReduxContext) : (0, $8zGGo.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $978da1a65f5b18aa$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $5uXOq.useRef)(true);
        const wrappedSelector = (0, $5uXOq.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $978da1a65f5b18aa$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $5uXOq.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $978da1a65f5b18aa$export$2105062e25df4afe = /*#__PURE__*/ $978da1a65f5b18aa$export$2b53f90d2bd1cbfb();

});
parcelRegister("8zGGo", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", () => $63e2b388a7da01c5$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $63e2b388a7da01c5$export$c1275ca9a6fd3ec5);

var $5uXOq = parcelRequire("5uXOq");

var $3aaq3 = parcelRequire("3aaq3");
function $63e2b388a7da01c5$export$d4d6226d5fc61558(context = (0, $3aaq3.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $5uXOq.useContext)(context);
        return contextValue;
    };
}
const $63e2b388a7da01c5$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $63e2b388a7da01c5$export$d4d6226d5fc61558();

});
parcelRegister("3aaq3", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $24da6356209e370c$export$cc80c08dc91f1c00);

var $5uXOq = parcelRequire("5uXOq");
const $24da6356209e370c$var$ContextKey = Symbol.for(`react-redux-context`);
const $24da6356209e370c$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $24da6356209e370c$var$getContext() {
    var _gT$ContextKey;
    if (!$5uXOq.createContext) return {};
    const contextMap = (_gT$ContextKey = $24da6356209e370c$var$gT[$24da6356209e370c$var$ContextKey]) != null ? _gT$ContextKey : $24da6356209e370c$var$gT[$24da6356209e370c$var$ContextKey] = new Map();
    let realContext = contextMap.get($5uXOq.createContext);
    if (!realContext) {
        realContext = $5uXOq.createContext(null);
        contextMap.set($5uXOq.createContext, realContext);
    }
    return realContext;
}
const $24da6356209e370c$export$cc80c08dc91f1c00 = /*#__PURE__*/ $24da6356209e370c$var$getContext();
var $24da6356209e370c$export$2e2bcd8739ae039 = $24da6356209e370c$export$cc80c08dc91f1c00;

});


parcelRegister("2HZB2", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $1f8f60af3cbfd685$export$20656a4825650bd0);
const $1f8f60af3cbfd685$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("9GYMs", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $70e72f0b158f02a7$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $70e72f0b158f02a7$export$2e2bcd8739ae039);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");

var $dY8Js = parcelRequire("dY8Js");

var $5uXOq = parcelRequire("5uXOq");

var $d5ZDO = parcelRequire("d5ZDO");

var $jHycI = parcelRequire("jHycI");

var $aE4d4 = parcelRequire("aE4d4");

var $18k8v = parcelRequire("18k8v");

var $Y8jyf = parcelRequire("Y8jyf");

var $HQMn3 = parcelRequire("HQMn3");

var $2fa5S = parcelRequire("2fa5S");

var $l9wit = parcelRequire("l9wit");
parcelRequire("h8mRJ");

var $3aaq3 = parcelRequire("3aaq3");

var $2HZB2 = parcelRequire("2HZB2");
const $70e72f0b158f02a7$var$_excluded = [
    "reactReduxForwardedRef"
];
let $70e72f0b158f02a7$var$useSyncExternalStore = (0, $2HZB2.notInitialized);
const $70e72f0b158f02a7$export$36d45daa6a4925b8 = (fn)=>{
    $70e72f0b158f02a7$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $70e72f0b158f02a7$var$EMPTY_ARRAY = [
    null,
    0
];
const $70e72f0b158f02a7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $70e72f0b158f02a7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $70e72f0b158f02a7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $2fa5S.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $70e72f0b158f02a7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $70e72f0b158f02a7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $70e72f0b158f02a7$var$initStateUpdates = ()=>$70e72f0b158f02a7$var$EMPTY_ARRAY;
function $70e72f0b158f02a7$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $70e72f0b158f02a7$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $70e72f0b158f02a7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $70e72f0b158f02a7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $l9wit.default), areStatePropsEqual: areStatePropsEqual = (0, $l9wit.default), areMergedPropsEqual: areMergedPropsEqual = (0, $l9wit.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $3aaq3.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $18k8v.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $aE4d4.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $Y8jyf.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $5uXOq.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $ddEsc.default)(props, $70e72f0b158f02a7$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $5uXOq.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $d5ZDO.isContextConsumer)(/*#__PURE__*/ $5uXOq.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $5uXOq.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $5uXOq.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $jHycI.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $5uXOq.useMemo(()=>{
                if (!shouldHandleStateChanges) return $70e72f0b158f02a7$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $HQMn3.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $5uXOq.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $bS32t.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $5uXOq.useRef();
            const lastWrapperProps = $5uXOq.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $5uXOq.useRef();
            const renderIsScheduled = $5uXOq.useRef(false);
            const isProcessingDispatch = $5uXOq.useRef(false);
            const isMounted = $5uXOq.useRef(false);
            const latestSubscriptionCallbackError = $5uXOq.useRef();
            (0, $2fa5S.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $5uXOq.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $5uXOq.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $70e72f0b158f02a7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $70e72f0b158f02a7$var$useIsomorphicLayoutEffectWithArgs($70e72f0b158f02a7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $70e72f0b158f02a7$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $2fa5S.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $5uXOq.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $5uXOq.createElement(WrappedComponent, (0, $bS32t.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $5uXOq.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $5uXOq.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $5uXOq.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $5uXOq.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $5uXOq.createElement(Connect, (0, $bS32t.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $70e72f0b158f02a7$export$2e2bcd8739ae039 = $70e72f0b158f02a7$var$connect;

});
parcelRegister("d5ZDO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bpRBR"));

});
parcelRegister("bpRBR", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $84fb9d4181a30402$export$a7c73072b1a182ae, (v) => $84fb9d4181a30402$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $84fb9d4181a30402$export$9f27bc3417b4524d, (v) => $84fb9d4181a30402$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $84fb9d4181a30402$export$db77ccec0bb4ccac, (v) => $84fb9d4181a30402$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $84fb9d4181a30402$export$8392c0c9d3dcbd35, (v) => $84fb9d4181a30402$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $84fb9d4181a30402$export$ffb0004e005737fa, (v) => $84fb9d4181a30402$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $84fb9d4181a30402$export$b624eff549462981, (v) => $84fb9d4181a30402$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $84fb9d4181a30402$export$7897aa7841a5380c, (v) => $84fb9d4181a30402$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $84fb9d4181a30402$export$602eac185826482c, (v) => $84fb9d4181a30402$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $84fb9d4181a30402$export$e2c29f18771995cb, (v) => $84fb9d4181a30402$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $84fb9d4181a30402$export$5f8d39834fd61797, (v) => $84fb9d4181a30402$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $84fb9d4181a30402$export$74bf444e3cd11ea5, (v) => $84fb9d4181a30402$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $84fb9d4181a30402$export$998bcd577473dd93, (v) => $84fb9d4181a30402$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $84fb9d4181a30402$export$92387174baf9b227, (v) => $84fb9d4181a30402$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $84fb9d4181a30402$export$ec112efeb987d9c6, (v) => $84fb9d4181a30402$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $84fb9d4181a30402$export$b706b080d889d2c9, (v) => $84fb9d4181a30402$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $84fb9d4181a30402$export$5be5a87408f70ddc, (v) => $84fb9d4181a30402$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $84fb9d4181a30402$export$45a5e7f76e0caa8d, (v) => $84fb9d4181a30402$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $84fb9d4181a30402$export$455c2e768291efa6, (v) => $84fb9d4181a30402$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $84fb9d4181a30402$export$9522e17588c12572, (v) => $84fb9d4181a30402$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $84fb9d4181a30402$export$2110ac352bb060b9, (v) => $84fb9d4181a30402$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $84fb9d4181a30402$export$56885ab8b9c456ab, (v) => $84fb9d4181a30402$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $84fb9d4181a30402$export$d927fcb6adf8f9de, (v) => $84fb9d4181a30402$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $84fb9d4181a30402$export$b82d16f27459e05a, (v) => $84fb9d4181a30402$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $84fb9d4181a30402$export$522c17b4f5e123e8, (v) => $84fb9d4181a30402$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $84fb9d4181a30402$export$1aabd8a0274ecfd6, (v) => $84fb9d4181a30402$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $84fb9d4181a30402$export$3d6c20d97e46b957, (v) => $84fb9d4181a30402$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $84fb9d4181a30402$export$9b621391a187a31a, (v) => $84fb9d4181a30402$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $84fb9d4181a30402$export$f5bbd400c2f4426f, (v) => $84fb9d4181a30402$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $84fb9d4181a30402$export$a7c73072b1a182ae;
var $84fb9d4181a30402$export$9f27bc3417b4524d;
var $84fb9d4181a30402$export$db77ccec0bb4ccac;
var $84fb9d4181a30402$export$8392c0c9d3dcbd35;
var $84fb9d4181a30402$export$ffb0004e005737fa;
var $84fb9d4181a30402$export$b624eff549462981;
var $84fb9d4181a30402$export$7897aa7841a5380c;
var $84fb9d4181a30402$export$602eac185826482c;
var $84fb9d4181a30402$export$e2c29f18771995cb;
var $84fb9d4181a30402$export$5f8d39834fd61797;
var $84fb9d4181a30402$export$74bf444e3cd11ea5;
var $84fb9d4181a30402$export$998bcd577473dd93;
var $84fb9d4181a30402$export$92387174baf9b227;
var $84fb9d4181a30402$export$ec112efeb987d9c6;
var $84fb9d4181a30402$export$b706b080d889d2c9;
var $84fb9d4181a30402$export$5be5a87408f70ddc;
var $84fb9d4181a30402$export$45a5e7f76e0caa8d;
var $84fb9d4181a30402$export$455c2e768291efa6;
var $84fb9d4181a30402$export$9522e17588c12572;
var $84fb9d4181a30402$export$2110ac352bb060b9;
var $84fb9d4181a30402$export$56885ab8b9c456ab;
var $84fb9d4181a30402$export$d927fcb6adf8f9de;
var $84fb9d4181a30402$export$b82d16f27459e05a;
var $84fb9d4181a30402$export$522c17b4f5e123e8;
var $84fb9d4181a30402$export$1aabd8a0274ecfd6;
var $84fb9d4181a30402$export$3d6c20d97e46b957;
var $84fb9d4181a30402$export$9b621391a187a31a;
var $84fb9d4181a30402$export$f5bbd400c2f4426f;
'use strict';
var $84fb9d4181a30402$var$b = Symbol.for("react.element"), $84fb9d4181a30402$var$c = Symbol.for("react.portal"), $84fb9d4181a30402$var$d = Symbol.for("react.fragment"), $84fb9d4181a30402$var$e = Symbol.for("react.strict_mode"), $84fb9d4181a30402$var$f = Symbol.for("react.profiler"), $84fb9d4181a30402$var$g = Symbol.for("react.provider"), $84fb9d4181a30402$var$h = Symbol.for("react.context"), $84fb9d4181a30402$var$k = Symbol.for("react.server_context"), $84fb9d4181a30402$var$l = Symbol.for("react.forward_ref"), $84fb9d4181a30402$var$m = Symbol.for("react.suspense"), $84fb9d4181a30402$var$n = Symbol.for("react.suspense_list"), $84fb9d4181a30402$var$p = Symbol.for("react.memo"), $84fb9d4181a30402$var$q = Symbol.for("react.lazy"), $84fb9d4181a30402$var$t = Symbol.for("react.offscreen"), $84fb9d4181a30402$var$u;
$84fb9d4181a30402$var$u = Symbol.for("react.module.reference");
function $84fb9d4181a30402$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $84fb9d4181a30402$var$b:
                switch(a = a.type, a){
                    case $84fb9d4181a30402$var$d:
                    case $84fb9d4181a30402$var$f:
                    case $84fb9d4181a30402$var$e:
                    case $84fb9d4181a30402$var$m:
                    case $84fb9d4181a30402$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $84fb9d4181a30402$var$k:
                            case $84fb9d4181a30402$var$h:
                            case $84fb9d4181a30402$var$l:
                            case $84fb9d4181a30402$var$q:
                            case $84fb9d4181a30402$var$p:
                            case $84fb9d4181a30402$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $84fb9d4181a30402$var$c:
                return r;
        }
    }
}
$84fb9d4181a30402$export$a7c73072b1a182ae = $84fb9d4181a30402$var$h;
$84fb9d4181a30402$export$9f27bc3417b4524d = $84fb9d4181a30402$var$g;
$84fb9d4181a30402$export$db77ccec0bb4ccac = $84fb9d4181a30402$var$b;
$84fb9d4181a30402$export$8392c0c9d3dcbd35 = $84fb9d4181a30402$var$l;
$84fb9d4181a30402$export$ffb0004e005737fa = $84fb9d4181a30402$var$d;
$84fb9d4181a30402$export$b624eff549462981 = $84fb9d4181a30402$var$q;
$84fb9d4181a30402$export$7897aa7841a5380c = $84fb9d4181a30402$var$p;
$84fb9d4181a30402$export$602eac185826482c = $84fb9d4181a30402$var$c;
$84fb9d4181a30402$export$e2c29f18771995cb = $84fb9d4181a30402$var$f;
$84fb9d4181a30402$export$5f8d39834fd61797 = $84fb9d4181a30402$var$e;
$84fb9d4181a30402$export$74bf444e3cd11ea5 = $84fb9d4181a30402$var$m;
$84fb9d4181a30402$export$998bcd577473dd93 = $84fb9d4181a30402$var$n;
$84fb9d4181a30402$export$92387174baf9b227 = function() {
    return !1;
};
$84fb9d4181a30402$export$ec112efeb987d9c6 = function() {
    return !1;
};
$84fb9d4181a30402$export$b706b080d889d2c9 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$h;
};
$84fb9d4181a30402$export$5be5a87408f70ddc = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$g;
};
$84fb9d4181a30402$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $84fb9d4181a30402$var$b;
};
$84fb9d4181a30402$export$455c2e768291efa6 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$l;
};
$84fb9d4181a30402$export$9522e17588c12572 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$d;
};
$84fb9d4181a30402$export$2110ac352bb060b9 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$q;
};
$84fb9d4181a30402$export$56885ab8b9c456ab = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$p;
};
$84fb9d4181a30402$export$d927fcb6adf8f9de = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$c;
};
$84fb9d4181a30402$export$b82d16f27459e05a = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$f;
};
$84fb9d4181a30402$export$522c17b4f5e123e8 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$e;
};
$84fb9d4181a30402$export$1aabd8a0274ecfd6 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$m;
};
$84fb9d4181a30402$export$3d6c20d97e46b957 = function(a) {
    return $84fb9d4181a30402$var$v(a) === $84fb9d4181a30402$var$n;
};
$84fb9d4181a30402$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $84fb9d4181a30402$var$d || a === $84fb9d4181a30402$var$f || a === $84fb9d4181a30402$var$e || a === $84fb9d4181a30402$var$m || a === $84fb9d4181a30402$var$n || a === $84fb9d4181a30402$var$t || "object" === typeof a && null !== a && (a.$$typeof === $84fb9d4181a30402$var$q || a.$$typeof === $84fb9d4181a30402$var$p || a.$$typeof === $84fb9d4181a30402$var$g || a.$$typeof === $84fb9d4181a30402$var$h || a.$$typeof === $84fb9d4181a30402$var$l || a.$$typeof === $84fb9d4181a30402$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$84fb9d4181a30402$export$f5bbd400c2f4426f = $84fb9d4181a30402$var$v;

});


parcelRegister("jHycI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e57c90b661b2aa9d$export$2e2bcd8739ae039);

var $ddEsc = parcelRequire("ddEsc");
parcelRequire("bdkPR");
const $e57c90b661b2aa9d$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $e57c90b661b2aa9d$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e57c90b661b2aa9d$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $ddEsc.default)(_ref, $e57c90b661b2aa9d$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e57c90b661b2aa9d$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("bdkPR", function(module, exports) {

var $h8mRJ = parcelRequire("h8mRJ");
function $82a112144f251592$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $h8mRJ.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $82a112144f251592$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $82a112144f251592$var$verify(mapStateToProps, 'mapStateToProps');
    $82a112144f251592$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $82a112144f251592$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("h8mRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c794ebae4175cea1$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $c794ebae4175cea1$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("aE4d4", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $7c00e7c696fadfe8$export$b69a785ceac019a6);

var $7m9Ej = parcelRequire("7m9Ej");

var $7421P = parcelRequire("7421P");

var $rj5V5 = parcelRequire("rj5V5");
function $7c00e7c696fadfe8$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $7421P.wrapMapToPropsConstant)((dispatch)=>(0, $7m9Ej.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $7421P.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $7421P.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $rj5V5.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("7m9Ej", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b212961e6abf3b$export$2e2bcd8739ae039);
function $55b212961e6abf3b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("7421P", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $524a7af0cb85693a$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $524a7af0cb85693a$export$8d46c7f53c8c602f);
parcelRequire("57Mzc");
function $524a7af0cb85693a$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $524a7af0cb85693a$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $524a7af0cb85693a$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $524a7af0cb85693a$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $524a7af0cb85693a$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("57Mzc", function(module, exports) {

var $j7ApP = parcelRequire("j7ApP");

var $h8mRJ = parcelRequire("h8mRJ");
function $3bb347890a03908a$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $j7ApP.default)(value)) (0, $h8mRJ.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("j7ApP", function(module, exports) {

$parcel$export(module.exports, "default", () => $debaeb2b9e73770f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $debaeb2b9e73770f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("rj5V5", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $0521557f3f6d71a1$export$19ef7b929f7e2559);
function $0521557f3f6d71a1$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("18k8v", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $0d362868a1c19f1b$export$e00e93951827eda7);

var $7421P = parcelRequire("7421P");

var $rj5V5 = parcelRequire("rj5V5");
function $0d362868a1c19f1b$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $7421P.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $7421P.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $rj5V5.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("Y8jyf", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $0b4c0dc47149fb1a$export$17457cf6fa742f84);

var $bS32t = parcelRequire("bS32t");
parcelRequire("57Mzc");

var $rj5V5 = parcelRequire("rj5V5");
function $0b4c0dc47149fb1a$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $bS32t.default)({}, ownProps, stateProps, dispatchProps);
}
function $0b4c0dc47149fb1a$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0b4c0dc47149fb1a$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$0b4c0dc47149fb1a$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $0b4c0dc47149fb1a$export$5b105939c84b5234(mergeProps) : (0, $rj5V5.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("HQMn3", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $083cf51c83dd0343$export$d567d2b9af322f8f);

var $dDtRT = parcelRequire("dDtRT");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $083cf51c83dd0343$var$createListenerCollection() {
    const batch = (0, $dDtRT.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $083cf51c83dd0343$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $083cf51c83dd0343$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $083cf51c83dd0343$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $083cf51c83dd0343$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $083cf51c83dd0343$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("2fa5S", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $1a24cfe8920aec00$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
const $1a24cfe8920aec00$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $1a24cfe8920aec00$export$700979bc83e7db82 = $1a24cfe8920aec00$export$71594e8a50f746f4 ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("l9wit", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6637dc3a66b2306$export$2e2bcd8739ae039);
function $f6637dc3a66b2306$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f6637dc3a66b2306$export$2e2bcd8739ae039(objA, objB) {
    if ($f6637dc3a66b2306$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f6637dc3a66b2306$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("lsmC4", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("9UgEX")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("9GYMs")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("02M5b")).useDispatch);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("02M5b")).createDispatchHook);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("d0Ii5")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("gJKSD")).useStore);

var $9UgEX = parcelRequire("9UgEX");

var $9GYMs = parcelRequire("9GYMs");

var $3aaq3 = parcelRequire("3aaq3");

var $02M5b = parcelRequire("02M5b");

var $d0Ii5 = parcelRequire("d0Ii5");

var $gJKSD = parcelRequire("gJKSD");

var $l9wit = parcelRequire("l9wit");
parcelRequire("1tjWm");

});
parcelRegister("9UgEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $73664443491a535d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3aaq3 = parcelRequire("3aaq3");

var $HQMn3 = parcelRequire("HQMn3");

var $2fa5S = parcelRequire("2fa5S");
function $73664443491a535d$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $5uXOq.useMemo(()=>{
        const subscription = (0, $HQMn3.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $5uXOq.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $2fa5S.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $3aaq3.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $5uXOq.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $73664443491a535d$export$2e2bcd8739ae039 = $73664443491a535d$var$Provider;

});

parcelRegister("02M5b", function(module, exports) {

$parcel$export(module.exports, "createDispatchHook", () => $00857c39942e9af2$export$bc9b55530897c558);
$parcel$export(module.exports, "useDispatch", () => $00857c39942e9af2$export$8ad76b76a4c905f8);

var $3aaq3 = parcelRequire("3aaq3");

var $gJKSD = parcelRequire("gJKSD");
function $00857c39942e9af2$export$bc9b55530897c558(context = (0, $3aaq3.ReactReduxContext)) {
    const useStore = context === (0, $3aaq3.ReactReduxContext) ? (0, $gJKSD.useStore) : (0, $gJKSD.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $00857c39942e9af2$export$8ad76b76a4c905f8 = /*#__PURE__*/ $00857c39942e9af2$export$bc9b55530897c558();

});
parcelRegister("gJKSD", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $c2f536bbe348fe73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $c2f536bbe348fe73$export$6ccbb43953eebf8);

var $3aaq3 = parcelRequire("3aaq3");

var $8zGGo = parcelRequire("8zGGo");
function $c2f536bbe348fe73$export$671dba69185d0304(context = (0, $3aaq3.ReactReduxContext)) {
    const useReduxContext = context === (0, $3aaq3.ReactReduxContext) ? (0, $8zGGo.useReduxContext) : (0, $8zGGo.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $c2f536bbe348fe73$export$6ccbb43953eebf8 = /*#__PURE__*/ $c2f536bbe348fe73$export$671dba69185d0304();

});


parcelRegister("1tjWm", function(module, exports) {

});



parcelRegister("9Hjn4", function(module, exports) {

$parcel$export(module.exports, "withStability", () => $9ef8c9d2f434f06f$export$717840dc0c82fbbc);

var $jcw0u = parcelRequire("jcw0u");

var $6Z846 = parcelRequire("6Z846");
/* eslint-disable @typescript-eslint/no-explicit-any, func-names */ const $9ef8c9d2f434f06f$var$ARITY = {
    0: (fn)=>function() {
            return fn.call(this);
        },
    1: (fn)=>function(arg1) {
            return fn.call(this, arg1);
        },
    2: (fn)=>function(arg1, arg2) {
            return fn.call(this, arg1, arg2);
        },
    3: (fn)=>function(arg1, arg2, arg3) {
            return fn.call(this, arg1, arg2, arg3);
        }
};
function $9ef8c9d2f434f06f$var$defineArity(arity, fn) {
    if (!$9ef8c9d2f434f06f$var$ARITY[arity]) throw new Error(`Unsupported arity ${arity}`);
    return $9ef8c9d2f434f06f$var$ARITY[arity](fn);
}
const $9ef8c9d2f434f06f$var$getDifference = (a, b)=>{
    const diff = {};
    for(const key in a)if (a[key] !== b[key]) diff[key] = a[key];
    return diff;
};
const $9ef8c9d2f434f06f$var$getTypes = (a)=>{
    const result = {};
    // eslint-disable-next-line guard-for-in
    for(const key in a)result[key] = typeof a[key];
    return result;
};
const $9ef8c9d2f434f06f$var$stability = (component, name, fn)=>{
    const isDevMode = false;
    let override = null;
    return $9ef8c9d2f434f06f$var$defineArity(3, (...args)=>{
        if (override) return override(...args);
        const v1 = fn(...args);
        if (typeof v1 === 'function') {
            override = $9ef8c9d2f434f06f$var$stability(component, `${name}>`, v1);
            return override(...args);
        }
        const v2 = fn(...args);
        if (!(0, $6Z846.isShallowEqual)(v1, v2)) {
            const displayName = component.displayName || component.name;
            const difference = $9ef8c9d2f434f06f$var$getDifference(v1, v2);
            const stabilityAttributes = {
                component: component,
                selector: fn,
                displayName: displayName,
                name: name,
                difference: difference,
                v1: v1,
                v2: v2,
                differenceTypes: $9ef8c9d2f434f06f$var$getTypes(difference),
                v1Types: $9ef8c9d2f434f06f$var$getTypes(v1),
                v2Types: $9ef8c9d2f434f06f$var$getTypes(v2)
            };
            // only log errors in dev mode
            if (isDevMode) // eslint-disable-next-line no-console
            console.error(`Unstable selector ${displayName}:${name}`, stabilityAttributes);
            const error = new Error(`Unstable selector used for ${displayName}:${name} : ${Object.keys(difference).join(',')}`);
            (0, $jcw0u.default)({
                meta: {
                    id: 'stabilityCheck',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                attributes: stabilityAttributes,
                error: error
            });
            // only throw error again in dev mode
            if (isDevMode) throw error;
        }
        return v2;
    });
};
const $9ef8c9d2f434f06f$export$717840dc0c82fbbc = (component, name, fn)=>{
    const isDevMode = false;
    if (!isDevMode || !fn || typeof fn !== 'function') return fn;
    // mergeProps cannot return a factory function
    if (name === 'mergeProps') return $9ef8c9d2f434f06f$var$defineArity(3, $9ef8c9d2f434f06f$var$stability(component, name, fn));
    return $9ef8c9d2f434f06f$var$defineArity(3, ()=>$9ef8c9d2f434f06f$var$stability(component, name, fn));
};

});
parcelRegister("jcw0u", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $9f89e4e6844051f3$export$476aa014e2fd89d5);
$parcel$export(module.exports, "getStatusCodeGroup", () => $9f89e4e6844051f3$export$d14e9b22afc87cb3);
$parcel$export(module.exports, "trackFetchErrors", () => $9f89e4e6844051f3$export$706c486c6b5abdfb);
$parcel$export(module.exports, "default", () => $9f89e4e6844051f3$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $9xWGk = parcelRequire("9xWGk");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $cfDZ3 = parcelRequire("cfDZ3");

var $8zOmE = parcelRequire("8zOmE");
var $lhVtI = parcelRequire("lhVtI");

var $fjcgS = parcelRequire("fjcgS");

var $aMh57 = parcelRequire("aMh57");

var $4R6GH = parcelRequire("4R6GH");
const $9f89e4e6844051f3$var$VIEW_WHITELIST = new Set([
    'project-issue-navigator',
    'jira-router-gin-redirect-entrypoint',
    'jira-business-attachments-app',
    'jira-business-timeline-app',
    'software-list-app',
    'business-list-app',
    'business-calendar',
    'business-calendar-embed',
    'software-calendar',
    'software-calendar-embed'
]);
const $9f89e4e6844051f3$var$isViewSupported = (view)=>{
    if (!(0, $4R6GH.fg)('jira-report-unhandled-errors-by-view')) return false;
    return $9f89e4e6844051f3$var$VIEW_WHITELIST.has(view);
};
const $9f89e4e6844051f3$export$476aa014e2fd89d5 = (error)=>{
    // @ts-expect-error - TS2339 - Property 'networkError' does not exist on type 'Error'. | TS2339 - Property 'networkError' does not exist on type 'Error'.
    const errorToCheck = error.networkError ? error.networkError : error;
    return typeof errorToCheck === 'object' && (errorToCheck instanceof (0, $jJZqs.default) || errorToCheck instanceof (0, $jJZqs.ValidationError) || (0, $fZneA.isClientFetchError)(errorToCheck));
};
const $9f89e4e6844051f3$export$d14e9b22afc87cb3 = (error)=>{
    if (error instanceof (0, $jJZqs.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode < 200) return '1xx';
        if (statusCode >= 300 && statusCode < 400) return '3xx';
        if (statusCode >= 400 && statusCode < 500) return '4xx';
        if (statusCode >= 500 && statusCode < 600) return '5xx';
    }
    if (error instanceof (0, $jJZqs.ValidationError)) return '4xx';
    return 'unknown';
};
const $9f89e4e6844051f3$var$getTraceId = (error)=>error instanceof (0, $jJZqs.default) ? error.traceId : undefined;
const $9f89e4e6844051f3$var$logErrorToSentry = (event, fullAnalyticsId, error, // eslint-disable-next-line @typescript-eslint/no-explicit-any
details)=>{
    if (event?.context) {
        const fullEvent = (0, $lhVtI.getEvent)(event);
        (0, $aMh57.captureException)(fullAnalyticsId, error, {
            ...details,
            ...fullEvent.payload
        });
    } else (0, $aMh57.captureException)(fullAnalyticsId, error, details);
};
const $9f89e4e6844051f3$var$logToPrivacyUnsafeSplunk = (fullAnalyticsId, error, errorInfo, meta)=>{
    const errorToLog = {
        message: error.message,
        stack: error.stack,
        // Include the status code group for network errors
        statusCodeGroup: $9f89e4e6844051f3$export$476aa014e2fd89d5(error) ? $9f89e4e6844051f3$export$d14e9b22afc87cb3(error) : undefined,
        // Include componentStack if present created by React's componentDidCatch
        componentStack: errorInfo ? errorInfo.componentStack : undefined,
        userLocation: (0, $cfDZ3.getUserLocation)(),
        teamName: meta?.teamName,
        packageName: meta?.packageName
    };
    (0, $2YZCu.default).unsafeErrorWithCustomerData(fullAnalyticsId, error.message, errorToLog);
};
const $9f89e4e6844051f3$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@\w+/gi, '***@***');
/**
 * Standard jira error handler.
 * If a network error is passed in a status code will be attached to the logged event.
 * Network events are not logged to sentry.
 * This can be used to filter out client side network errors from TOME SLOs
 *
 * @param errorPayload Information about the error being logged and configuration.
 * @param {AnalyticsEvent?} errorPayload.event Object describing the event that caused the error.
 * @param {Error?} errorPayload.error The error object that is being logged about, Can be sent to splunk or sentry.
 * @param {ErrorInfo?} errorPayload.errorInfo
 * @param {AnalyticsMeta} errorPayload.meta Metadata describing the name of the error to be logged, the package source of the error and the team owning the package.
 * @param {AnalyticsAttributes?} errorPayload.attributes Additional data to include in the payload being logged.
 * @param {boolean?} [errorPayload.sendToPrivacyUnsafeSplunk=false] Flag to opt to send the provided error to privacyUnsafeSplunk. Defaults to false
 * @param {boolean?} [errorPayload.skipSentry=false] Flag to opt to send the provided error to Sentry. Defaults to false
 */ const $9f89e4e6844051f3$var$fireErrorAnalytics = async ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk = false, skipSentry: skipSentry = false, view: view })=>{
    const networkError = error ? $9f89e4e6844051f3$export$476aa014e2fd89d5(error) : false;
    let eventAttributes;
    if (networkError && error) {
        const statusCodeGroup = $9f89e4e6844051f3$export$d14e9b22afc87cb3(error);
        const traceId = $9f89e4e6844051f3$var$getTraceId(error);
        eventAttributes = traceId === null || traceId === undefined ? {
            ...attributes,
            statusCodeGroup: statusCodeGroup
        } : {
            ...attributes,
            statusCodeGroup: statusCodeGroup,
            traceId: traceId
        };
    } else eventAttributes = attributes ?? {};
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $lhVtI.getEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: eventAttributes
            }));
        }
    }
    const fullAnalyticsId = packageName !== undefined ? `${packageName}.${id}` : id;
    if (error) {
        if (!networkError && !skipSentry) {
            const details = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
                ...eventAttributes,
                packageName: packageName,
                teamName: teamName,
                errorInfo: errorInfo
            }, (0, (/*@__PURE__*/$parcel$interopDefault($gccSB))));
            $9f89e4e6844051f3$var$logErrorToSentry(event, fullAnalyticsId, error, details);
            if (event && event?.handlers?.length > 0 && view && $9f89e4e6844051f3$var$isViewSupported(view)) (0, $8zOmE.fireOperationalAnalytics)(event, 'jiraViewException caught', {
                ...eventAttributes,
                view: view
            });
        }
        // This is a stop gap measure until Sentry is fully rolled out
        if (sendToPrivacyUnsafeSplunk) $9f89e4e6844051f3$var$logToPrivacyUnsafeSplunk(fullAnalyticsId, error, errorInfo, meta);
        eventAttributes = {
            errorMessage: error.message,
            ...eventAttributes
        };
        if (typeof eventAttributes.errorMessage === 'string') eventAttributes.errorMessage = $9f89e4e6844051f3$export$1bee4e6be783dd26(eventAttributes.errorMessage);
    }
    if (event && event?.handlers?.length > 0) {
        const attrs = eventAttributes;
        (0, $8zOmE.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: eventAttributes
        };
        const analyticsClient = await (0, $fjcgS.getAnalyticsWebClientPromise)();
        analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
    }
};
const $9f89e4e6844051f3$export$706c486c6b5abdfb = async (payload)=>{
    const { event: event, error: error, id: id, packageName: packageName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = payload;
    return $9f89e4e6844051f3$var$fireErrorAnalytics({
        event: event,
        error: error,
        attributes: attributes,
        meta: {
            packageName: packageName,
            id: id
        },
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};
var $9f89e4e6844051f3$export$2e2bcd8739ae039 = $9f89e4e6844051f3$var$fireErrorAnalytics;

});
parcelRegister("2YZCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fc557aa9084018$export$2e2bcd8739ae039);

var $jpY8v = parcelRequire("jpY8v");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $jyCEH = parcelRequire("jyCEH");
const $50fc557aa9084018$var$MAX_CONCURRENCY_FOR_THROTTLE = 5;
const $50fc557aa9084018$var$throttleInstance = (0, $jyCEH.default)($50fc557aa9084018$var$MAX_CONCURRENCY_FOR_THROTTLE);
if (typeof window !== 'undefined') window.addEventListener('beforeunload', $50fc557aa9084018$var$throttleInstance.flush);
// Each log call passes in a location - a path to the file with '.' separation. This utility will
// prepend 'jira.frontend.' to this location before it is sent.
// For example, 'jira.frontend.issue.state.reducers.entities.reducer'.
//
// Log messages and events must only contain privacy-safe information.
const $50fc557aa9084018$var$isProduction = ()=>true;
const $50fc557aa9084018$var$sendToServer = (body, endpoint)=>{
    const fetchOptions = {
        ...(0, $5HnTq.getDefaultOptions)(endpoint),
        method: 'POST',
        body: body
    };
    return fetch(endpoint, fetchOptions);
};
const $50fc557aa9084018$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%cJIRA %s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentWindow = window;
    if (!$50fc557aa9084018$var$isProduction() && currentWindow.Cypress) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.cypressSafeErrorsLog) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog = [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $50fc557aa9084018$var$joinArrayFields = (error)=>Object.fromEntries(Object.entries(error).map(([key, value])=>{
        if (Array.isArray(value)) return [
            key,
            value.join(', ')
        ];
        return [
            key,
            value
        ];
    }));
const $50fc557aa9084018$var$transformError = (error)=>{
    const commonProperties = {
        message: error.message,
        stack: error.stack
    };
    // Not importing ValidationError and performing instanceof check because it's causing bundle size increase for skeletons.
    // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'. | TS2339 - Property 'errors' does not exist on type 'Error'.
    if (error.name === (0, $jJZqs.VALIDATION_ERROR_NAME) && error.errors && error.errors.map) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'.
        const { errors: errors, ...otherProperties } = error;
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        const invalidFields = errors.map((item)=>item.field).join(', ');
        // @ts-expect-error - TS2322 - Type '{ name: string; message: string; stack: string | undefined; invalidFields: any; }' is not assignable to type '{ [key: string]: string | number; }'.
        return {
            ...commonProperties,
            invalidFields: invalidFields,
            ...otherProperties
        };
    }
    const result = {
        ...commonProperties,
        ...error
    };
    return $50fc557aa9084018$var$joinArrayFields(result);
};
const $50fc557aa9084018$var$transformData = (location, message, event)=>{
    const { name: browserName, version: browserVersion } = (0, $jpY8v.getBrowser)();
    return {
        sentFrom: `jira.frontend.${location}`,
        message: String(message),
        event: event instanceof Error ? $50fc557aa9084018$var$transformError(event) : event,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        buildKey: window.BUILD_KEY,
        logTime: new Date().toISOString(),
        browserName: browserName,
        browserVersion: browserVersion
    };
};
const $50fc557aa9084018$var$sendData = (level, location, message, event = {})=>{
    const data = $50fc557aa9084018$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($50fc557aa9084018$var$isProduction()) return new Promise((resolve, reject)=>{
        $50fc557aa9084018$var$throttleInstance.add(()=>$50fc557aa9084018$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $50fc557aa9084018$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event
 *
 * @example Usage
 * safeInfoWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource INFO "my.location.string"
 */ const $50fc557aa9084018$var$safeInfoWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('info', location, message, event);
};
/** This function logs privacy safe warnings.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeWarnWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource WARN "my.location.string"
 */ const $50fc557aa9084018$var$safeWarnWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('warn', location, message, event);
};
/** This function logs privacy safe errors.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeErrorWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource ERROR "my.location.string"
 */ const $50fc557aa9084018$var$safeErrorWithoutCustomerData = async (location, message, event)=>{
    await $50fc557aa9084018$var$sendData('error', location, message, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ const $50fc557aa9084018$var$unsafeErrorWithCustomerData = (location, message, event = {})=>{
    const data = $50fc557aa9084018$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = '/rest/internal/2/log/unsafe/frontend-exception';
    if ($50fc557aa9084018$var$isProduction()) return new Promise((resolve, reject)=>{
        $50fc557aa9084018$var$throttleInstance.add(()=>$50fc557aa9084018$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $50fc557aa9084018$var$sendToConsole(body, endpoint, 'error', message, typeof event, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$50fc557aa9084018$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $50fc557aa9084018$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $50fc557aa9084018$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $50fc557aa9084018$var$safeErrorWithoutCustomerData,
    unsafeErrorWithCustomerData: $50fc557aa9084018$var$unsafeErrorWithCustomerData
};

});
parcelRegister("jpY8v", function(module, exports) {

$parcel$export(module.exports, "getBrowser", () => $0f8ffafb41ad7521$export$89e15fc796a4a429);
$parcel$export(module.exports, "isIE11", () => $0f8ffafb41ad7521$export$f7bad96d83325a34);
$parcel$export(module.exports, "isEdge", () => $0f8ffafb41ad7521$export$cac3980734d91fbe);
$parcel$export(module.exports, "isChrome", () => $0f8ffafb41ad7521$export$6446a186d09e379e);
$parcel$export(module.exports, "isSafari", () => $0f8ffafb41ad7521$export$95df08bae54cb4df);
$parcel$export(module.exports, "isFirefox", () => $0f8ffafb41ad7521$export$b7d78993b74f766d);

var $4XKM3 = parcelRequire("4XKM3");
let $0f8ffafb41ad7521$var$parsedUA;
const $0f8ffafb41ad7521$var$parseUserAgent = ()=>{
    if ($0f8ffafb41ad7521$var$parsedUA === undefined) {
        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
        $0f8ffafb41ad7521$var$parsedUA = userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($4XKM3))).getParser(userAgent) : null;
    }
    return $0f8ffafb41ad7521$var$parsedUA;
};
const $0f8ffafb41ad7521$var$getBrowserNameAndVersion = ()=>{
    const browser = $0f8ffafb41ad7521$var$parseUserAgent();
    if (browser) return browser.getBrowser();
    return {
        name: '',
        version: ''
    };
};
const $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion = (bowserVersion, minimumVersion)=>{
    const parts = bowserVersion.split('.');
    const part1 = parts[0];
    const part2 = parts[1];
    let version;
    if (part2) version = `${part1}.${part2}`;
    else version = part1;
    return Number(version) >= minimumVersion;
};
const $0f8ffafb41ad7521$export$89e15fc796a4a429 = ()=>$0f8ffafb41ad7521$var$getBrowserNameAndVersion();
const $0f8ffafb41ad7521$export$f7bad96d83325a34 = ()=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Internet Explorer' && version === '11.0';
};
const $0f8ffafb41ad7521$export$cac3980734d91fbe = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Microsoft Edge' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$6446a186d09e379e = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Chrome' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$95df08bae54cb4df = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Safari' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $0f8ffafb41ad7521$export$b7d78993b74f766d = (minimumVersion = 0)=>{
    const { name: name, version: version } = $0f8ffafb41ad7521$var$getBrowserNameAndVersion();
    return name === 'Firefox' && $0f8ffafb41ad7521$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

});
parcelRegister("4XKM3", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("jJZqs", function(module, exports) {

$parcel$export(module.exports, "TYPE_ERROR_NAME", () => $9b8050d14ddb3fd0$export$764da004e4110fae);
$parcel$export(module.exports, "ABORT_ERROR_NAME", () => $9b8050d14ddb3fd0$export$41b7a909d5bcdc59);
$parcel$export(module.exports, "VALIDATION_ERROR_NAME", () => $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4);
$parcel$export(module.exports, "ValidationError", () => $9b8050d14ddb3fd0$export$2191b9da168c6cf0);
$parcel$export(module.exports, "isValidationError", () => $9b8050d14ddb3fd0$export$f715db496ec47204);
$parcel$export(module.exports, "default", () => $9b8050d14ddb3fd0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isFetchError", () => $9b8050d14ddb3fd0$export$96f7e6db4105d70c);
/* eslint-disable max-classes-per-file */ 
var $ht021 = parcelRequire("ht021");
const $9b8050d14ddb3fd0$export$764da004e4110fae = 'TypeError';
const $9b8050d14ddb3fd0$export$41b7a909d5bcdc59 = 'AbortError';
const $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4 = 'ValidationError';
const $9b8050d14ddb3fd0$export$83179404a61b001a = 'FetchError';
class $9b8050d14ddb3fd0$export$2191b9da168c6cf0 extends (0, $ht021.default) {
    constructor(message, errors = [], // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'number'.
    statusCode, traceId, originalResponse){
        super(message, {
            cause: errors[0]
        });
        // Setting name to a hardcoded string so it doesn't get obfuscated. This is used for my poor man's instanceof
        // check in common/util/logging/log.js.
        this.name = $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4;
        this.errors = errors;
        this.statusCode = statusCode;
        this.skipSentry = true;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}
const $9b8050d14ddb3fd0$export$f715db496ec47204 = (error)=>error.name === $9b8050d14ddb3fd0$export$e7d64b75be4ed4e4;
class $9b8050d14ddb3fd0$export$2e2bcd8739ae039 extends (0, $ht021.default) {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = $9b8050d14ddb3fd0$export$83179404a61b001a;
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $9b8050d14ddb3fd0$export$96f7e6db4105d70c = (error)=>error instanceof $9b8050d14ddb3fd0$export$2e2bcd8739ae039 && error.name === $9b8050d14ddb3fd0$export$83179404a61b001a;

});
parcelRegister("ht021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b155b7f0479fe122$export$2e2bcd8739ae039);
class $b155b7f0479fe122$export$2e2bcd8739ae039 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
    }
}

});


parcelRegister("5HnTq", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $d8e199c5de7ab402$export$430a3269e24b912e);
$parcel$export(module.exports, "defaultOptions", () => $d8e199c5de7ab402$export$ba43bf67f3d48107);

var $51xpa = parcelRequire("51xpa");
function $d8e199c5de7ab402$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $51xpa.applyObservabilityHeaders)(url, options) : options;
}
const $d8e199c5de7ab402$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});
parcelRegister("51xpa", function(module, exports) {

$parcel$export(module.exports, "makeObservabilityHeaders", () => $d3562d3cd66dff31$export$78a090c6aabf87d6);
$parcel$export(module.exports, "applyObservabilityHeaders", () => $d3562d3cd66dff31$export$f51f2ccd07af96d8);

var $aZsz6 = parcelRequire("aZsz6");

var $tcn7E = parcelRequire("tcn7E");


var $87OsA = parcelRequire("87OsA");

var $eKonk = parcelRequire("eKonk");
const $d3562d3cd66dff31$export$78a090c6aabf87d6 = ()=>{
    const headers = {};
    const capability = (0, $87OsA.getCapability)();
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)(capability);
    if (capabilityHeader) headers[0, $281cbd47ba46dd7d$export$9a80695e72849f84] = capabilityHeader;
    const tracingHeaders = (0, $tcn7E.getActiveTraceHttpRequestHeaders)();
    if (tracingHeaders !== null) Object.assign(headers, tracingHeaders);
    if (Object.keys(headers).length === 0) return null;
    return {
        headers: headers
    };
};
const $d3562d3cd66dff31$export$f51f2ccd07af96d8 = (url, options)=>{
    const endpointUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(url);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!false && endpointUrl.hostname && endpointUrl.hostname !== window.location.hostname) return options;
    const extraHeaders = $d3562d3cd66dff31$export$78a090c6aabf87d6();
    if (extraHeaders === null) return options;
    return {
        ...options,
        headers: {
            ...options.headers,
            ...extraHeaders.headers
        }
    };
};

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("87OsA", function(module, exports) {

$parcel$export(module.exports, "setCapability", () => $ddf54a85e3ee1f25$export$60e3f676689faf78);
$parcel$export(module.exports, "getCapability", () => $ddf54a85e3ee1f25$export$38805c31c710553c);
let $ddf54a85e3ee1f25$var$activeCapability = null;
const $ddf54a85e3ee1f25$export$60e3f676689faf78 = (capability)=>{
    $ddf54a85e3ee1f25$var$activeCapability = capability;
};
const $ddf54a85e3ee1f25$export$38805c31c710553c = ()=>$ddf54a85e3ee1f25$var$activeCapability;

});

parcelRegister("eKonk", function(module, exports) {

$parcel$export(module.exports, "getEnhancedCapabilityHeader", () => $ea5a8371adb619de$export$8660821f7e55d98b);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $4R6GH = parcelRequire("4R6GH");
function $ea5a8371adb619de$export$8660821f7e55d98b(capability) {
    if (!(0, $4R6GH.fg)('jira_enhanced_capability_header') || capability == null) return capability;
    const defaultCapabilityHeader = `${capability}--other`;
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (!interactionId) return defaultCapabilityHeader;
    const currentInteractionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
    if (currentInteractionType === 'page_load') return `${capability}--page-load`;
    else if (currentInteractionType === 'transition') return `${capability}--transition`;
    return defaultCapabilityHeader;
}

});



parcelRegister("jyCEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c5e2e6b0d512a0$export$2e2bcd8739ae039);
const $c1c5e2e6b0d512a0$var$throttleLogs = (limit)=>{
    const queue = [];
    let activeCount = 0;
    const next = ()=>{
        if (queue.length > 0 && activeCount < limit) {
            const fn = queue.shift();
            if (fn) {
                activeCount++;
                fn().finally(()=>{
                    activeCount--;
                    next();
                });
            }
        }
    };
    const add = (fn)=>{
        queue.push(fn);
        next();
    };
    const flush = async ()=>{
        const promises = [];
        while(queue.length > 0){
            const fn = queue.shift();
            if (fn) promises.push(fn());
        }
        await Promise.all(promises);
    };
    return {
        add: add,
        flush: flush
    };
};
var $c1c5e2e6b0d512a0$export$2e2bcd8739ae039 = $c1c5e2e6b0d512a0$var$throttleLogs;

});


parcelRegister("fZneA", function(module, exports) {

$parcel$export(module.exports, "isHttpClientErrorResponse", () => $846b7928ccd4bd75$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isHttpClientErrorStatusCode", () => $846b7928ccd4bd75$export$6e82b047ed95d4a2);
$parcel$export(module.exports, "isHttpTooManyRequestsResponse", () => $846b7928ccd4bd75$export$9d73d6caff63cf52);
$parcel$export(module.exports, "isClientFetchError", () => $846b7928ccd4bd75$export$2e7adc44463c3f4f);
$parcel$export(module.exports, "isBackendAPIError", () => $846b7928ccd4bd75$export$c837012eb09638f0);
$parcel$export(module.exports, "isBackendAPIErrorOld", () => $846b7928ccd4bd75$export$5d291241481dc60a);
const $846b7928ccd4bd75$export$2b62e563f0fadcee = (error)=>typeof error === 'object' && 'statusCode' in error && error.statusCode >= 400 && error.statusCode < 500;
const $846b7928ccd4bd75$export$6e82b047ed95d4a2 = (statusCode)=>statusCode !== null && statusCode >= 400 && statusCode < 500;
const $846b7928ccd4bd75$export$9d73d6caff63cf52 = (error)=>error.statusCode === 429;
const $846b7928ccd4bd75$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $846b7928ccd4bd75$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError',
    'Network error'
];
const $846b7928ccd4bd75$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$846b7928ccd4bd75$export$c748438cec453c9f.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $846b7928ccd4bd75$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($846b7928ccd4bd75$export$3876cb851aa46193.includes(error.name) || $846b7928ccd4bd75$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($846b7928ccd4bd75$export$3876cb851aa46193.includes(error.cause.name) || $846b7928ccd4bd75$var$isClientFetchErrorMessage(error.cause.message)));
const $846b7928ccd4bd75$export$bc51706fabc78ec4 = [
    'authProviderTimedOut',
    'Call to graphql returned empty issue',
    'endpoint failed with status',
    'Exception while fetching data',
    'fetch-error: no data or no data node',
    'FetchError',
    'GraphQL error',
    'GraphQLNoResultsError',
    'HTTP status',
    'java.lang.',
    'java.net.',
    'java.util.',
    'javax.net.',
    'JSON at position',
    'Network error:',
    'not valid JSON',
    'Problem while calling endpoint',
    'RelayNetwork',
    'Response ended with an error',
    'serverForbidden',
    'serverInvalidBody',
    'serverUnauthorized',
    'serverUnexpectedError'
];
const $846b7928ccd4bd75$export$c837012eb09638f0 = (error)=>Boolean(error) && typeof error === 'object' && ('statusCode' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'statusCode' in error.cause || 'graphQLErrors' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'graphQLErrors' in error.cause || $846b7928ccd4bd75$export$bc51706fabc78ec4.some((v)=>`${error.name}${error.message}${error.cause?.name}${error.cause?.message}`.includes(v)));
const $846b7928ccd4bd75$export$5d291241481dc60a = (error)=>Boolean(error) && typeof error === 'object' && ('statusCode' in error || error.cause && 'statusCode' in error.cause || 'graphQLErrors' in error || error.cause && 'graphQLErrors' in error.cause || $846b7928ccd4bd75$export$bc51706fabc78ec4.some((v)=>(error.name + error.message + error.cause?.name + error.cause?.message).includes(v)));

});

parcelRegister("cfDZ3", function(module, exports) {

$parcel$export(module.exports, "setMatchedRoute", () => $200339135f90fb3c$export$afe84d55f9496537);
$parcel$export(module.exports, "getMatchedRoute", () => $200339135f90fb3c$export$a0bca9c6a43bcc94);
$parcel$export(module.exports, "getRouteName", () => $200339135f90fb3c$export$52f85febe13405);
$parcel$export(module.exports, "getUserLocation", () => $200339135f90fb3c$export$a17b4f8f942a1896);
$parcel$export(module.exports, "setPreviousRouterState", () => $200339135f90fb3c$export$335179a30e3b3b9);
$parcel$export(module.exports, "getPreviousRouterState", () => $200339135f90fb3c$export$c54513a7c3de8fe7);
$parcel$export(module.exports, "getPreviousSubProduct", () => $200339135f90fb3c$export$20e84c9866aad5d2);
$parcel$export(module.exports, "setSubProduct", () => $200339135f90fb3c$export$37ee9c58e9a550c6);

var $fjcgS = parcelRequire("fjcgS");
let $200339135f90fb3c$var$matchedRoute = null;
const $200339135f90fb3c$export$afe84d55f9496537 = (route, match)=>{
    if (route && match) $200339135f90fb3c$var$matchedRoute = {
        route: route,
        match: match
    };
};
const $200339135f90fb3c$export$a0bca9c6a43bcc94 = ()=>$200339135f90fb3c$var$matchedRoute;
const $200339135f90fb3c$export$52f85febe13405 = ()=>$200339135f90fb3c$var$matchedRoute?.route.name ?? 'unknown';
const $200339135f90fb3c$export$a17b4f8f942a1896 = ()=>`${$200339135f90fb3c$var$matchedRoute?.route.group ?? 'unknown'}:${$200339135f90fb3c$export$52f85febe13405()}`;
let $200339135f90fb3c$var$previousRouterState = null;
let $200339135f90fb3c$var$previousSubProduct = '';
const $200339135f90fb3c$export$335179a30e3b3b9 = (state)=>{
    $200339135f90fb3c$var$previousRouterState = state;
};
const $200339135f90fb3c$export$c54513a7c3de8fe7 = ()=>$200339135f90fb3c$var$previousRouterState;
const $200339135f90fb3c$export$df8e6f241eebab99 = (subProduct)=>{
    $200339135f90fb3c$var$previousSubProduct = subProduct || '';
};
const $200339135f90fb3c$export$20e84c9866aad5d2 = ()=>$200339135f90fb3c$var$previousSubProduct;
const $200339135f90fb3c$export$37ee9c58e9a550c6 = (subproduct)=>{
    if (subproduct === null) return;
    if ($200339135f90fb3c$var$previousSubProduct !== subproduct) $200339135f90fb3c$export$df8e6f241eebab99(subproduct);
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subproduct);
    });
};
const $200339135f90fb3c$export$e87aa529d29d151b = (route, pathParamValues = {})=>{
    let result = route.path;
    Object.keys(pathParamValues).forEach((pathParamKey)=>{
        result = result.replaceAll(`:${pathParamKey}`, pathParamValues[pathParamKey].toString());
    });
    if (result.indexOf('/:') !== -1) // throwing error to fail early, as the path with not all :param replaced will not be usable, and will elad to other errors down hte line.
    throw new Error(`routePathToUrlPath: values for some path params have not been provided: ${result}`);
    return result;
};

});

parcelRegister("8zOmE", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $03330681e31fdbd3$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $03330681e31fdbd3$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $03330681e31fdbd3$export$13990ad4625571ed);
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $03330681e31fdbd3$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $03330681e31fdbd3$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $03330681e31fdbd3$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalytics", () => $03330681e31fdbd3$export$6f46fb37ad7d962b);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $03330681e31fdbd3$export$59b89d5a711a4fa);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $hYfgW = parcelRequire("hYfgW");


var $39ajt = parcelRequire("39ajt");
const $03330681e31fdbd3$export$34ac71ce24cddec2 = (event, type, eventOverrides = {})=>{
    // Safe check to prevent SSR to trigger and to avoid sentry errors such as https://ops.internal.atlassian.com/jira/browse/HOT-90825
    if (false) return;
    const clonedEvent = event.clone();
    if (clonedEvent) clonedEvent.update({
        ...eventOverrides,
        analyticsType: type
    }).fire('productAnalytics');
};
const $03330681e31fdbd3$var$getActionSubjectFromContext = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(event.context.map((i)=>i.component || i.componentName).filter(Boolean));
const $03330681e31fdbd3$var$fireEventWhenIdle = (fireFn, event, ...rest)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(()=>fireFn(event, ...rest));
    else fireFn(event, ...rest);
};
const $03330681e31fdbd3$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    const { action: attrAction, actionSubject: attrSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $39ajt.getSubjectsFromArguments)(...rest);
    const action = event.payload?.action || attrAction;
    const actionSubject = event.payload?.actionSubject || attrSubject || $03330681e31fdbd3$var$getActionSubjectFromContext(event);
    $03330681e31fdbd3$var$fireAnalyticsOfType(event, (0, $4d5e0871c06cee03$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $03330681e31fdbd3$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $03330681e31fdbd3$var$fireAnalyticsOfType = (event, eventType, analyticsProps)=>{
    // UI_EVENT_TYPE condition - just not to affect existing events we're sending; not to require update of existing monitoring
    const eventTypeForError = eventType === (0, $4d5e0871c06cee03$export$a1562d08625f5d7e) ? eventType : $03330681e31fdbd3$var$capitalize(eventType.toLowerCase());
    if (!event.clone) throw Error(`There is no analytics event from atlaskit in ${eventTypeForError} event`);
    if (!analyticsProps.action) throw Error(`Mandatory "action" field is missing from ${eventTypeForError} event`);
    if (!analyticsProps.actionSubject) throw Error(`Mandatory "actionSubject" field is missing from ${eventTypeForError} event`);
    $03330681e31fdbd3$export$34ac71ce24cddec2(event, eventType, analyticsProps);
};
const $03330681e31fdbd3$export$13990ad4625571ed = (event, ...rest)=>{
    const analyticsProps = (0, $39ajt.getSubjectsFromArguments)(...rest);
    $03330681e31fdbd3$var$fireAnalyticsOfType(event, (0, $4d5e0871c06cee03$export$947dac6c72b26f81), analyticsProps);
};
const $03330681e31fdbd3$export$b6c00a2e59d74c5e = (event, ...rest)=>$03330681e31fdbd3$var$fireEventWhenIdle($03330681e31fdbd3$export$13990ad4625571ed, event, ...rest);
const $03330681e31fdbd3$export$79f423cc3fd39762 = (event, ...rest)=>{
    const analyticsProps = (0, $39ajt.getSubjectsFromArguments)(...rest);
    $03330681e31fdbd3$var$fireAnalyticsOfType(event, (0, $4d5e0871c06cee03$export$12346a674644c156), analyticsProps);
};
const $03330681e31fdbd3$export$6bb7ef8f82969e8f = (event, ...rest)=>$03330681e31fdbd3$var$fireEventWhenIdle($03330681e31fdbd3$export$79f423cc3fd39762, event, ...rest);
const $03330681e31fdbd3$export$6f46fb37ad7d962b = (event, attributes = {})=>{
    if (!event.clone) throw Error('There is no analytics event from atlaskit in Screen event');
    $03330681e31fdbd3$export$34ac71ce24cddec2(event, (0, $4d5e0871c06cee03$export$f1d537d508d2945a), {
        attributes: attributes
    });
};
const $03330681e31fdbd3$export$59b89d5a711a4fa = (event, attributes = {})=>$03330681e31fdbd3$var$fireEventWhenIdle($03330681e31fdbd3$export$6f46fb37ad7d962b, event, attributes);

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("39ajt", function(module, exports) {

$parcel$export(module.exports, "getSubjectsFromArguments", () => $4cbfe21874158acb$export$c9bdf245bf8922fc);
$parcel$export(module.exports, "getAnalyticsType", () => $4cbfe21874158acb$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $4cbfe21874158acb$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $4cbfe21874158acb$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $4cbfe21874158acb$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $4cbfe21874158acb$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $4cbfe21874158acb$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $4cbfe21874158acb$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $4cbfe21874158acb$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $4cbfe21874158acb$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $4cbfe21874158acb$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $4cbfe21874158acb$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainers", () => $4cbfe21874158acb$export$ae861c5c02c4c14c);

var $183uB = parcelRequire("183uB");

var $cjFoH = parcelRequire("cjFoH");

var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

var $9xWGk = parcelRequire("9xWGk");

var $kGsr8 = parcelRequire("kGsr8");
// TODO remove `| ActionSubjectId` as a type option, from the actionSubjectAndAction, As the usage is deprecated
/**
 * @param string - string with format 'actionSubject action' or 'actionSubjectId'. It is recommended to supply an EventOverrides object instead of actionSubjectId.
 */ const $4cbfe21874158acb$var$extractDataFromStringAttribute = (actionSubjectAndAction)=>{
    const arr = actionSubjectAndAction.split(' ');
    switch(arr.length){
        /**
		 * @deprecated We no longer support this case as it leads to confusion with how the analytics API should be used.
		 * @see https://hello.atlassian.net/wiki/spaces/TGR/pages/2922733949
		 */ case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $4cbfe21874158acb$export$a502e64ed48035b = (obj)=>{
    const keysCount = Object.keys(obj).length;
    if (keysCount === 4) return 'actionSubjectId' in obj && 'attributes' in obj && 'action' in obj && 'actionSubject' in obj;
    return false;
};
/**
 * @param one - can be either string with format 'actionSubject action', AnalyticsAttributes or EventOverrides.
 * @example
 * ```ts
 * extractDataFromOneAttribute('button clicked') // { actionSubject: 'button', action: 'clicked', actionSubjectId: undefined, attributes: undefined }
 * extractDataFromOneAttribute({ foo: 'bar' }) // { actionSubject: undefined, action: undefined, actionSubjectId: undefined, attributes: { foo: 'bar' } }
 * extractDataFromOneAttribute({
 *  action: 'clicked',
 *  actionSubject: 'button',
 *  actionSubjectId: 'foo',
 *  attributes: { foo: 'bar' }
 * }) // { actionSubject: 'button', action: 'clicked', actionSubjectId: 'foo', attributes: { foo: 'bar' } }
 * ```
 */ const $4cbfe21874158acb$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $4cbfe21874158acb$var$extractDataFromStringAttribute(one);
    if ($4cbfe21874158acb$export$a502e64ed48035b(one)) return one;
    return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
};
const $4cbfe21874158acb$var$extractDataFromTwoAttributes = (actionSubjectAndAction, actionSubjectIdOrAttributes)=>{
    if (typeof actionSubjectIdOrAttributes === 'string') {
        const { action: action, actionSubject: actionSubject } = $4cbfe21874158acb$var$extractDataFromStringAttribute(actionSubjectAndAction);
        const actionSubjectId = actionSubjectIdOrAttributes;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $4cbfe21874158acb$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: actionSubjectIdOrAttributes
    };
};
const $4cbfe21874158acb$var$extractDataFromThreeAttributes = (actionSubjectAndAction, actionSubjectId, attributes)=>{
    const { action: action, actionSubject: actionSubject } = $4cbfe21874158acb$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
const $4cbfe21874158acb$var$extractFromContext = (event, property)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    event.context.map((item)=>item[property]);
const $4cbfe21874158acb$export$c9bdf245bf8922fc = (...attrs)=>{
    if (!attrs || !attrs.length) return {
        action: undefined,
        actionSubject: undefined,
        actionSubjectId: undefined,
        attributes: undefined
    };
    switch(attrs.length){
        case 1:
            return $4cbfe21874158acb$var$extractDataFromOneAttribute(attrs[0]);
        case 2:
            return $4cbfe21874158acb$var$extractDataFromTwoAttributes(attrs[0], attrs[1]);
        case 3:
            return $4cbfe21874158acb$var$extractDataFromThreeAttributes(attrs[0], attrs[1], attrs[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
const $4cbfe21874158acb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4cbfe21874158acb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4cbfe21874158acb$var$extractFromContext(event, 'attributes');
    const sources = $4cbfe21874158acb$var$extractFromContext(event, 'source');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextAttributes.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
};
const $4cbfe21874158acb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'source').filter(Boolean));
const $4cbfe21874158acb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4cbfe21874158acb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4cbfe21874158acb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4cbfe21874158acb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4cbfe21874158acb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4cbfe21874158acb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4cbfe21874158acb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($4cbfe21874158acb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4cbfe21874158acb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))((0, (/*@__PURE__*/$parcel$interopDefault($183uB)))($4cbfe21874158acb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
const $4cbfe21874158acb$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $4cbfe21874158acb$var$extractFromContext(event, 'containers');
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("lhVtI", function(module, exports) {

$parcel$export(module.exports, "getEvent", () => $750b6c701343a43d$export$ee2085e97a04e027);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $cjFoH = parcelRequire("cjFoH");

var $9xWGk = parcelRequire("9xWGk");


var $39ajt = parcelRequire("39ajt");
const $750b6c701343a43d$export$ee2085e97a04e027 = (event)=>{
    const analyticsType = (0, $39ajt.getAnalyticsType)(event);
    const attributes = (0, $39ajt.getAttributes)(event);
    const containers = (0, $39ajt.getContainers)(event);
    const source = (0, $39ajt.getSource)(event);
    const actionSubject = (0, $39ajt.getActionSubject)(event);
    if (analyticsType === (0, $4d5e0871c06cee03$export$f1d537d508d2945a)) return {
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $4d5e0871c06cee03$export$a1562d08625f5d7e:
        case 0, $4d5e0871c06cee03$export$947dac6c72b26f81:
        case 0, $4d5e0871c06cee03$export$12346a674644c156:
            {
                const action = (0, $39ajt.getAction)(event);
                const actionSubjectId = (0, $39ajt.getActionSubjectId)(event);
                const containerId = (0, $39ajt.getContainerId)(event);
                const containerType = (0, $39ajt.getContainerType)(event);
                const objectId = (0, $39ajt.getObjectId)(event);
                const objectType = (0, $39ajt.getObjectType)(event);
                const tags = (0, $39ajt.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($cjFoH))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};

});


parcelRegister("6Z846", function(module, exports) {

$parcel$export(module.exports, "isShallowEqual", () => $77b4c6a8366d876c$export$2225b4c39d37f8b3);
const $77b4c6a8366d876c$var$hasOwnProp = Object.prototype.hasOwnProperty;
const $77b4c6a8366d876c$export$2225b4c39d37f8b3 = (a, b, compare = Object.is)=>{
    if (compare(a, b)) return true;
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    let i = keysA.length;
    while(i--){
        const key = keysA[i];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        if (!$77b4c6a8366d876c$var$hasOwnProp.call(b, key) || !compare(a[key], b[key])) return false;
    }
    return true;
};

});


parcelRegister("cAUzv", function(module, exports) {

$parcel$export(module.exports, "extractFactoryFunction", () => $5a7f64eb0b6310bf$export$d9a70f5f8c7d4785);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => $5a7f64eb0b6310bf$export$4b8cb2da7a763ee8);

var $jcw0u = parcelRequire("jcw0u");
const $5a7f64eb0b6310bf$export$d9a70f5f8c7d4785 = (fn)=>{
    if (!(fn && typeof fn === 'function' && fn.length === 0)) return fn;
    try {
        const result = fn();
        return typeof result === 'function' ? result : fn;
    } catch (e) {
        return fn;
    }
};
const $5a7f64eb0b6310bf$export$4b8cb2da7a763ee8 = (mapStateToProps)=>{
    // return non-wrapped mapStateToProps if not a function
    if (!mapStateToProps) return mapStateToProps;
    if (typeof mapStateToProps !== 'function') return mapStateToProps;
    // return wrapped mapStateToProps which catches error, reports it and throws error again
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...props)=>{
        try {
            return mapStateToProps(...props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'mapStateToProps',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                error: e
            });
            throw e;
        }
    };
};

});


parcelRegister("8Uumt", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("ai1Tg"));

});
parcelRegister("ai1Tg", function(module, exports) {
'use strict';

var $9FY11 = parcelRequire("9FY11");

var $l4ZFM = parcelRequire("l4ZFM");

var $47DdV = parcelRequire("47DdV");

var $jaU96 = parcelRequire("jaU96");

var $7mpTt = parcelRequire("7mpTt");

var $aTIkl = parcelRequire("aTIkl");

var $9YyJ0 = parcelRequire("9YyJ0");

var $a6M7O = parcelRequire("a6M7O");

var $aKraw = parcelRequire("aKraw");
var $77dd0d3316b263be$var$loadQuery = $aKraw.loadQuery;

var $1auXT = parcelRequire("1auXT");

var $GBSe8 = parcelRequire("GBSe8");

var $couvJ = parcelRequire("couvJ");

var $8fqWB = parcelRequire("8fqWB");

var $eofgg = parcelRequire("eofgg");

var $ITbUa = parcelRequire("ITbUa");

var $667zR = parcelRequire("667zR");

var $jZlQN = parcelRequire("jZlQN");

var $iEtZE = parcelRequire("iEtZE");

var $6FDcO = parcelRequire("6FDcO");

var $kxGyI = parcelRequire("kxGyI");

var $g3TRS = parcelRequire("g3TRS");

var $jLHdt = parcelRequire("jLHdt");

var $jfy4f = parcelRequire("jfy4f");

var $eiowN = parcelRequire("eiowN");
module.exports = {
    ConnectionHandler: $eiowN.ConnectionHandler,
    QueryRenderer: $7mpTt,
    LocalQueryRenderer: $47DdV,
    MutationTypes: $eiowN.MutationTypes,
    RangeOperations: $eiowN.RangeOperations,
    ReactRelayContext: $9FY11,
    applyOptimisticMutation: $eiowN.applyOptimisticMutation,
    commitLocalUpdate: $eiowN.commitLocalUpdate,
    commitMutation: $eiowN.commitMutation,
    createFragmentContainer: $l4ZFM.createContainer,
    createPaginationContainer: $jaU96.createContainer,
    createRefetchContainer: $aTIkl.createContainer,
    fetchQuery_DEPRECATED: $eiowN.fetchQuery_DEPRECATED,
    graphql: $eiowN.graphql,
    readInlineData: $eiowN.readInlineData,
    requestSubscription: $eiowN.requestSubscription,
    EntryPointContainer: $9YyJ0,
    RelayEnvironmentProvider: $GBSe8,
    ProfilerContext: $1auXT,
    fetchQuery: $eiowN.fetchQuery,
    loadQuery: $77dd0d3316b263be$var$loadQuery,
    loadEntryPoint: $a6M7O,
    useClientQuery: $couvJ,
    useFragment: $eofgg,
    useLazyLoadQuery: $ITbUa,
    useEntryPointLoader: $8fqWB,
    useQueryLoader: $6FDcO,
    useMutation: $667zR,
    usePaginationFragment: $jZlQN,
    usePreloadedQuery: $iEtZE,
    useRefetchableFragment: $kxGyI,
    useRelayEnvironment: $g3TRS,
    useSubscribeToInvalidationState: $jLHdt,
    useSubscription: $jfy4f
};

});
parcelRegister("9FY11", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $70b67f32e7749ab0$var$createRelayContext = $eiowN.__internal.createRelayContext;
module.exports = $70b67f32e7749ab0$var$createRelayContext($5uXOq);

});
parcelRegister("eiowN", function(module, exports) {
/**
 * Relay v0.0.0-main-5980a913
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("ayYwL"));

});
parcelRegister("ayYwL", function(module, exports) {
'use strict';

var $6rMqE = parcelRequire("6rMqE");

var $aZrln = parcelRequire("aZrln");

var $iBS76 = parcelRequire("iBS76");

var $94lOA = parcelRequire("94lOA");

var $dKQ6c = parcelRequire("dKQ6c");

var $3vLc6 = parcelRequire("3vLc6");

var $lHSXK = parcelRequire("lHSXK");

var $fwYvm = parcelRequire("fwYvm");

var $ba6EV = parcelRequire("ba6EV");

var $fzyFU = parcelRequire("fzyFU");

var $iiJyo = parcelRequire("iiJyo");

var $giy5c = parcelRequire("giy5c");

var $8xeD3 = parcelRequire("8xeD3");

var $1sxqR = parcelRequire("1sxqR");

var $9IwIy = parcelRequire("9IwIy");

var $4iDAw = parcelRequire("4iDAw");

var $dgkLD = parcelRequire("dgkLD");
var $7b0c07d59afd09dc$var$generateClientID = $dgkLD.generateClientID, $7b0c07d59afd09dc$var$generateUniqueClientID = $dgkLD.generateUniqueClientID, $7b0c07d59afd09dc$var$isClientID = $dgkLD.isClientID;

var $f2SIM = parcelRequire("f2SIM");

var $3n6ka = parcelRequire("3n6ka");

var $9a00R = parcelRequire("9a00R");
var $7b0c07d59afd09dc$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel, $7b0c07d59afd09dc$var$suspenseSentinel = $9a00R.suspenseSentinel;

var $6YESs = parcelRequire("6YESs");

var $egtsh = parcelRequire("egtsh");

var $4vBS9 = parcelRequire("4vBS9");

var $kgs0j = parcelRequire("kgs0j");

var $97t9c = parcelRequire("97t9c");

var $gNCy0 = parcelRequire("gNCy0");

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");

var $aWP6d = parcelRequire("aWP6d");

var $6TOns = parcelRequire("6TOns");

var $67IX0 = parcelRequire("67IX0");

var $dfBRB = parcelRequire("dfBRB");

var $8tSNa = parcelRequire("8tSNa");

var $3r4Jp = parcelRequire("3r4Jp");

var $idYnc = parcelRequire("idYnc");

var $850ax = parcelRequire("850ax");

var $259Mc = parcelRequire("259Mc");

var $iUdPZ = parcelRequire("iUdPZ");

var $edNjw = parcelRequire("edNjw");

var $dVXVE = parcelRequire("dVXVE");

var $gAA10 = parcelRequire("gAA10");

var $gK5oo = parcelRequire("gK5oo");

var $6qcLj = parcelRequire("6qcLj");

var $eRozQ = parcelRequire("eRozQ");

var $hCyoo = parcelRequire("hCyoo");

var $gVASf = parcelRequire("gVASf");

var $j1f4S = parcelRequire("j1f4S");

var $473qV = parcelRequire("473qV");

var $b2CqU = parcelRequire("b2CqU");

var $7AO8k = parcelRequire("7AO8k");

var $aewLq = parcelRequire("aewLq");

var $8lAOl = parcelRequire("8lAOl");

var $brVAm = parcelRequire("brVAm");

var $3Yhea = parcelRequire("3Yhea");

var $90WnW = parcelRequire("90WnW");

var $1B8Po = parcelRequire("1B8Po");

var $hTmkp = parcelRequire("hTmkp");
var $7b0c07d59afd09dc$var$mapStr, $7b0c07d59afd09dc$var$setStr, $7b0c07d59afd09dc$var$promiseStr, $7b0c07d59afd09dc$var$objStr;
module.exports = {
    Environment: $97t9c,
    Network: $ba6EV,
    Observable: $fzyFU,
    QueryResponseCache: $iiJyo,
    RecordSource: $67IX0,
    Record: $jeujn,
    ReplaySubject: $90WnW,
    Store: $aWP6d,
    areEqualSelectors: $hqAuM.areEqualSelectors,
    createFragmentSpecResolver: $f2SIM,
    createNormalizationSelector: $hqAuM.createNormalizationSelector,
    createOperationDescriptor: $gNCy0.createOperationDescriptor,
    createReaderSelector: $hqAuM.createReaderSelector,
    createRequestDescriptor: $gNCy0.createRequestDescriptor,
    getArgumentValues: $dfBRB.getArgumentValues,
    getDataIDsFromFragment: $hqAuM.getDataIDsFromFragment,
    getDataIDsFromObject: $hqAuM.getDataIDsFromObject,
    getNode: $9IwIy.getNode,
    getFragment: $9IwIy.getFragment,
    getInlineDataFragment: $9IwIy.getInlineDataFragment,
    getModuleComponentKey: $dfBRB.getModuleComponentKey,
    getModuleOperationKey: $dfBRB.getModuleOperationKey,
    getPaginationFragment: $9IwIy.getPaginationFragment,
    getPluralSelector: $hqAuM.getPluralSelector,
    getRefetchableFragment: $9IwIy.getRefetchableFragment,
    getRequest: $9IwIy.getRequest,
    getRequestIdentifier: $eRozQ,
    getSelector: $hqAuM.getSelector,
    getSelectorsFromObject: $hqAuM.getSelectorsFromObject,
    getSingularSelector: $hqAuM.getSingularSelector,
    getStorageKey: $dfBRB.getStorageKey,
    getVariablesFromFragment: $hqAuM.getVariablesFromFragment,
    getVariablesFromObject: $hqAuM.getVariablesFromObject,
    getVariablesFromPluralFragment: $hqAuM.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $hqAuM.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $gVASf,
    graphql: $9IwIy.graphql,
    isFragment: $9IwIy.isFragment,
    isInlineDataFragment: $9IwIy.isInlineDataFragment,
    isSuspenseSentinel: $7b0c07d59afd09dc$var$isSuspenseSentinel,
    suspenseSentinel: $7b0c07d59afd09dc$var$suspenseSentinel,
    isRequest: $9IwIy.isRequest,
    readInlineData: $4vBS9,
    MutationTypes: $fwYvm.MutationTypes,
    RangeOperations: $fwYvm.RangeOperations,
    DefaultHandlerProvider: $94lOA,
    ConnectionHandler: $6rMqE,
    MutationHandlers: $iBS76,
    VIEWER_ID: $3r4Jp.VIEWER_ID,
    VIEWER_TYPE: $3r4Jp.VIEWER_TYPE,
    applyOptimisticMutation: $dKQ6c,
    commitLocalUpdate: $3vLc6,
    commitMutation: $lHSXK,
    fetchQuery: $giy5c,
    fetchQuery_DEPRECATED: $8xeD3,
    isRelayModernEnvironment: $6YESs,
    requestSubscription: $idYnc,
    ConnectionInterface: $aZrln,
    PreloadableQueryRegistry: $4iDAw,
    RelayProfiler: $3Yhea,
    createPayloadFor3DField: $850ax,
    RelayConcreteNode: $7AO8k,
    RelayError: $8lAOl,
    RelayFeatureFlags: $brVAm,
    DEFAULT_HANDLE_KEY: $aewLq.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $dfBRB.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $dfBRB.FRAGMENT_OWNER_KEY,
    ID_KEY: $dfBRB.ID_KEY,
    REF_KEY: $dfBRB.REF_KEY,
    REFS_KEY: $dfBRB.REFS_KEY,
    ROOT_ID: $dfBRB.ROOT_ID,
    ROOT_TYPE: $dfBRB.ROOT_TYPE,
    TYPENAME_KEY: $dfBRB.TYPENAME_KEY,
    deepFreeze: $259Mc,
    generateClientID: $7b0c07d59afd09dc$var$generateClientID,
    generateUniqueClientID: $7b0c07d59afd09dc$var$generateUniqueClientID,
    getRelayHandleKey: $6qcLj,
    isClientID: $7b0c07d59afd09dc$var$isClientID,
    isPromise: $j1f4S,
    isScalarAndEqual: $473qV,
    recycleNodesInto: $b2CqU,
    stableCopy: $1B8Po,
    getFragmentIdentifier: $iUdPZ,
    getRefetchMetadata: $gK5oo,
    getPaginationMetadata: $edNjw,
    getPaginationVariables: $dVXVE,
    getPendingOperationsForFragment: $gAA10,
    getValueAtPath: $hCyoo,
    __internal: {
        ResolverFragments: $8tSNa,
        OperationTracker: $6TOns,
        createRelayContext: $3n6ka,
        getOperationVariables: $kgs0j.getOperationVariables,
        getLocalVariables: $kgs0j.getLocalVariables,
        fetchQuery: $1sxqR.fetchQuery,
        fetchQueryDeduped: $1sxqR.fetchQueryDeduped,
        getPromiseForActiveRequest: $1sxqR.getPromiseForActiveRequest,
        getObservableForActiveRequest: $1sxqR.getObservableForActiveRequest,
        normalizeResponse: $egtsh,
        withProvidedVariables: $hTmkp
    }
};

});
parcelRegister("6rMqE", function(module, exports) {
'use strict';

var $dgkLD = parcelRequire("dgkLD");
var $4b1ad4ae4266f546$var$generateClientID = $dgkLD.generateClientID;

var $dfBRB = parcelRequire("dfBRB");
var $4b1ad4ae4266f546$var$getStableStorageKey = $dfBRB.getStableStorageKey;

var $6qcLj = parcelRequire("6qcLj");

var $aZrln = parcelRequire("aZrln");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $4b1ad4ae4266f546$var$CONNECTION = 'connection';
var $4b1ad4ae4266f546$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $4b1ad4ae4266f546$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $aZrln.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey);
        return;
    }
    var clientConnectionID = $4b1ad4ae4266f546$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $4b1ad4ae4266f546$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $4b1ad4ae4266f546$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($4b1ad4ae4266f546$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $4b1ad4ae4266f546$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $4b1ad4ae4266f546$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $4b1ad4ae4266f546$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $4b1ad4ae4266f546$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $4b1ad4ae4266f546$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $4b1ad4ae4266f546$var$getConnection(record, key, filters) {
    var handleKey = $6qcLj($4b1ad4ae4266f546$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $4b1ad4ae4266f546$var$getConnectionID(recordID, key, filters) {
    var handleKey = $6qcLj($4b1ad4ae4266f546$var$CONNECTION, key, null);
    var storageKey = $4b1ad4ae4266f546$var$getStableStorageKey(handleKey, filters);
    return $4b1ad4ae4266f546$var$generateClientID(recordID, storageKey);
}
function $4b1ad4ae4266f546$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $aZrln.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $4b1ad4ae4266f546$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $aZrln.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $4b1ad4ae4266f546$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $4b1ad4ae4266f546$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $aZrln.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $4b1ad4ae4266f546$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $aZrln.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $4b1ad4ae4266f546$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $aZrln.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($4b1ad4ae4266f546$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $aE1Lc(false);
    var edgeID = $4b1ad4ae4266f546$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $4b1ad4ae4266f546$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $4b1ad4ae4266f546$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $aZrln.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $4b1ad4ae4266f546$var$buildConnectionEdge,
    createEdge: $4b1ad4ae4266f546$var$createEdge,
    deleteNode: $4b1ad4ae4266f546$var$deleteNode,
    getConnection: $4b1ad4ae4266f546$var$getConnection,
    getConnectionID: $4b1ad4ae4266f546$var$getConnectionID,
    insertEdgeAfter: $4b1ad4ae4266f546$var$insertEdgeAfter,
    insertEdgeBefore: $4b1ad4ae4266f546$var$insertEdgeBefore,
    update: $4b1ad4ae4266f546$var$update
};

});
parcelRegister("dgkLD", function(module, exports) {
'use strict';

var $brVAm = parcelRequire("brVAm");

var $blaje = parcelRequire("blaje");
var $9a7ce0eec729fb88$var$intern = $blaje.intern;
var $9a7ce0eec729fb88$var$PREFIX = 'client:';
function $9a7ce0eec729fb88$var$generateClientID(id, storageKey, index) {
    var internedId = $brVAm.STRING_INTERN_LEVEL <= 0 ? id : $9a7ce0eec729fb88$var$intern(id, $brVAm.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($9a7ce0eec729fb88$var$PREFIX) !== 0) key = $9a7ce0eec729fb88$var$PREFIX + key;
    return key;
}
function $9a7ce0eec729fb88$var$isClientID(id) {
    return id.indexOf($9a7ce0eec729fb88$var$PREFIX) === 0;
}
var $9a7ce0eec729fb88$var$localID = 0;
function $9a7ce0eec729fb88$var$generateUniqueClientID() {
    return "".concat($9a7ce0eec729fb88$var$PREFIX, "local:").concat($9a7ce0eec729fb88$var$localID++);
}
function $9a7ce0eec729fb88$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($9a7ce0eec729fb88$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $9a7ce0eec729fb88$var$generateClientID,
    generateClientObjectClientID: $9a7ce0eec729fb88$var$generateClientObjectClientID,
    generateUniqueClientID: $9a7ce0eec729fb88$var$generateUniqueClientID,
    isClientID: $9a7ce0eec729fb88$var$isClientID
};

});
parcelRegister("brVAm", function(module, exports) {
'use strict';
var $855ee29d41bc2f55$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_LOAD_QUERY_REQUEST_DEDUPING: true,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    ENABLE_FIELD_ERROR_HANDLING: false,
    ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT: false,
    ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false
};
module.exports = $855ee29d41bc2f55$var$RelayFeatureFlags;

});

parcelRegister("blaje", function(module, exports) {
'use strict';
var $8419a70ae817fabc$var$internTable = new Map();
var $8419a70ae817fabc$var$nextIndex = 1;
var $8419a70ae817fabc$var$digits = $8419a70ae817fabc$var$initDigitTable();
var $8419a70ae817fabc$var$INTERN_PREFIX = '\t';
var $8419a70ae817fabc$var$ESCAPE_PREFIX = '\v';
function $8419a70ae817fabc$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $8419a70ae817fabc$var$escape(str) {
    if (str[0] === $8419a70ae817fabc$var$INTERN_PREFIX && $8419a70ae817fabc$var$digits.has(str[1]) || str[0] === $8419a70ae817fabc$var$ESCAPE_PREFIX) return $8419a70ae817fabc$var$ESCAPE_PREFIX + str;
    return str;
}
function $8419a70ae817fabc$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $8419a70ae817fabc$var$escape(str);
    var internedString = $8419a70ae817fabc$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $8419a70ae817fabc$var$INTERN_PREFIX + $8419a70ae817fabc$var$nextIndex++;
    $8419a70ae817fabc$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $8419a70ae817fabc$var$intern
};

});


parcelRegister("dfBRB", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $9a5a0bfa3ecf5ea1$var$_interopRequireDefault = $7gV6J.default;

var $9a5a0bfa3ecf5ea1$var$_toConsumableArray2 = $9a5a0bfa3ecf5ea1$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $6qcLj = parcelRequire("6qcLj");

var $7AO8k = parcelRequire("7AO8k");

var $1B8Po = parcelRequire("1B8Po");

var $aE1Lc = parcelRequire("aE1Lc");
var $9a5a0bfa3ecf5ea1$var$VARIABLE = $7AO8k.VARIABLE, $9a5a0bfa3ecf5ea1$var$LITERAL = $7AO8k.LITERAL, $9a5a0bfa3ecf5ea1$var$OBJECT_VALUE = $7AO8k.OBJECT_VALUE, $9a5a0bfa3ecf5ea1$var$LIST_VALUE = $7AO8k.LIST_VALUE;
var $9a5a0bfa3ecf5ea1$var$ERRORS_KEY = '__errors';
var $9a5a0bfa3ecf5ea1$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $9a5a0bfa3ecf5ea1$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
function $9a5a0bfa3ecf5ea1$var$getArgumentValue(arg, variables) {
    if (arg.kind === $9a5a0bfa3ecf5ea1$var$VARIABLE) return $9a5a0bfa3ecf5ea1$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $9a5a0bfa3ecf5ea1$var$LITERAL) return arg.value;
    else if (arg.kind === $9a5a0bfa3ecf5ea1$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $9a5a0bfa3ecf5ea1$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $9a5a0bfa3ecf5ea1$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($9a5a0bfa3ecf5ea1$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $9a5a0bfa3ecf5ea1$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$9a5a0bfa3ecf5ea1$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $9a5a0bfa3ecf5ea1$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $9a5a0bfa3ecf5ea1$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $6qcLj(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $9a5a0bfa3ecf5ea1$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $9a5a0bfa3ecf5ea1$var$formatStorageKey(handleName, $9a5a0bfa3ecf5ea1$var$getArgumentValues(filterArgs, variables));
}
function $9a5a0bfa3ecf5ea1$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $9a5a0bfa3ecf5ea1$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $9a5a0bfa3ecf5ea1$var$formatStorageKey(name, $9a5a0bfa3ecf5ea1$var$getArgumentValues(args, variables)) : name;
}
function $9a5a0bfa3ecf5ea1$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $9a5a0bfa3ecf5ea1$var$getStableStorageKey(name, args) {
    return $9a5a0bfa3ecf5ea1$var$formatStorageKey(name, $1B8Po(args));
}
function $9a5a0bfa3ecf5ea1$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $9a5a0bfa3ecf5ea1$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $aE1Lc(false);
    return $1B8Po(variables[name]);
}
function $9a5a0bfa3ecf5ea1$var$getModuleComponentKey(documentName) {
    return "".concat($9a5a0bfa3ecf5ea1$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $9a5a0bfa3ecf5ea1$var$getModuleOperationKey(documentName) {
    return "".concat($9a5a0bfa3ecf5ea1$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $9a5a0bfa3ecf5ea1$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $9a5a0bfa3ecf5ea1$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    formatStorageKey: $9a5a0bfa3ecf5ea1$var$formatStorageKey,
    getArgumentValue: $9a5a0bfa3ecf5ea1$var$getArgumentValue,
    getArgumentValues: $9a5a0bfa3ecf5ea1$var$getArgumentValues,
    getHandleStorageKey: $9a5a0bfa3ecf5ea1$var$getHandleStorageKey,
    getStorageKey: $9a5a0bfa3ecf5ea1$var$getStorageKey,
    getStableStorageKey: $9a5a0bfa3ecf5ea1$var$getStableStorageKey,
    getModuleComponentKey: $9a5a0bfa3ecf5ea1$var$getModuleComponentKey,
    getModuleOperationKey: $9a5a0bfa3ecf5ea1$var$getModuleOperationKey
};
module.exports = $9a5a0bfa3ecf5ea1$var$RelayStoreUtils;

});
parcelRegister("6qcLj", function(module, exports) {
'use strict';

var $aewLq = parcelRequire("aewLq");
var $4acf120e98b998d6$var$DEFAULT_HANDLE_KEY = $aewLq.DEFAULT_HANDLE_KEY;

var $aE1Lc = parcelRequire("aE1Lc");
function $4acf120e98b998d6$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $4acf120e98b998d6$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $aE1Lc(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $4acf120e98b998d6$var$getRelayHandleKey;

});
parcelRegister("aewLq", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});

parcelRegister("aE1Lc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $7bff015bbbc3674d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $7bff015bbbc3674d$var$invariant;

});


parcelRegister("7AO8k", function(module, exports) {
'use strict';
var $5872c8a07403b947$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $5872c8a07403b947$var$RelayConcreteNode;

});

parcelRegister("1B8Po", function(module, exports) {
'use strict';
function $12a0182f2ab1655c$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($12a0182f2ab1655c$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $12a0182f2ab1655c$var$stableCopy(value[keys[i]]);
    return stable;
}
module.exports = $12a0182f2ab1655c$var$stableCopy;

});


parcelRegister("aZrln", function(module, exports) {
'use strict';
var $8004cfcfa26fc246$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $8004cfcfa26fc246$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $8004cfcfa26fc246$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $8004cfcfa26fc246$var$config = newConfig;
    },
    get: function get() {
        return $8004cfcfa26fc246$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $8004cfcfa26fc246$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $8004cfcfa26fc246$var$ConnectionInterface;

});

parcelRegister("1srSR", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $d2yL6 = parcelRequire("d2yL6");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $10fe09229245eb75$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $10fe09229245eb75$var$warning = $d2yL6;
module.exports = $10fe09229245eb75$var$warning;

});
parcelRegister("d2yL6", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $97e66c9a852d37ff$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $97e66c9a852d37ff$var$emptyFunction = function emptyFunction() {};
$97e66c9a852d37ff$var$emptyFunction.thatReturns = $97e66c9a852d37ff$var$makeEmptyFunction;
$97e66c9a852d37ff$var$emptyFunction.thatReturnsFalse = $97e66c9a852d37ff$var$makeEmptyFunction(false);
$97e66c9a852d37ff$var$emptyFunction.thatReturnsTrue = $97e66c9a852d37ff$var$makeEmptyFunction(true);
$97e66c9a852d37ff$var$emptyFunction.thatReturnsNull = $97e66c9a852d37ff$var$makeEmptyFunction(null);
$97e66c9a852d37ff$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$97e66c9a852d37ff$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $97e66c9a852d37ff$var$emptyFunction;

});



parcelRegister("iBS76", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $d8c5a88340e745bf$var$_interopRequireDefault = $7gV6J.default;

var $d8c5a88340e745bf$var$_createForOfIteratorHelper2 = $d8c5a88340e745bf$var$_interopRequireDefault((parcelRequire("8utPl")));

var $6rMqE = parcelRequire("6rMqE");

var $aZrln = parcelRequire("aZrln");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $d8c5a88340e745bf$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $d8c5a88340e745bf$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aE1Lc(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $d8c5a88340e745bf$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $6rMqE.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $d8c5a88340e745bf$var$AppendEdgeHandler = {
    update: $d8c5a88340e745bf$var$edgeUpdater($6rMqE.insertEdgeAfter)
};
var $d8c5a88340e745bf$var$PrependEdgeHandler = {
    update: $d8c5a88340e745bf$var$edgeUpdater($6rMqE.insertEdgeBefore)
};
var $d8c5a88340e745bf$var$AppendNodeHandler = {
    update: $d8c5a88340e745bf$var$nodeUpdater($6rMqE.insertEdgeAfter)
};
var $d8c5a88340e745bf$var$PrependNodeHandler = {
    update: $d8c5a88340e745bf$var$nodeUpdater($6rMqE.insertEdgeBefore)
};
function $d8c5a88340e745bf$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $aE1Lc(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $aZrln.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $d8c5a88340e745bf$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $d8c5a88340e745bf$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $6rMqE.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $aE1Lc(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $d8c5a88340e745bf$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $aE1Lc(false);
        !(edgeTypeName != null) && $aE1Lc(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $aZrln.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $d8c5a88340e745bf$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $d8c5a88340e745bf$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $6rMqE.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $aE1Lc(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $d8c5a88340e745bf$var$AppendEdgeHandler,
    DeleteRecordHandler: $d8c5a88340e745bf$var$DeleteRecordHandler,
    PrependEdgeHandler: $d8c5a88340e745bf$var$PrependEdgeHandler,
    AppendNodeHandler: $d8c5a88340e745bf$var$AppendNodeHandler,
    PrependNodeHandler: $d8c5a88340e745bf$var$PrependNodeHandler,
    DeleteEdgeHandler: $d8c5a88340e745bf$var$DeleteEdgeHandler
};

});

parcelRegister("94lOA", function(module, exports) {
'use strict';

var $6rMqE = parcelRequire("6rMqE");

var $iBS76 = parcelRequire("iBS76");

var $aE1Lc = parcelRequire("aE1Lc");
function $69a568c5eb166e7d$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $6rMqE;
        case 'deleteRecord':
            return $iBS76.DeleteRecordHandler;
        case 'deleteEdge':
            return $iBS76.DeleteEdgeHandler;
        case 'appendEdge':
            return $iBS76.AppendEdgeHandler;
        case 'prependEdge':
            return $iBS76.PrependEdgeHandler;
        case 'appendNode':
            return $iBS76.AppendNodeHandler;
        case 'prependNode':
            return $iBS76.PrependNodeHandler;
    }
    $aE1Lc(false);
}
module.exports = $69a568c5eb166e7d$var$RelayDefaultHandlerProvider;

});

parcelRegister("dKQ6c", function(module, exports) {
'use strict';

var $9IwIy = parcelRequire("9IwIy");
var $a037fc064636d28d$var$getRequest = $9IwIy.getRequest;

var $6YESs = parcelRequire("6YESs");

var $gNCy0 = parcelRequire("gNCy0");
var $a037fc064636d28d$var$createOperationDescriptor = $gNCy0.createOperationDescriptor;

var $fwYvm = parcelRequire("fwYvm");

var $aE1Lc = parcelRequire("aE1Lc");
function $a037fc064636d28d$var$applyOptimisticMutation(environment, config) {
    !$6YESs(environment) && $aE1Lc(false);
    var mutation = $a037fc064636d28d$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $a037fc064636d28d$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $fwYvm.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $a037fc064636d28d$var$applyOptimisticMutation;

});
parcelRegister("9IwIy", function(module, exports) {
'use strict';

var $7AO8k = parcelRequire("7AO8k");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $71319a22db4c5bb9$var$graphql(strings) {
    $aE1Lc(false);
}
function $71319a22db4c5bb9$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $71319a22db4c5bb9$var$isFragment(node) {
    var fragment = $71319a22db4c5bb9$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $7AO8k.FRAGMENT;
}
function $71319a22db4c5bb9$var$isRequest(node) {
    var request = $71319a22db4c5bb9$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $7AO8k.REQUEST;
}
function $71319a22db4c5bb9$var$isUpdatableQuery(node) {
    var updatableQuery = $71319a22db4c5bb9$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $7AO8k.UPDATABLE_QUERY;
}
function $71319a22db4c5bb9$var$isInlineDataFragment(node) {
    var fragment = $71319a22db4c5bb9$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $7AO8k.INLINE_DATA_FRAGMENT;
}
function $71319a22db4c5bb9$var$getFragment(taggedNode) {
    var fragment = $71319a22db4c5bb9$var$getNode(taggedNode);
    !$71319a22db4c5bb9$var$isFragment(fragment) && $aE1Lc(false);
    return fragment;
}
function $71319a22db4c5bb9$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $71319a22db4c5bb9$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $71319a22db4c5bb9$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $71319a22db4c5bb9$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $71319a22db4c5bb9$var$getRequest(taggedNode) {
    var request = $71319a22db4c5bb9$var$getNode(taggedNode);
    !$71319a22db4c5bb9$var$isRequest(request) && $aE1Lc(false);
    return request;
}
function $71319a22db4c5bb9$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $71319a22db4c5bb9$var$getNode(taggedNode);
    !$71319a22db4c5bb9$var$isUpdatableQuery(updatableQuery) && $aE1Lc(false);
    return updatableQuery;
}
function $71319a22db4c5bb9$var$getInlineDataFragment(taggedNode) {
    var fragment = $71319a22db4c5bb9$var$getNode(taggedNode);
    !$71319a22db4c5bb9$var$isInlineDataFragment(fragment) && $aE1Lc(false);
    return fragment;
}
module.exports = {
    getFragment: $71319a22db4c5bb9$var$getFragment,
    getNode: $71319a22db4c5bb9$var$getNode,
    getPaginationFragment: $71319a22db4c5bb9$var$getPaginationFragment,
    getRefetchableFragment: $71319a22db4c5bb9$var$getRefetchableFragment,
    getRequest: $71319a22db4c5bb9$var$getRequest,
    getUpdatableQuery: $71319a22db4c5bb9$var$getUpdatableQuery,
    getInlineDataFragment: $71319a22db4c5bb9$var$getInlineDataFragment,
    graphql: $71319a22db4c5bb9$var$graphql,
    isFragment: $71319a22db4c5bb9$var$isFragment,
    isRequest: $71319a22db4c5bb9$var$isRequest,
    isUpdatableQuery: $71319a22db4c5bb9$var$isUpdatableQuery,
    isInlineDataFragment: $71319a22db4c5bb9$var$isInlineDataFragment
};

});

parcelRegister("6YESs", function(module, exports) {
'use strict';
function $51480e11bd485c52$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $51480e11bd485c52$var$isRelayModernEnvironment;

});

parcelRegister("gNCy0", function(module, exports) {
'use strict';
parcelRequire("259Mc");

var $eRozQ = parcelRequire("eRozQ");

var $kgs0j = parcelRequire("kgs0j");
var $c3af1faac269d18c$var$getOperationVariables = $kgs0j.getOperationVariables;

var $hqAuM = parcelRequire("hqAuM");
var $c3af1faac269d18c$var$createNormalizationSelector = $hqAuM.createNormalizationSelector, $c3af1faac269d18c$var$createReaderSelector = $hqAuM.createReaderSelector;

var $dfBRB = parcelRequire("dfBRB");
var $c3af1faac269d18c$var$ROOT_ID = $dfBRB.ROOT_ID;
function $c3af1faac269d18c$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c3af1faac269d18c$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $c3af1faac269d18c$var$getOperationVariables(operation, request.params.providedVariables, variables);
    var requestDescriptor = $c3af1faac269d18c$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $c3af1faac269d18c$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $c3af1faac269d18c$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $c3af1faac269d18c$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $eRozQ(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $c3af1faac269d18c$var$createOperationDescriptor,
    createRequestDescriptor: $c3af1faac269d18c$var$createRequestDescriptor
};

});
parcelRegister("259Mc", function(module, exports) {
'use strict';
function $1843a1d08c82ecf3$var$deepFreeze(object) {
    if (!$1843a1d08c82ecf3$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $1843a1d08c82ecf3$var$deepFreeze(property);
    });
    return object;
}
function $1843a1d08c82ecf3$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $1843a1d08c82ecf3$var$deepFreeze;

});

parcelRegister("eRozQ", function(module, exports) {
'use strict';

var $1B8Po = parcelRequire("1B8Po");

var $aE1Lc = parcelRequire("aE1Lc");
function $ad1914723d4aba26$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $aE1Lc(false);
    return requestID + JSON.stringify($1B8Po(variables));
}
module.exports = $ad1914723d4aba26$var$getRequestIdentifier;

});

parcelRegister("kgs0j", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $ec0b064a295b3aa3$var$_interopRequireDefault = $7gV6J.default;

var $ec0b064a295b3aa3$var$_objectSpread2 = $ec0b064a295b3aa3$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $dfBRB = parcelRequire("dfBRB");
var $ec0b064a295b3aa3$var$getArgumentValues = $dfBRB.getArgumentValues;

var $aE1Lc = parcelRequire("aE1Lc");
function $ec0b064a295b3aa3$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $ec0b064a295b3aa3$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $aE1Lc(false);
        }
    });
    return variables || argumentVariables;
}
function $ec0b064a295b3aa3$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $ec0b064a295b3aa3$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $ec0b064a295b3aa3$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $ec0b064a295b3aa3$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $ec0b064a295b3aa3$var$getLocalVariables,
    getFragmentVariables: $ec0b064a295b3aa3$var$getFragmentVariables,
    getOperationVariables: $ec0b064a295b3aa3$var$getOperationVariables
};

});

parcelRegister("hqAuM", function(module, exports) {
'use strict';

var $kgs0j = parcelRequire("kgs0j");
var $cb012c9cce77ac18$var$getFragmentVariables = $kgs0j.getFragmentVariables;

var $dfBRB = parcelRequire("dfBRB");
var $cb012c9cce77ac18$var$CLIENT_EDGE_TRAVERSAL_PATH = $dfBRB.CLIENT_EDGE_TRAVERSAL_PATH, $cb012c9cce77ac18$var$FRAGMENT_OWNER_KEY = $dfBRB.FRAGMENT_OWNER_KEY, $cb012c9cce77ac18$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $dfBRB.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $cb012c9cce77ac18$var$FRAGMENTS_KEY = $dfBRB.FRAGMENTS_KEY, $cb012c9cce77ac18$var$ID_KEY = $dfBRB.ID_KEY;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $cb012c9cce77ac18$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $aE1Lc(false);
    var dataID = item[$cb012c9cce77ac18$var$ID_KEY];
    var fragments = item[$cb012c9cce77ac18$var$FRAGMENTS_KEY];
    var mixedOwner = item[$cb012c9cce77ac18$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$cb012c9cce77ac18$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $cb012c9cce77ac18$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$cb012c9cce77ac18$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $cb012c9cce77ac18$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $cb012c9cce77ac18$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $cb012c9cce77ac18$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $cb012c9cce77ac18$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getSingularSelector(fragment, item);
    }
}
function $cb012c9cce77ac18$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $cb012c9cce77ac18$var$getSelector(fragment, item);
    }
    return selectors;
}
function $cb012c9cce77ac18$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $cb012c9cce77ac18$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $cb012c9cce77ac18$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getDataID(fragment, item);
    }
}
function $cb012c9cce77ac18$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $cb012c9cce77ac18$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $cb012c9cce77ac18$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $aE1Lc(false);
    var dataID = item[$cb012c9cce77ac18$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $cb012c9cce77ac18$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $cb012c9cce77ac18$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $cb012c9cce77ac18$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $aE1Lc(false);
        return $cb012c9cce77ac18$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $cb012c9cce77ac18$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $cb012c9cce77ac18$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $cb012c9cce77ac18$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $cb012c9cce77ac18$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $cb012c9cce77ac18$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $9p5ca(thisSelector.variables, thatSelector.variables) && $cb012c9cce77ac18$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $cb012c9cce77ac18$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $cb012c9cce77ac18$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $9p5ca(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $cb012c9cce77ac18$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $cb012c9cce77ac18$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $cb012c9cce77ac18$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $cb012c9cce77ac18$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $cb012c9cce77ac18$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $cb012c9cce77ac18$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $cb012c9cce77ac18$var$areEqualSelectors,
    createReaderSelector: $cb012c9cce77ac18$var$createReaderSelector,
    createNormalizationSelector: $cb012c9cce77ac18$var$createNormalizationSelector,
    getDataIDsFromFragment: $cb012c9cce77ac18$var$getDataIDsFromFragment,
    getDataIDsFromObject: $cb012c9cce77ac18$var$getDataIDsFromObject,
    getSingularSelector: $cb012c9cce77ac18$var$getSingularSelector,
    getPluralSelector: $cb012c9cce77ac18$var$getPluralSelector,
    getSelector: $cb012c9cce77ac18$var$getSelector,
    getSelectorsFromObject: $cb012c9cce77ac18$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $cb012c9cce77ac18$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $cb012c9cce77ac18$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $cb012c9cce77ac18$var$getVariablesFromFragment,
    getVariablesFromObject: $cb012c9cce77ac18$var$getVariablesFromObject
};

});
parcelRegister("9p5ca", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $6d8a7a8a0af6c563$var$aStackPool = [];
var $6d8a7a8a0af6c563$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $6d8a7a8a0af6c563$var$areEqual(a, b) {
    var aStack = $6d8a7a8a0af6c563$var$aStackPool.length ? $6d8a7a8a0af6c563$var$aStackPool.pop() : [];
    var bStack = $6d8a7a8a0af6c563$var$bStackPool.length ? $6d8a7a8a0af6c563$var$bStackPool.pop() : [];
    var result = $6d8a7a8a0af6c563$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $6d8a7a8a0af6c563$var$aStackPool.push(aStack);
    $6d8a7a8a0af6c563$var$bStackPool.push(bStack);
    return result;
}
function $6d8a7a8a0af6c563$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$6d8a7a8a0af6c563$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$6d8a7a8a0af6c563$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $6d8a7a8a0af6c563$var$areEqual;

});



parcelRegister("fwYvm", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $b4e8c7311f0f2ac6$var$_interopRequireDefault = $7gV6J.default;

var $b4e8c7311f0f2ac6$var$_createForOfIteratorHelper2 = $b4e8c7311f0f2ac6$var$_interopRequireDefault((parcelRequire("8utPl")));

var $6rMqE = parcelRequire("6rMqE");
parcelRequire("1srSR");
var $b4e8c7311f0f2ac6$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $b4e8c7311f0f2ac6$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $b4e8c7311f0f2ac6$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $b4e8c7311f0f2ac6$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $b4e8c7311f0f2ac6$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $b4e8c7311f0f2ac6$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $b4e8c7311f0f2ac6$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $b4e8c7311f0f2ac6$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $b4e8c7311f0f2ac6$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $b4e8c7311f0f2ac6$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $b4e8c7311f0f2ac6$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $6rMqE.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $6rMqE.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $6rMqE.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $6rMqE.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $b4e8c7311f0f2ac6$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $b4e8c7311f0f2ac6$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $b4e8c7311f0f2ac6$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $b4e8c7311f0f2ac6$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $b4e8c7311f0f2ac6$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $b4e8c7311f0f2ac6$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $6rMqE.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $6rMqE.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $b4e8c7311f0f2ac6$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $b4e8c7311f0f2ac6$var$MutationTypes,
    RangeOperations: $b4e8c7311f0f2ac6$var$RangeOperations,
    convert: $b4e8c7311f0f2ac6$var$convert
};

});


parcelRegister("3vLc6", function(module, exports) {
'use strict';
function $28e8e01daa038d4c$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $28e8e01daa038d4c$var$commitLocalUpdate;

});

parcelRegister("lHSXK", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $fcd83f979288402f$var$_interopRequireDefault = $7gV6J.default;

var $fcd83f979288402f$var$_toConsumableArray2 = $fcd83f979288402f$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $9IwIy = parcelRequire("9IwIy");
var $fcd83f979288402f$var$getRequest = $9IwIy.getRequest;

var $dgkLD = parcelRequire("dgkLD");
var $fcd83f979288402f$var$generateUniqueClientID = $dgkLD.generateUniqueClientID;

var $6YESs = parcelRequire("6YESs");

var $gNCy0 = parcelRequire("gNCy0");
var $fcd83f979288402f$var$createOperationDescriptor = $gNCy0.createOperationDescriptor;

var $fwYvm = parcelRequire("fwYvm");
parcelRequire("kGoc7");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $fcd83f979288402f$var$commitMutation(environment, config) {
    !$6YESs(environment) && $aE1Lc(false);
    var mutation = $fcd83f979288402f$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $fcd83f979288402f$var$createOperationDescriptor(mutation, variables, cacheConfig, $fcd83f979288402f$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $fwYvm.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $fcd83f979288402f$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $fcd83f979288402f$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $fcd83f979288402f$var$commitMutation;

});
parcelRegister("kGoc7", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $f0ea7f662a16d760$var$_interopRequireDefault = $7gV6J.default;

var $f0ea7f662a16d760$var$_objectSpread2 = $f0ea7f662a16d760$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $7AO8k = parcelRequire("7AO8k");
var $f0ea7f662a16d760$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $f0ea7f662a16d760$var$CLIENT_COMPONENT = $7AO8k.CLIENT_COMPONENT, $f0ea7f662a16d760$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT, $f0ea7f662a16d760$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $f0ea7f662a16d760$var$CONDITION = $7AO8k.CONDITION, $f0ea7f662a16d760$var$DEFER = $7AO8k.DEFER, $f0ea7f662a16d760$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $f0ea7f662a16d760$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $f0ea7f662a16d760$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $f0ea7f662a16d760$var$LINKED_HANDLE = $7AO8k.LINKED_HANDLE, $f0ea7f662a16d760$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $f0ea7f662a16d760$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $f0ea7f662a16d760$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $f0ea7f662a16d760$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $f0ea7f662a16d760$var$SCALAR_HANDLE = $7AO8k.SCALAR_HANDLE, $f0ea7f662a16d760$var$STREAM = $7AO8k.STREAM, $f0ea7f662a16d760$var$TYPE_DISCRIMINATOR = $7AO8k.TYPE_DISCRIMINATOR;
parcelRequire("1srSR");
var $f0ea7f662a16d760$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f0ea7f662a16d760$var$validateMutation = function validateMutation() {};
var $f0ea7f662a16d760$var$addFieldToDiff, $f0ea7f662a16d760$var$validateSelections, $f0ea7f662a16d760$var$validateSelection, $f0ea7f662a16d760$var$validateModuleImport, $f0ea7f662a16d760$var$validateAbstractKey, $f0ea7f662a16d760$var$validateField, $f0ea7f662a16d760$var$validateOptimisticResponse;
module.exports = $f0ea7f662a16d760$var$validateMutation;

});


parcelRegister("ba6EV", function(module, exports) {
'use strict';

var $hTmkp = parcelRequire("hTmkp");

var $6sMp5 = parcelRequire("6sMp5");
var $8205cb3b40ebedcd$var$convertFetch = $6sMp5.convertFetch;

var $aE1Lc = parcelRequire("aE1Lc");
function $8205cb3b40ebedcd$var$create(fetchFn, subscribe) {
    var observeFetch = $8205cb3b40ebedcd$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $hTmkp(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $aE1Lc(false);
            !!uploadables && $aE1Lc(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $aE1Lc(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $8205cb3b40ebedcd$var$create
};

});
parcelRegister("hTmkp", function(module, exports) {
'use strict';
parcelRequire("9p5ca");
parcelRequire("1srSR");
var $d068e49fdd9a071c$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $d068e49fdd9a071c$var$debugCache = $d068e49fdd9a071c$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $d068e49fdd9a071c$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$d068e49fdd9a071c$var$debugCache.has(providerFunction)) {
                $d068e49fdd9a071c$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $d068e49fdd9a071c$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$d068e49fdd9a071c$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $d068e49fdd9a071c$var$withProvidedVariables;

});

parcelRegister("6sMp5", function(module, exports) {
'use strict';

var $fzyFU = parcelRequire("fzyFU");
function $4b4ae78cd1d4bf09$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $fzyFU.create(function(sink) {
            return sink.error(result);
        });
        return $fzyFU.from(result);
    };
}
module.exports = {
    convertFetch: $4b4ae78cd1d4bf09$var$convertFetch
};

});
parcelRegister("fzyFU", function(module, exports) {
'use strict';

var $j1f4S = parcelRequire("j1f4S");
var $b56505a0e0eb7539$var$hostReportError = $b56505a0e0eb7539$var$swallowError;
var $b56505a0e0eb7539$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $b56505a0e0eb7539$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $b56505a0e0eb7539$var$isObservable(obj) ? $b56505a0e0eb7539$var$fromObservable(obj) : $j1f4S(obj) ? $b56505a0e0eb7539$var$fromPromise(obj) : $b56505a0e0eb7539$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $b56505a0e0eb7539$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $b56505a0e0eb7539$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $b56505a0e0eb7539$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $b56505a0e0eb7539$var$fromObservable(obj) {
    return obj instanceof $b56505a0e0eb7539$var$RelayObservable ? obj : $b56505a0e0eb7539$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $b56505a0e0eb7539$var$fromPromise(promise) {
    return $b56505a0e0eb7539$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $b56505a0e0eb7539$var$fromValue(value) {
    return $b56505a0e0eb7539$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $b56505a0e0eb7539$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $b56505a0e0eb7539$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $b56505a0e0eb7539$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $b56505a0e0eb7539$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $b56505a0e0eb7539$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $b56505a0e0eb7539$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $b56505a0e0eb7539$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $b56505a0e0eb7539$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $b56505a0e0eb7539$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $b56505a0e0eb7539$var$RelayObservable;

});
parcelRegister("j1f4S", function(module, exports) {
'use strict';
function $dd89ce696d80488e$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $dd89ce696d80488e$var$isPromise;

});




parcelRegister("iiJyo", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $d52d3e70c27e02d1$var$_interopRequireDefault = $7gV6J.default;

var $d52d3e70c27e02d1$var$_objectSpread2 = $d52d3e70c27e02d1$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $1B8Po = parcelRequire("1B8Po");

var $aE1Lc = parcelRequire("aE1Lc");
var $d52d3e70c27e02d1$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $aE1Lc(false);
        !(ttl > 0) && $aE1Lc(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $d52d3e70c27e02d1$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$d52d3e70c27e02d1$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $d52d3e70c27e02d1$var$_objectSpread2["default"])((0, $d52d3e70c27e02d1$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $d52d3e70c27e02d1$var$_objectSpread2["default"])((0, $d52d3e70c27e02d1$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $d52d3e70c27e02d1$var$_objectSpread2["default"])((0, $d52d3e70c27e02d1$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $d52d3e70c27e02d1$var$_objectSpread2["default"])((0, $d52d3e70c27e02d1$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $d52d3e70c27e02d1$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $d52d3e70c27e02d1$var$getCacheKey(queryID, variables) {
    return JSON.stringify($1B8Po({
        queryID: queryID,
        variables: variables
    }));
}
function $d52d3e70c27e02d1$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $d52d3e70c27e02d1$var$RelayQueryResponseCache;

});

parcelRegister("giy5c", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $bdd8c3ed9c6b00f0$var$_interopRequireDefault = $7gV6J.default;

var $bdd8c3ed9c6b00f0$var$_objectSpread2 = $bdd8c3ed9c6b00f0$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $fzyFU = parcelRequire("fzyFU");

var $gNCy0 = parcelRequire("gNCy0");
var $bdd8c3ed9c6b00f0$var$createOperationDescriptor = $gNCy0.createOperationDescriptor;

var $gVASf = parcelRequire("gVASf");

var $1sxqR = parcelRequire("1sxqR");

var $9IwIy = parcelRequire("9IwIy");
var $bdd8c3ed9c6b00f0$var$getRequest = $9IwIy.getRequest;

var $aE1Lc = parcelRequire("aE1Lc");
function $bdd8c3ed9c6b00f0$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $bdd8c3ed9c6b00f0$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $aE1Lc(false);
    var networkCacheConfig = (0, $bdd8c3ed9c6b00f0$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $bdd8c3ed9c6b00f0$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        var _queryNode$fragment$m, _queryNode$fragment$m2;
        $gVASf(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_queryNode$fragment$m = (_queryNode$fragment$m2 = queryNode.fragment.metadata) === null || _queryNode$fragment$m2 === void 0 ? void 0 : _queryNode$fragment$m2.throwOnFieldError) !== null && _queryNode$fragment$m !== void 0 ? _queryNode$fragment$m : false);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $bdd8c3ed9c6b00f0$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $fzyFU.from(environment.lookup(operation.fragment)).map(readData);
            return $bdd8c3ed9c6b00f0$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $bdd8c3ed9c6b00f0$var$getNetworkObservable(environment, operation) {
    return $1sxqR.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $bdd8c3ed9c6b00f0$var$fetchQuery;

});
parcelRegister("gVASf", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $c52e9299212cb942$var$_interopRequireDefault = $7gV6J.default;

var $c52e9299212cb942$var$_createForOfIteratorHelper2 = $c52e9299212cb942$var$_interopRequireDefault((parcelRequire("8utPl")));

var $8db39 = parcelRequire("8db39");

var $c52e9299212cb942$var$_RelayFeatureFlags = $c52e9299212cb942$var$_interopRequireDefault((parcelRequire("brVAm")));
function $c52e9299212cb942$var$handlePotentialSnapshotErrors(environment, missingRequiredFields, relayResolverErrors, errorResponseFields, throwOnFieldError) {
    var _iterator = (0, $c52e9299212cb942$var$_createForOfIteratorHelper2["default"])(relayResolverErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var resolverError = _step.value;
            environment.relayFieldLogger({
                kind: 'relay_resolver.error',
                owner: resolverError.field.owner,
                fieldPath: resolverError.field.path,
                error: resolverError.error
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (relayResolverErrors.length > 0 && ($c52e9299212cb942$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError)) throw new $8db39.RelayFieldError("Relay: Unexpected resolver exception", relayResolverErrors.map(function(e) {
        return {
            message: e.error.message
        };
    }));
    if (($c52e9299212cb942$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING || throwOnFieldError) && errorResponseFields != null) {
        if (errorResponseFields != null) {
            var _iterator2 = (0, $c52e9299212cb942$var$_createForOfIteratorHelper2["default"])(errorResponseFields), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var fieldError = _step2.value;
                    var path = fieldError.path, owner = fieldError.owner, error = fieldError.error;
                    environment.relayFieldLogger({
                        kind: 'relay_field_payload.error',
                        owner: owner,
                        fieldPath: path,
                        error: error
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
        if ($c52e9299212cb942$var$_RelayFeatureFlags["default"].ENABLE_FIELD_ERROR_HANDLING_THROW_BY_DEFAULT || throwOnFieldError) throw new $8db39.RelayFieldError("Relay: Unexpected response payload - this object includes an errors property in which you can access the underlying errors", errorResponseFields.map(function(_ref) {
            var error = _ref.error;
            return error;
        }));
    }
    if (missingRequiredFields != null) switch(missingRequiredFields.action){
        case 'THROW':
            var _missingRequiredField = missingRequiredFields.field, _path = _missingRequiredField.path, _owner = _missingRequiredField.owner;
            environment.relayFieldLogger({
                kind: 'missing_field.throw',
                owner: _owner,
                fieldPath: _path
            });
            throw new Error("Relay: Missing @required value at path '".concat(_path, "' in '").concat(_owner, "'."));
        case 'LOG':
            missingRequiredFields.fields.forEach(function(_ref2) {
                var path = _ref2.path, owner = _ref2.owner;
                environment.relayFieldLogger({
                    kind: 'missing_field.log',
                    owner: owner,
                    fieldPath: path
                });
            });
            break;
        default:
            missingRequiredFields.action;
    }
}
module.exports = $c52e9299212cb942$var$handlePotentialSnapshotErrors;

});
parcelRegister("8db39", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $5fa81bea0dc758d4$var$_interopRequireDefault = $7gV6J.default;

var $5fa81bea0dc758d4$var$_objectSpread2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $5fa81bea0dc758d4$var$_objectWithoutPropertiesLoose2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("7KAjS")));

var $5fa81bea0dc758d4$var$_createForOfIteratorHelper2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("8utPl")));

var $5fa81bea0dc758d4$var$_inheritsLoose2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("3fwIi")));

var $5fa81bea0dc758d4$var$_wrapNativeSuper2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("haFW8")));

var $5fa81bea0dc758d4$var$_toConsumableArray2 = $5fa81bea0dc758d4$var$_interopRequireDefault((parcelRequire("Dlo3s")));
var $5fa81bea0dc758d4$var$_excluded = [
    "path",
    "locations"
];

var $brVAm = parcelRequire("brVAm");
var $5fa81bea0dc758d4$var$SELF = Symbol('$SELF');
var $5fa81bea0dc758d4$var$RelayFieldError = /*#__PURE__*/ function(_Error) {
    (0, $5fa81bea0dc758d4$var$_inheritsLoose2["default"])(RelayFieldError, _Error);
    function RelayFieldError(message) {
        var _this;
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _this = _Error.call(this, message) || this;
        _this.name = 'RelayFieldError';
        _this.message = message;
        _this.errors = errors;
        return _this;
    }
    return RelayFieldError;
}(/*#__PURE__*/ (0, $5fa81bea0dc758d4$var$_wrapNativeSuper2["default"])(Error));
function $5fa81bea0dc758d4$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    if (!$brVAm.ENABLE_FIELD_ERROR_HANDLING) return null;
    var trie = new Map();
    var _iterator = (0, $5fa81bea0dc758d4$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $5fa81bea0dc758d4$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $5fa81bea0dc758d4$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($5fa81bea0dc758d4$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $5fa81bea0dc758d4$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $5fa81bea0dc758d4$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $5fa81bea0dc758d4$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $5fa81bea0dc758d4$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $5fa81bea0dc758d4$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $5fa81bea0dc758d4$var$_toConsumableArray2["default"])(value));
            else $5fa81bea0dc758d4$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $5fa81bea0dc758d4$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $5fa81bea0dc758d4$var$_objectSpread2["default"])((0, $5fa81bea0dc758d4$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $5fa81bea0dc758d4$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $5fa81bea0dc758d4$var$SELF,
    buildErrorTrie: $5fa81bea0dc758d4$var$buildErrorTrie,
    getNestedErrorTrieByKey: $5fa81bea0dc758d4$var$getNestedErrorTrieByKey,
    getErrorsByKey: $5fa81bea0dc758d4$var$getErrorsByKey,
    RelayFieldError: $5fa81bea0dc758d4$var$RelayFieldError
};

});


parcelRegister("1sxqR", function(module, exports) {
'use strict';

var $fzyFU = parcelRequire("fzyFU");

var $90WnW = parcelRequire("90WnW");

var $aE1Lc = parcelRequire("aE1Lc");
var $110256e3d513623c$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $110256e3d513623c$var$requestCachesByEnvironment = $110256e3d513623c$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $110256e3d513623c$var$fetchQuery(environment, operation) {
    return $110256e3d513623c$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $110256e3d513623c$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $fzyFU.create(function(sink) {
        var requestCache = $110256e3d513623c$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $90WnW(),
                    subjectForInFlightStatus: new $90WnW(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $110256e3d513623c$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $110256e3d513623c$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $110256e3d513623c$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $110256e3d513623c$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $aE1Lc(false);
        return $110256e3d513623c$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $110256e3d513623c$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $fzyFU.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $110256e3d513623c$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $fzyFU.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $110256e3d513623c$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $110256e3d513623c$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $110256e3d513623c$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $110256e3d513623c$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $110256e3d513623c$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $110256e3d513623c$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $110256e3d513623c$var$getRequestCache(environment) {
    var cached = $110256e3d513623c$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $110256e3d513623c$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $110256e3d513623c$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $aE1Lc(false);
    return cached;
}
module.exports = {
    fetchQuery: $110256e3d513623c$var$fetchQuery,
    fetchQueryDeduped: $110256e3d513623c$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $110256e3d513623c$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $110256e3d513623c$var$getObservableForActiveRequest
};

});
parcelRegister("90WnW", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $69016739ad830ffb$var$_interopRequireDefault = $7gV6J.default;

var $69016739ad830ffb$var$_createForOfIteratorHelper2 = $69016739ad830ffb$var$_interopRequireDefault((parcelRequire("8utPl")));

var $69016739ad830ffb$var$_defineProperty2 = $69016739ad830ffb$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $fzyFU = parcelRequire("fzyFU");

var $aE1Lc = parcelRequire("aE1Lc");
var $69016739ad830ffb$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $69016739ad830ffb$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $69016739ad830ffb$var$_defineProperty2["default"])(this, "_events", []);
        (0, $69016739ad830ffb$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $69016739ad830ffb$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $fzyFU.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $aE1Lc(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $69016739ad830ffb$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $69016739ad830ffb$var$RelayReplaySubject;

});



parcelRegister("8xeD3", function(module, exports) {
'use strict';

var $gNCy0 = parcelRequire("gNCy0");
var $636cc0cf67e64924$var$createOperationDescriptor = $gNCy0.createOperationDescriptor;

var $9IwIy = parcelRequire("9IwIy");
var $636cc0cf67e64924$var$getRequest = $9IwIy.getRequest;
function $636cc0cf67e64924$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $636cc0cf67e64924$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $636cc0cf67e64924$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $636cc0cf67e64924$var$fetchQuery_DEPRECATED;

});

parcelRegister("4iDAw", function(module, exports) {
'use strict';
var $32178d3a312ec3d0$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $32178d3a312ec3d0$var$preloadableQueryRegistry = new $32178d3a312ec3d0$var$PreloadableQueryRegistry();
module.exports = $32178d3a312ec3d0$var$preloadableQueryRegistry;

});

parcelRegister("f2SIM", function(module, exports) {
'use strict';

var $kc7Xx = parcelRequire("kc7Xx");
parcelRequire("1srSR");
function $af417d6fc5ca47bd$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $kc7Xx(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $af417d6fc5ca47bd$var$createFragmentSpecResolver;

});
parcelRegister("kc7Xx", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $eb3b1a3593353d24$var$_interopRequireDefault = $7gV6J.default;

var $eb3b1a3593353d24$var$_objectSpread2 = $eb3b1a3593353d24$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $eb3b1a3593353d24$var$_defineProperty2 = $eb3b1a3593353d24$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $gAA10 = parcelRequire("gAA10");

var $gVASf = parcelRequire("gVASf");

var $473qV = parcelRequire("473qV");

var $b2CqU = parcelRequire("b2CqU");

var $brVAm = parcelRequire("brVAm");

var $gNCy0 = parcelRequire("gNCy0");
var $eb3b1a3593353d24$var$createRequestDescriptor = $gNCy0.createRequestDescriptor;

var $hqAuM = parcelRequire("hqAuM");
var $eb3b1a3593353d24$var$areEqualSelectors = $hqAuM.areEqualSelectors, $eb3b1a3593353d24$var$createReaderSelector = $hqAuM.createReaderSelector, $eb3b1a3593353d24$var$getSelectorsFromObject = $hqAuM.getSelectorsFromObject;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $eb3b1a3593353d24$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $eb3b1a3593353d24$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $eb3b1a3593353d24$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $eb3b1a3593353d24$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$473qV(_nextItem, prevItem)) {
                        nextData = nextData || (0, $eb3b1a3593353d24$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($brVAm.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $eb3b1a3593353d24$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $eb3b1a3593353d24$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $eb3b1a3593353d24$var$SelectorListResolver) && $aE1Lc(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $eb3b1a3593353d24$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $eb3b1a3593353d24$var$SelectorResolver) && $aE1Lc(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $eb3b1a3593353d24$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $eb3b1a3593353d24$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._missingRequiredFields = snapshot.missingRequiredFields;
            _this2._errorResponseFields = snapshot.errorResponseFields;
            _this2._relayResolverErrors = snapshot.relayResolverErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._missingRequiredFields = _snapshot.missingRequiredFields;
        this._errorResponseFields = _snapshot.errorResponseFields;
        this._relayResolverErrors = _snapshot.relayResolverErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($brVAm.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        var _this$_selector$node$, _this$_selector$node$2;
        if (this._isMissingData === true) {
            var pendingOperationsResult = $gAA10(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $gVASf(this._environment, this._missingRequiredFields, this._relayResolverErrors, this._errorResponseFields, (_this$_selector$node$ = (_this$_selector$node$2 = this._selector.node.metadata) === null || _this$_selector$node$2 === void 0 ? void 0 : _this$_selector$node$2.throwOnFieldError) !== null && _this$_selector$node$ !== void 0 ? _this$_selector$node$ : false);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $eb3b1a3593353d24$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $b2CqU(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._missingRequiredFields = snapshot.missingRequiredFields;
        this._errorResponseFields = snapshot.errorResponseFields;
        this._relayResolverErrors = snapshot.relayResolverErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($9p5ca(variables, this._selector.variables)) return;
        var requestDescriptor = $eb3b1a3593353d24$var$createRequestDescriptor(request, variables);
        var selector = $eb3b1a3593353d24$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $eb3b1a3593353d24$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $eb3b1a3593353d24$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($eb3b1a3593353d24$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $eb3b1a3593353d24$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $eb3b1a3593353d24$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $eb3b1a3593353d24$var$RelayModernFragmentSpecResolver;

});
parcelRegister("gAA10", function(module, exports) {
'use strict';

var $1sxqR = parcelRequire("1sxqR");
var $c13bf1ff748088b6$var$getPromiseForActiveRequest = $1sxqR.getPromiseForActiveRequest;
function $c13bf1ff748088b6$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $c13bf1ff748088b6$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var result = environment.getOperationTracker().getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $c13bf1ff748088b6$var$getPendingOperationsForFragment;

});

parcelRegister("473qV", function(module, exports) {
'use strict';
function $2fea7aa27f090098$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $2fea7aa27f090098$var$isScalarAndEqual;

});

parcelRegister("b2CqU", function(module, exports) {
'use strict';
function $809db198106a7cd1$var$recycleNodesInto(prevData, nextData) {
    return $809db198106a7cd1$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $809db198106a7cd1$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $809db198106a7cd1$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $809db198106a7cd1$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $809db198106a7cd1$var$recycleNodesInto;

});



parcelRegister("3n6ka", function(module, exports) {
'use strict';

var $aE1Lc = parcelRequire("aE1Lc");
var $27486cef726de494$var$relayContext;
var $27486cef726de494$var$firstReact;
function $27486cef726de494$var$createRelayContext(react) {
    if (!$27486cef726de494$var$relayContext) {
        $27486cef726de494$var$relayContext = react.createContext(null);
        $27486cef726de494$var$firstReact = react;
    }
    !(react === $27486cef726de494$var$firstReact) && $aE1Lc(false);
    return $27486cef726de494$var$relayContext;
}
module.exports = $27486cef726de494$var$createRelayContext;

});

parcelRegister("9a00R", function(module, exports) {
'use strict';
var $6ab50ecadd6fb8b8$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $6ab50ecadd6fb8b8$var$suspenseSentinel() {
    return $6ab50ecadd6fb8b8$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $6ab50ecadd6fb8b8$var$isSuspenseSentinel(value) {
    return value === $6ab50ecadd6fb8b8$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $6ab50ecadd6fb8b8$var$isSuspenseSentinel,
    suspenseSentinel: $6ab50ecadd6fb8b8$var$suspenseSentinel
};

});

parcelRegister("egtsh", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $a6296877c3da9a1e$var$_interopRequireDefault = $7gV6J.default;

var $a6296877c3da9a1e$var$_objectSpread2 = $a6296877c3da9a1e$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $a6296877c3da9a1e$var$_RelayModernRecord = $a6296877c3da9a1e$var$_interopRequireDefault((parcelRequire("jeujn")));

var $a6296877c3da9a1e$var$_RelayRecordSource = $a6296877c3da9a1e$var$_interopRequireDefault((parcelRequire("67IX0")));

var $a6296877c3da9a1e$var$_RelayResponseNormalizer = $a6296877c3da9a1e$var$_interopRequireDefault((parcelRequire("ggNiN")));
function $a6296877c3da9a1e$var$normalizeResponse(response, selector, typeName, options) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $a6296877c3da9a1e$var$_RelayRecordSource["default"].create();
    var record = $a6296877c3da9a1e$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $a6296877c3da9a1e$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors);
    return (0, $a6296877c3da9a1e$var$_objectSpread2["default"])((0, $a6296877c3da9a1e$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $a6296877c3da9a1e$var$normalizeResponse;

});
parcelRegister("jeujn", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $e006d661a2b12cdc$var$_interopRequireDefault = $7gV6J.default;

var $e006d661a2b12cdc$var$_defineProperty2 = $e006d661a2b12cdc$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $e006d661a2b12cdc$var$_objectWithoutPropertiesLoose2 = $e006d661a2b12cdc$var$_interopRequireDefault((parcelRequire("7KAjS")));

var $e006d661a2b12cdc$var$_toPropertyKey2 = $e006d661a2b12cdc$var$_interopRequireDefault((parcelRequire("fZOz2")));

var $e006d661a2b12cdc$var$_objectSpread2 = $e006d661a2b12cdc$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $259Mc = parcelRequire("259Mc");

var $dgkLD = parcelRequire("dgkLD");
var $e006d661a2b12cdc$var$generateClientObjectClientID = $dgkLD.generateClientObjectClientID, $e006d661a2b12cdc$var$isClientID = $dgkLD.isClientID;

var $9a00R = parcelRequire("9a00R");
var $e006d661a2b12cdc$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;

var $dfBRB = parcelRequire("dfBRB");
var $e006d661a2b12cdc$var$ACTOR_IDENTIFIER_KEY = $dfBRB.ACTOR_IDENTIFIER_KEY, $e006d661a2b12cdc$var$ERRORS_KEY = $dfBRB.ERRORS_KEY, $e006d661a2b12cdc$var$ID_KEY = $dfBRB.ID_KEY, $e006d661a2b12cdc$var$INVALIDATED_AT_KEY = $dfBRB.INVALIDATED_AT_KEY, $e006d661a2b12cdc$var$REF_KEY = $dfBRB.REF_KEY, $e006d661a2b12cdc$var$REFS_KEY = $dfBRB.REFS_KEY, $e006d661a2b12cdc$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $e006d661a2b12cdc$var$ROOT_ID = $dfBRB.ROOT_ID, $e006d661a2b12cdc$var$TYPENAME_KEY = $dfBRB.TYPENAME_KEY;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $e006d661a2b12cdc$var$clone(record) {
    return (0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, record);
}
function $e006d661a2b12cdc$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $e006d661a2b12cdc$var$ID_KEY && key !== $e006d661a2b12cdc$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $e006d661a2b12cdc$var$create(dataID, typeName) {
    var record = {};
    record[$e006d661a2b12cdc$var$ID_KEY] = dataID;
    record[$e006d661a2b12cdc$var$TYPENAME_KEY] = typeName;
    return record;
}
function $e006d661a2b12cdc$var$fromObject(json) {
    return json;
}
function $e006d661a2b12cdc$var$getDataID(record) {
    return record[$e006d661a2b12cdc$var$ID_KEY];
}
function $e006d661a2b12cdc$var$getFields(record) {
    if ($e006d661a2b12cdc$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $e006d661a2b12cdc$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $e006d661a2b12cdc$var$getType(record) {
    return record[$e006d661a2b12cdc$var$TYPENAME_KEY];
}
function $e006d661a2b12cdc$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$e006d661a2b12cdc$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $e006d661a2b12cdc$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($e006d661a2b12cdc$var$REF_KEY) && !value.hasOwnProperty($e006d661a2b12cdc$var$REFS_KEY)) && $aE1Lc(false);
    return value;
}
function $e006d661a2b12cdc$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $e006d661a2b12cdc$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$e006d661a2b12cdc$var$REF_KEY] === 'string') && $aE1Lc(false);
    return link[$e006d661a2b12cdc$var$REF_KEY];
}
function $e006d661a2b12cdc$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$e006d661a2b12cdc$var$REF_KEY] === 'string';
}
function $e006d661a2b12cdc$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$e006d661a2b12cdc$var$REFS_KEY])) && $aE1Lc(false);
    return links[$e006d661a2b12cdc$var$REFS_KEY];
}
function $e006d661a2b12cdc$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$e006d661a2b12cdc$var$REFS_KEY]) && links[$e006d661a2b12cdc$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $e006d661a2b12cdc$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$e006d661a2b12cdc$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $e006d661a2b12cdc$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$e006d661a2b12cdc$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$e006d661a2b12cdc$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$9p5ca(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $e006d661a2b12cdc$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($9p5ca(prevValue, nextValue) && $9p5ca(prevErrors, nextErrors)) continue;
            updated = (0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$e006d661a2b12cdc$var$ERRORS_KEY] = (0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $e006d661a2b12cdc$var$setValue(updated, _storageKey2, nextValue);
        $e006d661a2b12cdc$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $e006d661a2b12cdc$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($e006d661a2b12cdc$var$ERRORS_KEY in record1 || $e006d661a2b12cdc$var$ERRORS_KEY in record2) {
        var errors1 = record1[$e006d661a2b12cdc$var$ERRORS_KEY], fields1 = (0, $e006d661a2b12cdc$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $e006d661a2b12cdc$var$ERRORS_KEY
        ].map($e006d661a2b12cdc$var$_toPropertyKey2["default"]));
        var errors2 = record2[$e006d661a2b12cdc$var$ERRORS_KEY], fields2 = (0, $e006d661a2b12cdc$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $e006d661a2b12cdc$var$ERRORS_KEY
        ].map($e006d661a2b12cdc$var$_toPropertyKey2["default"]));
        var updated = (0, $e006d661a2b12cdc$var$_objectSpread2["default"])((0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$e006d661a2b12cdc$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $e006d661a2b12cdc$var$_objectSpread2["default"])((0, $e006d661a2b12cdc$var$_objectSpread2["default"])({}, record1), record2);
}
function $e006d661a2b12cdc$var$freeze(record) {
    $259Mc(record);
}
function $e006d661a2b12cdc$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$e006d661a2b12cdc$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$e006d661a2b12cdc$var$ERRORS_KEY] = (0, $e006d661a2b12cdc$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$e006d661a2b12cdc$var$ERRORS_KEY];
        }
    }
}
function $e006d661a2b12cdc$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $e006d661a2b12cdc$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$e006d661a2b12cdc$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $e006d661a2b12cdc$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$e006d661a2b12cdc$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $e006d661a2b12cdc$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$e006d661a2b12cdc$var$REF_KEY] = linkedID;
    link[$e006d661a2b12cdc$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $e006d661a2b12cdc$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$e006d661a2b12cdc$var$REF_KEY] === 'string' && link[$e006d661a2b12cdc$var$ACTOR_IDENTIFIER_KEY] != null) && $aE1Lc(false);
    return [
        link[$e006d661a2b12cdc$var$ACTOR_IDENTIFIER_KEY],
        link[$e006d661a2b12cdc$var$REF_KEY]
    ];
}
function $e006d661a2b12cdc$var$getResolverLinkedRecordID(record, typeName) {
    var id = $e006d661a2b12cdc$var$getValue(record, $e006d661a2b12cdc$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $e006d661a2b12cdc$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $aE1Lc(false);
    return $e006d661a2b12cdc$var$generateClientObjectClientID(typeName, id);
}
function $e006d661a2b12cdc$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $e006d661a2b12cdc$var$getValue(record, $e006d661a2b12cdc$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $e006d661a2b12cdc$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $aE1Lc(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $aE1Lc(false);
        return $e006d661a2b12cdc$var$generateClientObjectClientID(typeName, id);
    });
}
function $e006d661a2b12cdc$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $e006d661a2b12cdc$var$clone,
    copyFields: $e006d661a2b12cdc$var$copyFields,
    create: $e006d661a2b12cdc$var$create,
    freeze: $e006d661a2b12cdc$var$freeze,
    fromObject: $e006d661a2b12cdc$var$fromObject,
    getDataID: $e006d661a2b12cdc$var$getDataID,
    getErrors: $e006d661a2b12cdc$var$getErrors,
    getFields: $e006d661a2b12cdc$var$getFields,
    getInvalidationEpoch: $e006d661a2b12cdc$var$getInvalidationEpoch,
    getLinkedRecordID: $e006d661a2b12cdc$var$getLinkedRecordID,
    getLinkedRecordIDs: $e006d661a2b12cdc$var$getLinkedRecordIDs,
    getType: $e006d661a2b12cdc$var$getType,
    getValue: $e006d661a2b12cdc$var$getValue,
    hasValue: $e006d661a2b12cdc$var$hasValue,
    hasLinkedRecordID: $e006d661a2b12cdc$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $e006d661a2b12cdc$var$hasLinkedRecordIDs,
    merge: $e006d661a2b12cdc$var$merge,
    setErrors: $e006d661a2b12cdc$var$setErrors,
    setValue: $e006d661a2b12cdc$var$setValue,
    setLinkedRecordID: $e006d661a2b12cdc$var$setLinkedRecordID,
    setLinkedRecordIDs: $e006d661a2b12cdc$var$setLinkedRecordIDs,
    update: $e006d661a2b12cdc$var$update,
    getActorLinkedRecordID: $e006d661a2b12cdc$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $e006d661a2b12cdc$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $e006d661a2b12cdc$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $e006d661a2b12cdc$var$getResolverLinkedRecordIDs,
    toJSON: $e006d661a2b12cdc$var$toJSON
};

});

parcelRegister("67IX0", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $475643cdb291a6b2$var$_interopRequireDefault = $7gV6J.default;

var $475643cdb291a6b2$var$_createForOfIteratorHelper2 = $475643cdb291a6b2$var$_interopRequireDefault((parcelRequire("8utPl")));

var $jeujn = parcelRequire("jeujn");

var $dKkgv = parcelRequire("dKkgv");
var $475643cdb291a6b2$var$EXISTENT = $dKkgv.EXISTENT, $475643cdb291a6b2$var$NONEXISTENT = $dKkgv.NONEXISTENT, $475643cdb291a6b2$var$UNKNOWN = $dKkgv.UNKNOWN;
var $475643cdb291a6b2$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $jeujn.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $475643cdb291a6b2$var$UNKNOWN;
        return this._records.get(dataID) == null ? $475643cdb291a6b2$var$NONEXISTENT : $475643cdb291a6b2$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $475643cdb291a6b2$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $jeujn.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $475643cdb291a6b2$var$RelayRecordSource;

});
parcelRegister("dKkgv", function(module, exports) {
'use strict';
var $a01f4a7e53f87f63$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $a01f4a7e53f87f63$var$RelayRecordState;

});


parcelRegister("ggNiN", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $bd846258fadd07da$var$_interopRequireDefault = $7gV6J.default;

var $bd846258fadd07da$var$_createForOfIteratorHelper2 = $bd846258fadd07da$var$_interopRequireDefault((parcelRequire("8utPl")));

var $bd846258fadd07da$var$_toConsumableArray2 = $bd846258fadd07da$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $7ZRFk = parcelRequire("7ZRFk");
var $bd846258fadd07da$var$ACTOR_IDENTIFIER_FIELD_NAME = $7ZRFk.ACTOR_IDENTIFIER_FIELD_NAME, $bd846258fadd07da$var$getActorIdentifierFromPayload = $7ZRFk.getActorIdentifierFromPayload;

var $7AO8k = parcelRequire("7AO8k");
var $bd846258fadd07da$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $bd846258fadd07da$var$CLIENT_COMPONENT = $7AO8k.CLIENT_COMPONENT, $bd846258fadd07da$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT, $bd846258fadd07da$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $bd846258fadd07da$var$CONDITION = $7AO8k.CONDITION, $bd846258fadd07da$var$DEFER = $7AO8k.DEFER, $bd846258fadd07da$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $bd846258fadd07da$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $bd846258fadd07da$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $bd846258fadd07da$var$LINKED_HANDLE = $7AO8k.LINKED_HANDLE, $bd846258fadd07da$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $bd846258fadd07da$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $bd846258fadd07da$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $bd846258fadd07da$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $bd846258fadd07da$var$SCALAR_HANDLE = $7AO8k.SCALAR_HANDLE, $bd846258fadd07da$var$STREAM = $7AO8k.STREAM, $bd846258fadd07da$var$TYPE_DISCRIMINATOR = $7AO8k.TYPE_DISCRIMINATOR;

var $dgkLD = parcelRequire("dgkLD");
var $bd846258fadd07da$var$generateClientID = $dgkLD.generateClientID, $bd846258fadd07da$var$isClientID = $dgkLD.isClientID;

var $kgs0j = parcelRequire("kgs0j");
var $bd846258fadd07da$var$getLocalVariables = $kgs0j.getLocalVariables;

var $8db39 = parcelRequire("8db39");
var $bd846258fadd07da$var$buildErrorTrie = $8db39.buildErrorTrie, $bd846258fadd07da$var$getErrorsByKey = $8db39.getErrorsByKey, $bd846258fadd07da$var$getNestedErrorTrieByKey = $8db39.getNestedErrorTrieByKey;

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");
var $bd846258fadd07da$var$createNormalizationSelector = $hqAuM.createNormalizationSelector;

var $dfBRB = parcelRequire("dfBRB");
var $bd846258fadd07da$var$ROOT_ID = $dfBRB.ROOT_ID, $bd846258fadd07da$var$TYPENAME_KEY = $dfBRB.TYPENAME_KEY, $bd846258fadd07da$var$getArgumentValues = $dfBRB.getArgumentValues, $bd846258fadd07da$var$getHandleStorageKey = $dfBRB.getHandleStorageKey, $bd846258fadd07da$var$getModuleComponentKey = $dfBRB.getModuleComponentKey, $bd846258fadd07da$var$getModuleOperationKey = $dfBRB.getModuleOperationKey, $bd846258fadd07da$var$getStorageKey = $dfBRB.getStorageKey;

var $fW7kJ = parcelRequire("fW7kJ");
var $bd846258fadd07da$var$TYPE_SCHEMA_TYPE = $fW7kJ.TYPE_SCHEMA_TYPE, $bd846258fadd07da$var$generateTypeID = $fW7kJ.generateTypeID;
parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $bd846258fadd07da$var$normalize(recordSource, selector, response, options, errors) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $bd846258fadd07da$var$RelayResponseNormalizer(recordSource, variables, options);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $bd846258fadd07da$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._followupPayloads = [];
        this._path = options.path ? (0, $bd846258fadd07da$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $aE1Lc(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $bd846258fadd07da$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $bd846258fadd07da$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $bd846258fadd07da$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $jeujn.create(typeID, $bd846258fadd07da$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $jeujn.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aE1Lc(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$bd846258fadd07da$var$TYPENAME_KEY];
        !(typeName != null) && $aE1Lc(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case $bd846258fadd07da$var$SCALAR_FIELD:
                case $bd846258fadd07da$var$LINKED_FIELD:
                    this._normalizeField(selection, record, data);
                    break;
                case $bd846258fadd07da$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case $bd846258fadd07da$var$FRAGMENT_SPREAD:
                    var prevVariables = this._variables;
                    this._variables = $bd846258fadd07da$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case $bd846258fadd07da$var$INLINE_FRAGMENT:
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $jeujn.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = data.hasOwnProperty(abstractKey);
                        var _typeName = $jeujn.getType(record);
                        var typeID = $bd846258fadd07da$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $jeujn.create(typeID, $bd846258fadd07da$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $jeujn.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case $bd846258fadd07da$var$TYPE_DISCRIMINATOR:
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = data.hasOwnProperty(_abstractKey);
                    var _typeName2 = $jeujn.getType(record);
                    var _typeID = $bd846258fadd07da$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $jeujn.create(_typeID, $bd846258fadd07da$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $jeujn.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case $bd846258fadd07da$var$LINKED_HANDLE:
                case $bd846258fadd07da$var$SCALAR_HANDLE:
                    var args = selection.args ? $bd846258fadd07da$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $bd846258fadd07da$var$getStorageKey(selection, this._variables);
                    var handleKey = $bd846258fadd07da$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $jeujn.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $bd846258fadd07da$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case $bd846258fadd07da$var$MODULE_IMPORT:
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case $bd846258fadd07da$var$DEFER:
                    this._normalizeDefer(selection, record, data);
                    break;
                case $bd846258fadd07da$var$STREAM:
                    this._normalizeStream(selection, record, data);
                    break;
                case $bd846258fadd07da$var$CLIENT_EXTENSION:
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case $bd846258fadd07da$var$CLIENT_COMPONENT:
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case $bd846258fadd07da$var$ACTOR_CHANGE:
                    this._normalizeActorChange(selection, record, data);
                    break;
                case $bd846258fadd07da$var$RELAY_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $bd846258fadd07da$var$RELAY_LIVE_RESOLVER:
                    this._normalizeResolver(selection, record, data);
                    break;
                case $bd846258fadd07da$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $aE1Lc(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $bd846258fadd07da$var$_toConsumableArray2["default"])(this._path),
            selector: $bd846258fadd07da$var$createNormalizationSelector(defer, $jeujn.getDataID(record), this._variables),
            typeName: $jeujn.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $bd846258fadd07da$var$_toConsumableArray2["default"])(this._path),
            parentID: $jeujn.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $aE1Lc(false);
        var typeName = $jeujn.getType(record);
        var componentKey = $bd846258fadd07da$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $jeujn.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $bd846258fadd07da$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $jeujn.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $jeujn.getDataID(record),
            operationReference: operationReference,
            path: (0, $bd846258fadd07da$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $aE1Lc(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $bd846258fadd07da$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $jeujn.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $bd846258fadd07da$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $jeujn.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === $bd846258fadd07da$var$SCALAR_FIELD) $jeujn.setValue(record, storageKey, fieldValue);
        else if (selection.kind === $bd846258fadd07da$var$LINKED_FIELD) {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $bd846258fadd07da$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $aE1Lc(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $aE1Lc(false);
        var responseKey = field.alias || field.name;
        var storageKey = $bd846258fadd07da$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $jeujn.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $bd846258fadd07da$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $jeujn.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $jeujn.getLinkedRecordID(record, storageKey) || $bd846258fadd07da$var$generateClientID($jeujn.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $aE1Lc(false);
        $jeujn.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $bd846258fadd07da$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $aE1Lc(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $jeujn.getLinkedRecordID(record, storageKey) || $bd846258fadd07da$var$generateClientID($jeujn.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $aE1Lc(false);
        $jeujn.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $jeujn.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        }
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $aE1Lc(false);
        var prevIDs = $jeujn.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $bd846258fadd07da$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $aE1Lc(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $bd846258fadd07da$var$generateClientID($jeujn.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $aE1Lc(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $jeujn.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            }
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $jeujn.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        var _field$concreteType4;
        var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
        var dataID = $jeujn.getDataID(record);
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var dataID, previousValue;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {};
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $bd846258fadd07da$var$normalize
};

});
parcelRegister("7ZRFk", function(module, exports) {
'use strict';
var $5d27dbc7ac1ae1f5$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $g6Qtb = parcelRequire("g6Qtb");
var $5d27dbc7ac1ae1f5$var$getActorIdentifier = $g6Qtb.getActorIdentifier;
function $5d27dbc7ac1ae1f5$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$5d27dbc7ac1ae1f5$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $5d27dbc7ac1ae1f5$var$getActorIdentifier(payload[$5d27dbc7ac1ae1f5$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $5d27dbc7ac1ae1f5$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $5d27dbc7ac1ae1f5$var$getActorIdentifierFromPayload
};

});
parcelRegister("g6Qtb", function(module, exports) {
'use strict';

var $aE1Lc = parcelRequire("aE1Lc");
var $bba5e84b34a117df$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $bba5e84b34a117df$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $bba5e84b34a117df$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $aE1Lc(false);
}
module.exports = {
    assertInternalActorIdentifier: $bba5e84b34a117df$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $bba5e84b34a117df$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("fW7kJ", function(module, exports) {
'use strict';
var $b9a1f609c26918ea$var$PREFIX = 'client:__type:';
var $b9a1f609c26918ea$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $b9a1f609c26918ea$var$generateTypeID(typeName) {
    return $b9a1f609c26918ea$var$PREFIX + typeName;
}
function $b9a1f609c26918ea$var$isTypeID(id) {
    return id.indexOf($b9a1f609c26918ea$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $b9a1f609c26918ea$var$generateTypeID,
    isTypeID: $b9a1f609c26918ea$var$isTypeID,
    TYPE_SCHEMA_TYPE: $b9a1f609c26918ea$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("4vBS9", function(module, exports) {
'use strict';

var $9IwIy = parcelRequire("9IwIy");
var $34876f5bfad34807$var$getInlineDataFragment = $9IwIy.getInlineDataFragment;

var $dfBRB = parcelRequire("dfBRB");
var $34876f5bfad34807$var$FRAGMENTS_KEY = $dfBRB.FRAGMENTS_KEY;

var $aE1Lc = parcelRequire("aE1Lc");
function $34876f5bfad34807$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $34876f5bfad34807$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $aE1Lc(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$34876f5bfad34807$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $aE1Lc(false);
    return inlineData;
}
module.exports = $34876f5bfad34807$var$readInlineData;

});

parcelRegister("97t9c", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $6a3b608b2eee2c1a$var$_interopRequireDefault = $7gV6J.default;

var $6a3b608b2eee2c1a$var$_objectSpread2 = $6a3b608b2eee2c1a$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $94lOA = parcelRequire("94lOA");

var $g6Qtb = parcelRequire("g6Qtb");
var $6a3b608b2eee2c1a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $6a3b608b2eee2c1a$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;

var $fzyFU = parcelRequire("fzyFU");

var $9Rq5a = parcelRequire("9Rq5a");

var $6TOns = parcelRequire("6TOns");

var $gC8pM = parcelRequire("gC8pM");

var $4FKGD = parcelRequire("4FKGD");

var $99xqt = parcelRequire("99xqt");

var $egtsh = parcelRequire("egtsh");

var $7c016 = parcelRequire("7c016");

var $8EtTz = parcelRequire("8EtTz");

var $67IX0 = parcelRequire("67IX0");
parcelRequire("aE1Lc");
var $6a3b608b2eee2c1a$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $6a3b608b2eee2c1a$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $99xqt;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $9Rq5a(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $4FKGD;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $8EtTz(config.store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $94lOA, this._getDataID, this._missingFieldHandlers);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = config.store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $egtsh;
        this.__setNet = function(newNet) {
            return _this._network = $9Rq5a(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $6TOns();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $gC8pM(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $fzyFU.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$6a3b608b2eee2c1a$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $fzyFU.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $67IX0.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $6a3b608b2eee2c1a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $6a3b608b2eee2c1a$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $6a3b608b2eee2c1a$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $6a3b608b2eee2c1a$var$_objectSpread2["default"])((0, $6a3b608b2eee2c1a$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $fzyFU.create(function(sink) {
            var executor = $7c016.execute({
                actorIdentifier: $6a3b608b2eee2c1a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $6a3b608b2eee2c1a$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $6a3b608b2eee2c1a$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $6a3b608b2eee2c1a$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$6a3b608b2eee2c1a$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $6a3b608b2eee2c1a$var$emptyFunction() {}
module.exports = $6a3b608b2eee2c1a$var$RelayModernEnvironment;

});
parcelRegister("9Rq5a", function(module, exports) {
'use strict';

var $lsKQA = parcelRequire("lsKQA");
function $72dd4bb54aeb10aa$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables) {
            var networkRequestId = $lsKQA();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo)["do"](logObserver);
        }
    };
}
module.exports = $72dd4bb54aeb10aa$var$wrapNetworkWithLogObserver;

});
parcelRegister("lsKQA", function(module, exports) {
'use strict';
var $fa008d63de3a1c46$var$id = 100000;
function $fa008d63de3a1c46$var$generateID() {
    return $fa008d63de3a1c46$var$id++;
}
module.exports = $fa008d63de3a1c46$var$generateID;

});


parcelRegister("6TOns", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $505ef5070240e036$var$_interopRequireDefault = $7gV6J.default;

var $505ef5070240e036$var$_createForOfIteratorHelper2 = $505ef5070240e036$var$_interopRequireDefault((parcelRequire("8utPl")));

var $aE1Lc = parcelRequire("aE1Lc");
var $505ef5070240e036$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $505ef5070240e036$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $505ef5070240e036$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $505ef5070240e036$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $505ef5070240e036$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $505ef5070240e036$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $aE1Lc(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $505ef5070240e036$var$RelayOperationTracker;

});

parcelRegister("gC8pM", function(module, exports) {
'use strict';
function $031f137fd76a33a4$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $031f137fd76a33a4$var$registerEnvironmentWithDevTools;

});

parcelRegister("4FKGD", function(module, exports) {
'use strict';

var $3r4Jp = parcelRequire("3r4Jp");
var $366f34c2350edd5d$var$VIEWER_ID = $3r4Jp.VIEWER_ID, $366f34c2350edd5d$var$VIEWER_TYPE = $3r4Jp.VIEWER_TYPE;
function $366f34c2350edd5d$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $366f34c2350edd5d$var$VIEWER_TYPE) return fieldValue.id == null ? $366f34c2350edd5d$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $366f34c2350edd5d$var$defaultGetDataID;

});
parcelRegister("3r4Jp", function(module, exports) {
'use strict';

var $dgkLD = parcelRequire("dgkLD");
var $28079049636617a8$var$generateClientID = $dgkLD.generateClientID;

var $dfBRB = parcelRequire("dfBRB");
var $28079049636617a8$var$ROOT_ID = $dfBRB.ROOT_ID;
var $28079049636617a8$var$VIEWER_ID = $28079049636617a8$var$generateClientID($28079049636617a8$var$ROOT_ID, 'viewer');
var $28079049636617a8$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $28079049636617a8$var$VIEWER_ID,
    VIEWER_TYPE: $28079049636617a8$var$VIEWER_TYPE
};

});


parcelRegister("99xqt", function(module, exports) {
'use strict';
var $6a9ee2013ddca0eb$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $6a9ee2013ddca0eb$var$defaultRelayFieldLogger;

});

parcelRegister("7c016", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $53c9aab4f29b6939$var$_interopRequireDefault = $7gV6J.default;

var $53c9aab4f29b6939$var$_createForOfIteratorHelper2 = $53c9aab4f29b6939$var$_interopRequireDefault((parcelRequire("8utPl")));

var $53c9aab4f29b6939$var$_toConsumableArray2 = $53c9aab4f29b6939$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $fzyFU = parcelRequire("fzyFU");

var $lsKQA = parcelRequire("lsKQA");

var $hUqwr = parcelRequire("hUqwr");

var $8lAOl = parcelRequire("8lAOl");

var $brVAm = parcelRequire("brVAm");

var $1B8Po = parcelRequire("1B8Po");

var $dzNif = parcelRequire("dzNif");

var $dgkLD = parcelRequire("dgkLD");
var $53c9aab4f29b6939$var$generateClientID = $dgkLD.generateClientID, $53c9aab4f29b6939$var$generateUniqueClientID = $dgkLD.generateUniqueClientID;

var $kgs0j = parcelRequire("kgs0j");
var $53c9aab4f29b6939$var$getLocalVariables = $kgs0j.getLocalVariables;

var $jeujn = parcelRequire("jeujn");

var $hqAuM = parcelRequire("hqAuM");
var $53c9aab4f29b6939$var$createNormalizationSelector = $hqAuM.createNormalizationSelector, $53c9aab4f29b6939$var$createReaderSelector = $hqAuM.createReaderSelector;

var $67IX0 = parcelRequire("67IX0");

var $dfBRB = parcelRequire("dfBRB");
var $53c9aab4f29b6939$var$ROOT_TYPE = $dfBRB.ROOT_TYPE, $53c9aab4f29b6939$var$TYPENAME_KEY = $dfBRB.TYPENAME_KEY, $53c9aab4f29b6939$var$getStorageKey = $dfBRB.getStorageKey;

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $53c9aab4f29b6939$var$execute(config) {
    return new $53c9aab4f29b6939$var$Executor(config);
}
var $53c9aab4f29b6939$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref2) {
        var _this = this;
        var actorIdentifier = _ref2.actorIdentifier, getDataID = _ref2.getDataID, getPublishQueue = _ref2.getPublishQueue, getStore = _ref2.getStore, isClientPayload = _ref2.isClientPayload, operation = _ref2.operation, operationExecutions = _ref2.operationExecutions, operationLoader = _ref2.operationLoader, operationTracker = _ref2.operationTracker, optimisticConfig = _ref2.optimisticConfig, scheduler = _ref2.scheduler, shouldProcessClientComponents = _ref2.shouldProcessClientComponents, sink = _ref2.sink, source = _ref2.source, treatMissingFieldsAsNull = _ref2.treatMissingFieldsAsNull, updater = _ref2.updater, log = _ref2.log, normalizeResponse = _ref2.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $lsKQA();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($brVAm.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ = _this._operation.request.cacheConfig) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : {}
                });
            }
        });
        if (!$brVAm.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $aE1Lc(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $fzyFU.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                });
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        this._schedule(function() {
            var _withDuration = $dzNif(function() {
                _this4._handleNext(response);
                _this4._maybeCompleteSubscriptionOperationTracking();
            }), duration = _withDuration[0];
            _this4._log({
                name: 'execute.next',
                executeId: _this4._executeId,
                response: response,
                duration: duration
            });
        });
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref3) {
                    var message = _ref3.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $8lAOl.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $aE1Lc(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $aE1Lc(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $53c9aab4f29b6939$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $53c9aab4f29b6939$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $53c9aab4f29b6939$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $53c9aab4f29b6939$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $aE1Lc(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $53c9aab4f29b6939$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            });
            $53c9aab4f29b6939$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $67IX0.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($brVAm.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $53c9aab4f29b6939$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $53c9aab4f29b6939$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $aE1Lc(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $53c9aab4f29b6939$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $53c9aab4f29b6939$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        return this._normalizeResponse({
            data: followupPayload.data
        }, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $hUqwr(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $53c9aab4f29b6939$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $53c9aab4f29b6939$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $53c9aab4f29b6939$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            });
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $hUqwr(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $fzyFU.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $fzyFU.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $hUqwr(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $brVAm.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withDuration2 = $dzNif(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), duration = _withDuration2[0];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $aE1Lc(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $aE1Lc(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $53c9aab4f29b6939$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $aE1Lc(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $jeujn.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $53c9aab4f29b6939$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $aE1Lc(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $aE1Lc(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aE1Lc(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions2;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $67IX0.create(),
                isFinal: ((_response$extensions2 = response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $aE1Lc(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $53c9aab4f29b6939$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $67IX0.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $aE1Lc(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $53c9aab4f29b6939$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $aE1Lc(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $jeujn.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $aE1Lc(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $aE1Lc(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$53c9aab4f29b6939$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $aE1Lc(false);
        var itemID = (_ref = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref !== void 0 ? _ref : $53c9aab4f29b6939$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $aE1Lc(false);
        var selector = $53c9aab4f29b6939$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $jeujn.clone(parentRecord);
        var nextIDs = (0, $53c9aab4f29b6939$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $jeujn.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            path: [].concat((0, $53c9aab4f29b6939$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        });
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $53c9aab4f29b6939$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $53c9aab4f29b6939$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $53c9aab4f29b6939$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $53c9aab4f29b6939$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $aE1Lc(false);
        return operationLoader;
    };
    return Executor;
}();
function $53c9aab4f29b6939$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    responses.forEach(function(response) {
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $aE1Lc(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses
    ];
}
function $53c9aab4f29b6939$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($1B8Po(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $53c9aab4f29b6939$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $aE1Lc(false);
}
module.exports = {
    execute: $53c9aab4f29b6939$var$execute
};

});
parcelRegister("hUqwr", function(module, exports) {
'use strict';

var $7AO8k = parcelRequire("7AO8k");
var $d09c3d63248ad913$var$REQUEST = $7AO8k.REQUEST, $d09c3d63248ad913$var$SPLIT_OPERATION = $7AO8k.SPLIT_OPERATION;
function $d09c3d63248ad913$var$getOperation(node) {
    switch(node.kind){
        case $d09c3d63248ad913$var$REQUEST:
            return node.operation;
        case $d09c3d63248ad913$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $d09c3d63248ad913$var$getOperation;

});

parcelRegister("8lAOl", function(module, exports) {
'use strict';
function $613cd6c78bf0a8c9$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $613cd6c78bf0a8c9$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $613cd6c78bf0a8c9$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("dzNif", function(module, exports) {
'use strict';
var $9e24c7e0a9809964$var$_window, $9e24c7e0a9809964$var$_window$performance;
var $9e24c7e0a9809964$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($9e24c7e0a9809964$var$_window = window) === null || $9e24c7e0a9809964$var$_window === void 0 ? void 0 : ($9e24c7e0a9809964$var$_window$performance = $9e24c7e0a9809964$var$_window.performance) === null || $9e24c7e0a9809964$var$_window$performance === void 0 ? void 0 : $9e24c7e0a9809964$var$_window$performance.now) === 'function';
function $9e24c7e0a9809964$var$currentTimestamp() {
    if ($9e24c7e0a9809964$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $9e24c7e0a9809964$var$withDuration(cb) {
    var startTime = $9e24c7e0a9809964$var$currentTimestamp();
    var result = cb();
    return [
        $9e24c7e0a9809964$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $9e24c7e0a9809964$var$withDuration;

});


parcelRegister("8EtTz", function(module, exports) {
'use strict';
var $64c93fc29eb48b00$var$_global$ErrorUtils$ap, $64c93fc29eb48b00$var$_global$ErrorUtils;

var $ds8he = parcelRequire("ds8he");

var $6Ugif = parcelRequire("6Ugif");

var $eXj0K = parcelRequire("eXj0K");

var $9miei = parcelRequire("9miei");

var $67IX0 = parcelRequire("67IX0");

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $64c93fc29eb48b00$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $64c93fc29eb48b00$var$applyWithGuard = ($64c93fc29eb48b00$var$_global$ErrorUtils$ap = $64c93fc29eb48b00$var$_global === null || $64c93fc29eb48b00$var$_global === void 0 ? void 0 : ($64c93fc29eb48b00$var$_global$ErrorUtils = $64c93fc29eb48b00$var$_global.ErrorUtils) === null || $64c93fc29eb48b00$var$_global$ErrorUtils === void 0 ? void 0 : $64c93fc29eb48b00$var$_global$ErrorUtils.applyWithGuard) !== null && $64c93fc29eb48b00$var$_global$ErrorUtils$ap !== void 0 ? $64c93fc29eb48b00$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $64c93fc29eb48b00$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $aE1Lc(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        if (runIsANoop) return [];
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $ds8he(this._store.getSource(), source);
        var recordSourceProxy = new $6Ugif(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aE1Lc(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $aE1Lc(false);
            var recordSourceSelectorProxy = new $eXj0K(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $64c93fc29eb48b00$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $67IX0.create();
                var mutator = new $ds8he(_this2._store.getSource(), sink);
                var recordSourceProxy = new $6Ugif(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers);
                $64c93fc29eb48b00$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $67IX0.create();
        var mutator = new $ds8he(this._store.getSource(), sink);
        var recordSourceProxy = new $6Ugif(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $64c93fc29eb48b00$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $64c93fc29eb48b00$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $eXj0K(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $64c93fc29eb48b00$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $64c93fc29eb48b00$var$lookupSelector(source, selector) {
    var selectorData = $9miei.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $64c93fc29eb48b00$var$RelayPublishQueue;

});
parcelRegister("ds8he", function(module, exports) {
'use strict';

var $jeujn = parcelRequire("jeujn");

var $dKkgv = parcelRequire("dKkgv");
var $9cb44f7ef29efea9$var$EXISTENT = $dKkgv.EXISTENT;

var $aE1Lc = parcelRequire("aE1Lc");
var $9cb44f7ef29efea9$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $jeujn.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $jeujn.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $jeujn.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $aE1Lc(false);
            sinkRecord = $jeujn.create(dataID, $jeujn.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $aE1Lc(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $jeujn.copyFields(baseSource, sink);
        if (sinkSource) $jeujn.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $jeujn.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $9cb44f7ef29efea9$var$EXISTENT && this._sink.getStatus(dataID) !== $9cb44f7ef29efea9$var$EXISTENT) && $aE1Lc(false);
        var record = $jeujn.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $jeujn.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $jeujn.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jeujn.setValue(sinkRecord, storageKey, value);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jeujn.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $jeujn.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $jeujn.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $9cb44f7ef29efea9$var$RelayRecordSourceMutator;

});

parcelRegister("6Ugif", function(module, exports) {
'use strict';

var $jeujn = parcelRequire("jeujn");

var $dKkgv = parcelRequire("dKkgv");
var $50749c8a985f47b6$var$EXISTENT = $dKkgv.EXISTENT, $50749c8a985f47b6$var$NONEXISTENT = $dKkgv.NONEXISTENT;

var $dfBRB = parcelRequire("dfBRB");
var $50749c8a985f47b6$var$ROOT_ID = $dfBRB.ROOT_ID, $50749c8a985f47b6$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;

var $62C5F = parcelRequire("62C5F");
var $50749c8a985f47b6$var$_readUpdatableFragment = $62C5F.readUpdatableFragment;

var $aRX1C = parcelRequire("aRX1C");
var $50749c8a985f47b6$var$_readUpdatableQuery = $aRX1C.readUpdatableQuery;

var $7ABFe = parcelRequire("7ABFe");

var $aE1Lc = parcelRequire("aE1Lc");
var $50749c8a985f47b6$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $50749c8a985f47b6$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $50749c8a985f47b6$var$EXISTENT) _this.create(dataID, $jeujn.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $50749c8a985f47b6$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $aE1Lc(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $aE1Lc(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $50749c8a985f47b6$var$ROOT_ID) && $aE1Lc(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $50749c8a985f47b6$var$EXISTENT) this._proxies[dataID] = new $7ABFe(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $50749c8a985f47b6$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($50749c8a985f47b6$var$ROOT_ID);
        if (!root) root = this.create($50749c8a985f47b6$var$ROOT_ID, $50749c8a985f47b6$var$ROOT_TYPE);
        !(root && root.getType() === $50749c8a985f47b6$var$ROOT_TYPE) && $aE1Lc(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $50749c8a985f47b6$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $50749c8a985f47b6$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $50749c8a985f47b6$var$RelayRecordSourceProxy;

});
parcelRegister("62C5F", function(module, exports) {
'use strict';

var $9IwIy = parcelRequire("9IwIy");
var $466079eda131fdaf$var$getFragment = $9IwIy.getFragment;

var $hqAuM = parcelRequire("hqAuM");
var $466079eda131fdaf$var$getVariablesFromFragment = $hqAuM.getVariablesFromFragment;

var $dfBRB = parcelRequire("dfBRB");
var $466079eda131fdaf$var$ID_KEY = $dfBRB.ID_KEY;

var $gtRRX = parcelRequire("gtRRX");
var $466079eda131fdaf$var$createUpdatableProxy = $gtRRX.createUpdatableProxy;

var $aE1Lc = parcelRequire("aE1Lc");
function $466079eda131fdaf$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $466079eda131fdaf$var$getFragment(fragment);
    var fragmentVariables = $466079eda131fdaf$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$466079eda131fdaf$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $aE1Lc(false);
    return {
        updatableData: $466079eda131fdaf$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $466079eda131fdaf$var$readUpdatableFragment
};

});
parcelRegister("gtRRX", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $bff9241597ca9d18$var$_interopRequireDefault = $7gV6J.default;

var $bff9241597ca9d18$var$_createForOfIteratorHelper2 = $bff9241597ca9d18$var$_interopRequireDefault((parcelRequire("8utPl")));

var $dfBRB = parcelRequire("dfBRB");
var $bff9241597ca9d18$var$getArgumentValues = $dfBRB.getArgumentValues;

var $7AO8k = parcelRequire("7AO8k");
var $bff9241597ca9d18$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $bff9241597ca9d18$var$ALIASED_FRAGMENT_SPREAD = $7AO8k.ALIASED_FRAGMENT_SPREAD, $bff9241597ca9d18$var$ALIASED_INLINE_FRAGMENT_SPREAD = $7AO8k.ALIASED_INLINE_FRAGMENT_SPREAD, $bff9241597ca9d18$var$CATCH_FIELD = $7AO8k.CATCH_FIELD, $bff9241597ca9d18$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT, $bff9241597ca9d18$var$CLIENT_EDGE_TO_SERVER_OBJECT = $7AO8k.CLIENT_EDGE_TO_SERVER_OBJECT, $bff9241597ca9d18$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $bff9241597ca9d18$var$CONDITION = $7AO8k.CONDITION, $bff9241597ca9d18$var$DEFER = $7AO8k.DEFER, $bff9241597ca9d18$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $bff9241597ca9d18$var$INLINE_DATA_FRAGMENT_SPREAD = $7AO8k.INLINE_DATA_FRAGMENT_SPREAD, $bff9241597ca9d18$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $bff9241597ca9d18$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $bff9241597ca9d18$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $bff9241597ca9d18$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $bff9241597ca9d18$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $bff9241597ca9d18$var$REQUIRED_FIELD = $7AO8k.REQUIRED_FIELD, $bff9241597ca9d18$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $bff9241597ca9d18$var$STREAM = $7AO8k.STREAM;
var $bff9241597ca9d18$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $bff9241597ca9d18$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $bff9241597ca9d18$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $bff9241597ca9d18$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $bff9241597ca9d18$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case $bff9241597ca9d18$var$LINKED_FIELD:
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $bff9241597ca9d18$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $bff9241597ca9d18$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $bff9241597ca9d18$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $bff9241597ca9d18$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case $bff9241597ca9d18$var$SCALAR_FIELD:
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $bff9241597ca9d18$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $bff9241597ca9d18$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case $bff9241597ca9d18$var$INLINE_FRAGMENT:
                    if (updatableProxyRootRecord.getType() === selection.type) $bff9241597ca9d18$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $bff9241597ca9d18$var$CLIENT_EXTENSION:
                    $bff9241597ca9d18$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case $bff9241597ca9d18$var$FRAGMENT_SPREAD:
                    break;
                case $bff9241597ca9d18$var$CONDITION:
                case $bff9241597ca9d18$var$ACTOR_CHANGE:
                case $bff9241597ca9d18$var$ALIASED_FRAGMENT_SPREAD:
                case $bff9241597ca9d18$var$INLINE_DATA_FRAGMENT_SPREAD:
                case $bff9241597ca9d18$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                case $bff9241597ca9d18$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $bff9241597ca9d18$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                case $bff9241597ca9d18$var$DEFER:
                case $bff9241597ca9d18$var$MODULE_IMPORT:
                case $bff9241597ca9d18$var$RELAY_LIVE_RESOLVER:
                case $bff9241597ca9d18$var$REQUIRED_FIELD:
                case $bff9241597ca9d18$var$CATCH_FIELD:
                case $bff9241597ca9d18$var$STREAM:
                case $bff9241597ca9d18$var$RELAY_RESOLVER:
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $bff9241597ca9d18$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $bff9241597ca9d18$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $bff9241597ca9d18$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $bff9241597ca9d18$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $bff9241597ca9d18$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $bff9241597ca9d18$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $bff9241597ca9d18$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $bff9241597ca9d18$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $bff9241597ca9d18$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $bff9241597ca9d18$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $bff9241597ca9d18$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $bff9241597ca9d18$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $bff9241597ca9d18$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $bff9241597ca9d18$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $bff9241597ca9d18$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $bff9241597ca9d18$var$createUpdatableProxy
};

});


parcelRegister("aRX1C", function(module, exports) {
'use strict';

var $9IwIy = parcelRequire("9IwIy");
var $7e9ca3c5a7f8de66$var$getUpdatableQuery = $9IwIy.getUpdatableQuery;

var $gtRRX = parcelRequire("gtRRX");
var $7e9ca3c5a7f8de66$var$createUpdatableProxy = $gtRRX.createUpdatableProxy;
function $7e9ca3c5a7f8de66$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $7e9ca3c5a7f8de66$var$getUpdatableQuery(query);
    return {
        updatableData: $7e9ca3c5a7f8de66$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $7e9ca3c5a7f8de66$var$readUpdatableQuery
};

});

parcelRegister("7ABFe", function(module, exports) {
'use strict';

var $dgkLD = parcelRequire("dgkLD");
var $58691c81b20b06d2$var$generateClientID = $dgkLD.generateClientID;

var $dfBRB = parcelRequire("dfBRB");
var $58691c81b20b06d2$var$getStableStorageKey = $dfBRB.getStableStorageKey;

var $aE1Lc = parcelRequire("aE1Lc");
var $58691c81b20b06d2$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $aE1Lc(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args) {
        !$58691c81b20b06d2$var$isValidLeafValue(value) && $aE1Lc(false);
        return this.setValue__UNSAFE(value, name, args);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args) {
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $aE1Lc(false);
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
            var clientID = $58691c81b20b06d2$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $aE1Lc(false);
        var storageKey = $58691c81b20b06d2$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $58691c81b20b06d2$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($58691c81b20b06d2$var$isValidLeafValue);
}
module.exports = $58691c81b20b06d2$var$RelayRecordProxy;

});


parcelRegister("eXj0K", function(module, exports) {
'use strict';

var $dfBRB = parcelRequire("dfBRB");
var $ae3552913da6531c$var$ROOT_TYPE = $dfBRB.ROOT_TYPE, $ae3552913da6531c$var$getStorageKey = $dfBRB.getStorageKey;

var $62C5F = parcelRequire("62C5F");
var $ae3552913da6531c$var$_readUpdatableFragment = $62C5F.readUpdatableFragment;

var $aRX1C = parcelRequire("aRX1C");
var $ae3552913da6531c$var$_readUpdatableQuery = $aRX1C.readUpdatableQuery;

var $aE1Lc = parcelRequire("aE1Lc");
var $ae3552913da6531c$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $ae3552913da6531c$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $aE1Lc(false);
        !(field.plural === plural) && $aE1Lc(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $ae3552913da6531c$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $ae3552913da6531c$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $ae3552913da6531c$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $ae3552913da6531c$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $ae3552913da6531c$var$RelayRecordSourceSelectorProxy;

});

parcelRegister("9miei", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $6d044f2b4d41457d$var$_interopRequireDefault = $7gV6J.default;

var $6d044f2b4d41457d$var$_defineProperty2 = $6d044f2b4d41457d$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $6d044f2b4d41457d$var$_createForOfIteratorHelper2 = $6d044f2b4d41457d$var$_interopRequireDefault((parcelRequire("8utPl")));

var $6d044f2b4d41457d$var$_toConsumableArray2 = $6d044f2b4d41457d$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $7AO8k = parcelRequire("7AO8k");
var $6d044f2b4d41457d$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $6d044f2b4d41457d$var$ALIASED_FRAGMENT_SPREAD = $7AO8k.ALIASED_FRAGMENT_SPREAD, $6d044f2b4d41457d$var$ALIASED_INLINE_FRAGMENT_SPREAD = $7AO8k.ALIASED_INLINE_FRAGMENT_SPREAD, $6d044f2b4d41457d$var$CATCH_FIELD = $7AO8k.CATCH_FIELD, $6d044f2b4d41457d$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT, $6d044f2b4d41457d$var$CLIENT_EDGE_TO_SERVER_OBJECT = $7AO8k.CLIENT_EDGE_TO_SERVER_OBJECT, $6d044f2b4d41457d$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $6d044f2b4d41457d$var$CONDITION = $7AO8k.CONDITION, $6d044f2b4d41457d$var$DEFER = $7AO8k.DEFER, $6d044f2b4d41457d$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $6d044f2b4d41457d$var$INLINE_DATA_FRAGMENT_SPREAD = $7AO8k.INLINE_DATA_FRAGMENT_SPREAD, $6d044f2b4d41457d$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $6d044f2b4d41457d$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $6d044f2b4d41457d$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $6d044f2b4d41457d$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $6d044f2b4d41457d$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $6d044f2b4d41457d$var$REQUIRED_FIELD = $7AO8k.REQUIRED_FIELD, $6d044f2b4d41457d$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $6d044f2b4d41457d$var$STREAM = $7AO8k.STREAM;

var $brVAm = parcelRequire("brVAm");

var $9a00R = parcelRequire("9a00R");
var $6d044f2b4d41457d$var$isSuspenseSentinel = $9a00R.isSuspenseSentinel;

var $kgs0j = parcelRequire("kgs0j");

var $jeujn = parcelRequire("jeujn");

var $dfBRB = parcelRequire("dfBRB");
var $6d044f2b4d41457d$var$CLIENT_EDGE_TRAVERSAL_PATH = $dfBRB.CLIENT_EDGE_TRAVERSAL_PATH, $6d044f2b4d41457d$var$FRAGMENT_OWNER_KEY = $dfBRB.FRAGMENT_OWNER_KEY, $6d044f2b4d41457d$var$FRAGMENT_PROP_NAME_KEY = $dfBRB.FRAGMENT_PROP_NAME_KEY, $6d044f2b4d41457d$var$FRAGMENTS_KEY = $dfBRB.FRAGMENTS_KEY, $6d044f2b4d41457d$var$ID_KEY = $dfBRB.ID_KEY, $6d044f2b4d41457d$var$MODULE_COMPONENT_KEY = $dfBRB.MODULE_COMPONENT_KEY, $6d044f2b4d41457d$var$ROOT_ID = $dfBRB.ROOT_ID, $6d044f2b4d41457d$var$getArgumentValues = $dfBRB.getArgumentValues, $6d044f2b4d41457d$var$getModuleComponentKey = $dfBRB.getModuleComponentKey, $6d044f2b4d41457d$var$getStorageKey = $dfBRB.getStorageKey;

var $6SB6y = parcelRequire("6SB6y");
var $6d044f2b4d41457d$var$NoopResolverCache = $6SB6y.NoopResolverCache;

var $8tSNa = parcelRequire("8tSNa");
var $6d044f2b4d41457d$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = $8tSNa.RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL, $6d044f2b4d41457d$var$withResolverContext = $8tSNa.withResolverContext;

var $fW7kJ = parcelRequire("fW7kJ");
var $6d044f2b4d41457d$var$generateTypeID = $fW7kJ.generateTypeID;

var $aE1Lc = parcelRequire("aE1Lc");
function $6d044f2b4d41457d$var$read(recordSource, selector, resolverCache) {
    var reader = new $6d044f2b4d41457d$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $6d044f2b4d41457d$var$NoopResolverCache());
    return reader.read();
}
var $6d044f2b4d41457d$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache) {
        var _selector$clientEdgeT;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $6d044f2b4d41457d$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._missingRequiredFields = null;
        this._errorResponseFields = null;
        this._owner = selector.owner;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._resolverErrors = [];
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            var recordType = $jeujn.getType(record);
            if (recordType !== node.type && dataID !== $6d044f2b4d41457d$var$ROOT_ID) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
            else if (implementsInterface == null) this._isMissingData = true;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            missingRequiredFields: this._missingRequiredFields,
            relayResolverErrors: this._resolverErrors,
            errorResponseFields: this._errorResponseFields
        };
    };
    _proto._maybeAddErrorResponseFields = function _maybeAddErrorResponseFields(record, storageKey) {
        if (!$brVAm.ENABLE_FIELD_ERROR_HANDLING) return;
        var errors = $jeujn.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._errorResponseFields == null) this._errorResponseFields = [];
        var _iterator = (0, $6d044f2b4d41457d$var$_createForOfIteratorHelper2["default"])(errors), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _error$path;
                var error = _step.value;
                this._errorResponseFields.push({
                    owner: owner,
                    path: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                    error: error
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing() {
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing();
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aE1Lc(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(fieldPath, action) {
        var _this$_missingRequire;
        if (((_this$_missingRequire = this._missingRequiredFields) === null || _this$_missingRequire === void 0 ? void 0 : _this$_missingRequire.action) === 'THROW') return;
        var owner = this._fragmentName;
        switch(action){
            case 'THROW':
                this._missingRequiredFields = {
                    action: action,
                    field: {
                        path: fieldPath,
                        owner: owner
                    }
                };
                return;
            case 'LOG':
                if (this._missingRequiredFields == null) this._missingRequiredFields = {
                    action: action,
                    fields: [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ]
                };
                else this._missingRequiredFields = {
                    action: action,
                    fields: [].concat((0, $6d044f2b4d41457d$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), [
                        {
                            path: fieldPath,
                            owner: owner
                        }
                    ])
                };
                return;
            default:
                action;
        }
    };
    _proto._handleCatchFieldValue = function _handleCatchFieldValue(selection, record, data, value) {
        var _selection$field$back, _selection$field, _field$alias, _this$_missingRequire2;
        var to = selection.to;
        var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
        var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
        !(fieldName != null) && $aE1Lc(false);
        if (this._errorResponseFields != null) for(var i = 0; i < this._errorResponseFields.length; i++)this._errorResponseFields[i].to = to;
        if (((_this$_missingRequire2 = this._missingRequiredFields) === null || _this$_missingRequire2 === void 0 ? void 0 : _this$_missingRequire2.action) === 'THROW') {
            var _this$_missingRequire3;
            if (((_this$_missingRequire3 = this._missingRequiredFields) === null || _this$_missingRequire3 === void 0 ? void 0 : _this$_missingRequire3.field) == null) return;
            if (this._errorResponseFields == null) this._errorResponseFields = [];
            var _this$_missingRequire4 = this._missingRequiredFields.field, owner = _this$_missingRequire4.owner, path = _this$_missingRequire4.path;
            this._errorResponseFields.push({
                owner: owner,
                path: path,
                error: {
                    message: "Relay: Missing @required value at path '".concat(path, "' in '").concat(owner, "'.")
                },
                to: to
            });
            this._missingRequiredFields = null;
            return;
        }
        if (this._errorResponseFields != null) {
            var errors = this._errorResponseFields.map(function(error) {
                return error.error;
            });
            data[fieldName] = {
                ok: false,
                errors: errors
            };
            return;
        }
        data[fieldName] = {
            ok: true,
            value: value
        };
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            var action = selection.action;
            if (action !== 'NONE') this._maybeReportUnexpectedNull(selection.path, action);
            return false;
        }
        return true;
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case $6d044f2b4d41457d$var$REQUIRED_FIELD:
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case $6d044f2b4d41457d$var$CATCH_FIELD:
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if ($brVAm.ENABLE_FIELD_ERROR_HANDLING_CATCH_DIRECTIVE) {
                        if (selection.to != 'NULL') this._handleCatchFieldValue(selection, record, data, catchFieldValue);
                    }
                    break;
                case $6d044f2b4d41457d$var$SCALAR_FIELD:
                    this._readScalar(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$LINKED_FIELD:
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$CONDITION:
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case $6d044f2b4d41457d$var$INLINE_FRAGMENT:
                    if (this._readInlineFragment(selection, record, data) === false) return false;
                    break;
                case $6d044f2b4d41457d$var$RELAY_LIVE_RESOLVER:
                case $6d044f2b4d41457d$var$RELAY_RESOLVER:
                    if (!$brVAm.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                    this._readResolverField(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$FRAGMENT_SPREAD:
                    this._createFragmentPointer(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$ALIASED_FRAGMENT_SPREAD:
                    data[selection.name] = this._createAliasedFragmentSpread(selection, record);
                    break;
                case $6d044f2b4d41457d$var$ALIASED_INLINE_FRAGMENT_SPREAD:
                    var fieldValue = this._readInlineFragment(selection.fragment, record, {});
                    if (fieldValue === false) fieldValue = null;
                    data[selection.name] = fieldValue;
                    break;
                case $6d044f2b4d41457d$var$MODULE_IMPORT:
                    this._readModuleImport(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$INLINE_DATA_FRAGMENT_SPREAD:
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$DEFER:
                case $6d044f2b4d41457d$var$CLIENT_EXTENSION:
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData) return false;
                    break;
                case $6d044f2b4d41457d$var$STREAM:
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData2) return false;
                    break;
                case $6d044f2b4d41457d$var$ACTOR_CHANGE:
                    this._readActorChange(selection, record, data);
                    break;
                case $6d044f2b4d41457d$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                case $6d044f2b4d41457d$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                    this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $aE1Lc(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case $6d044f2b4d41457d$var$SCALAR_FIELD:
                return this._readScalar(selection.field, record, data);
            case $6d044f2b4d41457d$var$LINKED_FIELD:
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case $6d044f2b4d41457d$var$RELAY_RESOLVER:
                if (!$brVAm.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $6d044f2b4d41457d$var$RELAY_LIVE_RESOLVER:
                if (!$brVAm.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readResolverField(selection.field, record, data);
            case $6d044f2b4d41457d$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
            case $6d044f2b4d41457d$var$CLIENT_EDGE_TO_SERVER_OBJECT:
                if (!$brVAm.ENABLE_RELAY_RESOLVERS) throw new Error('Relay Resolver fields are not yet supported.');
                return this._readClientEdge(selection.field, record, data);
            default:
                selection.field.kind;
                $aE1Lc(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $jeujn.getDataID(record);
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
            snapshot = $6d044f2b4d41457d$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $6d044f2b4d41457d$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $6d044f2b4d41457d$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $6d044f2b4d41457d$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $6d044f2b4d41457d$var$getResolverValue(field, _this._variables, key), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $6d044f2b4d41457d$var$getResolverValue(field, _this._variables, null), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propogateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propogateResolverMetadata = function _propogateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingRequiredFields != null) this._addMissingRequiredFields(cachedSnapshot.missingRequiredFields);
            if (cachedSnapshot.missingClientEdges != null) {
                var _iterator2 = (0, $6d044f2b4d41457d$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingClientEdges), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var missing = _step2.value;
                        this._missingClientEdges.push(missing);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                var _iterator3 = (0, $6d044f2b4d41457d$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.missingLiveResolverFields), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var missingResolverField = _step3.value;
                        this._missingLiveResolverFields.push(missingResolverField);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
            var _iterator4 = (0, $6d044f2b4d41457d$var$_createForOfIteratorHelper2["default"])(cachedSnapshot.relayResolverErrors), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var error = _step4.value;
                    this._resolverErrors.push(error);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) this._resolverErrors.push({
            field: {
                path: fieldPath,
                owner: this._fragmentName
            },
            error: resolverError
        });
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push({
                path: "".concat(this._fragmentName, ".").concat(fieldPath),
                liveStateID: suspenseID
            });
        }
        if (updatedDataIDs != null) {
            var _iterator5 = (0, $6d044f2b4d41457d$var$_createForOfIteratorHelper2["default"])(updatedDataIDs), _step5;
            try {
                for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                    var recordID = _step5.value;
                    this._updatedDataIDs.add(recordID);
                }
            } catch (err) {
                _iterator5.e(err);
            } finally{
                _iterator5.f();
            }
        }
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this2 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $aE1Lc(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $6d044f2b4d41457d$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $aE1Lc(false);
            var storeIDs;
            !(field.kind === $6d044f2b4d41457d$var$CLIENT_EDGE_TO_CLIENT_OBJECT) && $aE1Lc(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $aE1Lc(false);
                var localId = $6d044f2b4d41457d$var$extractIdFromResponse(itemResponse);
                var id = _this2._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $aE1Lc(false);
                    var model = _this2._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map($6d044f2b4d41457d$var$extractIdFromResponse);
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $6d044f2b4d41457d$var$extractIdFromResponse(clientEdgeResolverResponse);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === $6d044f2b4d41457d$var$CLIENT_EDGE_TO_CLIENT_OBJECT) {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $aE1Lc(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $aE1Lc(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $aE1Lc(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $aE1Lc(false);
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $6d044f2b4d41457d$var$getStorageKey(field, this._variables);
        var value = $jeujn.getValue(record, storageKey);
        if (value === null) this._maybeAddErrorResponseFields(record, storageKey);
        else if (value === undefined) this._markDataAsMissing();
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $6d044f2b4d41457d$var$getStorageKey(field, this._variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddErrorResponseFields(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing();
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $aE1Lc(false);
        var value = this._traverse(field, linkedID, prevData);
        data[fieldName] = value;
        return value;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $6d044f2b4d41457d$var$getStorageKey(field, this._variables);
        var externalRef = $jeujn.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing();
            else if (externalRef === null) this._maybeAddErrorResponseFields(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $jeujn.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $6d044f2b4d41457d$var$getStorageKey(field, this._variables);
        var linkedIDs = $jeujn.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null) this._maybeAddErrorResponseFields(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this3 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing();
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $aE1Lc(false);
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this3._markDataAsMissing();
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $aE1Lc(false);
            linkedArray[nextIndex] = _this3._traverse(field, linkedID, prevItem);
        });
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $6d044f2b4d41457d$var$getModuleComponentKey(moduleImport.documentName);
        var component = $jeujn.getValue(record, componentKey);
        if (component == null) {
            if (component === undefined) this._markDataAsMissing();
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$6d044f2b4d41457d$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$6d044f2b4d41457d$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._createAliasedFragmentSpread = function _createAliasedFragmentSpread(namedFragmentSpread, record) {
        var abstractKey = namedFragmentSpread.abstractKey;
        if (abstractKey == null) {
            var typeName = $jeujn.getType(record);
            if (typeName == null || typeName !== namedFragmentSpread.type) return null;
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) return null;
            else if (implementsInterface == null) {
                this._markDataAsMissing();
                return undefined;
            }
        }
        var fieldData = {};
        this._createFragmentPointer(namedFragmentSpread.fragment, record, fieldData);
        return $jeujn.fromObject(fieldData);
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            var typeName = $jeujn.getType(record);
            if (typeName == null || typeName !== inlineFragment.type) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return undefined;
            } else if (implementsInterface == null) {
                this._markDataAsMissing();
                return null;
            }
        }
        return data;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$6d044f2b4d41457d$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$6d044f2b4d41457d$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $aE1Lc(false);
        if (data[$6d044f2b4d41457d$var$ID_KEY] == null) data[$6d044f2b4d41457d$var$ID_KEY] = $jeujn.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $6d044f2b4d41457d$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$6d044f2b4d41457d$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$6d044f2b4d41457d$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $6d044f2b4d41457d$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$6d044f2b4d41457d$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$6d044f2b4d41457d$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $aE1Lc(false);
        if (data[$6d044f2b4d41457d$var$ID_KEY] == null) data[$6d044f2b4d41457d$var$ID_KEY] = $jeujn.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $6d044f2b4d41457d$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $kgs0j.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._addMissingRequiredFields = function _addMissingRequiredFields(additional) {
        if (this._missingRequiredFields == null) {
            this._missingRequiredFields = additional;
            return;
        }
        if (this._missingRequiredFields.action === 'THROW') return;
        if (additional.action === 'THROW') {
            this._missingRequiredFields = additional;
            return;
        }
        this._missingRequiredFields = {
            action: 'LOG',
            fields: [].concat((0, $6d044f2b4d41457d$var$_toConsumableArray2["default"])(this._missingRequiredFields.fields), (0, $6d044f2b4d41457d$var$_toConsumableArray2["default"])(additional.fields))
        };
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $jeujn.getType(record);
        var typeRecord = this._recordSource.get($6d044f2b4d41457d$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $jeujn.getValue(typeRecord, abstractKey) : null;
        return implementsInterface;
    };
    return RelayReader;
}();
function $6d044f2b4d41457d$var$getResolverValue(field, variables, fragmentKey) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $6d044f2b4d41457d$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        if (e === $6d044f2b4d41457d$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL) resolverResult = undefined;
        else resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $6d044f2b4d41457d$var$extractIdFromResponse(individualResponse) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $aE1Lc(false);
}
module.exports = {
    read: $6d044f2b4d41457d$var$read
};

});
parcelRegister("6SB6y", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $5024916e1d38dd9e$var$_interopRequireDefault = $7gV6J.default;

var $5024916e1d38dd9e$var$_createForOfIteratorHelper2 = $5024916e1d38dd9e$var$_interopRequireDefault((parcelRequire("8utPl")));

var $b2CqU = parcelRequire("b2CqU");

var $7AO8k = parcelRequire("7AO8k");
var $5024916e1d38dd9e$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER;

var $brVAm = parcelRequire("brVAm");

var $dFCzs = parcelRequire("dFCzs");

var $dgkLD = parcelRequire("dgkLD");
var $5024916e1d38dd9e$var$generateClientID = $dgkLD.generateClientID;

var $jeujn = parcelRequire("jeujn");

var $dfBRB = parcelRequire("dfBRB");
var $5024916e1d38dd9e$var$RELAY_RESOLVER_ERROR_KEY = $dfBRB.RELAY_RESOLVER_ERROR_KEY, $5024916e1d38dd9e$var$RELAY_RESOLVER_INVALIDATION_KEY = $dfBRB.RELAY_RESOLVER_INVALIDATION_KEY, $5024916e1d38dd9e$var$RELAY_RESOLVER_SNAPSHOT_KEY = $dfBRB.RELAY_RESOLVER_SNAPSHOT_KEY, $5024916e1d38dd9e$var$RELAY_RESOLVER_VALUE_KEY = $dfBRB.RELAY_RESOLVER_VALUE_KEY, $5024916e1d38dd9e$var$getStorageKey = $dfBRB.getStorageKey;

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
var $5024916e1d38dd9e$var$emptySet = new Set();
var $5024916e1d38dd9e$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $5024916e1d38dd9e$var$RELAY_LIVE_RESOLVER) && $aE1Lc(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $aE1Lc(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
function $5024916e1d38dd9e$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $5024916e1d38dd9e$var$RecordResolverCache = /*#__PURE__*/ function() {
    function RecordResolverCache(getRecordSource) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
    }
    var _proto2 = RecordResolverCache.prototype;
    _proto2.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = recordSource.get(recordID);
        !(record != null) && $aE1Lc(false);
        var storageKey = $5024916e1d38dd9e$var$getStorageKey(field, variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $5024916e1d38dd9e$var$generateClientID(recordID, storageKey);
            linkedRecord = $jeujn.create(linkedID, '__RELAY_RESOLVER__');
            var evaluationResult = evaluate();
            $dFCzs(evaluationResult.resolverResult);
            $jeujn.setValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_VALUE_KEY, evaluationResult.resolverResult);
            $jeujn.setValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $jeujn.setValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = recordSource.get(recordID);
            !(currentRecord != null) && $aE1Lc(false);
            var nextRecord = $jeujn.clone(currentRecord);
            $jeujn.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna;
                var fragmentStorageKey = $5024916e1d38dd9e$var$getStorageKey(field.fragment, variables);
                var resolverID = $5024916e1d38dd9e$var$generateClientID(recordID, fragmentStorageKey);
                $5024916e1d38dd9e$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $5024916e1d38dd9e$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna = evaluationResult.snapshot) === null || _evaluationResult$sna === void 0 ? void 0 : _evaluationResult$sna.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $5024916e1d38dd9e$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $5024916e1d38dd9e$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        }
        var answer = $jeujn.getValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_VALUE_KEY);
        var snapshot = $jeujn.getValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $jeujn.getValue(linkedRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_ERROR_KEY);
        return [
            answer,
            linkedID,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto2.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            updatedDataIDs.add(recordID);
            var _iterator2 = (0, $5024916e1d38dd9e$var$_createForOfIteratorHelper2["default"])((_this$_recordIDToReso = this._recordIDToResolverIDs.get(recordID)) !== null && _this$_recordIDToReso !== void 0 ? _this$_recordIDToReso : $5024916e1d38dd9e$var$emptySet), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _this$_recordIDToReso;
                    var fragment = _step2.value;
                    if (!visited.has(fragment)) {
                        var _iterator3 = (0, $5024916e1d38dd9e$var$_createForOfIteratorHelper2["default"])((_this$_resolverIDToRe = this._resolverIDToRecordIDs.get(fragment)) !== null && _this$_resolverIDToRe !== void 0 ? _this$_resolverIDToRe : $5024916e1d38dd9e$var$emptySet), _step3;
                        try {
                            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                var _this$_resolverIDToRe;
                                var anotherRecordID = _step3.value;
                                this._markInvalidatedResolverRecord(anotherRecordID, recordSource, updatedDataIDs);
                                if (!visited.has(anotherRecordID)) recordsToVisit.push(anotherRecordID);
                            }
                        } catch (err) {
                            _iterator3.e(err);
                        } finally{
                            _iterator3.f();
                        }
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    };
    _proto2._markInvalidatedResolverRecord = function _markInvalidatedResolverRecord(dataID, recordSource, updatedDataIDs) {
        var record = recordSource.get(dataID);
        if (!record) return;
        var nextRecord = $jeujn.clone(record);
        $jeujn.setValue(nextRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
        recordSource.set(dataID, nextRecord);
    };
    _proto2._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$jeujn.getValue(record, $5024916e1d38dd9e$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $jeujn.getValue(record, $5024916e1d38dd9e$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $b2CqU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($brVAm.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $jeujn.clone(record);
            $jeujn.setValue(nextRecord, $5024916e1d38dd9e$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($jeujn.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto2.ensureClientRecord = function ensureClientRecord(id, typename) {
        $aE1Lc(false);
    };
    _proto2.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        $aE1Lc(false);
    };
    return RecordResolverCache;
}();
module.exports = {
    NoopResolverCache: $5024916e1d38dd9e$var$NoopResolverCache,
    RecordResolverCache: $5024916e1d38dd9e$var$RecordResolverCache
};

});
parcelRegister("dFCzs", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});


parcelRegister("8tSNa", function(module, exports) {
'use strict';

var $9IwIy = parcelRequire("9IwIy");
var $62cb88bbe2ab4a95$var$getFragment = $9IwIy.getFragment;

var $hqAuM = parcelRequire("hqAuM");
var $62cb88bbe2ab4a95$var$getSelector = $hqAuM.getSelector;

var $aE1Lc = parcelRequire("aE1Lc");
var $62cb88bbe2ab4a95$var$contextStack = [];
function $62cb88bbe2ab4a95$var$withResolverContext(context, cb) {
    $62cb88bbe2ab4a95$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $62cb88bbe2ab4a95$var$contextStack.pop();
    }
}
function $62cb88bbe2ab4a95$var$readFragment(fragmentInput, fragmentKey) {
    if (!$62cb88bbe2ab4a95$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $62cb88bbe2ab4a95$var$contextStack[$62cb88bbe2ab4a95$var$contextStack.length - 1];
    var fragmentNode = $62cb88bbe2ab4a95$var$getFragment(fragmentInput);
    var fragmentSelector = $62cb88bbe2ab4a95$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $aE1Lc(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $aE1Lc(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData;
    if (isMissingData) throw $62cb88bbe2ab4a95$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL;
    return data;
}
var $62cb88bbe2ab4a95$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL = {};
module.exports = {
    readFragment: $62cb88bbe2ab4a95$var$readFragment,
    withResolverContext: $62cb88bbe2ab4a95$var$withResolverContext,
    RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL: $62cb88bbe2ab4a95$var$RESOLVER_FRAGMENT_MISSING_DATA_SENTINEL
};

});




parcelRegister("aWP6d", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $7f86f5636a84a03c$var$_interopRequireDefault = $7gV6J.default;

var $7f86f5636a84a03c$var$_createForOfIteratorHelper2 = $7f86f5636a84a03c$var$_interopRequireDefault((parcelRequire("8utPl")));

var $7f86f5636a84a03c$var$_defineProperty2 = $7f86f5636a84a03c$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $g6Qtb = parcelRequire("g6Qtb");
var $7f86f5636a84a03c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $g6Qtb.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $7f86f5636a84a03c$var$assertInternalActorIdentifier = $g6Qtb.assertInternalActorIdentifier;
parcelRequire("259Mc");

var $brVAm = parcelRequire("brVAm");

var $1zFTi = parcelRequire("1zFTi");

var $h7JIX = parcelRequire("h7JIX");

var $4FKGD = parcelRequire("4FKGD");

var $jeujn = parcelRequire("jeujn");

var $ja41X = parcelRequire("ja41X");

var $9miei = parcelRequire("9miei");

var $5DcbW = parcelRequire("5DcbW");

var $hWkm3 = parcelRequire("hWkm3");

var $dfBRB = parcelRequire("dfBRB");

var $dfBRB = parcelRequire("dfBRB");
var $7f86f5636a84a03c$var$ROOT_ID = $dfBRB.ROOT_ID, $7f86f5636a84a03c$var$ROOT_TYPE = $dfBRB.ROOT_TYPE;

var $6SB6y = parcelRequire("6SB6y");
var $7f86f5636a84a03c$var$RecordResolverCache = $6SB6y.RecordResolverCache;

var $aE1Lc = parcelRequire("aE1Lc");
var $7f86f5636a84a03c$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $7f86f5636a84a03c$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa;
        (0, $7f86f5636a84a03c$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $7f86f5636a84a03c$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $1zFTi;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $4FKGD;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $7f86f5636a84a03c$var$RecordResolverCache(function() {
            return _this._getMutableRecordSource();
        });
        this._storeSubscriptions = new $hWkm3(options === null || options === void 0 ? void 0 : options.log, this._resolverCache);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents;
        $7f86f5636a84a03c$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.check = function check(operation, options) {
        var _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $7f86f5636a84a03c$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $7f86f5636a84a03c$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $h7JIX.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $7f86f5636a84a03c$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents);
        return $7f86f5636a84a03c$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var source = this.getSource();
        var snapshot = $9miei.read(source, selector, this._resolverCache);
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        if ($brVAm.ENABLE_RELAY_RESOLVERS) this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $7f86f5636a84a03c$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $jeujn.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $7f86f5636a84a03c$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $ja41X.create(this.getSource());
    };
    _proto.restore = function restore() {
        !(this._optimisticSource != null) && $aE1Lc(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        top: while(true){
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $7f86f5636a84a03c$var$_createForOfIteratorHelper2["default"])(this._roots.values()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var operation = _step2.value.operation;
                    var selector = operation.root;
                    $5DcbW.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) continue top;
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var log = this.__log;
            if (log != null) log({
                name: 'store.gc',
                references: references
            });
            if (references.size === 0) this._recordSource.clear();
            else {
                var storeIDs = this._recordSource.getRecordIDs();
                for(var ii = 0; ii < storeIDs.length; ii++){
                    var dataID = storeIDs[ii];
                    if (!references.has(dataID)) this._recordSource.remove(dataID);
                }
            }
            return;
        }
    };
    return RelayModernStore;
}();
function $7f86f5636a84a03c$var$initializeRecordSource(target) {
    if (!target.has($7f86f5636a84a03c$var$ROOT_ID)) {
        var rootRecord = $jeujn.create($7f86f5636a84a03c$var$ROOT_ID, $7f86f5636a84a03c$var$ROOT_TYPE);
        target.set($7f86f5636a84a03c$var$ROOT_ID, rootRecord);
    }
}
function $7f86f5636a84a03c$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $jeujn.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $jeujn.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $jeujn.setValue(nextRecord, $dfBRB.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $jeujn.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $7f86f5636a84a03c$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $7f86f5636a84a03c$var$RelayModernStore;

});
parcelRegister("1zFTi", function(module, exports) {
'use strict';
var $12598df5c1dcd4ec$var$resolvedPromise = Promise.resolve();
function $12598df5c1dcd4ec$var$resolveImmediate(callback) {
    $12598df5c1dcd4ec$var$resolvedPromise.then(callback)["catch"]($12598df5c1dcd4ec$var$throwNext);
}
function $12598df5c1dcd4ec$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $12598df5c1dcd4ec$var$resolveImmediate;

});

parcelRegister("h7JIX", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $c7768ef31ef2a5fc$var$_interopRequireDefault = $7gV6J.default;

var $c7768ef31ef2a5fc$var$_createForOfIteratorHelper2 = $c7768ef31ef2a5fc$var$_interopRequireDefault((parcelRequire("8utPl")));

var $ds8he = parcelRequire("ds8he");

var $6Ugif = parcelRequire("6Ugif");

var $hUqwr = parcelRequire("hUqwr");

var $7AO8k = parcelRequire("7AO8k");

var $dgkLD = parcelRequire("dgkLD");
var $c7768ef31ef2a5fc$var$isClientID = $dgkLD.isClientID;

var $lQRTy = parcelRequire("lQRTy");

var $7V3La = parcelRequire("7V3La");

var $kgs0j = parcelRequire("kgs0j");
var $c7768ef31ef2a5fc$var$getLocalVariables = $kgs0j.getLocalVariables;

var $jeujn = parcelRequire("jeujn");

var $dKkgv = parcelRequire("dKkgv");
var $c7768ef31ef2a5fc$var$EXISTENT = $dKkgv.EXISTENT, $c7768ef31ef2a5fc$var$UNKNOWN = $dKkgv.UNKNOWN;

var $dfBRB = parcelRequire("dfBRB");

var $fW7kJ = parcelRequire("fW7kJ");
var $c7768ef31ef2a5fc$var$TYPE_SCHEMA_TYPE = $fW7kJ.TYPE_SCHEMA_TYPE, $c7768ef31ef2a5fc$var$generateTypeID = $fW7kJ.generateTypeID;

var $aE1Lc = parcelRequire("aE1Lc");
var $c7768ef31ef2a5fc$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $c7768ef31ef2a5fc$var$CONDITION = $7AO8k.CONDITION, $c7768ef31ef2a5fc$var$CLIENT_COMPONENT = $7AO8k.CLIENT_COMPONENT, $c7768ef31ef2a5fc$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $c7768ef31ef2a5fc$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT, $c7768ef31ef2a5fc$var$DEFER = $7AO8k.DEFER, $c7768ef31ef2a5fc$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $c7768ef31ef2a5fc$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $c7768ef31ef2a5fc$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $c7768ef31ef2a5fc$var$LINKED_HANDLE = $7AO8k.LINKED_HANDLE, $c7768ef31ef2a5fc$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $c7768ef31ef2a5fc$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $c7768ef31ef2a5fc$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $c7768ef31ef2a5fc$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $c7768ef31ef2a5fc$var$SCALAR_HANDLE = $7AO8k.SCALAR_HANDLE, $c7768ef31ef2a5fc$var$STREAM = $7AO8k.STREAM, $c7768ef31ef2a5fc$var$TYPE_DISCRIMINATOR = $7AO8k.TYPE_DISCRIMINATOR;
var $c7768ef31ef2a5fc$var$getModuleOperationKey = $dfBRB.getModuleOperationKey, $c7768ef31ef2a5fc$var$getStorageKey = $dfBRB.getStorageKey, $c7768ef31ef2a5fc$var$getArgumentValues = $dfBRB.getArgumentValues;
function $c7768ef31ef2a5fc$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $c7768ef31ef2a5fc$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents);
    return checker.check(node, dataID);
}
var $c7768ef31ef2a5fc$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $ds8he(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $6Ugif(mutator, this._getDataID, undefined, this._handlers);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aE1Lc(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $c7768ef31ef2a5fc$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $c7768ef31ef2a5fc$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $c7768ef31ef2a5fc$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $c7768ef31ef2a5fc$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $c7768ef31ef2a5fc$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $c7768ef31ef2a5fc$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $c7768ef31ef2a5fc$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $c7768ef31ef2a5fc$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $c7768ef31ef2a5fc$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $c7768ef31ef2a5fc$var$UNKNOWN) this._handleMissing();
        if (status === $c7768ef31ef2a5fc$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $jeujn.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $c7768ef31ef2a5fc$var$SCALAR_FIELD:
                    _this2._checkScalar(selection, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$LINKED_FIELD:
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$ACTOR_CHANGE:
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$CONDITION:
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$INLINE_FRAGMENT:
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $aE1Lc(false);
                        var _typeID = $c7768ef31ef2a5fc$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case $c7768ef31ef2a5fc$var$LINKED_HANDLE:
                    var handleField = $lQRTy(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$SCALAR_HANDLE:
                    var _handleField = $7V3La(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$MODULE_IMPORT:
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$DEFER:
                case $c7768ef31ef2a5fc$var$STREAM:
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$FRAGMENT_SPREAD:
                    var prevVariables = _this2._variables;
                    _this2._variables = $c7768ef31ef2a5fc$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case $c7768ef31ef2a5fc$var$CLIENT_EXTENSION:
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case $c7768ef31ef2a5fc$var$TYPE_DISCRIMINATOR:
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $aE1Lc(false);
                    var typeID = $c7768ef31ef2a5fc$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case $c7768ef31ef2a5fc$var$CLIENT_COMPONENT:
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$RELAY_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$RELAY_LIVE_RESOLVER:
                    _this2._checkResolver(selection, dataID);
                    break;
                case $c7768ef31ef2a5fc$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $aE1Lc(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aE1Lc(false);
        var operationKey = $c7768ef31ef2a5fc$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $hUqwr(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $c7768ef31ef2a5fc$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $c7768ef31ef2a5fc$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $c7768ef31ef2a5fc$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $c7768ef31ef2a5fc$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $c7768ef31ef2a5fc$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $jeujn.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $c7768ef31ef2a5fc$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $c7768ef31ef2a5fc$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $c7768ef31ef2a5fc$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $c7768ef31ef2a5fc$var$check
};

});
parcelRegister("lQRTy", function(module, exports) {
'use strict';

var $7AO8k = parcelRequire("7AO8k");
var $fe8842be74439d33$var$LINKED_FIELD = $7AO8k.LINKED_FIELD;

var $dfBRB = parcelRequire("dfBRB");
var $fe8842be74439d33$var$getHandleStorageKey = $dfBRB.getHandleStorageKey;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
function $fe8842be74439d33$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $fe8842be74439d33$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $9p5ca(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $fe8842be74439d33$var$LINKED_FIELD) && $aE1Lc(false);
    var handleKey = $fe8842be74439d33$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $fe8842be74439d33$var$cloneRelayHandleSourceField;

});

parcelRegister("7V3La", function(module, exports) {
'use strict';

var $7AO8k = parcelRequire("7AO8k");
var $5c40c5e2c90791b0$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD;

var $dfBRB = parcelRequire("dfBRB");
var $5c40c5e2c90791b0$var$getHandleStorageKey = $dfBRB.getHandleStorageKey;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");
function $5c40c5e2c90791b0$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $5c40c5e2c90791b0$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $9p5ca(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $5c40c5e2c90791b0$var$SCALAR_FIELD) && $aE1Lc(false);
    var handleKey = $5c40c5e2c90791b0$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $5c40c5e2c90791b0$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("ja41X", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $df3213e346cb6a5d$var$_interopRequireDefault = $7gV6J.default;

var $df3213e346cb6a5d$var$_objectSpread2 = $df3213e346cb6a5d$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $jeujn = parcelRequire("jeujn");

var $67IX0 = parcelRequire("67IX0");

var $aE1Lc = parcelRequire("aE1Lc");
var $df3213e346cb6a5d$var$UNPUBLISH_RECORD_SENTINEL = $jeujn.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $df3213e346cb6a5d$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $67IX0.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $df3213e346cb6a5d$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $df3213e346cb6a5d$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $67IX0.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $df3213e346cb6a5d$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $df3213e346cb6a5d$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $jeujn.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $df3213e346cb6a5d$var$create(base) {
    return new $df3213e346cb6a5d$var$RelayOptimisticRecordSource(base);
}
function $df3213e346cb6a5d$var$getOptimisticRecordIDs(source) {
    !(source instanceof $df3213e346cb6a5d$var$RelayOptimisticRecordSource) && $aE1Lc(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $df3213e346cb6a5d$var$create,
    getOptimisticRecordIDs: $df3213e346cb6a5d$var$getOptimisticRecordIDs
};

});

parcelRegister("5DcbW", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $419a0d41a71c4faf$var$_interopRequireDefault = $7gV6J.default;

var $419a0d41a71c4faf$var$_createForOfIteratorHelper2 = $419a0d41a71c4faf$var$_interopRequireDefault((parcelRequire("8utPl")));

var $hUqwr = parcelRequire("hUqwr");

var $7AO8k = parcelRequire("7AO8k");

var $lQRTy = parcelRequire("lQRTy");

var $24A8O = parcelRequire("24A8O");

var $kgs0j = parcelRequire("kgs0j");
var $419a0d41a71c4faf$var$getLocalVariables = $kgs0j.getLocalVariables;

var $jeujn = parcelRequire("jeujn");

var $dfBRB = parcelRequire("dfBRB");

var $fW7kJ = parcelRequire("fW7kJ");
var $419a0d41a71c4faf$var$generateTypeID = $fW7kJ.generateTypeID;

var $aE1Lc = parcelRequire("aE1Lc");
var $419a0d41a71c4faf$var$ACTOR_CHANGE = $7AO8k.ACTOR_CHANGE, $419a0d41a71c4faf$var$CONDITION = $7AO8k.CONDITION, $419a0d41a71c4faf$var$CLIENT_COMPONENT = $7AO8k.CLIENT_COMPONENT, $419a0d41a71c4faf$var$CLIENT_EXTENSION = $7AO8k.CLIENT_EXTENSION, $419a0d41a71c4faf$var$DEFER = $7AO8k.DEFER, $419a0d41a71c4faf$var$FRAGMENT_SPREAD = $7AO8k.FRAGMENT_SPREAD, $419a0d41a71c4faf$var$INLINE_FRAGMENT = $7AO8k.INLINE_FRAGMENT, $419a0d41a71c4faf$var$LINKED_FIELD = $7AO8k.LINKED_FIELD, $419a0d41a71c4faf$var$MODULE_IMPORT = $7AO8k.MODULE_IMPORT, $419a0d41a71c4faf$var$LINKED_HANDLE = $7AO8k.LINKED_HANDLE, $419a0d41a71c4faf$var$SCALAR_FIELD = $7AO8k.SCALAR_FIELD, $419a0d41a71c4faf$var$SCALAR_HANDLE = $7AO8k.SCALAR_HANDLE, $419a0d41a71c4faf$var$STREAM = $7AO8k.STREAM, $419a0d41a71c4faf$var$TYPE_DISCRIMINATOR = $7AO8k.TYPE_DISCRIMINATOR, $419a0d41a71c4faf$var$RELAY_RESOLVER = $7AO8k.RELAY_RESOLVER, $419a0d41a71c4faf$var$RELAY_LIVE_RESOLVER = $7AO8k.RELAY_LIVE_RESOLVER, $419a0d41a71c4faf$var$CLIENT_EDGE_TO_CLIENT_OBJECT = $7AO8k.CLIENT_EDGE_TO_CLIENT_OBJECT;
var $419a0d41a71c4faf$var$getStorageKey = $dfBRB.getStorageKey, $419a0d41a71c4faf$var$getModuleOperationKey = $dfBRB.getModuleOperationKey;
function $419a0d41a71c4faf$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $419a0d41a71c4faf$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents);
    marker.mark(node, dataID);
}
var $419a0d41a71c4faf$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $aE1Lc(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case $419a0d41a71c4faf$var$ACTOR_CHANGE:
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case $419a0d41a71c4faf$var$LINKED_FIELD:
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case $419a0d41a71c4faf$var$CONDITION:
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case $419a0d41a71c4faf$var$INLINE_FRAGMENT:
                    if (selection.abstractKey == null) {
                        var typeName = $jeujn.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $dfBRB.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $jeujn.getType(record);
                        var typeID = $419a0d41a71c4faf$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case $419a0d41a71c4faf$var$FRAGMENT_SPREAD:
                    var prevVariables = _this._variables;
                    _this._variables = $419a0d41a71c4faf$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case $419a0d41a71c4faf$var$LINKED_HANDLE:
                    var handleField = $lQRTy(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case $419a0d41a71c4faf$var$DEFER:
                case $419a0d41a71c4faf$var$STREAM:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $419a0d41a71c4faf$var$SCALAR_FIELD:
                case $419a0d41a71c4faf$var$SCALAR_HANDLE:
                    break;
                case $419a0d41a71c4faf$var$TYPE_DISCRIMINATOR:
                    var _typeName2 = $jeujn.getType(record);
                    var _typeID = $419a0d41a71c4faf$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case $419a0d41a71c4faf$var$MODULE_IMPORT:
                    _this._traverseModuleImport(selection, record);
                    break;
                case $419a0d41a71c4faf$var$CLIENT_EXTENSION:
                    _this._traverseSelections(selection.selections, record);
                    break;
                case $419a0d41a71c4faf$var$CLIENT_COMPONENT:
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case $419a0d41a71c4faf$var$RELAY_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $419a0d41a71c4faf$var$RELAY_LIVE_RESOLVER:
                    _this._traverseResolverField(selection, record);
                    break;
                case $419a0d41a71c4faf$var$CLIENT_EDGE_TO_CLIENT_OBJECT:
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $aE1Lc(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $24A8O(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $419a0d41a71c4faf$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $jeujn.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $419a0d41a71c4faf$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $jeujn.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        var storageKey = $419a0d41a71c4faf$var$getStorageKey(field, this._variables);
        var dataID = $jeujn.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $aE1Lc(false);
        var operationKey = $419a0d41a71c4faf$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $jeujn.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $hUqwr(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $419a0d41a71c4faf$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $419a0d41a71c4faf$var$getStorageKey(field, this._variables);
        var linkedID = $jeujn.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $419a0d41a71c4faf$var$getStorageKey(field, this._variables);
        var linkedIDs = $jeujn.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $419a0d41a71c4faf$var$mark
};

});
parcelRegister("24A8O", function(module, exports) {
'use strict';

var $jeujn = parcelRequire("jeujn");

var $dfBRB = parcelRequire("dfBRB");
var $1827fd594d80fa21$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $dfBRB.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $aE1Lc = parcelRequire("aE1Lc");
function $1827fd594d80fa21$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $jeujn.getValue(record, $1827fd594d80fa21$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $aE1Lc(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $1827fd594d80fa21$var$getOutputTypeRecordIDs;

});


parcelRegister("hWkm3", function(module, exports) {
'use strict';
parcelRequire("259Mc");

var $b2CqU = parcelRequire("b2CqU");

var $brVAm = parcelRequire("brVAm");

var $aWZ7I = parcelRequire("aWZ7I");

var $jkQdx = parcelRequire("jkQdx");

var $9miei = parcelRequire("9miei");
var $d0f7a47a43378e7b$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $9miei.read(source, snapshot.selector, _this2._resolverCache);
            var nextData = $b2CqU(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    missingRequiredFields: backup.missingRequiredFields,
                    relayResolverErrors: backup.relayResolverErrors,
                    errorResponseFields: backup.errorResponseFields
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $aWZ7I(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $9miei.read(source, snapshot.selector, this._resolverCache) : backup;
        var nextData = $b2CqU(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            missingRequiredFields: nextSnapshot.missingRequiredFields,
            relayResolverErrors: nextSnapshot.relayResolverErrors,
            errorResponseFields: nextSnapshot.errorResponseFields
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $brVAm.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($brVAm.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $jkQdx(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $d0f7a47a43378e7b$var$RelayStoreSubscriptions;

});
parcelRegister("aWZ7I", function(module, exports) {
'use strict';
var $7f8ebbfd1b053683$var$ITERATOR_KEY = Symbol.iterator;
function $7f8ebbfd1b053683$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$7f8ebbfd1b053683$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $7f8ebbfd1b053683$var$hasOverlappingIDs;

});

parcelRegister("jkQdx", function(module, exports) {
'use strict';

var $dfBRB = parcelRequire("dfBRB");
var $e13863df53fe9124$var$ROOT_ID = $dfBRB.ROOT_ID;

var $3r4Jp = parcelRequire("3r4Jp");
var $e13863df53fe9124$var$VIEWER_ID = $3r4Jp.VIEWER_ID;
var $e13863df53fe9124$var$ITERATOR_KEY = Symbol.iterator;
function $e13863df53fe9124$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$e13863df53fe9124$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $e13863df53fe9124$var$ROOT_ID && key !== $e13863df53fe9124$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $e13863df53fe9124$var$hasSignificantOverlappingIDs;

});



parcelRegister("idYnc", function(module, exports) {
'use strict';

var $fwYvm = parcelRequire("fwYvm");

var $9IwIy = parcelRequire("9IwIy");
var $d44845bba5ed9b73$var$getRequest = $9IwIy.getRequest;

var $gNCy0 = parcelRequire("gNCy0");
var $d44845bba5ed9b73$var$createOperationDescriptor = $gNCy0.createOperationDescriptor;

var $hqAuM = parcelRequire("hqAuM");
var $d44845bba5ed9b73$var$createReaderSelector = $hqAuM.createReaderSelector;
parcelRequire("1srSR");
function $d44845bba5ed9b73$var$requestSubscription(environment, config) {
    var subscription = $d44845bba5ed9b73$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $d44845bba5ed9b73$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $fwYvm.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $d44845bba5ed9b73$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $d44845bba5ed9b73$var$requestSubscription;

});

parcelRegister("850ax", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $5e1eebe6dea783fc$var$_interopRequireDefault = $7gV6J.default;

var $5e1eebe6dea783fc$var$_objectSpread2 = $5e1eebe6dea783fc$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $dfBRB = parcelRequire("dfBRB");
var $5e1eebe6dea783fc$var$getModuleComponentKey = $dfBRB.getModuleComponentKey, $5e1eebe6dea783fc$var$getModuleOperationKey = $dfBRB.getModuleOperationKey;
function $5e1eebe6dea783fc$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $5e1eebe6dea783fc$var$_objectSpread2["default"])({}, response);
    data[$5e1eebe6dea783fc$var$getModuleComponentKey(name)] = component;
    data[$5e1eebe6dea783fc$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $5e1eebe6dea783fc$var$createPayloadFor3DField;

});

parcelRegister("iUdPZ", function(module, exports) {
'use strict';

var $hqAuM = parcelRequire("hqAuM");
var $dc3830d40ab71c68$var$getDataIDsFromFragment = $hqAuM.getDataIDsFromFragment, $dc3830d40ab71c68$var$getSelector = $hqAuM.getSelector, $dc3830d40ab71c68$var$getVariablesFromFragment = $hqAuM.getVariablesFromFragment;

var $4XTUl = parcelRequire("4XTUl");

var $brVAm = parcelRequire("brVAm");

var $1B8Po = parcelRequire("1B8Po");

var $blaje = parcelRequire("blaje");
var $dc3830d40ab71c68$var$intern = $blaje.intern;
function $dc3830d40ab71c68$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $dc3830d40ab71c68$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $dc3830d40ab71c68$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $dc3830d40ab71c68$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($brVAm.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $brVAm.STRING_INTERN_LEVEL <= 1 ? ids : $dc3830d40ab71c68$var$intern(ids, $brVAm.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $4XTUl(fragmentVariables) ? '{}' : JSON.stringify($1B8Po(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $brVAm.STRING_INTERN_LEVEL <= 1 ? _ids : $dc3830d40ab71c68$var$intern(_ids, $brVAm.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($1B8Po(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $dc3830d40ab71c68$var$getFragmentIdentifier;

});
parcelRegister("4XTUl", function(module, exports) {
'use strict';
var $39d80a37c39acb2c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $39d80a37c39acb2c$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($39d80a37c39acb2c$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $39d80a37c39acb2c$var$isEmptyObject;

});


parcelRegister("edNjw", function(module, exports) {
'use strict';

var $gK5oo = parcelRequire("gK5oo");

var $aE1Lc = parcelRequire("aE1Lc");
function $02ac0232d78a1a86$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $gK5oo(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $aE1Lc(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $aE1Lc(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $aE1Lc(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $02ac0232d78a1a86$var$getPaginationMetadata;

});
parcelRegister("gK5oo", function(module, exports) {
'use strict';

var $aE1Lc = parcelRequire("aE1Lc");
function $c305200b262c9b7d$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $aE1Lc(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $aE1Lc(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $aE1Lc(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $aE1Lc(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $aE1Lc(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $c305200b262c9b7d$var$getRefetchMetadata;

});


parcelRegister("dVXVE", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $a24f15dcc56af141$var$_interopRequireDefault = $7gV6J.default;

var $a24f15dcc56af141$var$_defineProperty2 = $a24f15dcc56af141$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $a24f15dcc56af141$var$_objectSpread4 = $a24f15dcc56af141$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $aE1Lc = parcelRequire("aE1Lc");
parcelRequire("1srSR");
function $a24f15dcc56af141$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $aE1Lc(false);
        var _paginationVariables = (0, $a24f15dcc56af141$var$_objectSpread4["default"])((0, $a24f15dcc56af141$var$_objectSpread4["default"])((0, $a24f15dcc56af141$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $a24f15dcc56af141$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $a24f15dcc56af141$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $aE1Lc(false);
    var paginationVariables = (0, $a24f15dcc56af141$var$_objectSpread4["default"])((0, $a24f15dcc56af141$var$_objectSpread4["default"])((0, $a24f15dcc56af141$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $a24f15dcc56af141$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $a24f15dcc56af141$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $a24f15dcc56af141$var$getPaginationVariables;

});

parcelRegister("hCyoo", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $cd40a9e91fd33bc0$var$_interopRequireDefault = $7gV6J.default;

var $cd40a9e91fd33bc0$var$_createForOfIteratorHelper2 = $cd40a9e91fd33bc0$var$_interopRequireDefault((parcelRequire("8utPl")));

var $aE1Lc = parcelRequire("aE1Lc");
function $cd40a9e91fd33bc0$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $cd40a9e91fd33bc0$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $aE1Lc(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $aE1Lc(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $cd40a9e91fd33bc0$var$getValueAtPath;

});

parcelRegister("3Yhea", function(module, exports) {
'use strict';
var $2e4456b4bb260fd4$var$profileHandlersByName = {};
var $2e4456b4bb260fd4$var$defaultProfiler = {
    stop: function stop() {}
};
var $2e4456b4bb260fd4$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $2e4456b4bb260fd4$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $2e4456b4bb260fd4$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$2e4456b4bb260fd4$var$profileHandlersByName.hasOwnProperty(name)) $2e4456b4bb260fd4$var$profileHandlersByName[name] = [];
        $2e4456b4bb260fd4$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($2e4456b4bb260fd4$var$profileHandlersByName.hasOwnProperty(name)) $2e4456b4bb260fd4$var$removeFromArray($2e4456b4bb260fd4$var$profileHandlersByName[name], handler);
    }
};
function $2e4456b4bb260fd4$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $2e4456b4bb260fd4$var$RelayProfiler;

});




parcelRegister("l4ZFM", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $f589cf9f3b1f6777$var$_interopRequireDefault = $7gV6J.default;

var $f589cf9f3b1f6777$var$_extends2 = $f589cf9f3b1f6777$var$_interopRequireDefault((parcelRequire("cWDVE")));

var $f589cf9f3b1f6777$var$_objectWithoutPropertiesLoose2 = $f589cf9f3b1f6777$var$_interopRequireDefault((parcelRequire("7KAjS")));

var $f589cf9f3b1f6777$var$_assertThisInitialized2 = $f589cf9f3b1f6777$var$_interopRequireDefault((parcelRequire("j7t1u")));

var $f589cf9f3b1f6777$var$_inheritsLoose2 = $f589cf9f3b1f6777$var$_interopRequireDefault((parcelRequire("3fwIi")));

var $f589cf9f3b1f6777$var$_defineProperty2 = $f589cf9f3b1f6777$var$_interopRequireDefault((parcelRequire("2KFWS")));
var $f589cf9f3b1f6777$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $eYIdB = parcelRequire("eYIdB");

var $aJf0u = parcelRequire("aJf0u");
var $f589cf9f3b1f6777$var$getContainerName = $aJf0u.getContainerName;

var $gipEN = parcelRequire("gipEN");
var $f589cf9f3b1f6777$var$assertRelayContext = $gipEN.assertRelayContext;

var $9p5ca = parcelRequire("9p5ca");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $f589cf9f3b1f6777$var$createFragmentSpecResolver = $eiowN.createFragmentSpecResolver, $f589cf9f3b1f6777$var$getDataIDsFromObject = $eiowN.getDataIDsFromObject, $f589cf9f3b1f6777$var$isScalarAndEqual = $eiowN.isScalarAndEqual;
function $f589cf9f3b1f6777$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $f589cf9f3b1f6777$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $f589cf9f3b1f6777$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $f589cf9f3b1f6777$var$_defineProperty2["default"])((0, $f589cf9f3b1f6777$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $f589cf9f3b1f6777$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $f589cf9f3b1f6777$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $f589cf9f3b1f6777$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $f589cf9f3b1f6777$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $f589cf9f3b1f6777$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $f589cf9f3b1f6777$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $f589cf9f3b1f6777$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$9p5ca(prevIDs, nextIDs)) {
                resolver = $f589cf9f3b1f6777$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $f589cf9f3b1f6777$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $f589cf9f3b1f6777$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$f589cf9f3b1f6777$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $f589cf9f3b1f6777$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $f589cf9f3b1f6777$var$_excluded);
            return /*#__PURE__*/ $5uXOq.createElement(Component, (0, $f589cf9f3b1f6777$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($5uXOq.Component), (0, $f589cf9f3b1f6777$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $f589cf9f3b1f6777$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $f589cf9f3b1f6777$var$createContainer(Component, fragmentSpec) {
    return $eYIdB(Component, fragmentSpec, $f589cf9f3b1f6777$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $f589cf9f3b1f6777$var$createContainer
};

});
parcelRegister("eYIdB", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $ae78f81d61b9cc07$var$_interopRequireDefault = $7gV6J.default;

var $ae78f81d61b9cc07$var$_extends2 = $ae78f81d61b9cc07$var$_interopRequireDefault((parcelRequire("cWDVE")));

var $3xa87 = parcelRequire("3xa87");

var $aJf0u = parcelRequire("aJf0u");
var $ae78f81d61b9cc07$var$getComponentName = $aJf0u.getComponentName, $ae78f81d61b9cc07$var$getContainerName = $aJf0u.getContainerName;

var $9FY11 = parcelRequire("9FY11");

var $bW4Lx = parcelRequire("bW4Lx");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $ae78f81d61b9cc07$var$getFragment = $eiowN.getFragment;
var $ae78f81d61b9cc07$var$useContext = $5uXOq.useContext;
function $ae78f81d61b9cc07$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $ae78f81d61b9cc07$var$getContainerName(ComponentClass);
    $3xa87($ae78f81d61b9cc07$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $ae78f81d61b9cc07$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $ae78f81d61b9cc07$var$useContext($9FY11);
        !(context != null) && $aE1Lc(false);
        var queryRendererContext = $ae78f81d61b9cc07$var$useContext($bW4Lx);
        return /*#__PURE__*/ $5uXOq.createElement(Container, (0, $ae78f81d61b9cc07$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $5uXOq.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $ae78f81d61b9cc07$var$buildReactRelayContainer;

});
parcelRegister("3xa87", function(module, exports) {
'use strict';

var $aE1Lc = parcelRequire("aE1Lc");
function $292c4fc3185ae260$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $aE1Lc(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $aE1Lc(false);
    }
}
module.exports = $292c4fc3185ae260$var$assertFragmentMap;

});

parcelRegister("aJf0u", function(module, exports) {
'use strict';
function $7cf9bf629f644423$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $7cf9bf629f644423$var$getContainerName(Component) {
    return 'Relay(' + $7cf9bf629f644423$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $7cf9bf629f644423$var$getComponentName,
    getContainerName: $7cf9bf629f644423$var$getContainerName
};

});

parcelRegister("bW4Lx", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");
module.exports = $5uXOq.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("gipEN", function(module, exports) {
'use strict';

var $g8abf = parcelRequire("g8abf");

var $aE1Lc = parcelRequire("aE1Lc");
function $bdd23ab4d293b049$var$assertRelayContext(relay) {
    !$bdd23ab4d293b049$var$isRelayContext(relay) && $aE1Lc(false);
    return relay;
}
function $bdd23ab4d293b049$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $g8abf(context.environment);
}
module.exports = {
    assertRelayContext: $bdd23ab4d293b049$var$assertRelayContext,
    isRelayContext: $bdd23ab4d293b049$var$isRelayContext
};

});
parcelRegister("g8abf", function(module, exports) {
'use strict';
function $0307d3c7666f99e5$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $0307d3c7666f99e5$var$isRelayEnvironment;

});



parcelRegister("47DdV", function(module, exports) {
'use strict';

var $9FY11 = parcelRequire("9FY11");

var $bW4Lx = parcelRequire("bW4Lx");

var $9p5ca = parcelRequire("9p5ca");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $30063ddb163204cf$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $30063ddb163204cf$var$deepFreeze = $eiowN.deepFreeze, $30063ddb163204cf$var$getRequest = $eiowN.getRequest;
var $30063ddb163204cf$var$useLayoutEffect = $5uXOq.useLayoutEffect, $30063ddb163204cf$var$useState = $5uXOq.useState, $30063ddb163204cf$var$useRef = $5uXOq.useRef, $30063ddb163204cf$var$useMemo = $5uXOq.useMemo;
var $30063ddb163204cf$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $30063ddb163204cf$var$useDeepCompare(value) {
    var latestValue = $5uXOq.useRef(value);
    if (!$9p5ca(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $30063ddb163204cf$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $30063ddb163204cf$var$useDeepCompare(variables);
    var operation = $30063ddb163204cf$var$useMemo(function() {
        var request = $30063ddb163204cf$var$getRequest(query);
        return $30063ddb163204cf$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $30063ddb163204cf$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $30063ddb163204cf$var$useRef(null);
    var _useState = $30063ddb163204cf$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $30063ddb163204cf$var$useRef(null);
    var snapshot = $30063ddb163204cf$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $30063ddb163204cf$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($9FY11.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $5uXOq.createElement($bW4Lx.Provider, {
        value: $30063ddb163204cf$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $30063ddb163204cf$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("jaU96", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $df5a80dde20c4856$var$_interopRequireDefault = $7gV6J.default;

var $df5a80dde20c4856$var$_extends2 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("cWDVE")));

var $df5a80dde20c4856$var$_objectWithoutPropertiesLoose2 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("7KAjS")));

var $df5a80dde20c4856$var$_assertThisInitialized2 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("j7t1u")));

var $df5a80dde20c4856$var$_inheritsLoose2 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("3fwIi")));

var $df5a80dde20c4856$var$_defineProperty2 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $df5a80dde20c4856$var$_objectSpread3 = $df5a80dde20c4856$var$_interopRequireDefault((parcelRequire("fpQGd")));
var $df5a80dde20c4856$var$_excluded = [
    "componentRef"
], $df5a80dde20c4856$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $df5a80dde20c4856$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $eYIdB = parcelRequire("eYIdB");

var $cWKd1 = parcelRequire("cWKd1");

var $aJf0u = parcelRequire("aJf0u");
var $df5a80dde20c4856$var$getComponentName = $aJf0u.getComponentName, $df5a80dde20c4856$var$getContainerName = $aJf0u.getContainerName;

var $9FY11 = parcelRequire("9FY11");

var $3jGD1 = parcelRequire("3jGD1");

var $gipEN = parcelRequire("gipEN");
var $df5a80dde20c4856$var$assertRelayContext = $gipEN.assertRelayContext;

var $9p5ca = parcelRequire("9p5ca");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $df5a80dde20c4856$var$ConnectionInterface = $eiowN.ConnectionInterface, $df5a80dde20c4856$var$Observable = $eiowN.Observable, $df5a80dde20c4856$var$RelayFeatureFlags = $eiowN.RelayFeatureFlags, $df5a80dde20c4856$var$createFragmentSpecResolver = $eiowN.createFragmentSpecResolver, $df5a80dde20c4856$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $df5a80dde20c4856$var$getDataIDsFromObject = $eiowN.getDataIDsFromObject, $df5a80dde20c4856$var$getRequest = $eiowN.getRequest, $df5a80dde20c4856$var$getVariablesFromObject = $eiowN.getVariablesFromObject, $df5a80dde20c4856$var$isScalarAndEqual = $eiowN.isScalarAndEqual;
parcelRequire("1srSR");
var $df5a80dde20c4856$var$FORWARD = 'forward';
function $df5a80dde20c4856$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $aE1Lc(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $df5a80dde20c4856$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $aE1Lc(false);
    return function(prevVars, totalCount) {
        return (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, prevVars), {}, (0, $df5a80dde20c4856$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $df5a80dde20c4856$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $aE1Lc(false);
            !!foundConnectionMetadata && $aE1Lc(false);
            foundConnectionMetadata = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $aE1Lc(false);
    return foundConnectionMetadata || {};
}
function $df5a80dde20c4856$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $df5a80dde20c4856$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $df5a80dde20c4856$var$getComponentName(Component);
    var containerName = $df5a80dde20c4856$var$getContainerName(Component);
    var metadata = $df5a80dde20c4856$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $df5a80dde20c4856$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $aE1Lc(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $df5a80dde20c4856$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $df5a80dde20c4856$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $df5a80dde20c4856$var$_defineProperty2["default"])((0, $df5a80dde20c4856$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $df5a80dde20c4856$var$_defineProperty2["default"])((0, $df5a80dde20c4856$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $df5a80dde20c4856$var$_defineProperty2["default"])((0, $df5a80dde20c4856$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $df5a80dde20c4856$var$_defineProperty2["default"])((0, $df5a80dde20c4856$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $df5a80dde20c4856$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $df5a80dde20c4856$var$_defineProperty2["default"])((0, $df5a80dde20c4856$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $df5a80dde20c4856$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $df5a80dde20c4856$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $df5a80dde20c4856$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $df5a80dde20c4856$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($df5a80dde20c4856$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $df5a80dde20c4856$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $df5a80dde20c4856$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($df5a80dde20c4856$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($df5a80dde20c4856$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $df5a80dde20c4856$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $df5a80dde20c4856$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $df5a80dde20c4856$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $cWKd1(fragments, this.props);
            var nextRootVariables = $cWKd1(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$9p5ca(prevRootVariables, nextRootVariables) || !$9p5ca(prevIDs, nextIDs)) {
                this._cleanup();
                if ($df5a80dde20c4856$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $df5a80dde20c4856$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $df5a80dde20c4856$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$df5a80dde20c4856$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $df5a80dde20c4856$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $df5a80dde20c4856$var$_excluded);
            var props = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $df5a80dde20c4856$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $aE1Lc(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $aE1Lc(false);
            !(typeof pageInfo === 'object') && $aE1Lc(false);
            var hasMore = direction === $df5a80dde20c4856$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $df5a80dde20c4856$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $3jGD1();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $df5a80dde20c4856$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $df5a80dde20c4856$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $df5a80dde20c4856$var$_excluded2);
            var props = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $cWKd1(fragments, restProps);
            fragmentVariables = $df5a80dde20c4856$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $aE1Lc(false);
            fetchVariables = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $df5a80dde20c4856$var$_objectSpread3["default"])((0, $df5a80dde20c4856$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $df5a80dde20c4856$var$getRequest(connectionConfig.query);
            var operation = $df5a80dde20c4856$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$9p5ca(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $df5a80dde20c4856$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $df5a80dde20c4856$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $df5a80dde20c4856$var$_excluded3);
            return /*#__PURE__*/ $5uXOq.createElement($9FY11.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $5uXOq.createElement(Component, (0, $df5a80dde20c4856$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($5uXOq.Component), (0, $df5a80dde20c4856$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $df5a80dde20c4856$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $eYIdB(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $df5a80dde20c4856$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $df5a80dde20c4856$var$createContainer
};

});
parcelRegister("cWKd1", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $96cebefe0a25aa38$var$_interopRequireDefault = $7gV6J.default;

var $96cebefe0a25aa38$var$_objectSpread2 = $96cebefe0a25aa38$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $eiowN = parcelRequire("eiowN");
var $96cebefe0a25aa38$var$getSelector = $eiowN.getSelector;
function $96cebefe0a25aa38$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $96cebefe0a25aa38$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $96cebefe0a25aa38$var$_objectSpread2["default"])((0, $96cebefe0a25aa38$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $96cebefe0a25aa38$var$getRootVariablesForFragments;

});

parcelRegister("3jGD1", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $26a43689c82755e4$var$_interopRequireDefault = $7gV6J.default;

var $26a43689c82755e4$var$_defineProperty2 = $26a43689c82755e4$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $aE1Lc = parcelRequire("aE1Lc");

var $eiowN = parcelRequire("eiowN");
var $26a43689c82755e4$var$fetchQuery = $eiowN.__internal.fetchQuery, $26a43689c82755e4$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $26a43689c82755e4$var$isRelayModernEnvironment = $eiowN.isRelayModernEnvironment;
var $26a43689c82755e4$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $26a43689c82755e4$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $26a43689c82755e4$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$26a43689c82755e4$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $26a43689c82755e4$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $aE1Lc(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $26a43689c82755e4$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $aE1Lc(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $aE1Lc(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $26a43689c82755e4$var$ReactRelayQueryFetcher;

});


parcelRegister("7mpTt", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $55beac71dc8a6209$var$_interopRequireDefault = $7gV6J.default;

var $55beac71dc8a6209$var$_objectSpread2 = $55beac71dc8a6209$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $55beac71dc8a6209$var$_assertThisInitialized2 = $55beac71dc8a6209$var$_interopRequireDefault((parcelRequire("j7t1u")));

var $55beac71dc8a6209$var$_inheritsLoose2 = $55beac71dc8a6209$var$_interopRequireDefault((parcelRequire("3fwIi")));

var $55beac71dc8a6209$var$_defineProperty2 = $55beac71dc8a6209$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $9FY11 = parcelRequire("9FY11");

var $3jGD1 = parcelRequire("3jGD1");

var $bW4Lx = parcelRequire("bW4Lx");

var $9p5ca = parcelRequire("9p5ca");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $55beac71dc8a6209$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $55beac71dc8a6209$var$deepFreeze = $eiowN.deepFreeze, $55beac71dc8a6209$var$getRequest = $eiowN.getRequest;
var $55beac71dc8a6209$var$requestCache = {};
var $55beac71dc8a6209$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $55beac71dc8a6209$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $55beac71dc8a6209$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $55beac71dc8a6209$var$_defineProperty2["default"])((0, $55beac71dc8a6209$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $55beac71dc8a6209$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $55beac71dc8a6209$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $55beac71dc8a6209$var$getRequest(query);
            requestCacheKey = $55beac71dc8a6209$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $55beac71dc8a6209$var$requestCache[requestCacheKey] ? $55beac71dc8a6209$var$requestCache[requestCacheKey].queryFetcher : new $3jGD1();
        } else queryFetcher = new $3jGD1();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $55beac71dc8a6209$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $55beac71dc8a6209$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$9p5ca(prevState.prevPropsVariables, nextProps.variables)) return $55beac71dc8a6209$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $55beac71dc8a6209$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $55beac71dc8a6209$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $55beac71dc8a6209$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $55beac71dc8a6209$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $55beac71dc8a6209$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $55beac71dc8a6209$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $5uXOq.createElement($9FY11.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $5uXOq.createElement($bW4Lx.Provider, {
            value: $55beac71dc8a6209$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($5uXOq.Component);
function $55beac71dc8a6209$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $55beac71dc8a6209$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $55beac71dc8a6209$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $55beac71dc8a6209$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $55beac71dc8a6209$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $55beac71dc8a6209$var$getRequest(query);
        var requestCacheKey = $55beac71dc8a6209$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $55beac71dc8a6209$var$requestCache[requestCacheKey] ? $55beac71dc8a6209$var$requestCache[requestCacheKey].queryFetcher : new $3jGD1(prevSelectionReferences);
    } else queryFetcher = new $3jGD1(prevSelectionReferences);
    return (0, $55beac71dc8a6209$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $55beac71dc8a6209$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $55beac71dc8a6209$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $55beac71dc8a6209$var$getRequest(query);
        var operation = $55beac71dc8a6209$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $55beac71dc8a6209$var$requestCache[requestCacheKey]) {
            var snapshot = $55beac71dc8a6209$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $55beac71dc8a6209$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $55beac71dc8a6209$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $55beac71dc8a6209$var$getRequestCacheKey(request.params, props.variables);
            $55beac71dc8a6209$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $55beac71dc8a6209$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $55beac71dc8a6209$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $55beac71dc8a6209$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $55beac71dc8a6209$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $55beac71dc8a6209$var$ReactRelayQueryRenderer;

});

parcelRegister("aTIkl", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $7ef16cdf2b6d88a4$var$_interopRequireDefault = $7gV6J.default;

var $7ef16cdf2b6d88a4$var$_extends2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("cWDVE")));

var $7ef16cdf2b6d88a4$var$_objectWithoutPropertiesLoose2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("7KAjS")));

var $7ef16cdf2b6d88a4$var$_objectSpread2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $7ef16cdf2b6d88a4$var$_assertThisInitialized2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("j7t1u")));

var $7ef16cdf2b6d88a4$var$_inheritsLoose2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("3fwIi")));

var $7ef16cdf2b6d88a4$var$_defineProperty2 = $7ef16cdf2b6d88a4$var$_interopRequireDefault((parcelRequire("2KFWS")));
var $7ef16cdf2b6d88a4$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $eYIdB = parcelRequire("eYIdB");

var $cWKd1 = parcelRequire("cWKd1");

var $aJf0u = parcelRequire("aJf0u");
var $7ef16cdf2b6d88a4$var$getContainerName = $aJf0u.getContainerName;

var $9FY11 = parcelRequire("9FY11");

var $3jGD1 = parcelRequire("3jGD1");

var $gipEN = parcelRequire("gipEN");
var $7ef16cdf2b6d88a4$var$assertRelayContext = $gipEN.assertRelayContext;

var $9p5ca = parcelRequire("9p5ca");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $7ef16cdf2b6d88a4$var$Observable = $eiowN.Observable, $7ef16cdf2b6d88a4$var$createFragmentSpecResolver = $eiowN.createFragmentSpecResolver, $7ef16cdf2b6d88a4$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $7ef16cdf2b6d88a4$var$getDataIDsFromObject = $eiowN.getDataIDsFromObject, $7ef16cdf2b6d88a4$var$getRequest = $eiowN.getRequest, $7ef16cdf2b6d88a4$var$getVariablesFromObject = $eiowN.getVariablesFromObject, $7ef16cdf2b6d88a4$var$isScalarAndEqual = $eiowN.isScalarAndEqual;
parcelRequire("1srSR");
function $7ef16cdf2b6d88a4$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $7ef16cdf2b6d88a4$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $7ef16cdf2b6d88a4$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $7ef16cdf2b6d88a4$var$_defineProperty2["default"])((0, $7ef16cdf2b6d88a4$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $7ef16cdf2b6d88a4$var$_defineProperty2["default"])((0, $7ef16cdf2b6d88a4$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $7ef16cdf2b6d88a4$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $cWKd1(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])((0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])((0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $7ef16cdf2b6d88a4$var$getRequest(taggedNode);
                var operation = $7ef16cdf2b6d88a4$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $7ef16cdf2b6d88a4$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])((0, $7ef16cdf2b6d88a4$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $7ef16cdf2b6d88a4$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $7ef16cdf2b6d88a4$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $7ef16cdf2b6d88a4$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $7ef16cdf2b6d88a4$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $7ef16cdf2b6d88a4$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $7ef16cdf2b6d88a4$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $cWKd1(fragments, prevProps);
            var nextRootVariables = $cWKd1(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$9p5ca(prevRootVariables, nextRootVariables) || !$9p5ca(prevIDs, nextIDs)) {
                resolver = $7ef16cdf2b6d88a4$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $7ef16cdf2b6d88a4$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$7ef16cdf2b6d88a4$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $7ef16cdf2b6d88a4$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $3jGD1();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $7ef16cdf2b6d88a4$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $7ef16cdf2b6d88a4$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $5uXOq.createElement($9FY11.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $5uXOq.createElement(Component, (0, $7ef16cdf2b6d88a4$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($5uXOq.Component), (0, $7ef16cdf2b6d88a4$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $7ef16cdf2b6d88a4$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $7ef16cdf2b6d88a4$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $eYIdB(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $7ef16cdf2b6d88a4$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $7ef16cdf2b6d88a4$var$createContainer
};

});

parcelRegister("9YyJ0", function(module, exports) {
'use strict';

var $1auXT = parcelRequire("1auXT");

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");

var $5uXOq = parcelRequire("5uXOq");
var $01dfd1265522a99a$var$useContext = $5uXOq.useContext, $01dfd1265522a99a$var$useEffect = $5uXOq.useEffect;
parcelRequire("1srSR");
function $01dfd1265522a99a$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $01dfd1265522a99a$var$useContext($1auXT);
    var environment = $g3TRS();
    $01dfd1265522a99a$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $5uXOq.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $01dfd1265522a99a$var$EntryPointContainer;

});
parcelRegister("1auXT", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $0d9ebe9ee1e53119$var$ProfilerContext = $5uXOq.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $0d9ebe9ee1e53119$var$ProfilerContext;

});

parcelRegister("g3TRS", function(module, exports) {
'use strict';

var $9FY11 = parcelRequire("9FY11");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");
var $bb18436042a7199a$var$useContext = $5uXOq.useContext;
function $bb18436042a7199a$var$useRelayEnvironment() {
    var context = $bb18436042a7199a$var$useContext($9FY11);
    !(context != null) && $aE1Lc(false);
    return context.environment;
}
module.exports = $bb18436042a7199a$var$useRelayEnvironment;

});


parcelRegister("a6M7O", function(module, exports) {
'use strict';

var $aKraw = parcelRequire("aKraw");
var $75bfcb85c9c3bea8$var$loadQuery = $aKraw.loadQuery;
function $75bfcb85c9c3bea8$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var _queries$queryPropNam = queries[queryPropName], environmentProviderOptions = _queries$queryPropNam.environmentProviderOptions, options = _queries$queryPropNam.options, parameters = _queries$queryPropNam.parameters, variables = _queries$queryPropNam.variables;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $75bfcb85c9c3bea8$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $75bfcb85c9c3bea8$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $75bfcb85c9c3bea8$var$loadEntryPoint;

});
parcelRegister("aKraw", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $7d334660e1ac22cd$var$_interopRequireDefault = $7gV6J.default;

var $7d334660e1ac22cd$var$_objectSpread2 = $7d334660e1ac22cd$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $7d334660e1ac22cd$var$fetchQueryDeduped = $eiowN.__internal.fetchQueryDeduped, $7d334660e1ac22cd$var$Observable = $eiowN.Observable, $7d334660e1ac22cd$var$PreloadableQueryRegistry = $eiowN.PreloadableQueryRegistry, $7d334660e1ac22cd$var$RelayFeatureFlags = $eiowN.RelayFeatureFlags, $7d334660e1ac22cd$var$ReplaySubject = $eiowN.ReplaySubject, $7d334660e1ac22cd$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $7d334660e1ac22cd$var$getRequest = $eiowN.getRequest, $7d334660e1ac22cd$var$getRequestIdentifier = $eiowN.getRequestIdentifier;
parcelRequire("1srSR");
var $7d334660e1ac22cd$var$RenderDispatcher = null;
var $7d334660e1ac22cd$var$fetchKey = 100001;
function $7d334660e1ac22cd$var$useTrackLoadQueryInRender() {
    if ($7d334660e1ac22cd$var$RenderDispatcher === null) {
        var _React$__SECRET_INTER, _React$__SECRET_INTER2;
        $7d334660e1ac22cd$var$RenderDispatcher = (_React$__SECRET_INTER = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER === void 0 ? void 0 : (_React$__SECRET_INTER2 = _React$__SECRET_INTER.ReactCurrentDispatcher) === null || _React$__SECRET_INTER2 === void 0 ? void 0 : _React$__SECRET_INTER2.current;
    }
}
function $7d334660e1ac22cd$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _React$__SECRET_INTER3, _React$__SECRET_INTER4, _options$__nameForWar, _options$fetchPolicy;
    var CurrentDispatcher = (_React$__SECRET_INTER3 = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React$__SECRET_INTER3 === void 0 ? void 0 : (_React$__SECRET_INTER4 = _React$__SECRET_INTER3.ReactCurrentDispatcher) === null || _React$__SECRET_INTER4 === void 0 ? void 0 : _React$__SECRET_INTER4.current;
    $7d334660e1ac22cd$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $7d334660e1ac22cd$var$_objectSpread2["default"])((0, $7d334660e1ac22cd$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $7d334660e1ac22cd$var$ReplaySubject();
    var returnedObservable = $7d334660e1ac22cd$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params) {
        didMakeNetworkRequest = true;
        var observable;
        var subject = new $7d334660e1ac22cd$var$ReplaySubject();
        if ($7d334660e1ac22cd$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) {
            var identifier = 'raw-network-request-' + $7d334660e1ac22cd$var$getRequestIdentifier(params, variables);
            observable = $7d334660e1ac22cd$var$fetchQueryDeduped(environment, identifier, function() {
                var network = environment.getNetwork();
                return network.execute(params, variables, networkCacheConfig);
            });
        } else {
            var network = environment.getNetwork();
            observable = network.execute(params, variables, networkCacheConfig);
        }
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $7d334660e1ac22cd$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        if ($7d334660e1ac22cd$var$RelayFeatureFlags.ENABLE_LOAD_QUERY_REQUEST_DEDUPING === true) didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $7d334660e1ac22cd$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $7d334660e1ac22cd$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params);
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $aE1Lc(false);
        var _module = $7d334660e1ac22cd$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $7d334660e1ac22cd$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $7d334660e1ac22cd$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $7d334660e1ac22cd$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $7d334660e1ac22cd$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $7d334660e1ac22cd$var$loadQuery,
    useTrackLoadQueryInRender: $7d334660e1ac22cd$var$useTrackLoadQueryInRender
};

});


parcelRegister("GBSe8", function(module, exports) {
'use strict';

var $9FY11 = parcelRequire("9FY11");

var $5uXOq = parcelRequire("5uXOq");
var $08014d45be7bb613$var$useMemo = $5uXOq.useMemo;
function $08014d45be7bb613$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $08014d45be7bb613$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($9FY11.Provider, {
        value: context
    }, children);
}
module.exports = $08014d45be7bb613$var$RelayEnvironmentProvider;

});

parcelRegister("couvJ", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $905f64c26ce0c28f$var$_interopRequireDefault = $7gV6J.default;

var $905f64c26ce0c28f$var$_objectSpread2 = $905f64c26ce0c28f$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $ITbUa = parcelRequire("ITbUa");
function $905f64c26ce0c28f$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $ITbUa(query, variables, (0, $905f64c26ce0c28f$var$_objectSpread2["default"])((0, $905f64c26ce0c28f$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $905f64c26ce0c28f$var$useClientQuery;

});
parcelRegister("ITbUa", function(module, exports) {
'use strict';

var $aKraw = parcelRequire("aKraw");
var $086eebf626ae3350$var$useTrackLoadQueryInRender = $aKraw.useTrackLoadQueryInRender;

var $eeLcT = parcelRequire("eeLcT");

var $hM7AQ = parcelRequire("hM7AQ");

var $g3TRS = parcelRequire("g3TRS");

var $eiowN = parcelRequire("eiowN");
var $086eebf626ae3350$var$fetchQuery = $eiowN.__internal.fetchQuery;
function $086eebf626ae3350$var$useLazyLoadQuery(gqlQuery, variables, options) {
    $086eebf626ae3350$var$useTrackLoadQueryInRender();
    var environment = $g3TRS();
    var query = $hM7AQ(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $eeLcT({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $086eebf626ae3350$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $086eebf626ae3350$var$useLazyLoadQuery;

});
parcelRegister("eeLcT", function(module, exports) {
'use strict';

var $1auXT = parcelRequire("1auXT");

var $jeBnt = parcelRequire("jeBnt");
var $a5d6fdd66c77dcfa$var$getQueryCacheIdentifier = $jeBnt.getQueryCacheIdentifier, $a5d6fdd66c77dcfa$var$getQueryResourceForEnvironment = $jeBnt.getQueryResourceForEnvironment;

var $m9jvG = parcelRequire("m9jvG");

var $1kheK = parcelRequire("1kheK");

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");
var $a5d6fdd66c77dcfa$var$useContext = $5uXOq.useContext, $a5d6fdd66c77dcfa$var$useEffect = $5uXOq.useEffect, $a5d6fdd66c77dcfa$var$useState = $5uXOq.useState, $a5d6fdd66c77dcfa$var$useRef = $5uXOq.useRef;
function $a5d6fdd66c77dcfa$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $g3TRS();
    var profilerContext = $a5d6fdd66c77dcfa$var$useContext($1auXT);
    var QueryResource = $a5d6fdd66c77dcfa$var$getQueryResourceForEnvironment(environment);
    var _useState = $a5d6fdd66c77dcfa$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $m9jvG(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $a5d6fdd66c77dcfa$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $a5d6fdd66c77dcfa$var$useRef(false);
    $a5d6fdd66c77dcfa$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $a5d6fdd66c77dcfa$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $a5d6fdd66c77dcfa$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $1kheK(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $a5d6fdd66c77dcfa$var$useLazyLoadQueryNode;

});
parcelRegister("jeBnt", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $e00c519031e66c30$var$_interopRequireDefault = $7gV6J.default;

var $e00c519031e66c30$var$_objectSpread2 = $e00c519031e66c30$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $e00c519031e66c30$var$_defineProperty2 = $e00c519031e66c30$var$_interopRequireDefault((parcelRequire("2KFWS")));

var $dwbTw = parcelRequire("dwbTw");

var $gWetK = parcelRequire("gWetK");

var $aE1Lc = parcelRequire("aE1Lc");

var $eiowN = parcelRequire("eiowN");
var $e00c519031e66c30$var$isPromise = $eiowN.isPromise;
parcelRequire("1srSR");
var $e00c519031e66c30$var$CACHE_CAPACITY = 1000;
var $e00c519031e66c30$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $e00c519031e66c30$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $e00c519031e66c30$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $e00c519031e66c30$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $e00c519031e66c30$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $e00c519031e66c30$var$operationIsLiveQuery(operation) ? $e00c519031e66c30$var$DEFAULT_LIVE_FETCH_POLICY : $e00c519031e66c30$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $e00c519031e66c30$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $e00c519031e66c30$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $e00c519031e66c30$var$nextID = 200000;
function $e00c519031e66c30$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $e00c519031e66c30$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $gWetK(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $e00c519031e66c30$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $e00c519031e66c30$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $e00c519031e66c30$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $dwbTw.create($e00c519031e66c30$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $e00c519031e66c30$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $e00c519031e66c30$var$operationIsLiveQuery(operation) ? $e00c519031e66c30$var$DEFAULT_LIVE_FETCH_POLICY : $e00c519031e66c30$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $e00c519031e66c30$var$_objectSpread2["default"])((0, $e00c519031e66c30$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($e00c519031e66c30$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $e00c519031e66c30$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $e00c519031e66c30$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $e00c519031e66c30$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $e00c519031e66c30$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $e00c519031e66c30$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $e00c519031e66c30$var$_objectSpread2["default"])((0, $e00c519031e66c30$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($e00c519031e66c30$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $e00c519031e66c30$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $aE1Lc(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $e00c519031e66c30$var$createQueryResource(environment) {
    return new $e00c519031e66c30$var$QueryResourceImpl(environment);
}
var $e00c519031e66c30$var$dataResources = $e00c519031e66c30$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $e00c519031e66c30$var$getQueryResourceForEnvironment(environment) {
    var cached = $e00c519031e66c30$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $e00c519031e66c30$var$createQueryResource(environment);
    $e00c519031e66c30$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $e00c519031e66c30$var$createQueryResource,
    getQueryResourceForEnvironment: $e00c519031e66c30$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $e00c519031e66c30$var$getQueryCacheIdentifier
};

});
parcelRegister("dwbTw", function(module, exports) {
'use strict';

var $aE1Lc = parcelRequire("aE1Lc");
var $9d777d8190b73bdb$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $aE1Lc(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $9d777d8190b73bdb$var$create(capacity) {
    return new $9d777d8190b73bdb$var$LRUCache(capacity);
}
module.exports = {
    create: $9d777d8190b73bdb$var$create
};

});

parcelRegister("gWetK", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $c54d4b4de022af85$var$_interopRequireDefault = $7gV6J.default;

var $c54d4b4de022af85$var$_defineProperty2 = $c54d4b4de022af85$var$_interopRequireDefault((parcelRequire("2KFWS")));
parcelRequire("1srSR");
var $c54d4b4de022af85$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $c54d4b4de022af85$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $c54d4b4de022af85$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $c54d4b4de022af85$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $c54d4b4de022af85$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $c54d4b4de022af85$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $c54d4b4de022af85$var$SuspenseResource;

});


parcelRegister("m9jvG", function(module, exports) {
'use strict';

var $1AZCH = parcelRequire("1AZCH");

var $5uXOq = parcelRequire("5uXOq");
var $042947b0f4ad8868$var$useCallback = $5uXOq.useCallback, $042947b0f4ad8868$var$useEffect = $5uXOq.useEffect;
function $042947b0f4ad8868$var$useFetchTrackingRef() {
    var subscriptionRef = $1AZCH(null);
    var isFetchingRef = $1AZCH(false);
    var disposeFetch = $042947b0f4ad8868$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $042947b0f4ad8868$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $042947b0f4ad8868$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $042947b0f4ad8868$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $042947b0f4ad8868$var$useFetchTrackingRef;

});
parcelRegister("1AZCH", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $1298f44f6d049271$var$useMemo = $5uXOq.useMemo;
function $1298f44f6d049271$var$useUnsafeRef_DEPRECATED(init) {
    return $1298f44f6d049271$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $1298f44f6d049271$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("1kheK", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $0f75078fbb1737f9$var$_interopRequireDefault = $7gV6J.default;

var $0f75078fbb1737f9$var$_objectSpread2 = $0f75078fbb1737f9$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $0f75078fbb1737f9$var$_createForOfIteratorHelper2 = $0f75078fbb1737f9$var$_interopRequireDefault((parcelRequire("8utPl")));

var $0f75078fbb1737f9$var$_toConsumableArray2 = $0f75078fbb1737f9$var$_interopRequireDefault((parcelRequire("Dlo3s")));

var $jeBnt = parcelRequire("jeBnt");
var $0f75078fbb1737f9$var$getQueryResourceForEnvironment = $jeBnt.getQueryResourceForEnvironment;

var $g3TRS = parcelRequire("g3TRS");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");
var $0f75078fbb1737f9$var$useDebugValue = $5uXOq.useDebugValue, $0f75078fbb1737f9$var$useEffect = $5uXOq.useEffect, $0f75078fbb1737f9$var$useMemo = $5uXOq.useMemo, $0f75078fbb1737f9$var$useRef = $5uXOq.useRef, $0f75078fbb1737f9$var$useState = $5uXOq.useState;

var $eiowN = parcelRequire("eiowN");
var $0f75078fbb1737f9$var$_require3$__internal = $eiowN.__internal, $0f75078fbb1737f9$var$fetchQueryInternal = $0f75078fbb1737f9$var$_require3$__internal.fetchQuery, $0f75078fbb1737f9$var$getPromiseForActiveRequest = $0f75078fbb1737f9$var$_require3$__internal.getPromiseForActiveRequest, $0f75078fbb1737f9$var$RelayFeatureFlags = $eiowN.RelayFeatureFlags, $0f75078fbb1737f9$var$areEqualSelectors = $eiowN.areEqualSelectors, $0f75078fbb1737f9$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $0f75078fbb1737f9$var$getPendingOperationsForFragment = $eiowN.getPendingOperationsForFragment, $0f75078fbb1737f9$var$getSelector = $eiowN.getSelector, $0f75078fbb1737f9$var$getVariablesFromFragment = $eiowN.getVariablesFromFragment, $0f75078fbb1737f9$var$handlePotentialSnapshotErrors = $eiowN.handlePotentialSnapshotErrors, $0f75078fbb1737f9$var$recycleNodesInto = $eiowN.recycleNodesInto;
parcelRequire("1srSR");
function $0f75078fbb1737f9$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $0f75078fbb1737f9$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $0f75078fbb1737f9$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $0f75078fbb1737f9$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $0f75078fbb1737f9$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator5 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step5.value;
                $0f75078fbb1737f9$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $0f75078fbb1737f9$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $0f75078fbb1737f9$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            missingRequiredFields: currentSnapshot.missingRequiredFields,
            relayResolverErrors: currentSnapshot.relayResolverErrors,
            errorResponseFields: currentSnapshot.errorResponseFields
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $0f75078fbb1737f9$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                missingRequiredFields: _currentSnapshot.missingRequiredFields,
                relayResolverErrors: _currentSnapshot.relayResolverErrors,
                errorResponseFields: _currentSnapshot.errorResponseFields
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $aE1Lc(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $0f75078fbb1737f9$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $0f75078fbb1737f9$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $0f75078fbb1737f9$var$_objectSpread2["default"])((0, $0f75078fbb1737f9$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $0f75078fbb1737f9$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $0f75078fbb1737f9$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $0f75078fbb1737f9$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $0f75078fbb1737f9$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $0f75078fbb1737f9$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $0f75078fbb1737f9$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $0f75078fbb1737f9$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $0f75078fbb1737f9$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $0f75078fbb1737f9$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $0f75078fbb1737f9$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $0f75078fbb1737f9$var$useMemo(function() {
        return $0f75078fbb1737f9$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $aE1Lc(false);
    else !!Array.isArray(fragmentRef) && $aE1Lc(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $aE1Lc(false);
    var environment = $g3TRS();
    var _useState = $0f75078fbb1737f9$var$useState(function() {
        return $0f75078fbb1737f9$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $0f75078fbb1737f9$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $0f75078fbb1737f9$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $0f75078fbb1737f9$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$0f75078fbb1737f9$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $0f75078fbb1737f9$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $0f75078fbb1737f9$var$useRef(false);
    $0f75078fbb1737f9$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var _useMemo = $0f75078fbb1737f9$var$useMemo(function() {
            var missingClientEdges = $0f75078fbb1737f9$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $0f75078fbb1737f9$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $0f75078fbb1737f9$var$useEffect(function() {
            var QueryResource = $0f75078fbb1737f9$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    var _iterator9 = (0, $0f75078fbb1737f9$var$_createForOfIteratorHelper2["default"])(disposables), _step9;
                    try {
                        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                            var disposable = _step9.value;
                            disposable.dispose();
                        }
                    } catch (err) {
                        _iterator9.e(err);
                    } finally{
                        _iterator9.f();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($0f75078fbb1737f9$var$isMissingData(state)) {
        var suspendingLiveResolvers = $0f75078fbb1737f9$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(_ref) {
            var liveStateID = _ref.liveStateID;
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($0f75078fbb1737f9$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$0f75078fbb1737f9$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $aE1Lc(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $0f75078fbb1737f9$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $0f75078fbb1737f9$var$handlePotentialSnapshotErrorsForState(environment, state);
    var hasPendingStateChanges = $0f75078fbb1737f9$var$useRef(false);
    $0f75078fbb1737f9$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $0f75078fbb1737f9$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $0f75078fbb1737f9$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $0f75078fbb1737f9$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $0f75078fbb1737f9$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $aE1Lc(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $aE1Lc(false);
        data = state.snapshot.data;
    }
    if ($0f75078fbb1737f9$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $0f75078fbb1737f9$var$useFragmentInternal;

});


parcelRegister("hM7AQ", function(module, exports) {
'use strict';

var $44Sep = parcelRequire("44Sep");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $cf0ccf37835f4b37$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $cf0ccf37835f4b37$var$getRequest = $eiowN.getRequest;
var $cf0ccf37835f4b37$var$useMemo = $5uXOq.useMemo;
function $cf0ccf37835f4b37$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $44Sep(variables);
    var memoCacheConfig = $44Sep(cacheConfig || {});
    return $cf0ccf37835f4b37$var$useMemo(function() {
        return $cf0ccf37835f4b37$var$createOperationDescriptor($cf0ccf37835f4b37$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $cf0ccf37835f4b37$var$useMemoOperationDescriptor;

});
parcelRegister("44Sep", function(module, exports) {
'use strict';

var $9p5ca = parcelRequire("9p5ca");

var $5uXOq = parcelRequire("5uXOq");
var $2f819a5f9c77bb3b$var$useState = $5uXOq.useState;
function $2f819a5f9c77bb3b$var$useMemoVariables(variables) {
    var _useState = $2f819a5f9c77bb3b$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($9p5ca(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $2f819a5f9c77bb3b$var$useMemoVariables;

});




parcelRegister("8fqWB", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $60149fff5f785f13$var$_interopRequireDefault = $7gV6J.default;

var $60149fff5f785f13$var$_createForOfIteratorHelper2 = $60149fff5f785f13$var$_interopRequireDefault((parcelRequire("8utPl")));

var $a6M7O = parcelRequire("a6M7O");

var $aKraw = parcelRequire("aKraw");
var $60149fff5f785f13$var$useTrackLoadQueryInRender = $aKraw.useTrackLoadQueryInRender;

var $4Rylk = parcelRequire("4Rylk");

var $5uXOq = parcelRequire("5uXOq");
var $60149fff5f785f13$var$useCallback = $5uXOq.useCallback, $60149fff5f785f13$var$useEffect = $5uXOq.useEffect, $60149fff5f785f13$var$useRef = $5uXOq.useRef, $60149fff5f785f13$var$useState = $5uXOq.useState;
var $60149fff5f785f13$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $60149fff5f785f13$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    $60149fff5f785f13$var$useTrackLoadQueryInRender();
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $60149fff5f785f13$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $4Rylk();
    var undisposedEntryPointReferencesRef = $60149fff5f785f13$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $60149fff5f785f13$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $60149fff5f785f13$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $60149fff5f785f13$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $60149fff5f785f13$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $a6M7O(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $60149fff5f785f13$var$useRef(false);
    $60149fff5f785f13$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $60149fff5f785f13$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $60149fff5f785f13$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $60149fff5f785f13$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $60149fff5f785f13$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $60149fff5f785f13$var$useLoadEntryPoint;

});
parcelRegister("4Rylk", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $38a6c07c62949a22$var$useEffect = $5uXOq.useEffect, $38a6c07c62949a22$var$useRef = $5uXOq.useRef;
function $38a6c07c62949a22$var$useIsMountedRef() {
    var isMountedRef = $38a6c07c62949a22$var$useRef(true);
    $38a6c07c62949a22$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $38a6c07c62949a22$var$useIsMountedRef;

});


parcelRegister("eofgg", function(module, exports) {
'use strict';

var $aKraw = parcelRequire("aKraw");
var $a79f2526eda58359$var$useTrackLoadQueryInRender = $aKraw.useTrackLoadQueryInRender;

var $1kheK = parcelRequire("1kheK");

var $as8Ho = parcelRequire("as8Ho");

var $5uXOq = parcelRequire("5uXOq");
var $a79f2526eda58359$var$useDebugValue = $5uXOq.useDebugValue;

var $eiowN = parcelRequire("eiowN");
var $a79f2526eda58359$var$getFragment = $eiowN.getFragment;
function $a79f2526eda58359$var$useFragment(fragment, key) {
    $a79f2526eda58359$var$useTrackLoadQueryInRender();
    var fragmentNode = $a79f2526eda58359$var$getFragment(fragment);
    $as8Ho(fragmentNode, 'first argument of useFragment()');
    var data = $1kheK(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $a79f2526eda58359$var$useFragment;

});
parcelRegister("as8Ho", function(module, exports) {
'use strict';
parcelRequire("1AZCH");
parcelRequire("1srSR");
function $79c344503bf8c477$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $79c344503bf8c477$var$useStaticFragmentNodeWarning;

});


parcelRegister("667zR", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $47092e4e7962ddc6$var$_interopRequireDefault = $7gV6J.default;

var $47092e4e7962ddc6$var$_objectSpread2 = $47092e4e7962ddc6$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $4Rylk = parcelRequire("4Rylk");

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $47092e4e7962ddc6$var$defaultCommitMutation = $eiowN.commitMutation;
var $47092e4e7962ddc6$var$useState = $5uXOq.useState, $47092e4e7962ddc6$var$useEffect = $5uXOq.useEffect, $47092e4e7962ddc6$var$useRef = $5uXOq.useRef, $47092e4e7962ddc6$var$useCallback = $5uXOq.useCallback;
function $47092e4e7962ddc6$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $47092e4e7962ddc6$var$defaultCommitMutation;
    var environment = $g3TRS();
    var isMountedRef = $4Rylk();
    var environmentRef = $47092e4e7962ddc6$var$useRef(environment);
    var mutationRef = $47092e4e7962ddc6$var$useRef(mutation);
    var inFlightMutationsRef = $47092e4e7962ddc6$var$useRef(new Set());
    var _useState = $47092e4e7962ddc6$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $47092e4e7962ddc6$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $47092e4e7962ddc6$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $47092e4e7962ddc6$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $47092e4e7962ddc6$var$_objectSpread2["default"])((0, $47092e4e7962ddc6$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $47092e4e7962ddc6$var$useMutation;

});

parcelRegister("jZlQN", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $e8d4a9e36a88d0de$var$_interopRequireDefault = $7gV6J.default;

var $e8d4a9e36a88d0de$var$_objectSpread2 = $e8d4a9e36a88d0de$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $jIyyc = parcelRequire("jIyyc");

var $hq8PP = parcelRequire("hq8PP");

var $g3TRS = parcelRequire("g3TRS");

var $as8Ho = parcelRequire("as8Ho");

var $5uXOq = parcelRequire("5uXOq");
var $e8d4a9e36a88d0de$var$useCallback = $5uXOq.useCallback, $e8d4a9e36a88d0de$var$useDebugValue = $5uXOq.useDebugValue, $e8d4a9e36a88d0de$var$useState = $5uXOq.useState;

var $eiowN = parcelRequire("eiowN");
var $e8d4a9e36a88d0de$var$getFragment = $eiowN.getFragment, $e8d4a9e36a88d0de$var$getFragmentIdentifier = $eiowN.getFragmentIdentifier, $e8d4a9e36a88d0de$var$getPaginationMetadata = $eiowN.getPaginationMetadata;
function $e8d4a9e36a88d0de$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $e8d4a9e36a88d0de$var$getFragment(fragmentInput);
    $as8Ho(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $e8d4a9e36a88d0de$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $hq8PP(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $e8d4a9e36a88d0de$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $e8d4a9e36a88d0de$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $e8d4a9e36a88d0de$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $e8d4a9e36a88d0de$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $e8d4a9e36a88d0de$var$_objectSpread2["default"])((0, $e8d4a9e36a88d0de$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $e8d4a9e36a88d0de$var$useLoadMore(args) {
    var environment = $g3TRS();
    var _useState = $e8d4a9e36a88d0de$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        }
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $jIyyc((0, $e8d4a9e36a88d0de$var$_objectSpread2["default"])((0, $e8d4a9e36a88d0de$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $e8d4a9e36a88d0de$var$usePaginationFragment;

});
parcelRegister("jIyyc", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $e5aced652b09303b$var$_interopRequireDefault = $7gV6J.default;

var $e5aced652b09303b$var$_objectSpread2 = $e5aced652b09303b$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $m9jvG = parcelRequire("m9jvG");

var $4Rylk = parcelRequire("4Rylk");

var $fDS37 = parcelRequire("fDS37");

var $g3TRS = parcelRequire("g3TRS");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");
var $e5aced652b09303b$var$useCallback = $5uXOq.useCallback, $e5aced652b09303b$var$useEffect = $5uXOq.useEffect, $e5aced652b09303b$var$useState = $5uXOq.useState;

var $eiowN = parcelRequire("eiowN");
var $e5aced652b09303b$var$fetchQuery = $eiowN.__internal.fetchQuery, $e5aced652b09303b$var$ConnectionInterface = $eiowN.ConnectionInterface, $e5aced652b09303b$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $e5aced652b09303b$var$getPaginationVariables = $eiowN.getPaginationVariables, $e5aced652b09303b$var$getRefetchMetadata = $eiowN.getRefetchMetadata, $e5aced652b09303b$var$getSelector = $eiowN.getSelector, $e5aced652b09303b$var$getValueAtPath = $eiowN.getValueAtPath;
parcelRequire("1srSR");
function $e5aced652b09303b$var$useLoadMoreFunction(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $g3TRS();
    var _useFetchTrackingRef = $m9jvG(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $e5aced652b09303b$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $4Rylk();
    var _useState = $e5aced652b09303b$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $e5aced652b09303b$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $fDS37(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $e5aced652b09303b$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $e5aced652b09303b$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var loadMore = $e5aced652b09303b$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $e5aced652b09303b$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || fragmentData == null || isParentQueryActive) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $aE1Lc(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $e5aced652b09303b$var$_objectSpread2["default"])((0, $e5aced652b09303b$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $e5aced652b09303b$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $e5aced652b09303b$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $e5aced652b09303b$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $e5aced652b09303b$var$fetchQuery(environment, paginationQuery).subscribe((0, $e5aced652b09303b$var$_objectSpread2["default"])((0, $e5aced652b09303b$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isParentQueryActive,
        fragmentData,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
function $e5aced652b09303b$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $e5aced652b09303b$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $e5aced652b09303b$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $aE1Lc(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $aE1Lc(false);
    !(typeof pageInfo === 'object') && $aE1Lc(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $aE1Lc(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $e5aced652b09303b$var$useLoadMoreFunction;

});
parcelRegister("fDS37", function(module, exports) {
'use strict';

var $g3TRS = parcelRequire("g3TRS");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");
var $b6346c9d3444fc79$var$getObservableForActiveRequest = $eiowN.__internal.getObservableForActiveRequest, $b6346c9d3444fc79$var$getSelector = $eiowN.getSelector;
var $b6346c9d3444fc79$var$useEffect = $5uXOq.useEffect, $b6346c9d3444fc79$var$useState = $5uXOq.useState, $b6346c9d3444fc79$var$useMemo = $5uXOq.useMemo;
function $b6346c9d3444fc79$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $g3TRS();
    var observable = $b6346c9d3444fc79$var$useMemo(function() {
        var selector = $b6346c9d3444fc79$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $aE1Lc(false);
        return $b6346c9d3444fc79$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $b6346c9d3444fc79$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $b6346c9d3444fc79$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $b6346c9d3444fc79$var$useIsOperationNodeActive;

});


parcelRegister("hq8PP", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $caebb7ce5ff8ad3c$var$_interopRequireDefault = $7gV6J.default;

var $caebb7ce5ff8ad3c$var$_objectSpread2 = $caebb7ce5ff8ad3c$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $1auXT = parcelRequire("1auXT");

var $jeBnt = parcelRequire("jeBnt");
var $caebb7ce5ff8ad3c$var$getQueryResourceForEnvironment = $jeBnt.getQueryResourceForEnvironment;

var $jffhO = parcelRequire("jffhO");

var $1kheK = parcelRequire("1kheK");

var $4Rylk = parcelRequire("4Rylk");

var $6FDcO = parcelRequire("6FDcO");

var $g3TRS = parcelRequire("g3TRS");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");
var $caebb7ce5ff8ad3c$var$useCallback = $5uXOq.useCallback, $caebb7ce5ff8ad3c$var$useContext = $5uXOq.useContext, $caebb7ce5ff8ad3c$var$useReducer = $5uXOq.useReducer;

var $eiowN = parcelRequire("eiowN");
var $caebb7ce5ff8ad3c$var$fetchQuery = $eiowN.__internal.fetchQuery, $caebb7ce5ff8ad3c$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $caebb7ce5ff8ad3c$var$getFragmentIdentifier = $eiowN.getFragmentIdentifier, $caebb7ce5ff8ad3c$var$getRefetchMetadata = $eiowN.getRefetchMetadata, $caebb7ce5ff8ad3c$var$getSelector = $eiowN.getSelector, $caebb7ce5ff8ad3c$var$getValueAtPath = $eiowN.getValueAtPath;
parcelRequire("1srSR");
function $caebb7ce5ff8ad3c$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $caebb7ce5ff8ad3c$var$_objectSpread2["default"])((0, $caebb7ce5ff8ad3c$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $caebb7ce5ff8ad3c$var$useRefetchableFragmentNode(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $g3TRS();
    var _getRefetchMetadata = $caebb7ce5ff8ad3c$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $caebb7ce5ff8ad3c$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $caebb7ce5ff8ad3c$var$useReducer($caebb7ce5ff8ad3c$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $caebb7ce5ff8ad3c$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $caebb7ce5ff8ad3c$var$useContext($1auXT);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $6FDcO(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $caebb7ce5ff8ad3c$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $jffhO(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $aE1Lc(false);
        var refetchedFragmentRef = $caebb7ce5ff8ad3c$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $1kheK(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $caebb7ce5ff8ad3c$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $caebb7ce5ff8ad3c$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $4Rylk();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $caebb7ce5ff8ad3c$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $caebb7ce5ff8ad3c$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $caebb7ce5ff8ad3c$var$_objectSpread2["default"])((0, $caebb7ce5ff8ad3c$var$_objectSpread2["default"])((0, $caebb7ce5ff8ad3c$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $caebb7ce5ff8ad3c$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $caebb7ce5ff8ad3c$var$debugFunctions;
module.exports = $caebb7ce5ff8ad3c$var$useRefetchableFragmentNode;

});
parcelRegister("jffhO", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $e02b4690ccc1155c$var$_interopRequireDefault = $7gV6J.default;

var $e02b4690ccc1155c$var$_objectSpread2 = $e02b4690ccc1155c$var$_interopRequireDefault((parcelRequire("fpQGd")));

var $e02b4690ccc1155c$var$_createForOfIteratorHelper2 = $e02b4690ccc1155c$var$_interopRequireDefault((parcelRequire("8utPl")));

var $jeBnt = parcelRequire("jeBnt");
var $e02b4690ccc1155c$var$getQueryResourceForEnvironment = $jeBnt.getQueryResourceForEnvironment;

var $aE1Lc = parcelRequire("aE1Lc");

var $eiowN = parcelRequire("eiowN");
var $e02b4690ccc1155c$var$fetchQueryInternal = $eiowN.__internal.fetchQuery, $e02b4690ccc1155c$var$RelayFeatureFlags = $eiowN.RelayFeatureFlags, $e02b4690ccc1155c$var$createOperationDescriptor = $eiowN.createOperationDescriptor, $e02b4690ccc1155c$var$getPendingOperationsForFragment = $eiowN.getPendingOperationsForFragment, $e02b4690ccc1155c$var$getSelector = $eiowN.getSelector, $e02b4690ccc1155c$var$getVariablesFromFragment = $eiowN.getVariablesFromFragment, $e02b4690ccc1155c$var$handlePotentialSnapshotErrors = $eiowN.handlePotentialSnapshotErrors;
parcelRequire("1srSR");
function $e02b4690ccc1155c$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $e02b4690ccc1155c$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $e02b4690ccc1155c$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $e02b4690ccc1155c$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $e02b4690ccc1155c$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') {
        var _state$snapshot$selec, _state$snapshot$selec2;
        $e02b4690ccc1155c$var$handlePotentialSnapshotErrors(environment, state.snapshot.missingRequiredFields, state.snapshot.relayResolverErrors, state.snapshot.errorResponseFields, (_state$snapshot$selec = (_state$snapshot$selec2 = state.snapshot.selector.node.metadata) === null || _state$snapshot$selec2 === void 0 ? void 0 : _state$snapshot$selec2.throwOnFieldError) !== null && _state$snapshot$selec !== void 0 ? _state$snapshot$selec : false);
    } else if (state.kind === 'plural') {
        var _iterator3 = (0, $e02b4690ccc1155c$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _snapshot$selector$no, _snapshot$selector$no2;
                var snapshot = _step3.value;
                $e02b4690ccc1155c$var$handlePotentialSnapshotErrors(environment, snapshot.missingRequiredFields, snapshot.relayResolverErrors, snapshot.errorResponseFields, (_snapshot$selector$no = (_snapshot$selector$no2 = snapshot.selector.node.metadata) === null || _snapshot$selector$no2 === void 0 ? void 0 : _snapshot$selector$no2.throwOnFieldError) !== null && _snapshot$selector$no !== void 0 ? _snapshot$selector$no : false);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $e02b4690ccc1155c$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $e02b4690ccc1155c$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $e02b4690ccc1155c$var$_objectSpread2["default"])((0, $e02b4690ccc1155c$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $e02b4690ccc1155c$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $e02b4690ccc1155c$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $e02b4690ccc1155c$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $e02b4690ccc1155c$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $e02b4690ccc1155c$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $e02b4690ccc1155c$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $aE1Lc(false);
    else !!Array.isArray(fragmentRef) && $aE1Lc(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $aE1Lc(false);
    var state = $e02b4690ccc1155c$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true) {
        var missingClientEdges = $e02b4690ccc1155c$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $e02b4690ccc1155c$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($e02b4690ccc1155c$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($e02b4690ccc1155c$var$isMissingData(state)) {
        !(fragmentSelector != null) && $aE1Lc(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $e02b4690ccc1155c$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $e02b4690ccc1155c$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($e02b4690ccc1155c$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $e02b4690ccc1155c$var$readFragmentInternal;

});

parcelRegister("6FDcO", function(module, exports) {
'use strict';

var $7gV6J = parcelRequire("7gV6J");
var $4db4fbd16560d9ab$var$_interopRequireDefault = $7gV6J.default;

var $4db4fbd16560d9ab$var$_createForOfIteratorHelper2 = $4db4fbd16560d9ab$var$_interopRequireDefault((parcelRequire("8utPl")));

var $aKraw = parcelRequire("aKraw");
var $4db4fbd16560d9ab$var$loadQuery = $aKraw.loadQuery, $4db4fbd16560d9ab$var$useTrackLoadQueryInRender = $aKraw.useTrackLoadQueryInRender;

var $4Rylk = parcelRequire("4Rylk");

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");
var $4db4fbd16560d9ab$var$useCallback = $5uXOq.useCallback, $4db4fbd16560d9ab$var$useEffect = $5uXOq.useEffect, $4db4fbd16560d9ab$var$useRef = $5uXOq.useRef, $4db4fbd16560d9ab$var$useState = $5uXOq.useState;

var $eiowN = parcelRequire("eiowN");
var $4db4fbd16560d9ab$var$getRequest = $eiowN.getRequest;
var $4db4fbd16560d9ab$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $4db4fbd16560d9ab$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $4db4fbd16560d9ab$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $4db4fbd16560d9ab$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $4db4fbd16560d9ab$var$initialNullQueryReferenceState;
    var environment = $g3TRS();
    $4db4fbd16560d9ab$var$useTrackLoadQueryInRender();
    var isMountedRef = $4Rylk();
    var undisposedQueryReferencesRef = $4db4fbd16560d9ab$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $4db4fbd16560d9ab$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $4db4fbd16560d9ab$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $4db4fbd16560d9ab$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($4db4fbd16560d9ab$var$initialNullQueryReferenceState);
            setQueryReference($4db4fbd16560d9ab$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $4db4fbd16560d9ab$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $4db4fbd16560d9ab$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $4db4fbd16560d9ab$var$useRef(false);
    $4db4fbd16560d9ab$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $4db4fbd16560d9ab$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $4db4fbd16560d9ab$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($4db4fbd16560d9ab$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $4db4fbd16560d9ab$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $4db4fbd16560d9ab$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($4db4fbd16560d9ab$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $4db4fbd16560d9ab$var$useQueryLoader;

});



parcelRegister("iEtZE", function(module, exports) {
'use strict';

var $aKraw = parcelRequire("aKraw");
var $d9433a7490a2d83e$var$useTrackLoadQueryInRender = $aKraw.useTrackLoadQueryInRender;

var $eeLcT = parcelRequire("eeLcT");

var $hM7AQ = parcelRequire("hM7AQ");

var $g3TRS = parcelRequire("g3TRS");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");
var $d9433a7490a2d83e$var$useDebugValue = $5uXOq.useDebugValue;

var $eiowN = parcelRequire("eiowN");
var $d9433a7490a2d83e$var$_require3$__internal = $eiowN.__internal, $d9433a7490a2d83e$var$fetchQueryDeduped = $d9433a7490a2d83e$var$_require3$__internal.fetchQueryDeduped, $d9433a7490a2d83e$var$fetchQuery = $d9433a7490a2d83e$var$_require3$__internal.fetchQuery;
parcelRequire("1srSR");
function $d9433a7490a2d83e$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    $d9433a7490a2d83e$var$useTrackLoadQueryInRender();
    var environment = $g3TRS();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $hM7AQ(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $aE1Lc(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $d9433a7490a2d83e$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $d9433a7490a2d83e$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $eeLcT(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $d9433a7490a2d83e$var$usePreloadedQuery;

});

parcelRegister("kxGyI", function(module, exports) {
'use strict';

var $hq8PP = parcelRequire("hq8PP");

var $as8Ho = parcelRequire("as8Ho");

var $5uXOq = parcelRequire("5uXOq");
var $ef47e702d949e92b$var$useDebugValue = $5uXOq.useDebugValue;

var $eiowN = parcelRequire("eiowN");
var $ef47e702d949e92b$var$getFragment = $eiowN.getFragment;
function $ef47e702d949e92b$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $ef47e702d949e92b$var$getFragment(fragmentInput);
    $as8Ho(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $hq8PP(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $ef47e702d949e92b$var$useRefetchableFragment;

});

parcelRegister("jLHdt", function(module, exports) {
'use strict';

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");
var $e643edfdebf46b7a$var$useEffect = $5uXOq.useEffect, $e643edfdebf46b7a$var$useRef = $5uXOq.useRef;
function $e643edfdebf46b7a$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $g3TRS();
    var disposableRef = $e643edfdebf46b7a$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $e643edfdebf46b7a$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $e643edfdebf46b7a$var$useSubscribeToInvalidationState;

});

parcelRegister("jfy4f", function(module, exports) {
'use strict';

var $g3TRS = parcelRequire("g3TRS");

var $5uXOq = parcelRequire("5uXOq");
var $e039d81be03e9f83$var$useEffect = $5uXOq.useEffect;

var $eiowN = parcelRequire("eiowN");
var $e039d81be03e9f83$var$requestSubscription = $eiowN.requestSubscription;
function $e039d81be03e9f83$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $e039d81be03e9f83$var$requestSubscription;
    var environment = $g3TRS();
    $e039d81be03e9f83$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $e039d81be03e9f83$var$useSubscription;

});




parcelRegister("kyjRq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $u5Iie = parcelRequire("u5Iie");
var $ef666386a4569892$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $ef666386a4569892$var$hyphenateStyleName(string) {
    return $u5Iie(string).replace($ef666386a4569892$var$msPattern, '-ms-');
}
module.exports = $ef666386a4569892$var$hyphenateStyleName;

});
parcelRegister("u5Iie", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $05a73c0519428e8e$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $05a73c0519428e8e$var$hyphenate(string) {
    return string.replace($05a73c0519428e8e$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $05a73c0519428e8e$var$hyphenate;

});


parcelRegister("dbLxr", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("89FsM", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("6g6Ne", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6x2zj"));

});
parcelRegister("6x2zj", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $4c17d12ff2a07597$export$2b8d127b894957b9, (v) => $4c17d12ff2a07597$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $4c17d12ff2a07597$export$cea3a54a6425200c, (v) => $4c17d12ff2a07597$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $4c17d12ff2a07597$export$a7c73072b1a182ae, (v) => $4c17d12ff2a07597$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $4c17d12ff2a07597$export$9f27bc3417b4524d, (v) => $4c17d12ff2a07597$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $4c17d12ff2a07597$export$db77ccec0bb4ccac, (v) => $4c17d12ff2a07597$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $4c17d12ff2a07597$export$8392c0c9d3dcbd35, (v) => $4c17d12ff2a07597$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $4c17d12ff2a07597$export$ffb0004e005737fa, (v) => $4c17d12ff2a07597$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $4c17d12ff2a07597$export$b624eff549462981, (v) => $4c17d12ff2a07597$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $4c17d12ff2a07597$export$7897aa7841a5380c, (v) => $4c17d12ff2a07597$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $4c17d12ff2a07597$export$602eac185826482c, (v) => $4c17d12ff2a07597$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $4c17d12ff2a07597$export$e2c29f18771995cb, (v) => $4c17d12ff2a07597$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $4c17d12ff2a07597$export$5f8d39834fd61797, (v) => $4c17d12ff2a07597$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4c17d12ff2a07597$export$74bf444e3cd11ea5, (v) => $4c17d12ff2a07597$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $4c17d12ff2a07597$export$92387174baf9b227, (v) => $4c17d12ff2a07597$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $4c17d12ff2a07597$export$ec112efeb987d9c6, (v) => $4c17d12ff2a07597$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $4c17d12ff2a07597$export$b706b080d889d2c9, (v) => $4c17d12ff2a07597$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $4c17d12ff2a07597$export$5be5a87408f70ddc, (v) => $4c17d12ff2a07597$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $4c17d12ff2a07597$export$45a5e7f76e0caa8d, (v) => $4c17d12ff2a07597$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $4c17d12ff2a07597$export$455c2e768291efa6, (v) => $4c17d12ff2a07597$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $4c17d12ff2a07597$export$9522e17588c12572, (v) => $4c17d12ff2a07597$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $4c17d12ff2a07597$export$2110ac352bb060b9, (v) => $4c17d12ff2a07597$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $4c17d12ff2a07597$export$56885ab8b9c456ab, (v) => $4c17d12ff2a07597$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $4c17d12ff2a07597$export$d927fcb6adf8f9de, (v) => $4c17d12ff2a07597$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $4c17d12ff2a07597$export$b82d16f27459e05a, (v) => $4c17d12ff2a07597$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $4c17d12ff2a07597$export$522c17b4f5e123e8, (v) => $4c17d12ff2a07597$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $4c17d12ff2a07597$export$1aabd8a0274ecfd6, (v) => $4c17d12ff2a07597$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $4c17d12ff2a07597$export$9b621391a187a31a, (v) => $4c17d12ff2a07597$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $4c17d12ff2a07597$export$f5bbd400c2f4426f, (v) => $4c17d12ff2a07597$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4c17d12ff2a07597$export$2b8d127b894957b9;
var $4c17d12ff2a07597$export$cea3a54a6425200c;
var $4c17d12ff2a07597$export$a7c73072b1a182ae;
var $4c17d12ff2a07597$export$9f27bc3417b4524d;
var $4c17d12ff2a07597$export$db77ccec0bb4ccac;
var $4c17d12ff2a07597$export$8392c0c9d3dcbd35;
var $4c17d12ff2a07597$export$ffb0004e005737fa;
var $4c17d12ff2a07597$export$b624eff549462981;
var $4c17d12ff2a07597$export$7897aa7841a5380c;
var $4c17d12ff2a07597$export$602eac185826482c;
var $4c17d12ff2a07597$export$e2c29f18771995cb;
var $4c17d12ff2a07597$export$5f8d39834fd61797;
var $4c17d12ff2a07597$export$74bf444e3cd11ea5;
var $4c17d12ff2a07597$export$92387174baf9b227;
var $4c17d12ff2a07597$export$ec112efeb987d9c6;
var $4c17d12ff2a07597$export$b706b080d889d2c9;
var $4c17d12ff2a07597$export$5be5a87408f70ddc;
var $4c17d12ff2a07597$export$45a5e7f76e0caa8d;
var $4c17d12ff2a07597$export$455c2e768291efa6;
var $4c17d12ff2a07597$export$9522e17588c12572;
var $4c17d12ff2a07597$export$2110ac352bb060b9;
var $4c17d12ff2a07597$export$56885ab8b9c456ab;
var $4c17d12ff2a07597$export$d927fcb6adf8f9de;
var $4c17d12ff2a07597$export$b82d16f27459e05a;
var $4c17d12ff2a07597$export$522c17b4f5e123e8;
var $4c17d12ff2a07597$export$1aabd8a0274ecfd6;
var $4c17d12ff2a07597$export$9b621391a187a31a;
var $4c17d12ff2a07597$export$f5bbd400c2f4426f;
'use strict';
var $4c17d12ff2a07597$var$b = "function" === typeof Symbol && Symbol.for, $4c17d12ff2a07597$var$c = $4c17d12ff2a07597$var$b ? Symbol.for("react.element") : 60103, $4c17d12ff2a07597$var$d = $4c17d12ff2a07597$var$b ? Symbol.for("react.portal") : 60106, $4c17d12ff2a07597$var$e = $4c17d12ff2a07597$var$b ? Symbol.for("react.fragment") : 60107, $4c17d12ff2a07597$var$f = $4c17d12ff2a07597$var$b ? Symbol.for("react.strict_mode") : 60108, $4c17d12ff2a07597$var$g = $4c17d12ff2a07597$var$b ? Symbol.for("react.profiler") : 60114, $4c17d12ff2a07597$var$h = $4c17d12ff2a07597$var$b ? Symbol.for("react.provider") : 60109, $4c17d12ff2a07597$var$k = $4c17d12ff2a07597$var$b ? Symbol.for("react.context") : 60110, $4c17d12ff2a07597$var$l = $4c17d12ff2a07597$var$b ? Symbol.for("react.async_mode") : 60111, $4c17d12ff2a07597$var$m = $4c17d12ff2a07597$var$b ? Symbol.for("react.concurrent_mode") : 60111, $4c17d12ff2a07597$var$n = $4c17d12ff2a07597$var$b ? Symbol.for("react.forward_ref") : 60112, $4c17d12ff2a07597$var$p = $4c17d12ff2a07597$var$b ? Symbol.for("react.suspense") : 60113, $4c17d12ff2a07597$var$q = $4c17d12ff2a07597$var$b ? Symbol.for("react.suspense_list") : 60120, $4c17d12ff2a07597$var$r = $4c17d12ff2a07597$var$b ? Symbol.for("react.memo") : 60115, $4c17d12ff2a07597$var$t = $4c17d12ff2a07597$var$b ? Symbol.for("react.lazy") : 60116, $4c17d12ff2a07597$var$v = $4c17d12ff2a07597$var$b ? Symbol.for("react.block") : 60121, $4c17d12ff2a07597$var$w = $4c17d12ff2a07597$var$b ? Symbol.for("react.fundamental") : 60117, $4c17d12ff2a07597$var$x = $4c17d12ff2a07597$var$b ? Symbol.for("react.responder") : 60118, $4c17d12ff2a07597$var$y = $4c17d12ff2a07597$var$b ? Symbol.for("react.scope") : 60119;
function $4c17d12ff2a07597$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $4c17d12ff2a07597$var$c:
                switch(a = a.type, a){
                    case $4c17d12ff2a07597$var$l:
                    case $4c17d12ff2a07597$var$m:
                    case $4c17d12ff2a07597$var$e:
                    case $4c17d12ff2a07597$var$g:
                    case $4c17d12ff2a07597$var$f:
                    case $4c17d12ff2a07597$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4c17d12ff2a07597$var$k:
                            case $4c17d12ff2a07597$var$n:
                            case $4c17d12ff2a07597$var$t:
                            case $4c17d12ff2a07597$var$r:
                            case $4c17d12ff2a07597$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $4c17d12ff2a07597$var$d:
                return u;
        }
    }
}
function $4c17d12ff2a07597$var$A(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$m;
}
$4c17d12ff2a07597$export$2b8d127b894957b9 = $4c17d12ff2a07597$var$l;
$4c17d12ff2a07597$export$cea3a54a6425200c = $4c17d12ff2a07597$var$m;
$4c17d12ff2a07597$export$a7c73072b1a182ae = $4c17d12ff2a07597$var$k;
$4c17d12ff2a07597$export$9f27bc3417b4524d = $4c17d12ff2a07597$var$h;
$4c17d12ff2a07597$export$db77ccec0bb4ccac = $4c17d12ff2a07597$var$c;
$4c17d12ff2a07597$export$8392c0c9d3dcbd35 = $4c17d12ff2a07597$var$n;
$4c17d12ff2a07597$export$ffb0004e005737fa = $4c17d12ff2a07597$var$e;
$4c17d12ff2a07597$export$b624eff549462981 = $4c17d12ff2a07597$var$t;
$4c17d12ff2a07597$export$7897aa7841a5380c = $4c17d12ff2a07597$var$r;
$4c17d12ff2a07597$export$602eac185826482c = $4c17d12ff2a07597$var$d;
$4c17d12ff2a07597$export$e2c29f18771995cb = $4c17d12ff2a07597$var$g;
$4c17d12ff2a07597$export$5f8d39834fd61797 = $4c17d12ff2a07597$var$f;
$4c17d12ff2a07597$export$74bf444e3cd11ea5 = $4c17d12ff2a07597$var$p;
$4c17d12ff2a07597$export$92387174baf9b227 = function(a) {
    return $4c17d12ff2a07597$var$A(a) || $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$l;
};
$4c17d12ff2a07597$export$ec112efeb987d9c6 = $4c17d12ff2a07597$var$A;
$4c17d12ff2a07597$export$b706b080d889d2c9 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$k;
};
$4c17d12ff2a07597$export$5be5a87408f70ddc = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$h;
};
$4c17d12ff2a07597$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4c17d12ff2a07597$var$c;
};
$4c17d12ff2a07597$export$455c2e768291efa6 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$n;
};
$4c17d12ff2a07597$export$9522e17588c12572 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$e;
};
$4c17d12ff2a07597$export$2110ac352bb060b9 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$t;
};
$4c17d12ff2a07597$export$56885ab8b9c456ab = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$r;
};
$4c17d12ff2a07597$export$d927fcb6adf8f9de = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$d;
};
$4c17d12ff2a07597$export$b82d16f27459e05a = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$g;
};
$4c17d12ff2a07597$export$522c17b4f5e123e8 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$f;
};
$4c17d12ff2a07597$export$1aabd8a0274ecfd6 = function(a) {
    return $4c17d12ff2a07597$var$z(a) === $4c17d12ff2a07597$var$p;
};
$4c17d12ff2a07597$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4c17d12ff2a07597$var$e || a === $4c17d12ff2a07597$var$m || a === $4c17d12ff2a07597$var$g || a === $4c17d12ff2a07597$var$f || a === $4c17d12ff2a07597$var$p || a === $4c17d12ff2a07597$var$q || "object" === typeof a && null !== a && (a.$$typeof === $4c17d12ff2a07597$var$t || a.$$typeof === $4c17d12ff2a07597$var$r || a.$$typeof === $4c17d12ff2a07597$var$h || a.$$typeof === $4c17d12ff2a07597$var$k || a.$$typeof === $4c17d12ff2a07597$var$n || a.$$typeof === $4c17d12ff2a07597$var$w || a.$$typeof === $4c17d12ff2a07597$var$x || a.$$typeof === $4c17d12ff2a07597$var$y || a.$$typeof === $4c17d12ff2a07597$var$v);
};
$4c17d12ff2a07597$export$f5bbd400c2f4426f = $4c17d12ff2a07597$var$z;

});


parcelRegister("buCFF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $85e07e4ed6f4e06c$export$2e2bcd8739ae039);
function $85e07e4ed6f4e06c$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $85e07e4ed6f4e06c$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $85e07e4ed6f4e06c$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $85e07e4ed6f4e06c$var$isAbsolute(to);
    var isFromAbs = from && $85e07e4ed6f4e06c$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $85e07e4ed6f4e06c$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $85e07e4ed6f4e06c$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $85e07e4ed6f4e06c$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $85e07e4ed6f4e06c$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$85e07e4ed6f4e06c$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $85e07e4ed6f4e06c$export$2e2bcd8739ae039 = $85e07e4ed6f4e06c$var$resolvePathname;

});

parcelRegister("fcFOs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b118692e57cad10b$export$2e2bcd8739ae039);
var $b118692e57cad10b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $b118692e57cad10b$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $b118692e57cad10b$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $b118692e57cad10b$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $b118692e57cad10b$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $b118692e57cad10b$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $b118692e57cad10b$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $b118692e57cad10b$export$2e2bcd8739ae039 = $b118692e57cad10b$var$valueEqual;

});

parcelRegister("2OMIu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iIkmJ"));

});
parcelRegister("iIkmJ", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d9fc223fda04f9ed$export$ffb0004e005737fa, (v) => $d9fc223fda04f9ed$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d9fc223fda04f9ed$export$34b9dba7ce09269b, (v) => $d9fc223fda04f9ed$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d9fc223fda04f9ed$export$25062201e9e25d76, (v) => $d9fc223fda04f9ed$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9fc223fda04f9ed$export$ffb0004e005737fa;
var $d9fc223fda04f9ed$export$34b9dba7ce09269b;
var $d9fc223fda04f9ed$export$25062201e9e25d76;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
var $d9fc223fda04f9ed$var$k = Symbol.for("react.element"), $d9fc223fda04f9ed$var$l = Symbol.for("react.fragment"), $d9fc223fda04f9ed$var$m = Object.prototype.hasOwnProperty, $d9fc223fda04f9ed$var$n = $5uXOq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d9fc223fda04f9ed$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d9fc223fda04f9ed$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d9fc223fda04f9ed$var$m.call(a, b) && !$d9fc223fda04f9ed$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d9fc223fda04f9ed$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d9fc223fda04f9ed$var$n.current
    };
}
$d9fc223fda04f9ed$export$ffb0004e005737fa = $d9fc223fda04f9ed$var$l;
$d9fc223fda04f9ed$export$34b9dba7ce09269b = $d9fc223fda04f9ed$var$q;
$d9fc223fda04f9ed$export$25062201e9e25d76 = $d9fc223fda04f9ed$var$q;

});


parcelRegister("bwpsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $86366e315d74377c$export$2e2bcd8739ae039);
const $86366e315d74377c$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $86366e315d74377c$var$ATOMIC_GROUP_LENGTH = 5;
function $86366e315d74377c$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $86366e315d74377c$var$UNDERSCORE_UNICODE ? $86366e315d74377c$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}

});

parcelRegister("3YMLK", function(module, exports) {

$parcel$export(module.exports, "useMemoOne", () => $2e5cce37064d864e$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $2e5cce37064d864e$export$33752cf3ee811995);
$parcel$export(module.exports, "useMemo", () => $2e5cce37064d864e$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $2e5cce37064d864e$export$35808ee640e87ca7);

var $5uXOq = parcelRequire("5uXOq");
function $2e5cce37064d864e$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $2e5cce37064d864e$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5uXOq.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var committed = (0, $5uXOq.useRef)(initial);
    var isInputMatch = Boolean(inputs && committed.current.inputs && $2e5cce37064d864e$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = isInputMatch ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5uXOq.useEffect)(function() {
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $2e5cce37064d864e$export$33752cf3ee811995(callback, inputs) {
    return $2e5cce37064d864e$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $2e5cce37064d864e$export$1538c33de8887b59 = $2e5cce37064d864e$export$b6feb8998cd9b342;
var $2e5cce37064d864e$export$35808ee640e87ca7 = $2e5cce37064d864e$export$33752cf3ee811995;

});

parcelRegister("6Fgc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da32204afb1e8ba$export$2e2bcd8739ae039);

var $2Ebme = parcelRequire("2Ebme");

var $e4C0w = parcelRequire("e4C0w");
var $4qPgc = parcelRequire("4qPgc");
var $5dZlr = parcelRequire("5dZlr");
var $1p180 = parcelRequire("1p180");
var $gekG4 = parcelRequire("gekG4");
var $cJoHo = parcelRequire("cJoHo");
parcelRequire("5zhW1");
parcelRequire("ciu5u");
var $4da32204afb1e8ba$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $e4C0w.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $e4C0w.token)(character)) break;
        (0, $e4C0w.next)();
    }
    return (0, $e4C0w.slice)(begin, (0, $e4C0w.position));
};
var $4da32204afb1e8ba$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $e4C0w.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $e4C0w.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4da32204afb1e8ba$var$identifierWithPointTracking((0, $e4C0w.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $e4C0w.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $e4C0w.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $4qPgc.from)(character);
    }
    while (character = (0, $e4C0w.next)());
    return parsed;
};
var $4da32204afb1e8ba$var$getRules = function getRules(value, points) {
    return (0, $e4C0w.dealloc)($4da32204afb1e8ba$var$toRules((0, $e4C0w.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4da32204afb1e8ba$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4da32204afb1e8ba$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4da32204afb1e8ba$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4da32204afb1e8ba$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4da32204afb1e8ba$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4da32204afb1e8ba$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $4da32204afb1e8ba$var$prefix(value, length) {
    switch((0, $4qPgc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $1p180.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $1p180.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MOZ) + value + (0, $1p180.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + value + value;
        // order
        case 6165:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $1p180.WEBKIT) + value + (0, $4qPgc.replace)(value, /(\w+).+(:[^]+)/, (0, $1p180.WEBKIT) + 'box-$1$2' + (0, $1p180.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-item-' + (0, $4qPgc.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-line-pack' + (0, $4qPgc.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $1p180.WEBKIT) + 'box-' + (0, $4qPgc.replace)(value, '-grow', '') + (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $1p180.WEBKIT) + (0, $4qPgc.replace)(value, /([^-])(transform)/g, '$1' + (0, $1p180.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $4qPgc.replace)((0, $4qPgc.replace)((0, $4qPgc.replace)(value, /(zoom-|grab)/, (0, $1p180.WEBKIT) + '$1'), /(image-set)/, (0, $1p180.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $4qPgc.replace)(value, /(image-set\([^]*)/, (0, $1p180.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $4qPgc.replace)((0, $4qPgc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $1p180.WEBKIT) + 'box-pack:$3' + (0, $1p180.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $1p180.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $4qPgc.replace)(value, /(.+)-inline(.+)/, (0, $1p180.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $4qPgc.strlen)(value) - 1 - length > 6) switch((0, $4qPgc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $4qPgc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $4qPgc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $1p180.WEBKIT) + '$2-$3' + '$1' + (0, $1p180.MOZ) + ((0, $4qPgc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $4qPgc.indexof)(value, 'stretch') ? $4da32204afb1e8ba$var$prefix((0, $4qPgc.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $4qPgc.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $4qPgc.charat)(value, (0, $4qPgc.strlen)(value) - 3 - (~(0, $4qPgc.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $4qPgc.replace)(value, ':', ':' + (0, $1p180.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $4qPgc.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $1p180.WEBKIT) + ((0, $4qPgc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $1p180.WEBKIT) + '$2$3' + '$1' + (0, $1p180.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $4qPgc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + value + value;
    }
    return value;
}
var $4da32204afb1e8ba$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $1p180.DECLARATION:
                element["return"] = $4da32204afb1e8ba$var$prefix(element.value, element.length);
                break;
            case 0, $1p180.KEYFRAMES:
                return (0, $cJoHo.serialize)([
                    (0, $e4C0w.copy)(element, {
                        value: (0, $4qPgc.replace)(element.value, '@', '@' + (0, $1p180.WEBKIT))
                    })
                ], callback);
            case 0, $1p180.RULESET:
                if (element.length) return (0, $4qPgc.combine)(element.props, function(value) {
                    switch((0, $4qPgc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cJoHo.serialize)([
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(read-\w+)/, ':' + (0, $1p180.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cJoHo.serialize)([
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, ':' + (0, $1p180.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, ':' + (0, $1p180.MOZ) + '$1')
                                    ]
                                }),
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, (0, $1p180.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $4da32204afb1e8ba$var$defaultStylisPlugins = [
    $4da32204afb1e8ba$var$prefixer
];
var $4da32204afb1e8ba$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $4da32204afb1e8ba$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $4da32204afb1e8ba$var$compat,
        $4da32204afb1e8ba$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $cJoHo.stringify),
        (0, $gekG4.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $gekG4.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $cJoHo.serialize)((0, $5dZlr.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $2Ebme.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("e4C0w", function(module, exports) {

$parcel$export(module.exports, "position", () => $a3eeebe84b270ff4$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $a3eeebe84b270ff4$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $a3eeebe84b270ff4$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $a3eeebe84b270ff4$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $a3eeebe84b270ff4$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $a3eeebe84b270ff4$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $a3eeebe84b270ff4$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $a3eeebe84b270ff4$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $a3eeebe84b270ff4$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $a3eeebe84b270ff4$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $a3eeebe84b270ff4$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $a3eeebe84b270ff4$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $a3eeebe84b270ff4$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $a3eeebe84b270ff4$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $a3eeebe84b270ff4$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $a3eeebe84b270ff4$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $a3eeebe84b270ff4$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $a3eeebe84b270ff4$export$4254d4e2b3745c4c);

var $4qPgc = parcelRequire("4qPgc");
var $a3eeebe84b270ff4$export$53f1d5ea8de3d7c = 1;
var $a3eeebe84b270ff4$export$4e0c71f277ca26b3 = 1;
var $a3eeebe84b270ff4$export$f24224f1c91d8156 = 0;
var $a3eeebe84b270ff4$export$5880b8b5730aff45 = 0;
var $a3eeebe84b270ff4$export$c0306caf338ac095 = 0;
var $a3eeebe84b270ff4$export$30a86d91af8ff6e6 = '';
function $a3eeebe84b270ff4$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $a3eeebe84b270ff4$export$53f1d5ea8de3d7c,
        column: $a3eeebe84b270ff4$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $a3eeebe84b270ff4$export$784d13d8ee351f07(root, props) {
    return (0, $4qPgc.assign)($a3eeebe84b270ff4$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $a3eeebe84b270ff4$export$eba6f6f03b0a92e7() {
    return $a3eeebe84b270ff4$export$c0306caf338ac095;
}
function $a3eeebe84b270ff4$export$232faf9add678146() {
    $a3eeebe84b270ff4$export$c0306caf338ac095 = $a3eeebe84b270ff4$export$5880b8b5730aff45 > 0 ? (0, $4qPgc.charat)($a3eeebe84b270ff4$export$30a86d91af8ff6e6, --$a3eeebe84b270ff4$export$5880b8b5730aff45) : 0;
    if ($a3eeebe84b270ff4$export$4e0c71f277ca26b3--, $a3eeebe84b270ff4$export$c0306caf338ac095 === 10) $a3eeebe84b270ff4$export$4e0c71f277ca26b3 = 1, $a3eeebe84b270ff4$export$53f1d5ea8de3d7c--;
    return $a3eeebe84b270ff4$export$c0306caf338ac095;
}
function $a3eeebe84b270ff4$export$48cfd1e771a65c4f() {
    $a3eeebe84b270ff4$export$c0306caf338ac095 = $a3eeebe84b270ff4$export$5880b8b5730aff45 < $a3eeebe84b270ff4$export$f24224f1c91d8156 ? (0, $4qPgc.charat)($a3eeebe84b270ff4$export$30a86d91af8ff6e6, $a3eeebe84b270ff4$export$5880b8b5730aff45++) : 0;
    if ($a3eeebe84b270ff4$export$4e0c71f277ca26b3++, $a3eeebe84b270ff4$export$c0306caf338ac095 === 10) $a3eeebe84b270ff4$export$4e0c71f277ca26b3 = 1, $a3eeebe84b270ff4$export$53f1d5ea8de3d7c++;
    return $a3eeebe84b270ff4$export$c0306caf338ac095;
}
function $a3eeebe84b270ff4$export$4d3fb11e950abb9e() {
    return (0, $4qPgc.charat)($a3eeebe84b270ff4$export$30a86d91af8ff6e6, $a3eeebe84b270ff4$export$5880b8b5730aff45);
}
function $a3eeebe84b270ff4$export$e88cb2efb12ae807() {
    return $a3eeebe84b270ff4$export$5880b8b5730aff45;
}
function $a3eeebe84b270ff4$export$58adb3bec8346d0f(begin, end) {
    return (0, $4qPgc.substr)($a3eeebe84b270ff4$export$30a86d91af8ff6e6, begin, end);
}
function $a3eeebe84b270ff4$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $a3eeebe84b270ff4$export$2de70f21292aac9e(value) {
    return $a3eeebe84b270ff4$export$53f1d5ea8de3d7c = $a3eeebe84b270ff4$export$4e0c71f277ca26b3 = 1, $a3eeebe84b270ff4$export$f24224f1c91d8156 = (0, $4qPgc.strlen)($a3eeebe84b270ff4$export$30a86d91af8ff6e6 = value), $a3eeebe84b270ff4$export$5880b8b5730aff45 = 0, [];
}
function $a3eeebe84b270ff4$export$45918ac1574455b1(value) {
    return $a3eeebe84b270ff4$export$30a86d91af8ff6e6 = '', value;
}
function $a3eeebe84b270ff4$export$410ac95b9ec204b8(type) {
    return (0, $4qPgc.trim)($a3eeebe84b270ff4$export$58adb3bec8346d0f($a3eeebe84b270ff4$export$5880b8b5730aff45 - 1, $a3eeebe84b270ff4$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $a3eeebe84b270ff4$export$660b2ee2d4fb4eff(value) {
    return $a3eeebe84b270ff4$export$45918ac1574455b1($a3eeebe84b270ff4$export$5f8c09e3ae6f64e1($a3eeebe84b270ff4$export$2de70f21292aac9e(value)));
}
function $a3eeebe84b270ff4$export$7af1228ff777d175(type) {
    while($a3eeebe84b270ff4$export$c0306caf338ac095 = $a3eeebe84b270ff4$export$4d3fb11e950abb9e())if ($a3eeebe84b270ff4$export$c0306caf338ac095 < 33) $a3eeebe84b270ff4$export$48cfd1e771a65c4f();
    else break;
    return $a3eeebe84b270ff4$export$9e1725a4cfeada27(type) > 2 || $a3eeebe84b270ff4$export$9e1725a4cfeada27($a3eeebe84b270ff4$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $a3eeebe84b270ff4$export$5f8c09e3ae6f64e1(children) {
    while($a3eeebe84b270ff4$export$48cfd1e771a65c4f())switch($a3eeebe84b270ff4$export$9e1725a4cfeada27($a3eeebe84b270ff4$export$c0306caf338ac095)){
        case 0:
            (0, $4qPgc.append)($a3eeebe84b270ff4$export$c2ab62c7bf24634($a3eeebe84b270ff4$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $4qPgc.append)($a3eeebe84b270ff4$export$410ac95b9ec204b8($a3eeebe84b270ff4$export$c0306caf338ac095), children);
            break;
        default:
            (0, $4qPgc.append)((0, $4qPgc.from)($a3eeebe84b270ff4$export$c0306caf338ac095), children);
    }
    return children;
}
function $a3eeebe84b270ff4$export$955ba06d119e085e(index, count) {
    while(--count && $a3eeebe84b270ff4$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($a3eeebe84b270ff4$export$c0306caf338ac095 < 48 || $a3eeebe84b270ff4$export$c0306caf338ac095 > 102 || $a3eeebe84b270ff4$export$c0306caf338ac095 > 57 && $a3eeebe84b270ff4$export$c0306caf338ac095 < 65 || $a3eeebe84b270ff4$export$c0306caf338ac095 > 70 && $a3eeebe84b270ff4$export$c0306caf338ac095 < 97) break;
    return $a3eeebe84b270ff4$export$58adb3bec8346d0f(index, $a3eeebe84b270ff4$export$e88cb2efb12ae807() + (count < 6 && $a3eeebe84b270ff4$export$4d3fb11e950abb9e() == 32 && $a3eeebe84b270ff4$export$48cfd1e771a65c4f() == 32));
}
function $a3eeebe84b270ff4$export$c889f2fcc19dbf12(type) {
    while($a3eeebe84b270ff4$export$48cfd1e771a65c4f())switch($a3eeebe84b270ff4$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $a3eeebe84b270ff4$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $a3eeebe84b270ff4$export$c889f2fcc19dbf12($a3eeebe84b270ff4$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $a3eeebe84b270ff4$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $a3eeebe84b270ff4$export$48cfd1e771a65c4f();
            break;
    }
    return $a3eeebe84b270ff4$export$5880b8b5730aff45;
}
function $a3eeebe84b270ff4$export$4254d4e2b3745c4c(type, index) {
    while($a3eeebe84b270ff4$export$48cfd1e771a65c4f())// //
    if (type + $a3eeebe84b270ff4$export$c0306caf338ac095 === 57) break;
    else if (type + $a3eeebe84b270ff4$export$c0306caf338ac095 === 84 && $a3eeebe84b270ff4$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $a3eeebe84b270ff4$export$58adb3bec8346d0f(index, $a3eeebe84b270ff4$export$5880b8b5730aff45 - 1) + '*' + (0, $4qPgc.from)(type === 47 ? type : $a3eeebe84b270ff4$export$48cfd1e771a65c4f());
}
function $a3eeebe84b270ff4$export$c2ab62c7bf24634(index) {
    while(!$a3eeebe84b270ff4$export$9e1725a4cfeada27($a3eeebe84b270ff4$export$4d3fb11e950abb9e()))$a3eeebe84b270ff4$export$48cfd1e771a65c4f();
    return $a3eeebe84b270ff4$export$58adb3bec8346d0f(index, $a3eeebe84b270ff4$export$5880b8b5730aff45);
}

});
parcelRegister("4qPgc", function(module, exports) {

$parcel$export(module.exports, "abs", () => $33a15a6134c5d0a7$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $33a15a6134c5d0a7$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $33a15a6134c5d0a7$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $33a15a6134c5d0a7$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $33a15a6134c5d0a7$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $33a15a6134c5d0a7$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $33a15a6134c5d0a7$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $33a15a6134c5d0a7$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $33a15a6134c5d0a7$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $33a15a6134c5d0a7$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $33a15a6134c5d0a7$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $33a15a6134c5d0a7$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $33a15a6134c5d0a7$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $33a15a6134c5d0a7$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $33a15a6134c5d0a7$export$2335f513bbd82c6d = Math.abs;
var $33a15a6134c5d0a7$export$6788812c4e6611e6 = String.fromCharCode;
var $33a15a6134c5d0a7$export$e6e34fd1f2686227 = Object.assign;
function $33a15a6134c5d0a7$export$d6af199866bfb566(value, length) {
    return $33a15a6134c5d0a7$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $33a15a6134c5d0a7$export$a9db5e087081082d(value, 0)) << 2 ^ $33a15a6134c5d0a7$export$a9db5e087081082d(value, 1)) << 2 ^ $33a15a6134c5d0a7$export$a9db5e087081082d(value, 2)) << 2 ^ $33a15a6134c5d0a7$export$a9db5e087081082d(value, 3) : 0;
}
function $33a15a6134c5d0a7$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $33a15a6134c5d0a7$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $33a15a6134c5d0a7$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $33a15a6134c5d0a7$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $33a15a6134c5d0a7$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $33a15a6134c5d0a7$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $33a15a6134c5d0a7$export$36776f635604f274(value) {
    return value.length;
}
function $33a15a6134c5d0a7$export$f9084667e487ed46(value) {
    return value.length;
}
function $33a15a6134c5d0a7$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $33a15a6134c5d0a7$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("5dZlr", function(module, exports) {

$parcel$export(module.exports, "compile", () => $3cddc0717d56a2b4$export$ef7acd7185315e22);

var $1p180 = parcelRequire("1p180");

var $4qPgc = parcelRequire("4qPgc");

var $e4C0w = parcelRequire("e4C0w");
function $3cddc0717d56a2b4$export$ef7acd7185315e22(value) {
    return (0, $e4C0w.dealloc)($3cddc0717d56a2b4$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $e4C0w.alloc)(value), 0, [
        0
    ], value));
}
function $3cddc0717d56a2b4$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $e4C0w.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $4qPgc.charat)(characters, length - 1) == 58) {
                if ((0, $4qPgc.indexof)(characters += (0, $4qPgc.replace)((0, $e4C0w.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $e4C0w.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $e4C0w.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $e4C0w.escaping)((0, $e4C0w.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $e4C0w.peek)()){
                case 42:
                case 47:
                    (0, $4qPgc.append)($3cddc0717d56a2b4$export$4a34f930e789283c((0, $e4C0w.commenter)((0, $e4C0w.next)(), (0, $e4C0w.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $4qPgc.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $4qPgc.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $4qPgc.strlen)(characters) - length) (0, $4qPgc.append)(property > 32 ? $3cddc0717d56a2b4$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $3cddc0717d56a2b4$export$f8483753829ec8f3((0, $4qPgc.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $4qPgc.append)(reference = $3cddc0717d56a2b4$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $3cddc0717d56a2b4$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $4qPgc.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $3cddc0717d56a2b4$export$98e6a39c04603d36(value, reference, reference, rule && (0, $4qPgc.append)($3cddc0717d56a2b4$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $3cddc0717d56a2b4$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $4qPgc.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $e4C0w.prev)() == 125) continue;
            }
            switch(characters += (0, $4qPgc.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $4qPgc.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $e4C0w.peek)() === 45) characters += (0, $e4C0w.delimit)((0, $e4C0w.next)());
                    atrule = (0, $e4C0w.peek)(), offset = length = (0, $4qPgc.strlen)(type = characters += (0, $e4C0w.identifier)((0, $e4C0w.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $4qPgc.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $3cddc0717d56a2b4$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $4qPgc.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $4qPgc.substr)(value, post + 1, post = (0, $4qPgc.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $4qPgc.trim)(j > 0 ? rule[x] + ' ' + y : (0, $4qPgc.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $e4C0w.node)(value, root, parent, offset === 0 ? (0, $1p180.RULESET) : type, props, children, length);
}
function $3cddc0717d56a2b4$export$4a34f930e789283c(value, root, parent) {
    return (0, $e4C0w.node)(value, root, parent, (0, $1p180.COMMENT), (0, $4qPgc.from)((0, $e4C0w.char)()), (0, $4qPgc.substr)(value, 2, -2), 0);
}
function $3cddc0717d56a2b4$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $e4C0w.node)(value, root, parent, (0, $1p180.DECLARATION), (0, $4qPgc.substr)(value, 0, length), (0, $4qPgc.substr)(value, length + 1, -1), length);
}

});
parcelRegister("1p180", function(module, exports) {

$parcel$export(module.exports, "MS", () => $10590049e146d61b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $10590049e146d61b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $10590049e146d61b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $10590049e146d61b$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $10590049e146d61b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $10590049e146d61b$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $10590049e146d61b$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $10590049e146d61b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $10590049e146d61b$export$d773506282b3cfe6);
var $10590049e146d61b$export$71ad59f2e432cfe8 = '-ms-';
var $10590049e146d61b$export$2c0f367103c8d01c = '-moz-';
var $10590049e146d61b$export$39dfd62a25e0fe93 = '-webkit-';
var $10590049e146d61b$export$a29989082612d0d9 = 'comm';
var $10590049e146d61b$export$aa3a2e812ca8570d = 'rule';
var $10590049e146d61b$export$527d108ccf083c2b = 'decl';
var $10590049e146d61b$export$d3d35020fa5b54f0 = '@page';
var $10590049e146d61b$export$500415a86c544f73 = '@media';
var $10590049e146d61b$export$a763edbf796b780a = '@import';
var $10590049e146d61b$export$2790aeb8b4e5c826 = '@charset';
var $10590049e146d61b$export$1cc683e23b84b133 = '@viewport';
var $10590049e146d61b$export$9447a5efea57e862 = '@supports';
var $10590049e146d61b$export$ef011b4e114b1fba = '@document';
var $10590049e146d61b$export$6aad947bda0f3f46 = '@namespace';
var $10590049e146d61b$export$b44a8529a35fcb60 = '@keyframes';
var $10590049e146d61b$export$2c16de31893252e6 = '@font-face';
var $10590049e146d61b$export$3d846dd52e150c6f = '@counter-style';
var $10590049e146d61b$export$22314bfbb57653fe = '@font-feature-values';
var $10590049e146d61b$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("gekG4", function(module, exports) {

$parcel$export(module.exports, "middleware", () => $bd0dfe421702cde8$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $bd0dfe421702cde8$export$38bcb760f1d4871c);

var $1p180 = parcelRequire("1p180");

var $4qPgc = parcelRequire("4qPgc");

var $e4C0w = parcelRequire("e4C0w");

var $cJoHo = parcelRequire("cJoHo");

var $4Sbf4 = parcelRequire("4Sbf4");
function $bd0dfe421702cde8$export$5a7767152ae0305f(collection) {
    var length = (0, $4qPgc.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $bd0dfe421702cde8$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $bd0dfe421702cde8$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $1p180.DECLARATION:
                element.return = (0, $4Sbf4.prefix)(element.value, element.length, children);
                return;
            case 0, $1p180.KEYFRAMES:
                return (0, $cJoHo.serialize)([
                    (0, $e4C0w.copy)(element, {
                        value: (0, $4qPgc.replace)(element.value, '@', '@' + (0, $1p180.WEBKIT))
                    })
                ], callback);
            case 0, $1p180.RULESET:
                if (element.length) return (0, $4qPgc.combine)(element.props, function(value) {
                    switch((0, $4qPgc.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cJoHo.serialize)([
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(read-\w+)/, ':' + (0, $1p180.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cJoHo.serialize)([
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, ':' + (0, $1p180.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, ':' + (0, $1p180.MOZ) + '$1')
                                    ]
                                }),
                                (0, $e4C0w.copy)(element, {
                                    props: [
                                        (0, $4qPgc.replace)(value, /:(plac\w+)/, (0, $1p180.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $bd0dfe421702cde8$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $1p180.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $4qPgc.combine)((0, $e4C0w.tokenize)(value), function(value, index, children) {
                    switch((0, $4qPgc.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $4qPgc.substr)(value, 1, (0, $4qPgc.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $4qPgc.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $4qPgc.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $4qPgc.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("cJoHo", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $944cd8ac74b201ae$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $944cd8ac74b201ae$export$fac44ee5b035f737);

var $1p180 = parcelRequire("1p180");

var $4qPgc = parcelRequire("4qPgc");
function $944cd8ac74b201ae$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $4qPgc.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $944cd8ac74b201ae$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $1p180.LAYER:
            if (element.children.length) break;
        case 0, $1p180.IMPORT:
        case 0, $1p180.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $1p180.COMMENT:
            return '';
        case 0, $1p180.KEYFRAMES:
            return element.return = element.value + '{' + $944cd8ac74b201ae$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $1p180.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $4qPgc.strlen)(children = $944cd8ac74b201ae$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("4Sbf4", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $38c4ed03a0c462c9$export$82e9f45cca5ba907);

var $1p180 = parcelRequire("1p180");

var $4qPgc = parcelRequire("4qPgc");
function $38c4ed03a0c462c9$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $4qPgc.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $1p180.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $1p180.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $1p180.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MOZ) + value + (0, $1p180.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $4qPgc.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + value + value;
        // order
        case 6165:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $1p180.WEBKIT) + value + (0, $4qPgc.replace)(value, /(\w+).+(:[^]+)/, (0, $1p180.WEBKIT) + 'box-$1$2' + (0, $1p180.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-item-' + (0, $4qPgc.replace)(value, /flex-|-self/g, '') + (!(0, $4qPgc.match)(value, /flex-|baseline/) ? (0, $1p180.MS) + 'grid-row-' + (0, $4qPgc.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + 'flex-line-pack' + (0, $4qPgc.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $1p180.WEBKIT) + 'box-' + (0, $4qPgc.replace)(value, '-grow', '') + (0, $1p180.WEBKIT) + value + (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $1p180.WEBKIT) + (0, $4qPgc.replace)(value, /([^-])(transform)/g, '$1' + (0, $1p180.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $4qPgc.replace)((0, $4qPgc.replace)((0, $4qPgc.replace)(value, /(zoom-|grab)/, (0, $1p180.WEBKIT) + '$1'), /(image-set)/, (0, $1p180.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $4qPgc.replace)(value, /(image-set\([^]*)/, (0, $1p180.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $4qPgc.replace)((0, $4qPgc.replace)(value, /(.+:)(flex-)?(.*)/, (0, $1p180.WEBKIT) + 'box-pack:$3' + (0, $1p180.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $1p180.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $4qPgc.match)(value, /flex-|baseline/)) return (0, $1p180.MS) + 'grid-column-align' + (0, $4qPgc.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $1p180.MS) + (0, $4qPgc.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $4qPgc.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $4qPgc.indexof)(value + (children = children[length].value), 'span') ? value : (0, $1p180.MS) + (0, $4qPgc.replace)(value, '-start', '') + value + (0, $1p180.MS) + 'grid-row-span:' + (~(0, $4qPgc.indexof)(children, 'span') ? (0, $4qPgc.match)(children, /\d+/) : +(0, $4qPgc.match)(children, /\d+/) - +(0, $4qPgc.match)(value, /\d+/)) + ';';
            return (0, $1p180.MS) + (0, $4qPgc.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $4qPgc.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $1p180.MS) + (0, $4qPgc.replace)((0, $4qPgc.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $4qPgc.replace)(value, /(.+)-inline(.+)/, (0, $1p180.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $4qPgc.strlen)(value) - 1 - length > 6) switch((0, $4qPgc.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $4qPgc.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $4qPgc.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $1p180.WEBKIT) + '$2-$3' + '$1' + (0, $1p180.MOZ) + ((0, $4qPgc.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $4qPgc.indexof)(value, 'stretch') ? $38c4ed03a0c462c9$export$82e9f45cca5ba907((0, $4qPgc.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $4qPgc.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $1p180.MS) + a + ':' + b + f + (c ? (0, $1p180.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $4qPgc.charat)(value, length + 6) === 121) return (0, $4qPgc.replace)(value, ':', ':' + (0, $1p180.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $4qPgc.charat)(value, (0, $4qPgc.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $4qPgc.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $1p180.WEBKIT) + ((0, $4qPgc.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $1p180.WEBKIT) + '$2$3' + '$1' + (0, $1p180.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $4qPgc.replace)(value, ':', ':' + (0, $1p180.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $4qPgc.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("5zhW1", function(module, exports) {
var $40de221ef0a9b4b6$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("ciu5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3e813d73ce77f5$export$2e2bcd8739ae039);
function $8f3e813d73ce77f5$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("7AbCd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5854e7bee90834e9$export$2e2bcd8739ae039);
var $5854e7bee90834e9$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7PpcK", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $5b30d8ecb7b30afb$export$6321afa313b251b5);

var $5Ln8W = parcelRequire("5Ln8W");

var $A4gpm = parcelRequire("A4gpm");

var $ciu5u = parcelRequire("ciu5u");
var $5b30d8ecb7b30afb$var$isDevelopment = false;
var $5b30d8ecb7b30afb$var$hyphenateRegex = /[A-Z]|^ms/g;
var $5b30d8ecb7b30afb$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $5b30d8ecb7b30afb$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $5b30d8ecb7b30afb$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $5b30d8ecb7b30afb$var$processStyleName = /* #__PURE__ */ (0, $ciu5u.default)(function(styleName) {
    return $5b30d8ecb7b30afb$var$isCustomProperty(styleName) ? styleName : styleName.replace($5b30d8ecb7b30afb$var$hyphenateRegex, '-$&').toLowerCase();
});
var $5b30d8ecb7b30afb$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($5b30d8ecb7b30afb$var$animationRegex, function(match, p1, p2) {
                $5b30d8ecb7b30afb$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $5b30d8ecb7b30afb$var$cursor
                };
                return p1;
            });
    }
    if ((0, $A4gpm.default)[key] !== 1 && !$5b30d8ecb7b30afb$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $5b30d8ecb7b30afb$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $5b30d8ecb7b30afb$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $5b30d8ecb7b30afb$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $5b30d8ecb7b30afb$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $5b30d8ecb7b30afb$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $5b30d8ecb7b30afb$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $5b30d8ecb7b30afb$var$cursor;
                var result = interpolation(mergedProps);
                $5b30d8ecb7b30afb$var$cursor = previousCursor;
                return $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $5b30d8ecb7b30afb$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($5b30d8ecb7b30afb$var$isProcessableValue(asString)) string += $5b30d8ecb7b30afb$var$processStyleName(key) + ":" + $5b30d8ecb7b30afb$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $5b30d8ecb7b30afb$var$isDevelopment) throw new Error($5b30d8ecb7b30afb$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($5b30d8ecb7b30afb$var$isProcessableValue(value[_i])) string += $5b30d8ecb7b30afb$var$processStyleName(key) + ":" + $5b30d8ecb7b30afb$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $5b30d8ecb7b30afb$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $5b30d8ecb7b30afb$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $5b30d8ecb7b30afb$var$cursor;
function $5b30d8ecb7b30afb$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $5b30d8ecb7b30afb$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $5b30d8ecb7b30afb$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $5b30d8ecb7b30afb$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $5b30d8ecb7b30afb$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $5Ln8W.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $5b30d8ecb7b30afb$var$cursor
    };
}

});
parcelRegister("5Ln8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $43234b4df3746a5d$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $43234b4df3746a5d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("A4gpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $06c6ab944115e1c7$export$2e2bcd8739ae039);
var $06c6ab944115e1c7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("lDKn9", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $fc113617dc6a1c17$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $fc113617dc6a1c17$export$811a713a7276cb9d);

var $5uXOq = parcelRequire("5uXOq");
var $fc113617dc6a1c17$var$syncFallback = function syncFallback(create) {
    return create();
};
var $fc113617dc6a1c17$var$useInsertionEffect = $5uXOq.useInsertionEffect ? $5uXOq.useInsertionEffect : false;
var $fc113617dc6a1c17$export$db21c7ffa21794e7 = $fc113617dc6a1c17$var$useInsertionEffect || $fc113617dc6a1c17$var$syncFallback;
var $fc113617dc6a1c17$export$811a713a7276cb9d = $fc113617dc6a1c17$var$useInsertionEffect || $5uXOq.useLayoutEffect;

});

parcelRegister("1tTNc", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", () => $1143c71f26640918$export$39716b4af53f4ad);

var $ayFfI = parcelRequire("ayFfI");

var $DEWI6 = parcelRequire("DEWI6");
function $1143c71f26640918$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $ayFfI.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $ayFfI.createStrictSetupError)();
        },
        cx: $DEWI6.cx,
        XCSSProp () {
            throw (0, $ayFfI.createStrictSetupError)();
        }
    };
}

});
parcelRegister("ayFfI", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", () => $7afd1442e56c7f3b$export$c4df1cb0c2b4d77c);
const $7afd1442e56c7f3b$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $7afd1442e56c7f3b$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("DEWI6", function(module, exports) {

$parcel$export(module.exports, "cx", () => $077367a4d5677cd3$export$a274e22fb40f762e);

var $bwpsq = parcelRequire("bwpsq");
const $077367a4d5677cd3$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $bwpsq.default)(actualStyles);
};

});


parcelRegister("cBeZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $ievrd = parcelRequire("ievrd");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $ievrd.bind;
    }
});

var $kKhts = parcelRequire("kKhts");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $kKhts.bindAll;
    }
});

});
parcelRegister("ievrd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $d461ebbb57f062f1$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $d461ebbb57f062f1$var$bind;

});

parcelRegister("kKhts", function(module, exports) {
"use strict";
var $f1a5a88c1c09cc51$var$__assign = module.exports && module.exports.__assign || function() {
    $f1a5a88c1c09cc51$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f1a5a88c1c09cc51$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $ievrd = parcelRequire("ievrd");
function $f1a5a88c1c09cc51$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f1a5a88c1c09cc51$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f1a5a88c1c09cc51$var$__assign($f1a5a88c1c09cc51$var$__assign({}, original), {
        options: $f1a5a88c1c09cc51$var$__assign($f1a5a88c1c09cc51$var$__assign({}, $f1a5a88c1c09cc51$var$toOptions(sharedOptions)), $f1a5a88c1c09cc51$var$toOptions(original.options))
    });
    return binding;
}
function $f1a5a88c1c09cc51$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f1a5a88c1c09cc51$var$getBinding(original, sharedOptions);
        return (0, $ievrd.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $f1a5a88c1c09cc51$var$bindAll;

});


parcelRegister("lHrkK", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $fcc2d0fef47c90aa$var$hasElementType = typeof Element !== 'undefined';
var $fcc2d0fef47c90aa$var$hasMap = typeof Map === 'function';
var $fcc2d0fef47c90aa$var$hasSet = typeof Set === 'function';
var $fcc2d0fef47c90aa$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $fcc2d0fef47c90aa$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$fcc2d0fef47c90aa$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($fcc2d0fef47c90aa$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$fcc2d0fef47c90aa$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($fcc2d0fef47c90aa$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($fcc2d0fef47c90aa$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($fcc2d0fef47c90aa$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$fcc2d0fef47c90aa$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $fcc2d0fef47c90aa$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("hBYjV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $cd24aeba4568636e$var$__DEV__ = false;
var $cd24aeba4568636e$var$warning = function() {};
if ($cd24aeba4568636e$var$__DEV__) {
    var $cd24aeba4568636e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $cd24aeba4568636e$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $cd24aeba4568636e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $cd24aeba4568636e$var$warning;

});

parcelRegister("9H6ER", function(module, exports) {

var $cK19S = parcelRequire("cK19S");

var $9Efo3 = parcelRequire("9Efo3");

var $6G961 = parcelRequire("6G961");
/** `Object#toString` result references. */ var $01d247689c7676bf$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $01d247689c7676bf$var$funcProto = Function.prototype, $01d247689c7676bf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $01d247689c7676bf$var$funcToString = $01d247689c7676bf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $01d247689c7676bf$var$hasOwnProperty = $01d247689c7676bf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $01d247689c7676bf$var$objectCtorString = $01d247689c7676bf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $01d247689c7676bf$var$isPlainObject(value) {
    if (!$6G961(value) || $cK19S(value) != $01d247689c7676bf$var$objectTag) return false;
    var proto = $9Efo3(value);
    if (proto === null) return true;
    var Ctor = $01d247689c7676bf$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $01d247689c7676bf$var$funcToString.call(Ctor) == $01d247689c7676bf$var$objectCtorString;
}
module.exports = $01d247689c7676bf$var$isPlainObject;

});
parcelRegister("cK19S", function(module, exports) {

var $gDzvJ = parcelRequire("gDzvJ");

var $6svVc = parcelRequire("6svVc");

var $1ujEO = parcelRequire("1ujEO");
/** `Object#toString` result references. */ var $946aadef1e189334$var$nullTag = '[object Null]', $946aadef1e189334$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $946aadef1e189334$var$symToStringTag = $gDzvJ ? $gDzvJ.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $946aadef1e189334$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $946aadef1e189334$var$undefinedTag : $946aadef1e189334$var$nullTag;
    return $946aadef1e189334$var$symToStringTag && $946aadef1e189334$var$symToStringTag in Object(value) ? $6svVc(value) : $1ujEO(value);
}
module.exports = $946aadef1e189334$var$baseGetTag;

});
parcelRegister("gDzvJ", function(module, exports) {

var $973Si = parcelRequire("973Si");
/** Built-in value references. */ var $c1cbd5912c990363$var$Symbol = $973Si.Symbol;
module.exports = $c1cbd5912c990363$var$Symbol;

});
parcelRegister("973Si", function(module, exports) {

var $jL46c = parcelRequire("jL46c");
/** Detect free variable `self`. */ var $6a27c5f543788724$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6a27c5f543788724$var$root = $jL46c || $6a27c5f543788724$var$freeSelf || Function('return this')();
module.exports = $6a27c5f543788724$var$root;

});
parcelRegister("jL46c", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e625961ae735ab78$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e625961ae735ab78$var$freeGlobal;

});



parcelRegister("6svVc", function(module, exports) {

var $gDzvJ = parcelRequire("gDzvJ");
/** Used for built-in method references. */ var $4b3e1e8bc2f42119$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4b3e1e8bc2f42119$var$hasOwnProperty = $4b3e1e8bc2f42119$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4b3e1e8bc2f42119$var$nativeObjectToString = $4b3e1e8bc2f42119$var$objectProto.toString;
/** Built-in value references. */ var $4b3e1e8bc2f42119$var$symToStringTag = $gDzvJ ? $gDzvJ.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4b3e1e8bc2f42119$var$getRawTag(value) {
    var isOwn = $4b3e1e8bc2f42119$var$hasOwnProperty.call(value, $4b3e1e8bc2f42119$var$symToStringTag), tag = value[$4b3e1e8bc2f42119$var$symToStringTag];
    try {
        value[$4b3e1e8bc2f42119$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4b3e1e8bc2f42119$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4b3e1e8bc2f42119$var$symToStringTag] = tag;
        else delete value[$4b3e1e8bc2f42119$var$symToStringTag];
    }
    return result;
}
module.exports = $4b3e1e8bc2f42119$var$getRawTag;

});

parcelRegister("1ujEO", function(module, exports) {
/** Used for built-in method references. */ var $1157d75146f0062b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1157d75146f0062b$var$nativeObjectToString = $1157d75146f0062b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1157d75146f0062b$var$objectToString(value) {
    return $1157d75146f0062b$var$nativeObjectToString.call(value);
}
module.exports = $1157d75146f0062b$var$objectToString;

});


parcelRegister("9Efo3", function(module, exports) {

var $8swIZ = parcelRequire("8swIZ");
/** Built-in value references. */ var $7063c8fffe1ea365$var$getPrototype = $8swIZ(Object.getPrototypeOf, Object);
module.exports = $7063c8fffe1ea365$var$getPrototype;

});
parcelRegister("8swIZ", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $628a52b2bc23410b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $628a52b2bc23410b$var$overArg;

});


parcelRegister("6G961", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4dcdb8a39656d1db$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $4dcdb8a39656d1db$var$isObjectLike;

});


parcelRegister("ebaCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52a54ea964155b4$export$2e2bcd8739ae039);
/* global window */ 
var $jEzCt = parcelRequire("jEzCt");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $jEzCt.default)(root);
var $a52a54ea964155b4$export$2e2bcd8739ae039 = result;

});
parcelRegister("jEzCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ed620b1e770d04$export$2e2bcd8739ae039);
function $e4ed620b1e770d04$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("3XKGA", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("ipY9R", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $d68939f3762ba35d$export$fac44ee5b035f737, (v) => $d68939f3762ba35d$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $d68939f3762ba35d$export$98e6a39c04603d36, (v) => $d68939f3762ba35d$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $d68939f3762ba35d$export$fac44ee5b035f737;
var $d68939f3762ba35d$export$98e6a39c04603d36;
'use strict';
var $d68939f3762ba35d$var$has = Object.prototype.hasOwnProperty, $d68939f3762ba35d$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $d68939f3762ba35d$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $d68939f3762ba35d$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $d68939f3762ba35d$var$querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $d68939f3762ba35d$var$decode(part[1]), value = $d68939f3762ba35d$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $d68939f3762ba35d$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($d68939f3762ba35d$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $d68939f3762ba35d$var$undef || isNaN(value))) value = '';
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$d68939f3762ba35d$export$fac44ee5b035f737 = $d68939f3762ba35d$var$querystringify;
$d68939f3762ba35d$export$98e6a39c04603d36 = $d68939f3762ba35d$var$querystring;

});

parcelRegister("4G0ie", function(module, exports) {

$parcel$export(module.exports, "default", () => $367b4fe02641ecf4$export$2e2bcd8739ae039);

var $01OX0 = parcelRequire("01OX0");
function $367b4fe02641ecf4$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $01OX0.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("01OX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $00579de053fa74d2$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $00579de053fa74d2$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("bgYkX", function(module, exports) {

$parcel$export(module.exports, "default", () => $834ffe05577d3c2e$export$2e2bcd8739ae039);
function $834ffe05577d3c2e$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $834ffe05577d3c2e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $834ffe05577d3c2e$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $834ffe05577d3c2e$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("hq3wB", function(module, exports) {

});

parcelRegister("8QpSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6707409376cc0a7d$export$2e2bcd8739ae039);
var $6707409376cc0a7d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $6707409376cc0a7d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($6707409376cc0a7d$var$safeIsNaN(first) && $6707409376cc0a7d$var$safeIsNaN(second)) return true;
    return false;
}
function $6707409376cc0a7d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$6707409376cc0a7d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $6707409376cc0a7d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $6707409376cc0a7d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("jp5kW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4917b4b67f4e19$export$2e2bcd8739ae039);

var $iEN9D = parcelRequire("iEN9D");

var $40Gox = parcelRequire("40Gox");
let $2b4917b4b67f4e19$var$cache;
function $2b4917b4b67f4e19$export$2e2bcd8739ae039(name) {
    (0, $40Gox.UNSAFE_initIfNeeded)();
    try {
        if (!$2b4917b4b67f4e19$var$cache) {
            // Using this to access a dynamic parameter
            // Killswitching is known destructive, hence the lack of exposure
            const config = (0, $iEN9D.default).getExperimentValue('killswitch', 'value', [], {
                fireExperimentExposure: false
            });
            $2b4917b4b67f4e19$var$cache = new Set(config.map((d)=>d.toLowerCase()));
        }
        return $2b4917b4b67f4e19$var$cache.has(name.toLowerCase());
    } catch (e) {
        return false;
    }
}

});

parcelRegister("gg7kZ", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $0d5912b3025ed5b3$export$26ae5ca175b4ec5a);

var $5uXOq = parcelRequire("5uXOq");

var $9BPYy = parcelRequire("9BPYy");

var $7vbdl = parcelRequire("7vbdl");

var $bKpgX = parcelRequire("bKpgX");

var $5nCh1 = parcelRequire("5nCh1");
// eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
const $0d5912b3025ed5b3$var$noop = ()=>()=>{};
function $0d5912b3025ed5b3$export$26ae5ca175b4ec5a(StoreOrOptions = {}, { onInit: onInit = $0d5912b3025ed5b3$var$noop, onUpdate: onUpdate = $0d5912b3025ed5b3$var$noop, onCleanup: onCleanup = $0d5912b3025ed5b3$var$noop, displayName: displayName = '', getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $0d5912b3025ed5b3$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore Object.assign expects Object as params
                // but logical expression can return false
                // Ignoring TS to retain original source
                // eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
                handlers: Object.assign({}, onInit !== $0d5912b3025ed5b3$var$noop && {
                    onInit: ()=>onInit()
                }, onCleanup !== $0d5912b3025ed5b3$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, // TODO: on next major pass through next/prev props args
                onUpdate !== $0d5912b3025ed5b3$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            },
            getIsConcurrentSafe: getIsConcurrentSafe
        });
    }
    return $0d5912b3025ed5b3$var$createFunctionContainer(StoreOrOptions);
}
function $0d5912b3025ed5b3$var$useRegistry(scope, isGlobal, { globalRegistry: globalRegistry }) {
    return (0, $5uXOq.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $bKpgX.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $0d5912b3025ed5b3$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/exhaustive-deps, @typescript-eslint/no-explicit-any, react-hooks/exhaustive-deps -- PLEASE FIX THIS SUPPRESSION
    const containedStores = (0, $5uXOq.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $5uXOq.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store);
        // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $7vbdl.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $7vbdl.bindActions)(// eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
            Object.assign({}, Store.handlers, override?.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore);
            // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
            // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
            if (!isExisting || override) handlers.onInit?.();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $0d5912b3025ed5b3$var$useApi(check, // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
getContainedStore, { globalRegistry: globalRegistry, retrieveStore: retrieveStore }, isConcurrentSafe) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
    const retrieveRef = (0, $5uXOq.useRef)(isConcurrentSafe ? (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store) : undefined);
    if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useLayoutEffect)(()=>{
        retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    }, [
        check,
        getContainedStore,
        retrieveStore
    ]);
    else retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    return (0, $5uXOq.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef?.current?.(s)
        }), [
        globalRegistry
    ]);
}
function $0d5912b3025ed5b3$var$createFunctionContainer({ displayName: displayName, override: override, getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const isConcurrentSafe = getIsConcurrentSafe?.() ?? false;
        const { children: children, ...restProps } = props;
        const { scope: scope, isGlobal: isGlobal, ...subProps } = restProps;
        const ctx = (0, $5uXOq.useContext)((0, $9BPYy.Context));
        const registry = $0d5912b3025ed5b3$var$useRegistry(scope, isGlobal, ctx);
        // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $5uXOq.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        if (!isConcurrentSafe) propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps
        };
        const [containedStores, getContainedStore] = $0d5912b3025ed5b3$var$useContainedStore(scope, registry, propsRef, check, override);
        // Use a stable object as is passed as value to context Provider
        const api = $0d5912b3025ed5b3$var$useApi(check, getContainedStore, ctx, isConcurrentSafe);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useLayoutEffect)(()=>{
            propsRef.current = {
                prev: propsRef.current.next,
                next: restProps,
                sub: subProps
            };
            if (!(0, $5nCh1.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
                handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
            });
        }, [
            containedStores,
            restProps,
            subProps
        ]);
        else if (!(0, $5nCh1.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
            handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
        });
        // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $5uXOq.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate?.());
                    // eslint-disable-next-line no-param-reassign
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        // eslint-disable-next-line no-param-reassign
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        }, [
            containedStores.size,
            getContainedStore,
            isGlobal,
            scope
        ]);
        else if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $5uXOq.useEffect)(()=>()=>{
                containedStores.forEach(({ storeState: storeState, handlers: handlers, unsubscribe: unsubscribe }, Store)=>{
                    // Detatch container from subscription
                    unsubscribe?.();
                    // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify();
                    // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === registry.getStore(Store, scope, null)?.storeState) {
                            handlers.onDestroy?.();
                            // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                });
            // no need to reset containedStores as the map is already bound to scope
            }, [
            registry,
            scope,
            containedStores,
            isGlobal
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BPYy.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || 'Container';
    return FunctionContainer;
}

});
parcelRegister("9BPYy", function(module, exports) {

$parcel$export(module.exports, "Context", () => $db8cdcb0235e27c6$export$841858b892ce1f4c);

var $5uXOq = parcelRequire("5uXOq");

var $bKpgX = parcelRequire("bKpgX");
const $db8cdcb0235e27c6$export$841858b892ce1f4c = /*#__PURE__*/ (0, $5uXOq.createContext)({
    globalRegistry: (0, $bKpgX.defaultRegistry),
    retrieveStore: (Store)=>(0, $bKpgX.defaultRegistry).getStore(Store)
});

});
parcelRegister("bKpgX", function(module, exports) {

$parcel$export(module.exports, "StoreRegistry", () => $5ea3aa841bdd9fc5$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $5ea3aa841bdd9fc5$export$9d726ae4880b1060);

var $aJxu1 = parcelRequire("aJxu1");

var $7vbdl = parcelRequire("7vbdl");

var $8R0JF = parcelRequire("8R0JF");
const $5ea3aa841bdd9fc5$export$e4d628ba0054221b = '__global__';
class $5ea3aa841bdd9fc5$export$acb47f32da33501e {
    constructor(defaultScope = '__global__'){
        this.defaultScope = defaultScope;
        this.// eslint-disable-next-line @typescript-eslint/no-explicit-any
        stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + 'While it might still work, it will likely cause unexpected behaviours.');
                if ((0, $aJxu1.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $8R0JF.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $7vbdl.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.has(key);
        };
        this.getStore = (Store, scopeId = this.defaultScope, config = {
            props: ()=>({}),
            contained: ()=>false
        })=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.get(key) || config && this.initStore(key, Store, config);
        };
        this.deleteStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $5ea3aa841bdd9fc5$export$9d726ae4880b1060 = new $5ea3aa841bdd9fc5$export$acb47f32da33501e();

});
parcelRegister("aJxu1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6f9872033b1151$export$2e2bcd8739ae039);
const $2c6f9872033b1151$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $2c6f9872033b1151$export$2e2bcd8739ae039 = $2c6f9872033b1151$var$supports;

});

parcelRegister("7vbdl", function(module, exports) {

$parcel$export(module.exports, "bindActions", () => $171da3593e3c7ccd$export$5ee1d46cd0883a22);

var $jOqMN = parcelRequire("jOqMN");
const $171da3593e3c7ccd$var$namedMutator = (// storeState should be StoreState<TState>
// but this mutator's signature doesn't match
// the mutator's actual type of (Partial<TState>) => void
// eslint-disable-next-line @typescript-eslint/no-explicit-any
storeState, actionName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...arg)=>{
        // eslint-disable-next-line no-param-reassign
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arg);
    };
const $171da3593e3c7ccd$var$warnings = new WeakMap();
const $171da3593e3c7ccd$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $jOqMN.default).devtools ? $171da3593e3c7ccd$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2353 actions() is a deprecated API
            get actions () {
                if (!$171da3593e3c7ccd$var$warnings.has(actionFn)) $171da3593e3c7ccd$var$warnings.set(actionFn, // eslint-disable-next-line no-console
                console.warn("react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. " + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...args), actionKey);
};
const $171da3593e3c7ccd$export$5ee1d46cd0883a22 = (actions, storeState, config, boundActions = null)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(actions).reduce((acc, k)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        acc[k] = $171da3593e3c7ccd$export$5f944353e69b9bf3(storeState, actions[k], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        k, config, boundActions || acc);
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});
parcelRegister("jOqMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e0a94f63d396714$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0e0a94f63d396714$var$defaultMutator = (prevState, partialState)=>// Merge the partial state and the previous state.
    ({
        ...prevState,
        ...partialState
    });
const $0e0a94f63d396714$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))),
    devtools: false,
    middlewares: new Set(),
    mutator: $0e0a94f63d396714$var$defaultMutator
};
var $0e0a94f63d396714$export$2e2bcd8739ae039 = $0e0a94f63d396714$var$defaults;

});


parcelRegister("8R0JF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cebf8551510efbb$export$2e2bcd8739ae039);

var $jOqMN = parcelRequire("jOqMN");

var $dhedv = parcelRequire("dhedv");

var $cTYV1 = parcelRequire("cTYV1");

var $br7bQ = parcelRequire("br7bQ");
function $7cebf8551510efbb$var$createStoreState(key, initialState) {
    const listeners = new Set();
    let currentState = typeof initialState === 'function' ? initialState() : initialState;
    const storeState = {
        key: key,
        getState () {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
            return currentState;
        },
        setState (nextState) {
            currentState = nextState;
            // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $br7bQ.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        },
        // Added to satisfy StoreState<TState> type
        // eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
        mutator: ()=>{}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    storeState.mutator = (0, $cTYV1.default)(storeState, (0, $jOqMN.default).middlewares);
    return storeState;
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
$7cebf8551510efbb$export$2e2bcd8739ae039 = (0, $dhedv.default)($7cebf8551510efbb$var$createStoreState);

});
parcelRegister("dhedv", function(module, exports) {

$parcel$export(module.exports, "default", () => $01492cf5b23bccd0$export$2e2bcd8739ae039);

var $jOqMN = parcelRequire("jOqMN");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $01492cf5b23bccd0$var$connectDevTools = (storeState, config)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true,
        ...config
    });
    devTools.init(storeState.getState());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') // eslint-disable-next-line default-case
        switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
        }
        else if (message.type === 'ACTION') {
            const action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $01492cf5b23bccd0$var$withDevtools = (createStoreState)=>(...args)=>{
        const storeState = createStoreState(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if ((0, $jOqMN.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let devTools;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $jOqMN.default).devtools === 'function' ? (0, $jOqMN.default).devtools(storeState) : {};
                        devTools = $01492cf5b23bccd0$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $01492cf5b23bccd0$export$2e2bcd8739ae039 = $01492cf5b23bccd0$var$withDevtools;

});

parcelRegister("cTYV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2bb3246f9ee44df$export$2e2bcd8739ae039);

var $jOqMN = parcelRequire("jOqMN");

var $ay8Pl = parcelRequire("ay8Pl");
const $d2bb3246f9ee44df$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $ay8Pl.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $jOqMN.default).mutator);
var $d2bb3246f9ee44df$export$2e2bcd8739ae039 = $d2bb3246f9ee44df$var$applyMiddleware;

});
parcelRegister("ay8Pl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f36554be6b25ed3$export$2e2bcd8739ae039);

var $5nCh1 = parcelRequire("5nCh1");
const $6f36554be6b25ed3$var$updateMiddleware = (storeState)=>(next)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (arg)=>{
            let output;
            const state = storeState.getState();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $5nCh1.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $6f36554be6b25ed3$export$2e2bcd8739ae039 = $6f36554be6b25ed3$var$updateMiddleware;

});
parcelRegister("5nCh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae675c79f9804cac$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $ae675c79f9804cac$var$CACHE = new WeakMap();
function $ae675c79f9804cac$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    }
    // Handle Date, RegExp, String, Number, ... and complex objects
    const strA = `${objA}`;
    const strB = `${objB}`;
    if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
    // do object comparison
    let keysA;
    if ($ae675c79f9804cac$var$CACHE.has(objA)) keysA = $ae675c79f9804cac$var$CACHE.get(objA);
    else {
        keysA = Object.keys(objA);
        $ae675c79f9804cac$var$CACHE.set(objA, keysA);
    }
    let keysB;
    if ($ae675c79f9804cac$var$CACHE.has(objB)) keysB = $ae675c79f9804cac$var$CACHE.get(objB);
    else {
        keysB = Object.keys(objB);
        $ae675c79f9804cac$var$CACHE.set(objB, keysB);
    }
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}

});



parcelRegister("br7bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d992d4f4cd9581d5$export$2e2bcd8739ae039);

var $jOqMN = parcelRequire("jOqMN");

var $8dUCk = parcelRequire("8dUCk");

var $aJxu1 = parcelRequire("aJxu1");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d992d4f4cd9581d5$var$QUEUE = [];
let $d992d4f4cd9581d5$var$scheduled;
function $d992d4f4cd9581d5$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $jOqMN.default).batchUpdates || !(0, $aJxu1.default).scheduling()) return (0, $8dUCk.batch)(()=>fn());
    // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$d992d4f4cd9581d5$var$QUEUE.includes(fn)) $d992d4f4cd9581d5$var$QUEUE.push(fn);
    // if something already started schedule, skip
    if ($d992d4f4cd9581d5$var$scheduled) return;
    $d992d4f4cd9581d5$var$scheduled = (0, $8dUCk.batch)(()=>{
        let queueFn;
        // eslint-disable-next-line no-cond-assign
        while(queueFn = $d992d4f4cd9581d5$var$QUEUE.shift())queueFn();
        $d992d4f4cd9581d5$var$scheduled = null;
    });
}

});
parcelRegister("8dUCk", function(module, exports) {

$parcel$export(module.exports, "batch", () => $97c2db171026757b$export$712ea50be43a7858);
// eslint-disable-next-line camelcase

var $7nsd3 = parcelRequire("7nsd3");

var $gg6CF = parcelRequire("gg6CF");

var $jOqMN = parcelRequire("jOqMN");

var $aJxu1 = parcelRequire("aJxu1");
let $97c2db171026757b$var$isInsideBatchedSchedule = false;
function $97c2db171026757b$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $jOqMN.default).batchUpdates || !(0, $aJxu1.default).scheduling() || $97c2db171026757b$var$isInsideBatchedSchedule) return (0, $7nsd3.unstable_batchedUpdates)(fn);
    $97c2db171026757b$var$isInsideBatchedSchedule = true;
    // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $gg6CF.unstable_scheduleCallback)((0, $gg6CF.unstable_ImmediatePriority), ()=>{
        (0, $7nsd3.unstable_batchedUpdates)(fn);
        $97c2db171026757b$var$isInsideBatchedSchedule = false;
    });
}

});






parcelRegister("3sQ5x", function(module, exports) {

$parcel$export(module.exports, "createHook", () => $5faef4aae247d337$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createSelectorHook", () => $5faef4aae247d337$export$2b53f90d2bd1cbfb);
$parcel$export(module.exports, "createActionsHook", () => $5faef4aae247d337$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $5faef4aae247d337$export$6e4e5611de132e85);

var $5uXOq = parcelRequire("5uXOq");

var $8tyNL = parcelRequire("8tyNL");

var $9pe79 = parcelRequire("9pe79");

var $9BPYy = parcelRequire("9BPYy");

var $GjSo3 = parcelRequire("GjSo3");
const $5faef4aae247d337$var$EMPTY_SELECTOR = ()=>undefined;
const $5faef4aae247d337$var$DEFAULT_SELECTOR = (state)=>state;
function $5faef4aae247d337$export$e7f733c8fc2b8a24(// eslint-disable-next-line @typescript-eslint/no-explicit-any
Store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
{ selector: selector } = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetState(propsArg) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { retrieveStore: retrieveStore } = (0, $5uXOq.useContext)((0, $9BPYy.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $5uXOq.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $5uXOq.useMemo)(()=>{
            if (selector) return (0, $GjSo3.getSelectorInstance)(selector, storeState, hasPropsArg);
            return selector === null ? $5faef4aae247d337$var$EMPTY_SELECTOR : $5faef4aae247d337$var$DEFAULT_SELECTOR;
        }, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $5uXOq.useState)({})[1];
        const getSnapshot = (0, $5uXOq.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $8tyNL.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $5faef4aae247d337$export$2b53f90d2bd1cbfb(Store) {
    return function useSweetState(selector) {
        const { retrieveStore: retrieveStore } = (0, $5uXOq.useContext)((0, $9BPYy.Context));
        const { storeState: storeState } = retrieveStore(Store);
        const [, forceUpdate] = (0, $5uXOq.useState)({});
        const previousSelectorRef = (0, $5uXOq.useRef)(selector);
        const selectorRef = (0, $5uXOq.useRef)(selector);
        const selectedStateRef = (0, $5uXOq.useRef)(selectorRef.current(storeState.getState()));
        const previousState = (0, $5uXOq.useRef)(storeState.getState());
        (0, $5uXOq.useEffect)(()=>{
            if (selectorRef.current !== selector) {
                selectorRef.current = selector;
                if (!(0, $9pe79.default)(selectorRef.current(storeState.getState()), selectedStateRef.current)) forceUpdate({});
            }
        }, [
            selector,
            storeState
        ]);
        const getSnapshot = (0, $5uXOq.useCallback)(()=>{
            const state = storeState.getState();
            if (previousState.current !== state || previousSelectorRef.current !== selectorRef.current) {
                const nextSelectedState = selectorRef.current(state);
                if ((0, $9pe79.default)(nextSelectedState, selectedStateRef.current)) return selectedStateRef.current;
                previousSelectorRef.current = selectorRef.current;
                selectedStateRef.current = nextSelectedState;
                previousState.current = state;
            }
            return selectedStateRef.current;
        }, [
            storeState
        ]);
        return (0, $8tyNL.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
    };
}
function $5faef4aae247d337$export$7c643e1d6648e418(Store) {
    const useHook = $5faef4aae247d337$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $5faef4aae247d337$export$6e4e5611de132e85(Store, { selector: selector } = {}) {
    const useHook = $5faef4aae247d337$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("9pe79", function(module, exports) {

$parcel$export(module.exports, "default", () => $06cb96a92cdfd43f$export$2e2bcd8739ae039);

var $0xdyK = parcelRequire("0xdyK");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$06cb96a92cdfd43f$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $0xdyK.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $0xdyK.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("0xdyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50cb723ebf4f109$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $c50cb723ebf4f109$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("GjSo3", function(module, exports) {

$parcel$export(module.exports, "getSelectorInstance", () => $68b4cc66f2ec2434$export$38d24f3c60944dd5);

var $6dDSs = parcelRequire("6dDSs");
function $68b4cc66f2ec2434$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return (0, $6dDSs.createSelector)(dependencies, resultFunc);
}
const $68b4cc66f2ec2434$var$cache = new WeakMap();
function $68b4cc66f2ec2434$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$68b4cc66f2ec2434$var$cache.has(storeState)) $68b4cc66f2ec2434$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $68b4cc66f2ec2434$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $68b4cc66f2ec2434$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $68b4cc66f2ec2434$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("6dDSs", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $8cec4ec4e1649d38$export$595d22ed68ca2841);

var $hXBFG = parcelRequire("hXBFG");
function $8cec4ec4e1649d38$export$595d22ed68ca2841(...funcs) {
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $hXBFG.default)(function() {
        // eslint-disable-next-line prefer-spread, prefer-rest-params -- ERROR TO BE FIXED
        return resultFunc.apply(null, arguments);
    });
    // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $hXBFG.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)// eslint-disable-next-line prefer-rest-params -- ERROR TO BE FIXED
        params.push(dependencies[i].apply(null, arguments));
        // then call the final func with all them as arguments
        // eslint-disable-next-line prefer-spread -- ERROR TO BE FIXED
        return memoizedResultFunc.apply(null, params);
    }, true);
    // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}

});
parcelRegister("hXBFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a54273ad2e4aaf$export$2e2bcd8739ae039);

var $5nCh1 = parcelRequire("5nCh1");
function $89a54273ad2e4aaf$var$exactEqual(objA, objB) {
    return objA === objB;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
function $89a54273ad2e4aaf$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $5nCh1.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$89a54273ad2e4aaf$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $89a54273ad2e4aaf$export$2e2bcd8739ae039(resultFn, propsMode = false) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastArgs = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastResult;
    let calledOnce = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    const result = function() {
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        if (calledOnce && $89a54273ad2e4aaf$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $5nCh1.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});




parcelRegister("51nlc", function(module, exports) {

$parcel$export(module.exports, "createSubscriber", () => $5f734143b5a86bb4$export$48f338a7e080595c);
/* eslint-disable guard-for-in */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3sQ5x = parcelRequire("3sQ5x");
function $5f734143b5a86bb4$var$hasAdditionalProps(props) {
    for(const i in props)return true;
    return false;
}
function $5f734143b5a86bb4$export$48f338a7e080595c(Store, { selector: selector, displayName: displayName = '' } = {}) {
    const useStore = (0, $3sQ5x.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function({ children: children, ...rest }) {
        const api = useStore($5f734143b5a86bb4$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("iXqE5", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $0a7d3a3305f9fc0f$export$f51a9068ac82ea43);

var $54KIo = parcelRequire("54KIo");
function $0a7d3a3305f9fc0f$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $54KIo.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $0a7d3a3305f9fc0f$export$f51a9068ac82ea43({ name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} }) {
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            // eslint-disable-next-line no-return-assign
            return key || (key = $0a7d3a3305f9fc0f$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("54KIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1cf3c8835ac6d4$export$2e2bcd8739ae039);
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
// eslint-disable-next-line camelcase -- ERROR TO BE FIXED
function $ac1cf3c8835ac6d4$export$2e2bcd8739ae039(str) {
    let l = str.length;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    let h = l ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        str.charCodeAt(i) & 0xff | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 8 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 16 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k ^= k >>> 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    // eslint-disable-next-line default-case -- ERROR TO BE FIXED
    switch(l){
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        case 3:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 2:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 1:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= str.charCodeAt(i) & 0xff;
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 13;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 15;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    return (h >>> 0).toString(36);
}

});


parcelRegister("g9E9n", function(module, exports) {

$parcel$export(module.exports, "initAnalyticsWebClient", () => $18c9eb4ac4ac79ae$export$bb0df2ec3a6c8120);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $18c9eb4ac4ac79ae$export$e9ba7ef9458d1a4a);

var $2gQ83 = parcelRequire("2gQ83");

var $fjcgS = parcelRequire("fjcgS");

var $4Ew7h = parcelRequire("4Ew7h");

var $6dUOa = parcelRequire("6dUOa");
const $18c9eb4ac4ac79ae$export$bb0df2ec3a6c8120 = (attrs)=>{
    let internalClientInitialised;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.analyticsWebClient) try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient = false ? (0, $6dUOa.default) : new (0, $4Ew7h.default)();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        internalClientInitialised = window.analyticsWebClient.init(attrs);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient.setOriginTracingHandlers({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $2gQ83.default).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                return {
                    originTracingAttributes: {
                        id: 'originId' in attributes ? attributes.originId : undefined,
                        product: 'originProduct' in attributes ? attributes.originProduct : undefined,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id ?? undefined
                };
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // purposely empty
    }
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    internalClientInitialised = !!window.analyticsWebClient.getInstance();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, jira/jira-ssr/no-unchecked-globals-usage
    (0, $fjcgS.resolveAnalyticsWebClientPromise)(window.analyticsWebClient);
    return internalClientInitialised;
};
const $18c9eb4ac4ac79ae$export$e9ba7ef9458d1a4a = ()=>window.analyticsWebClient;

});
parcelRegister("4Ew7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bad7df82c54d30d5$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $fYgl8 = parcelRequire("fYgl8");
var $buAWB = parcelRequire("buAWB");
var $iZhen = parcelRequire("iZhen");

var $cm6fz = parcelRequire("cm6fz");


var $lcIAK = parcelRequire("lcIAK");
class $bad7df82c54d30d5$export$2e2bcd8739ae039 {
    resetBlockingDuration() {
        this.eventCount = 0;
        this.blockingDuration = 0;
    }
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, embeddedProduct: embeddedProduct, product: product, environment: environment, locale: locale, callback: callback, shouldTriggerUIViewed: shouldTriggerUIViewed = true, solutions: solutions, theme: theme, orgId: orgId, workspaceId: workspaceId }) {
        const start = performance.now();
        this.analyticsClient = new (0, $buAWB.default)({
            env: environment || (0, $iZhen.envType).DEV,
            product: product,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            version: window.BUILD_KEY || 'unknown',
            origin: (0, $iZhen.originType).WEB,
            locale: locale
        }, {
            useStargate: true,
            delayQueueCompressors: [
                new (0, $fYgl8.CompressionRule)((0, $cm6fz.canCompress), (0, $cm6fz.buildCompressionFunction)(50))
            ],
            onNewSessionStarted: this.onNewSessionStarted
        });
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $iZhen.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $iZhen.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (orgId) this.analyticsClient.setOrgInfo(orgId);
        if (workspaceId) this.analyticsClient.setWorkspaceInfo(workspaceId);
        this.clearUIViewedAttributes();
        if (solutions || theme) {
            const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            this.setUIViewedAttributes({
                ...solutions && {
                    solutions: solutions
                },
                ...theme && {
                    theme: theme,
                    OStheme: OStheme
                }
            });
        }
        if (embeddedProduct) this.analyticsClient.setEmbeddedProduct(embeddedProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        // Set init time
        this.initTime = performance.now() - start;
        return true;
    }
    sendEvent(event) {
        if ((0, $lcIAK.isAnalyticsEvent)(event)) {
            const { type: type, payload: payload } = event;
            const start = performance.now();
            if (this.amplitudeSRAttributesInjector) this.amplitudeSRAttributesInjector(payload);
            switch(type){
                case 0, $4d5e0871c06cee03$export$a1562d08625f5d7e:
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $4d5e0871c06cee03$export$947dac6c72b26f81:
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $4d5e0871c06cee03$export$12346a674644c156:
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $4d5e0871c06cee03$export$f1d537d508d2945a:
                    this.analyticsClient.sendScreenEvent(payload);
                    break;
                default:
                    break;
            }
            // Increment the blocking duration
            this.blockingDuration += performance.now() - start;
            this.eventCount += 1;
        }
    }
    isInitialized() {
        return this.analyticsClient && this.initTime > 0;
    }
    getInstance() {
        return this.analyticsClient;
    }
    setSubProduct(subProduct) {
        this.analyticsClient.setSubproduct(subProduct);
    }
    setUIViewedAttributes(attributes) {
        this.analyticsClient.setUIViewedAttributes({
            ...this.analyticsClient.getUIViewedAttributes(),
            ...attributes
        });
    }
    setEmbeddedProduct(embeddedProduct) {
        this.analyticsClient.setEmbeddedProduct(embeddedProduct);
    }
    removeUIViewedAttribute(key) {
        const { [key]: value, ...rest } = this.analyticsClient.getUIViewedAttributes();
        this.analyticsClient.setUIViewedAttributes({
            ...rest
        });
    }
    clearUIViewedAttributes() {
        this.analyticsClient.clearUIViewedAttributes();
    }
    clearEmbeddedProduct() {
        this.analyticsClient.clearEmbeddedProduct();
    }
    stopApdexEvent(payload) {
        this.analyticsClient.stopApdexEvent(payload);
    }
    setOriginTracingHandlers(originTracingHandlerMapping) {
        this.analyticsClient.setOriginTracingHandlers(originTracingHandlerMapping);
    }
    onNewSessionStarted() {
        this.updateAmplitudeSRClient && this.updateAmplitudeSRClient();
    }
    setUpdateAmplitudeSRClient(callbackFn) {
        this.updateAmplitudeSRClient = callbackFn;
    }
    setAmplitudeSRAttributesInjector(callbackFn) {
        this.amplitudeSRAttributesInjector = callbackFn;
    }
}

});
parcelRegister("lcIAK", function(module, exports) {

$parcel$export(module.exports, "isAnalyticsEvent", () => $be8a5bc72a24cbc4$export$ad4be5c2ec28cecf);
const $be8a5bc72a24cbc4$export$2bace62c90203a60 = [
    'SCREEN',
    'UI',
    'TRACK',
    'OPERATIONAL'
];
const $be8a5bc72a24cbc4$export$ad4be5c2ec28cecf = (value)=>typeof value === 'object' && value !== null && 'type' in value && typeof value.type === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $be8a5bc72a24cbc4$export$2bace62c90203a60.includes(value.type);

});


parcelRegister("6dUOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7478dd52cd803eb9$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");
const $7478dd52cd803eb9$var$SSRAnalyticsWebClient = {
    initTime: 0,
    eventCount: 0,
    blockingDuration: 0,
    amplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    resetBlockingDuration: ()=>undefined,
    init: (attrs)=>!!attrs,
    sendEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // @ts-expect-error - TS2741 - Property 'prototype' is missing in type '{}' but required in type 'AnalyticsWebClient'.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getInstance: ()=>new Proxy({}, {
            get: ()=>()=>{}
        }),
    setSubProduct: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    removeUIViewedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    clearUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    clearEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    stopApdexEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setOriginTracingHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onNewSessionStarted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setUpdateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    setAmplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isInitialized: ()=>false
};
var $7478dd52cd803eb9$export$2e2bcd8739ae039 = $7478dd52cd803eb9$var$SSRAnalyticsWebClient;

});


parcelRegister("5k7LC", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $3e04d85f3cf6f4f4$export$a143d493d941bafc, (v) => $3e04d85f3cf6f4f4$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $3e04d85f3cf6f4f4$export$e4cf37d7f6fb9e0a, (v) => $3e04d85f3cf6f4f4$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $3e04d85f3cf6f4f4$export$f99ded8fe4b79145, (v) => $3e04d85f3cf6f4f4$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $3e04d85f3cf6f4f4$export$599f31c3813fae4d, (v) => $3e04d85f3cf6f4f4$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3e04d85f3cf6f4f4$export$a143d493d941bafc;
var $3e04d85f3cf6f4f4$export$e4cf37d7f6fb9e0a;
var $3e04d85f3cf6f4f4$export$f99ded8fe4b79145;
var $3e04d85f3cf6f4f4$export$599f31c3813fae4d;
'use strict';

var $hE4TH = parcelRequire("hE4TH");

var $kna6j = parcelRequire("kna6j");
const $3e04d85f3cf6f4f4$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3e04d85f3cf6f4f4$export$a143d493d941bafc = $3e04d85f3cf6f4f4$var$Buffer;
$3e04d85f3cf6f4f4$export$e4cf37d7f6fb9e0a = $3e04d85f3cf6f4f4$var$SlowBuffer;
$3e04d85f3cf6f4f4$export$f99ded8fe4b79145 = 50;
const $3e04d85f3cf6f4f4$var$K_MAX_LENGTH = 0x7fffffff;
$3e04d85f3cf6f4f4$export$599f31c3813fae4d = $3e04d85f3cf6f4f4$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3e04d85f3cf6f4f4$var$Buffer.TYPED_ARRAY_SUPPORT = $3e04d85f3cf6f4f4$var$typedArraySupport();
if (!$3e04d85f3cf6f4f4$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3e04d85f3cf6f4f4$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3e04d85f3cf6f4f4$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3e04d85f3cf6f4f4$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3e04d85f3cf6f4f4$var$createBuffer(length) {
    if (length > $3e04d85f3cf6f4f4$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3e04d85f3cf6f4f4$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3e04d85f3cf6f4f4$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3e04d85f3cf6f4f4$var$allocUnsafe(arg);
    }
    return $3e04d85f3cf6f4f4$var$from(arg, encodingOrOffset, length);
}
$3e04d85f3cf6f4f4$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3e04d85f3cf6f4f4$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3e04d85f3cf6f4f4$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3e04d85f3cf6f4f4$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3e04d85f3cf6f4f4$var$isInstance(value, ArrayBuffer) || value && $3e04d85f3cf6f4f4$var$isInstance(value.buffer, ArrayBuffer)) return $3e04d85f3cf6f4f4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3e04d85f3cf6f4f4$var$isInstance(value, SharedArrayBuffer) || value && $3e04d85f3cf6f4f4$var$isInstance(value.buffer, SharedArrayBuffer))) return $3e04d85f3cf6f4f4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3e04d85f3cf6f4f4$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3e04d85f3cf6f4f4$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3e04d85f3cf6f4f4$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3e04d85f3cf6f4f4$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3e04d85f3cf6f4f4$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3e04d85f3cf6f4f4$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3e04d85f3cf6f4f4$var$Buffer, Uint8Array);
function $3e04d85f3cf6f4f4$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3e04d85f3cf6f4f4$var$alloc(size, fill, encoding) {
    $3e04d85f3cf6f4f4$var$assertSize(size);
    if (size <= 0) return $3e04d85f3cf6f4f4$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3e04d85f3cf6f4f4$var$createBuffer(size).fill(fill, encoding) : $3e04d85f3cf6f4f4$var$createBuffer(size).fill(fill);
    return $3e04d85f3cf6f4f4$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3e04d85f3cf6f4f4$var$Buffer.alloc = function(size, fill, encoding) {
    return $3e04d85f3cf6f4f4$var$alloc(size, fill, encoding);
};
function $3e04d85f3cf6f4f4$var$allocUnsafe(size) {
    $3e04d85f3cf6f4f4$var$assertSize(size);
    return $3e04d85f3cf6f4f4$var$createBuffer(size < 0 ? 0 : $3e04d85f3cf6f4f4$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3e04d85f3cf6f4f4$var$Buffer.allocUnsafe = function(size) {
    return $3e04d85f3cf6f4f4$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3e04d85f3cf6f4f4$var$Buffer.allocUnsafeSlow = function(size) {
    return $3e04d85f3cf6f4f4$var$allocUnsafe(size);
};
function $3e04d85f3cf6f4f4$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3e04d85f3cf6f4f4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3e04d85f3cf6f4f4$var$byteLength(string, encoding) | 0;
    let buf = $3e04d85f3cf6f4f4$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3e04d85f3cf6f4f4$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3e04d85f3cf6f4f4$var$checked(array.length) | 0;
    const buf = $3e04d85f3cf6f4f4$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3e04d85f3cf6f4f4$var$fromArrayView(arrayView) {
    if ($3e04d85f3cf6f4f4$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3e04d85f3cf6f4f4$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3e04d85f3cf6f4f4$var$fromArrayLike(arrayView);
}
function $3e04d85f3cf6f4f4$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3e04d85f3cf6f4f4$var$Buffer.prototype);
    return buf;
}
function $3e04d85f3cf6f4f4$var$fromObject(obj) {
    if ($3e04d85f3cf6f4f4$var$Buffer.isBuffer(obj)) {
        const len = $3e04d85f3cf6f4f4$var$checked(obj.length) | 0;
        const buf = $3e04d85f3cf6f4f4$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3e04d85f3cf6f4f4$var$numberIsNaN(obj.length)) return $3e04d85f3cf6f4f4$var$createBuffer(0);
        return $3e04d85f3cf6f4f4$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3e04d85f3cf6f4f4$var$fromArrayLike(obj.data);
}
function $3e04d85f3cf6f4f4$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3e04d85f3cf6f4f4$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3e04d85f3cf6f4f4$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3e04d85f3cf6f4f4$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3e04d85f3cf6f4f4$var$Buffer.alloc(+length);
}
$3e04d85f3cf6f4f4$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3e04d85f3cf6f4f4$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3e04d85f3cf6f4f4$var$Buffer.compare = function compare(a, b) {
    if ($3e04d85f3cf6f4f4$var$isInstance(a, Uint8Array)) a = $3e04d85f3cf6f4f4$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3e04d85f3cf6f4f4$var$isInstance(b, Uint8Array)) b = $3e04d85f3cf6f4f4$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(a) || !$3e04d85f3cf6f4f4$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3e04d85f3cf6f4f4$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3e04d85f3cf6f4f4$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3e04d85f3cf6f4f4$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3e04d85f3cf6f4f4$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3e04d85f3cf6f4f4$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(buf)) buf = $3e04d85f3cf6f4f4$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3e04d85f3cf6f4f4$var$byteLength(string, encoding) {
    if ($3e04d85f3cf6f4f4$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3e04d85f3cf6f4f4$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3e04d85f3cf6f4f4$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3e04d85f3cf6f4f4$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3e04d85f3cf6f4f4$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3e04d85f3cf6f4f4$var$Buffer.byteLength = $3e04d85f3cf6f4f4$var$byteLength;
function $3e04d85f3cf6f4f4$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3e04d85f3cf6f4f4$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3e04d85f3cf6f4f4$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3e04d85f3cf6f4f4$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3e04d85f3cf6f4f4$var$latin1Slice(this, start, end);
        case 'base64':
            return $3e04d85f3cf6f4f4$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3e04d85f3cf6f4f4$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3e04d85f3cf6f4f4$var$Buffer.prototype._isBuffer = true;
function $3e04d85f3cf6f4f4$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3e04d85f3cf6f4f4$var$swap(this, i, i + 1);
    return this;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3e04d85f3cf6f4f4$var$swap(this, i, i + 3);
        $3e04d85f3cf6f4f4$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3e04d85f3cf6f4f4$var$swap(this, i, i + 7);
        $3e04d85f3cf6f4f4$var$swap(this, i + 1, i + 6);
        $3e04d85f3cf6f4f4$var$swap(this, i + 2, i + 5);
        $3e04d85f3cf6f4f4$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3e04d85f3cf6f4f4$var$utf8Slice(this, 0, length);
    return $3e04d85f3cf6f4f4$var$slowToString.apply(this, arguments);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.toLocaleString = $3e04d85f3cf6f4f4$var$Buffer.prototype.toString;
$3e04d85f3cf6f4f4$var$Buffer.prototype.equals = function equals(b) {
    if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3e04d85f3cf6f4f4$var$Buffer.compare(this, b) === 0;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3e04d85f3cf6f4f4$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3e04d85f3cf6f4f4$var$customInspectSymbol) $3e04d85f3cf6f4f4$var$Buffer.prototype[$3e04d85f3cf6f4f4$var$customInspectSymbol] = $3e04d85f3cf6f4f4$var$Buffer.prototype.inspect;
$3e04d85f3cf6f4f4$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3e04d85f3cf6f4f4$var$isInstance(target, Uint8Array)) target = $3e04d85f3cf6f4f4$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3e04d85f3cf6f4f4$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3e04d85f3cf6f4f4$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3e04d85f3cf6f4f4$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3e04d85f3cf6f4f4$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3e04d85f3cf6f4f4$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3e04d85f3cf6f4f4$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3e04d85f3cf6f4f4$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3e04d85f3cf6f4f4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3e04d85f3cf6f4f4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3e04d85f3cf6f4f4$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3e04d85f3cf6f4f4$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3e04d85f3cf6f4f4$var$utf8Write(buf, string, offset, length) {
    return $3e04d85f3cf6f4f4$var$blitBuffer($3e04d85f3cf6f4f4$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3e04d85f3cf6f4f4$var$asciiWrite(buf, string, offset, length) {
    return $3e04d85f3cf6f4f4$var$blitBuffer($3e04d85f3cf6f4f4$var$asciiToBytes(string), buf, offset, length);
}
function $3e04d85f3cf6f4f4$var$base64Write(buf, string, offset, length) {
    return $3e04d85f3cf6f4f4$var$blitBuffer($3e04d85f3cf6f4f4$var$base64ToBytes(string), buf, offset, length);
}
function $3e04d85f3cf6f4f4$var$ucs2Write(buf, string, offset, length) {
    return $3e04d85f3cf6f4f4$var$blitBuffer($3e04d85f3cf6f4f4$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3e04d85f3cf6f4f4$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3e04d85f3cf6f4f4$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3e04d85f3cf6f4f4$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3e04d85f3cf6f4f4$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3e04d85f3cf6f4f4$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3e04d85f3cf6f4f4$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hE4TH.fromByteArray(buf);
    else return $hE4TH.fromByteArray(buf.slice(start, end));
}
function $3e04d85f3cf6f4f4$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3e04d85f3cf6f4f4$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3e04d85f3cf6f4f4$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3e04d85f3cf6f4f4$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3e04d85f3cf6f4f4$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3e04d85f3cf6f4f4$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3e04d85f3cf6f4f4$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3e04d85f3cf6f4f4$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3e04d85f3cf6f4f4$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3e04d85f3cf6f4f4$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3e04d85f3cf6f4f4$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3e04d85f3cf6f4f4$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3e04d85f3cf6f4f4$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUintLE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUintBE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUint8 = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUint16LE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUint16BE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUint32LE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readUint32BE = $3e04d85f3cf6f4f4$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readBigUInt64LE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3e04d85f3cf6f4f4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3e04d85f3cf6f4f4$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.readBigUInt64BE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3e04d85f3cf6f4f4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3e04d85f3cf6f4f4$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readBigInt64LE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3e04d85f3cf6f4f4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3e04d85f3cf6f4f4$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.readBigInt64BE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3e04d85f3cf6f4f4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3e04d85f3cf6f4f4$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return $kna6j.read(this, offset, true, 23, 4);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 4, this.length);
    return $kna6j.read(this, offset, false, 23, 4);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 8, this.length);
    return $kna6j.read(this, offset, true, 52, 8);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkOffset(offset, 8, this.length);
    return $kna6j.read(this, offset, false, 52, 8);
};
function $3e04d85f3cf6f4f4$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUintLE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUintBE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUint8 = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUint16LE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUint16BE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUint32LE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeUint32BE = $3e04d85f3cf6f4f4$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3e04d85f3cf6f4f4$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3e04d85f3cf6f4f4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3e04d85f3cf6f4f4$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3e04d85f3cf6f4f4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeBigUInt64LE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3e04d85f3cf6f4f4$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeBigUInt64BE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3e04d85f3cf6f4f4$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeBigInt64LE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3e04d85f3cf6f4f4$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeBigInt64BE = $3e04d85f3cf6f4f4$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3e04d85f3cf6f4f4$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3e04d85f3cf6f4f4$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3e04d85f3cf6f4f4$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kna6j.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3e04d85f3cf6f4f4$var$writeFloat(this, value, offset, true, noAssert);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3e04d85f3cf6f4f4$var$writeFloat(this, value, offset, false, noAssert);
};
function $3e04d85f3cf6f4f4$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3e04d85f3cf6f4f4$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kna6j.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3e04d85f3cf6f4f4$var$writeDouble(this, value, offset, true, noAssert);
};
$3e04d85f3cf6f4f4$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3e04d85f3cf6f4f4$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3e04d85f3cf6f4f4$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3e04d85f3cf6f4f4$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3e04d85f3cf6f4f4$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3e04d85f3cf6f4f4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3e04d85f3cf6f4f4$var$Buffer.isBuffer(val) ? val : $3e04d85f3cf6f4f4$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3e04d85f3cf6f4f4$var$errors = {};
function $3e04d85f3cf6f4f4$var$E(sym, getMessage, Base) {
    $3e04d85f3cf6f4f4$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3e04d85f3cf6f4f4$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3e04d85f3cf6f4f4$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3e04d85f3cf6f4f4$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3e04d85f3cf6f4f4$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3e04d85f3cf6f4f4$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3e04d85f3cf6f4f4$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3e04d85f3cf6f4f4$var$checkBounds(buf, offset, byteLength) {
    $3e04d85f3cf6f4f4$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3e04d85f3cf6f4f4$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3e04d85f3cf6f4f4$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3e04d85f3cf6f4f4$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3e04d85f3cf6f4f4$var$checkBounds(buf, offset, byteLength);
}
function $3e04d85f3cf6f4f4$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3e04d85f3cf6f4f4$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3e04d85f3cf6f4f4$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3e04d85f3cf6f4f4$var$validateNumber(value, type);
        throw new $3e04d85f3cf6f4f4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3e04d85f3cf6f4f4$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3e04d85f3cf6f4f4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3e04d85f3cf6f4f4$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3e04d85f3cf6f4f4$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3e04d85f3cf6f4f4$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3e04d85f3cf6f4f4$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3e04d85f3cf6f4f4$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3e04d85f3cf6f4f4$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3e04d85f3cf6f4f4$var$base64ToBytes(str) {
    return $hE4TH.toByteArray($3e04d85f3cf6f4f4$var$base64clean(str));
}
function $3e04d85f3cf6f4f4$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3e04d85f3cf6f4f4$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3e04d85f3cf6f4f4$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3e04d85f3cf6f4f4$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3e04d85f3cf6f4f4$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3e04d85f3cf6f4f4$var$BufferBigIntNotDefined : fn;
}
function $3e04d85f3cf6f4f4$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("hE4TH", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $cd89f89dd7a4057f$export$d622b2ad8d90c771, (v) => $cd89f89dd7a4057f$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $cd89f89dd7a4057f$export$6100ba28696e12de, (v) => $cd89f89dd7a4057f$export$6100ba28696e12de = v);
var $cd89f89dd7a4057f$export$a48f0734ac7c2329;
var $cd89f89dd7a4057f$export$d622b2ad8d90c771;
var $cd89f89dd7a4057f$export$6100ba28696e12de;
'use strict';
$cd89f89dd7a4057f$export$a48f0734ac7c2329 = $cd89f89dd7a4057f$var$byteLength;
$cd89f89dd7a4057f$export$d622b2ad8d90c771 = $cd89f89dd7a4057f$var$toByteArray;
$cd89f89dd7a4057f$export$6100ba28696e12de = $cd89f89dd7a4057f$var$fromByteArray;
var $cd89f89dd7a4057f$var$lookup = [];
var $cd89f89dd7a4057f$var$revLookup = [];
var $cd89f89dd7a4057f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $cd89f89dd7a4057f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $cd89f89dd7a4057f$var$i = 0, $cd89f89dd7a4057f$var$len = $cd89f89dd7a4057f$var$code.length; $cd89f89dd7a4057f$var$i < $cd89f89dd7a4057f$var$len; ++$cd89f89dd7a4057f$var$i){
    $cd89f89dd7a4057f$var$lookup[$cd89f89dd7a4057f$var$i] = $cd89f89dd7a4057f$var$code[$cd89f89dd7a4057f$var$i];
    $cd89f89dd7a4057f$var$revLookup[$cd89f89dd7a4057f$var$code.charCodeAt($cd89f89dd7a4057f$var$i)] = $cd89f89dd7a4057f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$cd89f89dd7a4057f$var$revLookup['-'.charCodeAt(0)] = 62;
$cd89f89dd7a4057f$var$revLookup['_'.charCodeAt(0)] = 63;
function $cd89f89dd7a4057f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $cd89f89dd7a4057f$var$byteLength(b64) {
    var lens = $cd89f89dd7a4057f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $cd89f89dd7a4057f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $cd89f89dd7a4057f$var$toByteArray(b64) {
    var tmp;
    var lens = $cd89f89dd7a4057f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $cd89f89dd7a4057f$var$Arr($cd89f89dd7a4057f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i)] << 18 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i)] << 2 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i)] << 10 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $cd89f89dd7a4057f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $cd89f89dd7a4057f$var$tripletToBase64(num) {
    return $cd89f89dd7a4057f$var$lookup[num >> 18 & 0x3F] + $cd89f89dd7a4057f$var$lookup[num >> 12 & 0x3F] + $cd89f89dd7a4057f$var$lookup[num >> 6 & 0x3F] + $cd89f89dd7a4057f$var$lookup[num & 0x3F];
}
function $cd89f89dd7a4057f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($cd89f89dd7a4057f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $cd89f89dd7a4057f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($cd89f89dd7a4057f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($cd89f89dd7a4057f$var$lookup[tmp >> 2] + $cd89f89dd7a4057f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($cd89f89dd7a4057f$var$lookup[tmp >> 10] + $cd89f89dd7a4057f$var$lookup[tmp >> 4 & 0x3F] + $cd89f89dd7a4057f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("kna6j", function(module, exports) {

$parcel$export(module.exports, "read", () => $ed4dca761d4a1404$export$aafa59e2e03f2942, (v) => $ed4dca761d4a1404$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $ed4dca761d4a1404$export$68d8715fc104d294, (v) => $ed4dca761d4a1404$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ed4dca761d4a1404$export$aafa59e2e03f2942;
var $ed4dca761d4a1404$export$68d8715fc104d294;
$ed4dca761d4a1404$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ed4dca761d4a1404$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6dUNv", function(module, exports) {
'use strict';

var $9e0Xz = parcelRequire("9e0Xz");

var $2kLAa = parcelRequire("2kLAa");

var $icvLs = parcelRequire("icvLs");
module.exports = {
    formats: $icvLs,
    parse: $2kLAa,
    stringify: $9e0Xz
};

});
parcelRegister("9e0Xz", function(module, exports) {
'use strict';

var $tzhBV = parcelRequire("tzhBV");

var $3k0M3 = parcelRequire("3k0M3");

var $icvLs = parcelRequire("icvLs");
var $6b762a77a4036e8d$var$has = Object.prototype.hasOwnProperty;
var $6b762a77a4036e8d$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $6b762a77a4036e8d$var$isArray = Array.isArray;
var $6b762a77a4036e8d$var$push = Array.prototype.push;
var $6b762a77a4036e8d$var$pushToArray = function(arr, valueOrArray) {
    $6b762a77a4036e8d$var$push.apply(arr, $6b762a77a4036e8d$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $6b762a77a4036e8d$var$toISO = Date.prototype.toISOString;
var $6b762a77a4036e8d$var$defaultFormat = $icvLs.default;
var $6b762a77a4036e8d$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $3k0M3.encode,
    encodeValuesOnly: false,
    format: $6b762a77a4036e8d$var$defaultFormat,
    formatter: $icvLs.formatters[$6b762a77a4036e8d$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $6b762a77a4036e8d$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $6b762a77a4036e8d$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $6b762a77a4036e8d$var$sentinel = {};
var $6b762a77a4036e8d$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($6b762a77a4036e8d$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($6b762a77a4036e8d$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $6b762a77a4036e8d$var$isArray(obj)) obj = $3k0M3.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $6b762a77a4036e8d$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($6b762a77a4036e8d$var$isNonNullishPrimitive(obj) || $3k0M3.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $6b762a77a4036e8d$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $6b762a77a4036e8d$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $6b762a77a4036e8d$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $3k0M3.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($6b762a77a4036e8d$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $6b762a77a4036e8d$var$isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $6b762a77a4036e8d$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $tzhBV();
        valueSideChannel.set($6b762a77a4036e8d$var$sentinel, sideChannel);
        $6b762a77a4036e8d$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === 'comma' && encodeValuesOnly && $6b762a77a4036e8d$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $6b762a77a4036e8d$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $6b762a77a4036e8d$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $6b762a77a4036e8d$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $icvLs.default;
    if (typeof opts.format !== 'undefined') {
        if (!$6b762a77a4036e8d$var$has.call($icvLs.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $icvLs.formatters[format];
    var filter = $6b762a77a4036e8d$var$defaults.filter;
    if (typeof opts.filter === 'function' || $6b762a77a4036e8d$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $6b762a77a4036e8d$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $6b762a77a4036e8d$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $6b762a77a4036e8d$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $6b762a77a4036e8d$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $6b762a77a4036e8d$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $6b762a77a4036e8d$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $6b762a77a4036e8d$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $6b762a77a4036e8d$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $6b762a77a4036e8d$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $6b762a77a4036e8d$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $6b762a77a4036e8d$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($6b762a77a4036e8d$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $6b762a77a4036e8d$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $6b762a77a4036e8d$var$arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $tzhBV();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $6b762a77a4036e8d$var$pushToArray(keys, $6b762a77a4036e8d$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("tzhBV", function(module, exports) {
'use strict';

var $kQfBa = parcelRequire("kQfBa");

var $9bPeo = parcelRequire("9bPeo");

var $lVo8d = parcelRequire("lVo8d");

var $5nWTT = parcelRequire("5nWTT");

var $c9VfB = parcelRequire("c9VfB");
var $058e1406915a18a9$var$makeChannel = $c9VfB || $5nWTT || $lVo8d;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kQfBa('Side channel does not contain ' + $9bPeo(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $058e1406915a18a9$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("kQfBa", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("9bPeo", function(module, exports) {
var $6b0ce1996aff24d5$var$hasMap = typeof Map === 'function' && Map.prototype;
var $6b0ce1996aff24d5$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $6b0ce1996aff24d5$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $6b0ce1996aff24d5$var$mapSize = $6b0ce1996aff24d5$var$hasMap && $6b0ce1996aff24d5$var$mapSizeDescriptor && typeof $6b0ce1996aff24d5$var$mapSizeDescriptor.get === 'function' ? $6b0ce1996aff24d5$var$mapSizeDescriptor.get : null;
var $6b0ce1996aff24d5$var$mapForEach = $6b0ce1996aff24d5$var$hasMap && Map.prototype.forEach;
var $6b0ce1996aff24d5$var$hasSet = typeof Set === 'function' && Set.prototype;
var $6b0ce1996aff24d5$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $6b0ce1996aff24d5$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $6b0ce1996aff24d5$var$setSize = $6b0ce1996aff24d5$var$hasSet && $6b0ce1996aff24d5$var$setSizeDescriptor && typeof $6b0ce1996aff24d5$var$setSizeDescriptor.get === 'function' ? $6b0ce1996aff24d5$var$setSizeDescriptor.get : null;
var $6b0ce1996aff24d5$var$setForEach = $6b0ce1996aff24d5$var$hasSet && Set.prototype.forEach;
var $6b0ce1996aff24d5$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $6b0ce1996aff24d5$var$weakMapHas = $6b0ce1996aff24d5$var$hasWeakMap ? WeakMap.prototype.has : null;
var $6b0ce1996aff24d5$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $6b0ce1996aff24d5$var$weakSetHas = $6b0ce1996aff24d5$var$hasWeakSet ? WeakSet.prototype.has : null;
var $6b0ce1996aff24d5$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $6b0ce1996aff24d5$var$weakRefDeref = $6b0ce1996aff24d5$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $6b0ce1996aff24d5$var$booleanValueOf = Boolean.prototype.valueOf;
var $6b0ce1996aff24d5$var$objectToString = Object.prototype.toString;
var $6b0ce1996aff24d5$var$functionToString = Function.prototype.toString;
var $6b0ce1996aff24d5$var$$match = String.prototype.match;
var $6b0ce1996aff24d5$var$$slice = String.prototype.slice;
var $6b0ce1996aff24d5$var$$replace = String.prototype.replace;
var $6b0ce1996aff24d5$var$$toUpperCase = String.prototype.toUpperCase;
var $6b0ce1996aff24d5$var$$toLowerCase = String.prototype.toLowerCase;
var $6b0ce1996aff24d5$var$$test = RegExp.prototype.test;
var $6b0ce1996aff24d5$var$$concat = Array.prototype.concat;
var $6b0ce1996aff24d5$var$$join = Array.prototype.join;
var $6b0ce1996aff24d5$var$$arrSlice = Array.prototype.slice;
var $6b0ce1996aff24d5$var$$floor = Math.floor;
var $6b0ce1996aff24d5$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $6b0ce1996aff24d5$var$gOPS = Object.getOwnPropertySymbols;
var $6b0ce1996aff24d5$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $6b0ce1996aff24d5$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $6b0ce1996aff24d5$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $6b0ce1996aff24d5$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $6b0ce1996aff24d5$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $6b0ce1996aff24d5$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $6b0ce1996aff24d5$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $6b0ce1996aff24d5$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$6b0ce1996aff24d5$var$$floor(-num) : $6b0ce1996aff24d5$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $6b0ce1996aff24d5$var$$slice.call(str, intStr.length + 1);
            return $6b0ce1996aff24d5$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $6b0ce1996aff24d5$var$$replace.call($6b0ce1996aff24d5$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $6b0ce1996aff24d5$var$$replace.call(str, sepRegex, '$&_');
}

var $hq3wB = parcelRequire("hq3wB");
var $6b0ce1996aff24d5$var$inspectCustom = $hq3wB.custom;
var $6b0ce1996aff24d5$var$inspectSymbol = $6b0ce1996aff24d5$var$isSymbol($6b0ce1996aff24d5$var$inspectCustom) ? $6b0ce1996aff24d5$var$inspectCustom : null;
var $6b0ce1996aff24d5$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $6b0ce1996aff24d5$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($6b0ce1996aff24d5$var$has(opts, 'quoteStyle') && !$6b0ce1996aff24d5$var$has($6b0ce1996aff24d5$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($6b0ce1996aff24d5$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $6b0ce1996aff24d5$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($6b0ce1996aff24d5$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($6b0ce1996aff24d5$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $6b0ce1996aff24d5$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $6b0ce1996aff24d5$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $6b0ce1996aff24d5$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $6b0ce1996aff24d5$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $6b0ce1996aff24d5$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($6b0ce1996aff24d5$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $6b0ce1996aff24d5$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($6b0ce1996aff24d5$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$6b0ce1996aff24d5$var$isRegExp(obj)) {
        var name = $6b0ce1996aff24d5$var$nameOf(obj);
        var keys = $6b0ce1996aff24d5$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $6b0ce1996aff24d5$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($6b0ce1996aff24d5$var$isSymbol(obj)) {
        var symString = $6b0ce1996aff24d5$var$hasShammedSymbols ? $6b0ce1996aff24d5$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $6b0ce1996aff24d5$var$symToString.call(obj);
        return typeof obj === 'object' && !$6b0ce1996aff24d5$var$hasShammedSymbols ? $6b0ce1996aff24d5$var$markBoxed(symString) : symString;
    }
    if ($6b0ce1996aff24d5$var$isElement(obj)) {
        var s = '<' + $6b0ce1996aff24d5$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $6b0ce1996aff24d5$var$wrapQuotes($6b0ce1996aff24d5$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $6b0ce1996aff24d5$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($6b0ce1996aff24d5$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $6b0ce1996aff24d5$var$arrObjKeys(obj, inspect);
        if (indent && !$6b0ce1996aff24d5$var$singleLineValues(xs)) return '[' + $6b0ce1996aff24d5$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $6b0ce1996aff24d5$var$$join.call(xs, ', ') + ' ]';
    }
    if ($6b0ce1996aff24d5$var$isError(obj)) {
        var parts = $6b0ce1996aff24d5$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$6b0ce1996aff24d5$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $6b0ce1996aff24d5$var$$join.call($6b0ce1996aff24d5$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $6b0ce1996aff24d5$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($6b0ce1996aff24d5$var$inspectSymbol && typeof obj[$6b0ce1996aff24d5$var$inspectSymbol] === 'function' && $hq3wB) return $hq3wB(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($6b0ce1996aff24d5$var$isMap(obj)) {
        var mapParts = [];
        if ($6b0ce1996aff24d5$var$mapForEach) $6b0ce1996aff24d5$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $6b0ce1996aff24d5$var$collectionOf('Map', $6b0ce1996aff24d5$var$mapSize.call(obj), mapParts, indent);
    }
    if ($6b0ce1996aff24d5$var$isSet(obj)) {
        var setParts = [];
        if ($6b0ce1996aff24d5$var$setForEach) $6b0ce1996aff24d5$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $6b0ce1996aff24d5$var$collectionOf('Set', $6b0ce1996aff24d5$var$setSize.call(obj), setParts, indent);
    }
    if ($6b0ce1996aff24d5$var$isWeakMap(obj)) return $6b0ce1996aff24d5$var$weakCollectionOf('WeakMap');
    if ($6b0ce1996aff24d5$var$isWeakSet(obj)) return $6b0ce1996aff24d5$var$weakCollectionOf('WeakSet');
    if ($6b0ce1996aff24d5$var$isWeakRef(obj)) return $6b0ce1996aff24d5$var$weakCollectionOf('WeakRef');
    if ($6b0ce1996aff24d5$var$isNumber(obj)) return $6b0ce1996aff24d5$var$markBoxed(inspect(Number(obj)));
    if ($6b0ce1996aff24d5$var$isBigInt(obj)) return $6b0ce1996aff24d5$var$markBoxed(inspect($6b0ce1996aff24d5$var$bigIntValueOf.call(obj)));
    if ($6b0ce1996aff24d5$var$isBoolean(obj)) return $6b0ce1996aff24d5$var$markBoxed($6b0ce1996aff24d5$var$booleanValueOf.call(obj));
    if ($6b0ce1996aff24d5$var$isString(obj)) return $6b0ce1996aff24d5$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$6b0ce1996aff24d5$var$isDate(obj) && !$6b0ce1996aff24d5$var$isRegExp(obj)) {
        var ys = $6b0ce1996aff24d5$var$arrObjKeys(obj, inspect);
        var isPlainObject = $6b0ce1996aff24d5$var$gPO ? $6b0ce1996aff24d5$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $6b0ce1996aff24d5$var$toStringTag && Object(obj) === obj && $6b0ce1996aff24d5$var$toStringTag in obj ? $6b0ce1996aff24d5$var$$slice.call($6b0ce1996aff24d5$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $6b0ce1996aff24d5$var$$join.call($6b0ce1996aff24d5$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $6b0ce1996aff24d5$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $6b0ce1996aff24d5$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $6b0ce1996aff24d5$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $6b0ce1996aff24d5$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $6b0ce1996aff24d5$var$quote(s) {
    return $6b0ce1996aff24d5$var$$replace.call(String(s), /"/g, '&quot;');
}
function $6b0ce1996aff24d5$var$canTrustToString(obj) {
    return !$6b0ce1996aff24d5$var$toStringTag || !(typeof obj === 'object' && ($6b0ce1996aff24d5$var$toStringTag in obj || typeof obj[$6b0ce1996aff24d5$var$toStringTag] !== 'undefined'));
}
function $6b0ce1996aff24d5$var$isArray(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object Array]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isDate(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object Date]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isRegExp(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object RegExp]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isError(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object Error]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isString(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object String]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isNumber(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object Number]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
function $6b0ce1996aff24d5$var$isBoolean(obj) {
    return $6b0ce1996aff24d5$var$toStr(obj) === '[object Boolean]' && $6b0ce1996aff24d5$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $6b0ce1996aff24d5$var$isSymbol(obj) {
    if ($6b0ce1996aff24d5$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$6b0ce1996aff24d5$var$symToString) return false;
    try {
        $6b0ce1996aff24d5$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$6b0ce1996aff24d5$var$bigIntValueOf) return false;
    try {
        $6b0ce1996aff24d5$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $6b0ce1996aff24d5$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $6b0ce1996aff24d5$var$has(obj, key) {
    return $6b0ce1996aff24d5$var$hasOwn.call(obj, key);
}
function $6b0ce1996aff24d5$var$toStr(obj) {
    return $6b0ce1996aff24d5$var$objectToString.call(obj);
}
function $6b0ce1996aff24d5$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $6b0ce1996aff24d5$var$$match.call($6b0ce1996aff24d5$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $6b0ce1996aff24d5$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $6b0ce1996aff24d5$var$isMap(x) {
    if (!$6b0ce1996aff24d5$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $6b0ce1996aff24d5$var$mapSize.call(x);
        try {
            $6b0ce1996aff24d5$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isWeakMap(x) {
    if (!$6b0ce1996aff24d5$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $6b0ce1996aff24d5$var$weakMapHas.call(x, $6b0ce1996aff24d5$var$weakMapHas);
        try {
            $6b0ce1996aff24d5$var$weakSetHas.call(x, $6b0ce1996aff24d5$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isWeakRef(x) {
    if (!$6b0ce1996aff24d5$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $6b0ce1996aff24d5$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isSet(x) {
    if (!$6b0ce1996aff24d5$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $6b0ce1996aff24d5$var$setSize.call(x);
        try {
            $6b0ce1996aff24d5$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isWeakSet(x) {
    if (!$6b0ce1996aff24d5$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $6b0ce1996aff24d5$var$weakSetHas.call(x, $6b0ce1996aff24d5$var$weakSetHas);
        try {
            $6b0ce1996aff24d5$var$weakMapHas.call(x, $6b0ce1996aff24d5$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6b0ce1996aff24d5$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $6b0ce1996aff24d5$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $6b0ce1996aff24d5$var$inspectString($6b0ce1996aff24d5$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $6b0ce1996aff24d5$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $6b0ce1996aff24d5$var$$replace.call($6b0ce1996aff24d5$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $6b0ce1996aff24d5$var$lowbyte);
    return $6b0ce1996aff24d5$var$wrapQuotes(s, 'single', opts);
}
function $6b0ce1996aff24d5$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $6b0ce1996aff24d5$var$$toUpperCase.call(n.toString(16));
}
function $6b0ce1996aff24d5$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $6b0ce1996aff24d5$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $6b0ce1996aff24d5$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $6b0ce1996aff24d5$var$indentedJoin(entries, indent) : $6b0ce1996aff24d5$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $6b0ce1996aff24d5$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($6b0ce1996aff24d5$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $6b0ce1996aff24d5$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $6b0ce1996aff24d5$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $6b0ce1996aff24d5$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $6b0ce1996aff24d5$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $6b0ce1996aff24d5$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $6b0ce1996aff24d5$var$arrObjKeys(obj, inspect) {
    var isArr = $6b0ce1996aff24d5$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $6b0ce1996aff24d5$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $6b0ce1996aff24d5$var$gOPS === 'function' ? $6b0ce1996aff24d5$var$gOPS(obj) : [];
    var symMap;
    if ($6b0ce1996aff24d5$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$6b0ce1996aff24d5$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($6b0ce1996aff24d5$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($6b0ce1996aff24d5$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $6b0ce1996aff24d5$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($6b0ce1996aff24d5$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});

parcelRegister("lVo8d", function(module, exports) {
'use strict';

var $9bPeo = parcelRequire("9bPeo");

var $kQfBa = parcelRequire("kQfBa");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $ff61a3d98adeb682$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $ff61a3d98adeb682$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $ff61a3d98adeb682$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $ff61a3d98adeb682$var$listSet = function(objects, key, value) {
    var node = $ff61a3d98adeb682$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $ff61a3d98adeb682$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$ff61a3d98adeb682$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $ff61a3d98adeb682$var$listDelete = function(objects, key) {
    if (objects) return $ff61a3d98adeb682$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kQfBa('Side channel does not contain ' + $9bPeo(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $ff61a3d98adeb682$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $ff61a3d98adeb682$var$listGet($o, key);
        },
        has: function(key) {
            return $ff61a3d98adeb682$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $ff61a3d98adeb682$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("5nWTT", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $3T2jo = parcelRequire("3T2jo");

var $9bPeo = parcelRequire("9bPeo");

var $kQfBa = parcelRequire("kQfBa");
var $3ebcca2628f88daf$var$$Map = $iPtqy('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $3ebcca2628f88daf$var$$mapGet = $3T2jo('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $3ebcca2628f88daf$var$$mapSet = $3T2jo('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $3ebcca2628f88daf$var$$mapHas = $3T2jo('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $3ebcca2628f88daf$var$$mapDelete = $3T2jo('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $3ebcca2628f88daf$var$$mapSize = $3T2jo('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$3ebcca2628f88daf$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kQfBa('Side channel does not contain ' + $9bPeo(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $3ebcca2628f88daf$var$$mapDelete($m, key);
                if ($3ebcca2628f88daf$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $3ebcca2628f88daf$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $3ebcca2628f88daf$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $3ebcca2628f88daf$var$$Map();
            $3ebcca2628f88daf$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("iPtqy", function(module, exports) {
'use strict';
var $db53d10b274d0217$var$undefined1;

var $hVuCj = parcelRequire("hVuCj");

var $6GVaQ = parcelRequire("6GVaQ");

var $aStM7 = parcelRequire("aStM7");

var $ejhBl = parcelRequire("ejhBl");

var $a38k5 = parcelRequire("a38k5");

var $6ZTEL = parcelRequire("6ZTEL");

var $kQfBa = parcelRequire("kQfBa");

var $bPhan = parcelRequire("bPhan");

var $5ZLTV = parcelRequire("5ZLTV");

var $5n79k = parcelRequire("5n79k");

var $dapmr = parcelRequire("dapmr");

var $4TbYs = parcelRequire("4TbYs");

var $cT7U6 = parcelRequire("cT7U6");

var $hPGvY = parcelRequire("hPGvY");

var $1DX9S = parcelRequire("1DX9S");
var $db53d10b274d0217$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $db53d10b274d0217$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $db53d10b274d0217$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $lBvcQ = parcelRequire("lBvcQ");

var $7Th0d = parcelRequire("7Th0d");
var $db53d10b274d0217$var$throwTypeError = function() {
    throw new $kQfBa();
};
var $db53d10b274d0217$var$ThrowTypeError = $lBvcQ ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $db53d10b274d0217$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $lBvcQ(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $db53d10b274d0217$var$throwTypeError;
        }
    }
}() : $db53d10b274d0217$var$throwTypeError;

var $db53d10b274d0217$var$hasSymbols = (parcelRequire("7Nc81"))();

var $863dK = parcelRequire("863dK");

var $6U7KV = parcelRequire("6U7KV");

var $61ECk = parcelRequire("61ECk");

var $iJCdB = parcelRequire("iJCdB");

var $douuT = parcelRequire("douuT");
var $db53d10b274d0217$var$needsEval = {};
var $db53d10b274d0217$var$TypedArray = typeof Uint8Array === 'undefined' || !$863dK ? undefined : $863dK(Uint8Array);
var $db53d10b274d0217$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $db53d10b274d0217$var$hasSymbols && $863dK ? $863dK([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $db53d10b274d0217$var$needsEval,
    '%AsyncGenerator%': $db53d10b274d0217$var$needsEval,
    '%AsyncGeneratorFunction%': $db53d10b274d0217$var$needsEval,
    '%AsyncIteratorPrototype%': $db53d10b274d0217$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6GVaQ,
    '%eval%': eval,
    '%EvalError%': $aStM7,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $db53d10b274d0217$var$$Function,
    '%GeneratorFunction%': $db53d10b274d0217$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $db53d10b274d0217$var$hasSymbols && $863dK ? $863dK($863dK([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$db53d10b274d0217$var$hasSymbols || !$863dK ? undefined : $863dK(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $hVuCj,
    '%Object.getOwnPropertyDescriptor%': $lBvcQ,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $ejhBl,
    '%ReferenceError%': $a38k5,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$db53d10b274d0217$var$hasSymbols || !$863dK ? undefined : $863dK(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $db53d10b274d0217$var$hasSymbols && $863dK ? $863dK(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $db53d10b274d0217$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $6ZTEL,
    '%ThrowTypeError%': $db53d10b274d0217$var$ThrowTypeError,
    '%TypedArray%': $db53d10b274d0217$var$TypedArray,
    '%TypeError%': $kQfBa,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $bPhan,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $douuT,
    '%Function.prototype.apply%': $iJCdB,
    '%Object.defineProperty%': $7Th0d,
    '%Object.getPrototypeOf%': $6U7KV,
    '%Math.abs%': $5ZLTV,
    '%Math.floor%': $5n79k,
    '%Math.max%': $dapmr,
    '%Math.min%': $4TbYs,
    '%Math.pow%': $cT7U6,
    '%Math.round%': $hPGvY,
    '%Math.sign%': $1DX9S,
    '%Reflect.getPrototypeOf%': $61ECk
};
if ($863dK) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $db53d10b274d0217$var$errorProto = $863dK($863dK(e));
    $db53d10b274d0217$var$INTRINSICS['%Error.prototype%'] = $db53d10b274d0217$var$errorProto;
}
var $db53d10b274d0217$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $db53d10b274d0217$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $db53d10b274d0217$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $db53d10b274d0217$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $863dK) value = $863dK(gen.prototype);
    }
    $db53d10b274d0217$var$INTRINSICS[name] = value;
    return value;
};
var $db53d10b274d0217$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $g2Z6Y = parcelRequire("g2Z6Y");

var $kO8H7 = parcelRequire("kO8H7");
var $db53d10b274d0217$var$$concat = $g2Z6Y.call($douuT, Array.prototype.concat);
var $db53d10b274d0217$var$$spliceApply = $g2Z6Y.call($iJCdB, Array.prototype.splice);
var $db53d10b274d0217$var$$replace = $g2Z6Y.call($douuT, String.prototype.replace);
var $db53d10b274d0217$var$$strSlice = $g2Z6Y.call($douuT, String.prototype.slice);
var $db53d10b274d0217$var$$exec = $g2Z6Y.call($douuT, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $db53d10b274d0217$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $db53d10b274d0217$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $db53d10b274d0217$var$stringToPath = function stringToPath(string) {
    var first = $db53d10b274d0217$var$$strSlice(string, 0, 1);
    var last = $db53d10b274d0217$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $6ZTEL('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $6ZTEL('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $db53d10b274d0217$var$$replace(string, $db53d10b274d0217$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $db53d10b274d0217$var$$replace(subString, $db53d10b274d0217$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $db53d10b274d0217$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($kO8H7($db53d10b274d0217$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $db53d10b274d0217$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($kO8H7($db53d10b274d0217$var$INTRINSICS, intrinsicName)) {
        var value = $db53d10b274d0217$var$INTRINSICS[intrinsicName];
        if (value === $db53d10b274d0217$var$needsEval) value = $db53d10b274d0217$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $kQfBa('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6ZTEL('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $kQfBa('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $kQfBa('"allowMissing" argument must be a boolean');
    if ($db53d10b274d0217$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6ZTEL('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $db53d10b274d0217$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $db53d10b274d0217$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $db53d10b274d0217$var$$spliceApply(parts, $db53d10b274d0217$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $db53d10b274d0217$var$$strSlice(part, 0, 1);
        var last = $db53d10b274d0217$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $6ZTEL('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($kO8H7($db53d10b274d0217$var$INTRINSICS, intrinsicRealName)) value = $db53d10b274d0217$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $kQfBa('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($lBvcQ && i + 1 >= parts.length) {
                var desc = $lBvcQ(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $kO8H7(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $db53d10b274d0217$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hVuCj", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6GVaQ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("aStM7", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ejhBl", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("a38k5", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6ZTEL", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("bPhan", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("5ZLTV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("5n79k", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dapmr", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4TbYs", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("cT7U6", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("hPGvY", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("1DX9S", function(module, exports) {
'use strict';

var $4eUYG = parcelRequire("4eUYG");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4eUYG(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4eUYG", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("lBvcQ", function(module, exports) {
'use strict';

var $bVQ5i = parcelRequire("bVQ5i");
var $fba5428c34464f68$require$$gOPD = $bVQ5i;
if ($fba5428c34464f68$require$$gOPD) try {
    $fba5428c34464f68$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $fba5428c34464f68$require$$gOPD = null;
}
module.exports = $fba5428c34464f68$require$$gOPD;

});
parcelRegister("bVQ5i", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("7Th0d", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $5beadbc9b2de4af2$var$$defineProperty = Object.defineProperty || false;
if ($5beadbc9b2de4af2$var$$defineProperty) try {
    $5beadbc9b2de4af2$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $5beadbc9b2de4af2$var$$defineProperty = false;
}
module.exports = $5beadbc9b2de4af2$var$$defineProperty;

});

parcelRegister("7Nc81", function(module, exports) {
'use strict';
var $5ac68475b4a0e6ee$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9T9x9 = parcelRequire("9T9x9");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $5ac68475b4a0e6ee$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $5ac68475b4a0e6ee$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9T9x9();
};

});
parcelRegister("9T9x9", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("863dK", function(module, exports) {
'use strict';

var $61ECk = parcelRequire("61ECk");

var $6U7KV = parcelRequire("6U7KV");

var $5zKke = parcelRequire("5zKke");
/** @type {import('.')} */ module.exports = $61ECk ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $61ECk(O);
} : $6U7KV ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $6U7KV(O);
} : $5zKke ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5zKke(O);
} : null;

});
parcelRegister("61ECk", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("6U7KV", function(module, exports) {
'use strict';

var $hVuCj = parcelRequire("hVuCj");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $hVuCj.getPrototypeOf || null;

});

parcelRegister("5zKke", function(module, exports) {
'use strict';

var $h08zB = parcelRequire("h08zB");

var $lBvcQ = parcelRequire("lBvcQ");
var $40f427e60522115f$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $40f427e60522115f$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $40f427e60522115f$var$desc = !!$40f427e60522115f$var$hasProtoAccessor && $lBvcQ && $lBvcQ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $40f427e60522115f$var$$Object = Object;
var $40f427e60522115f$var$$getPrototypeOf = $40f427e60522115f$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $40f427e60522115f$var$desc && typeof $40f427e60522115f$var$desc.get === 'function' ? $h08zB([
    $40f427e60522115f$var$desc.get
]) : typeof $40f427e60522115f$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $40f427e60522115f$var$$getPrototypeOf(value == null ? value : $40f427e60522115f$var$$Object(value));
} : false;

});
parcelRegister("h08zB", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $kQfBa = parcelRequire("kQfBa");

var $douuT = parcelRequire("douuT");

var $4XlJF = parcelRequire("4XlJF");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $kQfBa('a function is required');
    return $4XlJF($g2Z6Y, $douuT, args);
};

});
parcelRegister("g2Z6Y", function(module, exports) {
'use strict';

var $iJpV8 = parcelRequire("iJpV8");
module.exports = Function.prototype.bind || $iJpV8;

});
parcelRegister("iJpV8", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $da30893c96ae1a62$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $da30893c96ae1a62$var$toStr = Object.prototype.toString;
var $da30893c96ae1a62$var$max = Math.max;
var $da30893c96ae1a62$var$funcType = '[object Function]';
var $da30893c96ae1a62$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $da30893c96ae1a62$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $da30893c96ae1a62$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $da30893c96ae1a62$var$toStr.apply(target) !== $da30893c96ae1a62$var$funcType) throw new TypeError($da30893c96ae1a62$var$ERROR_MESSAGE + target);
    var args = $da30893c96ae1a62$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $da30893c96ae1a62$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $da30893c96ae1a62$var$concatty(args, arguments));
    };
    var boundLength = $da30893c96ae1a62$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $da30893c96ae1a62$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("douuT", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("4XlJF", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $iJCdB = parcelRequire("iJCdB");

var $douuT = parcelRequire("douuT");

var $902RO = parcelRequire("902RO");
/** @type {import('./actualApply')} */ module.exports = $902RO || $g2Z6Y.call($douuT, $iJCdB);

});
parcelRegister("iJCdB", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("902RO", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("kO8H7", function(module, exports) {
'use strict';
var $f25f38b778a8ffab$var$call = Function.prototype.call;
var $f25f38b778a8ffab$var$$hasOwn = Object.prototype.hasOwnProperty;

var $g2Z6Y = parcelRequire("g2Z6Y");
/** @type {import('.')} */ module.exports = $g2Z6Y.call($f25f38b778a8ffab$var$call, $f25f38b778a8ffab$var$$hasOwn);

});


parcelRegister("3T2jo", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $h08zB = parcelRequire("h08zB");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $2d484d3453bf31b9$var$$indexOf = $h08zB([
    $iPtqy('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $iPtqy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $2d484d3453bf31b9$var$$indexOf(name, '.prototype.') > -1) return $h08zB(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("c9VfB", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $3T2jo = parcelRequire("3T2jo");

var $9bPeo = parcelRequire("9bPeo");

var $5nWTT = parcelRequire("5nWTT");

var $kQfBa = parcelRequire("kQfBa");
var $8da2bc14b0968ac0$var$$WeakMap = $iPtqy('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $8da2bc14b0968ac0$var$$weakMapGet = $3T2jo('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $8da2bc14b0968ac0$var$$weakMapSet = $3T2jo('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $8da2bc14b0968ac0$var$$weakMapHas = $3T2jo('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $8da2bc14b0968ac0$var$$weakMapDelete = $3T2jo('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $8da2bc14b0968ac0$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $kQfBa('Side channel does not contain ' + $9bPeo(key));
        },
        'delete': function(key) {
            if ($8da2bc14b0968ac0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $8da2bc14b0968ac0$var$$weakMapDelete($wm, key);
            } else if ($5nWTT) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($8da2bc14b0968ac0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $8da2bc14b0968ac0$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($8da2bc14b0968ac0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $8da2bc14b0968ac0$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($8da2bc14b0968ac0$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $8da2bc14b0968ac0$var$$WeakMap();
                $8da2bc14b0968ac0$var$$weakMapSet($wm, key, value);
            } else if ($5nWTT) {
                if (!$m) $m = $5nWTT();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $5nWTT;

});


parcelRegister("3k0M3", function(module, exports) {
'use strict';

var $icvLs = parcelRequire("icvLs");
var $26b3d70b017a79b4$var$has = Object.prototype.hasOwnProperty;
var $26b3d70b017a79b4$var$isArray = Array.isArray;
var $26b3d70b017a79b4$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $26b3d70b017a79b4$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($26b3d70b017a79b4$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $26b3d70b017a79b4$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $26b3d70b017a79b4$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object') {
        if ($26b3d70b017a79b4$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$26b3d70b017a79b4$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($26b3d70b017a79b4$var$isArray(target) && !$26b3d70b017a79b4$var$isArray(source)) mergeTarget = $26b3d70b017a79b4$var$arrayToObject(target, options);
    if ($26b3d70b017a79b4$var$isArray(target) && $26b3d70b017a79b4$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($26b3d70b017a79b4$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($26b3d70b017a79b4$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $26b3d70b017a79b4$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $26b3d70b017a79b4$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $26b3d70b017a79b4$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $icvLs.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $26b3d70b017a79b4$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($26b3d70b017a79b4$var$hexTable[0xC0 | c >> 6] + $26b3d70b017a79b4$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($26b3d70b017a79b4$var$hexTable[0xE0 | c >> 12] + $26b3d70b017a79b4$var$hexTable[0x80 | c >> 6 & 0x3F] + $26b3d70b017a79b4$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $26b3d70b017a79b4$var$hexTable[0xF0 | c >> 18] + $26b3d70b017a79b4$var$hexTable[0x80 | c >> 12 & 0x3F] + $26b3d70b017a79b4$var$hexTable[0x80 | c >> 6 & 0x3F] + $26b3d70b017a79b4$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $26b3d70b017a79b4$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $26b3d70b017a79b4$var$compactQueue(queue);
    return value;
};
var $26b3d70b017a79b4$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $26b3d70b017a79b4$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $26b3d70b017a79b4$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $26b3d70b017a79b4$var$maybeMap = function maybeMap(val, fn) {
    if ($26b3d70b017a79b4$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $26b3d70b017a79b4$var$arrayToObject,
    assign: $26b3d70b017a79b4$var$assign,
    combine: $26b3d70b017a79b4$var$combine,
    compact: $26b3d70b017a79b4$var$compact,
    decode: $26b3d70b017a79b4$var$decode,
    encode: $26b3d70b017a79b4$var$encode,
    isBuffer: $26b3d70b017a79b4$var$isBuffer,
    isRegExp: $26b3d70b017a79b4$var$isRegExp,
    maybeMap: $26b3d70b017a79b4$var$maybeMap,
    merge: $26b3d70b017a79b4$var$merge
};

});
parcelRegister("icvLs", function(module, exports) {
'use strict';
var $d401fcb90965ff99$var$replace = String.prototype.replace;
var $d401fcb90965ff99$var$percentTwenties = /%20/g;
var $d401fcb90965ff99$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $d401fcb90965ff99$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d401fcb90965ff99$var$replace.call(value, $d401fcb90965ff99$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d401fcb90965ff99$var$Format.RFC1738,
    RFC3986: $d401fcb90965ff99$var$Format.RFC3986
};

});



parcelRegister("2kLAa", function(module, exports) {
'use strict';

var $3k0M3 = parcelRequire("3k0M3");
var $1b325be0f95043a1$var$has = Object.prototype.hasOwnProperty;
var $1b325be0f95043a1$var$isArray = Array.isArray;
var $1b325be0f95043a1$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $3k0M3.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $1b325be0f95043a1$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $1b325be0f95043a1$var$parseArrayValue = function(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $1b325be0f95043a1$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $1b325be0f95043a1$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $1b325be0f95043a1$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $1b325be0f95043a1$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $1b325be0f95043a1$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $1b325be0f95043a1$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $1b325be0f95043a1$var$defaults.decoder, charset, 'key');
            val = $3k0M3.maybeMap($1b325be0f95043a1$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $1b325be0f95043a1$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $1b325be0f95043a1$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $1b325be0f95043a1$var$isArray(val) ? [
            val
        ] : val;
        if ($1b325be0f95043a1$var$has.call(obj, key)) obj[key] = $3k0M3.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $1b325be0f95043a1$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $1b325be0f95043a1$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $1b325be0f95043a1$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $1b325be0f95043a1$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $1b325be0f95043a1$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $1b325be0f95043a1$var$parseObject(keys, val, options, valuesParsed);
};
var $1b325be0f95043a1$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $1b325be0f95043a1$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $1b325be0f95043a1$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $1b325be0f95043a1$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $1b325be0f95043a1$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $1b325be0f95043a1$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $1b325be0f95043a1$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $1b325be0f95043a1$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $1b325be0f95043a1$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $1b325be0f95043a1$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $3k0M3.isRegExp(opts.delimiter) ? opts.delimiter : $1b325be0f95043a1$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $1b325be0f95043a1$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $1b325be0f95043a1$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $1b325be0f95043a1$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $1b325be0f95043a1$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $1b325be0f95043a1$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $1b325be0f95043a1$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $1b325be0f95043a1$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $1b325be0f95043a1$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $3k0M3.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $3k0M3.compact(obj);
};

});


parcelRegister("1m0iJ", function(module, exports) {
'use strict';

var $5RwXc = parcelRequire("5RwXc");
/**
 * Expose `traverse`.
 */ module.exports = $0fc81454a298e603$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0fc81454a298e603$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $0fc81454a298e603$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $0fc81454a298e603$var$traverseArray(input, strict);
    else if ($5RwXc.is(input, strict)) return $5RwXc.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $0fc81454a298e603$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $0fc81454a298e603$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $0fc81454a298e603$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $0fc81454a298e603$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("5RwXc", function(module, exports) {

$parcel$export(module.exports, "parse", () => $444b76e92bd3fa02$export$98e6a39c04603d36, (v) => $444b76e92bd3fa02$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $444b76e92bd3fa02$export$226b3eccf92c9ed9, (v) => $444b76e92bd3fa02$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $444b76e92bd3fa02$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $444b76e92bd3fa02$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $444b76e92bd3fa02$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$444b76e92bd3fa02$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $444b76e92bd3fa02$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$444b76e92bd3fa02$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $444b76e92bd3fa02$var$matcher.test(string);
};

});


parcelRegister("hlggt", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("aCrRe", function(module, exports) {
'use strict';
var $7bb30fe7288da359$var$token = '%[a-f0-9]{2}';
var $7bb30fe7288da359$var$singleMatcher = new RegExp('(' + $7bb30fe7288da359$var$token + ')|([^%]+?)', 'gi');
var $7bb30fe7288da359$var$multiMatcher = new RegExp('(' + $7bb30fe7288da359$var$token + ')+', 'gi');
function $7bb30fe7288da359$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $7bb30fe7288da359$var$decodeComponents(left), $7bb30fe7288da359$var$decodeComponents(right));
}
function $7bb30fe7288da359$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($7bb30fe7288da359$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $7bb30fe7288da359$var$decodeComponents(tokens, i).join('');
            tokens = input.match($7bb30fe7288da359$var$singleMatcher) || [];
        }
        return input;
    }
}
function $7bb30fe7288da359$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $7bb30fe7288da359$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $7bb30fe7288da359$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $7bb30fe7288da359$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $7bb30fe7288da359$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("gjKya", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("cNVkY", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});

parcelRegister("M4Zg0", function(module, exports) {
(function(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    /**
   * @constructor
   */ function UrlTemplate() {}
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeReserved = function(str) {
        return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
            if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
            return part;
        }).join('');
    };
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeUnreserved = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /**
   * @private
   * @param {string} operator
   * @param {string} value
   * @param {string} key
   * @return {string}
   */ UrlTemplate.prototype.encodeValue = function(operator, value, key) {
        value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);
        if (key) return this.encodeUnreserved(key) + '=' + value;
        else return value;
    };
    /**
   * @private
   * @param {*} value
   * @return {boolean}
   */ UrlTemplate.prototype.isDefined = function(value) {
        return value !== undefined && value !== null;
    };
    /**
   * @private
   * @param {string}
   * @return {boolean}
   */ UrlTemplate.prototype.isKeyOperator = function(operator) {
        return operator === ';' || operator === '&' || operator === '?';
    };
    /**
   * @private
   * @param {Object} context
   * @param {string} operator
   * @param {string} key
   * @param {string} modifier
   */ UrlTemplate.prototype.getValues = function(context, operator, key, modifier) {
        var value = context[key], result = [];
        if (this.isDefined(value) && value !== '') {
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                value = value.toString();
                if (modifier && modifier !== '*') value = value.substring(0, parseInt(modifier, 10));
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
            } else if (modifier === '*') {
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) result.push(this.encodeValue(operator, value[k], k));
                }, this);
            } else {
                var tmp = [];
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    tmp.push(this.encodeValue(operator, value));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) {
                        tmp.push(this.encodeUnreserved(k));
                        tmp.push(this.encodeValue(operator, value[k].toString()));
                    }
                }, this);
                if (this.isKeyOperator(operator)) result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
                else if (tmp.length !== 0) result.push(tmp.join(','));
            }
        } else {
            if (operator === ';') {
                if (this.isDefined(value)) result.push(this.encodeUnreserved(key));
            } else if (value === '' && (operator === '&' || operator === '?')) result.push(this.encodeUnreserved(key) + '=');
            else if (value === '') result.push('');
        }
        return result;
    };
    /**
   * @param {string} template
   * @return {function(Object):string}
   */ UrlTemplate.prototype.parse = function(template) {
        var that = this;
        var operators = [
            '+',
            '#',
            '.',
            '/',
            ';',
            '?',
            '&'
        ];
        return {
            expand: function(context) {
                return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
                    if (expression) {
                        var operator = null, values = [];
                        if (operators.indexOf(expression.charAt(0)) !== -1) {
                            operator = expression.charAt(0);
                            expression = expression.substr(1);
                        }
                        expression.split(/,/g).forEach(function(variable) {
                            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        });
                        if (operator && operator !== '+') {
                            var separator = ',';
                            if (operator === '?') separator = '&';
                            else if (operator !== '#') separator = operator;
                            return (values.length !== 0 ? operator : '') + values.join(separator);
                        } else return values.join(',');
                    } else return that.encodeReserved(literal);
                });
            }
        };
    };
    return new UrlTemplate();
});

});

parcelRegister("dyczo", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("3VFsf", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $2dc6d9f7b15bc14b$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $2dc6d9f7b15bc14b$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $2dc6d9f7b15bc14b$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $2dc6d9f7b15bc14b$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2dc6d9f7b15bc14b$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $2dc6d9f7b15bc14b$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $2dc6d9f7b15bc14b$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $2dc6d9f7b15bc14b$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $2dc6d9f7b15bc14b$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $2dc6d9f7b15bc14b$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $2dc6d9f7b15bc14b$export$1216008129fb82ed);
$parcel$export(module.exports, "__importStar", () => $2dc6d9f7b15bc14b$export$c21735bcef00d192);
$parcel$export(module.exports, "__importDefault", () => $2dc6d9f7b15bc14b$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $2dc6d9f7b15bc14b$var$extendStatics = function(d, b) {
    $2dc6d9f7b15bc14b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2dc6d9f7b15bc14b$var$extendStatics(d, b);
};
function $2dc6d9f7b15bc14b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2dc6d9f7b15bc14b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2dc6d9f7b15bc14b$export$18ce0697a983be9b = function() {
    $2dc6d9f7b15bc14b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2dc6d9f7b15bc14b$export$18ce0697a983be9b.apply(this, arguments);
};
function $2dc6d9f7b15bc14b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2dc6d9f7b15bc14b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2dc6d9f7b15bc14b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2dc6d9f7b15bc14b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2dc6d9f7b15bc14b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2dc6d9f7b15bc14b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2dc6d9f7b15bc14b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2dc6d9f7b15bc14b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2dc6d9f7b15bc14b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2dc6d9f7b15bc14b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2dc6d9f7b15bc14b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2dc6d9f7b15bc14b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2dc6d9f7b15bc14b$export$45d3717a4c69092e(o, m, p);
}
function $2dc6d9f7b15bc14b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2dc6d9f7b15bc14b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2dc6d9f7b15bc14b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2dc6d9f7b15bc14b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2dc6d9f7b15bc14b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2dc6d9f7b15bc14b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2dc6d9f7b15bc14b$export$10c90e4f7922046c(v) {
    return this instanceof $2dc6d9f7b15bc14b$export$10c90e4f7922046c ? (this.v = v, this) : new $2dc6d9f7b15bc14b$export$10c90e4f7922046c(v);
}
function $2dc6d9f7b15bc14b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2dc6d9f7b15bc14b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2dc6d9f7b15bc14b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2dc6d9f7b15bc14b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2dc6d9f7b15bc14b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2dc6d9f7b15bc14b$export$19a8beecd37a4c45 === "function" ? $2dc6d9f7b15bc14b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2dc6d9f7b15bc14b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2dc6d9f7b15bc14b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $2dc6d9f7b15bc14b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2dc6d9f7b15bc14b$export$45d3717a4c69092e(result, mod, k);
    }
    $2dc6d9f7b15bc14b$var$__setModuleDefault(result, mod);
    return result;
}
function $2dc6d9f7b15bc14b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2dc6d9f7b15bc14b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2dc6d9f7b15bc14b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2dc6d9f7b15bc14b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2dc6d9f7b15bc14b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2dc6d9f7b15bc14b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2dc6d9f7b15bc14b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2dc6d9f7b15bc14b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $2dc6d9f7b15bc14b$export$2e2bcd8739ae039 = {
    __extends: $2dc6d9f7b15bc14b$export$a8ba968b8961cb8a,
    __assign: $2dc6d9f7b15bc14b$export$18ce0697a983be9b,
    __rest: $2dc6d9f7b15bc14b$export$3c9a16f847548506,
    __decorate: $2dc6d9f7b15bc14b$export$29e00dfd3077644b,
    __param: $2dc6d9f7b15bc14b$export$d5ad3fd78186038f,
    __metadata: $2dc6d9f7b15bc14b$export$f1db080c865becb9,
    __awaiter: $2dc6d9f7b15bc14b$export$1050f835b63b671e,
    __generator: $2dc6d9f7b15bc14b$export$67ebef60e6f28a6,
    __createBinding: $2dc6d9f7b15bc14b$export$45d3717a4c69092e,
    __exportStar: $2dc6d9f7b15bc14b$export$f33643c0debef087,
    __values: $2dc6d9f7b15bc14b$export$19a8beecd37a4c45,
    __read: $2dc6d9f7b15bc14b$export$8d051b38c9118094,
    __spread: $2dc6d9f7b15bc14b$export$afc72e2116322959,
    __spreadArrays: $2dc6d9f7b15bc14b$export$6388937ca91ccae8,
    __spreadArray: $2dc6d9f7b15bc14b$export$1216008129fb82ed,
    __await: $2dc6d9f7b15bc14b$export$10c90e4f7922046c,
    __asyncGenerator: $2dc6d9f7b15bc14b$export$e427f37a30a4de9b,
    __asyncDelegator: $2dc6d9f7b15bc14b$export$bbd80228419bb833,
    __asyncValues: $2dc6d9f7b15bc14b$export$e3b29a3d6162315f,
    __makeTemplateObject: $2dc6d9f7b15bc14b$export$4fb47efe1390b86f,
    __importStar: $2dc6d9f7b15bc14b$export$c21735bcef00d192,
    __importDefault: $2dc6d9f7b15bc14b$export$da59b14a69baef04,
    __classPrivateFieldGet: $2dc6d9f7b15bc14b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2dc6d9f7b15bc14b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2dc6d9f7b15bc14b$export$81fdc39f203e4e04,
    __addDisposableResource: $2dc6d9f7b15bc14b$export$88ac25d8e944e405,
    __disposeResources: $2dc6d9f7b15bc14b$export$8f076105dc360e92
};

});

parcelRegister("e6Bvx", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $a44eb87beacbcf31$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $a44eb87beacbcf31$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $a44eb87beacbcf31$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $a44eb87beacbcf31$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $a44eb87beacbcf31$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $a44eb87beacbcf31$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $a44eb87beacbcf31$export$3fae2929ed23c202(map, pl, field) {
    return $a44eb87beacbcf31$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $a44eb87beacbcf31$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $a44eb87beacbcf31$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $a44eb87beacbcf31$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $a44eb87beacbcf31$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $a44eb87beacbcf31$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("hTtGr", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $d06e993f714ddf2c$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $d06e993f714ddf2c$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $d06e993f714ddf2c$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $d06e993f714ddf2c$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $d06e993f714ddf2c$export$4ee1db8ce44a209b);

var $3VFsf = parcelRequire("3VFsf");

var $9m0GT = parcelRequire("9m0GT");

var $gkBUA = parcelRequire("gkBUA");

var $f1pKW = parcelRequire("f1pKW");
function $d06e993f714ddf2c$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $d06e993f714ddf2c$var$defaultErrorHandler = function(error) {};
var $d06e993f714ddf2c$var$defaultWarnHandler = function(warning) {};
var $d06e993f714ddf2c$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $d06e993f714ddf2c$var$defaultErrorHandler,
    onWarn: $d06e993f714ddf2c$var$defaultWarnHandler
};
function $d06e993f714ddf2c$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $d06e993f714ddf2c$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $d06e993f714ddf2c$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $d06e993f714ddf2c$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $gkBUA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3VFsf.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $gkBUA.strategies).variadic
    });
    var getNumberFormat = (0, $gkBUA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3VFsf.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.number),
        strategy: (0, $gkBUA.strategies).variadic
    });
    var getPluralRules = (0, $gkBUA.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3VFsf.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $gkBUA.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $gkBUA.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $9m0GT.IntlMessageFormat)(message, locales, overrideFormats, (0, $3VFsf.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.message),
            strategy: (0, $gkBUA.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $gkBUA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $gkBUA.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $gkBUA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.list),
            strategy: (0, $gkBUA.strategies).variadic
        }),
        getDisplayNames: (0, $gkBUA.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $d06e993f714ddf2c$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $gkBUA.strategies).variadic
        })
    };
}
function $d06e993f714ddf2c$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $f1pKW.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("9m0GT", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $6cf6b45354286df1$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $3VFsf = parcelRequire("3VFsf");

var $92gLf = parcelRequire("92gLf");

var $gkBUA = parcelRequire("gkBUA");

var $fEHjD = parcelRequire("fEHjD");
// -- MessageFormat --------------------------------------------------------
function $6cf6b45354286df1$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $6cf6b45354286df1$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $6cf6b45354286df1$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $3VFsf.__assign)({}, defaultConfig));
}
function $6cf6b45354286df1$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6cf6b45354286df1$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $gkBUA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cf6b45354286df1$var$createFastMemoizeCache(cache.number),
            strategy: (0, $gkBUA.strategies).variadic
        }),
        getDateTimeFormat: (0, $gkBUA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cf6b45354286df1$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $gkBUA.strategies).variadic
        }),
        getPluralRules: (0, $gkBUA.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $3VFsf.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cf6b45354286df1$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $gkBUA.strategies).variadic
        })
    };
}
var $6cf6b45354286df1$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $fEHjD.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $fEHjD.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $6cf6b45354286df1$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $6cf6b45354286df1$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $92gLf.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("92gLf", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("aW1IV")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("aW1IV")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("aW1IV")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("aW1IV")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("aW1IV")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("aW1IV")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("aW1IV")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("aW1IV")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("aW1IV")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("aW1IV")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("aW1IV")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("aW1IV")).TYPE);

$parcel$export(module.exports, "parse", () => $69414d612b928033$export$98e6a39c04603d36);

var $3VFsf = parcelRequire("3VFsf");

var $fO6rj = parcelRequire("fO6rj");

var $hkg45 = parcelRequire("hkg45");

var $aW1IV = parcelRequire("aW1IV");
function $69414d612b928033$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $aW1IV.isSelectElement)(el) || (0, $aW1IV.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $69414d612b928033$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $aW1IV.isNumberElement)(el) && (0, $aW1IV.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $aW1IV.isDateElement)(el) || (0, $aW1IV.isTimeElement)(el)) && (0, $aW1IV.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $aW1IV.isTagElement)(el)) $69414d612b928033$var$pruneLocation(el.children);
    });
}
function $69414d612b928033$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $3VFsf.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $hkg45.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $fO6rj.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $69414d612b928033$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("fO6rj", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $b820854b810d0ba8$export$896afd8541959ee5);
var $b820854b810d0ba8$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($b820854b810d0ba8$export$896afd8541959ee5 || ($b820854b810d0ba8$export$896afd8541959ee5 = {}));

});

parcelRegister("hkg45", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $c9d0c40ecda59600$export$7acfa6ed01010e37);

var $3VFsf = parcelRequire("3VFsf");

var $fO6rj = parcelRequire("fO6rj");

var $aW1IV = parcelRequire("aW1IV");

var $G9RoT = parcelRequire("G9RoT");
parcelRequire("2sUPe");
var $jH2zT = parcelRequire("jH2zT");
var $g0UVg = parcelRequire("g0UVg");

var $jDmUV = parcelRequire("jDmUV");
var $c9d0c40ecda59600$var$_a;
var $c9d0c40ecda59600$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $G9RoT.SPACE_SEPARATOR_REGEX).source, "*"));
var $c9d0c40ecda59600$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $G9RoT.SPACE_SEPARATOR_REGEX).source, "*$"));
function $c9d0c40ecda59600$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $c9d0c40ecda59600$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $c9d0c40ecda59600$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $c9d0c40ecda59600$var$hasNativeFromEntries = !!Object.fromEntries;
var $c9d0c40ecda59600$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $c9d0c40ecda59600$var$hasTrimStart = !!String.prototype.trimStart;
var $c9d0c40ecda59600$var$hasTrimEnd = !!String.prototype.trimEnd;
var $c9d0c40ecda59600$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $c9d0c40ecda59600$var$isSafeInteger = $c9d0c40ecda59600$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $c9d0c40ecda59600$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $c9d0c40ecda59600$var$re = $c9d0c40ecda59600$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $c9d0c40ecda59600$var$REGEX_SUPPORTS_U_AND_Y = (($c9d0c40ecda59600$var$_a = $c9d0c40ecda59600$var$re.exec('a')) === null || $c9d0c40ecda59600$var$_a === void 0 ? void 0 : $c9d0c40ecda59600$var$_a[0]) === 'a';
} catch (_) {
    $c9d0c40ecda59600$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $c9d0c40ecda59600$var$startsWith = $c9d0c40ecda59600$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $c9d0c40ecda59600$var$fromCodePoint = $c9d0c40ecda59600$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $c9d0c40ecda59600$var$fromEntries = // native
$c9d0c40ecda59600$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $c9d0c40ecda59600$var$codePointAt = $c9d0c40ecda59600$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $c9d0c40ecda59600$var$trimStart = $c9d0c40ecda59600$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($c9d0c40ecda59600$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $c9d0c40ecda59600$var$trimEnd = $c9d0c40ecda59600$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($c9d0c40ecda59600$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $c9d0c40ecda59600$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $c9d0c40ecda59600$var$matchIdentifierAtIndex;
if ($c9d0c40ecda59600$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $c9d0c40ecda59600$var$IDENTIFIER_PREFIX_RE_1 = $c9d0c40ecda59600$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $c9d0c40ecda59600$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $c9d0c40ecda59600$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $c9d0c40ecda59600$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$c9d0c40ecda59600$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $c9d0c40ecda59600$var$codePointAt(s, index);
        if (c === undefined || $c9d0c40ecda59600$var$_isWhiteSpace(c) || $c9d0c40ecda59600$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $c9d0c40ecda59600$var$fromCodePoint.apply(void 0, match);
};
var $c9d0c40ecda59600$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $aW1IV.TYPE).pound,
                    location: $c9d0c40ecda59600$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $fO6rj.ErrorKind).UNMATCHED_CLOSING_TAG, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $c9d0c40ecda59600$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $aW1IV.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $c9d0c40ecda59600$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$c9d0c40ecda59600$var$_isAlpha(this.char())) return this.error((0, $fO6rj.ErrorKind).INVALID_TAG, $c9d0c40ecda59600$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $fO6rj.ErrorKind).UNMATCHED_CLOSING_TAG, $c9d0c40ecda59600$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $fO6rj.ErrorKind).INVALID_TAG, $c9d0c40ecda59600$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $aW1IV.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $c9d0c40ecda59600$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $fO6rj.ErrorKind).UNCLOSED_TAG, $c9d0c40ecda59600$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $fO6rj.ErrorKind).INVALID_TAG, $c9d0c40ecda59600$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $c9d0c40ecda59600$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $c9d0c40ecda59600$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $aW1IV.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$c9d0c40ecda59600$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $c9d0c40ecda59600$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $c9d0c40ecda59600$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $fO6rj.ErrorKind).EMPTY_ARGUMENT, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $fO6rj.ErrorKind).MALFORMED_ARGUMENT, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $aW1IV.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $fO6rj.ErrorKind).MALFORMED_ARGUMENT, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $c9d0c40ecda59600$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $c9d0c40ecda59600$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_TYPE, $c9d0c40ecda59600$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $c9d0c40ecda59600$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_STYLE, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $c9d0c40ecda59600$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $c9d0c40ecda59600$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $c9d0c40ecda59600$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $aW1IV.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $fO6rj.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $jDmUV.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $aW1IV.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $jH2zT.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $aW1IV.TYPE).date : (0, $aW1IV.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $aW1IV.TYPE).number : argType === 'date' ? (0, $aW1IV.TYPE).date : (0, $aW1IV.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $fO6rj.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $c9d0c40ecda59600$var$createLocation(typeEndPosition_1, (0, $3VFsf.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $fO6rj.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $fO6rj.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $fO6rj.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $aW1IV.TYPE).select,
                        value: value,
                        options: $c9d0c40ecda59600$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $aW1IV.TYPE).plural,
                        value: value,
                        options: $c9d0c40ecda59600$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $fO6rj.ErrorKind).INVALID_ARGUMENT_TYPE, $c9d0c40ecda59600$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $fO6rj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $fO6rj.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $c9d0c40ecda59600$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $g0UVg.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $fO6rj.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $aW1IV.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $g0UVg.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $fO6rj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $fO6rj.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $c9d0c40ecda59600$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $fO6rj.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $fO6rj.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $fO6rj.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $fO6rj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $c9d0c40ecda59600$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $fO6rj.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $fO6rj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $fO6rj.ErrorKind).MISSING_OTHER_CLAUSE, $c9d0c40ecda59600$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $c9d0c40ecda59600$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$c9d0c40ecda59600$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $c9d0c40ecda59600$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($c9d0c40ecda59600$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $c9d0c40ecda59600$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $c9d0c40ecda59600$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $c9d0c40ecda59600$var$_isAlphaOrSlash(codepoint) {
    return $c9d0c40ecda59600$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $c9d0c40ecda59600$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c9d0c40ecda59600$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c9d0c40ecda59600$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("aW1IV", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $7f60a86fc78ec915$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $7f60a86fc78ec915$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $7f60a86fc78ec915$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $7f60a86fc78ec915$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $7f60a86fc78ec915$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $7f60a86fc78ec915$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $7f60a86fc78ec915$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $7f60a86fc78ec915$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $7f60a86fc78ec915$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $7f60a86fc78ec915$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $7f60a86fc78ec915$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $7f60a86fc78ec915$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $7f60a86fc78ec915$export$7680c41f1a55f4cf);
var $7f60a86fc78ec915$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($7f60a86fc78ec915$export$b87f371cbc396fcf || ($7f60a86fc78ec915$export$b87f371cbc396fcf = {}));
var $7f60a86fc78ec915$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($7f60a86fc78ec915$export$906452485466fa53 || ($7f60a86fc78ec915$export$906452485466fa53 = {}));
function $7f60a86fc78ec915$export$cfa10c5697238752(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.literal;
}
function $7f60a86fc78ec915$export$4f55724281bdfaf9(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.argument;
}
function $7f60a86fc78ec915$export$e11187b219e191e1(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.number;
}
function $7f60a86fc78ec915$export$32d811605da75f40(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.date;
}
function $7f60a86fc78ec915$export$34ec46f596b1702f(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.time;
}
function $7f60a86fc78ec915$export$dcfe1c11d168b5a1(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.select;
}
function $7f60a86fc78ec915$export$6c796d116f0a4fbc(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.plural;
}
function $7f60a86fc78ec915$export$c0ece297bdd0c082(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.pound;
}
function $7f60a86fc78ec915$export$5c83de34745812b(el) {
    return el.type === $7f60a86fc78ec915$export$b87f371cbc396fcf.tag;
}
function $7f60a86fc78ec915$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $7f60a86fc78ec915$export$906452485466fa53.number);
}
function $7f60a86fc78ec915$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $7f60a86fc78ec915$export$906452485466fa53.dateTime);
}
function $7f60a86fc78ec915$export$f0ac572c1121c662(value) {
    return {
        type: $7f60a86fc78ec915$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $7f60a86fc78ec915$export$425e864b0ba114f1(value, style) {
    return {
        type: $7f60a86fc78ec915$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("G9RoT", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $07eb9268724ce9d1$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $07eb9268724ce9d1$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $07eb9268724ce9d1$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("2sUPe", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("jH2zT")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("g0UVg")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("g0UVg")).parseNumberSkeletonFromString);
parcelRequire("jH2zT");
parcelRequire("g0UVg");

});
parcelRegister("jH2zT", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $e5640860b41c32dd$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $e5640860b41c32dd$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $e5640860b41c32dd$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($e5640860b41c32dd$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("g0UVg", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $ba88cd1608661f13$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $ba88cd1608661f13$export$47c6f8480bda3e11);

var $3VFsf = parcelRequire("3VFsf");

var $8cBek = parcelRequire("8cBek");
function $ba88cd1608661f13$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $8cBek.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $ba88cd1608661f13$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $ba88cd1608661f13$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $ba88cd1608661f13$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $ba88cd1608661f13$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $ba88cd1608661f13$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $ba88cd1608661f13$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($ba88cd1608661f13$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $ba88cd1608661f13$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $ba88cd1608661f13$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$ba88cd1608661f13$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $ba88cd1608661f13$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $ba88cd1608661f13$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $ba88cd1608661f13$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $ba88cd1608661f13$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, all), $ba88cd1608661f13$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, all), $ba88cd1608661f13$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($ba88cd1608661f13$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($ba88cd1608661f13$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($ba88cd1608661f13$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($ba88cd1608661f13$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), $ba88cd1608661f13$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($ba88cd1608661f13$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), $ba88cd1608661f13$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $ba88cd1608661f13$var$parseSign(token.stem);
        if (signOpts) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $ba88cd1608661f13$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("8cBek", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $5f8c52db6a9b2205$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $5f8c52db6a9b2205$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("jDmUV", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $e4b36fb83a1a7ed7$export$29c5368be8904d27);

var $g5cdh = parcelRequire("g5cdh");
function $e4b36fb83a1a7ed7$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $e4b36fb83a1a7ed7$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $e4b36fb83a1a7ed7$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $g5cdh.timeData)[regionTag || ''] || (0, $g5cdh.timeData)[languageTag || ''] || (0, $g5cdh.timeData)["".concat(languageTag, "-001")] || (0, $g5cdh.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("g5cdh", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $bb56964241ac3a5f$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $bb56964241ac3a5f$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("gkBUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3bec17e79057a9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "strategies", () => $be3bec17e79057a9$export$c5491a8691a23b9e);
//
// Main
//
function $be3bec17e79057a9$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $be3bec17e79057a9$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $be3bec17e79057a9$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $be3bec17e79057a9$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $be3bec17e79057a9$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $be3bec17e79057a9$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $be3bec17e79057a9$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $be3bec17e79057a9$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $be3bec17e79057a9$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $be3bec17e79057a9$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $be3bec17e79057a9$var$monadic : $be3bec17e79057a9$var$variadic;
    return $be3bec17e79057a9$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $be3bec17e79057a9$var$strategyVariadic(fn, options) {
    return $be3bec17e79057a9$var$assemble(fn, this, $be3bec17e79057a9$var$variadic, options.cache.create(), options.serializer);
}
function $be3bec17e79057a9$var$strategyMonadic(fn, options) {
    return $be3bec17e79057a9$var$assemble(fn, this, $be3bec17e79057a9$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $be3bec17e79057a9$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $be3bec17e79057a9$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$be3bec17e79057a9$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$be3bec17e79057a9$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $be3bec17e79057a9$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $be3bec17e79057a9$var$ObjectWithoutPrototypeCache();
    }
};
var $be3bec17e79057a9$export$c5491a8691a23b9e = {
    variadic: $be3bec17e79057a9$var$strategyVariadic,
    monadic: $be3bec17e79057a9$var$strategyMonadic
};

});

parcelRegister("fEHjD", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $b65c310cd6e62349$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $b65c310cd6e62349$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $b65c310cd6e62349$export$275d4a3bb5f66fda);
parcelRequire("92gLf");
var $aW1IV = parcelRequire("aW1IV");

var $8LVy2 = parcelRequire("8LVy2");
var $b65c310cd6e62349$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($b65c310cd6e62349$export$49694c2877b44c57 || ($b65c310cd6e62349$export$49694c2877b44c57 = {}));
function $b65c310cd6e62349$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $b65c310cd6e62349$export$49694c2877b44c57.literal || part.type !== $b65c310cd6e62349$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $b65c310cd6e62349$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $b65c310cd6e62349$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $aW1IV.isLiteralElement)(els[0])) return [
        {
            type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $aW1IV.isLiteralElement)(el)) {
            result.push({
                type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $aW1IV.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $8LVy2.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $aW1IV.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $b65c310cd6e62349$export$49694c2877b44c57.literal : $b65c310cd6e62349$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $aW1IV.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $aW1IV.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $aW1IV.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $aW1IV.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $aW1IV.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $aW1IV.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $b65c310cd6e62349$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $aW1IV.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$b65c310cd6e62349$export$df0c12a2d414a163(formatFn)) throw new (0, $8LVy2.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $b65c310cd6e62349$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $b65c310cd6e62349$export$49694c2877b44c57.literal : $b65c310cd6e62349$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $aW1IV.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $8LVy2.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $b65c310cd6e62349$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $aW1IV.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $8LVy2.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8LVy2.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $8LVy2.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $b65c310cd6e62349$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $b65c310cd6e62349$var$mergeLiteral(result);
}

});
parcelRegister("8LVy2", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $662f5a56ca4164bd$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $662f5a56ca4164bd$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $662f5a56ca4164bd$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $662f5a56ca4164bd$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $662f5a56ca4164bd$export$8bfc137e4d23fdf0);

var $3VFsf = parcelRequire("3VFsf");
var $662f5a56ca4164bd$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($662f5a56ca4164bd$export$d4e71bc0b80dc0fb || ($662f5a56ca4164bd$export$d4e71bc0b80dc0fb = {}));
var $662f5a56ca4164bd$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $662f5a56ca4164bd$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $662f5a56ca4164bd$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($662f5a56ca4164bd$export$7369836851cc1329);
var $662f5a56ca4164bd$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $662f5a56ca4164bd$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($662f5a56ca4164bd$export$7369836851cc1329);
var $662f5a56ca4164bd$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $662f5a56ca4164bd$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($662f5a56ca4164bd$export$7369836851cc1329);

});



parcelRegister("f1pKW", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", () => $aefaeda8bfc4331c$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $aefaeda8bfc4331c$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $aefaeda8bfc4331c$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $aefaeda8bfc4331c$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $aefaeda8bfc4331c$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $aefaeda8bfc4331c$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $aefaeda8bfc4331c$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $aefaeda8bfc4331c$export$2ddcb436d0aa3688);

var $3VFsf = parcelRequire("3VFsf");
var $aefaeda8bfc4331c$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($aefaeda8bfc4331c$export$557d6acb76e8a244 || ($aefaeda8bfc4331c$export$557d6acb76e8a244 = {}));
var $aefaeda8bfc4331c$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $aefaeda8bfc4331c$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $aefaeda8bfc4331c$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($aefaeda8bfc4331c$export$c016d36112f6ddf8);
var $aefaeda8bfc4331c$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $aefaeda8bfc4331c$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($aefaeda8bfc4331c$export$c016d36112f6ddf8);
var $aefaeda8bfc4331c$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $aefaeda8bfc4331c$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($aefaeda8bfc4331c$export$c016d36112f6ddf8);
var $aefaeda8bfc4331c$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $aefaeda8bfc4331c$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($aefaeda8bfc4331c$export$c016d36112f6ddf8);
var $aefaeda8bfc4331c$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($aefaeda8bfc4331c$export$e3b7eee1dbc44895);
var $aefaeda8bfc4331c$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $3VFsf.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $aefaeda8bfc4331c$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($aefaeda8bfc4331c$export$c016d36112f6ddf8);

});


parcelRegister("38q5N", function(module, exports) {

$parcel$export(module.exports, "createIntl", () => $24865be6fa6bf101$export$7e4cbedfdd7b4c0d);

var $3VFsf = parcelRequire("3VFsf");

var $hTtGr = parcelRequire("hTtGr");

var $f1pKW = parcelRequire("f1pKW");

var $at1OZ = parcelRequire("at1OZ");

var $9IdL2 = parcelRequire("9IdL2");

var $5codw = parcelRequire("5codw");

var $6RQEF = parcelRequire("6RQEF");

var $2RJG2 = parcelRequire("2RJG2");

var $32FOw = parcelRequire("32FOw");

var $eH9h0 = parcelRequire("eH9h0");
function $24865be6fa6bf101$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $24865be6fa6bf101$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $24865be6fa6bf101$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $24865be6fa6bf101$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $hTtGr.createFormatters)(cache);
    var resolvedConfig = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, (0, $hTtGr.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $f1pKW.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $f1pKW.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $f1pKW.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $24865be6fa6bf101$var$verifyConfigMessages(resolvedConfig);
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $at1OZ.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $at1OZ.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $9IdL2.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $5codw.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $5codw.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $5codw.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $5codw.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $5codw.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $6RQEF.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $2RJG2.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $2RJG2.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $32FOw.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $32FOw.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $eH9h0.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("at1OZ", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $79ee0681c6192cf5$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $79ee0681c6192cf5$export$6871080848f10b2f);

var $hTtGr = parcelRequire("hTtGr");

var $f1pKW = parcelRequire("f1pKW");
var $79ee0681c6192cf5$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $79ee0681c6192cf5$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $hTtGr.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $hTtGr.filterProps)(options, $79ee0681c6192cf5$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $79ee0681c6192cf5$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $79ee0681c6192cf5$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $79ee0681c6192cf5$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $79ee0681c6192cf5$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("9IdL2", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", () => $7122e51b1ccd3d10$export$b4ea3b48dcf921f6);

var $hTtGr = parcelRequire("hTtGr");

var $8LVy2 = parcelRequire("8LVy2");

var $f1pKW = parcelRequire("f1pKW");
var $7122e51b1ccd3d10$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $7122e51b1ccd3d10$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $hTtGr.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $hTtGr.filterProps)(options, $7122e51b1ccd3d10$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $7122e51b1ccd3d10$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $8LVy2.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $8LVy2.ErrorCode).MISSING_INTL_API));
    try {
        return $7122e51b1ccd3d10$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("5codw", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $3c90dbc4a4c31dd9$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $3c90dbc4a4c31dd9$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $3c90dbc4a4c31dd9$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $3c90dbc4a4c31dd9$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $3c90dbc4a4c31dd9$export$af6e5d7a5c73edeb);

var $3VFsf = parcelRequire("3VFsf");

var $hTtGr = parcelRequire("hTtGr");

var $f1pKW = parcelRequire("f1pKW");
var $3c90dbc4a4c31dd9$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $3c90dbc4a4c31dd9$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $hTtGr.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $hTtGr.filterProps)(options, $3c90dbc4a4c31dd9$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $3c90dbc4a4c31dd9$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $3c90dbc4a4c31dd9$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $3c90dbc4a4c31dd9$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $3c90dbc4a4c31dd9$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $3c90dbc4a4c31dd9$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $hTtGr.filterProps)(options, $3c90dbc4a4c31dd9$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $3c90dbc4a4c31dd9$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $3c90dbc4a4c31dd9$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $3c90dbc4a4c31dd9$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $3c90dbc4a4c31dd9$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("6RQEF", function(module, exports) {

$parcel$export(module.exports, "formatPlural", () => $500089813cf887c9$export$bbbd05c900f3568d);

var $hTtGr = parcelRequire("hTtGr");

var $f1pKW = parcelRequire("f1pKW");

var $8LVy2 = parcelRequire("8LVy2");
var $500089813cf887c9$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $500089813cf887c9$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $8LVy2.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $8LVy2.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $hTtGr.filterProps)(options, $500089813cf887c9$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $f1pKW.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("2RJG2", function(module, exports) {

$parcel$export(module.exports, "formatMessage", () => $2163f6883487cd1d$export$25868d1e8e76735f);

var $3VFsf = parcelRequire("3VFsf");

var $e6Bvx = parcelRequire("e6Bvx");

var $9m0GT = parcelRequire("9m0GT");

var $f1pKW = parcelRequire("f1pKW");
parcelRequire("92gLf");
var $aW1IV = parcelRequire("aW1IV");
function $2163f6883487cd1d$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $3VFsf.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $2163f6883487cd1d$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $2163f6883487cd1d$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9m0GT.IntlMessageFormat).formats;
    return (0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, mfFormats), f1), {
        date: $2163f6883487cd1d$var$deepMergeOptions($2163f6883487cd1d$var$setTimeZoneInOptions(mfFormats.date, timeZone), $2163f6883487cd1d$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $2163f6883487cd1d$var$deepMergeOptions($2163f6883487cd1d$var$setTimeZoneInOptions(mfFormats.time, timeZone), $2163f6883487cd1d$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $2163f6883487cd1d$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $e6Bvx.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $aW1IV.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, defaultRichTextElements), values || {});
    formats = $2163f6883487cd1d$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $2163f6883487cd1d$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $f1pKW.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $f1pKW.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $3VFsf.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $f1pKW.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $f1pKW.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}

});

parcelRegister("32FOw", function(module, exports) {

$parcel$export(module.exports, "formatList", () => $2371fe59d300556f$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $2371fe59d300556f$export$6f284aad1934db69);

var $3VFsf = parcelRequire("3VFsf");

var $hTtGr = parcelRequire("hTtGr");

var $8LVy2 = parcelRequire("8LVy2");

var $f1pKW = parcelRequire("f1pKW");
var $2371fe59d300556f$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $2371fe59d300556f$var$now = Date.now();
function $2371fe59d300556f$var$generateToken(i) {
    return "".concat($2371fe59d300556f$var$now, "_").concat(i, "_").concat($2371fe59d300556f$var$now);
}
function $2371fe59d300556f$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $2371fe59d300556f$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $2371fe59d300556f$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $8LVy2.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $8LVy2.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $hTtGr.filterProps)(options, $2371fe59d300556f$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $2371fe59d300556f$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("eH9h0", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", () => $ab2c464d4bb32d6f$export$62fe1a4d9e891fa2);

var $hTtGr = parcelRequire("hTtGr");

var $8LVy2 = parcelRequire("8LVy2");

var $f1pKW = parcelRequire("f1pKW");
var $ab2c464d4bb32d6f$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $ab2c464d4bb32d6f$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $8LVy2.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $8LVy2.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $hTtGr.filterProps)(options, $ab2c464d4bb32d6f$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $f1pKW.IntlError)((0, $f1pKW.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});


parcelRegister("gKZoD", function(module, exports) {

$parcel$export(module.exports, "di", () => $c330913db3f18753$export$479d1ccc5f2ab701);

var $kuH7D = parcelRequire("kuH7D");

var $baQns = parcelRequire("baQns");
function $c330913db3f18753$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $kuH7D.Context)._currentRenderer2 && (0, $kuH7D.Context)._currentValue2 || // grab value from default renderer
    (0, $kuH7D.Context)._currentValue || (0, $baQns.globalDi);
    return getDependencies(deps, target);
}

});
parcelRegister("kuH7D", function(module, exports) {

$parcel$export(module.exports, "Context", () => $eeb80f296af213d3$export$841858b892ce1f4c);

var $5uXOq = parcelRequire("5uXOq");

var $baQns = parcelRequire("baQns");
const $eeb80f296af213d3$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({
    getDependencies: (0, $baQns.globalDi).getDependencies
});

});
parcelRegister("baQns", function(module, exports) {

$parcel$export(module.exports, "globalDi", () => $822941ec920432a4$export$a775919ebd7dd28a);

var $53fwy = parcelRequire("53fwy");

var $gbS7D = parcelRequire("gbS7D");
const $822941ec920432a4$var$replacementMap = new Map();
const $822941ec920432a4$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($822941ec920432a4$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $gbS7D.findInjectable)($822941ec920432a4$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($822941ec920432a4$var$replacementMap.size) throw new Error(`${(0, $53fwy.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $gbS7D.addInjectableToMap)($822941ec920432a4$var$replacementMap, inj));
    },
    clear () {
        $822941ec920432a4$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $53fwy.diRegistry).get(inj).global) (0, $gbS7D.addInjectableToMap)($822941ec920432a4$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $gbS7D.removeInjectableFromMap)($822941ec920432a4$var$replacementMap, inj));
    }
};
function $822941ec920432a4$export$b887ce09d70113f9(thunk, deps) {
    $822941ec920432a4$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function' && typeof result.finally === 'function') result.finally($822941ec920432a4$export$a775919ebd7dd28a.clear);
        else $822941ec920432a4$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("53fwy", function(module, exports) {

$parcel$export(module.exports, "diRegistry", () => $3ad946528df32797$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $3ad946528df32797$export$b8b9d90f9e5bd72b);
const $3ad946528df32797$export$4203fb010fad9bf0 = new WeakMap();
const $3ad946528df32797$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("gbS7D", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $bc97a7ed7f44645a$export$5b28268982f175ba);
$parcel$export(module.exports, "addInjectableToMap", () => $bc97a7ed7f44645a$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $bc97a7ed7f44645a$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $bc97a7ed7f44645a$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $bc97a7ed7f44645a$export$7c436e151c3ee289);

var $53fwy = parcelRequire("53fwy");

var $duJai = parcelRequire("duJai");
let $bc97a7ed7f44645a$var$hasWarned = false;
function $bc97a7ed7f44645a$export$5b28268982f175ba(message) {
    if (!$bc97a7ed7f44645a$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $bc97a7ed7f44645a$var$hasWarned = true;
    }
}
function $bc97a7ed7f44645a$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $53fwy.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $duJai.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $bc97a7ed7f44645a$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $53fwy.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $bc97a7ed7f44645a$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $bc97a7ed7f44645a$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $bc97a7ed7f44645a$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $duJai.stats).track(candidate);
    return candidate;
}

});
parcelRegister("duJai", function(module, exports) {

$parcel$export(module.exports, "stats", () => $9d311c8dcfd06b8d$export$7804429c45dff272);
const $9d311c8dcfd06b8d$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $9d311c8dcfd06b8d$export$7804429c45dff272 = {
    state: $9d311c8dcfd06b8d$var$createState(),
    set (injObj) {
        var _injObj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === injObj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(injObj, new Error(`Unused "di" injectable: ${((_injObj$value = injObj.value) == null ? void 0 : _injObj$value.displayName) || injObj.value}.`, {
            cause: injObj.cause
        }));
        // reset to avoid potential memory leaks via stack traces
        injObj.cause = null;
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
    },
    reset () {
        this.state = $9d311c8dcfd06b8d$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("e5wyW", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $12199147dc0ae1fa$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $12199147dc0ae1fa$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $12199147dc0ae1fa$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $12199147dc0ae1fa$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("7zHWg", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $583de2969a487e4e$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $583de2969a487e4e$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $583de2969a487e4e$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $583de2969a487e4e$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $583de2969a487e4e$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $583de2969a487e4e$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $583de2969a487e4e$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $583de2969a487e4e$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $583de2969a487e4e$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $583de2969a487e4e$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $583de2969a487e4e$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $583de2969a487e4e$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $583de2969a487e4e$export$e262da7ae6480481);

var $3VFsf = parcelRequire("3VFsf");

var $3kk8J = parcelRequire("3kk8J");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $583de2969a487e4e$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $3kk8J.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $3VFsf.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $583de2969a487e4e$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $583de2969a487e4e$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $583de2969a487e4e$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $583de2969a487e4e$var$callOnHub('captureMessage', message, level, (0, $3VFsf.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $583de2969a487e4e$export$1462b974fdcf6ba2(event) {
    return $583de2969a487e4e$var$callOnHub('captureEvent', event);
}
function $583de2969a487e4e$export$99d44f04437e9cb8(callback) {
    $583de2969a487e4e$var$callOnHub('configureScope', callback);
}
function $583de2969a487e4e$export$efda9a273d7a036d(breadcrumb) {
    $583de2969a487e4e$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $583de2969a487e4e$export$2f04de43fe27971a(name, context) {
    $583de2969a487e4e$var$callOnHub('setContext', name, context);
}
function $583de2969a487e4e$export$bb4922da0dd51b92(extras) {
    $583de2969a487e4e$var$callOnHub('setExtras', extras);
}
function $583de2969a487e4e$export$74a8fb34822092e6(tags) {
    $583de2969a487e4e$var$callOnHub('setTags', tags);
}
function $583de2969a487e4e$export$8e8e7789d42ed61d(key, extra) {
    $583de2969a487e4e$var$callOnHub('setExtra', key, extra);
}
function $583de2969a487e4e$export$a37d07ee78eb4569(key, value) {
    $583de2969a487e4e$var$callOnHub('setTag', key, value);
}
function $583de2969a487e4e$export$8b6bb3dd62a01be2(user) {
    $583de2969a487e4e$var$callOnHub('setUser', user);
}
function $583de2969a487e4e$export$ec58d9285c204497(callback) {
    $583de2969a487e4e$var$callOnHub('withScope', callback);
}
function $583de2969a487e4e$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $583de2969a487e4e$var$callOnHub.apply(void 0, (0, $3VFsf.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $583de2969a487e4e$export$e262da7ae6480481(context, customSamplingContext) {
    return $583de2969a487e4e$var$callOnHub('startTransaction', (0, $3VFsf.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("3kk8J", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $26c2dcb27d4dffef$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $26c2dcb27d4dffef$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $26c2dcb27d4dffef$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $26c2dcb27d4dffef$export$a07cdf6544bbd7c);

var $3VFsf = parcelRequire("3VFsf");

var $3xuhl = parcelRequire("3xuhl");

var $23Apf = parcelRequire("23Apf");

var $gfYRq = parcelRequire("gfYRq");

var $lTZg9 = parcelRequire("lTZg9");
var $26c2dcb27d4dffef$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $26c2dcb27d4dffef$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $gfYRq.Scope)();
        if (_version === void 0) _version = $26c2dcb27d4dffef$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $gfYRq.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3xuhl.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $3xuhl.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $3xuhl.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $3xuhl.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $3VFsf.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $3xuhl.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $26c2dcb27d4dffef$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $26c2dcb27d4dffef$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $23Apf.IS_DEBUG_BUILD) && (0, $3xuhl.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $3xuhl.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $lTZg9.Session)((0, $3VFsf.__assign)((0, $3VFsf.__assign)((0, $3VFsf.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $3VFsf.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $26c2dcb27d4dffef$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $23Apf.IS_DEBUG_BUILD) && (0, $3xuhl.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $26c2dcb27d4dffef$export$19eade501500c6c1() {
    var carrier = (0, $3xuhl.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $26c2dcb27d4dffef$export$4188a14ad302d1bc(hub) {
    var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
    var oldHub = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $26c2dcb27d4dffef$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(registry) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, new $26c2dcb27d4dffef$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $3xuhl.isNodeEnv)()) return $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
}
function $26c2dcb27d4dffef$export$1c4d656130202699() {
    (0, $23Apf.IS_DEBUG_BUILD) && (0, $3xuhl.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(activeDomain) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) {
            var registryHubTopStack = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).getStackTop();
            $26c2dcb27d4dffef$export$849f05434e95d2f2(activeDomain, new $26c2dcb27d4dffef$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $gfYRq.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $26c2dcb27d4dffef$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $26c2dcb27d4dffef$export$bfa8a924a84a76b7(carrier) {
    return (0, $3xuhl.getGlobalSingleton)('hub', function() {
        return new $26c2dcb27d4dffef$export$8c41bb232f1008b1();
    }, carrier);
}
function $26c2dcb27d4dffef$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("23Apf", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $17f81a1bea39bc90$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $17f81a1bea39bc90$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("gfYRq", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $bd5d41be26a98453$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $bd5d41be26a98453$export$8e4e25f54d456511);

var $3VFsf = parcelRequire("3VFsf");

var $3xuhl = parcelRequire("3xuhl");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $bd5d41be26a98453$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $bd5d41be26a98453$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $3VFsf.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $3VFsf.__assign)({}, scope._tags);
            newScope._extra = (0, $3VFsf.__assign)({}, scope._extra);
            newScope._contexts = (0, $3VFsf.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $3VFsf.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $3xuhl.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $bd5d41be26a98453$var$MAX_BREADCRUMBS) : $bd5d41be26a98453$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $3VFsf.__assign)({
            timestamp: (0, $3xuhl.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $3VFsf.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $3VFsf.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $3VFsf.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $3VFsf.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $3VFsf.__spread)($bd5d41be26a98453$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $3xuhl.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $3VFsf.__assign)({}, event), hint);
                if ((0, $3xuhl.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $bd5d41be26a98453$var$getGlobalEventProcessors() {
    return (0, $3xuhl.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $bd5d41be26a98453$export$8e4e25f54d456511(callback) {
    $bd5d41be26a98453$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("lTZg9", function(module, exports) {

$parcel$export(module.exports, "Session", () => $ff1e40e1db4f1b32$export$1fb4852a55678982);

var $3xuhl = parcelRequire("3xuhl");
/**
 * @inheritdoc
 */ var $ff1e40e1db4f1b32$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $3xuhl.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $3xuhl.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $3xuhl.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $3xuhl.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $3xuhl.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("3joPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $26966771ccdfe4c1$export$2e2bcd8739ae039);
var $26966771ccdfe4c1$var$isProduction = true;
var $26966771ccdfe4c1$var$prefix = 'Invariant failed';
function $26966771ccdfe4c1$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($26966771ccdfe4c1$var$isProduction) throw new Error($26966771ccdfe4c1$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($26966771ccdfe4c1$var$prefix, ": ").concat(provided) : $26966771ccdfe4c1$var$prefix;
    throw new Error(value);
}

});

parcelRegister("lODMY", function(module, exports) {

$parcel$export(module.exports, "getRouterState", () => $275e9e2aae174a1c$export$ebf37f7e180b13a9);
$parcel$export(module.exports, "RouterStore", () => $275e9e2aae174a1c$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $275e9e2aae174a1c$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $275e9e2aae174a1c$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $275e9e2aae174a1c$export$ada49399abf7a3a1);
$parcel$export(module.exports, "createRouterSelector", () => $275e9e2aae174a1c$export$95ab46bba7ea7a22);
$parcel$export(module.exports, "useIsActiveRoute", () => $275e9e2aae174a1c$export$4273485d5c0831e0);
$parcel$export(module.exports, "addRouteListener", () => $275e9e2aae174a1c$export$6ec8251cd652e31a);

var $7bpAK = parcelRequire("7bpAK");

var $gKZoD = parcelRequire("gKZoD");

var $2YZCu = parcelRequire("2YZCu");

var $jp5kW = parcelRequire("jp5kW");

var $8dUCk = parcelRequire("8dUCk");
var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");

var $gqFAI = parcelRequire("gqFAI");

var $gowp1 = parcelRequire("gowp1");

var $9VXkC = parcelRequire("9VXkC");

var $9hyNx = parcelRequire("9hyNx");

var $2Gs5h = parcelRequire("2Gs5h");

var $jNUyg = parcelRequire("jNUyg");

var $l37Ss = parcelRequire("l37Ss");
const $275e9e2aae174a1c$export$36d128238e6b60f5 = {
    action: (0, $gqFAI.DEFAULT_ACTION),
    basePath: '',
    location: (0, $gqFAI.DEFAULT_HISTORY).location,
    history: (0, $gqFAI.DEFAULT_HISTORY),
    match: (0, $gqFAI.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $gqFAI.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: [],
    isLazyRoutes: false,
    hasPerformedLazyTransition: false
};
const $275e9e2aae174a1c$var$actions = {
    /**
	 * Bootstraps the store with initial data.
	 *
	 */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins, isLazyRoutes: isLazyRoutes } = props;
            const routerContext = (0, $jNUyg.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState({
                ...routerContext,
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins,
                isLazyRoutes: isLazyRoutes,
                hasPerformedLazyTransition: false
            });
            if (!(0, $9hyNx.isServerEnvironment)()) dispatch($275e9e2aae174a1c$var$actions.listen());
        },
    /**
	 * Starts listening to browser history and sets the unlisten function in state.
	 * Will request route resources on route change.
	 *
	 */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery, isLazyRoutes: isLazyRoutes, hasPerformedLazyTransition: hasPerformedLazyTransition } = getState();
                const nextContext = (0, $jNUyg.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $l37Ss.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                const updateState = ()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad?.({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    // If:
                    // * we are in the "lazy routes experiment",
                    // * we haven't killswitched this logger
                    // * and it's the first transition since loading the route list
                    // - log it as a "successful transition"
                    // This will let us work out a proper(-ish) success metric. Killswitch is just in case the
                    // log volume proves excessive
                    let nextHasPerformedLazyTransition = hasPerformedLazyTransition;
                    if (isLazyRoutes && !hasPerformedLazyTransition) {
                        if (!(0, $jp5kW.default)('lazyroute_success_logger')) // Since we're doing a transition, we don't need to await as this _should_ complete
                        // (and we don't want to block)
                        (0, $2YZCu.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'success', {
                            route: nextContext.route.name
                        });
                        nextHasPerformedLazyTransition = true;
                    }
                    setState({
                        ...nextContext,
                        location: location,
                        action: action,
                        hasPerformedLazyTransition: nextHasPerformedLazyTransition
                    });
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad?.({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                };
                updateState();
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            (0, $gKZoD.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $l37Ss.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(path);
            else history.push((0, $l37Ss.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $gowp1.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $2Gs5h.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes?.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            (0, $gKZoD.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $l37Ss.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.replace(path);
            else history.replace((0, $l37Ss.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $gowp1.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $2Gs5h.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes?.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = {
                ...existingQueryParams,
                ...params
            };
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $l37Ss.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $l37Ss.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = {
                ...existingPathParams,
                ...params
            };
            const updatedPath = (0, $9VXkC.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = {
                ...location,
                pathname: updatedPath
            };
            const existingRelativePath = (0, $l37Ss.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $l37Ss.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad?.({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $275e9e2aae174a1c$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $l37Ss.isExternalAbsolutePath)(path)) {
                const location = (0, $7bpAK.parsePath)((0, $l37Ss.getRelativePath)(path, basePath));
                // eslint-disable-next-line no-param-reassign
                nextContext = (0, $jNUyg.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $8dUCk.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch?.({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    setRoutes: (routes)=>({ getState: getState, setState: setState })=>{
            const { routes: currentRoutes, history: history } = getState();
            const currentRoutesByName = Object.fromEntries(currentRoutes.map((r)=>[
                    r.name,
                    r
                ]));
            // To ensure that history is preserved, we need to find any current routes
            // in the new route map, and ensure that object identity for that route
            // is preserved in the new route map
            for(let i = 0; i < routes.length; i++){
                const route = routes[i];
                if (Object.hasOwn(currentRoutesByName, route.name)) // eslint-disable-next-line no-param-reassign
                routes[i] = currentRoutesByName[route.name];
            }
            // Refresh info in history for transition blocking
            history.refreshRoutes && history.refreshRoutes(routes);
            setState({
                routes: routes
            });
        }
};
const $275e9e2aae174a1c$export$1cf0ecab63b1963c = (0, $iXqE5.createStore)({
    initialState: $275e9e2aae174a1c$export$36d128238e6b60f5,
    actions: $275e9e2aae174a1c$var$actions,
    name: 'router'
});
const $275e9e2aae174a1c$export$d6b817abe7a77ea5 = (0, $gg7kZ.createContainer)($275e9e2aae174a1c$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($275e9e2aae174a1c$var$actions.bootstrapStore(props));
            !(0, $9hyNx.isServerEnvironment)() && dispatch($275e9e2aae174a1c$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $9hyNx.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $275e9e2aae174a1c$export$9569010eab09ae9e = (0, $3sQ5x.createHook)($275e9e2aae174a1c$export$1cf0ecab63b1963c);
const $275e9e2aae174a1c$export$ada49399abf7a3a1 = (0, $3sQ5x.createActionsHook)($275e9e2aae174a1c$export$1cf0ecab63b1963c);
function $275e9e2aae174a1c$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $3sQ5x.createHook)($275e9e2aae174a1c$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        // @ts-expect-error TS2345
        return useHook(...args)[0];
    };
}
const $275e9e2aae174a1c$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $bKpgX.defaultRegistry).getStore($275e9e2aae174a1c$export$1cf0ecab63b1963c);
const $275e9e2aae174a1c$export$ebf37f7e180b13a9 = ()=>$275e9e2aae174a1c$export$5ccad187366c8494().storeState.getState();
const $275e9e2aae174a1c$export$4273485d5c0831e0 = (routeOrRoutes)=>{
    const selector = $275e9e2aae174a1c$export$95ab46bba7ea7a22(({ route: currentRoute })=>{
        if (typeof routeOrRoutes === 'string') return currentRoute.name === routeOrRoutes;
        return routeOrRoutes.has(currentRoute.name);
    });
    return selector();
};
const $275e9e2aae174a1c$export$6ec8251cd652e31a = (listener)=>{
    const store = $275e9e2aae174a1c$export$5ccad187366c8494();
    const unsubscriber = store.storeState.subscribe(listener);
    return ()=>unsubscriber();
};

});
parcelRegister("gqFAI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MATCH", () => $eb2b78cb2905120c$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $eb2b78cb2905120c$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $eb2b78cb2905120c$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $eb2b78cb2905120c$export$fa440ddf675c8a93);

var $hnPK7 = parcelRequire("hnPK7");
const $eb2b78cb2905120c$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $eb2b78cb2905120c$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $eb2b78cb2905120c$export$39607c9878cf5148 = (0, $hnPK7.createLegacyHistory)();
const $eb2b78cb2905120c$export$fa440ddf675c8a93 = 'POP';

});
parcelRegister("hnPK7", function(module, exports) {

$parcel$export(module.exports, "createLegacyHistory", () => $698cf47c46529f30$export$883c3f3b6c000133);

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $7bpAK = parcelRequire("7bpAK");

var $gKZoD = parcelRequire("gKZoD");
const $698cf47c46529f30$var$hasWindow = ()=>typeof window !== 'undefined';
const $698cf47c46529f30$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $698cf47c46529f30$var$getLocation = ()=>{
    (0, $gKZoD.di)(window);
    // todo - don't force non-optional search and hash
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $698cf47c46529f30$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $698cf47c46529f30$var$createLegacyListener = (updateExposedLocation)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector('#content');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currentHref = window.location.href;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHref !== window.location.href) {
            const newLocation = $698cf47c46529f30$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $698cf47c46529f30$export$883c3f3b6c000133 = ()=>{
    (0, $gKZoD.di)(window);
    let currentLocation = $698cf47c46529f30$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return {
        get location () {
            return currentLocation;
        },
        get length () {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            return $698cf47c46529f30$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        },
        ...$698cf47c46529f30$var$hasWindow() ? {
            push: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.assign(typeof path === 'string' ? path : (0, $7bpAK.createPath)(path || {})),
            replace: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.history.replaceState({}, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.title, typeof path === 'string' ? path : (0, $7bpAK.createPath)(path || {})),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goBack: ()=>window.history.back(),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goForward: ()=>window.history.forward(),
            listen: $698cf47c46529f30$var$createLegacyListener(updateExposedLocation),
            block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            createHref: (location)=>(0, $7bpAK.createPath)(location),
            refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        } : $698cf47c46529f30$var$methodsPlaceholders
    };
};

});


parcelRegister("gowp1", function(module, exports) {

$parcel$export(module.exports, "generateLocationFromPath", () => $411731485b1e129b$export$37e0729cc751960b);

var $aZsz6 = parcelRequire("aZsz6");

var $3gYPN = parcelRequire("3gYPN");
function $411731485b1e129b$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $aZsz6.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $3gYPN.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("3gYPN", function(module, exports) {

$parcel$export(module.exports, "compile", () => $91c28532d0ff43e3$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $91c28532d0ff43e3$export$71304158c7e35877);
// Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $91c28532d0ff43e3$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $91c28532d0ff43e3$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $91c28532d0ff43e3$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$91c28532d0ff43e3$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $91c28532d0ff43e3$export$ef7acd7185315e22(str, options) {
    return $91c28532d0ff43e3$export$5b9bad9e403cf3d9($91c28532d0ff43e3$export$98e6a39c04603d36(str, options), options);
}
function $91c28532d0ff43e3$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $91c28532d0ff43e3$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $91c28532d0ff43e3$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $91c28532d0ff43e3$export$71304158c7e35877(str, keys, options);
    return $91c28532d0ff43e3$export$968e97c88708237a(re, keys, options);
}
function $91c28532d0ff43e3$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $91c28532d0ff43e3$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $91c28532d0ff43e3$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $91c28532d0ff43e3$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $91c28532d0ff43e3$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$91c28532d0ff43e3$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $91c28532d0ff43e3$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $91c28532d0ff43e3$var$stringToRegexp(path, keys, options) {
    return $91c28532d0ff43e3$export$9a9303716def6456($91c28532d0ff43e3$export$98e6a39c04603d36(path, options), keys, options);
}
function $91c28532d0ff43e3$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$91c28532d0ff43e3$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$91c28532d0ff43e3$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $91c28532d0ff43e3$var$escapeString(encode(token));
    else {
        const prefix = $91c28532d0ff43e3$var$escapeString(encode(token.prefix));
        const suffix = $91c28532d0ff43e3$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $91c28532d0ff43e3$var$flags(options));
}
function $91c28532d0ff43e3$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $91c28532d0ff43e3$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $91c28532d0ff43e3$var$arrayToRegexp(path, keys, options);
    return $91c28532d0ff43e3$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("9VXkC", function(module, exports) {

$parcel$export(module.exports, "generatePath", () => $1496ffdfd32bd2ee$export$82476f982757e71e);

var $3gYPN = parcelRequire("3gYPN");
const $1496ffdfd32bd2ee$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $3gYPN.compile)(pattern)(params);

});

parcelRegister("9hyNx", function(module, exports) {

$parcel$export(module.exports, "isServerEnvironment", () => $87d8dab9a9bacdcd$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $6cAn5 = parcelRequire("6cAn5");
const $87d8dab9a9bacdcd$var$isJsDomEnvironment = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.name === 'nodejs' || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('Node.js') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('jsdom');
const $87d8dab9a9bacdcd$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $6cAn5 !== 'undefined' && $6cAn5.versions != null && $6cAn5.versions.node != null) return true;
    if ($87d8dab9a9bacdcd$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("2Gs5h", function(module, exports) {

$parcel$export(module.exports, "warmupMatchRouteCache", () => $d2fff2a1e093c3a6$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $d2fff2a1e093c3a6$export$2e2bcd8739ae039);

var $5Whsm = parcelRequire("5Whsm");

var $9D2aL = parcelRequire("9D2aL");
const $d2fff2a1e093c3a6$var$isLegacyRoutes = (routes)=>{
    // a naive way to check if the routes are legacy routes
    return routes[routes.length - 1]?.name === 'legacy-fallback';
};
const $d2fff2a1e093c3a6$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $d2fff2a1e093c3a6$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $5Whsm.default) : (0, $9D2aL.default);
    return matchRoute(routes, pathname, queryParams, basePath);
};
const $d2fff2a1e093c3a6$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    // no need to check legacy routes because `warmupMatchRouteCache` is used for SPA only
    return (0, $5Whsm.default)([
        route
    ], pathname, queryParams, basePath);
};
const $d2fff2a1e093c3a6$var$defaultMatchRoute = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $d2fff2a1e093c3a6$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $5Whsm.default) : (0, $9D2aL.default);
    const matchedRoute = matchRoute(routes, pathname, queryParams, basePath);
    return matchedRoute;
};
var $d2fff2a1e093c3a6$export$2e2bcd8739ae039 = $d2fff2a1e093c3a6$var$defaultMatchRoute;

});
parcelRegister("5Whsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1895f9fdab36fb4e$export$2e2bcd8739ae039);

var $2aljs = parcelRequire("2aljs");

var $8j5xv = parcelRequire("8j5xv");

var $3JSOI = parcelRequire("3JSOI");
const $1895f9fdab36fb4e$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const cachedMatch = (0, $3JSOI.matchRouteCache).get(pathname, queryParams, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    const matchedRoute = (0, $2aljs.default)(routes, pathname, queryParams, basePath);
    if (!matchedRoute) return null;
    (0, $8j5xv.default)(matchedRoute.route);
    (0, $3JSOI.matchRouteCache).set(pathname, queryParams, basePath, matchedRoute);
    return matchedRoute;
};
var $1895f9fdab36fb4e$export$2e2bcd8739ae039 = $1895f9fdab36fb4e$var$matchRoute;

});
parcelRegister("8j5xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54350b723a530a3$export$2e2bcd8739ae039);
const $a54350b723a530a3$var$deduplicateResources = (route)=>{
    // Apply resource de-duping to the route
    if ('resources' in route && Array.isArray(route.resources)) Object.assign(route, {
        resources: [
            ...new Set(route.resources)
        ]
    });
};
const $a54350b723a530a3$var$extractlazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const opts = route.lazyOpts();
        Object.assign(route, opts);
        // eslint-disable-next-line no-param-reassign
        delete route.lazyOpts;
    }
};
// This function mutates the route object by applying a series of transformations.
// such as deduplicating resources
// and calling the lazyOpts function to extract the lazy options and apply them to the route.
// (This is to defer the evaluation of the lazy options until the route is actually matched)
const $a54350b723a530a3$var$unsafeMutateRoute = (route)=>{
    // make sure `extractlazyOpts` is called before `deduplicateResources`
    // because `resources` is a lazy option
    [
        $a54350b723a530a3$var$extractlazyOpts,
        $a54350b723a530a3$var$deduplicateResources
    ].forEach((fn)=>fn(route));
};
var $a54350b723a530a3$export$2e2bcd8739ae039 = $a54350b723a530a3$var$unsafeMutateRoute;

});

parcelRegister("3JSOI", function(module, exports) {

$parcel$export(module.exports, "matchRouteCache", () => $8bad108eb9aac288$export$f594abf16a5ad948);
const $8bad108eb9aac288$var$MAX_CACHE_SIZE = 1000;
function $8bad108eb9aac288$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $8bad108eb9aac288$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($8bad108eb9aac288$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $8bad108eb9aac288$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $8bad108eb9aac288$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("9D2aL", function(module, exports) {

$parcel$export(module.exports, "default", () => $50deeb66970bfa49$export$2e2bcd8739ae039);

var $aZsz6 = parcelRequire("aZsz6");

var $8j5xv = parcelRequire("8j5xv");

var $8XGvX = parcelRequire("8XGvX");

var $16vsD = parcelRequire("16vsD");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $50deeb66970bfa49$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $aZsz6.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $16vsD.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $8XGvX.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $8j5xv.default)(matchedRoute.route);
            (0, $16vsD.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $50deeb66970bfa49$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    return $50deeb66970bfa49$var$matchRoute(routes, pathname, queryParams, basePath);
};
const $50deeb66970bfa49$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    return $50deeb66970bfa49$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $50deeb66970bfa49$export$2e2bcd8739ae039 = $50deeb66970bfa49$var$matchRoute;

});
parcelRegister("8XGvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0693ef4e28f459a4$export$2e2bcd8739ae039);

var $gEGIQ = parcelRequire("gEGIQ");

var $4sxG1 = parcelRequire("4sxG1");
/* This should match what react-router does to compute a root match. */ const $0693ef4e28f459a4$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $0693ef4e28f459a4$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $gEGIQ.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $0693ef4e28f459a4$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $4sxG1.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $0693ef4e28f459a4$export$2e2bcd8739ae039 = $0693ef4e28f459a4$var$execRouteMatching;

});
parcelRegister("gEGIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $498fec43ce6eed22$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $3gYPN = parcelRequire("3gYPN");
const $498fec43ce6eed22$var$cache = {};
const $498fec43ce6eed22$var$cacheLimit = 10000;
let $498fec43ce6eed22$var$cacheCount = 0;
function $498fec43ce6eed22$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $498fec43ce6eed22$var$cache[cacheKey] || ($498fec43ce6eed22$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $3gYPN.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($498fec43ce6eed22$var$cacheCount < $498fec43ce6eed22$var$cacheLimit) {
        pathCache[path] = result;
        $498fec43ce6eed22$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $498fec43ce6eed22$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $498fec43ce6eed22$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $498fec43ce6eed22$export$2e2bcd8739ae039 = $498fec43ce6eed22$var$matchPath;

});

parcelRegister("4sxG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f092c86c130c58f$export$2e2bcd8739ae039);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $7f092c86c130c58f$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}
var $7f092c86c130c58f$export$2e2bcd8739ae039 = $7f092c86c130c58f$var$matchQuery;

});


parcelRegister("16vsD", function(module, exports) {

$parcel$export(module.exports, "matchRouteCache", () => $7ae61447b9f0e7ef$export$f594abf16a5ad948);
const $7ae61447b9f0e7ef$var$MAX_CACHE_SIZE = 1000;
function $7ae61447b9f0e7ef$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $7ae61447b9f0e7ef$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($7ae61447b9f0e7ef$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $7ae61447b9f0e7ef$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $7ae61447b9f0e7ef$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});



parcelRegister("jNUyg", function(module, exports) {

$parcel$export(module.exports, "createRouterContext", () => $f9572ef94f7e5c4c$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $f9572ef94f7e5c4c$export$a0bd0313cbeabd49);

var $aZsz6 = parcelRequire("aZsz6");

var $gqFAI = parcelRequire("gqFAI");

var $9VXkC = parcelRequire("9VXkC");

var $2Gs5h = parcelRequire("2Gs5h");
const $f9572ef94f7e5c4c$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $9VXkC.generatePath)(route.path, params);
    const matchedRoute = (0, $2Gs5h.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $gqFAI.DEFAULT_MATCH),
        query: query
    };
};
const $f9572ef94f7e5c4c$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $aZsz6.qs).parse(search);
    const matchedRoute = (0, $2Gs5h.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $gqFAI.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $gqFAI.DEFAULT_MATCH)
    };
};

});

parcelRegister("l37Ss", function(module, exports) {

$parcel$export(module.exports, "isExternalAbsolutePath", () => $2a7087d16c80bad9$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $2a7087d16c80bad9$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $2a7087d16c80bad9$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $2a7087d16c80bad9$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $2a7087d16c80bad9$export$c9237620ff7fdf7c);

var $aZsz6 = parcelRequire("aZsz6");

var $a4GDG = parcelRequire("a4GDG");
const $2a7087d16c80bad9$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $2a7087d16c80bad9$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : `/${path}`;
const $2a7087d16c80bad9$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        // eslint-disable-next-line no-param-reassign
        prefix = $2a7087d16c80bad9$var$stripTrailingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        prefix = $2a7087d16c80bad9$var$addLeadingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        path = $2a7087d16c80bad9$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $2a7087d16c80bad9$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $2a7087d16c80bad9$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$2a7087d16c80bad9$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(path).hostname;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $2a7087d16c80bad9$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$2a7087d16c80bad9$export$e83e3719fc818ee5(path)) {
        // eslint-disable-next-line no-param-reassign
        path = $2a7087d16c80bad9$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $2a7087d16c80bad9$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $aZsz6.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $2a7087d16c80bad9$export$9ae1c7c875ef309d = (location)=>`${location.pathname}${location.search}${location.hash}`;
const $2a7087d16c80bad9$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $a4GDG.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});
parcelRegister("a4GDG", function(module, exports) {

$parcel$export(module.exports, "isSameRouteMatch", () => $43a47d67314c6e77$export$5997e70fc4543270);
const $43a47d67314c6e77$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $43a47d67314c6e77$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $43a47d67314c6e77$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $43a47d67314c6e77$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});



parcelRegister("lVJAU", function(module, exports) {

$parcel$export(module.exports, "useRouterActions", () => $14c61b6a4ec0911f$export$402e82ff1b20594b);

var $lODMY = parcelRequire("lODMY");
const $14c61b6a4ec0911f$export$402e82ff1b20594b = ()=>(0, $lODMY.useRouterStoreActions)();

});

parcelRegister("bhUJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $021eec879594ef9b$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $021eec879594ef9b$var$__assign = function() {
    $021eec879594ef9b$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $021eec879594ef9b$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $021eec879594ef9b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $021eec879594ef9b$var$isObject_1 = $021eec879594ef9b$var$isObject;
var $021eec879594ef9b$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
/** Detect free variable `global` from Node.js. */ var $021eec879594ef9b$var$freeGlobal = typeof $021eec879594ef9b$var$commonjsGlobal == 'object' && $021eec879594ef9b$var$commonjsGlobal && $021eec879594ef9b$var$commonjsGlobal.Object === Object && $021eec879594ef9b$var$commonjsGlobal;
var $021eec879594ef9b$var$_freeGlobal = $021eec879594ef9b$var$freeGlobal;
/** Detect free variable `self`. */ var $021eec879594ef9b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $021eec879594ef9b$var$root = $021eec879594ef9b$var$_freeGlobal || $021eec879594ef9b$var$freeSelf || Function('return this')();
var $021eec879594ef9b$var$_root = $021eec879594ef9b$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $021eec879594ef9b$var$now = function() {
    return $021eec879594ef9b$var$_root.Date.now();
};
var $021eec879594ef9b$var$now_1 = $021eec879594ef9b$var$now;
/** Built-in value references. */ var $021eec879594ef9b$var$Symbol = $021eec879594ef9b$var$_root.Symbol;
var $021eec879594ef9b$var$_Symbol = $021eec879594ef9b$var$Symbol;
/** Used for built-in method references. */ var $021eec879594ef9b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $021eec879594ef9b$var$hasOwnProperty = $021eec879594ef9b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $021eec879594ef9b$var$nativeObjectToString = $021eec879594ef9b$var$objectProto.toString;
/** Built-in value references. */ var $021eec879594ef9b$var$symToStringTag = $021eec879594ef9b$var$_Symbol ? $021eec879594ef9b$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $021eec879594ef9b$var$getRawTag(value) {
    var isOwn = $021eec879594ef9b$var$hasOwnProperty.call(value, $021eec879594ef9b$var$symToStringTag), tag = value[$021eec879594ef9b$var$symToStringTag];
    try {
        value[$021eec879594ef9b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $021eec879594ef9b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$021eec879594ef9b$var$symToStringTag] = tag;
        else delete value[$021eec879594ef9b$var$symToStringTag];
    }
    return result;
}
var $021eec879594ef9b$var$_getRawTag = $021eec879594ef9b$var$getRawTag;
/** Used for built-in method references. */ var $021eec879594ef9b$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $021eec879594ef9b$var$nativeObjectToString$1 = $021eec879594ef9b$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $021eec879594ef9b$var$objectToString(value) {
    return $021eec879594ef9b$var$nativeObjectToString$1.call(value);
}
var $021eec879594ef9b$var$_objectToString = $021eec879594ef9b$var$objectToString;
/** `Object#toString` result references. */ var $021eec879594ef9b$var$nullTag = '[object Null]', $021eec879594ef9b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $021eec879594ef9b$var$symToStringTag$1 = $021eec879594ef9b$var$_Symbol ? $021eec879594ef9b$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $021eec879594ef9b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $021eec879594ef9b$var$undefinedTag : $021eec879594ef9b$var$nullTag;
    return $021eec879594ef9b$var$symToStringTag$1 && $021eec879594ef9b$var$symToStringTag$1 in Object(value) ? $021eec879594ef9b$var$_getRawTag(value) : $021eec879594ef9b$var$_objectToString(value);
}
var $021eec879594ef9b$var$_baseGetTag = $021eec879594ef9b$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $021eec879594ef9b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $021eec879594ef9b$var$isObjectLike_1 = $021eec879594ef9b$var$isObjectLike;
/** `Object#toString` result references. */ var $021eec879594ef9b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $021eec879594ef9b$var$isSymbol(value) {
    return typeof value == 'symbol' || $021eec879594ef9b$var$isObjectLike_1(value) && $021eec879594ef9b$var$_baseGetTag(value) == $021eec879594ef9b$var$symbolTag;
}
var $021eec879594ef9b$var$isSymbol_1 = $021eec879594ef9b$var$isSymbol;
/** Used as references for various `Number` constants. */ var $021eec879594ef9b$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $021eec879594ef9b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $021eec879594ef9b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $021eec879594ef9b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $021eec879594ef9b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $021eec879594ef9b$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $021eec879594ef9b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($021eec879594ef9b$var$isSymbol_1(value)) return $021eec879594ef9b$var$NAN;
    if ($021eec879594ef9b$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $021eec879594ef9b$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($021eec879594ef9b$var$reTrim, '');
    var isBinary = $021eec879594ef9b$var$reIsBinary.test(value);
    return isBinary || $021eec879594ef9b$var$reIsOctal.test(value) ? $021eec879594ef9b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $021eec879594ef9b$var$reIsBadHex.test(value) ? $021eec879594ef9b$var$NAN : +value;
}
var $021eec879594ef9b$var$toNumber_1 = $021eec879594ef9b$var$toNumber;
/** Error message constants. */ var $021eec879594ef9b$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $021eec879594ef9b$var$nativeMax = Math.max, $021eec879594ef9b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $021eec879594ef9b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($021eec879594ef9b$var$FUNC_ERROR_TEXT);
    wait = $021eec879594ef9b$var$toNumber_1(wait) || 0;
    if ($021eec879594ef9b$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $021eec879594ef9b$var$nativeMax($021eec879594ef9b$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $021eec879594ef9b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $021eec879594ef9b$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($021eec879594ef9b$var$now_1());
    }
    function debounced() {
        var time = $021eec879594ef9b$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $021eec879594ef9b$var$debounce_1 = $021eec879594ef9b$var$debounce;
/** Error message constants. */ var $021eec879594ef9b$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $021eec879594ef9b$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($021eec879594ef9b$var$FUNC_ERROR_TEXT$1);
    if ($021eec879594ef9b$var$isObject_1(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $021eec879594ef9b$var$debounce_1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $021eec879594ef9b$var$throttle_1 = $021eec879594ef9b$var$throttle;
var $021eec879594ef9b$var$windowIdleEvents = [
    'scroll',
    'resize'
];
var $021eec879594ef9b$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
var $021eec879594ef9b$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === 'visible') _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $021eec879594ef9b$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener('visibilitychange', _this.onBrowserActiveChange);
            var throttleResetIdleTime = $021eec879594ef9b$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $021eec879594ef9b$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $021eec879594ef9b$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener('visibilitychange', _this.onBrowserActiveChange);
            $021eec879594ef9b$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $021eec879594ef9b$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $021eec879594ef9b$export$2e2bcd8739ae039 = $021eec879594ef9b$var$BrowserInteractionTime;

});

parcelRegister("5y0F0", function(module, exports) {

$parcel$export(module.exports, "RouterActions", () => $e2c93c7435918634$export$b371fa9cf762ad06);

var $5uXOq = parcelRequire("5uXOq");

var $lVJAU = parcelRequire("lVJAU");
const $e2c93c7435918634$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $lVJAU.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(actions));
};
$e2c93c7435918634$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("doZTA", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $87ffd70faf44aa80$export$9a302a45f65d0572);

var $lODMY = parcelRequire("lODMY");
const $87ffd70faf44aa80$export$9a302a45f65d0572 = ()=>(0, $lODMY.useRouterStore)();

});

parcelRegister("hjSul", function(module, exports) {

$parcel$export(module.exports, "Link", () => $cf713c82994e83eb$export$a6c7ac8248d6e38a);
/* eslint-disable jira/filename-case */ 
var $5uXOq = parcelRequire("5uXOq");

var $7bpAK = parcelRequire("7bpAK");

var $gowp1 = parcelRequire("gowp1");

var $jNUyg = parcelRequire("jNUyg");

var $lODMY = parcelRequire("lODMY");

var $2tF5g = parcelRequire("2tF5g");

var $bfOfD = parcelRequire("bfOfD");
const $cf713c82994e83eb$var$PREFETCH_DELAY = 225;
const $cf713c82994e83eb$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state, ...rest }, ref)=>{
    const routerActions = (0, $lODMY.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $2tF5g.useTimeout)($cf713c82994e83eb$var$PREFETCH_DELAY);
    const validLinkType = linkType === 'a' || linkType === 'button' ? linkType : 'a';
    const [route, setRoute] = (0, $5uXOq.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        if (to && typeof to !== 'string' && !route && 'then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
    }, [
        to,
        route
    ]);
    let routeValue = route;
    if (!routeValue && to && typeof to !== 'string' && !('then' in to)) // use the prop instead of the value in useState
    routeValue = to;
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = // eslint-disable-next-line no-nested-ternary
    href != null ? href : typeof to !== 'string' ? routeValue && (0, $7bpAK.createPath)((0, $gowp1.generateLocationFromPath)(routeValue.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $5uXOq.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !routeValue) return;
        const context = typeof to !== 'string' && routeValue ? (0, $jNUyg.createRouterContext)(routeValue, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeValue,
        linkDestination,
        routerActions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $bfOfD.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: routeValue && [
                routeValue,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $5uXOq.createElement)(validLinkType, {
        ...rest,
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }, children);
});
$cf713c82994e83eb$export$a6c7ac8248d6e38a.displayName = 'Link';

});
parcelRegister("2tF5g", function(module, exports) {

$parcel$export(module.exports, "useTimeout", () => $181e6f0d4e3d3b63$export$d8e6abf214c9ec0f);

var $5uXOq = parcelRequire("5uXOq");
const $181e6f0d4e3d3b63$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $5uXOq.useRef)();
    const schedule = (0, $5uXOq.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("bfOfD", function(module, exports) {

$parcel$export(module.exports, "handleNavigation", () => $145b3ab267f6c9b8$export$706ad1af8096e280);

var $e7NAP = parcelRequire("e7NAP");
const $145b3ab267f6c9b8$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $e7NAP.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $e7NAP.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $e7NAP.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("e7NAP", function(module, exports) {

$parcel$export(module.exports, "isModifiedEvent", () => $bcdefa4d58d549b7$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $bcdefa4d58d549b7$export$130b789831072f4c);
const $bcdefa4d58d549b7$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $bcdefa4d58d549b7$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});



parcelRegister("15Xx4", function(module, exports) {

$parcel$export(module.exports, "Router", () => $9bc2ee1147ecb03f$export$55185c17a0fcbe46);
/* eslint-disable jira/filename-case */ 
var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");
const $9bc2ee1147ecb03f$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes, isLazyRoutes: isLazyRoutes = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lODMY.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins ?? [],
        routes: routes,
        isLazyRoutes: isLazyRoutes
    }, children);

});

parcelRegister("8fYaK", function(module, exports) {

$parcel$export(module.exports, "getResourceStore", () => $6a706a6fd04a9ab4$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $6a706a6fd04a9ab4$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $6a706a6fd04a9ab4$export$98e41a62c9bef75e);
$parcel$export(module.exports, "useResourceStoreContext", () => $6a706a6fd04a9ab4$export$e59f52df235ac7b3);

var $4R6GH = parcelRequire("4R6GH");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $9hyNx = parcelRequire("9hyNx");

var $6iqqv = parcelRequire("6iqqv");

var $hzwXy = parcelRequire("hzwXy");

var $2CCUg = parcelRequire("2CCUg");

var $htn2f = parcelRequire("htn2f");

var $j7V6Y = parcelRequire("j7V6Y");

var $lcu0r = parcelRequire("lcu0r");

var $2C6R7 = parcelRequire("2C6R7");

var $jhu7v = parcelRequire("jhu7v");

var $avYsH = parcelRequire("avYsH");

var $aVHrD = parcelRequire("aVHrD");

var $RQ1Zx = parcelRequire("RQ1Zx");

var $lNQ9S = parcelRequire("lNQ9S");

var $dV1HY = parcelRequire("dV1HY");

const $6a706a6fd04a9ab4$export$3f1be494d407b77a = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $jhu7v.deleteResourceState)(type, key));
                dispatch((0, $htn2f.executeForDependents)(resource, (dependentResource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $jhu7v.deleteResourceState)(type));
        },
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context, ...resourceStoreState } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $6iqqv.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = {
                ...prevSlice,
                ...changes,
                expiresAt: (0, $j7V6Y.getExpiresAt)(maxAge),
                accessedAt: (0, $hzwXy.getAccessedAt)()
            };
            dispatch((0, $jhu7v.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $htn2f.executeForDependents)(resource, (dependentResource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $jhu7v.getResourceState)(type, key));
            if (cached && (0, $aVHrD.shouldUseCache)(cached)) {
                if ((0, $aVHrD.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $RQ1Zx.setSsrDataPromise)(cached);
                    cached = (0, $j7V6Y.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $hzwXy.getAccessedAt)();
                dispatch((0, $jhu7v.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($6a706a6fd04a9ab4$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
	 * Request a single resource and update the resource cache.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $jhu7v.getResourceState)(type, key)) || (0, $lcu0r.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $2C6R7.validateLRUCache)(resource, key));
            let loadingSlice = dispatch((0, $jhu7v.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $2CCUg.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $htn2f.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $jhu7v.setResourceState)(type, key, {
                    ...prevSlice,
                    ...loadingSlice,
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $hzwXy.getAccessedAt)()
                }));
                // trigger dependent resources to also load
                dispatch((0, $htn2f.executeForDependents)(resource, (dependentResource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = loadingSlice.data ?? await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $lNQ9S.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        promise: null
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $jhu7v.getResourceState)(type, key));
            const finalSlice = {
                ...recentSlice || prevSlice,
                ...resolvedSlice,
                accessedAt: (0, $hzwXy.getAccessedAt)(),
                expiresAt: (0, $j7V6Y.getExpiresAt)(maxAge)
            };
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $jhu7v.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
	 * Prefetch a single resource and store in the prefetch cache.
	 */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $jhu7v.getResourceState)(type, key)) || (0, $lcu0r.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return;
            if (prevSlice.data && prevSlice.expiresAt && prevSlice.expiresAt > Date.now()) // if the resource is not expired, return the current data
            return;
            let loadingSlice = dispatch((0, $jhu7v.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $2CCUg.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $htn2f.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependents
            dispatch((0, $jhu7v.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $htn2f.executeForDependents)(resource, (dependentResource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $6a706a6fd04a9ab4$export$e324594224ef24da = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 * Execute such that dependencies on current route will be cleared.
	 */ clearResource: (resource, routerStoreContext)=>(0, $htn2f.actionWithDependencies)(routerStoreContext?.route?.resources, resource, $6a706a6fd04a9ab4$export$3f1be494d407b77a.clearResource(resource, routerStoreContext ?? null)),
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 * Execute such that dependencies on current route will be updated.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $htn2f.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a706a6fd04a9ab4$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 * Execute such that dependencies on current route will be updated.
	 */ getResource: (resource, routerStoreContext, options)=>(0, $htn2f.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a706a6fd04a9ab4$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
	 * Request a single resource and update the resource cache.
	 * Execute such that dependencies on current route will be updated.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $htn2f.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a706a6fd04a9ab4$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
	 * Request all resources.
	 */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($6a706a6fd04a9ab4$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
	 * Cleans expired resources and resets them back to their initial state.
	 * We need to do this when transitioning into a route.
	 */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $jhu7v.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $jhu7v.deleteResourceState)(type, key));
            });
        },
    /**
	 * Requests a specific set of resources.
	 */ requestResources: (resources, routerStoreContext, options)=>{
        let predicate;
        if ((0, $4R6GH.fg)('add-skip-browser-support-to-rrr-fix')) predicate = (0, $9hyNx.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ({ skipBrowser: skipBrowser })=>!skipBrowser;
        else predicate = (0, $9hyNx.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $htn2f.mapActionWithDependencies)(routerStoreContext.route.resources?.filter(predicate), resources.filter(predicate), (resource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
	 * Prefetch a specific set of resources.
	 */ prefetchResources: (resources, routerStoreContext, options)=>(0, $htn2f.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$6a706a6fd04a9ab4$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, {
                ...options,
                prefetch: true
            })),
    /**
	 * Hydrates the store with state.
	 * Will not override pre-hydrated state.
	 */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $dV1HY.transformData)(getNextStateValue(data, resourceData), ({ error: error, expiresAt: expiresAt, loading: loading, ...rest })=>{
                const deserializedError = !error ? null : (0, $avYsH.deserializeError)(error);
                const isTimeoutError = deserializedError?.name === 'TimeoutError';
                return {
                    ...rest,
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                };
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
	 * Gets the store's context
	 */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
	 * Returns safe, portable and rehydratable data.
	 */ getSafeData: ()=>({ getState: getState })=>(0, $dV1HY.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $avYsH.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $lNQ9S.TimeoutError) ? loading : false
                }))
};
const $6a706a6fd04a9ab4$export$94f50dade551bd01 = (0, $iXqE5.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $6a706a6fd04a9ab4$export$e324594224ef24da,
    name: 'router-resources'
});
const $6a706a6fd04a9ab4$export$cc90fb9c37c5589d = (0, $gg7kZ.createContainer)($6a706a6fd04a9ab4$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $6a706a6fd04a9ab4$export$fee1a6213543bd78 = (0, $51nlc.createSubscriber)($6a706a6fd04a9ab4$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $6iqqv.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $6a706a6fd04a9ab4$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $bKpgX.defaultRegistry).getStore($6a706a6fd04a9ab4$export$94f50dade551bd01);
const $6a706a6fd04a9ab4$export$ac3608e0bb357c7 = (0, $3sQ5x.createHook)($6a706a6fd04a9ab4$export$94f50dade551bd01, {
    selector: (0, $6iqqv.getSliceForResource)
});
const $6a706a6fd04a9ab4$export$98e41a62c9bef75e = (0, $3sQ5x.createActionsHook)($6a706a6fd04a9ab4$export$94f50dade551bd01);
const $6a706a6fd04a9ab4$export$e59f52df235ac7b3 = (0, $3sQ5x.createHook)($6a706a6fd04a9ab4$export$94f50dade551bd01, {
    selector: (0, $6iqqv.getResourceStoreContext)
});

});
parcelRegister("6iqqv", function(module, exports) {

$parcel$export(module.exports, "getSliceForResource", () => $6017da727f923d1e$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $6017da727f923d1e$export$6a0b1779210de0ee);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $lcu0r = parcelRequire("lcu0r");
const $6017da727f923d1e$export$a11d18a937e2b512 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? {
        ...slice
    } : (0, $lcu0r.getDefaultStateSlice)();
};
const $6017da727f923d1e$var$defaultStateSlice = (0, $lcu0r.getDefaultStateSlice)();
const $6017da727f923d1e$export$d3752a5cc6e513ab = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    // The return of this needs to be stable object references - no cloning/spreading or new objects
    // otherwise it will cause re-renders in components that use this selector
    return slice || $6017da727f923d1e$var$defaultStateSlice;
};
const $6017da727f923d1e$export$c9ed509724feb827 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-concurrent-resource-router-stability'), $6017da727f923d1e$export$d3752a5cc6e513ab, $6017da727f923d1e$export$a11d18a937e2b512);
const $6017da727f923d1e$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("lcu0r", function(module, exports) {

$parcel$export(module.exports, "getDefaultStateSlice", () => $bcbcf97b5b9e3214$export$fa8e33c3301e2e94);

var $hzwXy = parcelRequire("hzwXy");


var $j7V6Y = parcelRequire("j7V6Y");

var $lmhE5 = parcelRequire("lmhE5");
const $bcbcf97b5b9e3214$export$fa8e33c3301e2e94 = ()=>({
        ...(0, $lmhE5.BASE_DEFAULT_STATE_SLICE),
        expiresAt: (0, $j7V6Y.getExpiresAt)((0, $6f9e74bb556ace2f$export$12c1dc38ea1692da)),
        accessedAt: (0, $hzwXy.getAccessedAt)()
    });

});
parcelRegister("hzwXy", function(module, exports) {

$parcel$export(module.exports, "getAccessedAt", () => $e0b2c4b5198927b0$export$9ccb639b7a119f61);
const $e0b2c4b5198927b0$export$9ccb639b7a119f61 = ()=>Date.now();

});

const $6f9e74bb556ace2f$export$881d135f98d8d7d0 = 100;
const $6f9e74bb556ace2f$export$9ab5bdcb8a1d6c34 = false;
const $6f9e74bb556ace2f$export$f267d0e9ab3eb265 = false;
const $6f9e74bb556ace2f$export$12c1dc38ea1692da = 0;

parcelRegister("j7V6Y", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $f5d6bb562e9c7c52$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $f5d6bb562e9c7c52$export$18d1d420fd588368);
const $f5d6bb562e9c7c52$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $f5d6bb562e9c7c52$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? {
        ...slice,
        expiresAt: $f5d6bb562e9c7c52$export$b65d7ba7fbf150f1(maxAge)
    } : slice;

});

parcelRegister("lmhE5", function(module, exports) {

$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $9a2b56d3e51ac6d2$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $9a2b56d3e51ac6d2$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});



parcelRegister("2CCUg", function(module, exports) {

$parcel$export(module.exports, "createLoadingSlice", () => $dabe6e8e4cea2e10$export$dc62515c8f0b52dd);


var $j7V6Y = parcelRequire("j7V6Y");

var $8RltX = parcelRequire("8RltX");

var $lNQ9S = parcelRequire("lNQ9S");

var $icGLV = parcelRequire("icGLV");
function $dabe6e8e4cea2e10$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData({
            ...routerStoreContext,
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }, context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $8RltX.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof promiseOrData?.then === 'function' ? undefined : promiseOrData;
    // eslint-disable-next-line no-nested-ternary
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard?.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $lNQ9S.TimeoutError)(type);
        timeoutGuard?.timerId && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $j7V6Y.getExpiresAt)(resource.maxAge ?? (0, $6f9e74bb556ace2f$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $j7V6Y.getExpiresAt)((0, $icGLV.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("8RltX", function(module, exports) {

$parcel$export(module.exports, "generateTimeGuard", () => $236af2d38c7c7ce9$export$58634b3a58ae66b7);
const $236af2d38c7c7ce9$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("lNQ9S", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", () => $e3b2dc8c870086d0$export$66d311bf29d5c89c);
class $e3b2dc8c870086d0$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(`Resource timed out: ${message}`);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("icGLV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $cfc28f7374a58b69$export$37d3126be6549b13);
const $cfc28f7374a58b69$export$37d3126be6549b13 = 10000;

});


parcelRegister("htn2f", function(module, exports) {

$parcel$export(module.exports, "ResourceDependencyError", () => $5198ca6998a5d5be$export$492ad57edfe1e919);
$parcel$export(module.exports, "actionWithDependencies", () => $5198ca6998a5d5be$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $5198ca6998a5d5be$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $5198ca6998a5d5be$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $5198ca6998a5d5be$export$75915f81f2a6540a);

var $lcu0r = parcelRequire("lcu0r");

var $jhu7v = parcelRequire("jhu7v");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $5198ca6998a5d5be$var$fromEntries = Object.fromEntries ?? ((entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        }))));
const $5198ca6998a5d5be$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $5198ca6998a5d5be$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $5198ca6998a5d5be$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = routeResources?.some(({ depends: depends })=>depends?.length) ?? false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources?.some($5198ca6998a5d5be$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!depends?.some((dependency)=>executableTypes.includes(dependency));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>{
            if (depends) acc.push(...depends);
            acc.push(type);
            return acc;
        }, []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>tuples.find($5198ca6998a5d5be$var$matchType(resource)) ?? [
                resource,
                null
            ]);
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            const latestTuple = getState().executing?.[i];
            const [{ type: latestType }, maybeAction] = latestTuple ?? [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($5198ca6998a5d5be$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $5198ca6998a5d5be$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($5198ca6998a5d5be$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $5198ca6998a5d5be$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$5198ca6998a5d5be$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $5198ca6998a5d5be$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = tuples?.findIndex($5198ca6998a5d5be$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executing = tuples.map((tuple, i)=>{
            const [tupleResource] = tuple;
            return i > indexForResource && tupleResource.depends?.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $5198ca6998a5d5be$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!depends?.length) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = tuples?.findIndex($5198ca6998a5d5be$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) throw new $5198ca6998a5d5be$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (dependency)=>[
                dependency,
                tuples.findIndex($5198ca6998a5d5be$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $5198ca6998a5d5be$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $5198ca6998a5d5be$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $5198ca6998a5d5be$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $jhu7v.getResourceState)(dependencyType, key)) || (0, $lcu0r.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $jhu7v.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = {
                ...slice,
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            };
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("jhu7v", function(module, exports) {

$parcel$export(module.exports, "getPrefetchSlice", () => $1b81cb0235a144a3$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $1b81cb0235a144a3$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $1b81cb0235a144a3$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $1b81cb0235a144a3$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $1b81cb0235a144a3$export$d40f35dc5952864b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1b81cb0235a144a3$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        const { prefetching: prefetching } = getState();
        const slice = prefetching?.[type]?.[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $1b81cb0235a144a3$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if (prefetching?.[type]?.[key] === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice?.promise?.then((maybeData)=>{
            // eslint-disable-next-line no-param-reassign
            slice.data = maybeData;
        });
        setState({
            prefetching: {
                ...prefetching,
                [type]: {
                    ...prefetching?.[type],
                    [key]: slice
                }
            }
        });
    };
const $1b81cb0235a144a3$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($1b81cb0235a144a3$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: {
                ...data,
                [type]: {
                    ...data[type] || {},
                    [key]: state
                }
            }
        });
    };
const $1b81cb0235a144a3$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType?.[key];
    };
const $1b81cb0235a144a3$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType, ...remainingData } = data;
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const { [key]: _, ...remainingForType } = resourceForType;
            setState({
                data: {
                    ...remainingData,
                    [type]: remainingForType
                }
            });
        }
    };

});


parcelRegister("2C6R7", function(module, exports) {

$parcel$export(module.exports, "validateLRUCache", () => $ea9138213c50c42a$export$89440b7623c2c75c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $jhu7v = parcelRequire("jhu7v");
const $ea9138213c50c42a$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $ea9138213c50c42a$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $ea9138213c50c42a$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $ea9138213c50c42a$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $ea9138213c50c42a$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $jhu7v.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("avYsH", function(module, exports) {

$parcel$export(module.exports, "serializeError", () => $647ccf403464790b$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $647ccf403464790b$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $647ccf403464790b$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $647ccf403464790b$var$NonError);
    }
}
const $647ccf403464790b$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $647ccf403464790b$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $647ccf403464790b$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $647ccf403464790b$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $647ccf403464790b$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $647ccf403464790b$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $647ccf403464790b$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $647ccf403464790b$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $647ccf403464790b$var$NonError(value);
};

});

parcelRegister("aVHrD", function(module, exports) {

$parcel$export(module.exports, "isFromSsr", () => $e082a428bfda08e5$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $e082a428bfda08e5$export$399de8c43d0ece3c);
const $e082a428bfda08e5$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $e082a428bfda08e5$var$isFresh = (resource)=>{
    if ($e082a428bfda08e5$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $e082a428bfda08e5$export$399de8c43d0ece3c = (resource)=>{
    if (resource?.error?.name === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($e082a428bfda08e5$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("RQ1Zx", function(module, exports) {

$parcel$export(module.exports, "setSsrDataPromise", () => $926638d87086da91$export$2e4da1b414980956);
const $926638d87086da91$export$2e4da1b414980956 = (slice)=>slice.promise === null ? {
        ...slice,
        promise: Promise.resolve(slice.data)
    } : slice;

});

parcelRegister("dV1HY", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $f7eee3084f630321$export$3ceb62baab058c6b);
const $f7eee3084f630321$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});


parcelRegister("2M1hQ", function(module, exports) {

$parcel$export(module.exports, "createResource", () => $8d954d1be0a58264$export$edd172c6c83c39cc);

const $8d954d1be0a58264$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $8d954d1be0a58264$export$edd172c6c83c39cc = (arg)=>({
        type: arg.type,
        getKey: arg.getKey,
        getData: arg.getData ?? $8d954d1be0a58264$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $6f9e74bb556ace2f$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $6f9e74bb556ace2f$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $6f9e74bb556ace2f$export$9ab5bdcb8a1d6c34),
        skipBrowser: typeof arg.skipBrowser === 'boolean' ? arg.skipBrowser : (0, $6f9e74bb556ace2f$export$f267d0e9ab3eb265),
        depends: arg.depends ?? null
    });

});

parcelRegister("2YP9W", function(module, exports) {

$parcel$export(module.exports, "useResource", () => $fecb9a5e2a723e9e$export$9f6abfd74295843b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $lODMY = parcelRequire("lODMY");

var $8fYaK = parcelRequire("8fYaK");
const $fecb9a5e2a723e9e$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $8fYaK.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $lODMY.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $5uXOq.useMemo)(()=>(0, $3sQ5x.createHook)((0, $lODMY.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    const key = useKey(options?.routerContext)[0];
    const [slice] = (0, $8fYaK.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    ()=>options?.routerContext || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $5uXOq.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $5uXOq.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $5uXOq.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $5uXOq.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return {
        ...slice,
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    };
};

});

parcelRegister("1bQGJ", function(module, exports) {

$parcel$export(module.exports, "withRouter", () => $183aee90dcda4c68$export$369b6b2b30582e8e);

var $5uXOq = parcelRequire("5uXOq");

var $lODMY = parcelRequire("lODMY");
const $183aee90dcda4c68$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $183aee90dcda4c68$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $183aee90dcda4c68$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $lODMY.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        });
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("7tQej", function(module, exports) {

$parcel$export(module.exports, "Redirect", () => $e0c9919a58c8d3f8$export$2d8d895a0a0f636e);

var $5uXOq = parcelRequire("5uXOq");

var $7bpAK = parcelRequire("7bpAK");

var $gowp1 = parcelRequire("gowp1");

var $doZTA = parcelRequire("doZTA");
// eslint-disable-next-line jira/react/no-class-components
class $e0c9919a58c8d3f8$var$Redirector extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            push: false
        };
    }
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = // eslint-disable-next-line no-nested-ternary
        typeof to === 'object' ? 'path' in to ? (0, $7bpAK.createPath)((0, $gowp1.generateLocationFromPath)(to.path, routeAttributes)) : (0, $7bpAK.createPath)(to) : to;
        const currentPath = (0, $7bpAK.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
const $e0c9919a58c8d3f8$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $doZTA.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0c9919a58c8d3f8$var$Redirector, {
        actions: actions,
        location: location,
        ...props
    });
};

});

parcelRegister("ieDtd", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $816cf8ab0c394911$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $lODMY = parcelRequire("lODMY");
const $816cf8ab0c394911$var$createQueryParamHook = (0, $3sQ5x.createHook)((0, $lODMY.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $816cf8ab0c394911$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $816cf8ab0c394911$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $5uXOq.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("jDDFr", function(module, exports) {

$parcel$export(module.exports, "RouterSubscriber", () => $2ba77449c0197744$export$672d721d310ff5f0);

var $5uXOq = parcelRequire("5uXOq");

var $9hyNx = parcelRequire("9hyNx");

var $lODMY = parcelRequire("lODMY");
const $2ba77449c0197744$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, { listen: listen, ...actions }] = (0, $lODMY.useRouterStore)();
    if (!state.unlisten && !(0, $9hyNx.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(state, actions));
};

});

parcelRegister("bmKPg", function(module, exports) {

$parcel$export(module.exports, "usePathParam", () => $f245513f3ca79fc4$export$8c8591dcd57728e6);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $lODMY = parcelRequire("lODMY");
const $f245513f3ca79fc4$var$createPathParamHook = (0, $3sQ5x.createHook)((0, $lODMY.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $f245513f3ca79fc4$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $f245513f3ca79fc4$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $5uXOq.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("ergyj", function(module, exports) {

$parcel$export(module.exports, "addResourcesListener", () => $8dea0a3b5fffe596$export$dee7bf9fc0ff48c3);

var $8fYaK = parcelRequire("8fYaK");
const $8dea0a3b5fffe596$export$dee7bf9fc0ff48c3 = (fn)=>(0, $8fYaK.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("awmeS", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (0, module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("7sdte", function(module, exports) {

$parcel$export(module.exports, "ResourceSubscriber", () => $c8c8bd31d8fc312f$export$fee1a6213543bd78);

var $5uXOq = parcelRequire("5uXOq");

var $2YP9W = parcelRequire("2YP9W");
const $c8c8bd31d8fc312f$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $2YP9W.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children(result));
};

});

parcelRegister("fqShm", function(module, exports) {

$parcel$export(module.exports, "RouteComponent", () => $be82cba7ed4087d8$export$7903e4b73fc7d6c3);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
const $be82cba7ed4087d8$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $doZTA.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

const $5f2d1e7b8a614058$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5f2d1e7b8a614058$export$f005e2e9f707cb5f = 'commercial';
const $5f2d1e7b8a614058$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5f2d1e7b8a614058$export$a739cd5aac835909 = 'stg';
const $5f2d1e7b8a614058$export$42dd0cdd351a4a9 = 'prod';
const $5f2d1e7b8a614058$export$404582bc18fe4d9e = 'dev';

const $90de389b166e701f$export$42f4885608027d0c = 'non_boolean';

const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';

const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $b2e0d12d54fddedd$export$cf090d5281b5ae06 = 10000;
const $b2e0d12d54fddedd$export$8575e30be0feb909 = 30000;

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';

// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

const $da88f8f66d8f0f0a$export$3288b14b6745c572 = 204;
const $da88f8f66d8f0f0a$export$c09e7ea0fc79f34f = 409;
const $da88f8f66d8f0f0a$export$974c37534b0191b1 = 503;


$parcel$global.rlb("kVX56")
//# sourceMappingURL=shared~vendor~ar.4a5f3bdf.js.map
